(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire70d3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire70d3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kZF3u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1hp2n"));

});
parcelRegister("1hp2n", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0eeaccdf054a797f$export$ffb0004e005737fa; }, function (v) { return $0eeaccdf054a797f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0eeaccdf054a797f$export$34b9dba7ce09269b; }, function (v) { return $0eeaccdf054a797f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0eeaccdf054a797f$export$25062201e9e25d76; }, function (v) { return $0eeaccdf054a797f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0eeaccdf054a797f$export$ffb0004e005737fa;
var $0eeaccdf054a797f$export$34b9dba7ce09269b;
var $0eeaccdf054a797f$export$25062201e9e25d76;
"use strict";

var $lcrTp = parcelRequire("lcrTp");
var $0eeaccdf054a797f$var$k = Symbol.for("react.element"), $0eeaccdf054a797f$var$l = Symbol.for("react.fragment"), $0eeaccdf054a797f$var$m = Object.prototype.hasOwnProperty, $0eeaccdf054a797f$var$n = $lcrTp.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0eeaccdf054a797f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0eeaccdf054a797f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0eeaccdf054a797f$var$m.call(a, b) && !$0eeaccdf054a797f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0eeaccdf054a797f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0eeaccdf054a797f$var$n.current
    };
}
$0eeaccdf054a797f$export$ffb0004e005737fa = $0eeaccdf054a797f$var$l;
$0eeaccdf054a797f$export$34b9dba7ce09269b = $0eeaccdf054a797f$var$q;
$0eeaccdf054a797f$export$25062201e9e25d76 = $0eeaccdf054a797f$var$q;

});
parcelRegister("lcrTp", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bCKmq"));

});
parcelRegister("bCKmq", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $87673497f62e9ffd$export$dca3b0875bd9a954; }, function (v) { return $87673497f62e9ffd$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $87673497f62e9ffd$export$16fa2f45be04daa8; }, function (v) { return $87673497f62e9ffd$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $87673497f62e9ffd$export$ffb0004e005737fa; }, function (v) { return $87673497f62e9ffd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $87673497f62e9ffd$export$e2c29f18771995cb; }, function (v) { return $87673497f62e9ffd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $87673497f62e9ffd$export$221d75b3f55bb0bd; }, function (v) { return $87673497f62e9ffd$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $87673497f62e9ffd$export$5f8d39834fd61797; }, function (v) { return $87673497f62e9ffd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $87673497f62e9ffd$export$74bf444e3cd11ea5; }, function (v) { return $87673497f62e9ffd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $87673497f62e9ffd$export$ae55be85d98224ed; }, function (v) { return $87673497f62e9ffd$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $87673497f62e9ffd$export$e530037191fcd5d7; }, function (v) { return $87673497f62e9ffd$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $87673497f62e9ffd$export$fd42f52fd3ae1109; }, function (v) { return $87673497f62e9ffd$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $87673497f62e9ffd$export$c8a8987d4410bf2d; }, function (v) { return $87673497f62e9ffd$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $87673497f62e9ffd$export$d38cd72104c1f0e9; }, function (v) { return $87673497f62e9ffd$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $87673497f62e9ffd$export$7d1e3a5e95ceca43; }, function (v) { return $87673497f62e9ffd$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $87673497f62e9ffd$export$257a8862b851cb5b; }, function (v) { return $87673497f62e9ffd$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $87673497f62e9ffd$export$a8257692ac88316c; }, function (v) { return $87673497f62e9ffd$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $87673497f62e9ffd$export$488013bae63b21da; }, function (v) { return $87673497f62e9ffd$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $87673497f62e9ffd$export$7c73462e0d25e514; }, function (v) { return $87673497f62e9ffd$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $87673497f62e9ffd$export$7568632d0d33d16d; }, function (v) { return $87673497f62e9ffd$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $87673497f62e9ffd$export$88948ce120ea2619; }, function (v) { return $87673497f62e9ffd$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $87673497f62e9ffd$export$35808ee640e87ca7; }, function (v) { return $87673497f62e9ffd$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $87673497f62e9ffd$export$fae74005e78b1a27; }, function (v) { return $87673497f62e9ffd$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $87673497f62e9ffd$export$dc8fbce3eb94dc1e; }, function (v) { return $87673497f62e9ffd$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $87673497f62e9ffd$export$6a7bc4e911dc01cf; }, function (v) { return $87673497f62e9ffd$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $87673497f62e9ffd$export$6d9c69b0de29b591; }, function (v) { return $87673497f62e9ffd$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $87673497f62e9ffd$export$f680877a34711e37; }, function (v) { return $87673497f62e9ffd$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $87673497f62e9ffd$export$d5a552a76deda3c2; }, function (v) { return $87673497f62e9ffd$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $87673497f62e9ffd$export$aaabe4eda9ed9969; }, function (v) { return $87673497f62e9ffd$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $87673497f62e9ffd$export$e5c5a5f917a5871c; }, function (v) { return $87673497f62e9ffd$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $87673497f62e9ffd$export$1538c33de8887b59; }, function (v) { return $87673497f62e9ffd$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $87673497f62e9ffd$export$13e3392192263954; }, function (v) { return $87673497f62e9ffd$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $87673497f62e9ffd$export$b8f5890fc79d6aca; }, function (v) { return $87673497f62e9ffd$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $87673497f62e9ffd$export$60241385465d0a34; }, function (v) { return $87673497f62e9ffd$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $87673497f62e9ffd$export$306c0aa65ff9ec16; }, function (v) { return $87673497f62e9ffd$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $87673497f62e9ffd$export$7b286972b8d8ccbf; }, function (v) { return $87673497f62e9ffd$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $87673497f62e9ffd$export$83d89fbfd8236492; }, function (v) { return $87673497f62e9ffd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $kMImg = parcelRequire("kMImg");
var $87673497f62e9ffd$export$dca3b0875bd9a954;
var $87673497f62e9ffd$export$16fa2f45be04daa8;
var $87673497f62e9ffd$export$ffb0004e005737fa;
var $87673497f62e9ffd$export$e2c29f18771995cb;
var $87673497f62e9ffd$export$221d75b3f55bb0bd;
var $87673497f62e9ffd$export$5f8d39834fd61797;
var $87673497f62e9ffd$export$74bf444e3cd11ea5;
var $87673497f62e9ffd$export$ae55be85d98224ed;
var $87673497f62e9ffd$export$e530037191fcd5d7;
var $87673497f62e9ffd$export$fd42f52fd3ae1109;
var $87673497f62e9ffd$export$c8a8987d4410bf2d;
var $87673497f62e9ffd$export$d38cd72104c1f0e9;
var $87673497f62e9ffd$export$7d1e3a5e95ceca43;
var $87673497f62e9ffd$export$257a8862b851cb5b;
var $87673497f62e9ffd$export$a8257692ac88316c;
var $87673497f62e9ffd$export$488013bae63b21da;
var $87673497f62e9ffd$export$7c73462e0d25e514;
var $87673497f62e9ffd$export$7568632d0d33d16d;
var $87673497f62e9ffd$export$88948ce120ea2619;
var $87673497f62e9ffd$export$35808ee640e87ca7;
var $87673497f62e9ffd$export$fae74005e78b1a27;
var $87673497f62e9ffd$export$dc8fbce3eb94dc1e;
var $87673497f62e9ffd$export$6a7bc4e911dc01cf;
var $87673497f62e9ffd$export$6d9c69b0de29b591;
var $87673497f62e9ffd$export$f680877a34711e37;
var $87673497f62e9ffd$export$d5a552a76deda3c2;
var $87673497f62e9ffd$export$aaabe4eda9ed9969;
var $87673497f62e9ffd$export$e5c5a5f917a5871c;
var $87673497f62e9ffd$export$1538c33de8887b59;
var $87673497f62e9ffd$export$13e3392192263954;
var $87673497f62e9ffd$export$b8f5890fc79d6aca;
var $87673497f62e9ffd$export$60241385465d0a34;
var $87673497f62e9ffd$export$306c0aa65ff9ec16;
var $87673497f62e9ffd$export$7b286972b8d8ccbf;
var $87673497f62e9ffd$export$83d89fbfd8236492;
"use strict";
var $87673497f62e9ffd$var$l = Symbol.for("react.element"), $87673497f62e9ffd$var$n = Symbol.for("react.portal"), $87673497f62e9ffd$var$p = Symbol.for("react.fragment"), $87673497f62e9ffd$var$q = Symbol.for("react.strict_mode"), $87673497f62e9ffd$var$r = Symbol.for("react.profiler"), $87673497f62e9ffd$var$t = Symbol.for("react.provider"), $87673497f62e9ffd$var$u = Symbol.for("react.context"), $87673497f62e9ffd$var$v = Symbol.for("react.forward_ref"), $87673497f62e9ffd$var$w = Symbol.for("react.suspense"), $87673497f62e9ffd$var$x = Symbol.for("react.memo"), $87673497f62e9ffd$var$y = Symbol.for("react.lazy"), $87673497f62e9ffd$var$z = Symbol.iterator;
function $87673497f62e9ffd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $87673497f62e9ffd$var$z && a[$87673497f62e9ffd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $87673497f62e9ffd$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $87673497f62e9ffd$var$C = Object.assign, $87673497f62e9ffd$var$D = {};
function $87673497f62e9ffd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $87673497f62e9ffd$var$D;
    this.updater = e || $87673497f62e9ffd$var$B;
}
$87673497f62e9ffd$var$E.prototype.isReactComponent = {};
$87673497f62e9ffd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$87673497f62e9ffd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $87673497f62e9ffd$var$F() {}
$87673497f62e9ffd$var$F.prototype = $87673497f62e9ffd$var$E.prototype;
function $87673497f62e9ffd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $87673497f62e9ffd$var$D;
    this.updater = e || $87673497f62e9ffd$var$B;
}
var $87673497f62e9ffd$var$H = $87673497f62e9ffd$var$G.prototype = new $87673497f62e9ffd$var$F;
$87673497f62e9ffd$var$H.constructor = $87673497f62e9ffd$var$G;
$87673497f62e9ffd$var$C($87673497f62e9ffd$var$H, $87673497f62e9ffd$var$E.prototype);
$87673497f62e9ffd$var$H.isPureReactComponent = !0;
var $87673497f62e9ffd$var$I = Array.isArray, $87673497f62e9ffd$var$J = Object.prototype.hasOwnProperty, $87673497f62e9ffd$var$K = {
    current: null
}, $87673497f62e9ffd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $87673497f62e9ffd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$87673497f62e9ffd$var$J.call(b, d) && !$87673497f62e9ffd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $87673497f62e9ffd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $87673497f62e9ffd$var$K.current
    };
}
function $87673497f62e9ffd$var$N(a, b) {
    return {
        $$typeof: $87673497f62e9ffd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $87673497f62e9ffd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $87673497f62e9ffd$var$l;
}
function $87673497f62e9ffd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $87673497f62e9ffd$var$P = /\/+/g;
function $87673497f62e9ffd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $87673497f62e9ffd$var$escape("" + a.key) : b.toString(36);
}
function $87673497f62e9ffd$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $kMImg._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $87673497f62e9ffd$var$l:
                case $87673497f62e9ffd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $87673497f62e9ffd$var$Q(h, 0) : d, $87673497f62e9ffd$var$I(c) ? (e = "", null != a && (e = a.replace($87673497f62e9ffd$var$P, "$&/") + "/"), $87673497f62e9ffd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($87673497f62e9ffd$var$O(c) && (c = $87673497f62e9ffd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($87673497f62e9ffd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($87673497f62e9ffd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $87673497f62e9ffd$var$Q(k, g);
        h += $87673497f62e9ffd$var$R(k, b, e, f, c);
    }
    else if (f = $87673497f62e9ffd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $87673497f62e9ffd$var$Q(k, g++), h += $87673497f62e9ffd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $87673497f62e9ffd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $87673497f62e9ffd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $87673497f62e9ffd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $87673497f62e9ffd$var$U = {
    current: null
}, $87673497f62e9ffd$var$V = {
    transition: null
}, $87673497f62e9ffd$var$W = {
    ReactCurrentDispatcher: $87673497f62e9ffd$var$U,
    ReactCurrentBatchConfig: $87673497f62e9ffd$var$V,
    ReactCurrentOwner: $87673497f62e9ffd$var$K
};
$87673497f62e9ffd$export$dca3b0875bd9a954 = {
    map: $87673497f62e9ffd$var$S,
    forEach: function forEach(a, b, e) {
        $87673497f62e9ffd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $87673497f62e9ffd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $87673497f62e9ffd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$87673497f62e9ffd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$87673497f62e9ffd$export$16fa2f45be04daa8 = $87673497f62e9ffd$var$E;
$87673497f62e9ffd$export$ffb0004e005737fa = $87673497f62e9ffd$var$p;
$87673497f62e9ffd$export$e2c29f18771995cb = $87673497f62e9ffd$var$r;
$87673497f62e9ffd$export$221d75b3f55bb0bd = $87673497f62e9ffd$var$G;
$87673497f62e9ffd$export$5f8d39834fd61797 = $87673497f62e9ffd$var$q;
$87673497f62e9ffd$export$74bf444e3cd11ea5 = $87673497f62e9ffd$var$w;
$87673497f62e9ffd$export$ae55be85d98224ed = $87673497f62e9ffd$var$W;
$87673497f62e9ffd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $87673497f62e9ffd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $87673497f62e9ffd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$87673497f62e9ffd$var$J.call(b, f) && !$87673497f62e9ffd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $87673497f62e9ffd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$87673497f62e9ffd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $87673497f62e9ffd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $87673497f62e9ffd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$87673497f62e9ffd$export$c8a8987d4410bf2d = $87673497f62e9ffd$var$M;
$87673497f62e9ffd$export$d38cd72104c1f0e9 = function(a) {
    var b = $87673497f62e9ffd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$87673497f62e9ffd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$87673497f62e9ffd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $87673497f62e9ffd$var$v,
        render: a
    };
};
$87673497f62e9ffd$export$a8257692ac88316c = $87673497f62e9ffd$var$O;
$87673497f62e9ffd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $87673497f62e9ffd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $87673497f62e9ffd$var$T
    };
};
$87673497f62e9ffd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $87673497f62e9ffd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$87673497f62e9ffd$export$7568632d0d33d16d = function(a) {
    var b = $87673497f62e9ffd$var$V.transition;
    $87673497f62e9ffd$var$V.transition = {};
    try {
        a();
    } finally{
        $87673497f62e9ffd$var$V.transition = b;
    }
};
$87673497f62e9ffd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$87673497f62e9ffd$export$35808ee640e87ca7 = function(a, b) {
    return $87673497f62e9ffd$var$U.current.useCallback(a, b);
};
$87673497f62e9ffd$export$fae74005e78b1a27 = function(a) {
    return $87673497f62e9ffd$var$U.current.useContext(a);
};
$87673497f62e9ffd$export$dc8fbce3eb94dc1e = function() {};
$87673497f62e9ffd$export$6a7bc4e911dc01cf = function(a) {
    return $87673497f62e9ffd$var$U.current.useDeferredValue(a);
};
$87673497f62e9ffd$export$6d9c69b0de29b591 = function(a, b) {
    return $87673497f62e9ffd$var$U.current.useEffect(a, b);
};
$87673497f62e9ffd$export$f680877a34711e37 = function() {
    return $87673497f62e9ffd$var$U.current.useId();
};
$87673497f62e9ffd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $87673497f62e9ffd$var$U.current.useImperativeHandle(a, b, e);
};
$87673497f62e9ffd$export$aaabe4eda9ed9969 = function(a, b) {
    return $87673497f62e9ffd$var$U.current.useInsertionEffect(a, b);
};
$87673497f62e9ffd$export$e5c5a5f917a5871c = function(a, b) {
    return $87673497f62e9ffd$var$U.current.useLayoutEffect(a, b);
};
$87673497f62e9ffd$export$1538c33de8887b59 = function(a, b) {
    return $87673497f62e9ffd$var$U.current.useMemo(a, b);
};
$87673497f62e9ffd$export$13e3392192263954 = function(a, b, e) {
    return $87673497f62e9ffd$var$U.current.useReducer(a, b, e);
};
$87673497f62e9ffd$export$b8f5890fc79d6aca = function(a) {
    return $87673497f62e9ffd$var$U.current.useRef(a);
};
$87673497f62e9ffd$export$60241385465d0a34 = function(a) {
    return $87673497f62e9ffd$var$U.current.useState(a);
};
$87673497f62e9ffd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $87673497f62e9ffd$var$U.current.useSyncExternalStore(a, b, e);
};
$87673497f62e9ffd$export$7b286972b8d8ccbf = function() {
    return $87673497f62e9ffd$var$U.current.useTransition();
};
$87673497f62e9ffd$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("kMImg", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $f21ab2ed809c4d9c$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $f21ab2ed809c4d9c$export$5f0017c582d45a2d; });
function $f21ab2ed809c4d9c$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("gVxhW", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c52bca934bf2714c$export$ae55be85d98224ed; }, function (v) { return $c52bca934bf2714c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c52bca934bf2714c$export$d39a5bbd09211389; }, function (v) { return $c52bca934bf2714c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c52bca934bf2714c$export$882461b6382ed46c; }, function (v) { return $c52bca934bf2714c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c52bca934bf2714c$export$466bfc07425424d5; }, function (v) { return $c52bca934bf2714c$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c52bca934bf2714c$export$cd75ccfd720a3cd4; }, function (v) { return $c52bca934bf2714c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c52bca934bf2714c$export$fa8d919ba61d84db; }, function (v) { return $c52bca934bf2714c$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c52bca934bf2714c$export$757ceba2d55c277e; }, function (v) { return $c52bca934bf2714c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c52bca934bf2714c$export$b3890eb0ae9dca99; }, function (v) { return $c52bca934bf2714c$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c52bca934bf2714c$export$502457920280e6be; }, function (v) { return $c52bca934bf2714c$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c52bca934bf2714c$export$c78a37762a8d58e1; }, function (v) { return $c52bca934bf2714c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c52bca934bf2714c$export$dc54d992c10e8a18; }, function (v) { return $c52bca934bf2714c$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c52bca934bf2714c$export$83d89fbfd8236492; }, function (v) { return $c52bca934bf2714c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $kMImg = parcelRequire("kMImg");
var $c52bca934bf2714c$export$ae55be85d98224ed;
var $c52bca934bf2714c$export$d39a5bbd09211389;
var $c52bca934bf2714c$export$882461b6382ed46c;
var $c52bca934bf2714c$export$466bfc07425424d5;
var $c52bca934bf2714c$export$cd75ccfd720a3cd4;
var $c52bca934bf2714c$export$fa8d919ba61d84db;
var $c52bca934bf2714c$export$757ceba2d55c277e;
var $c52bca934bf2714c$export$b3890eb0ae9dca99;
var $c52bca934bf2714c$export$502457920280e6be;
var $c52bca934bf2714c$export$c78a37762a8d58e1;
var $c52bca934bf2714c$export$dc54d992c10e8a18;
var $c52bca934bf2714c$export$83d89fbfd8236492;
"use strict";

var $lcrTp = parcelRequire("lcrTp");

var $l9xJK = parcelRequire("l9xJK");
function $c52bca934bf2714c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c52bca934bf2714c$var$da = new Set, $c52bca934bf2714c$var$ea = {};
function $c52bca934bf2714c$var$fa(a, b) {
    $c52bca934bf2714c$var$ha(a, b);
    $c52bca934bf2714c$var$ha(a + "Capture", b);
}
function $c52bca934bf2714c$var$ha(a, b) {
    $c52bca934bf2714c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c52bca934bf2714c$var$da.add(b[a]);
}
var $c52bca934bf2714c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c52bca934bf2714c$var$ja = Object.prototype.hasOwnProperty, $c52bca934bf2714c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c52bca934bf2714c$var$la = {}, $c52bca934bf2714c$var$ma = {};
function $c52bca934bf2714c$var$oa(a) {
    if ($c52bca934bf2714c$var$ja.call($c52bca934bf2714c$var$ma, a)) return !0;
    if ($c52bca934bf2714c$var$ja.call($c52bca934bf2714c$var$la, a)) return !1;
    if ($c52bca934bf2714c$var$ka.test(a)) return $c52bca934bf2714c$var$ma[a] = !0;
    $c52bca934bf2714c$var$la[a] = !0;
    return !1;
}
function $c52bca934bf2714c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $kMImg._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c52bca934bf2714c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c52bca934bf2714c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c52bca934bf2714c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c52bca934bf2714c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c52bca934bf2714c$var$z[b] = new $c52bca934bf2714c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c52bca934bf2714c$var$ra = /[\-:]([a-z])/g;
function $c52bca934bf2714c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c52bca934bf2714c$var$ra, $c52bca934bf2714c$var$sa);
    $c52bca934bf2714c$var$z[b] = new $c52bca934bf2714c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c52bca934bf2714c$var$ra, $c52bca934bf2714c$var$sa);
    $c52bca934bf2714c$var$z[b] = new $c52bca934bf2714c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c52bca934bf2714c$var$ra, $c52bca934bf2714c$var$sa);
    $c52bca934bf2714c$var$z[b] = new $c52bca934bf2714c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c52bca934bf2714c$var$z.xlinkHref = new $c52bca934bf2714c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c52bca934bf2714c$var$z[a] = new $c52bca934bf2714c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c52bca934bf2714c$var$ta(a, b, c, d) {
    var e = $c52bca934bf2714c$var$z.hasOwnProperty(b) ? $c52bca934bf2714c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c52bca934bf2714c$var$qa(b, c, e, d) && (c = null), d || null === e ? $c52bca934bf2714c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c52bca934bf2714c$var$ua = $lcrTp.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c52bca934bf2714c$var$va = Symbol.for("react.element"), $c52bca934bf2714c$var$wa = Symbol.for("react.portal"), $c52bca934bf2714c$var$ya = Symbol.for("react.fragment"), $c52bca934bf2714c$var$za = Symbol.for("react.strict_mode"), $c52bca934bf2714c$var$Aa = Symbol.for("react.profiler"), $c52bca934bf2714c$var$Ba = Symbol.for("react.provider"), $c52bca934bf2714c$var$Ca = Symbol.for("react.context"), $c52bca934bf2714c$var$Da = Symbol.for("react.forward_ref"), $c52bca934bf2714c$var$Ea = Symbol.for("react.suspense"), $c52bca934bf2714c$var$Fa = Symbol.for("react.suspense_list"), $c52bca934bf2714c$var$Ga = Symbol.for("react.memo"), $c52bca934bf2714c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c52bca934bf2714c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c52bca934bf2714c$var$Ja = Symbol.iterator;
function $c52bca934bf2714c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c52bca934bf2714c$var$Ja && a[$c52bca934bf2714c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c52bca934bf2714c$var$A = Object.assign, $c52bca934bf2714c$var$La;
function $c52bca934bf2714c$var$Ma(a) {
    if (void 0 === $c52bca934bf2714c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c52bca934bf2714c$var$La = b && b[1] || "";
    }
    return "\n" + $c52bca934bf2714c$var$La + a;
}
var $c52bca934bf2714c$var$Na = !1;
function $c52bca934bf2714c$var$Oa(a, b) {
    if (!a || $c52bca934bf2714c$var$Na) return "";
    $c52bca934bf2714c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c52bca934bf2714c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c52bca934bf2714c$var$Ma(a) : "";
}
function $c52bca934bf2714c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c52bca934bf2714c$var$Ma(a.type);
        case 16:
            return $c52bca934bf2714c$var$Ma("Lazy");
        case 13:
            return $c52bca934bf2714c$var$Ma("Suspense");
        case 19:
            return $c52bca934bf2714c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c52bca934bf2714c$var$Oa(a.type, !1), a;
        case 11:
            return a = $c52bca934bf2714c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c52bca934bf2714c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c52bca934bf2714c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c52bca934bf2714c$var$ya:
            return "Fragment";
        case $c52bca934bf2714c$var$wa:
            return "Portal";
        case $c52bca934bf2714c$var$Aa:
            return "Profiler";
        case $c52bca934bf2714c$var$za:
            return "StrictMode";
        case $c52bca934bf2714c$var$Ea:
            return "Suspense";
        case $c52bca934bf2714c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c52bca934bf2714c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c52bca934bf2714c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c52bca934bf2714c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c52bca934bf2714c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c52bca934bf2714c$var$Qa(a.type) || "Memo";
        case $c52bca934bf2714c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c52bca934bf2714c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c52bca934bf2714c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c52bca934bf2714c$var$Qa(b);
        case 8:
            return b === $c52bca934bf2714c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c52bca934bf2714c$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $kMImg._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c52bca934bf2714c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c52bca934bf2714c$var$Ua(a) {
    var b = $c52bca934bf2714c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c52bca934bf2714c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c52bca934bf2714c$var$Ua(a));
}
function $c52bca934bf2714c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c52bca934bf2714c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c52bca934bf2714c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c52bca934bf2714c$var$Ya(a, b) {
    var c = b.checked;
    return $c52bca934bf2714c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c52bca934bf2714c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c52bca934bf2714c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c52bca934bf2714c$var$ab(a, b) {
    b = b.checked;
    null != b && $c52bca934bf2714c$var$ta(a, "checked", b, !1);
}
function $c52bca934bf2714c$var$bb(a, b) {
    $c52bca934bf2714c$var$ab(a, b);
    var c = $c52bca934bf2714c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c52bca934bf2714c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c52bca934bf2714c$var$cb(a, b.type, $c52bca934bf2714c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c52bca934bf2714c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c52bca934bf2714c$var$cb(a, b, c) {
    if ("number" !== b || $c52bca934bf2714c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c52bca934bf2714c$var$eb = Array.isArray;
function $c52bca934bf2714c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c52bca934bf2714c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c52bca934bf2714c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c52bca934bf2714c$var$p(91));
    return $c52bca934bf2714c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c52bca934bf2714c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c52bca934bf2714c$var$p(92));
            if ($c52bca934bf2714c$var$eb(c)) {
                if (1 < c.length) throw Error($c52bca934bf2714c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c52bca934bf2714c$var$Sa(c)
    };
}
function $c52bca934bf2714c$var$ib(a, b) {
    var c = $c52bca934bf2714c$var$Sa(b.value), d = $c52bca934bf2714c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c52bca934bf2714c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c52bca934bf2714c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c52bca934bf2714c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c52bca934bf2714c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c52bca934bf2714c$var$mb, $c52bca934bf2714c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c52bca934bf2714c$var$mb = $c52bca934bf2714c$var$mb || document.createElement("div");
        $c52bca934bf2714c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c52bca934bf2714c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c52bca934bf2714c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c52bca934bf2714c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c52bca934bf2714c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c52bca934bf2714c$var$pb).forEach(function(a) {
    $c52bca934bf2714c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c52bca934bf2714c$var$pb[b] = $c52bca934bf2714c$var$pb[a];
    });
});
function $c52bca934bf2714c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c52bca934bf2714c$var$pb.hasOwnProperty(a) && $c52bca934bf2714c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c52bca934bf2714c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c52bca934bf2714c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c52bca934bf2714c$var$tb = $c52bca934bf2714c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c52bca934bf2714c$var$ub(a, b) {
    if (b) {
        if ($c52bca934bf2714c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c52bca934bf2714c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c52bca934bf2714c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c52bca934bf2714c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c52bca934bf2714c$var$p(62));
    }
}
function $c52bca934bf2714c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c52bca934bf2714c$var$wb = null;
function $c52bca934bf2714c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c52bca934bf2714c$var$yb = null, $c52bca934bf2714c$var$zb = null, $c52bca934bf2714c$var$Ab = null;
function $c52bca934bf2714c$var$Bb(a) {
    if (a = $c52bca934bf2714c$var$Cb(a)) {
        if ("function" !== typeof $c52bca934bf2714c$var$yb) throw Error($c52bca934bf2714c$var$p(280));
        var b = a.stateNode;
        b && (b = $c52bca934bf2714c$var$Db(b), $c52bca934bf2714c$var$yb(a.stateNode, a.type, b));
    }
}
function $c52bca934bf2714c$var$Eb(a) {
    $c52bca934bf2714c$var$zb ? $c52bca934bf2714c$var$Ab ? $c52bca934bf2714c$var$Ab.push(a) : $c52bca934bf2714c$var$Ab = [
        a
    ] : $c52bca934bf2714c$var$zb = a;
}
function $c52bca934bf2714c$var$Fb() {
    if ($c52bca934bf2714c$var$zb) {
        var a = $c52bca934bf2714c$var$zb, b = $c52bca934bf2714c$var$Ab;
        $c52bca934bf2714c$var$Ab = $c52bca934bf2714c$var$zb = null;
        $c52bca934bf2714c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c52bca934bf2714c$var$Bb(b[a]);
    }
}
function $c52bca934bf2714c$var$Gb(a, b) {
    return a(b);
}
function $c52bca934bf2714c$var$Hb() {}
var $c52bca934bf2714c$var$Ib = !1;
function $c52bca934bf2714c$var$Jb(a, b, c) {
    if ($c52bca934bf2714c$var$Ib) return a(b, c);
    $c52bca934bf2714c$var$Ib = !0;
    try {
        return $c52bca934bf2714c$var$Gb(a, b, c);
    } finally{
        if ($c52bca934bf2714c$var$Ib = !1, null !== $c52bca934bf2714c$var$zb || null !== $c52bca934bf2714c$var$Ab) $c52bca934bf2714c$var$Hb(), $c52bca934bf2714c$var$Fb();
    }
}
function $c52bca934bf2714c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c52bca934bf2714c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c52bca934bf2714c$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $kMImg._)(c)));
    return c;
}
var $c52bca934bf2714c$var$Lb = !1;
if ($c52bca934bf2714c$var$ia) try {
    var $c52bca934bf2714c$var$Mb = {};
    Object.defineProperty($c52bca934bf2714c$var$Mb, "passive", {
        get: function get() {
            $c52bca934bf2714c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c52bca934bf2714c$var$Mb, $c52bca934bf2714c$var$Mb);
    window.removeEventListener("test", $c52bca934bf2714c$var$Mb, $c52bca934bf2714c$var$Mb);
} catch (a) {
    $c52bca934bf2714c$var$Lb = !1;
}
function $c52bca934bf2714c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c52bca934bf2714c$var$Ob = !1, $c52bca934bf2714c$var$Pb = null, $c52bca934bf2714c$var$Qb = !1, $c52bca934bf2714c$var$Rb = null, $c52bca934bf2714c$var$Sb = {
    onError: function onError(a) {
        $c52bca934bf2714c$var$Ob = !0;
        $c52bca934bf2714c$var$Pb = a;
    }
};
function $c52bca934bf2714c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c52bca934bf2714c$var$Ob = !1;
    $c52bca934bf2714c$var$Pb = null;
    $c52bca934bf2714c$var$Nb.apply($c52bca934bf2714c$var$Sb, arguments);
}
function $c52bca934bf2714c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c52bca934bf2714c$var$Tb.apply(this, arguments);
    if ($c52bca934bf2714c$var$Ob) {
        if ($c52bca934bf2714c$var$Ob) {
            var l = $c52bca934bf2714c$var$Pb;
            $c52bca934bf2714c$var$Ob = !1;
            $c52bca934bf2714c$var$Pb = null;
        } else throw Error($c52bca934bf2714c$var$p(198));
        $c52bca934bf2714c$var$Qb || ($c52bca934bf2714c$var$Qb = !0, $c52bca934bf2714c$var$Rb = l);
    }
}
function $c52bca934bf2714c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c52bca934bf2714c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c52bca934bf2714c$var$Xb(a) {
    if ($c52bca934bf2714c$var$Vb(a) !== a) throw Error($c52bca934bf2714c$var$p(188));
}
function $c52bca934bf2714c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c52bca934bf2714c$var$Vb(a);
        if (null === b) throw Error($c52bca934bf2714c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c52bca934bf2714c$var$Xb(e), a;
                if (f === d) return $c52bca934bf2714c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c52bca934bf2714c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c52bca934bf2714c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c52bca934bf2714c$var$p(190));
    }
    if (3 !== c.tag) throw Error($c52bca934bf2714c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c52bca934bf2714c$var$Zb(a) {
    a = $c52bca934bf2714c$var$Yb(a);
    return null !== a ? $c52bca934bf2714c$var$$b(a) : null;
}
function $c52bca934bf2714c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c52bca934bf2714c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c52bca934bf2714c$var$ac = $l9xJK.unstable_scheduleCallback, $c52bca934bf2714c$var$bc = $l9xJK.unstable_cancelCallback, $c52bca934bf2714c$var$cc = $l9xJK.unstable_shouldYield, $c52bca934bf2714c$var$dc = $l9xJK.unstable_requestPaint, $c52bca934bf2714c$var$B = $l9xJK.unstable_now, $c52bca934bf2714c$var$ec = $l9xJK.unstable_getCurrentPriorityLevel, $c52bca934bf2714c$var$fc = $l9xJK.unstable_ImmediatePriority, $c52bca934bf2714c$var$gc = $l9xJK.unstable_UserBlockingPriority, $c52bca934bf2714c$var$hc = $l9xJK.unstable_NormalPriority, $c52bca934bf2714c$var$ic = $l9xJK.unstable_LowPriority, $c52bca934bf2714c$var$jc = $l9xJK.unstable_IdlePriority, $c52bca934bf2714c$var$kc = null, $c52bca934bf2714c$var$lc = null;
function $c52bca934bf2714c$var$mc(a) {
    if ($c52bca934bf2714c$var$lc && "function" === typeof $c52bca934bf2714c$var$lc.onCommitFiberRoot) try {
        $c52bca934bf2714c$var$lc.onCommitFiberRoot($c52bca934bf2714c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c52bca934bf2714c$var$oc = Math.clz32 ? Math.clz32 : $c52bca934bf2714c$var$nc, $c52bca934bf2714c$var$pc = Math.log, $c52bca934bf2714c$var$qc = Math.LN2;
function $c52bca934bf2714c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c52bca934bf2714c$var$pc(a) / $c52bca934bf2714c$var$qc | 0) | 0;
}
var $c52bca934bf2714c$var$rc = 64, $c52bca934bf2714c$var$sc = 4194304;
function $c52bca934bf2714c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c52bca934bf2714c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c52bca934bf2714c$var$tc(h) : (f &= g, 0 !== f && (d = $c52bca934bf2714c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c52bca934bf2714c$var$tc(g) : 0 !== f && (d = $c52bca934bf2714c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c52bca934bf2714c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c52bca934bf2714c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c52bca934bf2714c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c52bca934bf2714c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c52bca934bf2714c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c52bca934bf2714c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c52bca934bf2714c$var$yc() {
    var a = $c52bca934bf2714c$var$rc;
    $c52bca934bf2714c$var$rc <<= 1;
    0 === ($c52bca934bf2714c$var$rc & 4194240) && ($c52bca934bf2714c$var$rc = 64);
    return a;
}
function $c52bca934bf2714c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c52bca934bf2714c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c52bca934bf2714c$var$oc(b);
    a[b] = c;
}
function $c52bca934bf2714c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c52bca934bf2714c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c52bca934bf2714c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c52bca934bf2714c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c52bca934bf2714c$var$C = 0;
function $c52bca934bf2714c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c52bca934bf2714c$var$Ec, $c52bca934bf2714c$var$Fc, $c52bca934bf2714c$var$Gc, $c52bca934bf2714c$var$Hc, $c52bca934bf2714c$var$Ic, $c52bca934bf2714c$var$Jc = !1, $c52bca934bf2714c$var$Kc = [], $c52bca934bf2714c$var$Lc = null, $c52bca934bf2714c$var$Mc = null, $c52bca934bf2714c$var$Nc = null, $c52bca934bf2714c$var$Oc = new Map, $c52bca934bf2714c$var$Pc = new Map, $c52bca934bf2714c$var$Qc = [], $c52bca934bf2714c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c52bca934bf2714c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c52bca934bf2714c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c52bca934bf2714c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c52bca934bf2714c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c52bca934bf2714c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c52bca934bf2714c$var$Pc.delete(b.pointerId);
    }
}
function $c52bca934bf2714c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c52bca934bf2714c$var$Cb(b), null !== b && $c52bca934bf2714c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c52bca934bf2714c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c52bca934bf2714c$var$Lc = $c52bca934bf2714c$var$Tc($c52bca934bf2714c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c52bca934bf2714c$var$Mc = $c52bca934bf2714c$var$Tc($c52bca934bf2714c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c52bca934bf2714c$var$Nc = $c52bca934bf2714c$var$Tc($c52bca934bf2714c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c52bca934bf2714c$var$Oc.set(f, $c52bca934bf2714c$var$Tc($c52bca934bf2714c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c52bca934bf2714c$var$Pc.set(f, $c52bca934bf2714c$var$Tc($c52bca934bf2714c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c52bca934bf2714c$var$Vc(a) {
    var b = $c52bca934bf2714c$var$Wc(a.target);
    if (null !== b) {
        var c = $c52bca934bf2714c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c52bca934bf2714c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c52bca934bf2714c$var$Ic(a.priority, function() {
                        $c52bca934bf2714c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c52bca934bf2714c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c52bca934bf2714c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c52bca934bf2714c$var$wb = d;
            c.target.dispatchEvent(d);
            $c52bca934bf2714c$var$wb = null;
        } else return b = $c52bca934bf2714c$var$Cb(c), null !== b && $c52bca934bf2714c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c52bca934bf2714c$var$Zc(a, b, c) {
    $c52bca934bf2714c$var$Xc(a) && c.delete(b);
}
function $c52bca934bf2714c$var$$c() {
    $c52bca934bf2714c$var$Jc = !1;
    null !== $c52bca934bf2714c$var$Lc && $c52bca934bf2714c$var$Xc($c52bca934bf2714c$var$Lc) && ($c52bca934bf2714c$var$Lc = null);
    null !== $c52bca934bf2714c$var$Mc && $c52bca934bf2714c$var$Xc($c52bca934bf2714c$var$Mc) && ($c52bca934bf2714c$var$Mc = null);
    null !== $c52bca934bf2714c$var$Nc && $c52bca934bf2714c$var$Xc($c52bca934bf2714c$var$Nc) && ($c52bca934bf2714c$var$Nc = null);
    $c52bca934bf2714c$var$Oc.forEach($c52bca934bf2714c$var$Zc);
    $c52bca934bf2714c$var$Pc.forEach($c52bca934bf2714c$var$Zc);
}
function $c52bca934bf2714c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c52bca934bf2714c$var$Jc || ($c52bca934bf2714c$var$Jc = !0, $l9xJK.unstable_scheduleCallback($l9xJK.unstable_NormalPriority, $c52bca934bf2714c$var$$c)));
}
function $c52bca934bf2714c$var$bd(a) {
    function b(b) {
        return $c52bca934bf2714c$var$ad(b, a);
    }
    if (0 < $c52bca934bf2714c$var$Kc.length) {
        $c52bca934bf2714c$var$ad($c52bca934bf2714c$var$Kc[0], a);
        for(var c = 1; c < $c52bca934bf2714c$var$Kc.length; c++){
            var d = $c52bca934bf2714c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c52bca934bf2714c$var$Lc && $c52bca934bf2714c$var$ad($c52bca934bf2714c$var$Lc, a);
    null !== $c52bca934bf2714c$var$Mc && $c52bca934bf2714c$var$ad($c52bca934bf2714c$var$Mc, a);
    null !== $c52bca934bf2714c$var$Nc && $c52bca934bf2714c$var$ad($c52bca934bf2714c$var$Nc, a);
    $c52bca934bf2714c$var$Oc.forEach(b);
    $c52bca934bf2714c$var$Pc.forEach(b);
    for(c = 0; c < $c52bca934bf2714c$var$Qc.length; c++)d = $c52bca934bf2714c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c52bca934bf2714c$var$Qc.length && (c = $c52bca934bf2714c$var$Qc[0], null === c.blockedOn);)$c52bca934bf2714c$var$Vc(c), null === c.blockedOn && $c52bca934bf2714c$var$Qc.shift();
}
var $c52bca934bf2714c$var$cd = $c52bca934bf2714c$var$ua.ReactCurrentBatchConfig, $c52bca934bf2714c$var$dd = !0;
function $c52bca934bf2714c$var$ed(a, b, c, d) {
    var e = $c52bca934bf2714c$var$C, f = $c52bca934bf2714c$var$cd.transition;
    $c52bca934bf2714c$var$cd.transition = null;
    try {
        $c52bca934bf2714c$var$C = 1, $c52bca934bf2714c$var$fd(a, b, c, d);
    } finally{
        $c52bca934bf2714c$var$C = e, $c52bca934bf2714c$var$cd.transition = f;
    }
}
function $c52bca934bf2714c$var$gd(a, b, c, d) {
    var e = $c52bca934bf2714c$var$C, f = $c52bca934bf2714c$var$cd.transition;
    $c52bca934bf2714c$var$cd.transition = null;
    try {
        $c52bca934bf2714c$var$C = 4, $c52bca934bf2714c$var$fd(a, b, c, d);
    } finally{
        $c52bca934bf2714c$var$C = e, $c52bca934bf2714c$var$cd.transition = f;
    }
}
function $c52bca934bf2714c$var$fd(a, b, c, d) {
    if ($c52bca934bf2714c$var$dd) {
        var e = $c52bca934bf2714c$var$Yc(a, b, c, d);
        if (null === e) $c52bca934bf2714c$var$hd(a, b, d, $c52bca934bf2714c$var$id, c), $c52bca934bf2714c$var$Sc(a, d);
        else if ($c52bca934bf2714c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c52bca934bf2714c$var$Sc(a, d), b & 4 && -1 < $c52bca934bf2714c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c52bca934bf2714c$var$Cb(e);
                null !== f && $c52bca934bf2714c$var$Ec(f);
                f = $c52bca934bf2714c$var$Yc(a, b, c, d);
                null === f && $c52bca934bf2714c$var$hd(a, b, d, $c52bca934bf2714c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c52bca934bf2714c$var$hd(a, b, d, null, c);
    }
}
var $c52bca934bf2714c$var$id = null;
function $c52bca934bf2714c$var$Yc(a, b, c, d) {
    $c52bca934bf2714c$var$id = null;
    a = $c52bca934bf2714c$var$xb(d);
    a = $c52bca934bf2714c$var$Wc(a);
    if (null !== a) {
        if (b = $c52bca934bf2714c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c52bca934bf2714c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c52bca934bf2714c$var$id = a;
    return null;
}
function $c52bca934bf2714c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c52bca934bf2714c$var$ec()){
                case $c52bca934bf2714c$var$fc:
                    return 1;
                case $c52bca934bf2714c$var$gc:
                    return 4;
                case $c52bca934bf2714c$var$hc:
                case $c52bca934bf2714c$var$ic:
                    return 16;
                case $c52bca934bf2714c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c52bca934bf2714c$var$kd = null, $c52bca934bf2714c$var$ld = null, $c52bca934bf2714c$var$md = null;
function $c52bca934bf2714c$var$nd() {
    if ($c52bca934bf2714c$var$md) return $c52bca934bf2714c$var$md;
    var a, b = $c52bca934bf2714c$var$ld, c = b.length, d, e = "value" in $c52bca934bf2714c$var$kd ? $c52bca934bf2714c$var$kd.value : $c52bca934bf2714c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c52bca934bf2714c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c52bca934bf2714c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c52bca934bf2714c$var$pd() {
    return !0;
}
function $c52bca934bf2714c$var$qd() {
    return !1;
}
function $c52bca934bf2714c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c52bca934bf2714c$var$pd : $c52bca934bf2714c$var$qd;
        this.isPropagationStopped = $c52bca934bf2714c$var$qd;
        return this;
    }
    $c52bca934bf2714c$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $kMImg._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $c52bca934bf2714c$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $kMImg._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $c52bca934bf2714c$var$pd);
        },
        persist: function persist() {},
        isPersistent: $c52bca934bf2714c$var$pd
    });
    return b;
}
var $c52bca934bf2714c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c52bca934bf2714c$var$td = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$sd), $c52bca934bf2714c$var$ud = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$sd, {
    view: 0,
    detail: 0
}), $c52bca934bf2714c$var$vd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$ud), $c52bca934bf2714c$var$wd, $c52bca934bf2714c$var$xd, $c52bca934bf2714c$var$yd, $c52bca934bf2714c$var$Ad = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c52bca934bf2714c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c52bca934bf2714c$var$yd && ($c52bca934bf2714c$var$yd && "mousemove" === a.type ? ($c52bca934bf2714c$var$wd = a.screenX - $c52bca934bf2714c$var$yd.screenX, $c52bca934bf2714c$var$xd = a.screenY - $c52bca934bf2714c$var$yd.screenY) : $c52bca934bf2714c$var$xd = $c52bca934bf2714c$var$wd = 0, $c52bca934bf2714c$var$yd = a);
        return $c52bca934bf2714c$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $c52bca934bf2714c$var$xd;
    }
}), $c52bca934bf2714c$var$Bd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Ad), $c52bca934bf2714c$var$Cd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$Ad, {
    dataTransfer: 0
}), $c52bca934bf2714c$var$Dd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Cd), $c52bca934bf2714c$var$Ed = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$ud, {
    relatedTarget: 0
}), $c52bca934bf2714c$var$Fd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Ed), $c52bca934bf2714c$var$Gd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c52bca934bf2714c$var$Hd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Gd), $c52bca934bf2714c$var$Id = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c52bca934bf2714c$var$Jd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Id), $c52bca934bf2714c$var$Kd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$sd, {
    data: 0
}), $c52bca934bf2714c$var$Ld = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Kd), $c52bca934bf2714c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c52bca934bf2714c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c52bca934bf2714c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c52bca934bf2714c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c52bca934bf2714c$var$Od[a]) ? !!b[a] : !1;
}
function $c52bca934bf2714c$var$zd() {
    return $c52bca934bf2714c$var$Pd;
}
var $c52bca934bf2714c$var$Qd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $c52bca934bf2714c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c52bca934bf2714c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c52bca934bf2714c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c52bca934bf2714c$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $c52bca934bf2714c$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $c52bca934bf2714c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c52bca934bf2714c$var$Rd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Qd), $c52bca934bf2714c$var$Sd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c52bca934bf2714c$var$Td = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Sd), $c52bca934bf2714c$var$Ud = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c52bca934bf2714c$var$zd
}), $c52bca934bf2714c$var$Vd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Ud), $c52bca934bf2714c$var$Wd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c52bca934bf2714c$var$Xd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Wd), $c52bca934bf2714c$var$Yd = $c52bca934bf2714c$var$A({}, $c52bca934bf2714c$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c52bca934bf2714c$var$Zd = $c52bca934bf2714c$var$rd($c52bca934bf2714c$var$Yd), $c52bca934bf2714c$var$$d = [
    9,
    13,
    27,
    32
], $c52bca934bf2714c$var$ae = $c52bca934bf2714c$var$ia && "CompositionEvent" in window, $c52bca934bf2714c$var$be = null;
$c52bca934bf2714c$var$ia && "documentMode" in document && ($c52bca934bf2714c$var$be = document.documentMode);
var $c52bca934bf2714c$var$ce = $c52bca934bf2714c$var$ia && "TextEvent" in window && !$c52bca934bf2714c$var$be, $c52bca934bf2714c$var$de = $c52bca934bf2714c$var$ia && (!$c52bca934bf2714c$var$ae || $c52bca934bf2714c$var$be && 8 < $c52bca934bf2714c$var$be && 11 >= $c52bca934bf2714c$var$be), $c52bca934bf2714c$var$ee = String.fromCharCode(32), $c52bca934bf2714c$var$fe = !1;
function $c52bca934bf2714c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c52bca934bf2714c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c52bca934bf2714c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c52bca934bf2714c$var$ie = !1;
function $c52bca934bf2714c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c52bca934bf2714c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c52bca934bf2714c$var$fe = !0;
            return $c52bca934bf2714c$var$ee;
        case "textInput":
            return a = b.data, a === $c52bca934bf2714c$var$ee && $c52bca934bf2714c$var$fe ? null : a;
        default:
            return null;
    }
}
function $c52bca934bf2714c$var$ke(a, b) {
    if ($c52bca934bf2714c$var$ie) return "compositionend" === a || !$c52bca934bf2714c$var$ae && $c52bca934bf2714c$var$ge(a, b) ? (a = $c52bca934bf2714c$var$nd(), $c52bca934bf2714c$var$md = $c52bca934bf2714c$var$ld = $c52bca934bf2714c$var$kd = null, $c52bca934bf2714c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c52bca934bf2714c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c52bca934bf2714c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c52bca934bf2714c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c52bca934bf2714c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c52bca934bf2714c$var$ne(a, b, c, d) {
    $c52bca934bf2714c$var$Eb(d);
    b = $c52bca934bf2714c$var$oe(b, "onChange");
    0 < b.length && (c = new $c52bca934bf2714c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c52bca934bf2714c$var$pe = null, $c52bca934bf2714c$var$qe = null;
function $c52bca934bf2714c$var$re(a) {
    $c52bca934bf2714c$var$se(a, 0);
}
function $c52bca934bf2714c$var$te(a) {
    var b = $c52bca934bf2714c$var$ue(a);
    if ($c52bca934bf2714c$var$Wa(b)) return a;
}
function $c52bca934bf2714c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c52bca934bf2714c$var$we = !1;
if ($c52bca934bf2714c$var$ia) {
    var $c52bca934bf2714c$var$xe;
    if ($c52bca934bf2714c$var$ia) {
        var $c52bca934bf2714c$var$ye = "oninput" in document;
        if (!$c52bca934bf2714c$var$ye) {
            var $c52bca934bf2714c$var$ze = document.createElement("div");
            $c52bca934bf2714c$var$ze.setAttribute("oninput", "return;");
            $c52bca934bf2714c$var$ye = "function" === typeof $c52bca934bf2714c$var$ze.oninput;
        }
        $c52bca934bf2714c$var$xe = $c52bca934bf2714c$var$ye;
    } else $c52bca934bf2714c$var$xe = !1;
    $c52bca934bf2714c$var$we = $c52bca934bf2714c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c52bca934bf2714c$var$Ae() {
    $c52bca934bf2714c$var$pe && ($c52bca934bf2714c$var$pe.detachEvent("onpropertychange", $c52bca934bf2714c$var$Be), $c52bca934bf2714c$var$qe = $c52bca934bf2714c$var$pe = null);
}
function $c52bca934bf2714c$var$Be(a) {
    if ("value" === a.propertyName && $c52bca934bf2714c$var$te($c52bca934bf2714c$var$qe)) {
        var b = [];
        $c52bca934bf2714c$var$ne(b, $c52bca934bf2714c$var$qe, a, $c52bca934bf2714c$var$xb(a));
        $c52bca934bf2714c$var$Jb($c52bca934bf2714c$var$re, b);
    }
}
function $c52bca934bf2714c$var$Ce(a, b, c) {
    "focusin" === a ? ($c52bca934bf2714c$var$Ae(), $c52bca934bf2714c$var$pe = b, $c52bca934bf2714c$var$qe = c, $c52bca934bf2714c$var$pe.attachEvent("onpropertychange", $c52bca934bf2714c$var$Be)) : "focusout" === a && $c52bca934bf2714c$var$Ae();
}
function $c52bca934bf2714c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c52bca934bf2714c$var$te($c52bca934bf2714c$var$qe);
}
function $c52bca934bf2714c$var$Ee(a, b) {
    if ("click" === a) return $c52bca934bf2714c$var$te(b);
}
function $c52bca934bf2714c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c52bca934bf2714c$var$te(b);
}
function $c52bca934bf2714c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c52bca934bf2714c$var$He = "function" === typeof Object.is ? Object.is : $c52bca934bf2714c$var$Ge;
function $c52bca934bf2714c$var$Ie(a, b) {
    if ($c52bca934bf2714c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c52bca934bf2714c$var$ja.call(b, e) || !$c52bca934bf2714c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c52bca934bf2714c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c52bca934bf2714c$var$Ke(a, b) {
    var c = $c52bca934bf2714c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c52bca934bf2714c$var$Je(c);
    }
}
function $c52bca934bf2714c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c52bca934bf2714c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c52bca934bf2714c$var$Me() {
    for(var a = window, b = $c52bca934bf2714c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c52bca934bf2714c$var$Xa(a.document);
    }
    return b;
}
function $c52bca934bf2714c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c52bca934bf2714c$var$Oe(a) {
    var b = $c52bca934bf2714c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c52bca934bf2714c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c52bca934bf2714c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c52bca934bf2714c$var$Ke(c, f);
                var g = $c52bca934bf2714c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c52bca934bf2714c$var$Pe = $c52bca934bf2714c$var$ia && "documentMode" in document && 11 >= document.documentMode, $c52bca934bf2714c$var$Qe = null, $c52bca934bf2714c$var$Re = null, $c52bca934bf2714c$var$Se = null, $c52bca934bf2714c$var$Te = !1;
function $c52bca934bf2714c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c52bca934bf2714c$var$Te || null == $c52bca934bf2714c$var$Qe || $c52bca934bf2714c$var$Qe !== $c52bca934bf2714c$var$Xa(d) || (d = $c52bca934bf2714c$var$Qe, "selectionStart" in d && $c52bca934bf2714c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c52bca934bf2714c$var$Se && $c52bca934bf2714c$var$Ie($c52bca934bf2714c$var$Se, d) || ($c52bca934bf2714c$var$Se = d, d = $c52bca934bf2714c$var$oe($c52bca934bf2714c$var$Re, "onSelect"), 0 < d.length && (b = new $c52bca934bf2714c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c52bca934bf2714c$var$Qe)));
}
function $c52bca934bf2714c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c52bca934bf2714c$var$We = {
    animationend: $c52bca934bf2714c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c52bca934bf2714c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c52bca934bf2714c$var$Ve("Animation", "AnimationStart"),
    transitionend: $c52bca934bf2714c$var$Ve("Transition", "TransitionEnd")
}, $c52bca934bf2714c$var$Xe = {}, $c52bca934bf2714c$var$Ye = {};
$c52bca934bf2714c$var$ia && ($c52bca934bf2714c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c52bca934bf2714c$var$We.animationend.animation, delete $c52bca934bf2714c$var$We.animationiteration.animation, delete $c52bca934bf2714c$var$We.animationstart.animation), "TransitionEvent" in window || delete $c52bca934bf2714c$var$We.transitionend.transition);
function $c52bca934bf2714c$var$Ze(a) {
    if ($c52bca934bf2714c$var$Xe[a]) return $c52bca934bf2714c$var$Xe[a];
    if (!$c52bca934bf2714c$var$We[a]) return a;
    var b = $c52bca934bf2714c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c52bca934bf2714c$var$Ye) return $c52bca934bf2714c$var$Xe[a] = b[c];
    return a;
}
var $c52bca934bf2714c$var$$e = $c52bca934bf2714c$var$Ze("animationend"), $c52bca934bf2714c$var$af = $c52bca934bf2714c$var$Ze("animationiteration"), $c52bca934bf2714c$var$bf = $c52bca934bf2714c$var$Ze("animationstart"), $c52bca934bf2714c$var$cf = $c52bca934bf2714c$var$Ze("transitionend"), $c52bca934bf2714c$var$df = new Map, $c52bca934bf2714c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c52bca934bf2714c$var$ff(a, b) {
    $c52bca934bf2714c$var$df.set(a, b);
    $c52bca934bf2714c$var$fa(b, [
        a
    ]);
}
for(var $c52bca934bf2714c$var$gf = 0; $c52bca934bf2714c$var$gf < $c52bca934bf2714c$var$ef.length; $c52bca934bf2714c$var$gf++){
    var $c52bca934bf2714c$var$hf = $c52bca934bf2714c$var$ef[$c52bca934bf2714c$var$gf], $c52bca934bf2714c$var$jf = $c52bca934bf2714c$var$hf.toLowerCase(), $c52bca934bf2714c$var$kf = $c52bca934bf2714c$var$hf[0].toUpperCase() + $c52bca934bf2714c$var$hf.slice(1);
    $c52bca934bf2714c$var$ff($c52bca934bf2714c$var$jf, "on" + $c52bca934bf2714c$var$kf);
}
$c52bca934bf2714c$var$ff($c52bca934bf2714c$var$$e, "onAnimationEnd");
$c52bca934bf2714c$var$ff($c52bca934bf2714c$var$af, "onAnimationIteration");
$c52bca934bf2714c$var$ff($c52bca934bf2714c$var$bf, "onAnimationStart");
$c52bca934bf2714c$var$ff("dblclick", "onDoubleClick");
$c52bca934bf2714c$var$ff("focusin", "onFocus");
$c52bca934bf2714c$var$ff("focusout", "onBlur");
$c52bca934bf2714c$var$ff($c52bca934bf2714c$var$cf, "onTransitionEnd");
$c52bca934bf2714c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c52bca934bf2714c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c52bca934bf2714c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c52bca934bf2714c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c52bca934bf2714c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c52bca934bf2714c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c52bca934bf2714c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c52bca934bf2714c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c52bca934bf2714c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c52bca934bf2714c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c52bca934bf2714c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c52bca934bf2714c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c52bca934bf2714c$var$lf));
function $c52bca934bf2714c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c52bca934bf2714c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c52bca934bf2714c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c52bca934bf2714c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c52bca934bf2714c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c52bca934bf2714c$var$Qb) throw a = $c52bca934bf2714c$var$Rb, $c52bca934bf2714c$var$Qb = !1, $c52bca934bf2714c$var$Rb = null, a;
}
function $c52bca934bf2714c$var$D(a, b) {
    var c = b[$c52bca934bf2714c$var$of];
    void 0 === c && (c = b[$c52bca934bf2714c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c52bca934bf2714c$var$pf(b, a, 2, !1), c.add(d));
}
function $c52bca934bf2714c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c52bca934bf2714c$var$pf(c, a, d, b);
}
var $c52bca934bf2714c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c52bca934bf2714c$var$sf(a) {
    if (!a[$c52bca934bf2714c$var$rf]) {
        a[$c52bca934bf2714c$var$rf] = !0;
        $c52bca934bf2714c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c52bca934bf2714c$var$mf.has(b) || $c52bca934bf2714c$var$qf(b, !1, a), $c52bca934bf2714c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c52bca934bf2714c$var$rf] || (b[$c52bca934bf2714c$var$rf] = !0, $c52bca934bf2714c$var$qf("selectionchange", !1, b));
    }
}
function $c52bca934bf2714c$var$pf(a, b, c, d) {
    switch($c52bca934bf2714c$var$jd(b)){
        case 1:
            var e = $c52bca934bf2714c$var$ed;
            break;
        case 4:
            e = $c52bca934bf2714c$var$gd;
            break;
        default:
            e = $c52bca934bf2714c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c52bca934bf2714c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c52bca934bf2714c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c52bca934bf2714c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c52bca934bf2714c$var$Jb(function() {
        var _$d = f, _$e = $c52bca934bf2714c$var$xb(c), g = [];
        a: {
            var h = $c52bca934bf2714c$var$df.get(a);
            if (void 0 !== h) {
                var k = $c52bca934bf2714c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c52bca934bf2714c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c52bca934bf2714c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c52bca934bf2714c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c52bca934bf2714c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c52bca934bf2714c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c52bca934bf2714c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c52bca934bf2714c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c52bca934bf2714c$var$Vd;
                        break;
                    case $c52bca934bf2714c$var$$e:
                    case $c52bca934bf2714c$var$af:
                    case $c52bca934bf2714c$var$bf:
                        k = $c52bca934bf2714c$var$Hd;
                        break;
                    case $c52bca934bf2714c$var$cf:
                        k = $c52bca934bf2714c$var$Xd;
                        break;
                    case "scroll":
                        k = $c52bca934bf2714c$var$vd;
                        break;
                    case "wheel":
                        k = $c52bca934bf2714c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c52bca934bf2714c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c52bca934bf2714c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c52bca934bf2714c$var$Kb(w, x), null != F && t.push($c52bca934bf2714c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c52bca934bf2714c$var$wb && (n = c.relatedTarget || c.fromElement) && ($c52bca934bf2714c$var$Wc(n) || n[$c52bca934bf2714c$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $c52bca934bf2714c$var$Wc(n) : null, null !== n && (J = $c52bca934bf2714c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $c52bca934bf2714c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c52bca934bf2714c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c52bca934bf2714c$var$ue(k);
                        u = null == n ? h : $c52bca934bf2714c$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c52bca934bf2714c$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c52bca934bf2714c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c52bca934bf2714c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c52bca934bf2714c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c52bca934bf2714c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c52bca934bf2714c$var$vf(t);
                                x = $c52bca934bf2714c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c52bca934bf2714c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c52bca934bf2714c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $c52bca934bf2714c$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c52bca934bf2714c$var$ve;
                else if ($c52bca934bf2714c$var$me(h)) {
                    if ($c52bca934bf2714c$var$we) na = $c52bca934bf2714c$var$Fe;
                    else {
                        na = $c52bca934bf2714c$var$De;
                        var xa = $c52bca934bf2714c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c52bca934bf2714c$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $c52bca934bf2714c$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c52bca934bf2714c$var$cb(h, "number", h.value);
            }
            xa = _$d ? $c52bca934bf2714c$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($c52bca934bf2714c$var$me(xa) || "true" === xa.contentEditable) $c52bca934bf2714c$var$Qe = xa, $c52bca934bf2714c$var$Re = _$d, $c52bca934bf2714c$var$Se = null;
                    break;
                case "focusout":
                    $c52bca934bf2714c$var$Se = $c52bca934bf2714c$var$Re = $c52bca934bf2714c$var$Qe = null;
                    break;
                case "mousedown":
                    $c52bca934bf2714c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c52bca934bf2714c$var$Te = !1;
                    $c52bca934bf2714c$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($c52bca934bf2714c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c52bca934bf2714c$var$Ue(g, c, _$e);
            }
            var $a;
            if ($c52bca934bf2714c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c52bca934bf2714c$var$ie ? $c52bca934bf2714c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c52bca934bf2714c$var$de && "ko" !== c.locale && ($c52bca934bf2714c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c52bca934bf2714c$var$ie && ($a = $c52bca934bf2714c$var$nd()) : ($c52bca934bf2714c$var$kd = _$e, $c52bca934bf2714c$var$ld = "value" in $c52bca934bf2714c$var$kd ? $c52bca934bf2714c$var$kd.value : $c52bca934bf2714c$var$kd.textContent, $c52bca934bf2714c$var$ie = !0)), xa = $c52bca934bf2714c$var$oe(_$d, ba), 0 < xa.length && (ba = new $c52bca934bf2714c$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c52bca934bf2714c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c52bca934bf2714c$var$ce ? $c52bca934bf2714c$var$je(a, c) : $c52bca934bf2714c$var$ke(a, c)) _$d = $c52bca934bf2714c$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $c52bca934bf2714c$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $c52bca934bf2714c$var$se(g, b);
    });
}
function $c52bca934bf2714c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c52bca934bf2714c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c52bca934bf2714c$var$Kb(a, c), null != f && d.unshift($c52bca934bf2714c$var$tf(a, f, e)), f = $c52bca934bf2714c$var$Kb(a, b), null != f && d.push($c52bca934bf2714c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c52bca934bf2714c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c52bca934bf2714c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c52bca934bf2714c$var$Kb(c, f), null != k && g.unshift($c52bca934bf2714c$var$tf(c, k, h))) : e || (k = $c52bca934bf2714c$var$Kb(c, f), null != k && g.push($c52bca934bf2714c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c52bca934bf2714c$var$xf = /\r\n?/g, $c52bca934bf2714c$var$yf = /\u0000|\uFFFD/g;
function $c52bca934bf2714c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c52bca934bf2714c$var$xf, "\n").replace($c52bca934bf2714c$var$yf, "");
}
function $c52bca934bf2714c$var$Af(a, b, c) {
    b = $c52bca934bf2714c$var$zf(b);
    if ($c52bca934bf2714c$var$zf(a) !== b && c) throw Error($c52bca934bf2714c$var$p(425));
}
function $c52bca934bf2714c$var$Bf() {}
var $c52bca934bf2714c$var$Cf = null, $c52bca934bf2714c$var$Df = null;
function $c52bca934bf2714c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c52bca934bf2714c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c52bca934bf2714c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c52bca934bf2714c$var$Hf = "function" === typeof Promise ? Promise : void 0, $c52bca934bf2714c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c52bca934bf2714c$var$Hf ? function Jf(a) {
    return $c52bca934bf2714c$var$Hf.resolve(null).then(a).catch($c52bca934bf2714c$var$If);
} : $c52bca934bf2714c$var$Ff;
function $c52bca934bf2714c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c52bca934bf2714c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c52bca934bf2714c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c52bca934bf2714c$var$bd(b);
}
function $c52bca934bf2714c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c52bca934bf2714c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c52bca934bf2714c$var$Nf = Math.random().toString(36).slice(2), $c52bca934bf2714c$var$Of = "__reactFiber$" + $c52bca934bf2714c$var$Nf, $c52bca934bf2714c$var$Pf = "__reactProps$" + $c52bca934bf2714c$var$Nf, $c52bca934bf2714c$var$uf = "__reactContainer$" + $c52bca934bf2714c$var$Nf, $c52bca934bf2714c$var$of = "__reactEvents$" + $c52bca934bf2714c$var$Nf, $c52bca934bf2714c$var$Qf = "__reactListeners$" + $c52bca934bf2714c$var$Nf, $c52bca934bf2714c$var$Rf = "__reactHandles$" + $c52bca934bf2714c$var$Nf;
function $c52bca934bf2714c$var$Wc(a) {
    var b = a[$c52bca934bf2714c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c52bca934bf2714c$var$uf] || c[$c52bca934bf2714c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c52bca934bf2714c$var$Mf(a); null !== a;){
                if (c = a[$c52bca934bf2714c$var$Of]) return c;
                a = $c52bca934bf2714c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c52bca934bf2714c$var$Cb(a) {
    a = a[$c52bca934bf2714c$var$Of] || a[$c52bca934bf2714c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c52bca934bf2714c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c52bca934bf2714c$var$p(33));
}
function $c52bca934bf2714c$var$Db(a) {
    return a[$c52bca934bf2714c$var$Pf] || null;
}
var $c52bca934bf2714c$var$Sf = [], $c52bca934bf2714c$var$Tf = -1;
function $c52bca934bf2714c$var$Uf(a) {
    return {
        current: a
    };
}
function $c52bca934bf2714c$var$E(a) {
    0 > $c52bca934bf2714c$var$Tf || (a.current = $c52bca934bf2714c$var$Sf[$c52bca934bf2714c$var$Tf], $c52bca934bf2714c$var$Sf[$c52bca934bf2714c$var$Tf] = null, $c52bca934bf2714c$var$Tf--);
}
function $c52bca934bf2714c$var$G(a, b) {
    $c52bca934bf2714c$var$Tf++;
    $c52bca934bf2714c$var$Sf[$c52bca934bf2714c$var$Tf] = a.current;
    a.current = b;
}
var $c52bca934bf2714c$var$Vf = {}, $c52bca934bf2714c$var$H = $c52bca934bf2714c$var$Uf($c52bca934bf2714c$var$Vf), $c52bca934bf2714c$var$Wf = $c52bca934bf2714c$var$Uf(!1), $c52bca934bf2714c$var$Xf = $c52bca934bf2714c$var$Vf;
function $c52bca934bf2714c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c52bca934bf2714c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c52bca934bf2714c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c52bca934bf2714c$var$$f() {
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Wf);
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$H);
}
function $c52bca934bf2714c$var$ag(a, b, c) {
    if ($c52bca934bf2714c$var$H.current !== $c52bca934bf2714c$var$Vf) throw Error($c52bca934bf2714c$var$p(168));
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$H, b);
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Wf, c);
}
function $c52bca934bf2714c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c52bca934bf2714c$var$p(108, $c52bca934bf2714c$var$Ra(a) || "Unknown", e));
    return $c52bca934bf2714c$var$A({}, c, d);
}
function $c52bca934bf2714c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c52bca934bf2714c$var$Vf;
    $c52bca934bf2714c$var$Xf = $c52bca934bf2714c$var$H.current;
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$H, a);
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Wf, $c52bca934bf2714c$var$Wf.current);
    return !0;
}
function $c52bca934bf2714c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c52bca934bf2714c$var$p(169));
    c ? (a = $c52bca934bf2714c$var$bg(a, b, $c52bca934bf2714c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Wf), $c52bca934bf2714c$var$E($c52bca934bf2714c$var$H), $c52bca934bf2714c$var$G($c52bca934bf2714c$var$H, a)) : $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Wf);
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Wf, c);
}
var $c52bca934bf2714c$var$eg = null, $c52bca934bf2714c$var$fg = !1, $c52bca934bf2714c$var$gg = !1;
function $c52bca934bf2714c$var$hg(a) {
    null === $c52bca934bf2714c$var$eg ? $c52bca934bf2714c$var$eg = [
        a
    ] : $c52bca934bf2714c$var$eg.push(a);
}
function $c52bca934bf2714c$var$ig(a) {
    $c52bca934bf2714c$var$fg = !0;
    $c52bca934bf2714c$var$hg(a);
}
function $c52bca934bf2714c$var$jg() {
    if (!$c52bca934bf2714c$var$gg && null !== $c52bca934bf2714c$var$eg) {
        $c52bca934bf2714c$var$gg = !0;
        var a = 0, b = $c52bca934bf2714c$var$C;
        try {
            var c = $c52bca934bf2714c$var$eg;
            for($c52bca934bf2714c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c52bca934bf2714c$var$eg = null;
            $c52bca934bf2714c$var$fg = !1;
        } catch (e) {
            throw null !== $c52bca934bf2714c$var$eg && ($c52bca934bf2714c$var$eg = $c52bca934bf2714c$var$eg.slice(a + 1)), $c52bca934bf2714c$var$ac($c52bca934bf2714c$var$fc, $c52bca934bf2714c$var$jg), e;
        } finally{
            $c52bca934bf2714c$var$C = b, $c52bca934bf2714c$var$gg = !1;
        }
    }
    return null;
}
var $c52bca934bf2714c$var$kg = [], $c52bca934bf2714c$var$lg = 0, $c52bca934bf2714c$var$mg = null, $c52bca934bf2714c$var$ng = 0, $c52bca934bf2714c$var$og = [], $c52bca934bf2714c$var$pg = 0, $c52bca934bf2714c$var$qg = null, $c52bca934bf2714c$var$rg = 1, $c52bca934bf2714c$var$sg = "";
function $c52bca934bf2714c$var$tg(a, b) {
    $c52bca934bf2714c$var$kg[$c52bca934bf2714c$var$lg++] = $c52bca934bf2714c$var$ng;
    $c52bca934bf2714c$var$kg[$c52bca934bf2714c$var$lg++] = $c52bca934bf2714c$var$mg;
    $c52bca934bf2714c$var$mg = a;
    $c52bca934bf2714c$var$ng = b;
}
function $c52bca934bf2714c$var$ug(a, b, c) {
    $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg++] = $c52bca934bf2714c$var$rg;
    $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg++] = $c52bca934bf2714c$var$sg;
    $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg++] = $c52bca934bf2714c$var$qg;
    $c52bca934bf2714c$var$qg = a;
    var d = $c52bca934bf2714c$var$rg;
    a = $c52bca934bf2714c$var$sg;
    var e = 32 - $c52bca934bf2714c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c52bca934bf2714c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c52bca934bf2714c$var$rg = 1 << 32 - $c52bca934bf2714c$var$oc(b) + e | c << e | d;
        $c52bca934bf2714c$var$sg = f + a;
    } else $c52bca934bf2714c$var$rg = 1 << f | c << e | d, $c52bca934bf2714c$var$sg = a;
}
function $c52bca934bf2714c$var$vg(a) {
    null !== a.return && ($c52bca934bf2714c$var$tg(a, 1), $c52bca934bf2714c$var$ug(a, 1, 0));
}
function $c52bca934bf2714c$var$wg(a) {
    for(; a === $c52bca934bf2714c$var$mg;)$c52bca934bf2714c$var$mg = $c52bca934bf2714c$var$kg[--$c52bca934bf2714c$var$lg], $c52bca934bf2714c$var$kg[$c52bca934bf2714c$var$lg] = null, $c52bca934bf2714c$var$ng = $c52bca934bf2714c$var$kg[--$c52bca934bf2714c$var$lg], $c52bca934bf2714c$var$kg[$c52bca934bf2714c$var$lg] = null;
    for(; a === $c52bca934bf2714c$var$qg;)$c52bca934bf2714c$var$qg = $c52bca934bf2714c$var$og[--$c52bca934bf2714c$var$pg], $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg] = null, $c52bca934bf2714c$var$sg = $c52bca934bf2714c$var$og[--$c52bca934bf2714c$var$pg], $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg] = null, $c52bca934bf2714c$var$rg = $c52bca934bf2714c$var$og[--$c52bca934bf2714c$var$pg], $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg] = null;
}
var $c52bca934bf2714c$var$xg = null, $c52bca934bf2714c$var$yg = null, $c52bca934bf2714c$var$I = !1, $c52bca934bf2714c$var$zg = null;
function $c52bca934bf2714c$var$Ag(a, b) {
    var c = $c52bca934bf2714c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c52bca934bf2714c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c52bca934bf2714c$var$xg = a, $c52bca934bf2714c$var$yg = $c52bca934bf2714c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c52bca934bf2714c$var$xg = a, $c52bca934bf2714c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c52bca934bf2714c$var$qg ? {
                id: $c52bca934bf2714c$var$rg,
                overflow: $c52bca934bf2714c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c52bca934bf2714c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c52bca934bf2714c$var$xg = a, $c52bca934bf2714c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c52bca934bf2714c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c52bca934bf2714c$var$Eg(a) {
    if ($c52bca934bf2714c$var$I) {
        var b = $c52bca934bf2714c$var$yg;
        if (b) {
            var c = b;
            if (!$c52bca934bf2714c$var$Cg(a, b)) {
                if ($c52bca934bf2714c$var$Dg(a)) throw Error($c52bca934bf2714c$var$p(418));
                b = $c52bca934bf2714c$var$Lf(c.nextSibling);
                var d = $c52bca934bf2714c$var$xg;
                b && $c52bca934bf2714c$var$Cg(a, b) ? $c52bca934bf2714c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c52bca934bf2714c$var$I = !1, $c52bca934bf2714c$var$xg = a);
            }
        } else {
            if ($c52bca934bf2714c$var$Dg(a)) throw Error($c52bca934bf2714c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c52bca934bf2714c$var$I = !1;
            $c52bca934bf2714c$var$xg = a;
        }
    }
}
function $c52bca934bf2714c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c52bca934bf2714c$var$xg = a;
}
function $c52bca934bf2714c$var$Gg(a) {
    if (a !== $c52bca934bf2714c$var$xg) return !1;
    if (!$c52bca934bf2714c$var$I) return $c52bca934bf2714c$var$Fg(a), $c52bca934bf2714c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c52bca934bf2714c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c52bca934bf2714c$var$yg)) {
        if ($c52bca934bf2714c$var$Dg(a)) throw $c52bca934bf2714c$var$Hg(), Error($c52bca934bf2714c$var$p(418));
        for(; b;)$c52bca934bf2714c$var$Ag(a, b), b = $c52bca934bf2714c$var$Lf(b.nextSibling);
    }
    $c52bca934bf2714c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c52bca934bf2714c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c52bca934bf2714c$var$yg = $c52bca934bf2714c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c52bca934bf2714c$var$yg = null;
        }
    } else $c52bca934bf2714c$var$yg = $c52bca934bf2714c$var$xg ? $c52bca934bf2714c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c52bca934bf2714c$var$Hg() {
    for(var a = $c52bca934bf2714c$var$yg; a;)a = $c52bca934bf2714c$var$Lf(a.nextSibling);
}
function $c52bca934bf2714c$var$Ig() {
    $c52bca934bf2714c$var$yg = $c52bca934bf2714c$var$xg = null;
    $c52bca934bf2714c$var$I = !1;
}
function $c52bca934bf2714c$var$Jg(a) {
    null === $c52bca934bf2714c$var$zg ? $c52bca934bf2714c$var$zg = [
        a
    ] : $c52bca934bf2714c$var$zg.push(a);
}
var $c52bca934bf2714c$var$Kg = $c52bca934bf2714c$var$ua.ReactCurrentBatchConfig;
function $c52bca934bf2714c$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c52bca934bf2714c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c52bca934bf2714c$var$Mg = $c52bca934bf2714c$var$Uf(null), $c52bca934bf2714c$var$Ng = null, $c52bca934bf2714c$var$Og = null, $c52bca934bf2714c$var$Pg = null;
function $c52bca934bf2714c$var$Qg() {
    $c52bca934bf2714c$var$Pg = $c52bca934bf2714c$var$Og = $c52bca934bf2714c$var$Ng = null;
}
function $c52bca934bf2714c$var$Rg(a) {
    var b = $c52bca934bf2714c$var$Mg.current;
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Mg);
    a._currentValue = b;
}
function $c52bca934bf2714c$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c52bca934bf2714c$var$Tg(a, b) {
    $c52bca934bf2714c$var$Ng = a;
    $c52bca934bf2714c$var$Pg = $c52bca934bf2714c$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c52bca934bf2714c$var$Ug = !0), a.firstContext = null);
}
function $c52bca934bf2714c$var$Vg(a) {
    var b = a._currentValue;
    if ($c52bca934bf2714c$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c52bca934bf2714c$var$Og) {
            if (null === $c52bca934bf2714c$var$Ng) throw Error($c52bca934bf2714c$var$p(308));
            $c52bca934bf2714c$var$Og = a;
            $c52bca934bf2714c$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c52bca934bf2714c$var$Og = $c52bca934bf2714c$var$Og.next = a;
    }
    return b;
}
var $c52bca934bf2714c$var$Wg = null;
function $c52bca934bf2714c$var$Xg(a) {
    null === $c52bca934bf2714c$var$Wg ? $c52bca934bf2714c$var$Wg = [
        a
    ] : $c52bca934bf2714c$var$Wg.push(a);
}
function $c52bca934bf2714c$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c52bca934bf2714c$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c52bca934bf2714c$var$Zg(a, d);
}
function $c52bca934bf2714c$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c52bca934bf2714c$var$$g = !1;
function $c52bca934bf2714c$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c52bca934bf2714c$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c52bca934bf2714c$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c52bca934bf2714c$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c52bca934bf2714c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c52bca934bf2714c$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c52bca934bf2714c$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c52bca934bf2714c$var$Zg(a, c);
}
function $c52bca934bf2714c$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c52bca934bf2714c$var$Cc(a, c);
    }
}
function $c52bca934bf2714c$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c52bca934bf2714c$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c52bca934bf2714c$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c52bca934bf2714c$var$A({}, q, r);
                            break a;
                        case 2:
                            $c52bca934bf2714c$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c52bca934bf2714c$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c52bca934bf2714c$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c52bca934bf2714c$var$p(191, e));
            e.call(d);
        }
    }
}
var $c52bca934bf2714c$var$jh = (new $lcrTp.Component).refs;
function $c52bca934bf2714c$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c52bca934bf2714c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c52bca934bf2714c$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $c52bca934bf2714c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $c52bca934bf2714c$var$L(), e = $c52bca934bf2714c$var$lh(a), f = $c52bca934bf2714c$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c52bca934bf2714c$var$dh(a, f, e);
        null !== b && ($c52bca934bf2714c$var$mh(b, a, e, d), $c52bca934bf2714c$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $c52bca934bf2714c$var$L(), e = $c52bca934bf2714c$var$lh(a), f = $c52bca934bf2714c$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c52bca934bf2714c$var$dh(a, f, e);
        null !== b && ($c52bca934bf2714c$var$mh(b, a, e, d), $c52bca934bf2714c$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $c52bca934bf2714c$var$L(), d = $c52bca934bf2714c$var$lh(a), e = $c52bca934bf2714c$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c52bca934bf2714c$var$dh(a, e, d);
        null !== b && ($c52bca934bf2714c$var$mh(b, a, d, c), $c52bca934bf2714c$var$eh(b, a, d));
    }
};
function $c52bca934bf2714c$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c52bca934bf2714c$var$Ie(c, d) || !$c52bca934bf2714c$var$Ie(e, f) : !0;
}
function $c52bca934bf2714c$var$ph(a, b, c) {
    var d = !1, e = $c52bca934bf2714c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c52bca934bf2714c$var$Vg(f) : (e = $c52bca934bf2714c$var$Zf(b) ? $c52bca934bf2714c$var$Xf : $c52bca934bf2714c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c52bca934bf2714c$var$Yf(a, e) : $c52bca934bf2714c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c52bca934bf2714c$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c52bca934bf2714c$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c52bca934bf2714c$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c52bca934bf2714c$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c52bca934bf2714c$var$jh;
    $c52bca934bf2714c$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c52bca934bf2714c$var$Vg(f) : (f = $c52bca934bf2714c$var$Zf(b) ? $c52bca934bf2714c$var$Xf : $c52bca934bf2714c$var$H.current, e.context = $c52bca934bf2714c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c52bca934bf2714c$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c52bca934bf2714c$var$nh.enqueueReplaceState(e, e.state, null), $c52bca934bf2714c$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c52bca934bf2714c$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c52bca934bf2714c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c52bca934bf2714c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $c52bca934bf2714c$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c52bca934bf2714c$var$p(284));
        if (!c._owner) throw Error($c52bca934bf2714c$var$p(290, a));
    }
    return a;
}
function $c52bca934bf2714c$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c52bca934bf2714c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c52bca934bf2714c$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c52bca934bf2714c$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c52bca934bf2714c$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c52bca934bf2714c$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c52bca934bf2714c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c52bca934bf2714c$var$Ha && $c52bca934bf2714c$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c52bca934bf2714c$var$sh(a, b, c), d.return = a, d;
        d = $c52bca934bf2714c$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c52bca934bf2714c$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c52bca934bf2714c$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c52bca934bf2714c$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c52bca934bf2714c$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c52bca934bf2714c$var$va:
                    return c = $c52bca934bf2714c$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c52bca934bf2714c$var$sh(a, null, b), c.return = a, c;
                case $c52bca934bf2714c$var$wa:
                    return b = $c52bca934bf2714c$var$zh(b, a.mode, c), b.return = a, b;
                case $c52bca934bf2714c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c52bca934bf2714c$var$eb(b) || $c52bca934bf2714c$var$Ka(b)) return b = $c52bca934bf2714c$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c52bca934bf2714c$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c52bca934bf2714c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c52bca934bf2714c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c52bca934bf2714c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c52bca934bf2714c$var$eb(c) || $c52bca934bf2714c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c52bca934bf2714c$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c52bca934bf2714c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c52bca934bf2714c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c52bca934bf2714c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c52bca934bf2714c$var$eb(d) || $c52bca934bf2714c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c52bca934bf2714c$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c52bca934bf2714c$var$I && $c52bca934bf2714c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c52bca934bf2714c$var$I && $c52bca934bf2714c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c52bca934bf2714c$var$I && $c52bca934bf2714c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c52bca934bf2714c$var$Ka(h);
        if ("function" !== typeof l) throw Error($c52bca934bf2714c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c52bca934bf2714c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c52bca934bf2714c$var$I && $c52bca934bf2714c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c52bca934bf2714c$var$I && $c52bca934bf2714c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c52bca934bf2714c$var$I && $c52bca934bf2714c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c52bca934bf2714c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c52bca934bf2714c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c52bca934bf2714c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c52bca934bf2714c$var$Ha && $c52bca934bf2714c$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c52bca934bf2714c$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c52bca934bf2714c$var$ya ? (d = $c52bca934bf2714c$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c52bca934bf2714c$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c52bca934bf2714c$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c52bca934bf2714c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c52bca934bf2714c$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c52bca934bf2714c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c52bca934bf2714c$var$eb(f)) return n(a, d, f, h);
            if ($c52bca934bf2714c$var$Ka(f)) return t(a, d, f, h);
            $c52bca934bf2714c$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c52bca934bf2714c$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c52bca934bf2714c$var$Bh = $c52bca934bf2714c$var$vh(!0), $c52bca934bf2714c$var$Ch = $c52bca934bf2714c$var$vh(!1), $c52bca934bf2714c$var$Dh = {}, $c52bca934bf2714c$var$Eh = $c52bca934bf2714c$var$Uf($c52bca934bf2714c$var$Dh), $c52bca934bf2714c$var$Fh = $c52bca934bf2714c$var$Uf($c52bca934bf2714c$var$Dh), $c52bca934bf2714c$var$Gh = $c52bca934bf2714c$var$Uf($c52bca934bf2714c$var$Dh);
function $c52bca934bf2714c$var$Hh(a) {
    if (a === $c52bca934bf2714c$var$Dh) throw Error($c52bca934bf2714c$var$p(174));
    return a;
}
function $c52bca934bf2714c$var$Ih(a, b) {
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Gh, b);
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Fh, a);
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Eh, $c52bca934bf2714c$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c52bca934bf2714c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c52bca934bf2714c$var$lb(b, a);
    }
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Eh);
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Eh, b);
}
function $c52bca934bf2714c$var$Jh() {
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Eh);
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Fh);
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Gh);
}
function $c52bca934bf2714c$var$Kh(a) {
    $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Gh.current);
    var b = $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Eh.current);
    var c = $c52bca934bf2714c$var$lb(b, a.type);
    b !== c && ($c52bca934bf2714c$var$G($c52bca934bf2714c$var$Fh, a), $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Eh, c));
}
function $c52bca934bf2714c$var$Lh(a) {
    $c52bca934bf2714c$var$Fh.current === a && ($c52bca934bf2714c$var$E($c52bca934bf2714c$var$Eh), $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Fh));
}
var $c52bca934bf2714c$var$M = $c52bca934bf2714c$var$Uf(0);
function $c52bca934bf2714c$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c52bca934bf2714c$var$Nh = [];
function $c52bca934bf2714c$var$Oh() {
    for(var a = 0; a < $c52bca934bf2714c$var$Nh.length; a++)$c52bca934bf2714c$var$Nh[a]._workInProgressVersionPrimary = null;
    $c52bca934bf2714c$var$Nh.length = 0;
}
var $c52bca934bf2714c$var$Ph = $c52bca934bf2714c$var$ua.ReactCurrentDispatcher, $c52bca934bf2714c$var$Qh = $c52bca934bf2714c$var$ua.ReactCurrentBatchConfig, $c52bca934bf2714c$var$Rh = 0, $c52bca934bf2714c$var$N = null, $c52bca934bf2714c$var$O = null, $c52bca934bf2714c$var$P = null, $c52bca934bf2714c$var$Sh = !1, $c52bca934bf2714c$var$Th = !1, $c52bca934bf2714c$var$Uh = 0, $c52bca934bf2714c$var$Vh = 0;
function $c52bca934bf2714c$var$Q() {
    throw Error($c52bca934bf2714c$var$p(321));
}
function $c52bca934bf2714c$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c52bca934bf2714c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c52bca934bf2714c$var$Xh(a, b, c, d, e, f) {
    $c52bca934bf2714c$var$Rh = f;
    $c52bca934bf2714c$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c52bca934bf2714c$var$Ph.current = null === a || null === a.memoizedState ? $c52bca934bf2714c$var$Yh : $c52bca934bf2714c$var$Zh;
    a = c(d, e);
    if ($c52bca934bf2714c$var$Th) {
        f = 0;
        do {
            $c52bca934bf2714c$var$Th = !1;
            $c52bca934bf2714c$var$Uh = 0;
            if (25 <= f) throw Error($c52bca934bf2714c$var$p(301));
            f += 1;
            $c52bca934bf2714c$var$P = $c52bca934bf2714c$var$O = null;
            b.updateQueue = null;
            $c52bca934bf2714c$var$Ph.current = $c52bca934bf2714c$var$$h;
            a = c(d, e);
        }while ($c52bca934bf2714c$var$Th);
    }
    $c52bca934bf2714c$var$Ph.current = $c52bca934bf2714c$var$ai;
    b = null !== $c52bca934bf2714c$var$O && null !== $c52bca934bf2714c$var$O.next;
    $c52bca934bf2714c$var$Rh = 0;
    $c52bca934bf2714c$var$P = $c52bca934bf2714c$var$O = $c52bca934bf2714c$var$N = null;
    $c52bca934bf2714c$var$Sh = !1;
    if (b) throw Error($c52bca934bf2714c$var$p(300));
    return a;
}
function $c52bca934bf2714c$var$bi() {
    var a = 0 !== $c52bca934bf2714c$var$Uh;
    $c52bca934bf2714c$var$Uh = 0;
    return a;
}
function $c52bca934bf2714c$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c52bca934bf2714c$var$P ? $c52bca934bf2714c$var$N.memoizedState = $c52bca934bf2714c$var$P = a : $c52bca934bf2714c$var$P = $c52bca934bf2714c$var$P.next = a;
    return $c52bca934bf2714c$var$P;
}
function $c52bca934bf2714c$var$di() {
    if (null === $c52bca934bf2714c$var$O) {
        var a = $c52bca934bf2714c$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c52bca934bf2714c$var$O.next;
    var b = null === $c52bca934bf2714c$var$P ? $c52bca934bf2714c$var$N.memoizedState : $c52bca934bf2714c$var$P.next;
    if (null !== b) $c52bca934bf2714c$var$P = b, $c52bca934bf2714c$var$O = a;
    else {
        if (null === a) throw Error($c52bca934bf2714c$var$p(310));
        $c52bca934bf2714c$var$O = a;
        a = {
            memoizedState: $c52bca934bf2714c$var$O.memoizedState,
            baseState: $c52bca934bf2714c$var$O.baseState,
            baseQueue: $c52bca934bf2714c$var$O.baseQueue,
            queue: $c52bca934bf2714c$var$O.queue,
            next: null
        };
        null === $c52bca934bf2714c$var$P ? $c52bca934bf2714c$var$N.memoizedState = $c52bca934bf2714c$var$P = a : $c52bca934bf2714c$var$P = $c52bca934bf2714c$var$P.next = a;
    }
    return $c52bca934bf2714c$var$P;
}
function $c52bca934bf2714c$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c52bca934bf2714c$var$fi(a) {
    var b = $c52bca934bf2714c$var$di(), c = b.queue;
    if (null === c) throw Error($c52bca934bf2714c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c52bca934bf2714c$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c52bca934bf2714c$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c52bca934bf2714c$var$N.lanes |= m;
                $c52bca934bf2714c$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c52bca934bf2714c$var$He(d, b.memoizedState) || ($c52bca934bf2714c$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c52bca934bf2714c$var$N.lanes |= f, $c52bca934bf2714c$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c52bca934bf2714c$var$gi(a) {
    var b = $c52bca934bf2714c$var$di(), c = b.queue;
    if (null === c) throw Error($c52bca934bf2714c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c52bca934bf2714c$var$He(f, b.memoizedState) || ($c52bca934bf2714c$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c52bca934bf2714c$var$hi() {}
function $c52bca934bf2714c$var$ii(a, b) {
    var c = $c52bca934bf2714c$var$N, d = $c52bca934bf2714c$var$di(), e = b(), f = !$c52bca934bf2714c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c52bca934bf2714c$var$Ug = !0);
    d = d.queue;
    $c52bca934bf2714c$var$ji($c52bca934bf2714c$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c52bca934bf2714c$var$P && $c52bca934bf2714c$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c52bca934bf2714c$var$li(9, $c52bca934bf2714c$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c52bca934bf2714c$var$R) throw Error($c52bca934bf2714c$var$p(349));
        0 !== ($c52bca934bf2714c$var$Rh & 30) || $c52bca934bf2714c$var$ni(c, b, e);
    }
    return e;
}
function $c52bca934bf2714c$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c52bca934bf2714c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c52bca934bf2714c$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c52bca934bf2714c$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c52bca934bf2714c$var$oi(b) && $c52bca934bf2714c$var$pi(a);
}
function $c52bca934bf2714c$var$ki(a, b, c) {
    return c(function() {
        $c52bca934bf2714c$var$oi(b) && $c52bca934bf2714c$var$pi(a);
    });
}
function $c52bca934bf2714c$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c52bca934bf2714c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c52bca934bf2714c$var$pi(a) {
    var b = $c52bca934bf2714c$var$Zg(a, 1);
    null !== b && $c52bca934bf2714c$var$mh(b, a, 1, -1);
}
function $c52bca934bf2714c$var$qi(a) {
    var b = $c52bca934bf2714c$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c52bca934bf2714c$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c52bca934bf2714c$var$ri.bind(null, $c52bca934bf2714c$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c52bca934bf2714c$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c52bca934bf2714c$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c52bca934bf2714c$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c52bca934bf2714c$var$si() {
    return $c52bca934bf2714c$var$di().memoizedState;
}
function $c52bca934bf2714c$var$ti(a, b, c, d) {
    var e = $c52bca934bf2714c$var$ci();
    $c52bca934bf2714c$var$N.flags |= a;
    e.memoizedState = $c52bca934bf2714c$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c52bca934bf2714c$var$ui(a, b, c, d) {
    var e = $c52bca934bf2714c$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c52bca934bf2714c$var$O) {
        var g = $c52bca934bf2714c$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c52bca934bf2714c$var$Wh(d, g.deps)) {
            e.memoizedState = $c52bca934bf2714c$var$li(b, c, f, d);
            return;
        }
    }
    $c52bca934bf2714c$var$N.flags |= a;
    e.memoizedState = $c52bca934bf2714c$var$li(1 | b, c, f, d);
}
function $c52bca934bf2714c$var$vi(a, b) {
    return $c52bca934bf2714c$var$ti(8390656, 8, a, b);
}
function $c52bca934bf2714c$var$ji(a, b) {
    return $c52bca934bf2714c$var$ui(2048, 8, a, b);
}
function $c52bca934bf2714c$var$wi(a, b) {
    return $c52bca934bf2714c$var$ui(4, 2, a, b);
}
function $c52bca934bf2714c$var$xi(a, b) {
    return $c52bca934bf2714c$var$ui(4, 4, a, b);
}
function $c52bca934bf2714c$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c52bca934bf2714c$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c52bca934bf2714c$var$ui(4, 4, $c52bca934bf2714c$var$yi.bind(null, b, a), c);
}
function $c52bca934bf2714c$var$Ai() {}
function $c52bca934bf2714c$var$Bi(a, b) {
    var c = $c52bca934bf2714c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c52bca934bf2714c$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c52bca934bf2714c$var$Ci(a, b) {
    var c = $c52bca934bf2714c$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c52bca934bf2714c$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c52bca934bf2714c$var$Di(a, b, c) {
    if (0 === ($c52bca934bf2714c$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c52bca934bf2714c$var$Ug = !0), a.memoizedState = c;
    $c52bca934bf2714c$var$He(c, b) || (c = $c52bca934bf2714c$var$yc(), $c52bca934bf2714c$var$N.lanes |= c, $c52bca934bf2714c$var$hh |= c, a.baseState = !0);
    return b;
}
function $c52bca934bf2714c$var$Ei(a, b) {
    var c = $c52bca934bf2714c$var$C;
    $c52bca934bf2714c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c52bca934bf2714c$var$Qh.transition;
    $c52bca934bf2714c$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c52bca934bf2714c$var$C = c, $c52bca934bf2714c$var$Qh.transition = d;
    }
}
function $c52bca934bf2714c$var$Fi() {
    return $c52bca934bf2714c$var$di().memoizedState;
}
function $c52bca934bf2714c$var$Gi(a, b, c) {
    var d = $c52bca934bf2714c$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c52bca934bf2714c$var$Hi(a)) $c52bca934bf2714c$var$Ii(b, c);
    else if (c = $c52bca934bf2714c$var$Yg(a, b, c, d), null !== c) {
        var e = $c52bca934bf2714c$var$L();
        $c52bca934bf2714c$var$mh(c, a, d, e);
        $c52bca934bf2714c$var$Ji(c, b, d);
    }
}
function $c52bca934bf2714c$var$ri(a, b, c) {
    var d = $c52bca934bf2714c$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c52bca934bf2714c$var$Hi(a)) $c52bca934bf2714c$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c52bca934bf2714c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c52bca934bf2714c$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c52bca934bf2714c$var$Yg(a, b, e, d);
        null !== c && (e = $c52bca934bf2714c$var$L(), $c52bca934bf2714c$var$mh(c, a, d, e), $c52bca934bf2714c$var$Ji(c, b, d));
    }
}
function $c52bca934bf2714c$var$Hi(a) {
    var b = a.alternate;
    return a === $c52bca934bf2714c$var$N || null !== b && b === $c52bca934bf2714c$var$N;
}
function $c52bca934bf2714c$var$Ii(a, b) {
    $c52bca934bf2714c$var$Th = $c52bca934bf2714c$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c52bca934bf2714c$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c52bca934bf2714c$var$Cc(a, c);
    }
}
var $c52bca934bf2714c$var$ai = {
    readContext: $c52bca934bf2714c$var$Vg,
    useCallback: $c52bca934bf2714c$var$Q,
    useContext: $c52bca934bf2714c$var$Q,
    useEffect: $c52bca934bf2714c$var$Q,
    useImperativeHandle: $c52bca934bf2714c$var$Q,
    useInsertionEffect: $c52bca934bf2714c$var$Q,
    useLayoutEffect: $c52bca934bf2714c$var$Q,
    useMemo: $c52bca934bf2714c$var$Q,
    useReducer: $c52bca934bf2714c$var$Q,
    useRef: $c52bca934bf2714c$var$Q,
    useState: $c52bca934bf2714c$var$Q,
    useDebugValue: $c52bca934bf2714c$var$Q,
    useDeferredValue: $c52bca934bf2714c$var$Q,
    useTransition: $c52bca934bf2714c$var$Q,
    useMutableSource: $c52bca934bf2714c$var$Q,
    useSyncExternalStore: $c52bca934bf2714c$var$Q,
    useId: $c52bca934bf2714c$var$Q,
    unstable_isNewReconciler: !1
}, $c52bca934bf2714c$var$Yh = {
    readContext: $c52bca934bf2714c$var$Vg,
    useCallback: function useCallback(a, b) {
        $c52bca934bf2714c$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c52bca934bf2714c$var$Vg,
    useEffect: $c52bca934bf2714c$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c52bca934bf2714c$var$ti(4194308, 4, $c52bca934bf2714c$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $c52bca934bf2714c$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $c52bca934bf2714c$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $c52bca934bf2714c$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $c52bca934bf2714c$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c52bca934bf2714c$var$Gi.bind(null, $c52bca934bf2714c$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $c52bca934bf2714c$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c52bca934bf2714c$var$qi,
    useDebugValue: $c52bca934bf2714c$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $c52bca934bf2714c$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $c52bca934bf2714c$var$qi(!1), b = a[0];
        a = $c52bca934bf2714c$var$Ei.bind(null, a[1]);
        $c52bca934bf2714c$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $c52bca934bf2714c$var$N, e = $c52bca934bf2714c$var$ci();
        if ($c52bca934bf2714c$var$I) {
            if (void 0 === c) throw Error($c52bca934bf2714c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c52bca934bf2714c$var$R) throw Error($c52bca934bf2714c$var$p(349));
            0 !== ($c52bca934bf2714c$var$Rh & 30) || $c52bca934bf2714c$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c52bca934bf2714c$var$vi($c52bca934bf2714c$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c52bca934bf2714c$var$li(9, $c52bca934bf2714c$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $c52bca934bf2714c$var$ci(), b = $c52bca934bf2714c$var$R.identifierPrefix;
        if ($c52bca934bf2714c$var$I) {
            var c = $c52bca934bf2714c$var$sg;
            var d = $c52bca934bf2714c$var$rg;
            c = (d & ~(1 << 32 - $c52bca934bf2714c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c52bca934bf2714c$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c52bca934bf2714c$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c52bca934bf2714c$var$Zh = {
    readContext: $c52bca934bf2714c$var$Vg,
    useCallback: $c52bca934bf2714c$var$Bi,
    useContext: $c52bca934bf2714c$var$Vg,
    useEffect: $c52bca934bf2714c$var$ji,
    useImperativeHandle: $c52bca934bf2714c$var$zi,
    useInsertionEffect: $c52bca934bf2714c$var$wi,
    useLayoutEffect: $c52bca934bf2714c$var$xi,
    useMemo: $c52bca934bf2714c$var$Ci,
    useReducer: $c52bca934bf2714c$var$fi,
    useRef: $c52bca934bf2714c$var$si,
    useState: function useState() {
        return $c52bca934bf2714c$var$fi($c52bca934bf2714c$var$ei);
    },
    useDebugValue: $c52bca934bf2714c$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $c52bca934bf2714c$var$di();
        return $c52bca934bf2714c$var$Di(b, $c52bca934bf2714c$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $c52bca934bf2714c$var$fi($c52bca934bf2714c$var$ei)[0], b = $c52bca934bf2714c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c52bca934bf2714c$var$hi,
    useSyncExternalStore: $c52bca934bf2714c$var$ii,
    useId: $c52bca934bf2714c$var$Fi,
    unstable_isNewReconciler: !1
}, $c52bca934bf2714c$var$$h = {
    readContext: $c52bca934bf2714c$var$Vg,
    useCallback: $c52bca934bf2714c$var$Bi,
    useContext: $c52bca934bf2714c$var$Vg,
    useEffect: $c52bca934bf2714c$var$ji,
    useImperativeHandle: $c52bca934bf2714c$var$zi,
    useInsertionEffect: $c52bca934bf2714c$var$wi,
    useLayoutEffect: $c52bca934bf2714c$var$xi,
    useMemo: $c52bca934bf2714c$var$Ci,
    useReducer: $c52bca934bf2714c$var$gi,
    useRef: $c52bca934bf2714c$var$si,
    useState: function useState() {
        return $c52bca934bf2714c$var$gi($c52bca934bf2714c$var$ei);
    },
    useDebugValue: $c52bca934bf2714c$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $c52bca934bf2714c$var$di();
        return null === $c52bca934bf2714c$var$O ? b.memoizedState = a : $c52bca934bf2714c$var$Di(b, $c52bca934bf2714c$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $c52bca934bf2714c$var$gi($c52bca934bf2714c$var$ei)[0], b = $c52bca934bf2714c$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c52bca934bf2714c$var$hi,
    useSyncExternalStore: $c52bca934bf2714c$var$ii,
    useId: $c52bca934bf2714c$var$Fi,
    unstable_isNewReconciler: !1
};
function $c52bca934bf2714c$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c52bca934bf2714c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c52bca934bf2714c$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c52bca934bf2714c$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c52bca934bf2714c$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c52bca934bf2714c$var$Oi(a, b, c) {
    c = $c52bca934bf2714c$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c52bca934bf2714c$var$Pi || ($c52bca934bf2714c$var$Pi = !0, $c52bca934bf2714c$var$Qi = d);
        $c52bca934bf2714c$var$Mi(a, b);
    };
    return c;
}
function $c52bca934bf2714c$var$Ri(a, b, c) {
    c = $c52bca934bf2714c$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c52bca934bf2714c$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c52bca934bf2714c$var$Mi(a, b);
        "function" !== typeof d && (null === $c52bca934bf2714c$var$Si ? $c52bca934bf2714c$var$Si = new Set([
            this
        ]) : $c52bca934bf2714c$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $c52bca934bf2714c$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c52bca934bf2714c$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c52bca934bf2714c$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c52bca934bf2714c$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c52bca934bf2714c$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c52bca934bf2714c$var$ch(-1, 1), b.tag = 2, $c52bca934bf2714c$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c52bca934bf2714c$var$Xi = $c52bca934bf2714c$var$ua.ReactCurrentOwner, $c52bca934bf2714c$var$Ug = !1;
function $c52bca934bf2714c$var$Yi(a, b, c, d) {
    b.child = null === a ? $c52bca934bf2714c$var$Ch(b, null, c, d) : $c52bca934bf2714c$var$Bh(b, a.child, c, d);
}
function $c52bca934bf2714c$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c52bca934bf2714c$var$Tg(b, e);
    d = $c52bca934bf2714c$var$Xh(a, b, c, d, f, e);
    c = $c52bca934bf2714c$var$bi();
    if (null !== a && !$c52bca934bf2714c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c52bca934bf2714c$var$$i(a, b, e);
    $c52bca934bf2714c$var$I && c && $c52bca934bf2714c$var$vg(b);
    b.flags |= 1;
    $c52bca934bf2714c$var$Yi(a, b, d, e);
    return b.child;
}
function $c52bca934bf2714c$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c52bca934bf2714c$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c52bca934bf2714c$var$cj(a, b, f, d, e);
        a = $c52bca934bf2714c$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c52bca934bf2714c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c52bca934bf2714c$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c52bca934bf2714c$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c52bca934bf2714c$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c52bca934bf2714c$var$Ie(f, d) && a.ref === b.ref) {
            if ($c52bca934bf2714c$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c52bca934bf2714c$var$Ug = !0);
            else return b.lanes = a.lanes, $c52bca934bf2714c$var$$i(a, b, e);
        }
    }
    return $c52bca934bf2714c$var$dj(a, b, c, d, e);
}
function $c52bca934bf2714c$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c52bca934bf2714c$var$G($c52bca934bf2714c$var$fj, $c52bca934bf2714c$var$gj), $c52bca934bf2714c$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c52bca934bf2714c$var$G($c52bca934bf2714c$var$fj, $c52bca934bf2714c$var$gj), $c52bca934bf2714c$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c52bca934bf2714c$var$G($c52bca934bf2714c$var$fj, $c52bca934bf2714c$var$gj);
            $c52bca934bf2714c$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c52bca934bf2714c$var$G($c52bca934bf2714c$var$fj, $c52bca934bf2714c$var$gj), $c52bca934bf2714c$var$gj |= d;
    $c52bca934bf2714c$var$Yi(a, b, e, c);
    return b.child;
}
function $c52bca934bf2714c$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c52bca934bf2714c$var$dj(a, b, c, d, e) {
    var f = $c52bca934bf2714c$var$Zf(c) ? $c52bca934bf2714c$var$Xf : $c52bca934bf2714c$var$H.current;
    f = $c52bca934bf2714c$var$Yf(b, f);
    $c52bca934bf2714c$var$Tg(b, e);
    c = $c52bca934bf2714c$var$Xh(a, b, c, d, f, e);
    d = $c52bca934bf2714c$var$bi();
    if (null !== a && !$c52bca934bf2714c$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c52bca934bf2714c$var$$i(a, b, e);
    $c52bca934bf2714c$var$I && d && $c52bca934bf2714c$var$vg(b);
    b.flags |= 1;
    $c52bca934bf2714c$var$Yi(a, b, c, e);
    return b.child;
}
function $c52bca934bf2714c$var$ij(a, b, c, d, e) {
    if ($c52bca934bf2714c$var$Zf(c)) {
        var f = !0;
        $c52bca934bf2714c$var$cg(b);
    } else f = !1;
    $c52bca934bf2714c$var$Tg(b, e);
    if (null === b.stateNode) $c52bca934bf2714c$var$jj(a, b), $c52bca934bf2714c$var$ph(b, c, d), $c52bca934bf2714c$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c52bca934bf2714c$var$Vg(l) : (l = $c52bca934bf2714c$var$Zf(c) ? $c52bca934bf2714c$var$Xf : $c52bca934bf2714c$var$H.current, l = $c52bca934bf2714c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c52bca934bf2714c$var$qh(b, g, d, l);
        $c52bca934bf2714c$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c52bca934bf2714c$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c52bca934bf2714c$var$Wf.current || $c52bca934bf2714c$var$$g ? ("function" === typeof m && ($c52bca934bf2714c$var$kh(b, c, m, d), k = b.memoizedState), (h = $c52bca934bf2714c$var$$g || $c52bca934bf2714c$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c52bca934bf2714c$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c52bca934bf2714c$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c52bca934bf2714c$var$Vg(k) : (k = $c52bca934bf2714c$var$Zf(c) ? $c52bca934bf2714c$var$Xf : $c52bca934bf2714c$var$H.current, k = $c52bca934bf2714c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c52bca934bf2714c$var$qh(b, g, d, k);
        $c52bca934bf2714c$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c52bca934bf2714c$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c52bca934bf2714c$var$Wf.current || $c52bca934bf2714c$var$$g ? ("function" === typeof y && ($c52bca934bf2714c$var$kh(b, c, y, d), n = b.memoizedState), (l = $c52bca934bf2714c$var$$g || $c52bca934bf2714c$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c52bca934bf2714c$var$kj(a, b, c, d, f, e);
}
function $c52bca934bf2714c$var$kj(a, b, c, d, e, f) {
    $c52bca934bf2714c$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c52bca934bf2714c$var$dg(b, c, !1), $c52bca934bf2714c$var$$i(a, b, f);
    d = b.stateNode;
    $c52bca934bf2714c$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c52bca934bf2714c$var$Bh(b, a.child, null, f), b.child = $c52bca934bf2714c$var$Bh(b, null, h, f)) : $c52bca934bf2714c$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c52bca934bf2714c$var$dg(b, c, !0);
    return b.child;
}
function $c52bca934bf2714c$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c52bca934bf2714c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c52bca934bf2714c$var$ag(a, b.context, !1);
    $c52bca934bf2714c$var$Ih(a, b.containerInfo);
}
function $c52bca934bf2714c$var$mj(a, b, c, d, e) {
    $c52bca934bf2714c$var$Ig();
    $c52bca934bf2714c$var$Jg(e);
    b.flags |= 256;
    $c52bca934bf2714c$var$Yi(a, b, c, d);
    return b.child;
}
var $c52bca934bf2714c$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c52bca934bf2714c$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c52bca934bf2714c$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c52bca934bf2714c$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, e & 1);
    if (null === a) {
        $c52bca934bf2714c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c52bca934bf2714c$var$qj(g, d, 0, null), a = $c52bca934bf2714c$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c52bca934bf2714c$var$oj(c), b.memoizedState = $c52bca934bf2714c$var$nj, a) : $c52bca934bf2714c$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c52bca934bf2714c$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c52bca934bf2714c$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c52bca934bf2714c$var$wh(h, f) : (f = $c52bca934bf2714c$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c52bca934bf2714c$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c52bca934bf2714c$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c52bca934bf2714c$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c52bca934bf2714c$var$rj(a, b) {
    b = $c52bca934bf2714c$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c52bca934bf2714c$var$tj(a, b, c, d) {
    null !== d && $c52bca934bf2714c$var$Jg(d);
    $c52bca934bf2714c$var$Bh(b, a.child, null, c);
    a = $c52bca934bf2714c$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c52bca934bf2714c$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c52bca934bf2714c$var$Li(Error($c52bca934bf2714c$var$p(422))), $c52bca934bf2714c$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c52bca934bf2714c$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c52bca934bf2714c$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c52bca934bf2714c$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c52bca934bf2714c$var$oj(g);
        b.memoizedState = $c52bca934bf2714c$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c52bca934bf2714c$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c52bca934bf2714c$var$p(419));
        d = $c52bca934bf2714c$var$Li(f, d, void 0);
        return $c52bca934bf2714c$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c52bca934bf2714c$var$Ug || h) {
        d = $c52bca934bf2714c$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c52bca934bf2714c$var$Zg(a, e), $c52bca934bf2714c$var$mh(d, a, e, -1));
        }
        $c52bca934bf2714c$var$uj();
        d = $c52bca934bf2714c$var$Li(Error($c52bca934bf2714c$var$p(421)));
        return $c52bca934bf2714c$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c52bca934bf2714c$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c52bca934bf2714c$var$yg = $c52bca934bf2714c$var$Lf(e.nextSibling);
    $c52bca934bf2714c$var$xg = b;
    $c52bca934bf2714c$var$I = !0;
    $c52bca934bf2714c$var$zg = null;
    null !== a && ($c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg++] = $c52bca934bf2714c$var$rg, $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg++] = $c52bca934bf2714c$var$sg, $c52bca934bf2714c$var$og[$c52bca934bf2714c$var$pg++] = $c52bca934bf2714c$var$qg, $c52bca934bf2714c$var$rg = a.id, $c52bca934bf2714c$var$sg = a.overflow, $c52bca934bf2714c$var$qg = b);
    b = $c52bca934bf2714c$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c52bca934bf2714c$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c52bca934bf2714c$var$Sg(a.return, b, c);
}
function $c52bca934bf2714c$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c52bca934bf2714c$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c52bca934bf2714c$var$Yi(a, b, d.children, c);
    d = $c52bca934bf2714c$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c52bca934bf2714c$var$wj(a, c, b);
            else if (19 === a.tag) $c52bca934bf2714c$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c52bca934bf2714c$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c52bca934bf2714c$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c52bca934bf2714c$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c52bca934bf2714c$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c52bca934bf2714c$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c52bca934bf2714c$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c52bca934bf2714c$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c52bca934bf2714c$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c52bca934bf2714c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c52bca934bf2714c$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c52bca934bf2714c$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c52bca934bf2714c$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c52bca934bf2714c$var$lj(b);
            $c52bca934bf2714c$var$Ig();
            break;
        case 5:
            $c52bca934bf2714c$var$Kh(b);
            break;
        case 1:
            $c52bca934bf2714c$var$Zf(b.type) && $c52bca934bf2714c$var$cg(b);
            break;
        case 4:
            $c52bca934bf2714c$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, $c52bca934bf2714c$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c52bca934bf2714c$var$pj(a, b, c);
                $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, $c52bca934bf2714c$var$M.current & 1);
                a = $c52bca934bf2714c$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, $c52bca934bf2714c$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c52bca934bf2714c$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, $c52bca934bf2714c$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c52bca934bf2714c$var$ej(a, b, c);
    }
    return $c52bca934bf2714c$var$$i(a, b, c);
}
var $c52bca934bf2714c$var$Aj, $c52bca934bf2714c$var$Bj, $c52bca934bf2714c$var$Cj, $c52bca934bf2714c$var$Dj;
$c52bca934bf2714c$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c52bca934bf2714c$var$Bj = function Bj() {};
$c52bca934bf2714c$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c52bca934bf2714c$var$Ya(a, e);
                d = $c52bca934bf2714c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c52bca934bf2714c$var$A({}, e, {
                    value: void 0
                });
                d = $c52bca934bf2714c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c52bca934bf2714c$var$gb(a, e);
                d = $c52bca934bf2714c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c52bca934bf2714c$var$Bf);
        }
        $c52bca934bf2714c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c52bca934bf2714c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c52bca934bf2714c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c52bca934bf2714c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c52bca934bf2714c$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c52bca934bf2714c$var$Ej(a, b) {
    if (!$c52bca934bf2714c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c52bca934bf2714c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c52bca934bf2714c$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c52bca934bf2714c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c52bca934bf2714c$var$S(b), null;
        case 1:
            return $c52bca934bf2714c$var$Zf(b.type) && $c52bca934bf2714c$var$$f(), $c52bca934bf2714c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c52bca934bf2714c$var$Jh();
            $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Wf);
            $c52bca934bf2714c$var$E($c52bca934bf2714c$var$H);
            $c52bca934bf2714c$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c52bca934bf2714c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c52bca934bf2714c$var$zg && ($c52bca934bf2714c$var$Gj($c52bca934bf2714c$var$zg), $c52bca934bf2714c$var$zg = null));
            $c52bca934bf2714c$var$Bj(a, b);
            $c52bca934bf2714c$var$S(b);
            return null;
        case 5:
            $c52bca934bf2714c$var$Lh(b);
            var e = $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c52bca934bf2714c$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c52bca934bf2714c$var$p(166));
                    $c52bca934bf2714c$var$S(b);
                    return null;
                }
                a = $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Eh.current);
                if ($c52bca934bf2714c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c52bca934bf2714c$var$Of] = b;
                    d[$c52bca934bf2714c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c52bca934bf2714c$var$D("cancel", d);
                            $c52bca934bf2714c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c52bca934bf2714c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c52bca934bf2714c$var$lf.length; e++)$c52bca934bf2714c$var$D($c52bca934bf2714c$var$lf[e], d);
                            break;
                        case "source":
                            $c52bca934bf2714c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c52bca934bf2714c$var$D("error", d);
                            $c52bca934bf2714c$var$D("load", d);
                            break;
                        case "details":
                            $c52bca934bf2714c$var$D("toggle", d);
                            break;
                        case "input":
                            $c52bca934bf2714c$var$Za(d, f);
                            $c52bca934bf2714c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c52bca934bf2714c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c52bca934bf2714c$var$hb(d, f), $c52bca934bf2714c$var$D("invalid", d);
                    }
                    $c52bca934bf2714c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c52bca934bf2714c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c52bca934bf2714c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c52bca934bf2714c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c52bca934bf2714c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c52bca934bf2714c$var$Va(d);
                            $c52bca934bf2714c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c52bca934bf2714c$var$Va(d);
                            $c52bca934bf2714c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c52bca934bf2714c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c52bca934bf2714c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c52bca934bf2714c$var$Of] = b;
                    a[$c52bca934bf2714c$var$Pf] = d;
                    $c52bca934bf2714c$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c52bca934bf2714c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c52bca934bf2714c$var$D("cancel", a);
                                $c52bca934bf2714c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c52bca934bf2714c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c52bca934bf2714c$var$lf.length; e++)$c52bca934bf2714c$var$D($c52bca934bf2714c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c52bca934bf2714c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c52bca934bf2714c$var$D("error", a);
                                $c52bca934bf2714c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c52bca934bf2714c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c52bca934bf2714c$var$Za(a, d);
                                e = $c52bca934bf2714c$var$Ya(a, d);
                                $c52bca934bf2714c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c52bca934bf2714c$var$A({}, d, {
                                    value: void 0
                                });
                                $c52bca934bf2714c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c52bca934bf2714c$var$hb(a, d);
                                e = $c52bca934bf2714c$var$gb(a, d);
                                $c52bca934bf2714c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c52bca934bf2714c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c52bca934bf2714c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c52bca934bf2714c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c52bca934bf2714c$var$ob(a, k) : "number" === typeof k && $c52bca934bf2714c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c52bca934bf2714c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c52bca934bf2714c$var$D("scroll", a) : null != k && $c52bca934bf2714c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c52bca934bf2714c$var$Va(a);
                                $c52bca934bf2714c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c52bca934bf2714c$var$Va(a);
                                $c52bca934bf2714c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c52bca934bf2714c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c52bca934bf2714c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c52bca934bf2714c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c52bca934bf2714c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c52bca934bf2714c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c52bca934bf2714c$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c52bca934bf2714c$var$p(166));
                c = $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Gh.current);
                $c52bca934bf2714c$var$Hh($c52bca934bf2714c$var$Eh.current);
                if ($c52bca934bf2714c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c52bca934bf2714c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c52bca934bf2714c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c52bca934bf2714c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c52bca934bf2714c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c52bca934bf2714c$var$Of] = b, b.stateNode = d;
            }
            $c52bca934bf2714c$var$S(b);
            return null;
        case 13:
            $c52bca934bf2714c$var$E($c52bca934bf2714c$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c52bca934bf2714c$var$I && null !== $c52bca934bf2714c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c52bca934bf2714c$var$Hg(), $c52bca934bf2714c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c52bca934bf2714c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c52bca934bf2714c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c52bca934bf2714c$var$p(317));
                        f[$c52bca934bf2714c$var$Of] = b;
                    } else $c52bca934bf2714c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c52bca934bf2714c$var$S(b);
                    f = !1;
                } else null !== $c52bca934bf2714c$var$zg && ($c52bca934bf2714c$var$Gj($c52bca934bf2714c$var$zg), $c52bca934bf2714c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c52bca934bf2714c$var$M.current & 1) ? 0 === $c52bca934bf2714c$var$T && ($c52bca934bf2714c$var$T = 3) : $c52bca934bf2714c$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c52bca934bf2714c$var$S(b);
            return null;
        case 4:
            return $c52bca934bf2714c$var$Jh(), $c52bca934bf2714c$var$Bj(a, b), null === a && $c52bca934bf2714c$var$sf(b.stateNode.containerInfo), $c52bca934bf2714c$var$S(b), null;
        case 10:
            return $c52bca934bf2714c$var$Rg(b.type._context), $c52bca934bf2714c$var$S(b), null;
        case 17:
            return $c52bca934bf2714c$var$Zf(b.type) && $c52bca934bf2714c$var$$f(), $c52bca934bf2714c$var$S(b), null;
        case 19:
            $c52bca934bf2714c$var$E($c52bca934bf2714c$var$M);
            f = b.memoizedState;
            if (null === f) return $c52bca934bf2714c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c52bca934bf2714c$var$Ej(f, !1);
                else {
                    if (0 !== $c52bca934bf2714c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c52bca934bf2714c$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c52bca934bf2714c$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, $c52bca934bf2714c$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c52bca934bf2714c$var$B() > $c52bca934bf2714c$var$Hj && (b.flags |= 128, d = !0, $c52bca934bf2714c$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c52bca934bf2714c$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c52bca934bf2714c$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c52bca934bf2714c$var$I) return $c52bca934bf2714c$var$S(b), null;
                    } else 2 * $c52bca934bf2714c$var$B() - f.renderingStartTime > $c52bca934bf2714c$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c52bca934bf2714c$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c52bca934bf2714c$var$B(), b.sibling = null, c = $c52bca934bf2714c$var$M.current, $c52bca934bf2714c$var$G($c52bca934bf2714c$var$M, d ? c & 1 | 2 : c & 1), b;
            $c52bca934bf2714c$var$S(b);
            return null;
        case 22:
        case 23:
            return $c52bca934bf2714c$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c52bca934bf2714c$var$gj & 1073741824) && ($c52bca934bf2714c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c52bca934bf2714c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c52bca934bf2714c$var$p(156, b.tag));
}
function $c52bca934bf2714c$var$Jj(a, b) {
    $c52bca934bf2714c$var$wg(b);
    switch(b.tag){
        case 1:
            return $c52bca934bf2714c$var$Zf(b.type) && $c52bca934bf2714c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c52bca934bf2714c$var$Jh(), $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Wf), $c52bca934bf2714c$var$E($c52bca934bf2714c$var$H), $c52bca934bf2714c$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c52bca934bf2714c$var$Lh(b), null;
        case 13:
            $c52bca934bf2714c$var$E($c52bca934bf2714c$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c52bca934bf2714c$var$p(340));
                $c52bca934bf2714c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c52bca934bf2714c$var$E($c52bca934bf2714c$var$M), null;
        case 4:
            return $c52bca934bf2714c$var$Jh(), null;
        case 10:
            return $c52bca934bf2714c$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c52bca934bf2714c$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c52bca934bf2714c$var$Kj = !1, $c52bca934bf2714c$var$U = !1, $c52bca934bf2714c$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c52bca934bf2714c$var$V = null;
function $c52bca934bf2714c$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c52bca934bf2714c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c52bca934bf2714c$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c52bca934bf2714c$var$W(a, b, d);
    }
}
var $c52bca934bf2714c$var$Oj = !1;
function $c52bca934bf2714c$var$Pj(a, b) {
    $c52bca934bf2714c$var$Cf = $c52bca934bf2714c$var$dd;
    a = $c52bca934bf2714c$var$Me();
    if ($c52bca934bf2714c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c52bca934bf2714c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c52bca934bf2714c$var$dd = !1;
    for($c52bca934bf2714c$var$V = b; null !== $c52bca934bf2714c$var$V;)if (b = $c52bca934bf2714c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c52bca934bf2714c$var$V = a;
    else for(; null !== $c52bca934bf2714c$var$V;){
        b = $c52bca934bf2714c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c52bca934bf2714c$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c52bca934bf2714c$var$p(163));
            }
        } catch (F) {
            $c52bca934bf2714c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c52bca934bf2714c$var$V = a;
            break;
        }
        $c52bca934bf2714c$var$V = b.return;
    }
    n = $c52bca934bf2714c$var$Oj;
    $c52bca934bf2714c$var$Oj = !1;
    return n;
}
function $c52bca934bf2714c$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c52bca934bf2714c$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c52bca934bf2714c$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c52bca934bf2714c$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c52bca934bf2714c$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c52bca934bf2714c$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c52bca934bf2714c$var$Of], delete b[$c52bca934bf2714c$var$Pf], delete b[$c52bca934bf2714c$var$of], delete b[$c52bca934bf2714c$var$Qf], delete b[$c52bca934bf2714c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c52bca934bf2714c$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c52bca934bf2714c$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c52bca934bf2714c$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c52bca934bf2714c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c52bca934bf2714c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c52bca934bf2714c$var$Wj(a, b, c), a = a.sibling; null !== a;)$c52bca934bf2714c$var$Wj(a, b, c), a = a.sibling;
}
function $c52bca934bf2714c$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c52bca934bf2714c$var$Xj(a, b, c), a = a.sibling; null !== a;)$c52bca934bf2714c$var$Xj(a, b, c), a = a.sibling;
}
var $c52bca934bf2714c$var$X = null, $c52bca934bf2714c$var$Yj = !1;
function $c52bca934bf2714c$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c52bca934bf2714c$var$ak(a, b, c), c = c.sibling;
}
function $c52bca934bf2714c$var$ak(a, b, c) {
    if ($c52bca934bf2714c$var$lc && "function" === typeof $c52bca934bf2714c$var$lc.onCommitFiberUnmount) try {
        $c52bca934bf2714c$var$lc.onCommitFiberUnmount($c52bca934bf2714c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c52bca934bf2714c$var$U || $c52bca934bf2714c$var$Mj(c, b);
        case 6:
            var d = $c52bca934bf2714c$var$X, e = $c52bca934bf2714c$var$Yj;
            $c52bca934bf2714c$var$X = null;
            $c52bca934bf2714c$var$Zj(a, b, c);
            $c52bca934bf2714c$var$X = d;
            $c52bca934bf2714c$var$Yj = e;
            null !== $c52bca934bf2714c$var$X && ($c52bca934bf2714c$var$Yj ? (a = $c52bca934bf2714c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c52bca934bf2714c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c52bca934bf2714c$var$X && ($c52bca934bf2714c$var$Yj ? (a = $c52bca934bf2714c$var$X, c = c.stateNode, 8 === a.nodeType ? $c52bca934bf2714c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c52bca934bf2714c$var$Kf(a, c), $c52bca934bf2714c$var$bd(a)) : $c52bca934bf2714c$var$Kf($c52bca934bf2714c$var$X, c.stateNode));
            break;
        case 4:
            d = $c52bca934bf2714c$var$X;
            e = $c52bca934bf2714c$var$Yj;
            $c52bca934bf2714c$var$X = c.stateNode.containerInfo;
            $c52bca934bf2714c$var$Yj = !0;
            $c52bca934bf2714c$var$Zj(a, b, c);
            $c52bca934bf2714c$var$X = d;
            $c52bca934bf2714c$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c52bca934bf2714c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c52bca934bf2714c$var$Nj(c, b, g) : 0 !== (f & 4) && $c52bca934bf2714c$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c52bca934bf2714c$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c52bca934bf2714c$var$U && ($c52bca934bf2714c$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c52bca934bf2714c$var$W(c, b, h);
            }
            $c52bca934bf2714c$var$Zj(a, b, c);
            break;
        case 21:
            $c52bca934bf2714c$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c52bca934bf2714c$var$U = (d = $c52bca934bf2714c$var$U) || null !== c.memoizedState, $c52bca934bf2714c$var$Zj(a, b, c), $c52bca934bf2714c$var$U = d) : $c52bca934bf2714c$var$Zj(a, b, c);
            break;
        default:
            $c52bca934bf2714c$var$Zj(a, b, c);
    }
}
function $c52bca934bf2714c$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c52bca934bf2714c$var$Lj);
        b.forEach(function(b) {
            var d = $c52bca934bf2714c$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c52bca934bf2714c$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c52bca934bf2714c$var$X = h.stateNode;
                        $c52bca934bf2714c$var$Yj = !1;
                        break a;
                    case 3:
                        $c52bca934bf2714c$var$X = h.stateNode.containerInfo;
                        $c52bca934bf2714c$var$Yj = !0;
                        break a;
                    case 4:
                        $c52bca934bf2714c$var$X = h.stateNode.containerInfo;
                        $c52bca934bf2714c$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c52bca934bf2714c$var$X) throw Error($c52bca934bf2714c$var$p(160));
            $c52bca934bf2714c$var$ak(f, g, e);
            $c52bca934bf2714c$var$X = null;
            $c52bca934bf2714c$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c52bca934bf2714c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c52bca934bf2714c$var$ek(b, a), b = b.sibling;
}
function $c52bca934bf2714c$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            if (d & 4) {
                try {
                    $c52bca934bf2714c$var$Qj(3, a, a.return), $c52bca934bf2714c$var$Rj(3, a);
                } catch (t) {
                    $c52bca934bf2714c$var$W(a, a.return, t);
                }
                try {
                    $c52bca934bf2714c$var$Qj(5, a, a.return);
                } catch (t) {
                    $c52bca934bf2714c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            d & 512 && null !== c && $c52bca934bf2714c$var$Mj(c, c.return);
            break;
        case 5:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            d & 512 && null !== c && $c52bca934bf2714c$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c52bca934bf2714c$var$ob(e, "");
                } catch (t) {
                    $c52bca934bf2714c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c52bca934bf2714c$var$ab(e, f);
                    $c52bca934bf2714c$var$vb(h, g);
                    var l = $c52bca934bf2714c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c52bca934bf2714c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c52bca934bf2714c$var$nb(e, q) : "children" === m ? $c52bca934bf2714c$var$ob(e, q) : $c52bca934bf2714c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c52bca934bf2714c$var$bb(e, f);
                            break;
                        case "textarea":
                            $c52bca934bf2714c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c52bca934bf2714c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c52bca934bf2714c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c52bca934bf2714c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c52bca934bf2714c$var$Pf] = f;
                } catch (t) {
                    $c52bca934bf2714c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c52bca934bf2714c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c52bca934bf2714c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c52bca934bf2714c$var$bd(b.containerInfo);
            } catch (t) {
                $c52bca934bf2714c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            break;
        case 13:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c52bca934bf2714c$var$gk = $c52bca934bf2714c$var$B()));
            d & 4 && $c52bca934bf2714c$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c52bca934bf2714c$var$U = (l = $c52bca934bf2714c$var$U) || m, $c52bca934bf2714c$var$dk(b, a), $c52bca934bf2714c$var$U = l) : $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c52bca934bf2714c$var$V = a, m = a.child; null !== m;){
                    for(q = $c52bca934bf2714c$var$V = m; null !== $c52bca934bf2714c$var$V;){
                        r = $c52bca934bf2714c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c52bca934bf2714c$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c52bca934bf2714c$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c52bca934bf2714c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c52bca934bf2714c$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c52bca934bf2714c$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c52bca934bf2714c$var$V = y) : $c52bca934bf2714c$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c52bca934bf2714c$var$rb("display", g));
                            } catch (t) {
                                $c52bca934bf2714c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c52bca934bf2714c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c52bca934bf2714c$var$dk(b, a);
            $c52bca934bf2714c$var$fk(a);
            d & 4 && $c52bca934bf2714c$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c52bca934bf2714c$var$dk(b, a), $c52bca934bf2714c$var$fk(a);
    }
}
function $c52bca934bf2714c$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c52bca934bf2714c$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c52bca934bf2714c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c52bca934bf2714c$var$ob(e, ""), d.flags &= -33);
                    var f = $c52bca934bf2714c$var$Vj(a);
                    $c52bca934bf2714c$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c52bca934bf2714c$var$Vj(a);
                    $c52bca934bf2714c$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c52bca934bf2714c$var$p(161));
            }
        } catch (k) {
            $c52bca934bf2714c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c52bca934bf2714c$var$ik(a, b, c) {
    $c52bca934bf2714c$var$V = a;
    $c52bca934bf2714c$var$jk(a, b, c);
}
function $c52bca934bf2714c$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c52bca934bf2714c$var$V;){
        var e = $c52bca934bf2714c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c52bca934bf2714c$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c52bca934bf2714c$var$U;
                h = $c52bca934bf2714c$var$Kj;
                var l = $c52bca934bf2714c$var$U;
                $c52bca934bf2714c$var$Kj = g;
                if (($c52bca934bf2714c$var$U = k) && !l) for($c52bca934bf2714c$var$V = e; null !== $c52bca934bf2714c$var$V;)g = $c52bca934bf2714c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c52bca934bf2714c$var$kk(e) : null !== k ? (k.return = g, $c52bca934bf2714c$var$V = k) : $c52bca934bf2714c$var$kk(e);
                for(; null !== f;)$c52bca934bf2714c$var$V = f, $c52bca934bf2714c$var$jk(f, b, c), f = f.sibling;
                $c52bca934bf2714c$var$V = e;
                $c52bca934bf2714c$var$Kj = h;
                $c52bca934bf2714c$var$U = l;
            }
            $c52bca934bf2714c$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c52bca934bf2714c$var$V = f) : $c52bca934bf2714c$var$lk(a, b, c);
    }
}
function $c52bca934bf2714c$var$lk(a) {
    for(; null !== $c52bca934bf2714c$var$V;){
        var b = $c52bca934bf2714c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c52bca934bf2714c$var$U || $c52bca934bf2714c$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c52bca934bf2714c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c52bca934bf2714c$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c52bca934bf2714c$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c52bca934bf2714c$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c52bca934bf2714c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c52bca934bf2714c$var$p(163));
                }
                $c52bca934bf2714c$var$U || b.flags & 512 && $c52bca934bf2714c$var$Sj(b);
            } catch (r) {
                $c52bca934bf2714c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c52bca934bf2714c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c52bca934bf2714c$var$V = c;
            break;
        }
        $c52bca934bf2714c$var$V = b.return;
    }
}
function $c52bca934bf2714c$var$hk(a) {
    for(; null !== $c52bca934bf2714c$var$V;){
        var b = $c52bca934bf2714c$var$V;
        if (b === a) {
            $c52bca934bf2714c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c52bca934bf2714c$var$V = c;
            break;
        }
        $c52bca934bf2714c$var$V = b.return;
    }
}
function $c52bca934bf2714c$var$kk(a) {
    for(; null !== $c52bca934bf2714c$var$V;){
        var b = $c52bca934bf2714c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c52bca934bf2714c$var$Rj(4, b);
                    } catch (k) {
                        $c52bca934bf2714c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c52bca934bf2714c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c52bca934bf2714c$var$Sj(b);
                    } catch (k) {
                        $c52bca934bf2714c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c52bca934bf2714c$var$Sj(b);
                    } catch (k) {
                        $c52bca934bf2714c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c52bca934bf2714c$var$W(b, b.return, k);
        }
        if (b === a) {
            $c52bca934bf2714c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c52bca934bf2714c$var$V = h;
            break;
        }
        $c52bca934bf2714c$var$V = b.return;
    }
}
var $c52bca934bf2714c$var$mk = Math.ceil, $c52bca934bf2714c$var$nk = $c52bca934bf2714c$var$ua.ReactCurrentDispatcher, $c52bca934bf2714c$var$ok = $c52bca934bf2714c$var$ua.ReactCurrentOwner, $c52bca934bf2714c$var$pk = $c52bca934bf2714c$var$ua.ReactCurrentBatchConfig, $c52bca934bf2714c$var$K = 0, $c52bca934bf2714c$var$R = null, $c52bca934bf2714c$var$Y = null, $c52bca934bf2714c$var$Z = 0, $c52bca934bf2714c$var$gj = 0, $c52bca934bf2714c$var$fj = $c52bca934bf2714c$var$Uf(0), $c52bca934bf2714c$var$T = 0, $c52bca934bf2714c$var$qk = null, $c52bca934bf2714c$var$hh = 0, $c52bca934bf2714c$var$rk = 0, $c52bca934bf2714c$var$sk = 0, $c52bca934bf2714c$var$tk = null, $c52bca934bf2714c$var$uk = null, $c52bca934bf2714c$var$gk = 0, $c52bca934bf2714c$var$Hj = Infinity, $c52bca934bf2714c$var$vk = null, $c52bca934bf2714c$var$Pi = !1, $c52bca934bf2714c$var$Qi = null, $c52bca934bf2714c$var$Si = null, $c52bca934bf2714c$var$wk = !1, $c52bca934bf2714c$var$xk = null, $c52bca934bf2714c$var$yk = 0, $c52bca934bf2714c$var$zk = 0, $c52bca934bf2714c$var$Ak = null, $c52bca934bf2714c$var$Bk = -1, $c52bca934bf2714c$var$Ck = 0;
function $c52bca934bf2714c$var$L() {
    return 0 !== ($c52bca934bf2714c$var$K & 6) ? $c52bca934bf2714c$var$B() : -1 !== $c52bca934bf2714c$var$Bk ? $c52bca934bf2714c$var$Bk : $c52bca934bf2714c$var$Bk = $c52bca934bf2714c$var$B();
}
function $c52bca934bf2714c$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c52bca934bf2714c$var$K & 2) && 0 !== $c52bca934bf2714c$var$Z) return $c52bca934bf2714c$var$Z & -$c52bca934bf2714c$var$Z;
    if (null !== $c52bca934bf2714c$var$Kg.transition) return 0 === $c52bca934bf2714c$var$Ck && ($c52bca934bf2714c$var$Ck = $c52bca934bf2714c$var$yc()), $c52bca934bf2714c$var$Ck;
    a = $c52bca934bf2714c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c52bca934bf2714c$var$jd(a.type);
    return a;
}
function $c52bca934bf2714c$var$mh(a, b, c, d) {
    if (50 < $c52bca934bf2714c$var$zk) throw $c52bca934bf2714c$var$zk = 0, $c52bca934bf2714c$var$Ak = null, Error($c52bca934bf2714c$var$p(185));
    $c52bca934bf2714c$var$Ac(a, c, d);
    if (0 === ($c52bca934bf2714c$var$K & 2) || a !== $c52bca934bf2714c$var$R) a === $c52bca934bf2714c$var$R && (0 === ($c52bca934bf2714c$var$K & 2) && ($c52bca934bf2714c$var$rk |= c), 4 === $c52bca934bf2714c$var$T && $c52bca934bf2714c$var$Dk(a, $c52bca934bf2714c$var$Z)), $c52bca934bf2714c$var$Ek(a, d), 1 === c && 0 === $c52bca934bf2714c$var$K && 0 === (b.mode & 1) && ($c52bca934bf2714c$var$Hj = $c52bca934bf2714c$var$B() + 500, $c52bca934bf2714c$var$fg && $c52bca934bf2714c$var$jg());
}
function $c52bca934bf2714c$var$Ek(a, b) {
    var c = a.callbackNode;
    $c52bca934bf2714c$var$wc(a, b);
    var d = $c52bca934bf2714c$var$uc(a, a === $c52bca934bf2714c$var$R ? $c52bca934bf2714c$var$Z : 0);
    if (0 === d) null !== c && $c52bca934bf2714c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c52bca934bf2714c$var$bc(c);
        if (1 === b) 0 === a.tag ? $c52bca934bf2714c$var$ig($c52bca934bf2714c$var$Fk.bind(null, a)) : $c52bca934bf2714c$var$hg($c52bca934bf2714c$var$Fk.bind(null, a)), $c52bca934bf2714c$var$Jf(function() {
            0 === ($c52bca934bf2714c$var$K & 6) && $c52bca934bf2714c$var$jg();
        }), c = null;
        else {
            switch($c52bca934bf2714c$var$Dc(d)){
                case 1:
                    c = $c52bca934bf2714c$var$fc;
                    break;
                case 4:
                    c = $c52bca934bf2714c$var$gc;
                    break;
                case 16:
                    c = $c52bca934bf2714c$var$hc;
                    break;
                case 536870912:
                    c = $c52bca934bf2714c$var$jc;
                    break;
                default:
                    c = $c52bca934bf2714c$var$hc;
            }
            c = $c52bca934bf2714c$var$Gk(c, $c52bca934bf2714c$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c52bca934bf2714c$var$Hk(a, b) {
    $c52bca934bf2714c$var$Bk = -1;
    $c52bca934bf2714c$var$Ck = 0;
    if (0 !== ($c52bca934bf2714c$var$K & 6)) throw Error($c52bca934bf2714c$var$p(327));
    var c = a.callbackNode;
    if ($c52bca934bf2714c$var$Ik() && a.callbackNode !== c) return null;
    var d = $c52bca934bf2714c$var$uc(a, a === $c52bca934bf2714c$var$R ? $c52bca934bf2714c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c52bca934bf2714c$var$Jk(a, d);
    else {
        b = d;
        var e = $c52bca934bf2714c$var$K;
        $c52bca934bf2714c$var$K |= 2;
        var f = $c52bca934bf2714c$var$Kk();
        if ($c52bca934bf2714c$var$R !== a || $c52bca934bf2714c$var$Z !== b) $c52bca934bf2714c$var$vk = null, $c52bca934bf2714c$var$Hj = $c52bca934bf2714c$var$B() + 500, $c52bca934bf2714c$var$Lk(a, b);
        for(;;)try {
            $c52bca934bf2714c$var$Mk();
            break;
        } catch (h) {
            $c52bca934bf2714c$var$Nk(a, h);
        }
        $c52bca934bf2714c$var$Qg();
        $c52bca934bf2714c$var$nk.current = f;
        $c52bca934bf2714c$var$K = e;
        null !== $c52bca934bf2714c$var$Y ? b = 0 : ($c52bca934bf2714c$var$R = null, $c52bca934bf2714c$var$Z = 0, b = $c52bca934bf2714c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c52bca934bf2714c$var$xc(a), 0 !== e && (d = e, b = $c52bca934bf2714c$var$Ok(a, e)));
        if (1 === b) throw c = $c52bca934bf2714c$var$qk, $c52bca934bf2714c$var$Lk(a, 0), $c52bca934bf2714c$var$Dk(a, d), $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B()), c;
        if (6 === b) $c52bca934bf2714c$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c52bca934bf2714c$var$Pk(e) && (b = $c52bca934bf2714c$var$Jk(a, d), 2 === b && (f = $c52bca934bf2714c$var$xc(a), 0 !== f && (d = f, b = $c52bca934bf2714c$var$Ok(a, f))), 1 === b)) throw c = $c52bca934bf2714c$var$qk, $c52bca934bf2714c$var$Lk(a, 0), $c52bca934bf2714c$var$Dk(a, d), $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c52bca934bf2714c$var$p(345));
                case 2:
                    $c52bca934bf2714c$var$Qk(a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk);
                    break;
                case 3:
                    $c52bca934bf2714c$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c52bca934bf2714c$var$gk + 500 - $c52bca934bf2714c$var$B(), 10 < b)) {
                        if (0 !== $c52bca934bf2714c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c52bca934bf2714c$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c52bca934bf2714c$var$Ff($c52bca934bf2714c$var$Qk.bind(null, a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk), b);
                        break;
                    }
                    $c52bca934bf2714c$var$Qk(a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk);
                    break;
                case 4:
                    $c52bca934bf2714c$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c52bca934bf2714c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c52bca934bf2714c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c52bca934bf2714c$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c52bca934bf2714c$var$Ff($c52bca934bf2714c$var$Qk.bind(null, a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk), d);
                        break;
                    }
                    $c52bca934bf2714c$var$Qk(a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk);
                    break;
                case 5:
                    $c52bca934bf2714c$var$Qk(a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk);
                    break;
                default:
                    throw Error($c52bca934bf2714c$var$p(329));
            }
        }
    }
    $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B());
    return a.callbackNode === c ? $c52bca934bf2714c$var$Hk.bind(null, a) : null;
}
function $c52bca934bf2714c$var$Ok(a, b) {
    var c = $c52bca934bf2714c$var$tk;
    a.current.memoizedState.isDehydrated && ($c52bca934bf2714c$var$Lk(a, b).flags |= 256);
    a = $c52bca934bf2714c$var$Jk(a, b);
    2 !== a && (b = $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$uk = c, null !== b && $c52bca934bf2714c$var$Gj(b));
    return a;
}
function $c52bca934bf2714c$var$Gj(a) {
    null === $c52bca934bf2714c$var$uk ? $c52bca934bf2714c$var$uk = a : $c52bca934bf2714c$var$uk.push.apply($c52bca934bf2714c$var$uk, a);
}
function $c52bca934bf2714c$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c52bca934bf2714c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c52bca934bf2714c$var$Dk(a, b) {
    b &= ~$c52bca934bf2714c$var$sk;
    b &= ~$c52bca934bf2714c$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c52bca934bf2714c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c52bca934bf2714c$var$Fk(a) {
    if (0 !== ($c52bca934bf2714c$var$K & 6)) throw Error($c52bca934bf2714c$var$p(327));
    $c52bca934bf2714c$var$Ik();
    var b = $c52bca934bf2714c$var$uc(a, 0);
    if (0 === (b & 1)) return $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B()), null;
    var c = $c52bca934bf2714c$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c52bca934bf2714c$var$xc(a);
        0 !== d && (b = d, c = $c52bca934bf2714c$var$Ok(a, d));
    }
    if (1 === c) throw c = $c52bca934bf2714c$var$qk, $c52bca934bf2714c$var$Lk(a, 0), $c52bca934bf2714c$var$Dk(a, b), $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B()), c;
    if (6 === c) throw Error($c52bca934bf2714c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c52bca934bf2714c$var$Qk(a, $c52bca934bf2714c$var$uk, $c52bca934bf2714c$var$vk);
    $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B());
    return null;
}
function $c52bca934bf2714c$var$Rk(a, b) {
    var c = $c52bca934bf2714c$var$K;
    $c52bca934bf2714c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c52bca934bf2714c$var$K = c, 0 === $c52bca934bf2714c$var$K && ($c52bca934bf2714c$var$Hj = $c52bca934bf2714c$var$B() + 500, $c52bca934bf2714c$var$fg && $c52bca934bf2714c$var$jg());
    }
}
function $c52bca934bf2714c$var$Sk(a) {
    null !== $c52bca934bf2714c$var$xk && 0 === $c52bca934bf2714c$var$xk.tag && 0 === ($c52bca934bf2714c$var$K & 6) && $c52bca934bf2714c$var$Ik();
    var b = $c52bca934bf2714c$var$K;
    $c52bca934bf2714c$var$K |= 1;
    var c = $c52bca934bf2714c$var$pk.transition, d = $c52bca934bf2714c$var$C;
    try {
        if ($c52bca934bf2714c$var$pk.transition = null, $c52bca934bf2714c$var$C = 1, a) return a();
    } finally{
        $c52bca934bf2714c$var$C = d, $c52bca934bf2714c$var$pk.transition = c, $c52bca934bf2714c$var$K = b, 0 === ($c52bca934bf2714c$var$K & 6) && $c52bca934bf2714c$var$jg();
    }
}
function $c52bca934bf2714c$var$Ij() {
    $c52bca934bf2714c$var$gj = $c52bca934bf2714c$var$fj.current;
    $c52bca934bf2714c$var$E($c52bca934bf2714c$var$fj);
}
function $c52bca934bf2714c$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c52bca934bf2714c$var$Gf(c));
    if (null !== $c52bca934bf2714c$var$Y) for(c = $c52bca934bf2714c$var$Y.return; null !== c;){
        var d = c;
        $c52bca934bf2714c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c52bca934bf2714c$var$$f();
                break;
            case 3:
                $c52bca934bf2714c$var$Jh();
                $c52bca934bf2714c$var$E($c52bca934bf2714c$var$Wf);
                $c52bca934bf2714c$var$E($c52bca934bf2714c$var$H);
                $c52bca934bf2714c$var$Oh();
                break;
            case 5:
                $c52bca934bf2714c$var$Lh(d);
                break;
            case 4:
                $c52bca934bf2714c$var$Jh();
                break;
            case 13:
                $c52bca934bf2714c$var$E($c52bca934bf2714c$var$M);
                break;
            case 19:
                $c52bca934bf2714c$var$E($c52bca934bf2714c$var$M);
                break;
            case 10:
                $c52bca934bf2714c$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c52bca934bf2714c$var$Ij();
        }
        c = c.return;
    }
    $c52bca934bf2714c$var$R = a;
    $c52bca934bf2714c$var$Y = a = $c52bca934bf2714c$var$wh(a.current, null);
    $c52bca934bf2714c$var$Z = $c52bca934bf2714c$var$gj = b;
    $c52bca934bf2714c$var$T = 0;
    $c52bca934bf2714c$var$qk = null;
    $c52bca934bf2714c$var$sk = $c52bca934bf2714c$var$rk = $c52bca934bf2714c$var$hh = 0;
    $c52bca934bf2714c$var$uk = $c52bca934bf2714c$var$tk = null;
    if (null !== $c52bca934bf2714c$var$Wg) {
        for(b = 0; b < $c52bca934bf2714c$var$Wg.length; b++)if (c = $c52bca934bf2714c$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c52bca934bf2714c$var$Wg = null;
    }
    return a;
}
function $c52bca934bf2714c$var$Nk(a, b) {
    do {
        var c = $c52bca934bf2714c$var$Y;
        try {
            $c52bca934bf2714c$var$Qg();
            $c52bca934bf2714c$var$Ph.current = $c52bca934bf2714c$var$ai;
            if ($c52bca934bf2714c$var$Sh) {
                for(var d = $c52bca934bf2714c$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c52bca934bf2714c$var$Sh = !1;
            }
            $c52bca934bf2714c$var$Rh = 0;
            $c52bca934bf2714c$var$P = $c52bca934bf2714c$var$O = $c52bca934bf2714c$var$N = null;
            $c52bca934bf2714c$var$Th = !1;
            $c52bca934bf2714c$var$Uh = 0;
            $c52bca934bf2714c$var$ok.current = null;
            if (null === c || null === c.return) {
                $c52bca934bf2714c$var$T = 1;
                $c52bca934bf2714c$var$qk = b;
                $c52bca934bf2714c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c52bca934bf2714c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c52bca934bf2714c$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c52bca934bf2714c$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c52bca934bf2714c$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c52bca934bf2714c$var$Ti(f, l, b);
                            $c52bca934bf2714c$var$uj();
                            break a;
                        }
                        k = Error($c52bca934bf2714c$var$p(426));
                    }
                } else if ($c52bca934bf2714c$var$I && h.mode & 1) {
                    var J = $c52bca934bf2714c$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c52bca934bf2714c$var$Wi(J, g, h, f, b);
                        $c52bca934bf2714c$var$Jg($c52bca934bf2714c$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c52bca934bf2714c$var$Ki(k, h);
                4 !== $c52bca934bf2714c$var$T && ($c52bca934bf2714c$var$T = 2);
                null === $c52bca934bf2714c$var$tk ? $c52bca934bf2714c$var$tk = [
                    f
                ] : $c52bca934bf2714c$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c52bca934bf2714c$var$Oi(f, k, b);
                            $c52bca934bf2714c$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c52bca934bf2714c$var$Si || !$c52bca934bf2714c$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c52bca934bf2714c$var$Ri(f, h, b);
                                $c52bca934bf2714c$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c52bca934bf2714c$var$Tk(c);
        } catch (na) {
            b = na;
            $c52bca934bf2714c$var$Y === c && null !== c && ($c52bca934bf2714c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c52bca934bf2714c$var$Kk() {
    var a = $c52bca934bf2714c$var$nk.current;
    $c52bca934bf2714c$var$nk.current = $c52bca934bf2714c$var$ai;
    return null === a ? $c52bca934bf2714c$var$ai : a;
}
function $c52bca934bf2714c$var$uj() {
    if (0 === $c52bca934bf2714c$var$T || 3 === $c52bca934bf2714c$var$T || 2 === $c52bca934bf2714c$var$T) $c52bca934bf2714c$var$T = 4;
    null === $c52bca934bf2714c$var$R || 0 === ($c52bca934bf2714c$var$hh & 268435455) && 0 === ($c52bca934bf2714c$var$rk & 268435455) || $c52bca934bf2714c$var$Dk($c52bca934bf2714c$var$R, $c52bca934bf2714c$var$Z);
}
function $c52bca934bf2714c$var$Jk(a, b) {
    var c = $c52bca934bf2714c$var$K;
    $c52bca934bf2714c$var$K |= 2;
    var d = $c52bca934bf2714c$var$Kk();
    if ($c52bca934bf2714c$var$R !== a || $c52bca934bf2714c$var$Z !== b) $c52bca934bf2714c$var$vk = null, $c52bca934bf2714c$var$Lk(a, b);
    for(;;)try {
        $c52bca934bf2714c$var$Uk();
        break;
    } catch (e) {
        $c52bca934bf2714c$var$Nk(a, e);
    }
    $c52bca934bf2714c$var$Qg();
    $c52bca934bf2714c$var$K = c;
    $c52bca934bf2714c$var$nk.current = d;
    if (null !== $c52bca934bf2714c$var$Y) throw Error($c52bca934bf2714c$var$p(261));
    $c52bca934bf2714c$var$R = null;
    $c52bca934bf2714c$var$Z = 0;
    return $c52bca934bf2714c$var$T;
}
function $c52bca934bf2714c$var$Uk() {
    for(; null !== $c52bca934bf2714c$var$Y;)$c52bca934bf2714c$var$Vk($c52bca934bf2714c$var$Y);
}
function $c52bca934bf2714c$var$Mk() {
    for(; null !== $c52bca934bf2714c$var$Y && !$c52bca934bf2714c$var$cc();)$c52bca934bf2714c$var$Vk($c52bca934bf2714c$var$Y);
}
function $c52bca934bf2714c$var$Vk(a) {
    var b = $c52bca934bf2714c$var$Wk(a.alternate, a, $c52bca934bf2714c$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c52bca934bf2714c$var$Tk(a) : $c52bca934bf2714c$var$Y = b;
    $c52bca934bf2714c$var$ok.current = null;
}
function $c52bca934bf2714c$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c52bca934bf2714c$var$Fj(c, b, $c52bca934bf2714c$var$gj), null !== c) {
                $c52bca934bf2714c$var$Y = c;
                return;
            }
        } else {
            c = $c52bca934bf2714c$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c52bca934bf2714c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c52bca934bf2714c$var$T = 6;
                $c52bca934bf2714c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c52bca934bf2714c$var$Y = b;
            return;
        }
        $c52bca934bf2714c$var$Y = b = a;
    }while (null !== b);
    0 === $c52bca934bf2714c$var$T && ($c52bca934bf2714c$var$T = 5);
}
function $c52bca934bf2714c$var$Qk(a, b, c) {
    var d = $c52bca934bf2714c$var$C, e = $c52bca934bf2714c$var$pk.transition;
    try {
        $c52bca934bf2714c$var$pk.transition = null, $c52bca934bf2714c$var$C = 1, $c52bca934bf2714c$var$Xk(a, b, c, d);
    } finally{
        $c52bca934bf2714c$var$pk.transition = e, $c52bca934bf2714c$var$C = d;
    }
    return null;
}
function $c52bca934bf2714c$var$Xk(a, b, c, d) {
    do $c52bca934bf2714c$var$Ik();
    while (null !== $c52bca934bf2714c$var$xk);
    if (0 !== ($c52bca934bf2714c$var$K & 6)) throw Error($c52bca934bf2714c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c52bca934bf2714c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c52bca934bf2714c$var$Bc(a, f);
    a === $c52bca934bf2714c$var$R && ($c52bca934bf2714c$var$Y = $c52bca934bf2714c$var$R = null, $c52bca934bf2714c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c52bca934bf2714c$var$wk || ($c52bca934bf2714c$var$wk = !0, $c52bca934bf2714c$var$Gk($c52bca934bf2714c$var$hc, function() {
        $c52bca934bf2714c$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c52bca934bf2714c$var$pk.transition;
        $c52bca934bf2714c$var$pk.transition = null;
        var g = $c52bca934bf2714c$var$C;
        $c52bca934bf2714c$var$C = 1;
        var h = $c52bca934bf2714c$var$K;
        $c52bca934bf2714c$var$K |= 4;
        $c52bca934bf2714c$var$ok.current = null;
        $c52bca934bf2714c$var$Pj(a, c);
        $c52bca934bf2714c$var$ek(c, a);
        $c52bca934bf2714c$var$Oe($c52bca934bf2714c$var$Df);
        $c52bca934bf2714c$var$dd = !!$c52bca934bf2714c$var$Cf;
        $c52bca934bf2714c$var$Df = $c52bca934bf2714c$var$Cf = null;
        a.current = c;
        $c52bca934bf2714c$var$ik(c, a, e);
        $c52bca934bf2714c$var$dc();
        $c52bca934bf2714c$var$K = h;
        $c52bca934bf2714c$var$C = g;
        $c52bca934bf2714c$var$pk.transition = f;
    } else a.current = c;
    $c52bca934bf2714c$var$wk && ($c52bca934bf2714c$var$wk = !1, $c52bca934bf2714c$var$xk = a, $c52bca934bf2714c$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c52bca934bf2714c$var$Si = null);
    $c52bca934bf2714c$var$mc(c.stateNode, d);
    $c52bca934bf2714c$var$Ek(a, $c52bca934bf2714c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c52bca934bf2714c$var$Pi) throw $c52bca934bf2714c$var$Pi = !1, a = $c52bca934bf2714c$var$Qi, $c52bca934bf2714c$var$Qi = null, a;
    0 !== ($c52bca934bf2714c$var$yk & 1) && 0 !== a.tag && $c52bca934bf2714c$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c52bca934bf2714c$var$Ak ? $c52bca934bf2714c$var$zk++ : ($c52bca934bf2714c$var$zk = 0, $c52bca934bf2714c$var$Ak = a) : $c52bca934bf2714c$var$zk = 0;
    $c52bca934bf2714c$var$jg();
    return null;
}
function $c52bca934bf2714c$var$Ik() {
    if (null !== $c52bca934bf2714c$var$xk) {
        var a = $c52bca934bf2714c$var$Dc($c52bca934bf2714c$var$yk), b = $c52bca934bf2714c$var$pk.transition, c = $c52bca934bf2714c$var$C;
        try {
            $c52bca934bf2714c$var$pk.transition = null;
            $c52bca934bf2714c$var$C = 16 > a ? 16 : a;
            if (null === $c52bca934bf2714c$var$xk) var d = !1;
            else {
                a = $c52bca934bf2714c$var$xk;
                $c52bca934bf2714c$var$xk = null;
                $c52bca934bf2714c$var$yk = 0;
                if (0 !== ($c52bca934bf2714c$var$K & 6)) throw Error($c52bca934bf2714c$var$p(331));
                var e = $c52bca934bf2714c$var$K;
                $c52bca934bf2714c$var$K |= 4;
                for($c52bca934bf2714c$var$V = a.current; null !== $c52bca934bf2714c$var$V;){
                    var f = $c52bca934bf2714c$var$V, g = f.child;
                    if (0 !== ($c52bca934bf2714c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c52bca934bf2714c$var$V = l; null !== $c52bca934bf2714c$var$V;){
                                    var m = $c52bca934bf2714c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c52bca934bf2714c$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c52bca934bf2714c$var$V = q;
                                    else for(; null !== $c52bca934bf2714c$var$V;){
                                        m = $c52bca934bf2714c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c52bca934bf2714c$var$Tj(m);
                                        if (m === l) {
                                            $c52bca934bf2714c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c52bca934bf2714c$var$V = r;
                                            break;
                                        }
                                        $c52bca934bf2714c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c52bca934bf2714c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c52bca934bf2714c$var$V = g;
                    else b: for(; null !== $c52bca934bf2714c$var$V;){
                        f = $c52bca934bf2714c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c52bca934bf2714c$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c52bca934bf2714c$var$V = x;
                            break b;
                        }
                        $c52bca934bf2714c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c52bca934bf2714c$var$V = w; null !== $c52bca934bf2714c$var$V;){
                    g = $c52bca934bf2714c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c52bca934bf2714c$var$V = u;
                    else b: for(g = w; null !== $c52bca934bf2714c$var$V;){
                        h = $c52bca934bf2714c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c52bca934bf2714c$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c52bca934bf2714c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c52bca934bf2714c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c52bca934bf2714c$var$V = F;
                            break b;
                        }
                        $c52bca934bf2714c$var$V = h.return;
                    }
                }
                $c52bca934bf2714c$var$K = e;
                $c52bca934bf2714c$var$jg();
                if ($c52bca934bf2714c$var$lc && "function" === typeof $c52bca934bf2714c$var$lc.onPostCommitFiberRoot) try {
                    $c52bca934bf2714c$var$lc.onPostCommitFiberRoot($c52bca934bf2714c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c52bca934bf2714c$var$C = c, $c52bca934bf2714c$var$pk.transition = b;
        }
    }
    return !1;
}
function $c52bca934bf2714c$var$Yk(a, b, c) {
    b = $c52bca934bf2714c$var$Ki(c, b);
    b = $c52bca934bf2714c$var$Oi(a, b, 1);
    a = $c52bca934bf2714c$var$dh(a, b, 1);
    b = $c52bca934bf2714c$var$L();
    null !== a && ($c52bca934bf2714c$var$Ac(a, 1, b), $c52bca934bf2714c$var$Ek(a, b));
}
function $c52bca934bf2714c$var$W(a, b, c) {
    if (3 === a.tag) $c52bca934bf2714c$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c52bca934bf2714c$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c52bca934bf2714c$var$Si || !$c52bca934bf2714c$var$Si.has(d))) {
                a = $c52bca934bf2714c$var$Ki(c, a);
                a = $c52bca934bf2714c$var$Ri(b, a, 1);
                b = $c52bca934bf2714c$var$dh(b, a, 1);
                a = $c52bca934bf2714c$var$L();
                null !== b && ($c52bca934bf2714c$var$Ac(b, 1, a), $c52bca934bf2714c$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c52bca934bf2714c$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c52bca934bf2714c$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c52bca934bf2714c$var$R === a && ($c52bca934bf2714c$var$Z & c) === c && (4 === $c52bca934bf2714c$var$T || 3 === $c52bca934bf2714c$var$T && ($c52bca934bf2714c$var$Z & 130023424) === $c52bca934bf2714c$var$Z && 500 > $c52bca934bf2714c$var$B() - $c52bca934bf2714c$var$gk ? $c52bca934bf2714c$var$Lk(a, 0) : $c52bca934bf2714c$var$sk |= c);
    $c52bca934bf2714c$var$Ek(a, b);
}
function $c52bca934bf2714c$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c52bca934bf2714c$var$sc, $c52bca934bf2714c$var$sc <<= 1, 0 === ($c52bca934bf2714c$var$sc & 130023424) && ($c52bca934bf2714c$var$sc = 4194304)));
    var c = $c52bca934bf2714c$var$L();
    a = $c52bca934bf2714c$var$Zg(a, b);
    null !== a && ($c52bca934bf2714c$var$Ac(a, b, c), $c52bca934bf2714c$var$Ek(a, c));
}
function $c52bca934bf2714c$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c52bca934bf2714c$var$Zk(a, c);
}
function $c52bca934bf2714c$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c52bca934bf2714c$var$p(314));
    }
    null !== d && d.delete(b);
    $c52bca934bf2714c$var$Zk(a, c);
}
var $c52bca934bf2714c$var$Wk;
$c52bca934bf2714c$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c52bca934bf2714c$var$Wf.current) $c52bca934bf2714c$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c52bca934bf2714c$var$Ug = !1, $c52bca934bf2714c$var$zj(a, b, c);
            $c52bca934bf2714c$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c52bca934bf2714c$var$Ug = !1, $c52bca934bf2714c$var$I && 0 !== (b.flags & 1048576) && $c52bca934bf2714c$var$ug(b, $c52bca934bf2714c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c52bca934bf2714c$var$jj(a, b);
            a = b.pendingProps;
            var e = $c52bca934bf2714c$var$Yf(b, $c52bca934bf2714c$var$H.current);
            $c52bca934bf2714c$var$Tg(b, c);
            e = $c52bca934bf2714c$var$Xh(null, b, d, a, e, c);
            var f = $c52bca934bf2714c$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c52bca934bf2714c$var$Zf(d) ? (f = !0, $c52bca934bf2714c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c52bca934bf2714c$var$ah(b), e.updater = $c52bca934bf2714c$var$nh, b.stateNode = e, e._reactInternals = b, $c52bca934bf2714c$var$rh(b, d, a, c), b = $c52bca934bf2714c$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c52bca934bf2714c$var$I && f && $c52bca934bf2714c$var$vg(b), $c52bca934bf2714c$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c52bca934bf2714c$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c52bca934bf2714c$var$$k(d);
                a = $c52bca934bf2714c$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c52bca934bf2714c$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c52bca934bf2714c$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c52bca934bf2714c$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c52bca934bf2714c$var$aj(null, b, d, $c52bca934bf2714c$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c52bca934bf2714c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c52bca934bf2714c$var$Lg(d, e), $c52bca934bf2714c$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c52bca934bf2714c$var$Lg(d, e), $c52bca934bf2714c$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c52bca934bf2714c$var$lj(b);
                if (null === a) throw Error($c52bca934bf2714c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c52bca934bf2714c$var$bh(a, b);
                $c52bca934bf2714c$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c52bca934bf2714c$var$Ki(Error($c52bca934bf2714c$var$p(423)), b);
                        b = $c52bca934bf2714c$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c52bca934bf2714c$var$Ki(Error($c52bca934bf2714c$var$p(424)), b);
                        b = $c52bca934bf2714c$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c52bca934bf2714c$var$yg = $c52bca934bf2714c$var$Lf(b.stateNode.containerInfo.firstChild), $c52bca934bf2714c$var$xg = b, $c52bca934bf2714c$var$I = !0, $c52bca934bf2714c$var$zg = null, c = $c52bca934bf2714c$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c52bca934bf2714c$var$Ig();
                    if (d === e) {
                        b = $c52bca934bf2714c$var$$i(a, b, c);
                        break a;
                    }
                    $c52bca934bf2714c$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c52bca934bf2714c$var$Kh(b), null === a && $c52bca934bf2714c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c52bca934bf2714c$var$Ef(d, e) ? g = null : null !== f && $c52bca934bf2714c$var$Ef(d, f) && (b.flags |= 32), $c52bca934bf2714c$var$hj(a, b), $c52bca934bf2714c$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c52bca934bf2714c$var$Eg(b), null;
        case 13:
            return $c52bca934bf2714c$var$pj(a, b, c);
        case 4:
            return $c52bca934bf2714c$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c52bca934bf2714c$var$Bh(b, null, d, c) : $c52bca934bf2714c$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c52bca934bf2714c$var$Lg(d, e), $c52bca934bf2714c$var$Zi(a, b, d, e, c);
        case 7:
            return $c52bca934bf2714c$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c52bca934bf2714c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c52bca934bf2714c$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c52bca934bf2714c$var$G($c52bca934bf2714c$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c52bca934bf2714c$var$He(f.value, g)) {
                        if (f.children === e.children && !$c52bca934bf2714c$var$Wf.current) {
                            b = $c52bca934bf2714c$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c52bca934bf2714c$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c52bca934bf2714c$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c52bca934bf2714c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c52bca934bf2714c$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c52bca934bf2714c$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c52bca934bf2714c$var$Tg(b, c), e = $c52bca934bf2714c$var$Vg(e), d = d(e), b.flags |= 1, $c52bca934bf2714c$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c52bca934bf2714c$var$Lg(d, b.pendingProps), e = $c52bca934bf2714c$var$Lg(d.type, e), $c52bca934bf2714c$var$aj(a, b, d, e, c);
        case 15:
            return $c52bca934bf2714c$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c52bca934bf2714c$var$Lg(d, e), $c52bca934bf2714c$var$jj(a, b), b.tag = 1, $c52bca934bf2714c$var$Zf(d) ? (a = !0, $c52bca934bf2714c$var$cg(b)) : a = !1, $c52bca934bf2714c$var$Tg(b, c), $c52bca934bf2714c$var$ph(b, d, e), $c52bca934bf2714c$var$rh(b, d, e, c), $c52bca934bf2714c$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c52bca934bf2714c$var$yj(a, b, c);
        case 22:
            return $c52bca934bf2714c$var$ej(a, b, c);
    }
    throw Error($c52bca934bf2714c$var$p(156, b.tag));
};
function $c52bca934bf2714c$var$Gk(a, b) {
    return $c52bca934bf2714c$var$ac(a, b);
}
function $c52bca934bf2714c$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c52bca934bf2714c$var$Bg(a, b, c, d) {
    return new $c52bca934bf2714c$var$al(a, b, c, d);
}
function $c52bca934bf2714c$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c52bca934bf2714c$var$$k(a) {
    if ("function" === typeof a) return $c52bca934bf2714c$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c52bca934bf2714c$var$Da) return 11;
        if (a === $c52bca934bf2714c$var$Ga) return 14;
    }
    return 2;
}
function $c52bca934bf2714c$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c52bca934bf2714c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c52bca934bf2714c$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c52bca934bf2714c$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c52bca934bf2714c$var$ya:
            return $c52bca934bf2714c$var$Ah(c.children, e, f, b);
        case $c52bca934bf2714c$var$za:
            g = 8;
            e |= 8;
            break;
        case $c52bca934bf2714c$var$Aa:
            return a = $c52bca934bf2714c$var$Bg(12, c, b, e | 2), a.elementType = $c52bca934bf2714c$var$Aa, a.lanes = f, a;
        case $c52bca934bf2714c$var$Ea:
            return a = $c52bca934bf2714c$var$Bg(13, c, b, e), a.elementType = $c52bca934bf2714c$var$Ea, a.lanes = f, a;
        case $c52bca934bf2714c$var$Fa:
            return a = $c52bca934bf2714c$var$Bg(19, c, b, e), a.elementType = $c52bca934bf2714c$var$Fa, a.lanes = f, a;
        case $c52bca934bf2714c$var$Ia:
            return $c52bca934bf2714c$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c52bca934bf2714c$var$Ba:
                    g = 10;
                    break a;
                case $c52bca934bf2714c$var$Ca:
                    g = 9;
                    break a;
                case $c52bca934bf2714c$var$Da:
                    g = 11;
                    break a;
                case $c52bca934bf2714c$var$Ga:
                    g = 14;
                    break a;
                case $c52bca934bf2714c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c52bca934bf2714c$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $kMImg._)(a), ""));
    }
    b = $c52bca934bf2714c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c52bca934bf2714c$var$Ah(a, b, c, d) {
    a = $c52bca934bf2714c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c52bca934bf2714c$var$qj(a, b, c, d) {
    a = $c52bca934bf2714c$var$Bg(22, a, d, b);
    a.elementType = $c52bca934bf2714c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c52bca934bf2714c$var$xh(a, b, c) {
    a = $c52bca934bf2714c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c52bca934bf2714c$var$zh(a, b, c) {
    b = $c52bca934bf2714c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c52bca934bf2714c$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c52bca934bf2714c$var$zc(0);
    this.expirationTimes = $c52bca934bf2714c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c52bca934bf2714c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c52bca934bf2714c$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c52bca934bf2714c$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c52bca934bf2714c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c52bca934bf2714c$var$ah(f);
    return a;
}
function $c52bca934bf2714c$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c52bca934bf2714c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c52bca934bf2714c$var$el(a) {
    if (!a) return $c52bca934bf2714c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c52bca934bf2714c$var$Vb(a) !== a || 1 !== a.tag) throw Error($c52bca934bf2714c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c52bca934bf2714c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c52bca934bf2714c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c52bca934bf2714c$var$Zf(c)) return $c52bca934bf2714c$var$bg(a, c, b);
    }
    return b;
}
function $c52bca934bf2714c$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c52bca934bf2714c$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c52bca934bf2714c$var$el(null);
    c = a.current;
    d = $c52bca934bf2714c$var$L();
    e = $c52bca934bf2714c$var$lh(c);
    f = $c52bca934bf2714c$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c52bca934bf2714c$var$dh(c, f, e);
    a.current.lanes = e;
    $c52bca934bf2714c$var$Ac(a, e, d);
    $c52bca934bf2714c$var$Ek(a, d);
    return a;
}
function $c52bca934bf2714c$var$gl(a, b, c, d) {
    var e = b.current, f = $c52bca934bf2714c$var$L(), g = $c52bca934bf2714c$var$lh(e);
    c = $c52bca934bf2714c$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c52bca934bf2714c$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c52bca934bf2714c$var$dh(e, b, g);
    null !== a && ($c52bca934bf2714c$var$mh(a, e, g, f), $c52bca934bf2714c$var$eh(a, e, g));
    return g;
}
function $c52bca934bf2714c$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c52bca934bf2714c$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c52bca934bf2714c$var$jl(a, b) {
    $c52bca934bf2714c$var$il(a, b);
    (a = a.alternate) && $c52bca934bf2714c$var$il(a, b);
}
function $c52bca934bf2714c$var$kl() {
    return null;
}
var $c52bca934bf2714c$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $c52bca934bf2714c$var$ml(a) {
    this._internalRoot = a;
}
$c52bca934bf2714c$var$nl.prototype.render = $c52bca934bf2714c$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c52bca934bf2714c$var$p(409));
    $c52bca934bf2714c$var$gl(a, b, null, null);
};
$c52bca934bf2714c$var$nl.prototype.unmount = $c52bca934bf2714c$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c52bca934bf2714c$var$Sk(function() {
            $c52bca934bf2714c$var$gl(null, a, null, null);
        });
        b[$c52bca934bf2714c$var$uf] = null;
    }
};
function $c52bca934bf2714c$var$nl(a) {
    this._internalRoot = a;
}
$c52bca934bf2714c$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c52bca934bf2714c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c52bca934bf2714c$var$Qc.length && 0 !== b && b < $c52bca934bf2714c$var$Qc[c].priority; c++);
        $c52bca934bf2714c$var$Qc.splice(c, 0, a);
        0 === c && $c52bca934bf2714c$var$Vc(a);
    }
};
function $c52bca934bf2714c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c52bca934bf2714c$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c52bca934bf2714c$var$ql() {}
function $c52bca934bf2714c$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $c52bca934bf2714c$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $c52bca934bf2714c$var$fl(b, d, a, 0, null, !1, !1, "", $c52bca934bf2714c$var$ql);
        a._reactRootContainer = g;
        a[$c52bca934bf2714c$var$uf] = g.current;
        $c52bca934bf2714c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c52bca934bf2714c$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $c52bca934bf2714c$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $c52bca934bf2714c$var$cl(a, 0, !1, null, null, !1, !1, "", $c52bca934bf2714c$var$ql);
    a._reactRootContainer = k;
    a[$c52bca934bf2714c$var$uf] = k.current;
    $c52bca934bf2714c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c52bca934bf2714c$var$Sk(function() {
        $c52bca934bf2714c$var$gl(b, k, c, d);
    });
    return k;
}
function $c52bca934bf2714c$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $c52bca934bf2714c$var$hl(g);
                h.call(_$a);
            };
        }
        $c52bca934bf2714c$var$gl(b, g, a, e);
    } else g = $c52bca934bf2714c$var$rl(c, b, a, e, d);
    return $c52bca934bf2714c$var$hl(g);
}
$c52bca934bf2714c$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c52bca934bf2714c$var$tc(b.pendingLanes);
                0 !== c && ($c52bca934bf2714c$var$Cc(b, c | 1), $c52bca934bf2714c$var$Ek(b, $c52bca934bf2714c$var$B()), 0 === ($c52bca934bf2714c$var$K & 6) && ($c52bca934bf2714c$var$Hj = $c52bca934bf2714c$var$B() + 500, $c52bca934bf2714c$var$jg()));
            }
            break;
        case 13:
            $c52bca934bf2714c$var$Sk(function() {
                var b = $c52bca934bf2714c$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c52bca934bf2714c$var$L();
                    $c52bca934bf2714c$var$mh(b, a, 1, c);
                }
            }), $c52bca934bf2714c$var$jl(a, 1);
    }
};
$c52bca934bf2714c$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $c52bca934bf2714c$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c52bca934bf2714c$var$L();
            $c52bca934bf2714c$var$mh(b, a, 134217728, c);
        }
        $c52bca934bf2714c$var$jl(a, 134217728);
    }
};
$c52bca934bf2714c$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $c52bca934bf2714c$var$lh(a), c = $c52bca934bf2714c$var$Zg(a, b);
        if (null !== c) {
            var d = $c52bca934bf2714c$var$L();
            $c52bca934bf2714c$var$mh(c, a, b, d);
        }
        $c52bca934bf2714c$var$jl(a, b);
    }
};
$c52bca934bf2714c$var$Hc = function Hc() {
    return $c52bca934bf2714c$var$C;
};
$c52bca934bf2714c$var$Ic = function Ic(a, b) {
    var c = $c52bca934bf2714c$var$C;
    try {
        return $c52bca934bf2714c$var$C = a, b();
    } finally{
        $c52bca934bf2714c$var$C = c;
    }
};
$c52bca934bf2714c$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $c52bca934bf2714c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c52bca934bf2714c$var$Db(d);
                        if (!e) throw Error($c52bca934bf2714c$var$p(90));
                        $c52bca934bf2714c$var$Wa(d);
                        $c52bca934bf2714c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c52bca934bf2714c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c52bca934bf2714c$var$fb(a, !!c.multiple, b, !1);
    }
};
$c52bca934bf2714c$var$Gb = $c52bca934bf2714c$var$Rk;
$c52bca934bf2714c$var$Hb = $c52bca934bf2714c$var$Sk;
var $c52bca934bf2714c$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c52bca934bf2714c$var$Cb,
        $c52bca934bf2714c$var$ue,
        $c52bca934bf2714c$var$Db,
        $c52bca934bf2714c$var$Eb,
        $c52bca934bf2714c$var$Fb,
        $c52bca934bf2714c$var$Rk
    ]
}, $c52bca934bf2714c$var$ul = {
    findFiberByHostInstance: $c52bca934bf2714c$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c52bca934bf2714c$var$vl = {
    bundleType: $c52bca934bf2714c$var$ul.bundleType,
    version: $c52bca934bf2714c$var$ul.version,
    rendererPackageName: $c52bca934bf2714c$var$ul.rendererPackageName,
    rendererConfig: $c52bca934bf2714c$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c52bca934bf2714c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $c52bca934bf2714c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c52bca934bf2714c$var$ul.findFiberByHostInstance || $c52bca934bf2714c$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c52bca934bf2714c$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c52bca934bf2714c$var$wl.isDisabled && $c52bca934bf2714c$var$wl.supportsFiber) try {
        $c52bca934bf2714c$var$kc = $c52bca934bf2714c$var$wl.inject($c52bca934bf2714c$var$vl), $c52bca934bf2714c$var$lc = $c52bca934bf2714c$var$wl;
    } catch (a) {}
}
$c52bca934bf2714c$export$ae55be85d98224ed = $c52bca934bf2714c$var$tl;
$c52bca934bf2714c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c52bca934bf2714c$var$ol(b)) throw Error($c52bca934bf2714c$var$p(200));
    return $c52bca934bf2714c$var$dl(a, b, null, c);
};
$c52bca934bf2714c$export$882461b6382ed46c = function(a, b) {
    if (!$c52bca934bf2714c$var$ol(a)) throw Error($c52bca934bf2714c$var$p(299));
    var c = !1, d = "", e = $c52bca934bf2714c$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c52bca934bf2714c$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c52bca934bf2714c$var$uf] = b.current;
    $c52bca934bf2714c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c52bca934bf2714c$var$ml(b);
};
$c52bca934bf2714c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c52bca934bf2714c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c52bca934bf2714c$var$p(268, a));
    }
    a = $c52bca934bf2714c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c52bca934bf2714c$export$cd75ccfd720a3cd4 = function(a) {
    return $c52bca934bf2714c$var$Sk(a);
};
$c52bca934bf2714c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c52bca934bf2714c$var$pl(b)) throw Error($c52bca934bf2714c$var$p(200));
    return $c52bca934bf2714c$var$sl(null, a, b, !0, c);
};
$c52bca934bf2714c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c52bca934bf2714c$var$ol(a)) throw Error($c52bca934bf2714c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c52bca934bf2714c$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c52bca934bf2714c$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c52bca934bf2714c$var$uf] = b.current;
    $c52bca934bf2714c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c52bca934bf2714c$var$nl(b);
};
$c52bca934bf2714c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c52bca934bf2714c$var$pl(b)) throw Error($c52bca934bf2714c$var$p(200));
    return $c52bca934bf2714c$var$sl(null, a, b, !1, c);
};
$c52bca934bf2714c$export$502457920280e6be = function(a) {
    if (!$c52bca934bf2714c$var$pl(a)) throw Error($c52bca934bf2714c$var$p(40));
    return a._reactRootContainer ? ($c52bca934bf2714c$var$Sk(function() {
        $c52bca934bf2714c$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c52bca934bf2714c$var$uf] = null;
        });
    }), !0) : !1;
};
$c52bca934bf2714c$export$c78a37762a8d58e1 = $c52bca934bf2714c$var$Rk;
$c52bca934bf2714c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c52bca934bf2714c$var$pl(c)) throw Error($c52bca934bf2714c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c52bca934bf2714c$var$p(38));
    return $c52bca934bf2714c$var$sl(a, b, c, !1, d);
};
$c52bca934bf2714c$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("l9xJK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cQ3Bl"));

});
parcelRegister("cQ3Bl", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $958d227f7675f478$export$c4744153514ff05d; }, function (v) { return $958d227f7675f478$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $958d227f7675f478$export$3e506c1ccc9cc1a7; }, function (v) { return $958d227f7675f478$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $958d227f7675f478$export$e26fe2ed2fa76875; }, function (v) { return $958d227f7675f478$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $958d227f7675f478$export$502329bbf4b505b1; }, function (v) { return $958d227f7675f478$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $958d227f7675f478$export$6e3807111c4874c4; }, function (v) { return $958d227f7675f478$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $958d227f7675f478$export$c27134553091fb3a; }, function (v) { return $958d227f7675f478$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $958d227f7675f478$export$33ee1acdc04fd2a2; }, function (v) { return $958d227f7675f478$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $958d227f7675f478$export$b00a404bbd5edef2; }, function (v) { return $958d227f7675f478$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $958d227f7675f478$export$8352ce38b91d0c62; }, function (v) { return $958d227f7675f478$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $958d227f7675f478$export$d66a1c1c77bd778b; }, function (v) { return $958d227f7675f478$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $958d227f7675f478$export$d3dfb8e4810cb555; }, function (v) { return $958d227f7675f478$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $958d227f7675f478$export$839f9183b0465a69; }, function (v) { return $958d227f7675f478$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $958d227f7675f478$export$72fdf0e06517287b; }, function (v) { return $958d227f7675f478$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $958d227f7675f478$export$4b844e58a3e414b4; }, function (v) { return $958d227f7675f478$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $958d227f7675f478$export$816d2913ae6b83b1; }, function (v) { return $958d227f7675f478$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $958d227f7675f478$export$61bcfe829111a1d0; }, function (v) { return $958d227f7675f478$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $958d227f7675f478$export$7ee8c9beb337bc3f; }, function (v) { return $958d227f7675f478$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $958d227f7675f478$export$b5836b71941fa3ed; }, function (v) { return $958d227f7675f478$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $958d227f7675f478$export$cf845f2c119da08a; }, function (v) { return $958d227f7675f478$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $958d227f7675f478$export$c4744153514ff05d;
var $958d227f7675f478$export$3e506c1ccc9cc1a7;
var $958d227f7675f478$export$e26fe2ed2fa76875;
var $958d227f7675f478$export$502329bbf4b505b1;
var $958d227f7675f478$export$6e3807111c4874c4;
var $958d227f7675f478$export$c27134553091fb3a;
var $958d227f7675f478$export$33ee1acdc04fd2a2;
var $958d227f7675f478$export$b00a404bbd5edef2;
var $958d227f7675f478$export$8352ce38b91d0c62;
var $958d227f7675f478$export$d66a1c1c77bd778b;
var $958d227f7675f478$export$d3dfb8e4810cb555;
var $958d227f7675f478$export$839f9183b0465a69;
var $958d227f7675f478$export$72fdf0e06517287b;
var $958d227f7675f478$export$4b844e58a3e414b4;
var $958d227f7675f478$export$816d2913ae6b83b1;
var $958d227f7675f478$export$61bcfe829111a1d0;
var $958d227f7675f478$export$7ee8c9beb337bc3f;
var $958d227f7675f478$export$b5836b71941fa3ed;
var $958d227f7675f478$export$cf845f2c119da08a;
"use strict";
function $958d227f7675f478$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $958d227f7675f478$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $958d227f7675f478$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $958d227f7675f478$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $958d227f7675f478$var$g(C, c)) n < e && 0 > $958d227f7675f478$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $958d227f7675f478$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $958d227f7675f478$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $958d227f7675f478$var$l = performance;
    $958d227f7675f478$export$c4744153514ff05d = function() {
        return $958d227f7675f478$var$l.now();
    };
} else {
    var $958d227f7675f478$var$p = Date, $958d227f7675f478$var$q = $958d227f7675f478$var$p.now();
    $958d227f7675f478$export$c4744153514ff05d = function() {
        return $958d227f7675f478$var$p.now() - $958d227f7675f478$var$q;
    };
}
var $958d227f7675f478$var$r = [], $958d227f7675f478$var$t = [], $958d227f7675f478$var$u = 1, $958d227f7675f478$var$v = null, $958d227f7675f478$var$y = 3, $958d227f7675f478$var$z = !1, $958d227f7675f478$var$A = !1, $958d227f7675f478$var$B = !1, $958d227f7675f478$var$D = "function" === typeof setTimeout ? setTimeout : null, $958d227f7675f478$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $958d227f7675f478$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $958d227f7675f478$var$G(a) {
    for(var b = $958d227f7675f478$var$h($958d227f7675f478$var$t); null !== b;){
        if (null === b.callback) $958d227f7675f478$var$k($958d227f7675f478$var$t);
        else if (b.startTime <= a) $958d227f7675f478$var$k($958d227f7675f478$var$t), b.sortIndex = b.expirationTime, $958d227f7675f478$var$f($958d227f7675f478$var$r, b);
        else break;
        b = $958d227f7675f478$var$h($958d227f7675f478$var$t);
    }
}
function $958d227f7675f478$var$H(a) {
    $958d227f7675f478$var$B = !1;
    $958d227f7675f478$var$G(a);
    if (!$958d227f7675f478$var$A) {
        if (null !== $958d227f7675f478$var$h($958d227f7675f478$var$r)) $958d227f7675f478$var$A = !0, $958d227f7675f478$var$I($958d227f7675f478$var$J);
        else {
            var b = $958d227f7675f478$var$h($958d227f7675f478$var$t);
            null !== b && $958d227f7675f478$var$K($958d227f7675f478$var$H, b.startTime - a);
        }
    }
}
function $958d227f7675f478$var$J(a, b) {
    $958d227f7675f478$var$A = !1;
    $958d227f7675f478$var$B && ($958d227f7675f478$var$B = !1, $958d227f7675f478$var$E($958d227f7675f478$var$L), $958d227f7675f478$var$L = -1);
    $958d227f7675f478$var$z = !0;
    var c = $958d227f7675f478$var$y;
    try {
        $958d227f7675f478$var$G(b);
        for($958d227f7675f478$var$v = $958d227f7675f478$var$h($958d227f7675f478$var$r); null !== $958d227f7675f478$var$v && (!($958d227f7675f478$var$v.expirationTime > b) || a && !$958d227f7675f478$var$M());){
            var d = $958d227f7675f478$var$v.callback;
            if ("function" === typeof d) {
                $958d227f7675f478$var$v.callback = null;
                $958d227f7675f478$var$y = $958d227f7675f478$var$v.priorityLevel;
                var e = d($958d227f7675f478$var$v.expirationTime <= b);
                b = $958d227f7675f478$export$c4744153514ff05d();
                "function" === typeof e ? $958d227f7675f478$var$v.callback = e : $958d227f7675f478$var$v === $958d227f7675f478$var$h($958d227f7675f478$var$r) && $958d227f7675f478$var$k($958d227f7675f478$var$r);
                $958d227f7675f478$var$G(b);
            } else $958d227f7675f478$var$k($958d227f7675f478$var$r);
            $958d227f7675f478$var$v = $958d227f7675f478$var$h($958d227f7675f478$var$r);
        }
        if (null !== $958d227f7675f478$var$v) var w = !0;
        else {
            var m = $958d227f7675f478$var$h($958d227f7675f478$var$t);
            null !== m && $958d227f7675f478$var$K($958d227f7675f478$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $958d227f7675f478$var$v = null, $958d227f7675f478$var$y = c, $958d227f7675f478$var$z = !1;
    }
}
var $958d227f7675f478$var$N = !1, $958d227f7675f478$var$O = null, $958d227f7675f478$var$L = -1, $958d227f7675f478$var$P = 5, $958d227f7675f478$var$Q = -1;
function $958d227f7675f478$var$M() {
    return $958d227f7675f478$export$c4744153514ff05d() - $958d227f7675f478$var$Q < $958d227f7675f478$var$P ? !1 : !0;
}
function $958d227f7675f478$var$R() {
    if (null !== $958d227f7675f478$var$O) {
        var a = $958d227f7675f478$export$c4744153514ff05d();
        $958d227f7675f478$var$Q = a;
        var b = !0;
        try {
            b = $958d227f7675f478$var$O(!0, a);
        } finally{
            b ? $958d227f7675f478$var$S() : ($958d227f7675f478$var$N = !1, $958d227f7675f478$var$O = null);
        }
    } else $958d227f7675f478$var$N = !1;
}
var $958d227f7675f478$var$S;
if ("function" === typeof $958d227f7675f478$var$F) $958d227f7675f478$var$S = function S() {
    $958d227f7675f478$var$F($958d227f7675f478$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $958d227f7675f478$var$T = new MessageChannel, $958d227f7675f478$var$U = $958d227f7675f478$var$T.port2;
    $958d227f7675f478$var$T.port1.onmessage = $958d227f7675f478$var$R;
    $958d227f7675f478$var$S = function S() {
        $958d227f7675f478$var$U.postMessage(null);
    };
} else $958d227f7675f478$var$S = function S() {
    $958d227f7675f478$var$D($958d227f7675f478$var$R, 0);
};
function $958d227f7675f478$var$I(a) {
    $958d227f7675f478$var$O = a;
    $958d227f7675f478$var$N || ($958d227f7675f478$var$N = !0, $958d227f7675f478$var$S());
}
function $958d227f7675f478$var$K(a, b) {
    $958d227f7675f478$var$L = $958d227f7675f478$var$D(function() {
        a($958d227f7675f478$export$c4744153514ff05d());
    }, b);
}
$958d227f7675f478$export$3e506c1ccc9cc1a7 = 5;
$958d227f7675f478$export$e26fe2ed2fa76875 = 1;
$958d227f7675f478$export$502329bbf4b505b1 = 4;
$958d227f7675f478$export$6e3807111c4874c4 = 3;
$958d227f7675f478$export$c27134553091fb3a = null;
$958d227f7675f478$export$33ee1acdc04fd2a2 = 2;
$958d227f7675f478$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$958d227f7675f478$export$8352ce38b91d0c62 = function() {
    $958d227f7675f478$var$A || $958d227f7675f478$var$z || ($958d227f7675f478$var$A = !0, $958d227f7675f478$var$I($958d227f7675f478$var$J));
};
$958d227f7675f478$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $958d227f7675f478$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$958d227f7675f478$export$d3dfb8e4810cb555 = function() {
    return $958d227f7675f478$var$y;
};
$958d227f7675f478$export$839f9183b0465a69 = function() {
    return $958d227f7675f478$var$h($958d227f7675f478$var$r);
};
$958d227f7675f478$export$72fdf0e06517287b = function(a) {
    switch($958d227f7675f478$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $958d227f7675f478$var$y;
    }
    var c = $958d227f7675f478$var$y;
    $958d227f7675f478$var$y = b;
    try {
        return a();
    } finally{
        $958d227f7675f478$var$y = c;
    }
};
$958d227f7675f478$export$4b844e58a3e414b4 = function() {};
$958d227f7675f478$export$816d2913ae6b83b1 = function() {};
$958d227f7675f478$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $958d227f7675f478$var$y;
    $958d227f7675f478$var$y = a;
    try {
        return b();
    } finally{
        $958d227f7675f478$var$y = c;
    }
};
$958d227f7675f478$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $958d227f7675f478$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $958d227f7675f478$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $958d227f7675f478$var$f($958d227f7675f478$var$t, a), null === $958d227f7675f478$var$h($958d227f7675f478$var$r) && a === $958d227f7675f478$var$h($958d227f7675f478$var$t) && ($958d227f7675f478$var$B ? ($958d227f7675f478$var$E($958d227f7675f478$var$L), $958d227f7675f478$var$L = -1) : $958d227f7675f478$var$B = !0, $958d227f7675f478$var$K($958d227f7675f478$var$H, c - d))) : (a.sortIndex = e, $958d227f7675f478$var$f($958d227f7675f478$var$r, a), $958d227f7675f478$var$A || $958d227f7675f478$var$z || ($958d227f7675f478$var$A = !0, $958d227f7675f478$var$I($958d227f7675f478$var$J)));
    return a;
};
$958d227f7675f478$export$b5836b71941fa3ed = $958d227f7675f478$var$M;
$958d227f7675f478$export$cf845f2c119da08a = function(a) {
    var b = $958d227f7675f478$var$y;
    return function() {
        var c = $958d227f7675f478$var$y;
        $958d227f7675f478$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $958d227f7675f478$var$y = c;
        }
    };
};

});



parcelRegister("1McU1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $14b4484f57098271$export$bf730a2d8bf68b42; }, function (v) { return $14b4484f57098271$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $14b4484f57098271$export$bf730a2d8bf68b42;
"use strict";

var $lcrTp = parcelRequire("lcrTp");
function $14b4484f57098271$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $14b4484f57098271$var$p = "function" === typeof Object.is ? Object.is : $14b4484f57098271$var$n, $14b4484f57098271$var$q = $lcrTp.useSyncExternalStore, $14b4484f57098271$var$r = $lcrTp.useRef, $14b4484f57098271$var$t = $lcrTp.useEffect, $14b4484f57098271$var$u = $lcrTp.useMemo, $14b4484f57098271$var$v = $lcrTp.useDebugValue;
$14b4484f57098271$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $14b4484f57098271$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $14b4484f57098271$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($14b4484f57098271$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $14b4484f57098271$var$q(a, c[0], c[1]);
    $14b4484f57098271$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $14b4484f57098271$var$v(d);
    return d;
};

});

parcelRegister("cE9Yb", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $aIKKI = parcelRequire("aIKKI");

var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");

var $9Hju1 = parcelRequire("9Hju1");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $kMImg = parcelRequire("kMImg");

var $bPmCu = parcelRequire("bPmCu");

var $hCdf1 = parcelRequire("hCdf1");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && isPlainObject(base)) {
        if (!getPrototypeOf(base)) {
            var obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return __spreadValues({}, base);
    }
    var descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    var keys = Reflect.ownKeys(descriptors);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $3tDj3._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $kMImg._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $lfBxf._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _this = this;
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $1UA6e._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $1UA6e._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $9tzan._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $3tDj3._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $9Hju1._)(DraftMap, Map1);
        var _super = (0, $hCdf1._)(DraftMap);
        function DraftMap(target, parent) {
            (0, $lfBxf._)(this, DraftMap);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: (0, $aIKKI._)(_this),
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $9tzan._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $azcHm._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $azcHm._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $azcHm._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $azcHm._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $bPmCu._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $9Hju1._)(DraftSet, Set1);
        var _super = (0, $hCdf1._)(DraftSet);
        function DraftSet(target, parent) {
            (0, $lfBxf._)(this, DraftSet);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: (0, $aIKKI._)(_this),
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $9tzan._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $bPmCu._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("aIKKI", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $7ce24788945011dc$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $7ce24788945011dc$export$f3b8ed2e4a5d10b8; });
function $7ce24788945011dc$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("lfBxf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7881d6aac9bc56f$export$2996f80ef42b8419; });
function $f7881d6aac9bc56f$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9tzan", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e6219cf80723e38$export$d60067ff2358eee8; });
function $6e6219cf80723e38$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e6219cf80723e38$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $6e6219cf80723e38$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e6219cf80723e38$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("azcHm", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $7b1705e0bd421f8b$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $7b1705e0bd421f8b$export$1e71eb4bef00f6b0; });
function $7b1705e0bd421f8b$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("9Hju1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $70f73e2831a54131$export$7e4530ad35d3bb8; });

var $jkhBd = parcelRequire("jkhBd");
function $70f73e2831a54131$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $jkhBd._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("jkhBd", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $e11d8966c99dd9fc$export$c2c98ac76e997b63; });
function $e11d8966c99dd9fc$export$c2c98ac76e997b63(o, p) {
    $e11d8966c99dd9fc$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e11d8966c99dd9fc$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("3tDj3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $288291ed5642e525$export$fdf2a89c76341bbf; });

var $bnrkU = parcelRequire("bnrkU");

var $5EP09 = parcelRequire("5EP09");

var $fhYrX = parcelRequire("fhYrX");

var $gbwd1 = parcelRequire("gbwd1");
function $288291ed5642e525$export$fdf2a89c76341bbf(arr, i) {
    return (0, $bnrkU._array_with_holes)(arr) || (0, $5EP09._iterable_to_array_limit)(arr, i) || (0, $gbwd1._unsupported_iterable_to_array)(arr, i) || (0, $fhYrX._non_iterable_rest)();
}

});
parcelRegister("bnrkU", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $84870c13bacf0b97$export$e6256bf45c68d561; });
function $84870c13bacf0b97$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("5EP09", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $41e8400378a4d65e$export$2fd15edff6687200; });
function $41e8400378a4d65e$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("fhYrX", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $b21755a135d053e9$export$60dbc22abd7da546; });
function $b21755a135d053e9$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("gbwd1", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $bc86a87b89c1b208$export$a5be06335b3a083c; });

var $2WwrM = parcelRequire("2WwrM");
function $bc86a87b89c1b208$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2WwrM._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2WwrM._array_like_to_array)(o, minLen);
}

});
parcelRegister("2WwrM", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $224a2ae16741d9d7$export$79e617b1955a2616; });
function $224a2ae16741d9d7$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("1UA6e", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $164706038ac5e80e$export$1b5e630bc3aea29f; });

var $i94ne = parcelRequire("i94ne");

var $f0y3z = parcelRequire("f0y3z");

var $jLjPo = parcelRequire("jLjPo");

var $gbwd1 = parcelRequire("gbwd1");
function $164706038ac5e80e$export$1b5e630bc3aea29f(arr) {
    return (0, $i94ne._array_without_holes)(arr) || (0, $f0y3z._iterable_to_array)(arr) || (0, $gbwd1._unsupported_iterable_to_array)(arr) || (0, $jLjPo._non_iterable_spread)();
}

});
parcelRegister("i94ne", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $d35c75c57a7a7fd9$export$7e0947b5ad3404e2; });

var $2WwrM = parcelRequire("2WwrM");
function $d35c75c57a7a7fd9$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $2WwrM._array_like_to_array)(arr);
}

});

parcelRegister("f0y3z", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $aed14601caf65471$export$1eb58a6e75231000; });
function $aed14601caf65471$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jLjPo", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $e631c98932c81e8e$export$e6f3c4780d19eb2b; });
function $e631c98932c81e8e$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bPmCu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89c600f458e3ec05$export$2466d533fda16e33; });

var $5eooS = parcelRequire("5eooS");

var $g0UjU = parcelRequire("g0UjU");

var $3E07m = parcelRequire("3E07m");

var $jkhBd = parcelRequire("jkhBd");
function $89c600f458e3ec05$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $89c600f458e3ec05$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $3E07m._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5eooS._construct)(Class, arguments, (0, $g0UjU._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $jkhBd._set_prototype_of)(Wrapper, Class);
    };
    return $89c600f458e3ec05$export$2466d533fda16e33(Class);
}

});
parcelRegister("5eooS", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $3cf12feaaa262878$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $3cf12feaaa262878$export$2d841144c5f8c4ab; });

var $1LHcN = parcelRequire("1LHcN");

var $jkhBd = parcelRequire("jkhBd");
function $3cf12feaaa262878$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $1LHcN._is_native_reflect_construct)()) $3cf12feaaa262878$export$2d841144c5f8c4ab = Reflect.construct;
    else $3cf12feaaa262878$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $jkhBd._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $3cf12feaaa262878$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("1LHcN", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $149bb1e791fdc25b$export$685354647fba1516; });
function $149bb1e791fdc25b$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("g0UjU", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $ba8855747be15c94$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $ba8855747be15c94$export$f09211a7d3c496a1; });
function $ba8855747be15c94$export$f09211a7d3c496a1(o) {
    $ba8855747be15c94$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ba8855747be15c94$export$f09211a7d3c496a1(o);
}

});

parcelRegister("3E07m", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $2a7532e79f03bb8f$export$514eda94019f4334; });
function $2a7532e79f03bb8f$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("hCdf1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd3041b9df4daa20$export$8dd05c13f5255580; });

var $g0UjU = parcelRequire("g0UjU");

var $1LHcN = parcelRequire("1LHcN");

var $aS5tf = parcelRequire("aS5tf");
function $cd3041b9df4daa20$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $1LHcN._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $g0UjU._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $g0UjU._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $aS5tf._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("aS5tf", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $7ea330e79da98578$export$ef97c660ca164e52; });

var $aIKKI = parcelRequire("aIKKI");

var $kMImg = parcelRequire("kMImg");
function $7ea330e79da98578$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $kMImg._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $aIKKI._assert_this_initialized)(self);
}

});



parcelRegister("iT2Uc", function(module, exports) {


module.exports = (parcelRequire("dzC3s"))((parcelRequire("9JoR4")).resolve("hcu2T")).then(function() {
    return parcelRequire("iPQZJ");
});

});
parcelRegister("dzC3s", function(module, exports) {
"use strict";

var $esMUn = parcelRequire("esMUn");
module.exports = $esMUn(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("esMUn", function(module, exports) {
"use strict";
var $a8799e6039e730e2$var$cachedBundles = {};
var $a8799e6039e730e2$var$cachedPreloads = {};
var $a8799e6039e730e2$var$cachedPrefetches = {};
function $a8799e6039e730e2$var$getCache(type) {
    switch(type){
        case "preload":
            return $a8799e6039e730e2$var$cachedPreloads;
        case "prefetch":
            return $a8799e6039e730e2$var$cachedPrefetches;
        default:
            return $a8799e6039e730e2$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a8799e6039e730e2$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");
var $201994bc3c423705$exports = {};

$parcel$export($201994bc3c423705$exports, "createRoot", function () { return $201994bc3c423705$export$882461b6382ed46c; }, function (v) { return $201994bc3c423705$export$882461b6382ed46c = v; });
$parcel$export($201994bc3c423705$exports, "hydrateRoot", function () { return $201994bc3c423705$export$757ceba2d55c277e; }, function (v) { return $201994bc3c423705$export$757ceba2d55c277e = v; });
var $201994bc3c423705$export$882461b6382ed46c;
var $201994bc3c423705$export$757ceba2d55c277e;
"use strict";
var $33a5ccd44dbd30cb$exports = {};
"use strict";
function $33a5ccd44dbd30cb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($33a5ccd44dbd30cb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$33a5ccd44dbd30cb$var$checkDCE();

$33a5ccd44dbd30cb$exports = (parcelRequire("gVxhW"));


var $201994bc3c423705$var$i;
$201994bc3c423705$export$882461b6382ed46c = $33a5ccd44dbd30cb$exports.createRoot;
$201994bc3c423705$export$757ceba2d55c277e = $33a5ccd44dbd30cb$exports.hydrateRoot;



var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");
/**
 * React Router DOM v6.22.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $cb837825d0f9e672$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $cb837825d0f9e672$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $cb837825d0f9e672$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $cb837825d0f9e672$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $lfBxf = parcelRequire("lfBxf");

var $3tDj3 = parcelRequire("3tDj3");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $kMImg = parcelRequire("kMImg");
var $75cbc07a4214bd1d$var$extendStatics = function extendStatics1(d, b) {
    $75cbc07a4214bd1d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $75cbc07a4214bd1d$var$extendStatics(d, b);
};
function $75cbc07a4214bd1d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $75cbc07a4214bd1d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $75cbc07a4214bd1d$export$18ce0697a983be9b = function __assign1() {
    $75cbc07a4214bd1d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75cbc07a4214bd1d$export$18ce0697a983be9b.apply(this, arguments);
};
function $75cbc07a4214bd1d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $75cbc07a4214bd1d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $75cbc07a4214bd1d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $75cbc07a4214bd1d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $75cbc07a4214bd1d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $75cbc07a4214bd1d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $kMImg._)(x)) === "symbol" ? x : "".concat(x);
}
function $75cbc07a4214bd1d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $kMImg._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $75cbc07a4214bd1d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $75cbc07a4214bd1d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $75cbc07a4214bd1d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $75cbc07a4214bd1d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $75cbc07a4214bd1d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $75cbc07a4214bd1d$export$45d3717a4c69092e(o, m, p);
}
function $75cbc07a4214bd1d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $75cbc07a4214bd1d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $75cbc07a4214bd1d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($75cbc07a4214bd1d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $75cbc07a4214bd1d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $75cbc07a4214bd1d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $75cbc07a4214bd1d$export$10c90e4f7922046c(v) {
    return this instanceof $75cbc07a4214bd1d$export$10c90e4f7922046c ? (this.v = v, this) : new $75cbc07a4214bd1d$export$10c90e4f7922046c(v);
}
function $75cbc07a4214bd1d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $75cbc07a4214bd1d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $75cbc07a4214bd1d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $75cbc07a4214bd1d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $75cbc07a4214bd1d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $75cbc07a4214bd1d$export$19a8beecd37a4c45 === "function" ? $75cbc07a4214bd1d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $75cbc07a4214bd1d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $75cbc07a4214bd1d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $75cbc07a4214bd1d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $75cbc07a4214bd1d$export$45d3717a4c69092e(result, mod, k);
    }
    $75cbc07a4214bd1d$var$__setModuleDefault(result, mod);
    return result;
}
function $75cbc07a4214bd1d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $75cbc07a4214bd1d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $75cbc07a4214bd1d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $75cbc07a4214bd1d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $75cbc07a4214bd1d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $75cbc07a4214bd1d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $75cbc07a4214bd1d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $75cbc07a4214bd1d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $75cbc07a4214bd1d$export$2e2bcd8739ae039 = {
    __extends: $75cbc07a4214bd1d$export$a8ba968b8961cb8a,
    __assign: $75cbc07a4214bd1d$export$18ce0697a983be9b,
    __rest: $75cbc07a4214bd1d$export$3c9a16f847548506,
    __decorate: $75cbc07a4214bd1d$export$29e00dfd3077644b,
    __param: $75cbc07a4214bd1d$export$d5ad3fd78186038f,
    __metadata: $75cbc07a4214bd1d$export$f1db080c865becb9,
    __awaiter: $75cbc07a4214bd1d$export$1050f835b63b671e,
    __generator: $75cbc07a4214bd1d$export$67ebef60e6f28a6,
    __createBinding: $75cbc07a4214bd1d$export$45d3717a4c69092e,
    __exportStar: $75cbc07a4214bd1d$export$f33643c0debef087,
    __values: $75cbc07a4214bd1d$export$19a8beecd37a4c45,
    __read: $75cbc07a4214bd1d$export$8d051b38c9118094,
    __spread: $75cbc07a4214bd1d$export$afc72e2116322959,
    __spreadArrays: $75cbc07a4214bd1d$export$6388937ca91ccae8,
    __spreadArray: $75cbc07a4214bd1d$export$1216008129fb82ed,
    __await: $75cbc07a4214bd1d$export$10c90e4f7922046c,
    __asyncGenerator: $75cbc07a4214bd1d$export$e427f37a30a4de9b,
    __asyncDelegator: $75cbc07a4214bd1d$export$bbd80228419bb833,
    __asyncValues: $75cbc07a4214bd1d$export$e3b29a3d6162315f,
    __makeTemplateObject: $75cbc07a4214bd1d$export$4fb47efe1390b86f,
    __importStar: $75cbc07a4214bd1d$export$c21735bcef00d192,
    __importDefault: $75cbc07a4214bd1d$export$da59b14a69baef04,
    __classPrivateFieldGet: $75cbc07a4214bd1d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $75cbc07a4214bd1d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $75cbc07a4214bd1d$export$81fdc39f203e4e04,
    __addDisposableResource: $75cbc07a4214bd1d$export$88ac25d8e944e405,
    __disposeResources: $75cbc07a4214bd1d$export$8f076105dc360e92
};



var $lcrTp = parcelRequire("lcrTp");

/**
 * @remix-run/router v1.15.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");

var $9Hju1 = parcelRequire("9Hju1");

var $3tDj3 = parcelRequire("3tDj3");

var $bnrkU = parcelRequire("bnrkU");

var $f0y3z = parcelRequire("f0y3z");

var $fhYrX = parcelRequire("fhYrX");

var $gbwd1 = parcelRequire("gbwd1");
function $ed960a62e15e1de4$export$e62c166da838fa3(arr) {
    return (0, $bnrkU._array_with_holes)(arr) || (0, $f0y3z._iterable_to_array)(arr) || (0, $gbwd1._unsupported_iterable_to_array)(arr) || (0, $fhYrX._non_iterable_rest)();
}



var $1UA6e = parcelRequire("1UA6e");

var $bPmCu = parcelRequire("bPmCu");

var $hCdf1 = parcelRequire("hCdf1");


function $bd7b3a1457c42298$var$_extends() {
    $bd7b3a1457c42298$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd7b3a1457c42298$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $bd7b3a1457c42298$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($bd7b3a1457c42298$export$e19cd5f9376f8cee || ($bd7b3a1457c42298$export$e19cd5f9376f8cee = {}));
var $bd7b3a1457c42298$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $bd7b3a1457c42298$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $bd7b3a1457c42298$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $bd7b3a1457c42298$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $bd7b3a1457c42298$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $bd7b3a1457c42298$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $bd7b3a1457c42298$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $bd7b3a1457c42298$export$fe53371bee54353d(to);
    }
    return $bd7b3a1457c42298$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $bd7b3a1457c42298$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $bd7b3a1457c42298$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $bd7b3a1457c42298$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $bd7b3a1457c42298$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $bd7b3a1457c42298$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $bd7b3a1457c42298$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $bd7b3a1457c42298$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $bd7b3a1457c42298$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $bd7b3a1457c42298$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $bd7b3a1457c42298$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $bd7b3a1457c42298$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $bd7b3a1457c42298$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $bd7b3a1457c42298$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $bd7b3a1457c42298$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $bd7b3a1457c42298$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $bd7b3a1457c42298$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($bd7b3a1457c42298$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Push;
        var location = $bd7b3a1457c42298$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $bd7b3a1457c42298$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Replace;
        var location = $bd7b3a1457c42298$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $bd7b3a1457c42298$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $bd7b3a1457c42298$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $bd7b3a1457c42298$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($bd7b3a1457c42298$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($bd7b3a1457c42298$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $bd7b3a1457c42298$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($bd7b3a1457c42298$var$ResultType || ($bd7b3a1457c42298$var$ResultType = {}));
var $bd7b3a1457c42298$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $bd7b3a1457c42298$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $bd7b3a1457c42298$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $1UA6e._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $bd7b3a1457c42298$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $bd7b3a1457c42298$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($bd7b3a1457c42298$var$isIndexRoute(route)) {
            var indexRoute = $bd7b3a1457c42298$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $bd7b3a1457c42298$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $bd7b3a1457c42298$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $bd7b3a1457c42298$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $bd7b3a1457c42298$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $bd7b3a1457c42298$var$flattenRoutes(routes);
    $bd7b3a1457c42298$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = $bd7b3a1457c42298$var$decodePath(pathname);
        matches = $bd7b3a1457c42298$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $bd7b3a1457c42298$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $bd7b3a1457c42298$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $bd7b3a1457c42298$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $bd7b3a1457c42298$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $bd7b3a1457c42298$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $bd7b3a1457c42298$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $bd7b3a1457c42298$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $bd7b3a1457c42298$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $bd7b3a1457c42298$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $ed960a62e15e1de4$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $bd7b3a1457c42298$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $1UA6e._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $1UA6e._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $bd7b3a1457c42298$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $bd7b3a1457c42298$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $bd7b3a1457c42298$var$paramRe = /^:[\w-]+$/;
var $bd7b3a1457c42298$var$dynamicSegmentValue = 3;
var $bd7b3a1457c42298$var$indexRouteValue = 2;
var $bd7b3a1457c42298$var$emptySegmentValue = 1;
var $bd7b3a1457c42298$var$staticSegmentValue = 10;
var $bd7b3a1457c42298$var$splatPenalty = -2;
var $bd7b3a1457c42298$var$isSplat = function(s) {
    return s === "*";
};
function $bd7b3a1457c42298$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($bd7b3a1457c42298$var$isSplat)) initialScore += $bd7b3a1457c42298$var$splatPenalty;
    if (index) initialScore += $bd7b3a1457c42298$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$bd7b3a1457c42298$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($bd7b3a1457c42298$var$paramRe.test(segment) ? $bd7b3a1457c42298$var$dynamicSegmentValue : segment === "" ? $bd7b3a1457c42298$var$emptySegmentValue : $bd7b3a1457c42298$var$staticSegmentValue);
    }, initialScore);
}
function $bd7b3a1457c42298$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $bd7b3a1457c42298$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $bd7b3a1457c42298$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $bd7b3a1457c42298$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $bd7b3a1457c42298$export$a5c6d149b50c1d86($bd7b3a1457c42298$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $bd7b3a1457c42298$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $bd7b3a1457c42298$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $bd7b3a1457c42298$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $3tDj3._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $bd7b3a1457c42298$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $bd7b3a1457c42298$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $3tDj3._)($bd7b3a1457c42298$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $bd7b3a1457c42298$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $bd7b3a1457c42298$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $bd7b3a1457c42298$var$decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        $bd7b3a1457c42298$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $bd7b3a1457c42298$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $bd7b3a1457c42298$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $bd7b3a1457c42298$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $bd7b3a1457c42298$var$normalizeSearch(search),
        hash: $bd7b3a1457c42298$var$normalizeHash(hash)
    };
}
function $bd7b3a1457c42298$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $bd7b3a1457c42298$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $bd7b3a1457c42298$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $bd7b3a1457c42298$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $bd7b3a1457c42298$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $bd7b3a1457c42298$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $bd7b3a1457c42298$export$8ccf933b0513f8d0(toArg);
    else {
        to = $bd7b3a1457c42298$var$_extends({}, toArg);
        $bd7b3a1457c42298$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $bd7b3a1457c42298$var$getInvalidPathError("?", "pathname", "search", to));
        $bd7b3a1457c42298$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $bd7b3a1457c42298$var$getInvalidPathError("#", "pathname", "hash", to));
        $bd7b3a1457c42298$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $bd7b3a1457c42298$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $bd7b3a1457c42298$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $bd7b3a1457c42298$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $bd7b3a1457c42298$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $bd7b3a1457c42298$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $bd7b3a1457c42298$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $bd7b3a1457c42298$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $bd7b3a1457c42298$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $bd7b3a1457c42298$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $bd7b3a1457c42298$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $9Hju1._)(AbortedDeferredError, Error1);
    var _super = (0, $hCdf1._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $lfBxf._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $bPmCu._)(Error));
var $bd7b3a1457c42298$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $lfBxf._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $bd7b3a1457c42298$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $bd7b3a1457c42298$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $3tDj3._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $azcHm._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $9tzan._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $bd7b3a1457c42298$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $bd7b3a1457c42298$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $3tDj3._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $azcHm._)({}, key, $bd7b3a1457c42298$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $bd7b3a1457c42298$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $bd7b3a1457c42298$var$unwrapTrackedPromise(value) {
    if (!$bd7b3a1457c42298$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $bd7b3a1457c42298$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $bd7b3a1457c42298$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $bd7b3a1457c42298$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $bd7b3a1457c42298$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $bd7b3a1457c42298$export$a6cd19cd1951a23c = function(url, init) {
    var response = $bd7b3a1457c42298$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $bd7b3a1457c42298$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $lfBxf._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $bd7b3a1457c42298$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $bd7b3a1457c42298$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $bd7b3a1457c42298$var$validMutationMethods = new Set($bd7b3a1457c42298$var$validMutationMethodsArr);
var $bd7b3a1457c42298$var$validRequestMethodsArr = [
    "get"
].concat((0, $1UA6e._)($bd7b3a1457c42298$var$validMutationMethodsArr));
var $bd7b3a1457c42298$var$validRequestMethods = new Set($bd7b3a1457c42298$var$validRequestMethodsArr);
var $bd7b3a1457c42298$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $bd7b3a1457c42298$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $bd7b3a1457c42298$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $bd7b3a1457c42298$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $bd7b3a1457c42298$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $bd7b3a1457c42298$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $bd7b3a1457c42298$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $bd7b3a1457c42298$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $bd7b3a1457c42298$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $bd7b3a1457c42298$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $bd7b3a1457c42298$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $bd7b3a1457c42298$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $bd7b3a1457c42298$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $bd7b3a1457c42298$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $bd7b3a1457c42298$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $bd7b3a1457c42298$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $azcHm._)({}, route.id, error);
    }
    var initialized;
    var hasLazyRoutes = initialMatches.some(function(m) {
        return m.route.lazy;
    });
    var hasLoaders = initialMatches.some(function(m) {
        return m.route.loader;
    });
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every(function(m) {
            return m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $bd7b3a1457c42298$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $bd7b3a1457c42298$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $bd7b3a1457c42298$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $bd7b3a1457c42298$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $bd7b3a1457c42298$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $bd7b3a1457c42298$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $1UA6e._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $bd7b3a1457c42298$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $bd7b3a1457c42298$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $bd7b3a1457c42298$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $bd7b3a1457c42298$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $bd7b3a1457c42298$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $bd7b3a1457c42298$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($bd7b3a1457c42298$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $bd7b3a1457c42298$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $bd7b3a1457c42298$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $bd7b3a1457c42298$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $bd7b3a1457c42298$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $bd7b3a1457c42298$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $bd7b3a1457c42298$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $bd7b3a1457c42298$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $bd7b3a1457c42298$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $bd7b3a1457c42298$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $bd7b3a1457c42298$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $azcHm._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $bd7b3a1457c42298$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $bd7b3a1457c42298$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $bd7b3a1457c42298$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $azcHm._)({}, $bd7b3a1457c42298$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $bd7b3a1457c42298$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $bd7b3a1457c42298$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $bd7b3a1457c42298$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $bd7b3a1457c42298$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        actionMatch = $bd7b3a1457c42298$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $bd7b3a1457c42298$var$ResultType.error,
                            error: $bd7b3a1457c42298$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $bd7b3a1457c42298$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$bd7b3a1457c42298$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($bd7b3a1457c42298$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $bd7b3a1457c42298$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $bd7b3a1457c42298$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $azcHm._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($bd7b3a1457c42298$var$isDeferredResult(result)) throw $bd7b3a1457c42298$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $azcHm._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $bd7b3a1457c42298$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $bd7b3a1457c42298$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $3tDj3._)($bd7b3a1457c42298$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $bd7b3a1457c42298$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $bd7b3a1457c42298$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($bd7b3a1457c42298$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $bd7b3a1457c42298$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $bd7b3a1457c42298$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, $3tDj3._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, $3tDj3._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, $azcHm._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $bd7b3a1457c42298$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $bd7b3a1457c42298$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $bd7b3a1457c42298$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $bd7b3a1457c42298$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $bd7b3a1457c42298$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $bd7b3a1457c42298$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $bd7b3a1457c42298$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, flushSync, submission) {
            var error, existingFetcher, abortController, fetchRequest, originatingLoadId, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $bd7b3a1457c42298$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $bd7b3a1457c42298$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $bd7b3a1457c42298$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $bd7b3a1457c42298$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($bd7b3a1457c42298$var$isRedirectResult(actionResult) || $bd7b3a1457c42298$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $bd7b3a1457c42298$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($bd7b3a1457c42298$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $bd7b3a1457c42298$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $bd7b3a1457c42298$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(state, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($bd7b3a1457c42298$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($bd7b3a1457c42298$var$isDeferredResult(actionResult)) throw $bd7b3a1457c42298$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $bd7b3a1457c42298$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $bd7b3a1457c42298$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $bd7b3a1457c42298$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $bd7b3a1457c42298$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $3tDj3._)($bd7b3a1457c42298$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $azcHm._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $bd7b3a1457c42298$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $bd7b3a1457c42298$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $bd7b3a1457c42298$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $bd7b3a1457c42298$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $bd7b3a1457c42298$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $bd7b3a1457c42298$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(key, routeId, path, match, matches, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, originatingLoadId, result;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $bd7b3a1457c42298$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $bd7b3a1457c42298$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $bd7b3a1457c42298$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$bd7b3a1457c42298$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $bd7b3a1457c42298$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $bd7b3a1457c42298$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$bd7b3a1457c42298$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $bd7b3a1457c42298$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($bd7b3a1457c42298$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $bd7b3a1457c42298$export$3e9cee6b33872309(!$bd7b3a1457c42298$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $bd7b3a1457c42298$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(state, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $bd7b3a1457c42298$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $bd7b3a1457c42298$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($bd7b3a1457c42298$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $bd7b3a1457c42298$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $bd7b3a1457c42298$export$e19cd5f9376f8cee.Replace : $bd7b3a1457c42298$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $bd7b3a1457c42298$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($bd7b3a1457c42298$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $bd7b3a1457c42298$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $bd7b3a1457c42298$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $bd7b3a1457c42298$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $1UA6e._)(matchesToLoad.map(function(match) {
                                return $bd7b3a1457c42298$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                            })).concat((0, $1UA6e._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $bd7b3a1457c42298$var$callLoaderOrAction("loader", $bd7b3a1457c42298$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                                else {
                                    var error = {
                                        type: $bd7b3a1457c42298$var$ResultType.error,
                                        error: $bd7b3a1457c42298$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $bd7b3a1457c42298$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $bd7b3a1457c42298$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $1UA6e._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $bd7b3a1457c42298$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $azcHm._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $bd7b3a1457c42298$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $bd7b3a1457c42298$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $bd7b3a1457c42298$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $bd7b3a1457c42298$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $bd7b3a1457c42298$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $bd7b3a1457c42298$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $bd7b3a1457c42298$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $bd7b3a1457c42298$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $bd7b3a1457c42298$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $3tDj3._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $bd7b3a1457c42298$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $bd7b3a1457c42298$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $bd7b3a1457c42298$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $bd7b3a1457c42298$export$4d0306f8f6a4585b = Symbol("deferred");
function $bd7b3a1457c42298$export$3336b097a6fbc59a(routes, opts) {
    $bd7b3a1457c42298$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $bd7b3a1457c42298$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $bd7b3a1457c42298$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $bd7b3a1457c42298$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, _temp3) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp3 === void 0 ? {} : _temp3).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $bd7b3a1457c42298$var$createLocation("", $bd7b3a1457c42298$export$fe53371bee54353d(url), null, "default");
                        matches = $bd7b3a1457c42298$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$bd7b3a1457c42298$var$isValidMethod(method) && method !== "HEAD") {
                            error = $bd7b3a1457c42298$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $bd7b3a1457c42298$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $azcHm._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $bd7b3a1457c42298$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $bd7b3a1457c42298$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $azcHm._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($bd7b3a1457c42298$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $bd7b3a1457c42298$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, _temp4) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $bd7b3a1457c42298$var$createLocation("", $bd7b3a1457c42298$export$fe53371bee54353d(url), null, "default");
                        matches = $bd7b3a1457c42298$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$bd7b3a1457c42298$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $bd7b3a1457c42298$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $bd7b3a1457c42298$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $bd7b3a1457c42298$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $bd7b3a1457c42298$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $bd7b3a1457c42298$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($bd7b3a1457c42298$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$bd7b3a1457c42298$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $bd7b3a1457c42298$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$bd7b3a1457c42298$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $bd7b3a1457c42298$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $bd7b3a1457c42298$var$isResponse(result1) ? result1 : $bd7b3a1457c42298$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($bd7b3a1457c42298$var$isQueryRouteResponse(e)) {
                            if (e.type === $bd7b3a1457c42298$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($bd7b3a1457c42298$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $bd7b3a1457c42298$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $bd7b3a1457c42298$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $bd7b3a1457c42298$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) $bd7b3a1457c42298$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($bd7b3a1457c42298$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($bd7b3a1457c42298$var$isDeferredResult(result)) {
                            error1 = $bd7b3a1457c42298$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $bd7b3a1457c42298$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($bd7b3a1457c42298$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $azcHm._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$bd7b3a1457c42298$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $bd7b3a1457c42298$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $azcHm._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $bd7b3a1457c42298$var$_extends({}, context, {
                                statusCode: $bd7b3a1457c42298$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $bd7b3a1457c42298$var$_extends({}, result.headers ? (0, $azcHm._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $bd7b3a1457c42298$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $azcHm._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $bd7b3a1457c42298$var$_extends({}, result.headers ? (0, $azcHm._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $bd7b3a1457c42298$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $bd7b3a1457c42298$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $azcHm._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $1UA6e._)(matchesToLoad.map(function(match) {
                                return $bd7b3a1457c42298$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $bd7b3a1457c42298$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $bd7b3a1457c42298$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $bd7b3a1457c42298$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $bd7b3a1457c42298$export$fec11da027c70692(routes, context, error) {
    var newContext = $bd7b3a1457c42298$var$_extends({}, context, {
        statusCode: $bd7b3a1457c42298$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $azcHm._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $bd7b3a1457c42298$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $bd7b3a1457c42298$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $bd7b3a1457c42298$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $bd7b3a1457c42298$export$cae722b0cc860f13(to ? to : ".", $bd7b3a1457c42298$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $bd7b3a1457c42298$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$bd7b3a1457c42298$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $bd7b3a1457c42298$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $bd7b3a1457c42298$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $bd7b3a1457c42298$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$bd7b3a1457c42298$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$bd7b3a1457c42298$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $bd7b3a1457c42298$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $bd7b3a1457c42298$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $bd7b3a1457c42298$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$bd7b3a1457c42298$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, $3tDj3._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$bd7b3a1457c42298$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $bd7b3a1457c42298$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $bd7b3a1457c42298$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $bd7b3a1457c42298$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $bd7b3a1457c42298$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $bd7b3a1457c42298$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($bd7b3a1457c42298$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $bd7b3a1457c42298$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $bd7b3a1457c42298$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $bd7b3a1457c42298$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $bd7b3a1457c42298$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $bd7b3a1457c42298$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $bd7b3a1457c42298$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($bd7b3a1457c42298$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $bd7b3a1457c42298$var$shouldRevalidateLoader(match, $bd7b3a1457c42298$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $bd7b3a1457c42298$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $bd7b3a1457c42298$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $bd7b3a1457c42298$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $bd7b3a1457c42298$var$shouldRevalidateLoader(fetcherMatch, $bd7b3a1457c42298$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $bd7b3a1457c42298$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $bd7b3a1457c42298$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $bd7b3a1457c42298$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $bd7b3a1457c42298$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $bd7b3a1457c42298$var$_loadLazyRouteModule.apply(this, arguments);
}
function $bd7b3a1457c42298$var$_loadLazyRouteModule() {
    $bd7b3a1457c42298$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $bd7b3a1457c42298$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $bd7b3a1457c42298$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$bd7b3a1457c42298$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $bd7b3a1457c42298$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $bd7b3a1457c42298$var$_loadLazyRouteModule.apply(this, arguments);
}
function $bd7b3a1457c42298$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    return $bd7b3a1457c42298$var$_callLoaderOrAction.apply(this, arguments);
}
function $bd7b3a1457c42298$var$_callLoaderOrAction() {
    $bd7b3a1457c42298$var$_callLoaderOrAction = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, e1, _result$init, _result$init2;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $bd7b3a1457c42298$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $bd7b3a1457c42298$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $bd7b3a1457c42298$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $bd7b3a1457c42298$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $bd7b3a1457c42298$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $bd7b3a1457c42298$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $bd7b3a1457c42298$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$bd7b3a1457c42298$var$isResponse(result)) return [
                        3,
                        24
                    ];
                    status = result.status;
                    // Process redirects
                    if ($bd7b3a1457c42298$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $bd7b3a1457c42298$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$bd7b3a1457c42298$var$ABSOLUTE_URL_REGEX.test(location)) location = $bd7b3a1457c42298$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $bd7b3a1457c42298$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $bd7b3a1457c42298$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $bd7b3a1457c42298$var$ResultType.error ? $bd7b3a1457c42298$var$ResultType.error : $bd7b3a1457c42298$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    _state.label = 15;
                case 15:
                    _state.trys.push([
                        15,
                        22,
                        ,
                        23
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        19
                    ];
                    if (!(result.body == null)) return [
                        3,
                        16
                    ];
                    data = null;
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.json()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    return [
                        4,
                        result.text()
                    ];
                case 20:
                    data = _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        3,
                        23
                    ];
                case 22:
                    e1 = _state.sent();
                    return [
                        2,
                        {
                            type: $bd7b3a1457c42298$var$ResultType.error,
                            error: e1
                        }
                    ];
                case 23:
                    if (resultType === $bd7b3a1457c42298$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $bd7b3a1457c42298$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $bd7b3a1457c42298$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 24:
                    if (resultType === $bd7b3a1457c42298$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($bd7b3a1457c42298$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $bd7b3a1457c42298$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $bd7b3a1457c42298$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $bd7b3a1457c42298$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $bd7b3a1457c42298$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($bd7b3a1457c42298$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $bd7b3a1457c42298$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $bd7b3a1457c42298$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $bd7b3a1457c42298$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $bd7b3a1457c42298$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $bd7b3a1457c42298$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $bd7b3a1457c42298$export$3e9cee6b33872309(!$bd7b3a1457c42298$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($bd7b3a1457c42298$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $bd7b3a1457c42298$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $bd7b3a1457c42298$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($bd7b3a1457c42298$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $bd7b3a1457c42298$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $bd7b3a1457c42298$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $bd7b3a1457c42298$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($bd7b3a1457c42298$var$isErrorResult(result)) {
            var boundaryMatch = $bd7b3a1457c42298$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $bd7b3a1457c42298$var$_extends({}, errors, (0, $azcHm._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($bd7b3a1457c42298$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $bd7b3a1457c42298$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($bd7b3a1457c42298$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $bd7b3a1457c42298$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $bd7b3a1457c42298$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $bd7b3a1457c42298$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $bd7b3a1457c42298$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $bd7b3a1457c42298$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $1UA6e._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $bd7b3a1457c42298$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $bd7b3a1457c42298$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $bd7b3a1457c42298$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $bd7b3a1457c42298$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($bd7b3a1457c42298$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $bd7b3a1457c42298$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(path) : path;
    return $bd7b3a1457c42298$export$fe53371bee54353d($bd7b3a1457c42298$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $bd7b3a1457c42298$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $bd7b3a1457c42298$var$isDeferredResult(result) {
    return result.type === $bd7b3a1457c42298$var$ResultType.deferred;
}
function $bd7b3a1457c42298$var$isErrorResult(result) {
    return result.type === $bd7b3a1457c42298$var$ResultType.error;
}
function $bd7b3a1457c42298$var$isRedirectResult(result) {
    return (result && result.type) === $bd7b3a1457c42298$var$ResultType.redirect;
}
function $bd7b3a1457c42298$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $bd7b3a1457c42298$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $bd7b3a1457c42298$var$isRedirectResponse(result) {
    if (!$bd7b3a1457c42298$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $bd7b3a1457c42298$var$isQueryRouteResponse(obj) {
    return obj && $bd7b3a1457c42298$var$isResponse(obj.response) && (obj.type === $bd7b3a1457c42298$var$ResultType.data || obj.type === $bd7b3a1457c42298$var$ResultType.error);
}
function $bd7b3a1457c42298$var$isValidMethod(method) {
    return $bd7b3a1457c42298$var$validRequestMethods.has(method.toLowerCase());
}
function $bd7b3a1457c42298$var$isMutationMethod(method) {
    return $bd7b3a1457c42298$var$validMutationMethods.has(method.toLowerCase());
}
function $bd7b3a1457c42298$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $bd7b3a1457c42298$var$_resolveDeferredResults.apply(this, arguments);
}
function $bd7b3a1457c42298$var$_resolveDeferredResults() {
    $bd7b3a1457c42298$var$_resolveDeferredResults = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$bd7b3a1457c42298$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($bd7b3a1457c42298$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $bd7b3a1457c42298$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $bd7b3a1457c42298$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $75cbc07a4214bd1d$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $bd7b3a1457c42298$var$_resolveDeferredResults.apply(this, arguments);
}
function $bd7b3a1457c42298$var$resolveDeferredData(result, signal, unwrap) {
    return $bd7b3a1457c42298$var$_resolveDeferredData.apply(this, arguments);
}
function $bd7b3a1457c42298$var$_resolveDeferredData() {
    $bd7b3a1457c42298$var$_resolveDeferredData = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $bd7b3a1457c42298$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $bd7b3a1457c42298$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $bd7b3a1457c42298$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $bd7b3a1457c42298$var$_resolveDeferredData.apply(this, arguments);
}
function $bd7b3a1457c42298$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $bd7b3a1457c42298$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $bd7b3a1457c42298$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $bd7b3a1457c42298$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $bd7b3a1457c42298$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $bd7b3a1457c42298$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $bd7b3a1457c42298$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $bd7b3a1457c42298$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $bd7b3a1457c42298$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $bd7b3a1457c42298$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $bd7b3a1457c42298$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $bd7b3a1457c42298$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($bd7b3a1457c42298$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $3tDj3._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $bd7b3a1457c42298$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $3tDj3._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $1UA6e._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($bd7b3a1457c42298$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $bd7b3a1457c42298$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $9Hju1 = parcelRequire("9Hju1");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $hCdf1 = parcelRequire("hCdf1");

var $lcrTp = parcelRequire("lcrTp");

function $e3ffdf28351c8739$var$_extends() {
    $e3ffdf28351c8739$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e3ffdf28351c8739$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $e3ffdf28351c8739$export$3add0d5dce533e2e = /*#__PURE__*/ $lcrTp.createContext(null);
var $e3ffdf28351c8739$export$145dfa71566a64dc = /*#__PURE__*/ $lcrTp.createContext(null);
var $e3ffdf28351c8739$var$AwaitContext = /*#__PURE__*/ $lcrTp.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $e3ffdf28351c8739$export$26749e8557646306 = /*#__PURE__*/ $lcrTp.createContext(null);
var $e3ffdf28351c8739$export$c7914228fb69b0f5 = /*#__PURE__*/ $lcrTp.createContext(null);
var $e3ffdf28351c8739$export$9072aa6dd1f93057 = /*#__PURE__*/ $lcrTp.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $e3ffdf28351c8739$var$RouteErrorContext = /*#__PURE__*/ $lcrTp.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $e3ffdf28351c8739$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var _React_useContext = $lcrTp.useContext($e3ffdf28351c8739$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $e3ffdf28351c8739$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bd7b3a1457c42298$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $e3ffdf28351c8739$export$9c954a9d03d32f4a() {
    return $lcrTp.useContext($e3ffdf28351c8739$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $e3ffdf28351c8739$export$45d76561a5302f2b() {
    !$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return $lcrTp.useContext($e3ffdf28351c8739$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $e3ffdf28351c8739$export$1b3f31771c5d07c() {
    return $lcrTp.useContext($e3ffdf28351c8739$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $e3ffdf28351c8739$export$6c330e8992e8a295(pattern) {
    !$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var pathname = $e3ffdf28351c8739$export$45d76561a5302f2b().pathname;
    return $lcrTp.useMemo(function() {
        return (0, $bd7b3a1457c42298$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $e3ffdf28351c8739$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $e3ffdf28351c8739$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $lcrTp.useContext($e3ffdf28351c8739$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lcrTp.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $e3ffdf28351c8739$export$9770f232ac06a008() {
    var isDataRoute = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $e3ffdf28351c8739$var$useNavigateStable() : $e3ffdf28351c8739$var$useNavigateUnstable();
}
function $e3ffdf28351c8739$var$useNavigateUnstable() {
    !$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var dataRouterContext = $lcrTp.useContext($e3ffdf28351c8739$export$3add0d5dce533e2e);
    var _React_useContext = $lcrTp.useContext($e3ffdf28351c8739$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057).matches;
    var _useLocation = $e3ffdf28351c8739$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $bd7b3a1457c42298$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $lcrTp.useRef(false);
    $e3ffdf28351c8739$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $lcrTp.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $bd7b3a1457c42298$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bd7b3a1457c42298$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $e3ffdf28351c8739$var$OutletContext = /*#__PURE__*/ $lcrTp.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $e3ffdf28351c8739$export$4138103a3ae699cc() {
    return $lcrTp.useContext($e3ffdf28351c8739$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $e3ffdf28351c8739$export$a3be3530d8e40d0b(context) {
    var outlet = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $e3ffdf28351c8739$export$99eaa27ddbbb95ef() {
    var matches = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $e3ffdf28351c8739$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $lcrTp.useContext($e3ffdf28351c8739$export$26749e8557646306).future;
    var matches = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057).matches;
    var _useLocation = $e3ffdf28351c8739$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $bd7b3a1457c42298$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $lcrTp.useMemo(function() {
        return (0, $bd7b3a1457c42298$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $e3ffdf28351c8739$export$5d3fca4a98652595(routes, locationArg) {
    return $e3ffdf28351c8739$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $e3ffdf28351c8739$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var navigator = $lcrTp.useContext($e3ffdf28351c8739$export$26749e8557646306).navigator;
    var _React_useContext = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $e3ffdf28351c8739$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $bd7b3a1457c42298$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $bd7b3a1457c42298$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $e3ffdf28351c8739$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bd7b3a1457c42298$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bd7b3a1457c42298$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $e3ffdf28351c8739$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bd7b3a1457c42298$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $e3ffdf28351c8739$var$DefaultErrorComponent() {
    var error = $e3ffdf28351c8739$export$ed527bf60f6e05f2();
    var message = (0, $bd7b3a1457c42298$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $lcrTp.createElement($lcrTp.Fragment, null, /*#__PURE__*/ $lcrTp.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lcrTp.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lcrTp.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $e3ffdf28351c8739$var$defaultErrorElement = /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$DefaultErrorComponent, null);
var $e3ffdf28351c8739$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $9Hju1._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $hCdf1._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $lfBxf._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $9tzan._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($lcrTp.Component);
function $e3ffdf28351c8739$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $lcrTp.useContext($e3ffdf28351c8739$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $e3ffdf28351c8739$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $e3ffdf28351c8739$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $e3ffdf28351c8739$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lcrTp.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $e3ffdf28351c8739$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($e3ffdf28351c8739$var$DataRouterHook || {});
var $e3ffdf28351c8739$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($e3ffdf28351c8739$var$DataRouterStateHook || {});
function $e3ffdf28351c8739$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $e3ffdf28351c8739$var$useDataRouterContext(hookName) {
    var ctx = $lcrTp.useContext($e3ffdf28351c8739$export$3add0d5dce533e2e);
    !ctx && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e3ffdf28351c8739$var$useDataRouterState(hookName) {
    var state = $lcrTp.useContext($e3ffdf28351c8739$export$145dfa71566a64dc);
    !state && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return state;
}
function $e3ffdf28351c8739$var$useRouteContext(hookName) {
    var route = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057);
    !route && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $e3ffdf28351c8739$var$useCurrentRouteId(hookName) {
    var route = $e3ffdf28351c8739$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $e3ffdf28351c8739$export$5fc8298006ad9e58() {
    return $e3ffdf28351c8739$var$useCurrentRouteId($e3ffdf28351c8739$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $e3ffdf28351c8739$export$d0fd4b7106de2769() {
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $e3ffdf28351c8739$export$600dc272ed516c15() {
    var dataRouterContext = $e3ffdf28351c8739$var$useDataRouterContext($e3ffdf28351c8739$var$DataRouterHook.UseRevalidator);
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseRevalidator);
    return $lcrTp.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $e3ffdf28351c8739$export$2378eb7f5ff86053() {
    var _useDataRouterState = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $lcrTp.useMemo(function() {
        return matches.map(function(m) {
            return (0, $bd7b3a1457c42298$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $e3ffdf28351c8739$export$1448a5050d252c4d() {
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseLoaderData);
    var routeId = $e3ffdf28351c8739$var$useCurrentRouteId($e3ffdf28351c8739$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $e3ffdf28351c8739$export$fd5d37484eab868d(routeId) {
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $e3ffdf28351c8739$export$fdc00f3f26066d5e() {
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseActionData);
    var routeId = $e3ffdf28351c8739$var$useCurrentRouteId($e3ffdf28351c8739$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $e3ffdf28351c8739$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $lcrTp.useContext($e3ffdf28351c8739$var$RouteErrorContext);
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseRouteError);
    var routeId = $e3ffdf28351c8739$var$useCurrentRouteId($e3ffdf28351c8739$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $e3ffdf28351c8739$export$78a72ddb39bdd145() {
    var value = $lcrTp.useContext($e3ffdf28351c8739$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $e3ffdf28351c8739$export$17f53340677d5831() {
    var value = $lcrTp.useContext($e3ffdf28351c8739$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $e3ffdf28351c8739$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $e3ffdf28351c8739$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $e3ffdf28351c8739$var$useDataRouterContext($e3ffdf28351c8739$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $e3ffdf28351c8739$var$useDataRouterState($e3ffdf28351c8739$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $3tDj3._)($lcrTp.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $lcrTp.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $e3ffdf28351c8739$var$_extends({}, currentLocation, {
                pathname: (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $e3ffdf28351c8739$var$_extends({}, nextLocation, {
                pathname: (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lcrTp.useEffect(function() {
        var key = String(++$e3ffdf28351c8739$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lcrTp.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $bd7b3a1457c42298$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $e3ffdf28351c8739$var$useNavigateStable() {
    var router = $e3ffdf28351c8739$var$useDataRouterContext($e3ffdf28351c8739$var$DataRouterHook.UseNavigateStable).router;
    var id = $e3ffdf28351c8739$var$useCurrentRouteId($e3ffdf28351c8739$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $lcrTp.useRef(false);
    $e3ffdf28351c8739$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $lcrTp.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $e3ffdf28351c8739$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $e3ffdf28351c8739$var$alreadyWarned = {};
function $e3ffdf28351c8739$var$warningOnce(key, cond, message) {
    if (!cond && !$e3ffdf28351c8739$var$alreadyWarned[key]) $e3ffdf28351c8739$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $e3ffdf28351c8739$var$START_TRANSITION = "startTransition";
var $e3ffdf28351c8739$var$startTransitionImpl = $lcrTp[$e3ffdf28351c8739$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e3ffdf28351c8739$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $3tDj3._)($lcrTp.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $lcrTp.useCallback(function(newState) {
        if (v7_startTransition && $e3ffdf28351c8739$var$startTransitionImpl) $e3ffdf28351c8739$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lcrTp.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $lcrTp.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $lcrTp.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $lcrTp.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lcrTp.createElement($lcrTp.Fragment, null, /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $e3ffdf28351c8739$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $e3ffdf28351c8739$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $e3ffdf28351c8739$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $lcrTp.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bd7b3a1457c42298$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $3tDj3._)($lcrTp.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $lcrTp.useCallback(function(newState) {
        v7_startTransition && $e3ffdf28351c8739$var$startTransitionImpl ? $e3ffdf28351c8739$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lcrTp.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $e3ffdf28351c8739$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var _React_useContext = $lcrTp.useContext($e3ffdf28351c8739$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $lcrTp.useContext($e3ffdf28351c8739$export$9072aa6dd1f93057).matches;
    var _useLocation = $e3ffdf28351c8739$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $e3ffdf28351c8739$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $bd7b3a1457c42298$export$cae722b0cc860f13)(to, (0, $bd7b3a1457c42298$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $lcrTp.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $e3ffdf28351c8739$export$910ae8079b2c2852(props) {
    return $e3ffdf28351c8739$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $e3ffdf28351c8739$export$e7b0ac011bb776c6(_props) {
    (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $e3ffdf28351c8739$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $bd7b3a1457c42298$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$e3ffdf28351c8739$export$9c954a9d03d32f4a() && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $lcrTp.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $e3ffdf28351c8739$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bd7b3a1457c42298$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $lcrTp.useMemo(function() {
        var trailingPathname = (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $e3ffdf28351c8739$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $e3ffdf28351c8739$export$5d3fca4a98652595($e3ffdf28351c8739$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $e3ffdf28351c8739$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$ResolveAwait, null, children));
}
var $e3ffdf28351c8739$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($e3ffdf28351c8739$var$AwaitRenderStatus || {});
var $e3ffdf28351c8739$var$neverSettledPromise = new Promise(function() {});
var $e3ffdf28351c8739$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $9Hju1._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $hCdf1._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $lfBxf._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $9tzan._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $e3ffdf28351c8739$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $e3ffdf28351c8739$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $e3ffdf28351c8739$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $e3ffdf28351c8739$var$AwaitRenderStatus.error : promise._data !== undefined ? $e3ffdf28351c8739$var$AwaitRenderStatus.success : $e3ffdf28351c8739$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $e3ffdf28351c8739$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $e3ffdf28351c8739$var$AwaitRenderStatus.error && promise._error instanceof (0, $bd7b3a1457c42298$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $e3ffdf28351c8739$var$neverSettledPromise;
                if (status === $e3ffdf28351c8739$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $e3ffdf28351c8739$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $e3ffdf28351c8739$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $lcrTp.createElement($e3ffdf28351c8739$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($lcrTp.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $e3ffdf28351c8739$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $e3ffdf28351c8739$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lcrTp.createElement($lcrTp.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $e3ffdf28351c8739$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $lcrTp.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $lcrTp.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $1UA6e._)(parentPath).concat([
            index
        ]);
        if (element.type === $lcrTp.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $e3ffdf28351c8739$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $e3ffdf28351c8739$export$e7b0ac011bb776c6) && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $e3ffdf28351c8739$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $e3ffdf28351c8739$export$daf73786167a7f72(matches) {
    return $e3ffdf28351c8739$var$_renderMatches(matches);
}
function $e3ffdf28351c8739$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lcrTp.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $lcrTp.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lcrTp.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $e3ffdf28351c8739$export$f30f7e456d254e83(routes, opts) {
    return (0, $bd7b3a1457c42298$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e3ffdf28351c8739$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bd7b3a1457c42298$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $e3ffdf28351c8739$export$52b333d321859367
    }).initialize();
}



function $04fc80922e1b6460$var$_extends() {
    $04fc80922e1b6460$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04fc80922e1b6460$var$_extends.apply(this, arguments);
}
function $04fc80922e1b6460$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $04fc80922e1b6460$var$defaultMethod = "get";
var $04fc80922e1b6460$var$defaultEncType = "application/x-www-form-urlencoded";
function $04fc80922e1b6460$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $04fc80922e1b6460$var$isButtonElement(object) {
    return $04fc80922e1b6460$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $04fc80922e1b6460$var$isFormElement(object) {
    return $04fc80922e1b6460$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $04fc80922e1b6460$var$isInputElement(object) {
    return $04fc80922e1b6460$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $04fc80922e1b6460$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $04fc80922e1b6460$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$04fc80922e1b6460$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $04fc80922e1b6460$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $04fc80922e1b6460$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $04fc80922e1b6460$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $04fc80922e1b6460$var$_formDataSupportsSubmitter = null;
function $04fc80922e1b6460$var$isFormDataSubmitterSupported() {
    if ($04fc80922e1b6460$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $04fc80922e1b6460$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $04fc80922e1b6460$var$_formDataSupportsSubmitter = true;
    }
    return $04fc80922e1b6460$var$_formDataSupportsSubmitter;
}
var $04fc80922e1b6460$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $04fc80922e1b6460$var$getFormEncType(encType) {
    if (encType != null && !$04fc80922e1b6460$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $04fc80922e1b6460$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($04fc80922e1b6460$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $04fc80922e1b6460$var$defaultMethod;
        encType = $04fc80922e1b6460$var$getFormEncType(target.getAttribute("enctype")) || $04fc80922e1b6460$var$defaultEncType;
        formData = new FormData(target);
    } else if ($04fc80922e1b6460$var$isButtonElement(target) || $04fc80922e1b6460$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $04fc80922e1b6460$var$defaultMethod;
        encType = $04fc80922e1b6460$var$getFormEncType(target.getAttribute("formenctype")) || $04fc80922e1b6460$var$getFormEncType(form.getAttribute("enctype")) || $04fc80922e1b6460$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$04fc80922e1b6460$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($04fc80922e1b6460$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $04fc80922e1b6460$var$defaultMethod;
        action = null;
        encType = $04fc80922e1b6460$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $04fc80922e1b6460$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $04fc80922e1b6460$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $04fc80922e1b6460$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $04fc80922e1b6460$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $04fc80922e1b6460$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $04fc80922e1b6460$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bd7b3a1457c42298$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $04fc80922e1b6460$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bd7b3a1457c42298$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $04fc80922e1b6460$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e3ffdf28351c8739$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $04fc80922e1b6460$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bd7b3a1457c42298$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $04fc80922e1b6460$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bd7b3a1457c42298$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $04fc80922e1b6460$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e3ffdf28351c8739$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $04fc80922e1b6460$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $04fc80922e1b6460$var$_extends({}, state, {
        errors: $04fc80922e1b6460$var$deserializeErrors(state.errors)
    });
    return state;
}
function $04fc80922e1b6460$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bd7b3a1457c42298$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $04fc80922e1b6460$export$7ad602f0e94e62d1 = /*#__PURE__*/ $lcrTp.createContext({
    isTransitioning: false
});
var $04fc80922e1b6460$export$148fd98d095596d4 = /*#__PURE__*/ $lcrTp.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $04fc80922e1b6460$var$START_TRANSITION = "startTransition";
var $04fc80922e1b6460$var$startTransitionImpl = $lcrTp[$04fc80922e1b6460$var$START_TRANSITION];
var $04fc80922e1b6460$var$FLUSH_SYNC = "flushSync";
var $04fc80922e1b6460$var$flushSyncImpl = $33a5ccd44dbd30cb$exports[$04fc80922e1b6460$var$FLUSH_SYNC];
var $04fc80922e1b6460$var$USE_ID = "useId";
var $04fc80922e1b6460$var$useIdImpl = $lcrTp[$04fc80922e1b6460$var$USE_ID];
function $04fc80922e1b6460$var$startTransitionSafe(cb) {
    if ($04fc80922e1b6460$var$startTransitionImpl) $04fc80922e1b6460$var$startTransitionImpl(cb);
    else cb();
}
function $04fc80922e1b6460$var$flushSyncSafe(cb) {
    if ($04fc80922e1b6460$var$flushSyncImpl) $04fc80922e1b6460$var$flushSyncImpl(cb);
    else cb();
}
var $04fc80922e1b6460$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $lfBxf._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $04fc80922e1b6460$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $3tDj3._)($lcrTp.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $3tDj3._)($lcrTp.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $3tDj3._)($lcrTp.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $3tDj3._)($lcrTp.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $3tDj3._)($lcrTp.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $3tDj3._)($lcrTp.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $lcrTp.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $lcrTp.useCallback(function(cb) {
        if (v7_startTransition) $04fc80922e1b6460$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $lcrTp.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $04fc80922e1b6460$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $04fc80922e1b6460$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $04fc80922e1b6460$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $04fc80922e1b6460$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $04fc80922e1b6460$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lcrTp.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $lcrTp.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $04fc80922e1b6460$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $lcrTp.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $lcrTp.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $lcrTp.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $lcrTp.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $lcrTp.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $lcrTp.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lcrTp.createElement($lcrTp.Fragment, null, /*#__PURE__*/ $lcrTp.createElement((0, $e3ffdf28351c8739$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lcrTp.createElement((0, $e3ffdf28351c8739$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $lcrTp.createElement($04fc80922e1b6460$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $lcrTp.createElement($04fc80922e1b6460$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $lcrTp.createElement((0, $e3ffdf28351c8739$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lcrTp.createElement($04fc80922e1b6460$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $04fc80922e1b6460$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $e3ffdf28351c8739$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $04fc80922e1b6460$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $lcrTp.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bd7b3a1457c42298$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $3tDj3._)($lcrTp.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $lcrTp.useCallback(function(newState) {
        v7_startTransition && $04fc80922e1b6460$var$startTransitionImpl ? $04fc80922e1b6460$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lcrTp.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lcrTp.createElement((0, $e3ffdf28351c8739$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $04fc80922e1b6460$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $lcrTp.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bd7b3a1457c42298$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $3tDj3._)($lcrTp.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $lcrTp.useCallback(function(newState) {
        v7_startTransition && $04fc80922e1b6460$var$startTransitionImpl ? $04fc80922e1b6460$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lcrTp.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lcrTp.createElement((0, $e3ffdf28351c8739$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $04fc80922e1b6460$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $3tDj3._)($lcrTp.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $lcrTp.useCallback(function(newState) {
        v7_startTransition && $04fc80922e1b6460$var$startTransitionImpl ? $04fc80922e1b6460$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lcrTp.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lcrTp.createElement((0, $e3ffdf28351c8739$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $04fc80922e1b6460$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $04fc80922e1b6460$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $04fc80922e1b6460$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lcrTp.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $04fc80922e1b6460$var$_objectWithoutPropertiesLoose(_ref7, $04fc80922e1b6460$var$_excluded);
    var basename = $lcrTp.useContext((0, $e3ffdf28351c8739$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $04fc80922e1b6460$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($04fc80922e1b6460$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $e3ffdf28351c8739$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $04fc80922e1b6460$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lcrTp.createElement("a", $04fc80922e1b6460$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $04fc80922e1b6460$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lcrTp.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $04fc80922e1b6460$var$_objectWithoutPropertiesLoose(_ref8, $04fc80922e1b6460$var$_excluded2);
    var path = (0, $e3ffdf28351c8739$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $e3ffdf28351c8739$export$45d76561a5302f2b)();
    var routerState = $lcrTp.useContext((0, $e3ffdf28351c8739$export$145dfa71566a64dc));
    var _React_useContext = $lcrTp.useContext((0, $e3ffdf28351c8739$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $04fc80922e1b6460$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $lcrTp.createElement($04fc80922e1b6460$export$a6c7ac8248d6e38a, $04fc80922e1b6460$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $04fc80922e1b6460$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lcrTp.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $04fc80922e1b6460$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $04fc80922e1b6460$var$_objectWithoutPropertiesLoose(_ref9, $04fc80922e1b6460$var$_excluded3);
    var submit = $04fc80922e1b6460$export$47c85c6e3a081d3();
    var formAction = $04fc80922e1b6460$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $lcrTp.createElement("form", $04fc80922e1b6460$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $04fc80922e1b6460$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $04fc80922e1b6460$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $04fc80922e1b6460$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($04fc80922e1b6460$var$DataRouterHook || ($04fc80922e1b6460$var$DataRouterHook = {}));
var $04fc80922e1b6460$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($04fc80922e1b6460$var$DataRouterStateHook || ($04fc80922e1b6460$var$DataRouterStateHook = {}));
// Internal hooks
function $04fc80922e1b6460$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $04fc80922e1b6460$var$useDataRouterContext(hookName) {
    var ctx = $lcrTp.useContext((0, $e3ffdf28351c8739$export$3add0d5dce533e2e));
    !ctx && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return ctx;
}
function $04fc80922e1b6460$var$useDataRouterState(hookName) {
    var state = $lcrTp.useContext((0, $e3ffdf28351c8739$export$145dfa71566a64dc));
    !state && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $04fc80922e1b6460$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $e3ffdf28351c8739$export$9770f232ac06a008)();
    var location = (0, $e3ffdf28351c8739$export$45d76561a5302f2b)();
    var path = (0, $e3ffdf28351c8739$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lcrTp.useCallback(function(event) {
        if ($04fc80922e1b6460$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $bd7b3a1457c42298$export$fe53371bee54353d)(location) === (0, $bd7b3a1457c42298$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $04fc80922e1b6460$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $lcrTp.useRef($04fc80922e1b6460$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $lcrTp.useRef(false);
    var location = (0, $e3ffdf28351c8739$export$45d76561a5302f2b)();
    var searchParams = $lcrTp.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $04fc80922e1b6460$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $e3ffdf28351c8739$export$9770f232ac06a008)();
    var setSearchParams = $lcrTp.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $04fc80922e1b6460$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $04fc80922e1b6460$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $04fc80922e1b6460$var$fetcherId = 0;
var $04fc80922e1b6460$var$getUniqueFetcherId = function() {
    return "__" + String(++$04fc80922e1b6460$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $04fc80922e1b6460$export$47c85c6e3a081d3() {
    var router = $04fc80922e1b6460$var$useDataRouterContext($04fc80922e1b6460$var$DataRouterHook.UseSubmit).router;
    var basename = $lcrTp.useContext((0, $e3ffdf28351c8739$export$26749e8557646306)).basename;
    var currentRouteId = (0, $e3ffdf28351c8739$export$5fc8298006ad9e58)();
    return $lcrTp.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $04fc80922e1b6460$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $04fc80922e1b6460$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $04fc80922e1b6460$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $04fc80922e1b6460$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $lcrTp.useContext((0, $e3ffdf28351c8739$export$26749e8557646306)).basename;
    var routeContext = $lcrTp.useContext((0, $e3ffdf28351c8739$export$9072aa6dd1f93057));
    !routeContext && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $3tDj3._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $04fc80922e1b6460$var$_extends({}, (0, $e3ffdf28351c8739$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $e3ffdf28351c8739$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bd7b3a1457c42298$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $bd7b3a1457c42298$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $04fc80922e1b6460$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $04fc80922e1b6460$var$useDataRouterContext($04fc80922e1b6460$var$DataRouterHook.UseFetcher).router;
    var state = $04fc80922e1b6460$var$useDataRouterState($04fc80922e1b6460$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $lcrTp.useContext($04fc80922e1b6460$export$148fd98d095596d4);
    var route = $lcrTp.useContext((0, $e3ffdf28351c8739$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    !route && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $04fc80922e1b6460$var$useIdImpl ? $04fc80922e1b6460$var$useIdImpl() : "";
    var _React_useState = (0, $3tDj3._)($lcrTp.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($04fc80922e1b6460$var$getUniqueFetcherId());
    // Registration/cleanup
    $lcrTp.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $lcrTp.useCallback(function(href, opts) {
        !routeId && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $04fc80922e1b6460$export$47c85c6e3a081d3();
    var submit = $lcrTp.useCallback(function(target, opts) {
        submitImpl(target, $04fc80922e1b6460$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $lcrTp.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $lcrTp.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $lcrTp.createElement($04fc80922e1b6460$export$a7fed597f4b8afd8, $04fc80922e1b6460$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $bd7b3a1457c42298$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $lcrTp.useMemo(function() {
        return $04fc80922e1b6460$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $04fc80922e1b6460$export$fa996778a3a31087() {
    var state = $04fc80922e1b6460$var$useDataRouterState($04fc80922e1b6460$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $3tDj3._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $04fc80922e1b6460$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $04fc80922e1b6460$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $04fc80922e1b6460$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $04fc80922e1b6460$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $04fc80922e1b6460$var$useDataRouterContext($04fc80922e1b6460$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $04fc80922e1b6460$var$useDataRouterState($04fc80922e1b6460$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $lcrTp.useContext((0, $e3ffdf28351c8739$export$26749e8557646306)).basename;
    var location = (0, $e3ffdf28351c8739$export$45d76561a5302f2b)();
    var matches = (0, $e3ffdf28351c8739$export$2378eb7f5ff86053)();
    var navigation = (0, $e3ffdf28351c8739$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lcrTp.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $04fc80922e1b6460$var$usePageHide($lcrTp.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $04fc80922e1b6460$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $04fc80922e1b6460$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($04fc80922e1b6460$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lcrTp.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $04fc80922e1b6460$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $04fc80922e1b6460$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lcrTp.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($04fc80922e1b6460$var$_extends({}, location, {
                    pathname: (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($04fc80922e1b6460$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lcrTp.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $04fc80922e1b6460$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $lcrTp.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $04fc80922e1b6460$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $lcrTp.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $04fc80922e1b6460$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $e3ffdf28351c8739$export$b273b3273281a049)(when);
    $lcrTp.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lcrTp.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $04fc80922e1b6460$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $lcrTp.useContext($04fc80922e1b6460$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $bd7b3a1457c42298$export$3e9cee6b33872309)(false);
    var basename = $04fc80922e1b6460$var$useDataRouterContext($04fc80922e1b6460$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $e3ffdf28351c8739$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $bd7b3a1457c42298$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $bd7b3a1457c42298$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $bd7b3a1457c42298$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $3tDj3 = parcelRequire("3tDj3");

var $lcrTp = parcelRequire("lcrTp");
var $67361a66487702b6$var$useOnlineStatus = function() {
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(true), 2), status = _useState[0], setStatus = _useState[1];
    (0, $lcrTp.useEffect)(function() {
        window.addEventListener("online", function() {
            setStatus(true);
        });
        window.addEventListener("offline", function() {
            setStatus(false);
        });
    }, []);
    return status;
};
var $67361a66487702b6$export$2e2bcd8739ae039 = $67361a66487702b6$var$useOnlineStatus;



var $lcrTp = parcelRequire("lcrTp");
var $3589c1d122ad772c$var$UserContext = /*#__PURE__*/ (0, $lcrTp.createContext)({
    myName: "Default"
});
var $3589c1d122ad772c$export$2e2bcd8739ae039 = $3589c1d122ad772c$var$UserContext;



var $azcHm = parcelRequire("azcHm");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $kMImg = parcelRequire("kMImg");

var $lcrTp = parcelRequire("lcrTp");
var $47c00ebffac04673$exports = {};
"use strict";

$47c00ebffac04673$exports = (parcelRequire("1McU1"));


var $9ebbf69bd910f984$var$__defProp = Object.defineProperty;
var $9ebbf69bd910f984$var$__defProps = Object.defineProperties;
var $9ebbf69bd910f984$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9ebbf69bd910f984$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9ebbf69bd910f984$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9ebbf69bd910f984$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9ebbf69bd910f984$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $9ebbf69bd910f984$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $9ebbf69bd910f984$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($9ebbf69bd910f984$var$__hasOwnProp.call(b, prop)) $9ebbf69bd910f984$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($9ebbf69bd910f984$var$__getOwnPropSymbols) try {
        for(var _iterator = $9ebbf69bd910f984$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($9ebbf69bd910f984$var$__propIsEnum.call(b, prop)) $9ebbf69bd910f984$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $9ebbf69bd910f984$var$__spreadProps = function(a, b) {
    return $9ebbf69bd910f984$var$__defProps(a, $9ebbf69bd910f984$var$__getOwnPropDescs(b));
};
var $9ebbf69bd910f984$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($9ebbf69bd910f984$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $9ebbf69bd910f984$var$__getOwnPropSymbols) try {
        for(var _iterator = $9ebbf69bd910f984$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $9ebbf69bd910f984$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $9ebbf69bd910f984$var$React = // prettier-ignore
// @ts-ignore
"default" in $lcrTp ? $lcrTp["default"] : $lcrTp;
// src/components/Context.ts
var $9ebbf69bd910f984$var$ContextKey = Symbol.for("react-redux-context");
var $9ebbf69bd910f984$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $9ebbf69bd910f984$var$getContext() {
    var _a;
    if (!$9ebbf69bd910f984$var$React.createContext) return {};
    var contextMap = (_a = $9ebbf69bd910f984$var$gT[$9ebbf69bd910f984$var$ContextKey]) != null ? _a : $9ebbf69bd910f984$var$gT[$9ebbf69bd910f984$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($9ebbf69bd910f984$var$React.createContext);
    if (!realContext) {
        realContext = $9ebbf69bd910f984$var$React.createContext(null);
        contextMap.set($9ebbf69bd910f984$var$React.createContext, realContext);
    }
    return realContext;
}
var $9ebbf69bd910f984$export$cc80c08dc91f1c00 = /* @__PURE__ */ $9ebbf69bd910f984$var$getContext();
// src/utils/useSyncExternalStore.ts
var $9ebbf69bd910f984$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $9ebbf69bd910f984$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $9ebbf69bd910f984$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $9ebbf69bd910f984$var$React.useContext(context);
        return contextValue;
    };
}
var $9ebbf69bd910f984$var$useReduxContext = /* @__PURE__ */ $9ebbf69bd910f984$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $9ebbf69bd910f984$var$useSyncExternalStoreWithSelector = $9ebbf69bd910f984$var$notInitialized;
var $9ebbf69bd910f984$var$initializeUseSelector = function(fn) {
    $9ebbf69bd910f984$var$useSyncExternalStoreWithSelector = fn;
};
var $9ebbf69bd910f984$var$refEquality = function(a, b) {
    return a === b;
};
function $9ebbf69bd910f984$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $9ebbf69bd910f984$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $9ebbf69bd910f984$export$cc80c08dc91f1c00 ? $9ebbf69bd910f984$var$useReduxContext : $9ebbf69bd910f984$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $9ebbf69bd910f984$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $9ebbf69bd910f984$var$React.useRef(true);
        var wrappedSelector = $9ebbf69bd910f984$var$React.useCallback((0, $azcHm._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $9ebbf69bd910f984$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $9ebbf69bd910f984$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $9ebbf69bd910f984$export$2105062e25df4afe = /* @__PURE__ */ $9ebbf69bd910f984$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $9ebbf69bd910f984$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $9ebbf69bd910f984$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $9ebbf69bd910f984$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $9ebbf69bd910f984$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $9ebbf69bd910f984$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $9ebbf69bd910f984$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $9ebbf69bd910f984$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $9ebbf69bd910f984$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $9ebbf69bd910f984$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $9ebbf69bd910f984$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $9ebbf69bd910f984$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $9ebbf69bd910f984$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $9ebbf69bd910f984$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $9ebbf69bd910f984$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $9ebbf69bd910f984$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $9ebbf69bd910f984$var$ForwardRef = $9ebbf69bd910f984$var$REACT_FORWARD_REF_TYPE;
var $9ebbf69bd910f984$var$Memo = $9ebbf69bd910f984$var$REACT_MEMO_TYPE;
function $9ebbf69bd910f984$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $9ebbf69bd910f984$var$REACT_FRAGMENT_TYPE || type === $9ebbf69bd910f984$var$REACT_PROFILER_TYPE || type === $9ebbf69bd910f984$var$REACT_STRICT_MODE_TYPE || type === $9ebbf69bd910f984$var$REACT_SUSPENSE_TYPE || type === $9ebbf69bd910f984$var$REACT_SUSPENSE_LIST_TYPE || type === $9ebbf69bd910f984$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $9ebbf69bd910f984$var$REACT_LAZY_TYPE || type.$$typeof === $9ebbf69bd910f984$var$REACT_MEMO_TYPE || type.$$typeof === $9ebbf69bd910f984$var$REACT_PROVIDER_TYPE || type.$$typeof === $9ebbf69bd910f984$var$REACT_CONTEXT_TYPE || type.$$typeof === $9ebbf69bd910f984$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $9ebbf69bd910f984$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $9ebbf69bd910f984$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $9ebbf69bd910f984$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $9ebbf69bd910f984$var$REACT_FRAGMENT_TYPE:
                        case $9ebbf69bd910f984$var$REACT_PROFILER_TYPE:
                        case $9ebbf69bd910f984$var$REACT_STRICT_MODE_TYPE:
                        case $9ebbf69bd910f984$var$REACT_SUSPENSE_TYPE:
                        case $9ebbf69bd910f984$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $9ebbf69bd910f984$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $9ebbf69bd910f984$var$REACT_CONTEXT_TYPE:
                                    case $9ebbf69bd910f984$var$REACT_FORWARD_REF_TYPE:
                                    case $9ebbf69bd910f984$var$REACT_LAZY_TYPE:
                                    case $9ebbf69bd910f984$var$REACT_MEMO_TYPE:
                                    case $9ebbf69bd910f984$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $9ebbf69bd910f984$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $9ebbf69bd910f984$var$isContextConsumer(object) {
    return $9ebbf69bd910f984$var$typeOf(object) === $9ebbf69bd910f984$var$REACT_CONTEXT_TYPE;
}
function $9ebbf69bd910f984$var$isMemo(object) {
    return $9ebbf69bd910f984$var$typeOf(object) === $9ebbf69bd910f984$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $9ebbf69bd910f984$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $9ebbf69bd910f984$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $9ebbf69bd910f984$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $9ebbf69bd910f984$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $9ebbf69bd910f984$var$verify(mapStateToProps, "mapStateToProps");
    $9ebbf69bd910f984$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $9ebbf69bd910f984$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $9ebbf69bd910f984$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $9ebbf69bd910f984$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $9ebbf69bd910f984$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $9ebbf69bd910f984$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $9ebbf69bd910f984$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $1UA6e._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $9ebbf69bd910f984$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $9ebbf69bd910f984$var$verifyPlainObject(value, displayName, methodName) {
    if (!$9ebbf69bd910f984$var$isPlainObject(value)) $9ebbf69bd910f984$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $9ebbf69bd910f984$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $9ebbf69bd910f984$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $9ebbf69bd910f984$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $9ebbf69bd910f984$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $9ebbf69bd910f984$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $9ebbf69bd910f984$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $kMImg._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $9ebbf69bd910f984$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $9ebbf69bd910f984$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $9ebbf69bd910f984$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $9ebbf69bd910f984$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $9ebbf69bd910f984$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $9ebbf69bd910f984$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $9ebbf69bd910f984$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $9ebbf69bd910f984$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $9ebbf69bd910f984$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $9ebbf69bd910f984$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $9ebbf69bd910f984$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $9ebbf69bd910f984$var$__spreadValues($9ebbf69bd910f984$var$__spreadValues($9ebbf69bd910f984$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $9ebbf69bd910f984$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $9ebbf69bd910f984$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $9ebbf69bd910f984$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $9ebbf69bd910f984$var$wrapMergePropsFunc(mergeProps) : $9ebbf69bd910f984$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $9ebbf69bd910f984$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $9ebbf69bd910f984$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $9ebbf69bd910f984$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $9ebbf69bd910f984$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $9ebbf69bd910f984$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $9ebbf69bd910f984$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $9ebbf69bd910f984$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $9ebbf69bd910f984$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $9ebbf69bd910f984$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $9ebbf69bd910f984$var$useIsomorphicLayoutEffect = $9ebbf69bd910f984$var$canUseDOM ? $9ebbf69bd910f984$var$React.useLayoutEffect : $9ebbf69bd910f984$var$React.useEffect;
// src/utils/shallowEqual.ts
function $9ebbf69bd910f984$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $9ebbf69bd910f984$export$d36bdfa510afb180(objA, objB) {
    if ($9ebbf69bd910f984$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$9ebbf69bd910f984$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $9ebbf69bd910f984$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $9ebbf69bd910f984$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $9ebbf69bd910f984$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $9ebbf69bd910f984$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $9ebbf69bd910f984$var$_obj;
var $9ebbf69bd910f984$var$TYPE_STATICS = ($9ebbf69bd910f984$var$_obj = {}, (0, $azcHm._)($9ebbf69bd910f984$var$_obj, $9ebbf69bd910f984$var$ForwardRef, $9ebbf69bd910f984$var$FORWARD_REF_STATICS), (0, $azcHm._)($9ebbf69bd910f984$var$_obj, $9ebbf69bd910f984$var$Memo, $9ebbf69bd910f984$var$MEMO_STATICS), $9ebbf69bd910f984$var$_obj);
function $9ebbf69bd910f984$var$getStatics(component) {
    if ($9ebbf69bd910f984$var$isMemo(component)) return $9ebbf69bd910f984$var$MEMO_STATICS;
    return $9ebbf69bd910f984$var$TYPE_STATICS[component["$$typeof"]] || $9ebbf69bd910f984$var$REACT_STATICS;
}
var $9ebbf69bd910f984$var$defineProperty = Object.defineProperty;
var $9ebbf69bd910f984$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $9ebbf69bd910f984$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9ebbf69bd910f984$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9ebbf69bd910f984$var$getPrototypeOf = Object.getPrototypeOf;
var $9ebbf69bd910f984$var$objectPrototype = Object.prototype;
function $9ebbf69bd910f984$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($9ebbf69bd910f984$var$objectPrototype) {
            var inheritedComponent = $9ebbf69bd910f984$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $9ebbf69bd910f984$var$objectPrototype) $9ebbf69bd910f984$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $9ebbf69bd910f984$var$getOwnPropertyNames(sourceComponent);
        if ($9ebbf69bd910f984$var$getOwnPropertySymbols) keys = keys.concat($9ebbf69bd910f984$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $9ebbf69bd910f984$var$getStatics(targetComponent);
        var sourceStatics = $9ebbf69bd910f984$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$9ebbf69bd910f984$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $9ebbf69bd910f984$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $9ebbf69bd910f984$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $9ebbf69bd910f984$var$useSyncExternalStore = $9ebbf69bd910f984$var$notInitialized;
var $9ebbf69bd910f984$var$initializeConnect = function(fn) {
    $9ebbf69bd910f984$var$useSyncExternalStore = fn;
};
var $9ebbf69bd910f984$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $9ebbf69bd910f984$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $9ebbf69bd910f984$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $9ebbf69bd910f984$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $1UA6e._)(effectArgs));
    }, dependencies);
}
function $9ebbf69bd910f984$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $9ebbf69bd910f984$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $9ebbf69bd910f984$var$strictEqual(a, b) {
    return a === b;
}
var $9ebbf69bd910f984$var$hasWarnedAboutDeprecatedPureOption = false;
function $9ebbf69bd910f984$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $9ebbf69bd910f984$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $9ebbf69bd910f984$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $9ebbf69bd910f984$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $9ebbf69bd910f984$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $9ebbf69bd910f984$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $9ebbf69bd910f984$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $9ebbf69bd910f984$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $9ebbf69bd910f984$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $3tDj3._)($9ebbf69bd910f984$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $9ebbf69bd910f984$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $9ebbf69bd910f984$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $9ebbf69bd910f984$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $9ebbf69bd910f984$var$React.useMemo(function() {
                return $9ebbf69bd910f984$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $3tDj3._)($9ebbf69bd910f984$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $9ebbf69bd910f984$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $9ebbf69bd910f984$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $9ebbf69bd910f984$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $9ebbf69bd910f984$var$__spreadProps($9ebbf69bd910f984$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $9ebbf69bd910f984$var$React.useRef();
            var lastWrapperProps = $9ebbf69bd910f984$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $9ebbf69bd910f984$var$React.useRef();
            var renderIsScheduled = $9ebbf69bd910f984$var$React.useRef(false);
            var isProcessingDispatch = $9ebbf69bd910f984$var$React.useRef(false);
            var isMounted = $9ebbf69bd910f984$var$React.useRef(false);
            var latestSubscriptionCallbackError = $9ebbf69bd910f984$var$React.useRef();
            $9ebbf69bd910f984$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $9ebbf69bd910f984$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $9ebbf69bd910f984$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $9ebbf69bd910f984$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $9ebbf69bd910f984$var$useIsomorphicLayoutEffectWithArgs($9ebbf69bd910f984$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $9ebbf69bd910f984$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $9ebbf69bd910f984$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $9ebbf69bd910f984$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $9ebbf69bd910f984$var$React.createElement(WrappedComponent, $9ebbf69bd910f984$var$__spreadProps($9ebbf69bd910f984$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $9ebbf69bd910f984$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $9ebbf69bd910f984$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $9ebbf69bd910f984$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $9ebbf69bd910f984$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $9ebbf69bd910f984$var$React.createElement(Connect, $9ebbf69bd910f984$var$__spreadProps($9ebbf69bd910f984$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $9ebbf69bd910f984$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $9ebbf69bd910f984$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $9ebbf69bd910f984$export$64605811ab45167f = $9ebbf69bd910f984$var$connect;
// src/components/Provider.tsx
function $9ebbf69bd910f984$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $9ebbf69bd910f984$var$React.useMemo(function() {
        var subscription = $9ebbf69bd910f984$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $9ebbf69bd910f984$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $9ebbf69bd910f984$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $9ebbf69bd910f984$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $9ebbf69bd910f984$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $9ebbf69bd910f984$export$2881499e37b75b9a = $9ebbf69bd910f984$var$Provider;
// src/hooks/useStore.ts
function $9ebbf69bd910f984$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $9ebbf69bd910f984$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $9ebbf69bd910f984$export$cc80c08dc91f1c00 ? $9ebbf69bd910f984$var$useReduxContext : // @ts-ignore
    $9ebbf69bd910f984$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $9ebbf69bd910f984$export$6ccbb43953eebf8 = /* @__PURE__ */ $9ebbf69bd910f984$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $9ebbf69bd910f984$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $9ebbf69bd910f984$export$cc80c08dc91f1c00;
    var useStore2 = context === $9ebbf69bd910f984$export$cc80c08dc91f1c00 ? $9ebbf69bd910f984$export$6ccbb43953eebf8 : $9ebbf69bd910f984$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $9ebbf69bd910f984$export$8ad76b76a4c905f8 = /* @__PURE__ */ $9ebbf69bd910f984$export$bc9b55530897c558();
// src/exports.ts
var $9ebbf69bd910f984$export$712ea50be43a7858 = $9ebbf69bd910f984$var$defaultNoopBatch;
// src/index.ts
$9ebbf69bd910f984$var$initializeUseSelector((0, $47c00ebffac04673$exports.useSyncExternalStoreWithSelector));
$9ebbf69bd910f984$var$initializeConnect($lcrTp.useSyncExternalStore);


// src/index.ts

var $aIKKI = parcelRequire("aIKKI");


var $lfBxf = parcelRequire("lfBxf");

var $5eooS = parcelRequire("5eooS");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");

var $g0UjU = parcelRequire("g0UjU");
function $be7b62b2ed84b5e6$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $g0UjU._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}


function $2234ea2a8ddda7cd$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $2234ea2a8ddda7cd$export$afb3516d9d608401 = Reflect.get;
    else $2234ea2a8ddda7cd$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $be7b62b2ed84b5e6$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $2234ea2a8ddda7cd$export$afb3516d9d608401(target, property, receiver || target);
}



var $g0UjU = parcelRequire("g0UjU");

var $9Hju1 = parcelRequire("9Hju1");

var $azcHm = parcelRequire("azcHm");
function $29c5440143c029da$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $azcHm._define_property)(target, key, source[key]);
        });
    }
    return target;
}


function $80cf69b4a84d1e85$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $80cf69b4a84d1e85$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $80cf69b4a84d1e85$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $5ea625cf063491c1$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $2acbba6c26703fbf$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $5ea625cf063491c1$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $kMImg = parcelRequire("kMImg");

var $bPmCu = parcelRequire("bPmCu");

var $hCdf1 = parcelRequire("hCdf1");

// src/utils/formatProdErrorMessage.ts

var $azcHm = parcelRequire("azcHm");



var $1UA6e = parcelRequire("1UA6e");

var $kMImg = parcelRequire("kMImg");
function $b92618eab423720a$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $b92618eab423720a$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $b92618eab423720a$var$symbol_observable_default = $b92618eab423720a$var$$$observable;
// src/utils/actionTypes.ts
var $b92618eab423720a$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $b92618eab423720a$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($b92618eab423720a$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($b92618eab423720a$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($b92618eab423720a$var$randomString());
    }
};
var $b92618eab423720a$export$4219e499db7ca678 = $b92618eab423720a$var$ActionTypes;
// src/utils/isPlainObject.ts
function $b92618eab423720a$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $b92618eab423720a$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $kMImg._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($b92618eab423720a$var$isDate(val)) return "date";
    if ($b92618eab423720a$var$isError(val)) return "error";
    var constructorName = $b92618eab423720a$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $b92618eab423720a$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $b92618eab423720a$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $b92618eab423720a$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $b92618eab423720a$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $kMImg._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $b92618eab423720a$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($b92618eab423720a$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($b92618eab423720a$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($b92618eab423720a$var$formatProdErrorMessage(1));
        return enhancer($b92618eab423720a$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($b92618eab423720a$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($b92618eab423720a$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b92618eab423720a$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b92618eab423720a$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$b92618eab423720a$export$53b83ca8eaab0383(action)) throw new Error($b92618eab423720a$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($b92618eab423720a$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($b92618eab423720a$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($b92618eab423720a$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($b92618eab423720a$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $b92618eab423720a$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $azcHm._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($b92618eab423720a$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $b92618eab423720a$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $b92618eab423720a$export$4219e499db7ca678.INIT
    });
    var store = (0, $azcHm._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $b92618eab423720a$var$symbol_observable_default, observable);
    return store;
}
function $b92618eab423720a$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $b92618eab423720a$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $b92618eab423720a$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $b92618eab423720a$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $b92618eab423720a$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b92618eab423720a$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($b92618eab423720a$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b92618eab423720a$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $b92618eab423720a$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $b92618eab423720a$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($b92618eab423720a$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $b92618eab423720a$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($b92618eab423720a$var$formatProdErrorMessage(13));
    });
}
function $b92618eab423720a$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $b92618eab423720a$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($b92618eab423720a$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $b92618eab423720a$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $b92618eab423720a$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $b92618eab423720a$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($b92618eab423720a$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $b92618eab423720a$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $b92618eab423720a$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $1UA6e._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $b92618eab423720a$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($b92618eab423720a$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $1UA6e._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $b92618eab423720a$export$f672e0b6f7222cd7.apply(void 0, (0, $1UA6e._)(chain))(store.dispatch);
            return (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $b92618eab423720a$export$b956e38827fca970(action) {
    return $b92618eab423720a$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $cE9Yb = parcelRequire("cE9Yb");

var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $kMImg = parcelRequire("kMImg");
var $d9b44030c4aa7212$var$__defProp = Object.defineProperty;
var $d9b44030c4aa7212$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9b44030c4aa7212$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9b44030c4aa7212$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9b44030c4aa7212$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d9b44030c4aa7212$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d9b44030c4aa7212$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d9b44030c4aa7212$var$__hasOwnProp.call(b, prop)) $d9b44030c4aa7212$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d9b44030c4aa7212$var$__getOwnPropSymbols) try {
        for(var _iterator = $d9b44030c4aa7212$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d9b44030c4aa7212$var$__propIsEnum.call(b, prop)) $d9b44030c4aa7212$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d9b44030c4aa7212$var$__publicField = function(obj, key, value) {
    $d9b44030c4aa7212$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $kMImg._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $d9b44030c4aa7212$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $d9b44030c4aa7212$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $1UA6e._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $d9b44030c4aa7212$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $d9b44030c4aa7212$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($d9b44030c4aa7212$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $d9b44030c4aa7212$var$NOT_FOUND = "NOT_FOUND";
function $d9b44030c4aa7212$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $kMImg._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $d9b44030c4aa7212$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $kMImg._)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $d9b44030c4aa7212$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $kMImg._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $d9b44030c4aa7212$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $d9b44030c4aa7212$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $d9b44030c4aa7212$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $d9b44030c4aa7212$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $d9b44030c4aa7212$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $d9b44030c4aa7212$var$__spreadValues($d9b44030c4aa7212$var$__spreadValues({}, $d9b44030c4aa7212$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $d9b44030c4aa7212$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $d9b44030c4aa7212$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $d9b44030c4aa7212$var$$REVISION = 0;
var $d9b44030c4aa7212$var$CURRENT_TRACKER = null;
var $d9b44030c4aa7212$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d9b44030c4aa7212$var$tripleEq;
        (0, $lfBxf._)(this, Cell);
        $d9b44030c4aa7212$var$__publicField(this, "revision", $d9b44030c4aa7212$var$$REVISION);
        $d9b44030c4aa7212$var$__publicField(this, "_value");
        $d9b44030c4aa7212$var$__publicField(this, "_lastValue");
        $d9b44030c4aa7212$var$__publicField(this, "_isEqual", $d9b44030c4aa7212$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $9tzan._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $d9b44030c4aa7212$var$CURRENT_TRACKER == null || $d9b44030c4aa7212$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$d9b44030c4aa7212$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $d9b44030c4aa7212$var$tripleEq(a, b) {
    return a === b;
}
var $d9b44030c4aa7212$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $lfBxf._)(this, TrackingCache);
        $d9b44030c4aa7212$var$__publicField(this, "_cachedValue");
        $d9b44030c4aa7212$var$__publicField(this, "_cachedRevision", -1);
        $d9b44030c4aa7212$var$__publicField(this, "_deps", []);
        $d9b44030c4aa7212$var$__publicField(this, "hits", 0);
        $d9b44030c4aa7212$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $9tzan._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $d9b44030c4aa7212$var$CURRENT_TRACKER;
                    $d9b44030c4aa7212$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $d9b44030c4aa7212$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $d9b44030c4aa7212$var$CURRENT_TRACKER == null || $d9b44030c4aa7212$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $1UA6e._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $d9b44030c4aa7212$var$getValue(cell) {
    if (!(cell instanceof $d9b44030c4aa7212$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $d9b44030c4aa7212$var$setValue(storage, value) {
    if (!(storage instanceof $d9b44030c4aa7212$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $d9b44030c4aa7212$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d9b44030c4aa7212$var$tripleEq;
    return new $d9b44030c4aa7212$var$Cell(initialValue, isEqual);
}
function $d9b44030c4aa7212$var$createCache(fn) {
    $d9b44030c4aa7212$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $d9b44030c4aa7212$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $d9b44030c4aa7212$var$neverEq = function(a, b) {
    return false;
};
function $d9b44030c4aa7212$var$createTag() {
    return $d9b44030c4aa7212$var$createCell(null, $d9b44030c4aa7212$var$neverEq);
}
function $d9b44030c4aa7212$var$dirtyTag(tag, value) {
    $d9b44030c4aa7212$var$setValue(tag, value);
}
var $d9b44030c4aa7212$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $d9b44030c4aa7212$var$createTag();
    $d9b44030c4aa7212$var$getValue(tag);
};
var $d9b44030c4aa7212$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $d9b44030c4aa7212$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $d9b44030c4aa7212$var$REDUX_PROXY_LABEL = Symbol();
var $d9b44030c4aa7212$var$nextId = 0;
var $d9b44030c4aa7212$var$proto = Object.getPrototypeOf({});
var $d9b44030c4aa7212$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $lfBxf._)(this, ObjectTreeNode);
    this.value = value;
    $d9b44030c4aa7212$var$__publicField(this, "proxy", new Proxy(this, $d9b44030c4aa7212$var$objectProxyHandler));
    $d9b44030c4aa7212$var$__publicField(this, "tag", $d9b44030c4aa7212$var$createTag());
    $d9b44030c4aa7212$var$__publicField(this, "tags", {});
    $d9b44030c4aa7212$var$__publicField(this, "children", {});
    $d9b44030c4aa7212$var$__publicField(this, "collectionTag", null);
    $d9b44030c4aa7212$var$__publicField(this, "id", $d9b44030c4aa7212$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $d9b44030c4aa7212$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $kMImg._)(key)) === "symbol") return childValue;
            if (key in $d9b44030c4aa7212$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $d9b44030c4aa7212$var$createNode(childValue);
                if (childNode.tag) $d9b44030c4aa7212$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $d9b44030c4aa7212$var$createTag();
                    tag.value = childValue;
                }
                $d9b44030c4aa7212$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $d9b44030c4aa7212$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $d9b44030c4aa7212$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $lfBxf._)(this, ArrayTreeNode);
    this.value = value;
    $d9b44030c4aa7212$var$__publicField(this, "proxy", new Proxy([
        this
    ], $d9b44030c4aa7212$var$arrayProxyHandler));
    $d9b44030c4aa7212$var$__publicField(this, "tag", $d9b44030c4aa7212$var$createTag());
    $d9b44030c4aa7212$var$__publicField(this, "tags", {});
    $d9b44030c4aa7212$var$__publicField(this, "children", {});
    $d9b44030c4aa7212$var$__publicField(this, "collectionTag", null);
    $d9b44030c4aa7212$var$__publicField(this, "id", $d9b44030c4aa7212$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $d9b44030c4aa7212$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $3tDj3._)(param, 1), node = _param[0];
        if (key === "length") $d9b44030c4aa7212$var$consumeCollection(node);
        return $d9b44030c4aa7212$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $3tDj3._)(param, 1), node = _param[0];
        return $d9b44030c4aa7212$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $3tDj3._)(param, 1), node = _param[0];
        return $d9b44030c4aa7212$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $3tDj3._)(param, 1), node = _param[0];
        return $d9b44030c4aa7212$var$objectProxyHandler.has(node, prop);
    }
};
function $d9b44030c4aa7212$var$createNode(value) {
    if (Array.isArray(value)) return new $d9b44030c4aa7212$var$ArrayTreeNode(value);
    return new $d9b44030c4aa7212$var$ObjectTreeNode(value);
}
function $d9b44030c4aa7212$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $d9b44030c4aa7212$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $d9b44030c4aa7212$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $d9b44030c4aa7212$var$dirtyCollection(node);
            $d9b44030c4aa7212$var$dirtyTag(tags[key1], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if (typeof newChildValue1 === "object" && newChildValue1 !== null) $d9b44030c4aa7212$var$updateNode(childNode, newChildValue1);
        else {
            $d9b44030c4aa7212$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $d9b44030c4aa7212$var$deleteNode(node) {
    if (node.tag) $d9b44030c4aa7212$var$dirtyTag(node.tag, null);
    $d9b44030c4aa7212$var$dirtyCollection(node);
    for(var key in node.tags)$d9b44030c4aa7212$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$d9b44030c4aa7212$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $d9b44030c4aa7212$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $d9b44030c4aa7212$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $d9b44030c4aa7212$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $d9b44030c4aa7212$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $d9b44030c4aa7212$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $d9b44030c4aa7212$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $d9b44030c4aa7212$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $d9b44030c4aa7212$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $d9b44030c4aa7212$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $d9b44030c4aa7212$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize === 1 ? $d9b44030c4aa7212$var$createSingletonCache(comparator) : $d9b44030c4aa7212$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $d9b44030c4aa7212$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $d9b44030c4aa7212$export$c8f9cf88d9fdee55(func) {
    var node = $d9b44030c4aa7212$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $d9b44030c4aa7212$var$createCacheKeyComparator($d9b44030c4aa7212$export$3f025202a230c6dd);
    var cache = $d9b44030c4aa7212$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $d9b44030c4aa7212$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $d9b44030c4aa7212$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $lfBxf._)(this, StrongRef);
        this.value = value;
    }
    (0, $9tzan._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $d9b44030c4aa7212$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $d9b44030c4aa7212$var$StrongRef;
var $d9b44030c4aa7212$var$UNTERMINATED = 0;
var $d9b44030c4aa7212$var$TERMINATED = 1;
function $d9b44030c4aa7212$var$createCacheNode() {
    return {
        s: $d9b44030c4aa7212$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $d9b44030c4aa7212$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $d9b44030c4aa7212$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $d9b44030c4aa7212$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $d9b44030c4aa7212$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $d9b44030c4aa7212$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $d9b44030c4aa7212$var$TERMINATED;
        if (resultEqualityCheck) {
            var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $d9b44030c4aa7212$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $d9b44030c4aa7212$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $d9b44030c4aa7212$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $d9b44030c4aa7212$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $kMImg._)(resultFunc), "]"));
        var combinedOptions = $d9b44030c4aa7212$var$__spreadValues($d9b44030c4aa7212$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $d9b44030c4aa7212$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $d9b44030c4aa7212$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $d9b44030c4aa7212$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $d9b44030c4aa7212$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $1UA6e._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $d9b44030c4aa7212$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $1UA6e._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $d9b44030c4aa7212$export$595d22ed68ca2841 = /* @__PURE__ */ $d9b44030c4aa7212$export$5943f4447f6ef248($d9b44030c4aa7212$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $d9b44030c4aa7212$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d9b44030c4aa7212$export$595d22ed68ca2841;
    $d9b44030c4aa7212$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $kMImg._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $d9b44030c4aa7212$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $b05954a27b02bab2$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $b05954a27b02bab2$export$dd164f5517779f15 = $b05954a27b02bab2$var$createThunkMiddleware();
var $b05954a27b02bab2$export$16d06542a1949d9e = $b05954a27b02bab2$var$createThunkMiddleware;


var $4bad40546c362ef2$exports = {};
// shim for using process in browser
var $4bad40546c362ef2$var$process = $4bad40546c362ef2$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4bad40546c362ef2$var$cachedSetTimeout;
var $4bad40546c362ef2$var$cachedClearTimeout;
function $4bad40546c362ef2$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4bad40546c362ef2$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4bad40546c362ef2$var$cachedSetTimeout = setTimeout;
        else $4bad40546c362ef2$var$cachedSetTimeout = $4bad40546c362ef2$var$defaultSetTimout;
    } catch (e) {
        $4bad40546c362ef2$var$cachedSetTimeout = $4bad40546c362ef2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4bad40546c362ef2$var$cachedClearTimeout = clearTimeout;
        else $4bad40546c362ef2$var$cachedClearTimeout = $4bad40546c362ef2$var$defaultClearTimeout;
    } catch (e) {
        $4bad40546c362ef2$var$cachedClearTimeout = $4bad40546c362ef2$var$defaultClearTimeout;
    }
})();
function $4bad40546c362ef2$var$runTimeout(fun) {
    if ($4bad40546c362ef2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4bad40546c362ef2$var$cachedSetTimeout === $4bad40546c362ef2$var$defaultSetTimout || !$4bad40546c362ef2$var$cachedSetTimeout) && setTimeout) {
        $4bad40546c362ef2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4bad40546c362ef2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4bad40546c362ef2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4bad40546c362ef2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4bad40546c362ef2$var$runClearTimeout(marker) {
    if ($4bad40546c362ef2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4bad40546c362ef2$var$cachedClearTimeout === $4bad40546c362ef2$var$defaultClearTimeout || !$4bad40546c362ef2$var$cachedClearTimeout) && clearTimeout) {
        $4bad40546c362ef2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4bad40546c362ef2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4bad40546c362ef2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4bad40546c362ef2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4bad40546c362ef2$var$queue = [];
var $4bad40546c362ef2$var$draining = false;
var $4bad40546c362ef2$var$currentQueue;
var $4bad40546c362ef2$var$queueIndex = -1;
function $4bad40546c362ef2$var$cleanUpNextTick() {
    if (!$4bad40546c362ef2$var$draining || !$4bad40546c362ef2$var$currentQueue) return;
    $4bad40546c362ef2$var$draining = false;
    if ($4bad40546c362ef2$var$currentQueue.length) $4bad40546c362ef2$var$queue = $4bad40546c362ef2$var$currentQueue.concat($4bad40546c362ef2$var$queue);
    else $4bad40546c362ef2$var$queueIndex = -1;
    if ($4bad40546c362ef2$var$queue.length) $4bad40546c362ef2$var$drainQueue();
}
function $4bad40546c362ef2$var$drainQueue() {
    if ($4bad40546c362ef2$var$draining) return;
    var timeout = $4bad40546c362ef2$var$runTimeout($4bad40546c362ef2$var$cleanUpNextTick);
    $4bad40546c362ef2$var$draining = true;
    var len = $4bad40546c362ef2$var$queue.length;
    while(len){
        $4bad40546c362ef2$var$currentQueue = $4bad40546c362ef2$var$queue;
        $4bad40546c362ef2$var$queue = [];
        while(++$4bad40546c362ef2$var$queueIndex < len)if ($4bad40546c362ef2$var$currentQueue) $4bad40546c362ef2$var$currentQueue[$4bad40546c362ef2$var$queueIndex].run();
        $4bad40546c362ef2$var$queueIndex = -1;
        len = $4bad40546c362ef2$var$queue.length;
    }
    $4bad40546c362ef2$var$currentQueue = null;
    $4bad40546c362ef2$var$draining = false;
    $4bad40546c362ef2$var$runClearTimeout(timeout);
}
$4bad40546c362ef2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4bad40546c362ef2$var$queue.push(new $4bad40546c362ef2$var$Item(fun, args));
    if ($4bad40546c362ef2$var$queue.length === 1 && !$4bad40546c362ef2$var$draining) $4bad40546c362ef2$var$runTimeout($4bad40546c362ef2$var$drainQueue);
};
// v8 likes predictible objects
function $4bad40546c362ef2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4bad40546c362ef2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4bad40546c362ef2$var$process.title = "browser";
$4bad40546c362ef2$var$process.browser = true;
$4bad40546c362ef2$var$process.env = {};
$4bad40546c362ef2$var$process.argv = [];
$4bad40546c362ef2$var$process.version = ""; // empty string to avoid regexp issues
$4bad40546c362ef2$var$process.versions = {};
function $4bad40546c362ef2$var$noop() {}
$4bad40546c362ef2$var$process.on = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.addListener = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.once = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.off = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.removeListener = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.removeAllListeners = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.emit = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.prependListener = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.prependOnceListener = $4bad40546c362ef2$var$noop;
$4bad40546c362ef2$var$process.listeners = function(name) {
    return [];
};
$4bad40546c362ef2$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4bad40546c362ef2$var$process.cwd = function() {
    return "/";
};
$4bad40546c362ef2$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4bad40546c362ef2$var$process.umask = function() {
    return 0;
};


var $d82c5bf5c7096fe2$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $d9b44030c4aa7212$export$5943f4447f6ef248).apply(void 0, (0, $1UA6e._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $1UA6e._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $cE9Yb.isDraft)(value) ? (0, $cE9Yb.current)(value) : value
            ].concat((0, $1UA6e._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $d82c5bf5c7096fe2$export$a5d3c27355e35910 = $d82c5bf5c7096fe2$export$aab6de9e3dbb1473((0, $d9b44030c4aa7212$export$8402dc26d96f6902));
var $d82c5bf5c7096fe2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b92618eab423720a$export$f672e0b6f7222cd7;
    return (0, $b92618eab423720a$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d82c5bf5c7096fe2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d82c5bf5c7096fe2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $1UA6e._)(args));
            if (!prepared) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(0));
            return (0, $29c5440143c029da$export$581ff339ea0ba762)({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }, "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $b92618eab423720a$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $d82c5bf5c7096fe2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d82c5bf5c7096fe2$var$hasMatchFunction(action);
}
function $d82c5bf5c7096fe2$export$ebd532f9034651f3(action) {
    return (0, $b92618eab423720a$export$b956e38827fca970)(action) && Object.keys(action).every($d82c5bf5c7096fe2$var$isValidKey);
}
function $d82c5bf5c7096fe2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d82c5bf5c7096fe2$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $d82c5bf5c7096fe2$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $d82c5bf5c7096fe2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $d82c5bf5c7096fe2$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $d82c5bf5c7096fe2$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $9Hju1._)(_Tuple, Array1);
    var _super = (0, $hCdf1._)(_Tuple);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $lfBxf._)(this, _Tuple);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $1UA6e._)(items)));
        Object.setPrototypeOf((0, $aIKKI._)(_this), _Tuple.prototype);
        return _this;
    }
    (0, $9tzan._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $2234ea2a8ddda7cd$export$afb3516d9d608401)((0, $g0UjU._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $5eooS._)(_Tuple, (0, $1UA6e._)(arr[0].concat(this)));
                return (0, $5eooS._)(_Tuple, (0, $1UA6e._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $bPmCu._)(Array));
function $d82c5bf5c7096fe2$var$freezeDraftable(val) {
    return (0, $cE9Yb.isDraftable)(val) ? (0, $cE9Yb.produce)(val, function() {}) : val;
}
function $d82c5bf5c7096fe2$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $d82c5bf5c7096fe2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d82c5bf5c7096fe2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $d82c5bf5c7096fe2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $d82c5bf5c7096fe2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d82c5bf5c7096fe2$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d82c5bf5c7096fe2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d82c5bf5c7096fe2$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $d82c5bf5c7096fe2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $kMImg._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $d82c5bf5c7096fe2$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $d82c5bf5c7096fe2$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $kMImg._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $b92618eab423720a$export$53b83ca8eaab0383)(val);
}
function $d82c5bf5c7096fe2$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $d82c5bf5c7096fe2$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if (typeof nestedValue === "object") {
                foundNestedSerializable = $d82c5bf5c7096fe2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $kMImg._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $d82c5bf5c7096fe2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d82c5bf5c7096fe2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if (typeof nestedValue !== "object" || nestedValue === null) continue;
            if (!$d82c5bf5c7096fe2$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $d82c5bf5c7096fe2$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $d82c5bf5c7096fe2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d82c5bf5c7096fe2$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options !== null && options !== void 0 ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $d82c5bf5c7096fe2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d82c5bf5c7096fe2$var$isBoolean(thunk)) middlewareArray.push((0, $b05954a27b02bab2$export$dd164f5517779f15));
            else middlewareArray.push((0, $b05954a27b02bab2$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $d82c5bf5c7096fe2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d82c5bf5c7096fe2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $azcHm._)({}, $d82c5bf5c7096fe2$export$8fb31c0f05df007b, true)
        };
    };
};
var $d82c5bf5c7096fe2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $d82c5bf5c7096fe2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d82c5bf5c7096fe2$var$createQueueWithTimer(10);
var $d82c5bf5c7096fe2$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $1UA6e._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $d82c5bf5c7096fe2$var$rAF : options.type === "callback" ? options.queueNotification : $d82c5bf5c7096fe2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    try {
                        var _action_meta;
                        notifying = !(action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta[$d82c5bf5c7096fe2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $d82c5bf5c7096fe2$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options !== null && options !== void 0 ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $d82c5bf5c7096fe2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d82c5bf5c7096fe2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $d82c5bf5c7096fe2$var$IS_PRODUCTION = true;
function $d82c5bf5c7096fe2$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $d82c5bf5c7096fe2$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $b92618eab423720a$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $b92618eab423720a$export$66e4520cdb265d18)(reducer);
    else throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(1));
    if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(4));
    var finalCompose = (0, $b92618eab423720a$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d82c5bf5c7096fe2$var$composeWithDevTools((0, $29c5440143c029da$export$581ff339ea0ba762)({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$d82c5bf5c7096fe2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var middlewareEnhancer = (0, $b92618eab423720a$export$9ff26e0402cc7b7).apply(void 0, (0, $1UA6e._)(finalMiddleware));
    var getDefaultEnhancers = $d82c5bf5c7096fe2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(6));
    if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(7));
    if (!$d82c5bf5c7096fe2$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $1UA6e._)(storeEnhancers));
    return (0, $b92618eab423720a$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d82c5bf5c7096fe2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d82c5bf5c7096fe2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d82c5bf5c7096fe2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $3tDj3._)($d82c5bf5c7096fe2$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($d82c5bf5c7096fe2$var$isStateFunction(initialState)) getInitialState = function() {
        return $d82c5bf5c7096fe2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $d82c5bf5c7096fe2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $1UA6e._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $cE9Yb.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $cE9Yb.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $cE9Yb.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $d82c5bf5c7096fe2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d82c5bf5c7096fe2$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $d82c5bf5c7096fe2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $d82c5bf5c7096fe2$var$matches = function(matcher, action) {
    if ($d82c5bf5c7096fe2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d82c5bf5c7096fe2$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $d82c5bf5c7096fe2$var$matches(matcher, action);
        });
    };
}
function $d82c5bf5c7096fe2$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $d82c5bf5c7096fe2$var$matches(matcher, action);
        });
    };
}
function $d82c5bf5c7096fe2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d82c5bf5c7096fe2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d82c5bf5c7096fe2$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $d82c5bf5c7096fe2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$d82c5bf5c7096fe2$var$isAsyncThunkArray(asyncThunks)) return $d82c5bf5c7096fe2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $d82c5bf5c7096fe2$export$2c3435c7647f7b0d.apply(void 0, (0, $1UA6e._)(matchers));
        return combinedMatcher(action);
    };
}
function $d82c5bf5c7096fe2$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $d82c5bf5c7096fe2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$d82c5bf5c7096fe2$var$isAsyncThunkArray(asyncThunks)) return $d82c5bf5c7096fe2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $d82c5bf5c7096fe2$export$2c3435c7647f7b0d.apply(void 0, (0, $1UA6e._)(matchers));
        return combinedMatcher(action);
    };
}
function $d82c5bf5c7096fe2$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $d82c5bf5c7096fe2$export$9dd1fb32974da385($d82c5bf5c7096fe2$export$a5c5d27e3994c5be.apply(void 0, (0, $1UA6e._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
    if (!$d82c5bf5c7096fe2$var$isAsyncThunkArray(asyncThunks)) return $d82c5bf5c7096fe2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $d82c5bf5c7096fe2$export$9dd1fb32974da385($d82c5bf5c7096fe2$export$a5c5d27e3994c5be.apply(void 0, (0, $1UA6e._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
}
function $d82c5bf5c7096fe2$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $d82c5bf5c7096fe2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$d82c5bf5c7096fe2$var$isAsyncThunkArray(asyncThunks)) return $d82c5bf5c7096fe2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $d82c5bf5c7096fe2$export$2c3435c7647f7b0d.apply(void 0, (0, $1UA6e._)(matchers));
        return combinedMatcher(action);
    };
}
function $d82c5bf5c7096fe2$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $d82c5bf5c7096fe2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$d82c5bf5c7096fe2$var$isAsyncThunkArray(asyncThunks)) return $d82c5bf5c7096fe2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = asyncThunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var asyncThunk = _step.value;
                matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var combinedMatcher = $d82c5bf5c7096fe2$export$2c3435c7647f7b0d.apply(void 0, (0, $1UA6e._)(matchers));
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $d82c5bf5c7096fe2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d82c5bf5c7096fe2$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $lfBxf._)(this, RejectWithValue);
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $azcHm._)(this, "_type", void 0);
    this.payload = payload;
    this.meta = meta;
};
var $d82c5bf5c7096fe2$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $lfBxf._)(this, FulfillWithMeta);
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $azcHm._)(this, "_type", void 0);
    this.payload = payload;
    this.meta = meta;
};
var $d82c5bf5c7096fe2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $d82c5bf5c7096fe2$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d82c5bf5c7096fe2$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $d82c5bf5c7096fe2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d82c5bf5c7096fe2$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var finalAction, _options_condition, _options_getPendingMeta, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = options === null || options === void 0 ? void 0 : (_options_condition = options.condition) === null || _options_condition === void 0 ? void 0 : _options_condition.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$d82c5bf5c7096fe2$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, options === null || options === void 0 ? void 0 : (_options_getPendingMeta = options.getPendingMeta) === null || _options_getPendingMeta === void 0 ? void 0 : _options_getPendingMeta.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $d82c5bf5c7096fe2$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $d82c5bf5c7096fe2$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $d82c5bf5c7096fe2$var$RejectWithValue) throw result;
                                            if (result instanceof $d82c5bf5c7096fe2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $d82c5bf5c7096fe2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($d82c5bf5c7096fe2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d82c5bf5c7096fe2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $d82c5bf5c7096fe2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d82c5bf5c7096fe2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d82c5bf5c7096fe2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d82c5bf5c7096fe2$export$343355ed40c51c46 = (0, $azcHm._)({}, $d82c5bf5c7096fe2$var$asyncThunkSymbol, $d82c5bf5c7096fe2$export$6abd22dc03e5063f);
var $d82c5bf5c7096fe2$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($d82c5bf5c7096fe2$export$23a094319a4b586 || {});
function $d82c5bf5c7096fe2$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $d82c5bf5c7096fe2$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _creators_asyncThunk;
    var cAT = creators === null || creators === void 0 ? void 0 : (_creators_asyncThunk = creators.asyncThunk) === null || _creators_asyncThunk === void 0 ? void 0 : _creators_asyncThunk[$d82c5bf5c7096fe2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(11));
        typeof $4bad40546c362ef2$exports === "undefined" ? "undefined" : (0, $kMImg._)($4bad40546c362ef2$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($d82c5bf5c7096fe2$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $d82c5bf5c7096fe2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d82c5bf5c7096fe2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d82c5bf5c7096fe2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d82c5bf5c7096fe2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $3tDj3._)(typeof options.extraReducers === "function" ? $d82c5bf5c7096fe2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = (0, $29c5440143c029da$export$581ff339ea0ba762)({}, extraReducers, context.sliceCaseReducersByType);
            return $d82c5bf5c7096fe2$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $d82c5bf5c7096fe2$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $d82c5bf5c7096fe2$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var map = {};
                        var _options_selectors;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_options_selectors = options.selectors) !== null && _options_selectors !== void 0 ? _options_selectors : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $3tDj3._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $d82c5bf5c7096fe2$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var pathOpt = _param.reducerPath, config = (0, $2acbba6c26703fbf$export$69fdd232f62cde60)(_param, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return (0, $29c5440143c029da$export$581ff339ea0ba762)({}, slice, makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d82c5bf5c7096fe2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $1UA6e._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d82c5bf5c7096fe2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d82c5bf5c7096fe2$export$affdea4146de9cf5();
function $d82c5bf5c7096fe2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return (0, $29c5440143c029da$export$581ff339ea0ba762)({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $azcHm._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $1UA6e._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d82c5bf5c7096fe2$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d82c5bf5c7096fe2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(type, prepareCallback) : $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(type));
}
function $d82c5bf5c7096fe2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d82c5bf5c7096fe2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d82c5bf5c7096fe2$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d82c5bf5c7096fe2$var$noop,
        pending: pending || $d82c5bf5c7096fe2$var$noop,
        rejected: rejected || $d82c5bf5c7096fe2$var$noop,
        settled: settled || $d82c5bf5c7096fe2$var$noop
    });
}
function $d82c5bf5c7096fe2$var$noop() {}
// src/entities/entity_state.ts
function $d82c5bf5c7096fe2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d82c5bf5c7096fe2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($d82c5bf5c7096fe2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d82c5bf5c7096fe2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $d82c5bf5c7096fe2$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $d82c5bf5c7096fe2$var$isDraftTyped = (0, $cE9Yb.isDraft);
function $d82c5bf5c7096fe2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $d82c5bf5c7096fe2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d82c5bf5c7096fe2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d82c5bf5c7096fe2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d82c5bf5c7096fe2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $cE9Yb.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d82c5bf5c7096fe2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $d82c5bf5c7096fe2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d82c5bf5c7096fe2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $d82c5bf5c7096fe2$var$selectIdValue(entity, selectId);
            if (id in state.entities) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d82c5bf5c7096fe2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $d82c5bf5c7096fe2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $d82c5bf5c7096fe2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $d82c5bf5c7096fe2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: (0, $29c5440143c029da$export$581ff339ea0ba762)({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null, update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $d82c5bf5c7096fe2$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $3tDj3._)($d82c5bf5c7096fe2$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d82c5bf5c7096fe2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d82c5bf5c7096fe2$var$createStateOperator(addOneMutably),
        addMany: $d82c5bf5c7096fe2$var$createStateOperator(addManyMutably),
        setOne: $d82c5bf5c7096fe2$var$createStateOperator(setOneMutably),
        setMany: $d82c5bf5c7096fe2$var$createStateOperator(setManyMutably),
        setAll: $d82c5bf5c7096fe2$var$createStateOperator(setAllMutably),
        updateOne: $d82c5bf5c7096fe2$var$createStateOperator(updateOneMutably),
        updateMany: $d82c5bf5c7096fe2$var$createStateOperator(updateManyMutably),
        upsertOne: $d82c5bf5c7096fe2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d82c5bf5c7096fe2$var$createStateOperator(upsertManyMutably),
        removeOne: $d82c5bf5c7096fe2$var$createStateOperator(removeOneMutably),
        removeMany: $d82c5bf5c7096fe2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d82c5bf5c7096fe2$var$createSortedStateAdapter(selectId, sort) {
    var _createUnsortedStateAdapter = $d82c5bf5c7096fe2$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($d82c5bf5c7096fe2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d82c5bf5c7096fe2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    delete state.entities[update.id];
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $3tDj3._)($d82c5bf5c7096fe2$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d82c5bf5c7096fe2$var$createStateOperator(addOneMutably),
        updateOne: $d82c5bf5c7096fe2$var$createStateOperator(updateOneMutably),
        upsertOne: $d82c5bf5c7096fe2$var$createStateOperator(upsertOneMutably),
        setOne: $d82c5bf5c7096fe2$var$createStateOperator(setOneMutably),
        setMany: $d82c5bf5c7096fe2$var$createStateOperator(setManyMutably),
        setAll: $d82c5bf5c7096fe2$var$createStateOperator(setAllMutably),
        addMany: $d82c5bf5c7096fe2$var$createStateOperator(addManyMutably),
        updateMany: $d82c5bf5c7096fe2$var$createStateOperator(updateManyMutably),
        upsertMany: $d82c5bf5c7096fe2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d82c5bf5c7096fe2$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$_object_spread = (0, $29c5440143c029da$export$581ff339ea0ba762)({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _$_object_spread.selectId, sortComparer = _$_object_spread.sortComparer;
    var stateAdapter = sortComparer ? $d82c5bf5c7096fe2$var$createSortedStateAdapter(selectId, sortComparer) : $d82c5bf5c7096fe2$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $d82c5bf5c7096fe2$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $d82c5bf5c7096fe2$var$createSelectorsFactory();
    return (0, $29c5440143c029da$export$581ff339ea0ba762)({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory, selectorsFactory, stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d82c5bf5c7096fe2$var$task = "task";
var $d82c5bf5c7096fe2$var$listener = "listener";
var $d82c5bf5c7096fe2$var$completed = "completed";
var $d82c5bf5c7096fe2$var$cancelled = "cancelled";
var $d82c5bf5c7096fe2$var$taskCancelled = "task-".concat($d82c5bf5c7096fe2$var$cancelled);
var $d82c5bf5c7096fe2$var$taskCompleted = "task-".concat($d82c5bf5c7096fe2$var$completed);
var $d82c5bf5c7096fe2$var$listenerCancelled = "".concat($d82c5bf5c7096fe2$var$listener, "-").concat($d82c5bf5c7096fe2$var$cancelled);
var $d82c5bf5c7096fe2$var$listenerCompleted = "".concat($d82c5bf5c7096fe2$var$listener, "-").concat($d82c5bf5c7096fe2$var$completed);
var $d82c5bf5c7096fe2$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $lfBxf._)(this, TaskAbortError);
    (0, $azcHm._)(this, "name", "TaskAbortError");
    (0, $azcHm._)(this, "message", void 0);
    this.code = code;
    this.message = "".concat($d82c5bf5c7096fe2$var$task, " ").concat($d82c5bf5c7096fe2$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $d82c5bf5c7096fe2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(32));
};
var $d82c5bf5c7096fe2$var$noop2 = function() {};
var $d82c5bf5c7096fe2$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $d82c5bf5c7096fe2$var$noop2;
    promise.catch(onError);
    return promise;
};
var $d82c5bf5c7096fe2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $d82c5bf5c7096fe2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $d82c5bf5c7096fe2$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $d82c5bf5c7096fe2$export$cb1bdac908fed7f(reason);
    }
};
function $d82c5bf5c7096fe2$var$raceWithSignal(signal, promise) {
    var cleanup = $d82c5bf5c7096fe2$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $d82c5bf5c7096fe2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d82c5bf5c7096fe2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $d82c5bf5c7096fe2$var$noop2;
    });
}
var $d82c5bf5c7096fe2$var$runTask = function() {
    var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(task2, cleanUp) {
        var value, error;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $d82c5bf5c7096fe2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp === null || cleanUp === void 0 ? void 0 : cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $d82c5bf5c7096fe2$var$createPause = function(signal) {
    return function(promise) {
        return $d82c5bf5c7096fe2$var$catchRejection($d82c5bf5c7096fe2$var$raceWithSignal(signal, promise).then(function(output) {
            $d82c5bf5c7096fe2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d82c5bf5c7096fe2$var$createDelay = function(signal) {
    var pause = $d82c5bf5c7096fe2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $d82c5bf5c7096fe2$var$assign = Object.assign;
var $d82c5bf5c7096fe2$var$INTERNAL_NIL_TOKEN = {};
var $d82c5bf5c7096fe2$var$alm = "listenerMiddleware";
var $d82c5bf5c7096fe2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $d82c5bf5c7096fe2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $d82c5bf5c7096fe2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $d82c5bf5c7096fe2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $d82c5bf5c7096fe2$var$runTask(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
            var result2;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $d82c5bf5c7096fe2$var$validateActive(parentAbortSignal);
                        $d82c5bf5c7096fe2$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $d82c5bf5c7096fe2$var$createPause(childAbortController.signal),
                                delay: $d82c5bf5c7096fe2$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $d82c5bf5c7096fe2$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $d82c5bf5c7096fe2$var$abortControllerWithReason(childAbortController, $d82c5bf5c7096fe2$var$taskCompleted);
        });
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d82c5bf5c7096fe2$var$noop2));
        return {
            result: $d82c5bf5c7096fe2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $d82c5bf5c7096fe2$var$abortControllerWithReason(childAbortController, $d82c5bf5c7096fe2$var$taskCancelled);
            }
        };
    };
};
var $d82c5bf5c7096fe2$var$createTakePattern = function(startListening, signal) {
    var take = function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $d82c5bf5c7096fe2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $d82c5bf5c7096fe2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $d82c5bf5c7096fe2$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $d82c5bf5c7096fe2$var$catchRejection(take(predicate, timeout));
    };
};
var $d82c5bf5c7096fe2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $d82c5bf5c7096fe2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(21));
    $d82c5bf5c7096fe2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d82c5bf5c7096fe2$var$createListenerEntry = Object.assign(function(options) {
    var _getListenerEntryPropsFrom = $d82c5bf5c7096fe2$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $d82c5bf5c7096fe2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $d82c5bf5c7096fe2$var$createListenerEntry;
    }
});
var $d82c5bf5c7096fe2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $d82c5bf5c7096fe2$var$abortControllerWithReason(controller, $d82c5bf5c7096fe2$var$listenerCancelled);
    });
};
var $d82c5bf5c7096fe2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($d82c5bf5c7096fe2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d82c5bf5c7096fe2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $d82c5bf5c7096fe2$export$f03a6b845d3fb58b = Object.assign($d82c5bf5c7096fe2$export$309c7a02b0b0bc62("".concat($d82c5bf5c7096fe2$var$alm, "/add")), {
    withTypes: function() {
        return $d82c5bf5c7096fe2$export$f03a6b845d3fb58b;
    }
});
var $d82c5bf5c7096fe2$export$b1b8022855fb2b71 = $d82c5bf5c7096fe2$export$309c7a02b0b0bc62("".concat($d82c5bf5c7096fe2$var$alm, "/removeAll"));
var $d82c5bf5c7096fe2$export$b03e9483f936dccb = Object.assign($d82c5bf5c7096fe2$export$309c7a02b0b0bc62("".concat($d82c5bf5c7096fe2$var$alm, "/remove")), {
    withTypes: function() {
        return $d82c5bf5c7096fe2$export$b03e9483f936dccb;
    }
});
var $d82c5bf5c7096fe2$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($d82c5bf5c7096fe2$var$alm, "/error")
    ].concat((0, $1UA6e._)(args)));
};
var $d82c5bf5c7096fe2$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $d82c5bf5c7096fe2$var$defaultErrorHandler : _middlewareOptions_onError;
    $d82c5bf5c7096fe2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $d82c5bf5c7096fe2$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $d82c5bf5c7096fe2$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $d82c5bf5c7096fe2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $d82c5bf5c7096fe2$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $d82c5bf5c7096fe2$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d82c5bf5c7096fe2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $d82c5bf5c7096fe2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $d82c5bf5c7096fe2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $d82c5bf5c7096fe2$var$createDelay(internalTaskController.signal),
                                pause: $d82c5bf5c7096fe2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $d82c5bf5c7096fe2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $d82c5bf5c7096fe2$var$abortControllerWithReason(controller, $d82c5bf5c7096fe2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $d82c5bf5c7096fe2$var$abortControllerWithReason(internalTaskController, $d82c5bf5c7096fe2$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $d82c5bf5c7096fe2$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $d82c5bf5c7096fe2$export$cb1bdac908fed7f)) $d82c5bf5c7096fe2$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $d82c5bf5c7096fe2$var$abortControllerWithReason(internalTaskController, $d82c5bf5c7096fe2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $d82c5bf5c7096fe2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $b92618eab423720a$export$b956e38827fca970)(action)) return next(action);
                if ($d82c5bf5c7096fe2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d82c5bf5c7096fe2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d82c5bf5c7096fe2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $d82c5bf5c7096fe2$var$INTERNAL_NIL_TOKEN) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $d82c5bf5c7096fe2$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $d82c5bf5c7096fe2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $d82c5bf5c7096fe2$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $d82c5bf5c7096fe2$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $d82c5bf5c7096fe2$var$matchInstance = function(instanceId) {
    return function(action) {
        var _action_meta;
        return (action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta.instanceId) === instanceId;
    };
};
var $d82c5bf5c7096fe2$export$4bb1606a79445586 = function() {
    var instanceId = $d82c5bf5c7096fe2$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($d82c5bf5c7096fe2$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $d82c5bf5c7096fe2$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $d82c5bf5c7096fe2$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $d82c5bf5c7096fe2$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $b92618eab423720a$export$f672e0b6f7222cd7).apply(void 0, (0, $1UA6e._)(appliedMiddleware));
    };
    var isWithMiddleware = $d82c5bf5c7096fe2$export$9dd1fb32974da385(withMiddleware, $d82c5bf5c7096fe2$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $1UA6e._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d82c5bf5c7096fe2$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $d82c5bf5c7096fe2$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $d82c5bf5c7096fe2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $d82c5bf5c7096fe2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d82c5bf5c7096fe2$var$isStateProxy = function(value) {
    return !!value && !!value[$d82c5bf5c7096fe2$var$ORIGINAL_STATE];
};
var $d82c5bf5c7096fe2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d82c5bf5c7096fe2$var$createStateProxy = function(state, reducerMap) {
    return $d82c5bf5c7096fe2$var$emplace($d82c5bf5c7096fe2$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $d82c5bf5c7096fe2$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $d82c5bf5c7096fe2$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $d82c5bf5c7096fe2$var$original = function(state) {
    if (!$d82c5bf5c7096fe2$var$isStateProxy(state)) throw new Error($d82c5bf5c7096fe2$export$378fa86b259c0280(25));
    return state[$d82c5bf5c7096fe2$var$ORIGINAL_STATE];
};
var $d82c5bf5c7096fe2$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $d82c5bf5c7096fe2$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($d82c5bf5c7096fe2$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $b92618eab423720a$export$66e4520cdb265d18)(reducerMap) : $d82c5bf5c7096fe2$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $4bad40546c362ef2$exports === "undefined" ? "undefined" : (0, $kMImg._)($4bad40546c362ef2$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $d82c5bf5c7096fe2$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $1UA6e._)(args))) : state, reducerMap)
            ].concat((0, $1UA6e._)(args)));
        };
    }, {
        original: $d82c5bf5c7096fe2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d82c5bf5c7096fe2$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $97e825b352217d68$var$themeSlice = (0, $d82c5bf5c7096fe2$export$4d8d9bd83c24ae8b)({
    name: "themeChanger",
    initialState: {
        theme: "dark"
    },
    reducers: {
        toogleTheme: function(state, action) {
            if (state.theme === "light") state.theme = "dark";
            else state.theme = "light";
        }
    }
});
var $97e825b352217d68$export$2e2bcd8739ae039 = $97e825b352217d68$var$themeSlice.reducer;
var $97e825b352217d68$export$9443a770e75d2a08 = $97e825b352217d68$var$themeSlice.actions.toogleTheme;


var $df6b3e332a139c88$export$bcede3532aa4b7f7 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $df6b3e332a139c88$export$4cb72355748c04dd = "https://ucarecdn.com/a5921077-2612-4458-b16e-c37a80402d5a/-/preview/999x952/";
var $df6b3e332a139c88$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.4089123&lng=77.3177894&restaurantId=";
var $df6b3e332a139c88$export$1087355e69a7a68 = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.4089123&lng=77.3177894";
var $df6b3e332a139c88$export$f89a830e1c49df8f = "https://img.icons8.com/fluency/96/vegetarian-food-symbol.png";
var $df6b3e332a139c88$export$ecdeacdb356c62b = "https://www.pngkey.com/png/detail/245-2459071_non-veg-icon-non-veg-symbol-png.png";
var $df6b3e332a139c88$export$f30cb9bc4f736419 = "https://ucarecdn.com/3e2bf550-142d-4d38-9d87-9b10260a9878/2682848_day_forecast_sun_sunny_weather_icon.png";
var $df6b3e332a139c88$export$3e936a8db52a10a0 = "https://ucarecdn.com/481c8102-6fa2-4cbe-8f2a-5a3e2123ca37/8726101_moon_icon.png"; /* 
    fetch('https://proxy.cors.sh/https://acme.com', {
  headers: {
  'x-cors-api-key': 'temp_1d89d97e9a7fea79a5794d20f4d66a87'
  }
})
    */ 


// Import the functions you need from the SDKs you need



var $kZF3u = parcelRequire("kZF3u");


var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");

var $1UA6e = parcelRequire("1UA6e");



var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $aIKKI = parcelRequire("aIKKI");

var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $9Hju1 = parcelRequire("9Hju1");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $bPmCu = parcelRequire("bPmCu");

var $hCdf1 = parcelRequire("hCdf1");

var $4aa7d5a8ca32ac7d$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $4aa7d5a8ca32ac7d$export$a7a9523472993e97 = function assert(assertion, message) {
    if (!assertion) throw $4aa7d5a8ca32ac7d$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $4aa7d5a8ca32ac7d$export$a39cad550e7ab28a = function assertionError(message) {
    return new Error("Firebase Database (" + $4aa7d5a8ca32ac7d$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4aa7d5a8ca32ac7d$var$stringToByteArray$1 = function stringToByteArray$1(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $4aa7d5a8ca32ac7d$var$byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c21 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c21 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c22 = bytes[pos++];
            var c31 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c31 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $4aa7d5a8ca32ac7d$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($4aa7d5a8ca32ac7d$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $4aa7d5a8ca32ac7d$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $4aa7d5a8ca32ac7d$export$55ca9d4bee46aeb3();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ var $4aa7d5a8ca32ac7d$export$55ca9d4bee46aeb3 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $9Hju1._)(DecodeBase64StringError, Error1);
    var _super = (0, $hCdf1._)(DecodeBase64StringError);
    function DecodeBase64StringError() {
        (0, $lfBxf._)(this, DecodeBase64StringError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "DecodeBase64StringError";
        return _this;
    }
    return DecodeBase64StringError;
}((0, $bPmCu._)(Error));
/**
 * URL-safe base64 encoding
 */ var $4aa7d5a8ca32ac7d$export$e510a73ee562749 = function base64Encode(str) {
    var utf8Bytes = $4aa7d5a8ca32ac7d$var$stringToByteArray$1(str);
    return $4aa7d5a8ca32ac7d$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ var $4aa7d5a8ca32ac7d$export$4b5284a3025a455 = function base64urlEncodeWithoutPadding(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $4aa7d5a8ca32ac7d$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $4aa7d5a8ca32ac7d$export$c62426fdd000a97e = function base64Decode(str) {
    try {
        return $4aa7d5a8ca32ac7d$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $4aa7d5a8ca32ac7d$export$6c40052bed430212(value) {
    return $4aa7d5a8ca32ac7d$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $4aa7d5a8ca32ac7d$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$4aa7d5a8ca32ac7d$var$isValidKey(prop)) continue;
        target[prop] = $4aa7d5a8ca32ac7d$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $4aa7d5a8ca32ac7d$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $4aa7d5a8ca32ac7d$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4aa7d5a8ca32ac7d$var$getDefaultsFromGlobal = function() {
    return $4aa7d5a8ca32ac7d$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
};
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ var $4aa7d5a8ca32ac7d$var$getDefaultsFromEnvVariable = function() {
    if (typeof $4bad40546c362ef2$exports === "undefined" || typeof $4bad40546c362ef2$exports.env === "undefined") return;
    var defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
var $4aa7d5a8ca32ac7d$var$getDefaultsFromCookie = function() {
    if (typeof document === "undefined") return;
    var match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    var decoded = match && $4aa7d5a8ca32ac7d$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ var $4aa7d5a8ca32ac7d$export$212bb2fc580a90a8 = function() {
    try {
        return $4aa7d5a8ca32ac7d$var$getDefaultsFromGlobal() || $4aa7d5a8ca32ac7d$var$getDefaultsFromEnvVariable() || $4aa7d5a8ca32ac7d$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e));
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ var $4aa7d5a8ca32ac7d$export$9c11895284c8adad = function(productName) {
    var _a, _b;
    return (_b = (_a = $4aa7d5a8ca32ac7d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ var $4aa7d5a8ca32ac7d$export$a3febcf1f14a3a0c = function(productName) {
    var host = $4aa7d5a8ca32ac7d$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    var separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error("Invalid host ".concat(host, " with no separate hostname and port!"));
    // eslint-disable-next-line no-restricted-globals
    var port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ var $4aa7d5a8ca32ac7d$export$3dfb6827a9f89756 = function() {
    var _a;
    return (_a = $4aa7d5a8ca32ac7d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ var $4aa7d5a8ca32ac7d$export$5539a1a3afe87d6 = function(name) {
    var _a;
    return (_a = $4aa7d5a8ca32ac7d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a["_".concat(name)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $4aa7d5a8ca32ac7d$export$85f6557964517f1a = /*#__PURE__*/ function() {
    "use strict";
    function Deferred() {
        var _this = this;
        (0, $lfBxf._)(this, Deferred);
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    (0, $9tzan._)(Deferred, [
        {
            /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ key: "wrapCallback",
            value: function wrapCallback(callback) {
                var _this = this;
                return function(error, value) {
                    if (error) _this.reject(error);
                    else _this.resolve(value);
                    if (typeof callback === "function") {
                        // Attaching noop handler just in case developer wasn't expecting
                        // promises
                        _this.promise.catch(function() {});
                        // Some of our callbacks don't expect a value and our own tests
                        // assert that the parameter length is 1
                        if (callback.length === 1) callback(error);
                        else callback(error, value);
                    }
                };
            }
        }
    ]);
    return Deferred;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4aa7d5a8ca32ac7d$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: "none",
        type: "JWT"
    };
    var project = projectId || "demo-project";
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    var payload = Object.assign({
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/".concat(project),
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = "";
    return [
        $4aa7d5a8ca32ac7d$export$4b5284a3025a455(JSON.stringify(header)),
        $4aa7d5a8ca32ac7d$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $4aa7d5a8ca32ac7d$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $4aa7d5a8ca32ac7d$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($4aa7d5a8ca32ac7d$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $4aa7d5a8ca32ac7d$export$8ee0fc9ee280b4ee() {
    var _a;
    var forceEnvironment = (_a = $4aa7d5a8ca32ac7d$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $4aa7d5a8ca32ac7d$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $4aa7d5a8ca32ac7d$export$caa8774a9107a58e() {
    var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $4aa7d5a8ca32ac7d$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $4aa7d5a8ca32ac7d$export$f2f6a8999f8ebd30() {
    return $4aa7d5a8ca32ac7d$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $4aa7d5a8ca32ac7d$export$7e7b1a9668aaed8() {
    var ua = $4aa7d5a8ca32ac7d$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $4aa7d5a8ca32ac7d$export$202944b2d2824246() {
    return $4aa7d5a8ca32ac7d$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $4aa7d5a8ca32ac7d$export$5d1d834fbbf8bab7() {
    return $4aa7d5a8ca32ac7d$export$588c7fdda06fbb0a.NODE_CLIENT === true || $4aa7d5a8ca32ac7d$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $4aa7d5a8ca32ac7d$export$95df08bae54cb4df() {
    return !$4aa7d5a8ca32ac7d$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $4aa7d5a8ca32ac7d$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $4aa7d5a8ca32ac7d$export$a8a3018f3d187a4d() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist = true;
            var DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            var request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = function() {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = function() {
                preExist = false;
            };
            request.onerror = function() {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $4aa7d5a8ca32ac7d$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ var $4aa7d5a8ca32ac7d$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $9Hju1._)(FirebaseError, Error1);
    var _super = (0, $hCdf1._)(FirebaseError);
    function FirebaseError(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData) {
        (0, $lfBxf._)(this, FirebaseError);
        var _this;
        _this = _super.call(this, message);
        _this.code = code;
        _this.customData = customData;
        /** The custom name for all FirebaseErrors. */ _this.name = $4aa7d5a8ca32ac7d$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $aIKKI._)(_this), FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace((0, $aIKKI._)(_this), $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40.prototype.create);
        return _this;
    }
    return FirebaseError;
}((0, $bPmCu._)(Error));
var $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40 = /*#__PURE__*/ function() {
    "use strict";
    function ErrorFactory(service, serviceName, errors) {
        (0, $lfBxf._)(this, ErrorFactory);
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    (0, $9tzan._)(ErrorFactory, [
        {
            key: "create",
            value: function create(code) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var customData = data[0] || {};
                var fullCode = "".concat(this.service, "/").concat(code);
                var template = this.errors[code];
                var message = template ? $4aa7d5a8ca32ac7d$var$replaceTemplate(template, customData) : "Error";
                // Service Name: Error message (service/code).
                var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
                var error = new $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
                return error;
            }
        }
    ]);
    return ErrorFactory;
}();
function $4aa7d5a8ca32ac7d$var$replaceTemplate(template, data) {
    return template.replace($4aa7d5a8ca32ac7d$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? String(value) : "<".concat(key, "?>");
    });
}
var $4aa7d5a8ca32ac7d$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $4aa7d5a8ca32ac7d$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $4aa7d5a8ca32ac7d$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $4aa7d5a8ca32ac7d$export$2f872c0f2117be69 = function decode(token) {
    var header = {}, claims = {}, data = {}, signature = "";
    try {
        var parts = token.split(".");
        header = $4aa7d5a8ca32ac7d$export$c5a53ce6a17cf18d($4aa7d5a8ca32ac7d$export$c62426fdd000a97e(parts[0]) || "");
        claims = $4aa7d5a8ca32ac7d$export$c5a53ce6a17cf18d($4aa7d5a8ca32ac7d$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $4aa7d5a8ca32ac7d$export$5f870fcca7ae6a88 = function isValidTimestamp(token) {
    var claims = $4aa7d5a8ca32ac7d$export$2f872c0f2117be69(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $4aa7d5a8ca32ac7d$export$701c661ec91095f2 = function issuedAtTime(token) {
    var claims = $4aa7d5a8ca32ac7d$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $4aa7d5a8ca32ac7d$export$9565ca3d387f8aa0 = function isValidFormat(token) {
    var decoded = $4aa7d5a8ca32ac7d$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $4aa7d5a8ca32ac7d$export$fc970ed23da99565 = function isAdmin(token) {
    var claims = $4aa7d5a8ca32ac7d$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4aa7d5a8ca32ac7d$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $4aa7d5a8ca32ac7d$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $4aa7d5a8ca32ac7d$export$dd1bc94b04021eeb(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $4aa7d5a8ca32ac7d$export$871de8747c9eaa88(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $4aa7d5a8ca32ac7d$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            if (!bKeys.includes(k)) return false;
            var aProp = a[k];
            var bProp = b[k];
            if ($4aa7d5a8ca32ac7d$var$isObject(aProp) && $4aa7d5a8ca32ac7d$var$isObject(bProp)) {
                if (!$4aa7d5a8ca32ac7d$export$9cb4719e2e525b7a(aProp, bProp)) return false;
            } else if (aProp !== bProp) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = bKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k1 = _step1.value;
            if (!aKeys.includes(k1)) return false;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
function $4aa7d5a8ca32ac7d$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $4aa7d5a8ca32ac7d$export$a9cd205a244d9f54(promise) {
    var timeInMS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var deferredPromise = new $4aa7d5a8ca32ac7d$export$85f6557964517f1a();
    setTimeout(function() {
        return deferredPromise.reject("timeout!");
    }, timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $4aa7d5a8ca32ac7d$export$ac4103b836844853(querystringParams) {
    var params = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (Array.isArray(value)) value.forEach(function(arrayVal) {
                params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
            });
            else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        };
        for(var _iterator = Object.entries(querystringParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $4aa7d5a8ca32ac7d$export$c1271ca4c8a70741(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach(function(token) {
        if (token) {
            var _token_split = (0, $3tDj3._)(token.split("="), 2), key = _token_split[0], value = _token_split[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $4aa7d5a8ca32ac7d$export$1a8408415472d8ed(url) {
    var queryStart = url.indexOf("?");
    if (!queryStart) return "";
    var fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $4aa7d5a8ca32ac7d$export$c85d589bf4e25fef = /*#__PURE__*/ function() {
    "use strict";
    function Sha1() {
        (0, $lfBxf._)(this, Sha1);
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    (0, $9tzan._)(Sha1, [
        {
            key: "reset",
            value: function reset() {
                this.chain_[0] = 0x67452301;
                this.chain_[1] = 0xefcdab89;
                this.chain_[2] = 0x98badcfe;
                this.chain_[3] = 0x10325476;
                this.chain_[4] = 0xc3d2e1f0;
                this.inbuf_ = 0;
                this.total_ = 0;
            }
        },
        {
            /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ key: "compress_",
            value: function compress_(buf, offset) {
                if (!offset) offset = 0;
                var W = this.W_;
                // get 16 big endian words
                if (typeof buf === "string") for(var i = 0; i < 16; i++){
                    // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                    // have a bug that turns the post-increment ++ operator into pre-increment
                    // during JIT compilation.  We have code that depends heavily on SHA-1 for
                    // correctness and which is affected by this bug, so I've removed all uses
                    // of post-increment ++ in which the result value is used.  We can revert
                    // this change once the Safari bug
                    // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                    // most clients have been updated.
                    W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
                    offset += 4;
                }
                else for(var i1 = 0; i1 < 16; i1++){
                    W[i1] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
                    offset += 4;
                }
                // expand to 80 words
                for(var i2 = 16; i2 < 80; i2++){
                    var t = W[i2 - 3] ^ W[i2 - 8] ^ W[i2 - 14] ^ W[i2 - 16];
                    W[i2] = (t << 1 | t >>> 31) & 0xffffffff;
                }
                var a = this.chain_[0];
                var b = this.chain_[1];
                var c = this.chain_[2];
                var d = this.chain_[3];
                var e = this.chain_[4];
                var f, k;
                // TODO(user): Try to unroll this loop to speed up the computation.
                for(var i3 = 0; i3 < 80; i3++){
                    if (i3 < 40) {
                        if (i3 < 20) {
                            f = d ^ b & (c ^ d);
                            k = 0x5a827999;
                        } else {
                            f = b ^ c ^ d;
                            k = 0x6ed9eba1;
                        }
                    } else if (i3 < 60) {
                        f = b & c | d & (b | c);
                        k = 0x8f1bbcdc;
                    } else {
                        f = b ^ c ^ d;
                        k = 0xca62c1d6;
                    }
                    var t1 = (a << 5 | a >>> 27) + f + e + k + W[i3] & 0xffffffff;
                    e = d;
                    d = c;
                    c = (b << 30 | b >>> 2) & 0xffffffff;
                    b = a;
                    a = t1;
                }
                this.chain_[0] = this.chain_[0] + a & 0xffffffff;
                this.chain_[1] = this.chain_[1] + b & 0xffffffff;
                this.chain_[2] = this.chain_[2] + c & 0xffffffff;
                this.chain_[3] = this.chain_[3] + d & 0xffffffff;
                this.chain_[4] = this.chain_[4] + e & 0xffffffff;
            }
        },
        {
            key: "update",
            value: function update(bytes, length) {
                // TODO(johnlenz): tighten the function signature and remove this check
                if (bytes == null) return;
                if (length === undefined) length = bytes.length;
                var lengthMinusBlock = length - this.blockSize;
                var n = 0;
                // Using local instead of member variables gives ~5% speedup on Firefox 16.
                var buf = this.buf_;
                var inbuf = this.inbuf_;
                // The outer while loop should execute at most twice.
                while(n < length){
                    // When we have no data in the block to top up, we can directly process the
                    // input buffer (assuming it contains sufficient data). This gives ~25%
                    // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
                    // the data is provided in large chunks (or in multiples of 64 bytes).
                    if (inbuf === 0) while(n <= lengthMinusBlock){
                        this.compress_(bytes, n);
                        n += this.blockSize;
                    }
                    if (typeof bytes === "string") while(n < length){
                        buf[inbuf] = bytes.charCodeAt(n);
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                    else while(n < length){
                        buf[inbuf] = bytes[n];
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                }
                this.inbuf_ = inbuf;
                this.total_ += length;
            }
        },
        {
            /** @override */ key: "digest",
            value: function digest() {
                var digest = [];
                var totalBits = this.total_ * 8;
                // Add pad 0x80 0x00*.
                if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
                else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
                // Add # bits.
                for(var i = this.blockSize - 1; i >= 56; i--){
                    this.buf_[i] = totalBits & 255;
                    totalBits /= 256; // Don't use bit-shifting here!
                }
                this.compress_(this.buf_);
                var n = 0;
                for(var i1 = 0; i1 < 5; i1++)for(var j = 24; j >= 0; j -= 8){
                    digest[n] = this.chain_[i1] >> j & 255;
                    ++n;
                }
                return digest;
            }
        }
    ]);
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $4aa7d5a8ca32ac7d$export$364097d812234b3f(executor, onNoObservers) {
    var proxy = new $4aa7d5a8ca32ac7d$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $4aa7d5a8ca32ac7d$var$ObserverProxy = /*#__PURE__*/ function() {
    "use strict";
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        (0, $lfBxf._)(this, ObserverProxy);
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    (0, $9tzan._)(ObserverProxy, [
        {
            key: "next",
            value: function next(value) {
                this.forEachObserver(function(observer) {
                    observer.next(value);
                });
            }
        },
        {
            key: "error",
            value: function error(error) {
                this.forEachObserver(function(observer) {
                    observer.error(error);
                });
                this.close(error);
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.forEachObserver(function(observer) {
                    observer.complete();
                });
                this.close();
            }
        },
        {
            /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ key: "subscribe",
            value: function subscribe(nextOrObserver, error, complete) {
                var _this = this;
                var observer;
                if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
                // Assemble an Observer object when passed as callback functions.
                if ($4aa7d5a8ca32ac7d$var$implementsAnyMethods(nextOrObserver, [
                    "next",
                    "error",
                    "complete"
                ])) observer = nextOrObserver;
                else observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
                if (observer.next === undefined) observer.next = $4aa7d5a8ca32ac7d$var$noop;
                if (observer.error === undefined) observer.error = $4aa7d5a8ca32ac7d$var$noop;
                if (observer.complete === undefined) observer.complete = $4aa7d5a8ca32ac7d$var$noop;
                var unsub = this.unsubscribeOne.bind(this, this.observers.length);
                // Attempt to subscribe to a terminated Observable - we
                // just respond to the Observer with the final error or complete
                // event.
                if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    try {
                        if (_this.finalError) observer.error(_this.finalError);
                        else observer.complete();
                    } catch (e) {
                    // nothing
                    }
                    return;
                });
                this.observers.push(observer);
                return unsub;
            }
        },
        {
            // Unsubscribe is synchronous - we guarantee that no events are sent to
            // any unsubscribed Observer.
            key: "unsubscribeOne",
            value: function unsubscribeOne(i) {
                if (this.observers === undefined || this.observers[i] === undefined) return;
                delete this.observers[i];
                this.observerCount -= 1;
                if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
            }
        },
        {
            key: "forEachObserver",
            value: function forEachObserver(fn) {
                if (this.finalized) // Already closed by previous event....just eat the additional values.
                return;
                // Since sendOne calls asynchronously - there is no chance that
                // this.observers will become undefined.
                for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
            }
        },
        {
            // Call the Observer via one of it's callback function. We are careful to
            // confirm that the observe has not been unsubscribed since this asynchronous
            // function had been queued.
            key: "sendOne",
            value: function sendOne(i, fn) {
                var _this = this;
                // Execute the callback asynchronously
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                        fn(_this.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== "undefined" && console.error) console.error(e);
                    }
                });
            }
        },
        {
            key: "close",
            value: function close(err) {
                var _this = this;
                if (this.finalized) return;
                this.finalized = true;
                if (err !== undefined) this.finalError = err;
                // Proxy is no longer needed - garbage collect references
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    _this.observers = undefined;
                    _this.onNoObservers = undefined;
                });
            }
        }
    ]);
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4aa7d5a8ca32ac7d$export$12af436354f1a4f7(fn, onError) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Promise.resolve(true).then(function() {
            fn.apply(void 0, (0, $1UA6e._)(args));
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $4aa7d5a8ca32ac7d$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var method = _step.value;
            if (method in obj && typeof obj[method] === "function") return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $4aa7d5a8ca32ac7d$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $4aa7d5a8ca32ac7d$export$20164226a0ed35c3 = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        var error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $4aa7d5a8ca32ac7d$export$adea4917e02d93dc(fnName, argName) {
    return "".concat(fnName, " failed: ").concat(argName, " argument ");
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $4aa7d5a8ca32ac7d$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($4aa7d5a8ca32ac7d$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $4aa7d5a8ca32ac7d$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($4aa7d5a8ca32ac7d$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $4aa7d5a8ca32ac7d$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($4aa7d5a8ca32ac7d$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $4aa7d5a8ca32ac7d$export$655666783217a925 = function stringToByteArray(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $4aa7d5a8ca32ac7d$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $4aa7d5a8ca32ac7d$export$9536dc0a75b20bf9 = function stringLength(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ var $4aa7d5a8ca32ac7d$export$abe4376e1bf796d6 = function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $4aa7d5a8ca32ac7d$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $4aa7d5a8ca32ac7d$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $4aa7d5a8ca32ac7d$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $4aa7d5a8ca32ac7d$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $4aa7d5a8ca32ac7d$export$4d810c0ca64ed8e9(backoffCount) {
    var intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $4aa7d5a8ca32ac7d$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $4aa7d5a8ca32ac7d$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $4aa7d5a8ca32ac7d$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($4aa7d5a8ca32ac7d$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $4aa7d5a8ca32ac7d$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return "".concat(i);
    return i + $4aa7d5a8ca32ac7d$var$indicator(i);
}
function $4aa7d5a8ca32ac7d$var$indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    var dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $761466ca98ea5fb8$export$16fa2f45be04daa8 = /*#__PURE__*/ function() {
    "use strict";
    function Component(name, instanceFactory, type) {
        (0, $lfBxf._)(this, Component);
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    (0, $9tzan._)(Component, [
        {
            key: "setInstantiationMode",
            value: function setInstantiationMode(mode) {
                this.instantiationMode = mode;
                return this;
            }
        },
        {
            key: "setMultipleInstances",
            value: function setMultipleInstances(multipleInstances) {
                this.multipleInstances = multipleInstances;
                return this;
            }
        },
        {
            key: "setServiceProps",
            value: function setServiceProps(props) {
                this.serviceProps = props;
                return this;
            }
        },
        {
            key: "setInstanceCreatedCallback",
            value: function setInstanceCreatedCallback(callback) {
                this.onInstanceCreated = callback;
                return this;
            }
        }
    ]);
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $761466ca98ea5fb8$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function Provider(name, container) {
        (0, $lfBxf._)(this, Provider);
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    (0, $9tzan._)(Provider, [
        {
            /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ key: "get",
            value: function get(identifier) {
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                if (!this.instancesDeferred.has(normalizedIdentifier)) {
                    var deferred = new (0, $4aa7d5a8ca32ac7d$export$85f6557964517f1a)();
                    this.instancesDeferred.set(normalizedIdentifier, deferred);
                    if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
                    try {
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        if (instance) deferred.resolve(instance);
                    } catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                    }
                }
                return this.instancesDeferred.get(normalizedIdentifier).promise;
            }
        },
        {
            key: "getImmediate",
            value: function getImmediate(options) {
                var _a;
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
                var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
                if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
                    return this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                } catch (e) {
                    if (optional) return null;
                    else throw e;
                }
                else {
                    // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
                    if (optional) return null;
                    else throw Error("Service ".concat(this.name, " is not available"));
                }
            }
        },
        {
            key: "getComponent",
            value: function getComponent() {
                return this.component;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(component) {
                if (component.name !== this.name) throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
                if (this.component) throw Error("Component for ".concat(this.name, " has already been provided"));
                this.component = component;
                // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
                if (!this.shouldAutoInitialize()) return;
                // if the service is eager, initialize the default instance
                if ($761466ca98ea5fb8$var$isComponentEager(component)) try {
                    this.getOrInitializeService({
                        instanceIdentifier: $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME
                    });
                } catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Create service instances for the pending promises and resolve them
                    // NOTE: if this.multipleInstances is false, only the default instance will be created
                    // and all promises with resolve with it regardless of the identifier.
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $3tDj3._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        try {
                            // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                            var instance = this.getOrInitializeService({
                                instanceIdentifier: normalizedIdentifier
                            });
                            instanceDeferred.resolve(instance);
                        } catch (e) {
                        // when the instance factory throws an exception, it should not cause
                        // a fatal error. We just leave the promise unresolved.
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearInstance",
            value: function clearInstance() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME;
                this.instancesDeferred.delete(identifier);
                this.instancesOptions.delete(identifier);
                this.instances.delete(identifier);
            }
        },
        {
            key: "delete",
            value: // app.delete() will call this method on every provider to delete the services
            // TODO: should we mark the provider as deleted?
            function _delete() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var services;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                services = Array.from(_this.instances.values());
                                return [
                                    4,
                                    Promise.all((0, $1UA6e._)(services.filter(function(service) {
                                        return "INTERNAL" in service;
                                    }) // legacy services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service.INTERNAL.delete();
                                    })).concat((0, $1UA6e._)(services.filter(function(service) {
                                        return "_delete" in service;
                                    }) // modularized services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service._delete();
                                    }))))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isComponentSet",
            value: function isComponentSet() {
                return this.component != null;
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME;
                return this.instances.has(identifier);
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME;
                return this.instancesOptions.get(identifier) || {};
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _opts_options = opts.options, options = _opts_options === void 0 ? {} : _opts_options;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
                if (this.isInitialized(normalizedIdentifier)) throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
                if (!this.isComponentSet()) throw Error("Component ".concat(this.name, " has not been registered yet"));
                var instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier,
                    options: options
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // resolve any pending promise waiting for the service instance
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $3tDj3._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return instance;
            }
        },
        {
            /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ key: "onInit",
            value: function onInit(callback, identifier) {
                var _a;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
                existingCallbacks.add(callback);
                this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
                var existingInstance = this.instances.get(normalizedIdentifier);
                if (existingInstance) callback(existingInstance, normalizedIdentifier);
                return function() {
                    existingCallbacks.delete(callback);
                };
            }
        },
        {
            /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ key: "invokeOnInitCallbacks",
            value: function invokeOnInitCallbacks(instance, identifier) {
                var callbacks = this.onInitCallbacks.get(identifier);
                if (!callbacks) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        try {
                            callback(instance, identifier);
                        } catch (_a) {
                        // ignore errors in the onInit callback
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getOrInitializeService",
            value: function getOrInitializeService(param) {
                var instanceIdentifier = param.instanceIdentifier, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
                var instance = this.instances.get(instanceIdentifier);
                if (!instance && this.component) {
                    instance = this.component.instanceFactory(this.container, {
                        instanceIdentifier: $761466ca98ea5fb8$var$normalizeIdentifierForFactory(instanceIdentifier),
                        options: options
                    });
                    this.instances.set(instanceIdentifier, instance);
                    this.instancesOptions.set(instanceIdentifier, options);
                    /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
                    /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                        this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                    } catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                    }
                }
                return instance || null;
            }
        },
        {
            key: "normalizeInstanceIdentifier",
            value: function normalizeInstanceIdentifier() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME;
                if (this.component) return this.component.multipleInstances ? identifier : $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME;
                else return identifier; // assume multiple instances are supported before the component is provided.
            }
        },
        {
            key: "shouldAutoInitialize",
            value: function shouldAutoInitialize() {
                return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
            }
        }
    ]);
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $761466ca98ea5fb8$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $761466ca98ea5fb8$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $761466ca98ea5fb8$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $761466ca98ea5fb8$export$436a80eea5d5c0c5 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentContainer(name) {
        (0, $lfBxf._)(this, ComponentContainer);
        this.name = name;
        this.providers = new Map();
    }
    (0, $9tzan._)(ComponentContainer, [
        {
            /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ key: "addComponent",
            value: function addComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
                provider.setComponent(component);
            }
        },
        {
            key: "addOrOverwriteComponent",
            value: function addOrOverwriteComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
                this.providers.delete(component.name);
                this.addComponent(component);
            }
        },
        {
            /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ key: "getProvider",
            value: function getProvider(name) {
                if (this.providers.has(name)) return this.providers.get(name);
                // create a Provider for a service that hasn't registered with Firebase
                var provider = new $761466ca98ea5fb8$export$2881499e37b75b9a(name, this);
                this.providers.set(name, provider);
                return provider;
            }
        },
        {
            key: "getProviders",
            value: function getProviders() {
                return Array.from(this.providers.values());
            }
        }
    ]);
    return ComponentContainer;
}();


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ 
var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");

var $1UA6e = parcelRequire("1UA6e");
var $2ef812b47e0043d3$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $2ef812b47e0043d3$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($2ef812b47e0043d3$export$243e62d78d3b544d || ($2ef812b47e0043d3$export$243e62d78d3b544d = {}));
var $2ef812b47e0043d3$var$levelStringToEnum = {
    "debug": $2ef812b47e0043d3$export$243e62d78d3b544d.DEBUG,
    "verbose": $2ef812b47e0043d3$export$243e62d78d3b544d.VERBOSE,
    "info": $2ef812b47e0043d3$export$243e62d78d3b544d.INFO,
    "warn": $2ef812b47e0043d3$export$243e62d78d3b544d.WARN,
    "error": $2ef812b47e0043d3$export$243e62d78d3b544d.ERROR,
    "silent": $2ef812b47e0043d3$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $2ef812b47e0043d3$var$defaultLogLevel = $2ef812b47e0043d3$export$243e62d78d3b544d.INFO;
var $2ef812b47e0043d3$var$_obj;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $2ef812b47e0043d3$var$ConsoleMethod = ($2ef812b47e0043d3$var$_obj = {}, (0, $azcHm._)($2ef812b47e0043d3$var$_obj, $2ef812b47e0043d3$export$243e62d78d3b544d.DEBUG, "log"), (0, $azcHm._)($2ef812b47e0043d3$var$_obj, $2ef812b47e0043d3$export$243e62d78d3b544d.VERBOSE, "log"), (0, $azcHm._)($2ef812b47e0043d3$var$_obj, $2ef812b47e0043d3$export$243e62d78d3b544d.INFO, "info"), (0, $azcHm._)($2ef812b47e0043d3$var$_obj, $2ef812b47e0043d3$export$243e62d78d3b544d.WARN, "warn"), (0, $azcHm._)($2ef812b47e0043d3$var$_obj, $2ef812b47e0043d3$export$243e62d78d3b544d.ERROR, "error"), $2ef812b47e0043d3$var$_obj);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $2ef812b47e0043d3$var$defaultLogHandler = function(instance, logType) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _console;
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $2ef812b47e0043d3$var$ConsoleMethod[logType];
    if (method) (_console = console)[method].apply(_console, [
        "[".concat(now, "]  ").concat(instance.name, ":")
    ].concat((0, $1UA6e._)(args)));
    else throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
};
var $2ef812b47e0043d3$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    "use strict";
    function Logger(name) {
        (0, $lfBxf._)(this, Logger);
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $2ef812b47e0043d3$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $2ef812b47e0043d3$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $2ef812b47e0043d3$var$instances.push(this);
    }
    (0, $9tzan._)(Logger, [
        {
            key: "logLevel",
            get: function get() {
                return this._logLevel;
            },
            set: function set(val) {
                if (!(val in $2ef812b47e0043d3$export$243e62d78d3b544d)) throw new TypeError('Invalid value "'.concat(val, '" assigned to `logLevel`'));
                this._logLevel = val;
            }
        },
        {
            // Workaround for setter/getter having to be the same type.
            key: "setLogLevel",
            value: function setLogLevel(val) {
                this._logLevel = typeof val === "string" ? $2ef812b47e0043d3$var$levelStringToEnum[val] : val;
            }
        },
        {
            key: "logHandler",
            get: function get() {
                return this._logHandler;
            },
            set: function set(val) {
                if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
                this._logHandler = val;
            }
        },
        {
            key: "userLogHandler",
            get: function get() {
                return this._userLogHandler;
            },
            set: function set(val) {
                this._userLogHandler = val;
            }
        },
        {
            /**
     * The functions below are all based on the `console` interface
     */ key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.DEBUG
                ].concat((0, $1UA6e._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.DEBUG
                ].concat((0, $1UA6e._)(args)));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $1UA6e._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $1UA6e._)(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.INFO
                ].concat((0, $1UA6e._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.INFO
                ].concat((0, $1UA6e._)(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.WARN
                ].concat((0, $1UA6e._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.WARN
                ].concat((0, $1UA6e._)(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.ERROR
                ].concat((0, $1UA6e._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $2ef812b47e0043d3$export$243e62d78d3b544d.ERROR
                ].concat((0, $1UA6e._)(args)));
            }
        }
    ]);
    return Logger;
}();
function $2ef812b47e0043d3$export$c622e99c0ce7b1c9(level) {
    $2ef812b47e0043d3$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $2ef812b47e0043d3$export$29577d29c84db5f6(logCallback, options) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var instance = _step.value;
            var customLogLevel = null;
            if (options && options.level) customLogLevel = $2ef812b47e0043d3$var$levelStringToEnum[options.level];
            if (logCallback === null) instance.userLogHandler = null;
            else instance.userLogHandler = function(instance, level) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var message = args.map(function(arg) {
                    if (arg == null) return null;
                    else if (typeof arg === "string") return arg;
                    else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                    else if (arg instanceof Error) return arg.message;
                    else try {
                        return JSON.stringify(arg);
                    } catch (ignored) {
                        return null;
                    }
                }).filter(function(arg) {
                    return arg;
                }).join(" ");
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                    level: $2ef812b47e0043d3$export$243e62d78d3b544d[level].toLowerCase(),
                    message: message,
                    args: args,
                    type: instance.name
                });
            };
        };
        for(var _iterator = $2ef812b47e0043d3$var$instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}







var $1UA6e = parcelRequire("1UA6e");


var $1UA6e = parcelRequire("1UA6e");
var $347c2fa4e49a3a20$export$23f2a1d2818174ef = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var $347c2fa4e49a3a20$var$idbProxyableTypes;
var $347c2fa4e49a3a20$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $347c2fa4e49a3a20$var$getIdbProxyableTypes() {
    return $347c2fa4e49a3a20$var$idbProxyableTypes || ($347c2fa4e49a3a20$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $347c2fa4e49a3a20$var$getCursorAdvanceMethods() {
    return $347c2fa4e49a3a20$var$cursorAdvanceMethods || ($347c2fa4e49a3a20$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var $347c2fa4e49a3a20$var$cursorRequestMap = new WeakMap();
var $347c2fa4e49a3a20$var$transactionDoneMap = new WeakMap();
var $347c2fa4e49a3a20$var$transactionStoreNamesMap = new WeakMap();
var $347c2fa4e49a3a20$var$transformCache = new WeakMap();
var $347c2fa4e49a3a20$export$407448d2b89b1813 = new WeakMap();
function $347c2fa4e49a3a20$var$promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        var success = function() {
            resolve($347c2fa4e49a3a20$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $347c2fa4e49a3a20$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $347c2fa4e49a3a20$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $347c2fa4e49a3a20$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($347c2fa4e49a3a20$var$transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $347c2fa4e49a3a20$var$transactionDoneMap.set(tx, done);
}
var $347c2fa4e49a3a20$var$idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $347c2fa4e49a3a20$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $347c2fa4e49a3a20$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $347c2fa4e49a3a20$export$efccba1c4a2ef57b(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $347c2fa4e49a3a20$export$43caf9889c228507(callback) {
    $347c2fa4e49a3a20$var$idbProxyTraps = callback($347c2fa4e49a3a20$var$idbProxyTraps);
}
function $347c2fa4e49a3a20$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            $347c2fa4e49a3a20$export$3b14a55fb2447963(this),
            storeNames
        ].concat((0, $1UA6e._)(args)));
        $347c2fa4e49a3a20$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $347c2fa4e49a3a20$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($347c2fa4e49a3a20$var$getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($347c2fa4e49a3a20$export$3b14a55fb2447963(this), args);
        return $347c2fa4e49a3a20$export$efccba1c4a2ef57b($347c2fa4e49a3a20$var$cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $347c2fa4e49a3a20$export$efccba1c4a2ef57b(func.apply($347c2fa4e49a3a20$export$3b14a55fb2447963(this), args));
    };
}
function $347c2fa4e49a3a20$var$transformCachableValue(value) {
    if (typeof value === "function") return $347c2fa4e49a3a20$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $347c2fa4e49a3a20$var$cacheDonePromiseForTransaction(value);
    if ($347c2fa4e49a3a20$export$23f2a1d2818174ef(value, $347c2fa4e49a3a20$var$getIdbProxyableTypes())) return new Proxy(value, $347c2fa4e49a3a20$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $347c2fa4e49a3a20$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $347c2fa4e49a3a20$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($347c2fa4e49a3a20$var$transformCache.has(value)) return $347c2fa4e49a3a20$var$transformCache.get(value);
    var newValue = $347c2fa4e49a3a20$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $347c2fa4e49a3a20$var$transformCache.set(value, newValue);
        $347c2fa4e49a3a20$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
var $347c2fa4e49a3a20$export$3b14a55fb2447963 = function(value) {
    return $347c2fa4e49a3a20$export$407448d2b89b1813.get(value);
};


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $69c658ad764e255d$export$ca0ed41b1a2af7e(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, $347c2fa4e49a3a20$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", function(event) {
        upgrade((0, $347c2fa4e49a3a20$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $347c2fa4e49a3a20$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event);
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener("close", function() {
            return terminated();
        });
        if (blocking) db.addEventListener("versionchange", function(event) {
            return blocking(event.oldVersion, event.newVersion, event);
        });
    }).catch(function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $69c658ad764e255d$export$9d6df0ac66a98bb2(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event);
    });
    return (0, $347c2fa4e49a3a20$export$efccba1c4a2ef57b)(request).then(function() {
        return undefined;
    });
}
var $69c658ad764e255d$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
var $69c658ad764e255d$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
var $69c658ad764e255d$var$cachedMethods = new Map();
function $69c658ad764e255d$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($69c658ad764e255d$var$cachedMethods.get(prop)) return $69c658ad764e255d$var$cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, "");
    var useIndex = prop !== targetFuncName;
    var isWrite = $69c658ad764e255d$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $69c658ad764e255d$var$readMethods.includes(targetFuncName))) return;
    var method = function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(storeName) {
            var _len, args, _key, _target, tx, _$target;
            var _arguments = arguments;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
                        tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            Promise.all([
                                (_target = _$target)[targetFuncName].apply(_target, (0, $1UA6e._)(args)),
                                isWrite && tx.done
                            ])
                        ];
                    case 1:
                        // Must reject if op rejects.
                        // If it's a write operation, must reject if tx.done rejects.
                        // Must reject with op rejection first.
                        // Must resolve with op value.
                        // Must handle both promises (no unhandled rejections)
                        return [
                            2,
                            _state.sent()[0]
                        ];
                }
            });
        });
        return function method(storeName) {
            return _ref.apply(this, arguments);
        };
    }();
    $69c658ad764e255d$var$cachedMethods.set(prop, method);
    return method;
}
(0, $347c2fa4e49a3a20$export$43caf9889c228507)(function(oldTraps) {
    return (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return $69c658ad764e255d$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!$69c658ad764e255d$var$getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $43ffc92b683abcf2$var$PlatformLoggerServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function PlatformLoggerServiceImpl(container) {
        (0, $lfBxf._)(this, PlatformLoggerServiceImpl);
        this.container = container;
    }
    (0, $9tzan._)(PlatformLoggerServiceImpl, [
        {
            // In initial implementation, this will be called by installations on
            // auth token refresh, and installations will send this string.
            key: "getPlatformInfoString",
            value: function getPlatformInfoString() {
                var providers = this.container.getProviders();
                // Loop through providers and get library/version pairs from any that are
                // version components.
                return providers.map(function(provider) {
                    if ($43ffc92b683abcf2$var$isVersionServiceProvider(provider)) {
                        var service = provider.getImmediate();
                        return "".concat(service.library, "/").concat(service.version);
                    } else return null;
                }).filter(function(logString) {
                    return logString;
                }).join(" ");
            }
        }
    ]);
    return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $43ffc92b683abcf2$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
var $43ffc92b683abcf2$var$name$o = "@firebase/app";
var $43ffc92b683abcf2$var$version$1 = "0.9.23";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $43ffc92b683abcf2$var$logger = new (0, $2ef812b47e0043d3$export$efa9a398d6368992)("@firebase/app");
var $43ffc92b683abcf2$var$name$n = "@firebase/app-compat";
var $43ffc92b683abcf2$var$name$m = "@firebase/analytics-compat";
var $43ffc92b683abcf2$var$name$l = "@firebase/analytics";
var $43ffc92b683abcf2$var$name$k = "@firebase/app-check-compat";
var $43ffc92b683abcf2$var$name$j = "@firebase/app-check";
var $43ffc92b683abcf2$var$name$i = "@firebase/auth";
var $43ffc92b683abcf2$var$name$h = "@firebase/auth-compat";
var $43ffc92b683abcf2$var$name$g = "@firebase/database";
var $43ffc92b683abcf2$var$name$f = "@firebase/database-compat";
var $43ffc92b683abcf2$var$name$e = "@firebase/functions";
var $43ffc92b683abcf2$var$name$d = "@firebase/functions-compat";
var $43ffc92b683abcf2$var$name$c = "@firebase/installations";
var $43ffc92b683abcf2$var$name$b = "@firebase/installations-compat";
var $43ffc92b683abcf2$var$name$a = "@firebase/messaging";
var $43ffc92b683abcf2$var$name$9 = "@firebase/messaging-compat";
var $43ffc92b683abcf2$var$name$8 = "@firebase/performance";
var $43ffc92b683abcf2$var$name$7 = "@firebase/performance-compat";
var $43ffc92b683abcf2$var$name$6 = "@firebase/remote-config";
var $43ffc92b683abcf2$var$name$5 = "@firebase/remote-config-compat";
var $43ffc92b683abcf2$var$name$4 = "@firebase/storage";
var $43ffc92b683abcf2$var$name$3 = "@firebase/storage-compat";
var $43ffc92b683abcf2$var$name$2 = "@firebase/firestore";
var $43ffc92b683abcf2$var$name$1 = "@firebase/firestore-compat";
var $43ffc92b683abcf2$var$name = "firebase";
var $43ffc92b683abcf2$var$version = "10.6.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ var $43ffc92b683abcf2$export$9f30fa0c10967f7f = "[DEFAULT]";
var $43ffc92b683abcf2$var$_obj;
var $43ffc92b683abcf2$var$PLATFORM_LOG_STRING = ($43ffc92b683abcf2$var$_obj = {}, (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$o, "fire-core"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$n, "fire-core-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$l, "fire-analytics"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$m, "fire-analytics-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$j, "fire-app-check"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$k, "fire-app-check-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$i, "fire-auth"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$h, "fire-auth-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$g, "fire-rtdb"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$f, "fire-rtdb-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$e, "fire-fn"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$d, "fire-fn-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$c, "fire-iid"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$b, "fire-iid-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$a, "fire-fcm"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$9, "fire-fcm-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$8, "fire-perf"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$7, "fire-perf-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$6, "fire-rc"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$5, "fire-rc-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$4, "fire-gcs"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$3, "fire-gcs-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$2, "fire-fst"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name$1, "fire-fst-compat"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, "fire-js", "fire-js"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj, $43ffc92b683abcf2$var$name, "fire-js-all"), $43ffc92b683abcf2$var$_obj);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $43ffc92b683abcf2$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $43ffc92b683abcf2$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $43ffc92b683abcf2$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $43ffc92b683abcf2$var$logger.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e);
    }
}
/**
 *
 * @internal
 */ function $43ffc92b683abcf2$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $43ffc92b683abcf2$export$c930050e7bb63965(component) {
    var componentName = component.name;
    if ($43ffc92b683abcf2$export$9566bce3835c0f28.has(componentName)) {
        $43ffc92b683abcf2$var$logger.debug("There were multiple attempts to register component ".concat(componentName, "."));
        return false;
    }
    $43ffc92b683abcf2$export$9566bce3835c0f28.set(componentName, component);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add the component to existing app instances
        for(var _iterator = $43ffc92b683abcf2$export$b4e3c36c855b14b5.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var app = _step.value;
            $43ffc92b683abcf2$export$fa5244b94c62d36a(app, component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $43ffc92b683abcf2$export$fa0d6da0f5838f50(app, name) {
    var heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $43ffc92b683abcf2$export$48d18de2ff1c45a5(app, name) {
    var instanceIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $43ffc92b683abcf2$export$9f30fa0c10967f7f;
    $43ffc92b683abcf2$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $43ffc92b683abcf2$export$3685d89b9c3cdfaf() {
    $43ffc92b683abcf2$export$9566bce3835c0f28.clear();
}
var $43ffc92b683abcf2$var$_obj1;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $43ffc92b683abcf2$var$ERRORS = ($43ffc92b683abcf2$var$_obj1 = {}, (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "no-app" /* AppError.NO_APP */ , "No Firebase App '{$appName}' has been created - call initializeApp() first"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "bad-app-name" /* AppError.BAD_APP_NAME */ , "Illegal App name: '{$appName}"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "duplicate-app" /* AppError.DUPLICATE_APP */ , "Firebase App named '{$appName}' already exists with different options or config"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "app-deleted" /* AppError.APP_DELETED */ , "Firebase App named '{$appName}' already deleted"), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "no-options" /* AppError.NO_OPTIONS */ , "Need to provide options, when not being deployed to hosting via source."), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , "firebase.{$appName}() takes either no argument or a Firebase App instance."), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ , "First argument to `onLog` must be null or a function."), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "idb-open" /* AppError.IDB_OPEN */ , "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}."), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "idb-get" /* AppError.IDB_GET */ , "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}."), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "idb-set" /* AppError.IDB_WRITE */ , "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}."), (0, $azcHm._)($43ffc92b683abcf2$var$_obj1, "idb-delete" /* AppError.IDB_DELETE */ , "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."), $43ffc92b683abcf2$var$_obj1);
var $43ffc92b683abcf2$var$ERROR_FACTORY = new (0, $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40)("app", "Firebase", $43ffc92b683abcf2$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $43ffc92b683abcf2$var$FirebaseAppImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseAppImpl(options, config, container) {
        var _this = this;
        (0, $lfBxf._)(this, FirebaseAppImpl);
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("app", function() {
            return _this;
        }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    (0, $9tzan._)(FirebaseAppImpl, [
        {
            key: "automaticDataCollectionEnabled",
            get: function get() {
                this.checkDestroyed();
                return this._automaticDataCollectionEnabled;
            },
            set: function set(val) {
                this.checkDestroyed();
                this._automaticDataCollectionEnabled = val;
            }
        },
        {
            key: "name",
            get: function get() {
                this.checkDestroyed();
                return this._name;
            }
        },
        {
            key: "options",
            get: function get() {
                this.checkDestroyed();
                return this._options;
            }
        },
        {
            key: "config",
            get: function get() {
                this.checkDestroyed();
                return this._config;
            }
        },
        {
            key: "container",
            get: function get() {
                return this._container;
            }
        },
        {
            key: "isDeleted",
            get: function get() {
                return this._isDeleted;
            },
            set: function set(val) {
                this._isDeleted = val;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
                    appName: this._name
                });
            }
        }
    ]);
    return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ var $43ffc92b683abcf2$export$31499a9cd224b78c = $43ffc92b683abcf2$var$version;
function $43ffc92b683abcf2$export$c55cfd413944906d(_options) {
    var rawConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = _options;
    if (typeof rawConfig !== "object") {
        var name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    var config = Object.assign({
        name: $43ffc92b683abcf2$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    var name1 = config.name;
    if (typeof name1 !== "string" || !name1) throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name1)
    });
    options || (options = (0, $4aa7d5a8ca32ac7d$export$3dfb6827a9f89756)());
    if (!options) throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    var existingApp = $43ffc92b683abcf2$export$b4e3c36c855b14b5.get(name1);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $4aa7d5a8ca32ac7d$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $4aa7d5a8ca32ac7d$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name1
        });
    }
    var container = new (0, $761466ca98ea5fb8$export$436a80eea5d5c0c5)(name1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $43ffc92b683abcf2$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $43ffc92b683abcf2$var$FirebaseAppImpl(options, config, container);
    $43ffc92b683abcf2$export$b4e3c36c855b14b5.set(name1, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $43ffc92b683abcf2$export$f9962582c9e66d99() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $43ffc92b683abcf2$export$9f30fa0c10967f7f;
    var app = $43ffc92b683abcf2$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $43ffc92b683abcf2$export$9f30fa0c10967f7f && (0, $4aa7d5a8ca32ac7d$export$3dfb6827a9f89756)()) return $43ffc92b683abcf2$export$c55cfd413944906d();
    if (!app) throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $43ffc92b683abcf2$export$68ddedf7d44b3bdf() {
    return Array.from($43ffc92b683abcf2$export$b4e3c36c855b14b5.values());
}
function $43ffc92b683abcf2$export$6eec44aa53d5ea34(app) {
    return $43ffc92b683abcf2$var$_deleteApp.apply(this, arguments);
}
function $43ffc92b683abcf2$var$_deleteApp() {
    $43ffc92b683abcf2$var$_deleteApp = /**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(app) {
        var name;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    name = app.name;
                    if (!$43ffc92b683abcf2$export$b4e3c36c855b14b5.has(name)) return [
                        3,
                        2
                    ];
                    $43ffc92b683abcf2$export$b4e3c36c855b14b5.delete(name);
                    return [
                        4,
                        Promise.all(app.container.getProviders().map(function(provider) {
                            return provider.delete();
                        }))
                    ];
                case 1:
                    _state.sent();
                    app.isDeleted = true;
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $43ffc92b683abcf2$var$_deleteApp.apply(this, arguments);
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $43ffc92b683abcf2$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    var library = (_a = $43ffc92b683abcf2$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += "-".concat(variant);
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        var warning = [
            'Unable to register library "'.concat(library, '" with version "').concat(version, '":')
        ];
        if (libraryMismatch) warning.push('library name "'.concat(library, '" contains illegal characters (whitespace or "/")'));
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push('version name "'.concat(version, '" contains illegal characters (whitespace or "/")'));
        $43ffc92b683abcf2$var$logger.warn(warning.join(" "));
        return;
    }
    $43ffc92b683abcf2$export$c930050e7bb63965(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("".concat(library, "-version"), function() {
        return {
            library: library,
            version: version
        };
    }, "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $43ffc92b683abcf2$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $2ef812b47e0043d3$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $43ffc92b683abcf2$export$c622e99c0ce7b1c9(logLevel) {
    (0, $2ef812b47e0043d3$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $43ffc92b683abcf2$var$DB_NAME = "firebase-heartbeat-database";
var $43ffc92b683abcf2$var$DB_VERSION = 1;
var $43ffc92b683abcf2$var$STORE_NAME = "firebase-heartbeat-store";
var $43ffc92b683abcf2$var$dbPromise = null;
function $43ffc92b683abcf2$var$getDbPromise() {
    if (!$43ffc92b683abcf2$var$dbPromise) $43ffc92b683abcf2$var$dbPromise = (0, $69c658ad764e255d$export$ca0ed41b1a2af7e)($43ffc92b683abcf2$var$DB_NAME, $43ffc92b683abcf2$var$DB_VERSION, {
        upgrade: function(db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($43ffc92b683abcf2$var$STORE_NAME);
            }
        }
    }).catch(function(e) {
        throw $43ffc92b683abcf2$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $43ffc92b683abcf2$var$dbPromise;
}
function $43ffc92b683abcf2$var$readHeartbeatsFromIndexedDB(app) {
    return $43ffc92b683abcf2$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $43ffc92b683abcf2$var$_readHeartbeatsFromIndexedDB() {
    $43ffc92b683abcf2$var$_readHeartbeatsFromIndexedDB = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(app) {
        var db, result, e, idbGetError;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $43ffc92b683abcf2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    return [
                        4,
                        db.transaction($43ffc92b683abcf2$var$STORE_NAME).objectStore($43ffc92b683abcf2$var$STORE_NAME).get($43ffc92b683abcf2$var$computeKey(app))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 3:
                    e = _state.sent();
                    if (e instanceof (0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56)) $43ffc92b683abcf2$var$logger.warn(e.message);
                    else {
                        idbGetError = $43ffc92b683abcf2$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $43ffc92b683abcf2$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $43ffc92b683abcf2$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $43ffc92b683abcf2$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    return $43ffc92b683abcf2$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $43ffc92b683abcf2$var$_writeHeartbeatsToIndexedDB() {
    $43ffc92b683abcf2$var$_writeHeartbeatsToIndexedDB = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(app, heartbeatObject) {
        var db, tx, objectStore, e, idbGetError;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $43ffc92b683abcf2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($43ffc92b683abcf2$var$STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($43ffc92b683abcf2$var$STORE_NAME);
                    return [
                        4,
                        objectStore.put(heartbeatObject, $43ffc92b683abcf2$var$computeKey(app))
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56)) $43ffc92b683abcf2$var$logger.warn(e.message);
                    else {
                        idbGetError = $43ffc92b683abcf2$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $43ffc92b683abcf2$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $43ffc92b683abcf2$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $43ffc92b683abcf2$var$computeKey(app) {
    return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $43ffc92b683abcf2$var$MAX_HEADER_BYTES = 1024;
// 30 days
var $43ffc92b683abcf2$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
var $43ffc92b683abcf2$var$HeartbeatServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatServiceImpl(container) {
        var _this = this;
        (0, $lfBxf._)(this, HeartbeatServiceImpl);
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        var app = this.container.getProvider("app").getImmediate();
        this._storage = new $43ffc92b683abcf2$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(function(result) {
            _this._heartbeatsCache = result;
            return result;
        });
    }
    (0, $9tzan._)(HeartbeatServiceImpl, [
        {
            key: "triggerHeartbeat",
            value: /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ function triggerHeartbeat() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, platformLogger, agent, date;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                platformLogger = _this.container.getProvider("platform-logger").getImmediate();
                                // This is the "Firebase user agent" string from the platform logger
                                // service, not the browser user agent.
                                agent = platformLogger.getPlatformInfoString();
                                date = $43ffc92b683abcf2$var$getUTCDateString();
                                if (!(((_a = _this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _this._heartbeatsCache = _state.sent();
                                _state.label = 2;
                            case 2:
                                // Do not store a heartbeat if one is already stored for this day
                                // or if a header has already been sent today.
                                if (_this._heartbeatsCache.lastSentHeartbeatDate === date || _this._heartbeatsCache.heartbeats.some(function(singleDateHeartbeat) {
                                    return singleDateHeartbeat.date === date;
                                })) return [
                                    2
                                ];
                                else // There is no entry for this date. Create one.
                                _this._heartbeatsCache.heartbeats.push({
                                    date: date,
                                    agent: agent
                                });
                                // Remove entries older than 30 days.
                                _this._heartbeatsCache.heartbeats = _this._heartbeatsCache.heartbeats.filter(function(singleDateHeartbeat) {
                                    var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                                    var now = Date.now();
                                    return now - hbTimestamp <= $43ffc92b683abcf2$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                                });
                                return [
                                    2,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHeartbeatsHeader",
            value: /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ function getHeartbeatsHeader() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, date, _extractHeartbeatsForHeader, heartbeatsToSend, unsentEntries, headerString;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // If it's still null or the array is empty, there is no data to send.
                                if (((_a = _this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || _this._heartbeatsCache.heartbeats.length === 0) return [
                                    2,
                                    ""
                                ];
                                date = $43ffc92b683abcf2$var$getUTCDateString();
                                // Extract as many heartbeats from the cache as will fit under the size limit.
                                _extractHeartbeatsForHeader = $43ffc92b683abcf2$var$extractHeartbeatsForHeader(_this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsForHeader.heartbeatsToSend, unsentEntries = _extractHeartbeatsForHeader.unsentEntries;
                                headerString = (0, $4aa7d5a8ca32ac7d$export$4b5284a3025a455)(JSON.stringify({
                                    version: 2,
                                    heartbeats: heartbeatsToSend
                                }));
                                // Store last sent date to prevent another being logged/sent for the same day.
                                _this._heartbeatsCache.lastSentHeartbeatDate = date;
                                if (!(unsentEntries.length > 0)) return [
                                    3,
                                    4
                                ];
                                // Store any unsent entries if they exist.
                                _this._heartbeatsCache.heartbeats = unsentEntries;
                                // This seems more likely than emptying the array (below) to lead to some odd state
                                // since the cache isn't empty and this will be called again on the next request,
                                // and is probably safest if we await it.
                                return [
                                    4,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this._heartbeatsCache.heartbeats = [];
                                // Do not wait for this, to reduce latency.
                                _this._storage.overwrite(_this._heartbeatsCache);
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    headerString
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatServiceImpl;
}();
function $43ffc92b683abcf2$var$getUTCDateString() {
    var today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $43ffc92b683abcf2$var$extractHeartbeatsForHeader(heartbeatsCache) {
    var maxSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $43ffc92b683abcf2$var$MAX_HEADER_BYTES;
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    var heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    var unsentEntries = heartbeatsCache.slice();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var singleDateHeartbeat = _step.value;
            // Look for an existing entry with the same user agent.
            var heartbeatEntry = heartbeatsToSend.find(function(hb) {
                return hb.agent === singleDateHeartbeat.agent;
            });
            if (!heartbeatEntry) {
                // If no entry for this user agent exists, create one.
                heartbeatsToSend.push({
                    agent: singleDateHeartbeat.agent,
                    dates: [
                        singleDateHeartbeat.date
                    ]
                });
                if ($43ffc92b683abcf2$var$countBytes(heartbeatsToSend) > maxSize) {
                    // If the header would exceed max size, remove the added heartbeat
                    // entry and stop adding to the header.
                    heartbeatsToSend.pop();
                    return "break";
                }
            } else {
                heartbeatEntry.dates.push(singleDateHeartbeat.date);
                // If the header would exceed max size, remove the added date
                // and stop adding to the header.
                if ($43ffc92b683abcf2$var$countBytes(heartbeatsToSend) > maxSize) {
                    heartbeatEntry.dates.pop();
                    return "break";
                }
            }
            // Pop unsent entry from queue. (Skipped if adding the entry exceeded
            // quota and the loop breaks early.)
            unsentEntries = unsentEntries.slice(1);
        };
        for(var _iterator = heartbeatsCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
var $43ffc92b683abcf2$var$HeartbeatStorageImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatStorageImpl(app) {
        (0, $lfBxf._)(this, HeartbeatStorageImpl);
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    (0, $9tzan._)(HeartbeatStorageImpl, [
        {
            key: "runIndexedDBEnvironmentCheck",
            value: function runIndexedDBEnvironmentCheck() {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        if (!(0, $4aa7d5a8ca32ac7d$export$3865db50535c2055)()) return [
                            2,
                            false
                        ];
                        else return [
                            2,
                            (0, $4aa7d5a8ca32ac7d$export$a8a3018f3d187a4d)().then(function() {
                                return true;
                            }).catch(function() {
                                return false;
                            })
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "read",
            value: /**
     * Read all heartbeats.
     */ function read() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var canUseIndexedDB, idbHeartbeatObject;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                            case 2:
                                return [
                                    4,
                                    $43ffc92b683abcf2$var$readHeartbeatsFromIndexedDB(_this.app)
                                ];
                            case 3:
                                idbHeartbeatObject = _state.sent();
                                return [
                                    2,
                                    idbHeartbeatObject || {
                                        heartbeats: []
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "overwrite",
            value: // overwrite the storage with the provided heartbeats
            function overwrite(heartbeatsObject) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $43ffc92b683abcf2$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: heartbeatsObject.heartbeats
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "add",
            value: // add heartbeats
            function add(heartbeatsObject) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $43ffc92b683abcf2$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: (0, $1UA6e._)(existingHeartbeatsObject.heartbeats).concat((0, $1UA6e._)(heartbeatsObject.heartbeats))
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $43ffc92b683abcf2$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $4aa7d5a8ca32ac7d$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $43ffc92b683abcf2$var$registerCoreComponents(variant) {
    $43ffc92b683abcf2$export$c930050e7bb63965(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("platform-logger", function(container) {
        return new $43ffc92b683abcf2$var$PlatformLoggerServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    $43ffc92b683abcf2$export$c930050e7bb63965(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("heartbeat", function(container) {
        return new $43ffc92b683abcf2$var$HeartbeatServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $43ffc92b683abcf2$export$d29d5299a7137abc($43ffc92b683abcf2$var$name$o, $43ffc92b683abcf2$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $43ffc92b683abcf2$export$d29d5299a7137abc($43ffc92b683abcf2$var$name$o, $43ffc92b683abcf2$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $43ffc92b683abcf2$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $43ffc92b683abcf2$var$registerCoreComponents("");


var $6a1a643d20660043$var$name = "firebase";
var $6a1a643d20660043$var$version = "10.6.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $43ffc92b683abcf2$export$d29d5299a7137abc)($6a1a643d20660043$var$name, $6a1a643d20660043$var$version, "app");



var $aIKKI = parcelRequire("aIKKI");


var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");


var $g0UjU = parcelRequire("g0UjU");

var $9Hju1 = parcelRequire("9Hju1");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");

var $hCdf1 = parcelRequire("hCdf1");






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ var $82f70d645a4b3e84$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ var $82f70d645a4b3e84$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ var $82f70d645a4b3e84$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ var $82f70d645a4b3e84$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ var $82f70d645a4b3e84$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$_debugErrorMap() {
    var _obj;
    return _obj = {}, (0, $azcHm._)(_obj, "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ , "This operation is restricted to administrators only."), (0, $azcHm._)(_obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , ""), (0, $azcHm._)(_obj, "app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ , "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console."), (0, $azcHm._)(_obj, "app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ , "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device."), (0, $azcHm._)(_obj, "captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ , "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains."), (0, $azcHm._)(_obj, "code-expired" /* AuthErrorCode.CODE_EXPIRED */ , "The SMS code has expired. Please re-send the verification code to try again."), (0, $azcHm._)(_obj, "cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ , "Cordova framework is not ready."), (0, $azcHm._)(_obj, "cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ , "This browser is not supported."), (0, $azcHm._)(_obj, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , "This credential is already associated with a different user account."), (0, $azcHm._)(_obj, "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ , "The custom token corresponds to a different audience."), (0, $azcHm._)(_obj, "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "This operation is sensitive and requires recent authentication. Log in again before retrying this request."), (0, $azcHm._)(_obj, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."), (0, $azcHm._)(_obj, "dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ , "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions."), (0, $azcHm._)(_obj, "email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ , "Multi-factor users must always have a verified email."), (0, $azcHm._)(_obj, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , "The email address is already in use by another account."), (0, $azcHm._)(_obj, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ , 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.'), (0, $azcHm._)(_obj, "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ , "The action code has expired."), (0, $azcHm._)(_obj, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ , "This operation has been cancelled due to another conflicting popup being opened."), (0, $azcHm._)(_obj, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , "An internal AuthError has occurred."), (0, $azcHm._)(_obj, "invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ , "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired."), (0, $azcHm._)(_obj, "invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ , "The mobile app identifier is not registed for the current project."), (0, $azcHm._)(_obj, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ , "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key."), (0, $azcHm._)(_obj, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $azcHm._)(_obj, "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ , "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user."), (0, $azcHm._)(_obj, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ , "The continue URL provided in the request is invalid."), (0, $azcHm._)(_obj, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme."), (0, $azcHm._)(_obj, "invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ , "The custom token format is incorrect. Please check the documentation."), (0, $azcHm._)(_obj, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ , "The provided dynamic link domain is not configured or authorized for the current project."), (0, $azcHm._)(_obj, "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ , "The email address is badly formatted."), (0, $azcHm._)(_obj, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ , "Emulator URL must start with a valid scheme (http:// or https://)."), (0, $azcHm._)(_obj, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , "Your API key is invalid, please check you have copied it correctly."), (0, $azcHm._)(_obj, "invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ , "The SHA-1 certificate hash provided is invalid."), (0, $azcHm._)(_obj, "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ , "The supplied auth credential is malformed or has expired."), (0, $azcHm._)(_obj, "invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ , "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $azcHm._)(_obj, "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ , "The request does not contain a valid proof of first factor successful sign-in."), (0, $azcHm._)(_obj, "invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ , "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers."), (0, $azcHm._)(_obj, "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ , "The OAuth client ID provided is either invalid or does not match the specified API key."), (0, $azcHm._)(_obj, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ , "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console."), (0, $azcHm._)(_obj, "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ , "The action code is invalid. This can happen if the code is malformed, expired, or has already been used."), (0, $azcHm._)(_obj, "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ , "The password is invalid or the user does not have a password."), (0, $azcHm._)(_obj, "invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ , "The specified persistence type is invalid. It can only be local, session or none."), (0, $azcHm._)(_obj, "invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ , "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code]."), (0, $azcHm._)(_obj, "invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ , "The specified provider ID is invalid."), (0, $azcHm._)(_obj, "invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ , "The email corresponding to this action failed to send as the provided recipient email address is invalid."), (0, $azcHm._)(_obj, "invalid-sender" /* AuthErrorCode.INVALID_SENDER */ , "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $azcHm._)(_obj, "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ , "The verification ID used to create the phone auth credential is invalid."), (0, $azcHm._)(_obj, "invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ , "The Auth instance's tenant ID is invalid."), (0, $azcHm._)(_obj, "login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , "Login blocked by user-provided method: {$originalMessage}"), (0, $azcHm._)(_obj, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ , "An Android Package Name must be provided if the Android App is required to be installed."), (0, $azcHm._)(_obj, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ , "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console."), (0, $azcHm._)(_obj, "missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ , "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided."), (0, $azcHm._)(_obj, "missing-verification-code" /* AuthErrorCode.MISSING_CODE */ , "The phone auth credential was created with an empty SMS verification code."), (0, $azcHm._)(_obj, "missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ , "A continue URL must be provided in the request."), (0, $azcHm._)(_obj, "missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ , "An internal AuthError has occurred."), (0, $azcHm._)(_obj, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ , "An iOS Bundle ID must be provided if an App Store ID is provided."), (0, $azcHm._)(_obj, "missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ , "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload."), (0, $azcHm._)(_obj, "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ , "A non-empty password must be provided"), (0, $azcHm._)(_obj, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ , "No second factor identifier is provided."), (0, $azcHm._)(_obj, "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ , "The request is missing proof of first factor successful sign-in."), (0, $azcHm._)(_obj, "missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ , "To send verification codes, provide a phone number for the recipient."), (0, $azcHm._)(_obj, "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ , "The phone auth credential was created with an empty verification ID."), (0, $azcHm._)(_obj, "app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ , "This instance of FirebaseApp has been deleted."), (0, $azcHm._)(_obj, "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ , "The user does not have a second factor matching the identifier provided."), (0, $azcHm._)(_obj, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , "Proof of ownership of a second factor is required to complete sign-in."), (0, $azcHm._)(_obj, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."), (0, $azcHm._)(_obj, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred."), (0, $azcHm._)(_obj, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $azcHm._)(_obj, "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ , "User was not linked to an account with the given provider."), (0, $azcHm._)(_obj, "null-user" /* AuthErrorCode.NULL_USER */ , "A null user object was provided as the argument for an operation which requires a non-null user object."), (0, $azcHm._)(_obj, "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ , "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section."), (0, $azcHm._)(_obj, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.'), (0, $azcHm._)(_obj, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ , "Unable to establish a connection with the popup. It may have been blocked by the browser."), (0, $azcHm._)(_obj, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ , "The popup has been closed by the user before finalizing the operation."), (0, $azcHm._)(_obj, "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ , "User can only be linked to one identity for the given provider."), (0, $azcHm._)(_obj, "quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ , "The project's quota for this operation has been exceeded."), (0, $azcHm._)(_obj, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ , "The redirect operation has been cancelled by the user before finalizing."), (0, $azcHm._)(_obj, "redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ , "A redirect sign-in operation is already pending."), (0, $azcHm._)(_obj, "rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ , "The request contains malformed or mismatching credentials."), (0, $azcHm._)(_obj, "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ , "The second factor is already enrolled on this account."), (0, $azcHm._)(_obj, "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ , "The maximum allowed number of second factors on a user has been exceeded."), (0, $azcHm._)(_obj, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ , "The provided tenant ID does not match the Auth instance's tenant ID"), (0, $azcHm._)(_obj, "timeout" /* AuthErrorCode.TIMEOUT */ , "The operation has timed out."), (0, $azcHm._)(_obj, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ , "The user's credential is no longer valid. The user must sign in again."), (0, $azcHm._)(_obj, "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ , "We have blocked all requests from this device due to unusual activity. Try again later."), (0, $azcHm._)(_obj, "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ , "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console."), (0, $azcHm._)(_obj, "unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ , "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor."), (0, $azcHm._)(_obj, "unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ , "The current environment does not support the specified persistence type."), (0, $azcHm._)(_obj, "unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ , "This operation is not supported in a multi-tenant context."), (0, $azcHm._)(_obj, "unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ , "The operation requires a verified email."), (0, $azcHm._)(_obj, "user-cancelled" /* AuthErrorCode.USER_CANCELLED */ , "The user did not grant your application the permissions it requested."), (0, $azcHm._)(_obj, "user-not-found" /* AuthErrorCode.USER_DELETED */ , "There is no user record corresponding to this identifier. The user may have been deleted."), (0, $azcHm._)(_obj, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , "The user account has been disabled by an administrator."), (0, $azcHm._)(_obj, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ , "The supplied credentials do not correspond to the previously signed in user."), (0, $azcHm._)(_obj, "user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ , ""), (0, $azcHm._)(_obj, "weak-password" /* AuthErrorCode.WEAK_PASSWORD */ , "The password must be 6 characters long or more."), (0, $azcHm._)(_obj, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ , "This browser is not supported or 3rd party cookies and data may be disabled."), (0, $azcHm._)(_obj, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ , "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."), (0, $azcHm._)(_obj, "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is missing when sending request to the backend."), (0, $azcHm._)(_obj, "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is invalid when sending request to the backend."), (0, $azcHm._)(_obj, "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ , "The reCAPTCHA action is invalid when sending request to the backend."), (0, $azcHm._)(_obj, "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ , "reCAPTCHA Enterprise integration is not enabled for this project."), (0, $azcHm._)(_obj, "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ , "The reCAPTCHA client type is missing when sending request to the backend."), (0, $azcHm._)(_obj, "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ , "The reCAPTCHA version is missing when sending request to the backend."), (0, $azcHm._)(_obj, "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ , "Invalid request parameters."), (0, $azcHm._)(_obj, "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ , "The reCAPTCHA version is invalid when sending request to the backend."), (0, $azcHm._)(_obj, "unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK."), (0, $azcHm._)(_obj, "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "The password does not meet the requirements."), _obj;
}
function $82f70d645a4b3e84$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return (0, $azcHm._)({}, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.");
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $82f70d645a4b3e84$export$2329c99376c9d0a4 = $82f70d645a4b3e84$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $82f70d645a4b3e84$export$7f8ddf7c7c20b3cd = $82f70d645a4b3e84$var$_prodErrorMap;
var $82f70d645a4b3e84$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40)("auth", "Firebase", $82f70d645a4b3e84$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ var $82f70d645a4b3e84$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$logClient = new (0, $2ef812b47e0043d3$export$efa9a398d6368992)("@firebase/auth");
function $82f70d645a4b3e84$var$_logWarn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($82f70d645a4b3e84$var$logClient.logLevel <= (0, $2ef812b47e0043d3$export$243e62d78d3b544d).WARN) (_logClient = $82f70d645a4b3e84$var$logClient).warn.apply(_logClient, [
        "Auth (".concat((0, $43ffc92b683abcf2$export$31499a9cd224b78c), "): ").concat(msg)
    ].concat((0, $1UA6e._)(args)));
}
function $82f70d645a4b3e84$var$_logError(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($82f70d645a4b3e84$var$logClient.logLevel <= (0, $2ef812b47e0043d3$export$243e62d78d3b544d).ERROR) (_logClient = $82f70d645a4b3e84$var$logClient).error.apply(_logClient, [
        "Auth (".concat((0, $43ffc92b683abcf2$export$31499a9cd224b78c), "): ").concat(msg)
    ].concat((0, $1UA6e._)(args)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$export$9fa96a7d116ea3ce(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    throw $82f70d645a4b3e84$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $1UA6e._)(rest)));
}
function $82f70d645a4b3e84$export$9d398bebfec1c039(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    return $82f70d645a4b3e84$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $1UA6e._)(rest)));
}
function $82f70d645a4b3e84$var$_errorWithCustomMessage(auth, code, message) {
    var errorMap = Object.assign(Object.assign({}, $82f70d645a4b3e84$export$7f8ddf7c7c20b3cd()), (0, $azcHm._)({}, code, message));
    var factory = new (0, $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $82f70d645a4b3e84$var$_assertInstanceOf(auth, object, instance) {
    var constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $82f70d645a4b3e84$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , "Type of ".concat(object.constructor.name, " does not match expected instance.") + "Did you pass a reference from a different Auth SDK?");
    }
}
function $82f70d645a4b3e84$var$createErrorInternal(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    var _DEFAULT_AUTH_ERROR_FACTORY1;
    if (typeof authOrCode !== "string") {
        var _authOrCode__errorFactory;
        var code = rest[0];
        var fullParams = (0, $1UA6e._)(rest.slice(1));
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return (_authOrCode__errorFactory = authOrCode._errorFactory).create.apply(_authOrCode__errorFactory, [
            code
        ].concat((0, $1UA6e._)(fullParams)));
    }
    return (_DEFAULT_AUTH_ERROR_FACTORY1 = $82f70d645a4b3e84$var$_DEFAULT_AUTH_ERROR_FACTORY).create.apply(_DEFAULT_AUTH_ERROR_FACTORY1, [
        authOrCode
    ].concat((0, $1UA6e._)(rest)));
}
function $82f70d645a4b3e84$export$890c4ad488842ce7(assertion, authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rest[_key - 2] = arguments[_key];
    }
    if (!assertion) throw $82f70d645a4b3e84$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $1UA6e._)(rest)));
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $82f70d645a4b3e84$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "INTERNAL ASSERTION FAILED: " + failure;
    $82f70d645a4b3e84$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $82f70d645a4b3e84$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $82f70d645a4b3e84$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $82f70d645a4b3e84$var$_isHttpOrHttps() {
    return $82f70d645a4b3e84$var$_getCurrentScheme() === "http:" || $82f70d645a4b3e84$var$_getCurrentScheme() === "https:";
}
function $82f70d645a4b3e84$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $82f70d645a4b3e84$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($82f70d645a4b3e84$var$_isHttpOrHttps() || (0, $4aa7d5a8ca32ac7d$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $82f70d645a4b3e84$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    var navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ var $82f70d645a4b3e84$var$Delay = /*#__PURE__*/ function() {
    "use strict";
    function Delay(shortDelay, longDelay) {
        (0, $lfBxf._)(this, Delay);
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $82f70d645a4b3e84$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $4aa7d5a8ca32ac7d$export$872f8323f01d7ae0)() || (0, $4aa7d5a8ca32ac7d$export$f7a1e23e542d38e3)();
    }
    (0, $9tzan._)(Delay, [
        {
            key: "get",
            value: function get() {
                if (!$82f70d645a4b3e84$var$_isOnline()) // Pick the shorter timeout.
                return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
                // If running in a mobile environment, return the long delay, otherwise
                // return the short delay.
                // This could be improved in the future to dynamically change based on other
                // variables instead of just reading the current environment.
                return this.isMobile ? this.longDelay : this.shortDelay;
            }
        }
    ]);
    return Delay;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$_emulatorUrl(config, path) {
    $82f70d645a4b3e84$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    var url = config.emulator.url;
    if (!path) return url;
    return "".concat(url).concat(path.startsWith("/") ? path.slice(1) : path);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$export$2ed0fc6709e59212 = /*#__PURE__*/ function() {
    "use strict";
    function FetchProvider() {
        (0, $lfBxf._)(this, FetchProvider);
    }
    (0, $9tzan._)(FetchProvider, null, [
        {
            key: "initialize",
            value: function initialize(fetchImpl, headersImpl, responseImpl) {
                this.fetchImpl = fetchImpl;
                if (headersImpl) this.headersImpl = headersImpl;
                if (responseImpl) this.responseImpl = responseImpl;
            }
        },
        {
            key: "fetch",
            value: function fetch1() {
                if (this.fetchImpl) return this.fetchImpl;
                if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
                if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
                if (typeof fetch !== "undefined") return fetch;
                $82f70d645a4b3e84$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "headers",
            value: function headers() {
                if (this.headersImpl) return this.headersImpl;
                if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
                if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
                if (typeof Headers !== "undefined") return Headers;
                $82f70d645a4b3e84$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "response",
            value: function response() {
                if (this.responseImpl) return this.responseImpl;
                if (typeof self !== "undefined" && "Response" in self) return self.Response;
                if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
                if (typeof Response !== "undefined") return Response;
                $82f70d645a4b3e84$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        }
    ]);
    return FetchProvider;
}();
var $82f70d645a4b3e84$var$_obj;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ var $82f70d645a4b3e84$var$SERVER_ERROR_MAP = ($82f70d645a4b3e84$var$_obj = {}, // Custom token errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ , "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ), // This can only happen if the SDK sends a bad request.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Create Auth URI errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ , "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ), // This can only happen if the SDK sends a bad request.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Sign in with email and password errors (some apply to sign up too).
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ , "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ), // This can only happen if the SDK sends a bad request.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ , "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ), // Sign up with email and password errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ , "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ , "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ), // Verify assertion for sign in with credential errors:
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ , "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ), // This can only happen if the SDK sends a bad request.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Send Password reset email errors:
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ , "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ , "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ), // This can only happen if the SDK sends a bad request.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Operations that require ID token in request:
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ , "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), // Other errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ), // Phone Auth related errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_CODE" /* ServerError.INVALID_CODE */ , "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ , "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ , "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ , "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ), // Other action code errors when additional settings passed.
// MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
// This is OK as this error will be caught by client side validation.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ , "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ , "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ), // getProjectConfig errors when clientId is passed.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ , "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ), // User actions (sign-up or deletion) disabled errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ , "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ), // Multi factor related errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ , "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ , "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ , "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ , "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ , "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ , "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ), // Blocking functions related errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Recaptcha related errors.
(0, $azcHm._)($82f70d645a4b3e84$var$_obj, "RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ , "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ , "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ , "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ , "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ , "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ , "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ , "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ), (0, $azcHm._)($82f70d645a4b3e84$var$_obj, "INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ , "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ), $82f70d645a4b3e84$var$_obj);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$DEFAULT_API_TIMEOUT_MS = new $82f70d645a4b3e84$var$Delay(30000, 60000);
function $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
function $82f70d645a4b3e84$var$_performApiRequest(auth, method, path, request) {
    return $82f70d645a4b3e84$var$__performApiRequest.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__performApiRequest() {
    $82f70d645a4b3e84$var$__performApiRequest = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, method, path, request) {
        var customErrorMap;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
            return [
                2,
                $82f70d645a4b3e84$var$_performFetchWithErrorHandling(auth, customErrorMap, /*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var body, params, query, headers;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = {};
                                params = {};
                                if (request) {
                                    if (method === "GET" /* HttpMethod.GET */ ) params = request;
                                    else body = {
                                        body: JSON.stringify(request)
                                    };
                                }
                                query = (0, $4aa7d5a8ca32ac7d$export$ac4103b836844853)(Object.assign({
                                    key: auth.config.apiKey
                                }, params)).slice(1);
                                return [
                                    4,
                                    auth._getAdditionalHeaders()
                                ];
                            case 1:
                                headers = _state.sent();
                                headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
                                if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
                                return [
                                    2,
                                    $82f70d645a4b3e84$export$2ed0fc6709e59212.fetch()($82f70d645a4b3e84$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
                                        method: method,
                                        headers: headers,
                                        referrerPolicy: "no-referrer"
                                    }, body))
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return $82f70d645a4b3e84$var$__performApiRequest.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    return $82f70d645a4b3e84$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__performFetchWithErrorHandling() {
    $82f70d645a4b3e84$var$__performFetchWithErrorHandling = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, customErrorMap, fetchFn) {
        var errorMap, networkTimeout, response, json, errorMessage, _errorMessage_split, serverErrorCode, serverErrorMessage, authError, e;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth._canInitEmulator = false;
                    errorMap = Object.assign(Object.assign({}, $82f70d645a4b3e84$var$SERVER_ERROR_MAP), customErrorMap);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    networkTimeout = new $82f70d645a4b3e84$var$NetworkTimeout(auth);
                    return [
                        4,
                        Promise.race([
                            fetchFn(),
                            networkTimeout.promise
                        ])
                    ];
                case 2:
                    response = _state.sent();
                    // If we've reached this point, the fetch succeeded and the networkTimeout
                    // didn't throw; clear the network timeout delay so that Node won't hang
                    networkTimeout.clearNetworkTimeout();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    if ("needConfirmation" in json) throw $82f70d645a4b3e84$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
                    if (response.ok && !("errorMessage" in json)) return [
                        2,
                        json
                    ];
                    else {
                        errorMessage = response.ok ? json.errorMessage : json.error.message;
                        _errorMessage_split = (0, $3tDj3._)(errorMessage.split(" : "), 2), serverErrorCode = _errorMessage_split[0], serverErrorMessage = _errorMessage_split[1];
                        if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $82f70d645a4b3e84$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
                        else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $82f70d645a4b3e84$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
                        else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $82f70d645a4b3e84$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
                        authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
                        if (serverErrorMessage) throw $82f70d645a4b3e84$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
                        else $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, authError);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56)) throw e;
                    // Changing this to a different error code will log user out when there is a network error
                    // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
                    // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
                    $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
                        "message": String(e)
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_performSignInRequest(auth, method, path, request) {
    return $82f70d645a4b3e84$var$__performSignInRequest.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__performSignInRequest() {
    $82f70d645a4b3e84$var$__performSignInRequest = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, method, path, request) {
        var customErrorMap, serverResponse;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                    return [
                        4,
                        $82f70d645a4b3e84$var$_performApiRequest(auth, method, path, request, customErrorMap)
                    ];
                case 1:
                    serverResponse = _state.sent();
                    if ("mfaPendingCredential" in serverResponse) $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
                        _serverResponse: serverResponse
                    });
                    return [
                        2,
                        serverResponse
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__performSignInRequest.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getFinalTarget(auth, host, path, query) {
    var base = "".concat(host).concat(path, "?").concat(query);
    if (!auth.config.emulator) return "".concat(auth.config.apiScheme, "://").concat(base);
    return $82f70d645a4b3e84$var$_emulatorUrl(auth.config, base);
}
function $82f70d645a4b3e84$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
var $82f70d645a4b3e84$var$NetworkTimeout = /*#__PURE__*/ function() {
    "use strict";
    function NetworkTimeout(auth) {
        var _this = this;
        (0, $lfBxf._)(this, NetworkTimeout);
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise(function(_, reject) {
            _this.timer = setTimeout(function() {
                return reject($82f70d645a4b3e84$export$9d398bebfec1c039(_this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $82f70d645a4b3e84$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    (0, $9tzan._)(NetworkTimeout, [
        {
            key: "clearNetworkTimeout",
            value: function clearNetworkTimeout() {
                clearTimeout(this.timer);
            }
        }
    ]);
    return NetworkTimeout;
}();
function $82f70d645a4b3e84$var$_makeTaggedError(auth, code, response) {
    var errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    var error = $82f70d645a4b3e84$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $82f70d645a4b3e84$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
var $82f70d645a4b3e84$var$RecaptchaConfig = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaConfig(response) {
        (0, $lfBxf._)(this, RecaptchaConfig);
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    (0, $9tzan._)(RecaptchaConfig, [
        {
            /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ key: "getProviderEnforcementState",
            value: function getProviderEnforcementState(providerStr) {
                if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.recaptchaEnforcementState[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var recaptchaEnforcementState = _step.value;
                        if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $82f70d645a4b3e84$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ key: "isProviderEnabled",
            value: function isProviderEnabled(providerStr) {
                return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
            }
        }
    ]);
    return RecaptchaConfig;
}();
function $82f70d645a4b3e84$var$getRecaptchaParams(auth) {
    return $82f70d645a4b3e84$var$_getRecaptchaParams.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getRecaptchaParams() {
    $82f70d645a4b3e84$var$_getRecaptchaParams = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().recaptchaSiteKey || ""
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_getRecaptchaParams.apply(this, arguments);
}
function $82f70d645a4b3e84$var$getRecaptchaConfig(auth, request) {
    return $82f70d645a4b3e84$var$_getRecaptchaConfig.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getRecaptchaConfig() {
    $82f70d645a4b3e84$var$_getRecaptchaConfig = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_getRecaptchaConfig.apply(this, arguments);
}
function $82f70d645a4b3e84$var$deleteAccount(auth, request) {
    return $82f70d645a4b3e84$var$_deleteAccount.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_deleteAccount() {
    $82f70d645a4b3e84$var$_deleteAccount = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_deleteAccount.apply(this, arguments);
}
function $82f70d645a4b3e84$var$deleteLinkedAccounts(auth, request) {
    return $82f70d645a4b3e84$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_deleteLinkedAccounts() {
    $82f70d645a4b3e84$var$_deleteLinkedAccounts = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $82f70d645a4b3e84$var$getAccountInfo(auth, request) {
    return $82f70d645a4b3e84$var$_getAccountInfo.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getAccountInfo() {
    $82f70d645a4b3e84$var$_getAccountInfo = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_getAccountInfo.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        var date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $82f70d645a4b3e84$export$306ddfe3a8403e2(user) {
    var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
function $82f70d645a4b3e84$export$7a38258bbe170828(user) {
    return $82f70d645a4b3e84$var$_getIdTokenResult.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getIdTokenResult() {
    $82f70d645a4b3e84$var$_getIdTokenResult = /**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user) {
        var forceRefresh, userInternal, token, claims, firebase, signInProvider;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        userInternal.getIdToken(forceRefresh)
                    ];
                case 1:
                    token = _state.sent();
                    claims = $82f70d645a4b3e84$var$_parseToken(token);
                    $82f70d645a4b3e84$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
                    signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
                    return [
                        2,
                        {
                            claims: claims,
                            token: token,
                            authTime: $82f70d645a4b3e84$var$utcTimestampToDateString($82f70d645a4b3e84$var$secondsStringToMilliseconds(claims.auth_time)),
                            issuedAtTime: $82f70d645a4b3e84$var$utcTimestampToDateString($82f70d645a4b3e84$var$secondsStringToMilliseconds(claims.iat)),
                            expirationTime: $82f70d645a4b3e84$var$utcTimestampToDateString($82f70d645a4b3e84$var$secondsStringToMilliseconds(claims.exp)),
                            signInProvider: signInProvider || null,
                            signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
                        }
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_getIdTokenResult.apply(this, arguments);
}
function $82f70d645a4b3e84$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $82f70d645a4b3e84$var$_parseToken(token) {
    var _token_split = (0, $3tDj3._)(token.split("."), 3), algorithm = _token_split[0], payload = _token_split[1], signature = _token_split[2];
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $82f70d645a4b3e84$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        var decoded = (0, $4aa7d5a8ca32ac7d$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $82f70d645a4b3e84$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $82f70d645a4b3e84$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $82f70d645a4b3e84$var$_tokenExpiresIn(token) {
    var parsedToken = $82f70d645a4b3e84$var$_parseToken(token);
    $82f70d645a4b3e84$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
function $82f70d645a4b3e84$var$_logoutIfInvalidated(user, promise) {
    return $82f70d645a4b3e84$var$__logoutIfInvalidated.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__logoutIfInvalidated() {
    $82f70d645a4b3e84$var$__logoutIfInvalidated = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, promise) {
        var bypassAuthState, e;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if (bypassAuthState) return [
                        2,
                        promise
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    if (!(e instanceof (0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56) && $82f70d645a4b3e84$var$isUserInvalidated(e))) return [
                        3,
                        5
                    ];
                    if (!(user.auth.currentUser === user)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        user.auth.signOut()
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    throw e;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__logoutIfInvalidated.apply(this, arguments);
}
function $82f70d645a4b3e84$var$isUserInvalidated(param) {
    var code = param.code;
    return code === "auth/user-disabled" /* AuthErrorCode.USER_DISABLED */  || code === "auth/user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$ProactiveRefresh = /*#__PURE__*/ function() {
    "use strict";
    function ProactiveRefresh(user) {
        (0, $lfBxf._)(this, ProactiveRefresh);
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    (0, $9tzan._)(ProactiveRefresh, [
        {
            key: "_start",
            value: function _start() {
                if (this.isRunning) return;
                this.isRunning = true;
                this.schedule();
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                if (!this.isRunning) return;
                this.isRunning = false;
                if (this.timerId !== null) clearTimeout(this.timerId);
            }
        },
        {
            key: "getInterval",
            value: function getInterval(wasError) {
                var _a;
                if (wasError) {
                    var interval = this.errorBackoff;
                    this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
                    return interval;
                } else {
                    // Reset the error backoff
                    this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
                    var expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
                    var interval1 = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
                    return Math.max(0, interval1);
                }
            }
        },
        {
            key: "schedule",
            value: function schedule() {
                var wasError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.isRunning) // Just in case...
                return;
                var interval = this.getInterval(wasError);
                var _this = this;
                this.timerId = setTimeout(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.iteration()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }), interval);
            }
        },
        {
            key: "iteration",
            value: function iteration() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.user.getIdToken(true)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                // Only retry on network errors
                                if ((e === null || e === void 0 ? void 0 : e.code) === "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) _this.schedule(/* wasError */ true);
                                return [
                                    2
                                ];
                            case 3:
                                _this.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProactiveRefresh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$UserMetadata = /*#__PURE__*/ function() {
    "use strict";
    function UserMetadata(createdAt, lastLoginAt) {
        (0, $lfBxf._)(this, UserMetadata);
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    (0, $9tzan._)(UserMetadata, [
        {
            key: "_initializeTime",
            value: function _initializeTime() {
                this.lastSignInTime = $82f70d645a4b3e84$var$utcTimestampToDateString(this.lastLoginAt);
                this.creationTime = $82f70d645a4b3e84$var$utcTimestampToDateString(this.createdAt);
            }
        },
        {
            key: "_copy",
            value: function _copy(metadata) {
                this.createdAt = metadata.createdAt;
                this.lastLoginAt = metadata.lastLoginAt;
                this._initializeTime();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    createdAt: this.createdAt,
                    lastLoginAt: this.lastLoginAt
                };
            }
        }
    ]);
    return UserMetadata;
}();
function $82f70d645a4b3e84$var$_reloadWithoutSaving(user) {
    return $82f70d645a4b3e84$var$__reloadWithoutSaving.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__reloadWithoutSaving() {
    $82f70d645a4b3e84$var$__reloadWithoutSaving = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user) {
        var _a, auth, idToken, response, coreAccount, newProviderData, providerData, oldIsAnonymous, newIsAnonymous, isAnonymous, updates;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$_logoutIfInvalidated(user, $82f70d645a4b3e84$var$getAccountInfo(auth, {
                            idToken: idToken
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    $82f70d645a4b3e84$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    coreAccount = response.users[0];
                    user._notifyReloadListener(coreAccount);
                    newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $82f70d645a4b3e84$var$extractProviderData(coreAccount.providerUserInfo) : [];
                    providerData = $82f70d645a4b3e84$var$mergeProviderData(user.providerData, newProviderData);
                    // Preserves the non-nonymous status of the stored user, even if no more
                    // credentials (federated or email/password) are linked to the user. If
                    // the user was previously anonymous, then use provider data to update.
                    // On the other hand, if it was not anonymous before, it should never be
                    // considered anonymous now.
                    oldIsAnonymous = user.isAnonymous;
                    newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
                    isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
                    updates = {
                        uid: coreAccount.localId,
                        displayName: coreAccount.displayName || null,
                        photoURL: coreAccount.photoUrl || null,
                        email: coreAccount.email || null,
                        emailVerified: coreAccount.emailVerified || false,
                        phoneNumber: coreAccount.phoneNumber || null,
                        tenantId: coreAccount.tenantId || null,
                        providerData: providerData,
                        metadata: new $82f70d645a4b3e84$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
                        isAnonymous: isAnonymous
                    };
                    Object.assign(user, updates);
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__reloadWithoutSaving.apply(this, arguments);
}
function $82f70d645a4b3e84$export$d24c54395ce0c509(user) {
    return $82f70d645a4b3e84$var$_reload.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_reload() {
    $82f70d645a4b3e84$var$_reload = /**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user) {
        var userInternal;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_reloadWithoutSaving(userInternal)
                    ];
                case 1:
                    _state.sent();
                    // Even though the current user hasn't changed, update
                    // current user will trigger a persistence update w/ the
                    // new info.
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 2:
                    _state.sent();
                    userInternal.auth._notifyListenersIfCurrent(userInternal);
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_reload.apply(this, arguments);
}
function $82f70d645a4b3e84$var$mergeProviderData(original, newData) {
    var deduped = original.filter(function(o) {
        return !newData.some(function(n) {
            return n.providerId === o.providerId;
        });
    });
    return (0, $1UA6e._)(deduped).concat((0, $1UA6e._)(newData));
}
function $82f70d645a4b3e84$var$extractProviderData(providers) {
    return providers.map(function(_a) {
        var providerId = _a.providerId, provider = (0, $75cbc07a4214bd1d$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
function $82f70d645a4b3e84$var$requestStsToken(auth, refreshToken) {
    return $82f70d645a4b3e84$var$_requestStsToken.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_requestStsToken() {
    $82f70d645a4b3e84$var$_requestStsToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, refreshToken) {
        var response;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_performFetchWithErrorHandling(auth, {}, /*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                            var body, _auth_config, tokenApiHost, apiKey, url, headers;
                            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        body = (0, $4aa7d5a8ca32ac7d$export$ac4103b836844853)({
                                            "grant_type": "refresh_token",
                                            "refresh_token": refreshToken
                                        }).slice(1);
                                        _auth_config = auth.config, tokenApiHost = _auth_config.tokenApiHost, apiKey = _auth_config.apiKey;
                                        url = $82f70d645a4b3e84$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , "key=".concat(apiKey));
                                        return [
                                            4,
                                            auth._getAdditionalHeaders()
                                        ];
                                    case 1:
                                        headers = _state.sent();
                                        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
                                        return [
                                            2,
                                            $82f70d645a4b3e84$export$2ed0fc6709e59212.fetch()(url, {
                                                method: "POST" /* HttpMethod.POST */ ,
                                                headers: headers,
                                                body: body
                                            })
                                        ];
                                }
                            });
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    // The response comes back in snake_case. Convert to camel:
                    return [
                        2,
                        {
                            accessToken: response.access_token,
                            expiresIn: response.expires_in,
                            refreshToken: response.refresh_token
                        }
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_requestStsToken.apply(this, arguments);
}
function $82f70d645a4b3e84$var$revokeToken(auth, request) {
    return $82f70d645a4b3e84$var$_revokeToken.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_revokeToken() {
    $82f70d645a4b3e84$var$_revokeToken = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_revokeToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ var $82f70d645a4b3e84$var$StsTokenManager = /*#__PURE__*/ function() {
    "use strict";
    function StsTokenManager() {
        (0, $lfBxf._)(this, StsTokenManager);
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    (0, $9tzan._)(StsTokenManager, [
        {
            key: "isExpired",
            get: function get() {
                return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
            }
        },
        {
            key: "updateFromServerResponse",
            value: function updateFromServerResponse(response) {
                $82f70d645a4b3e84$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $82f70d645a4b3e84$var$_tokenExpiresIn(response.idToken);
                this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
            }
        },
        {
            key: "getToken",
            value: function getToken(auth) {
                var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $82f70d645a4b3e84$export$890c4ad488842ce7(!_this.accessToken || _this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
                                if (!forceRefresh && _this.accessToken && !_this.isExpired) return [
                                    2,
                                    _this.accessToken
                                ];
                                if (!_this.refreshToken) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.refresh(auth, _this.refreshToken)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.accessToken
                                ];
                            case 2:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearRefreshToken",
            value: function clearRefreshToken() {
                this.refreshToken = null;
            }
        },
        {
            key: "refresh",
            value: function refresh(auth, oldToken) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _ref, accessToken, refreshToken, expiresIn;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$requestStsToken(auth, oldToken)
                                ];
                            case 1:
                                _ref = _state.sent(), accessToken = _ref.accessToken, refreshToken = _ref.refreshToken, expiresIn = _ref.expiresIn;
                                _this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateTokensAndExpiration",
            value: function updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
                this.refreshToken = refreshToken || null;
                this.accessToken = accessToken || null;
                this.expirationTime = Date.now() + expiresInSec * 1000;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    refreshToken: this.refreshToken,
                    accessToken: this.accessToken,
                    expirationTime: this.expirationTime
                };
            }
        },
        {
            key: "_assign",
            value: function _assign(stsTokenManager) {
                this.accessToken = stsTokenManager.accessToken;
                this.refreshToken = stsTokenManager.refreshToken;
                this.expirationTime = stsTokenManager.expirationTime;
            }
        },
        {
            key: "_clone",
            value: function _clone() {
                return Object.assign(new StsTokenManager(), this.toJSON());
            }
        },
        {
            key: "_performRefresh",
            value: function _performRefresh() {
                return $82f70d645a4b3e84$var$debugFail("not implemented");
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(appName, object) {
                var refreshToken = object.refreshToken, accessToken = object.accessToken, expirationTime = object.expirationTime;
                var manager = new StsTokenManager();
                if (refreshToken) {
                    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.refreshToken = refreshToken;
                }
                if (accessToken) {
                    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.accessToken = accessToken;
                }
                if (expirationTime) {
                    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.expirationTime = expirationTime;
                }
                return manager;
            }
        }
    ]);
    return StsTokenManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$assertStringOrUndefined(assertion, appName) {
    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
var $82f70d645a4b3e84$export$23ebac1979863676 = /*#__PURE__*/ function() {
    "use strict";
    function UserImpl(_a) {
        (0, $lfBxf._)(this, UserImpl);
        var uid = _a.uid, auth = _a.auth, stsTokenManager = _a.stsTokenManager, opt = (0, $75cbc07a4214bd1d$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $82f70d645a4b3e84$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? (0, $1UA6e._)(opt.providerData) : [];
        this.metadata = new $82f70d645a4b3e84$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    (0, $9tzan._)(UserImpl, [
        {
            key: "getIdToken",
            value: function getIdToken(forceRefresh) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var accessToken;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_logoutIfInvalidated(_this, _this.stsTokenManager.getToken(_this.auth, forceRefresh))
                                ];
                            case 1:
                                accessToken = _state.sent();
                                $82f70d645a4b3e84$export$890c4ad488842ce7(accessToken, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                if (!(_this.accessToken !== accessToken)) return [
                                    3,
                                    3
                                ];
                                _this.accessToken = accessToken;
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 2:
                                _state.sent();
                                _this.auth._notifyListenersIfCurrent(_this);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    accessToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIdTokenResult",
            value: function getIdTokenResult1(forceRefresh) {
                return $82f70d645a4b3e84$export$7a38258bbe170828(this, forceRefresh);
            }
        },
        {
            key: "reload",
            value: function reload1() {
                return $82f70d645a4b3e84$export$d24c54395ce0c509(this);
            }
        },
        {
            key: "_assign",
            value: function _assign(user) {
                if (this === user) return;
                $82f70d645a4b3e84$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.displayName = user.displayName;
                this.photoURL = user.photoURL;
                this.email = user.email;
                this.emailVerified = user.emailVerified;
                this.phoneNumber = user.phoneNumber;
                this.isAnonymous = user.isAnonymous;
                this.tenantId = user.tenantId;
                this.providerData = user.providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                this.metadata._copy(user.metadata);
                this.stsTokenManager._assign(user.stsTokenManager);
            }
        },
        {
            key: "_clone",
            value: function _clone(auth) {
                var newUser = new UserImpl(Object.assign(Object.assign({}, this), {
                    auth: auth,
                    stsTokenManager: this.stsTokenManager._clone()
                }));
                newUser.metadata._copy(this.metadata);
                return newUser;
            }
        },
        {
            key: "_onReload",
            value: function _onReload(callback) {
                // There should only ever be one listener, and that is a single instance of MultiFactorUser
                $82f70d645a4b3e84$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.reloadListener = callback;
                if (this.reloadUserInfo) {
                    this._notifyReloadListener(this.reloadUserInfo);
                    this.reloadUserInfo = null;
                }
            }
        },
        {
            key: "_notifyReloadListener",
            value: function _notifyReloadListener(userInfo) {
                if (this.reloadListener) this.reloadListener(userInfo);
                else // If no listener is subscribed yet, save the result so it's available when they do subscribe
                this.reloadUserInfo = userInfo;
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.proactiveRefresh._start();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.proactiveRefresh._stop();
            }
        },
        {
            key: "_updateTokensIfNecessary",
            value: function _updateTokensIfNecessary(response) {
                var reload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var tokensRefreshed;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tokensRefreshed = false;
                                if (response.idToken && response.idToken !== _this.stsTokenManager.accessToken) {
                                    _this.stsTokenManager.updateFromServerResponse(response);
                                    tokensRefreshed = true;
                                }
                                if (!reload) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_reloadWithoutSaving(_this)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 3:
                                _state.sent();
                                if (tokensRefreshed) _this.auth._notifyListenersIfCurrent(_this);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var idToken;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_logoutIfInvalidated(_this, $82f70d645a4b3e84$var$deleteAccount(_this.auth, {
                                        idToken: idToken
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _this.stsTokenManager.clearRefreshToken();
                                // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
                                //       cancels pending actions...
                                return [
                                    2,
                                    _this.auth.signOut()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return Object.assign(Object.assign({
                    uid: this.uid,
                    email: this.email || undefined,
                    emailVerified: this.emailVerified,
                    displayName: this.displayName || undefined,
                    isAnonymous: this.isAnonymous,
                    photoURL: this.photoURL || undefined,
                    phoneNumber: this.phoneNumber || undefined,
                    tenantId: this.tenantId || undefined,
                    providerData: this.providerData.map(function(userInfo) {
                        return Object.assign({}, userInfo);
                    }),
                    stsTokenManager: this.stsTokenManager.toJSON(),
                    // Redirect event ID must be maintained in case there is a pending
                    // redirect event.
                    _redirectEventId: this._redirectEventId
                }, this.metadata.toJSON()), {
                    // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
                    apiKey: this.auth.config.apiKey,
                    appName: this.auth.name
                });
            }
        },
        {
            key: "refreshToken",
            get: function get() {
                return this.stsTokenManager.refreshToken || "";
            }
        }
    ], [
        {
            key: "_fromJSON",
            value: function _fromJSON(auth, object) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
                var email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
                var phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
                var photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
                var tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
                var _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
                var createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
                var lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
                var uid = object.uid, emailVerified = object.emailVerified, isAnonymous = object.isAnonymous, providerData = object.providerData, plainObjectTokenManager = object.stsTokenManager;
                $82f70d645a4b3e84$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var stsTokenManager = $82f70d645a4b3e84$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $82f70d645a4b3e84$var$assertStringOrUndefined(displayName, auth.name);
                $82f70d645a4b3e84$var$assertStringOrUndefined(email, auth.name);
                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $82f70d645a4b3e84$var$assertStringOrUndefined(phoneNumber, auth.name);
                $82f70d645a4b3e84$var$assertStringOrUndefined(photoURL, auth.name);
                $82f70d645a4b3e84$var$assertStringOrUndefined(tenantId, auth.name);
                $82f70d645a4b3e84$var$assertStringOrUndefined(_redirectEventId, auth.name);
                $82f70d645a4b3e84$var$assertStringOrUndefined(createdAt, auth.name);
                $82f70d645a4b3e84$var$assertStringOrUndefined(lastLoginAt, auth.name);
                var user = new UserImpl({
                    uid: uid,
                    auth: auth,
                    email: email,
                    emailVerified: emailVerified,
                    displayName: displayName,
                    isAnonymous: isAnonymous,
                    photoURL: photoURL,
                    phoneNumber: phoneNumber,
                    tenantId: tenantId,
                    stsTokenManager: stsTokenManager,
                    createdAt: createdAt,
                    lastLoginAt: lastLoginAt
                });
                if (providerData && Array.isArray(providerData)) user.providerData = providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                if (_redirectEventId) user._redirectEventId = _redirectEventId;
                return user;
            }
        },
        {
            key: "_fromIdTokenResponse",
            value: /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ function _fromIdTokenResponse(auth, idTokenResponse) {
                var isAnonymous = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var stsTokenManager, user;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stsTokenManager = new $82f70d645a4b3e84$var$StsTokenManager();
                                stsTokenManager.updateFromServerResponse(idTokenResponse);
                                // Initialize the Firebase Auth user.
                                user = new UserImpl({
                                    uid: idTokenResponse.localId,
                                    auth: auth,
                                    stsTokenManager: stsTokenManager,
                                    isAnonymous: isAnonymous
                                });
                                // Updates the user info and data and resolves with a user instance.
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    user
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$instanceCache = new Map();
function $82f70d645a4b3e84$export$158acd800e1ef08b(cls) {
    $82f70d645a4b3e84$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    var instance = $82f70d645a4b3e84$var$instanceCache.get(cls);
    if (instance) {
        $82f70d645a4b3e84$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $82f70d645a4b3e84$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$InMemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function InMemoryPersistence() {
        (0, $lfBxf._)(this, InMemoryPersistence);
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    (0, $9tzan._)(InMemoryPersistence, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            true
                        ];
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        _this.storage[key] = value;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var value;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        value = _this.storage[key];
                        return [
                            2,
                            value === undefined ? null : value
                        ];
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        delete _this.storage[key];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        }
    ]);
    return InMemoryPersistence;
}();
$82f70d645a4b3e84$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ var $82f70d645a4b3e84$export$3a6d5c9ae78a2c08 = $82f70d645a4b3e84$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return "firebase:".concat(key, ":").concat(apiKey, ":").concat(appName);
}
var $82f70d645a4b3e84$var$PersistenceUserManager = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceUserManager(persistence, auth, userKey) {
        (0, $lfBxf._)(this, PersistenceUserManager);
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        var _this_auth = this.auth, config = _this_auth.config, name = _this_auth.name;
        this.fullUserKey = $82f70d645a4b3e84$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $82f70d645a4b3e84$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    (0, $9tzan._)(PersistenceUserManager, [
        {
            key: "setCurrentUser",
            value: function setCurrentUser(user) {
                return this.persistence._set(this.fullUserKey, user.toJSON());
            }
        },
        {
            key: "getCurrentUser",
            value: function getCurrentUser() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var blob;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.persistence._get(_this.fullUserKey)
                                ];
                            case 1:
                                blob = _state.sent();
                                return [
                                    2,
                                    blob ? $82f70d645a4b3e84$export$23ebac1979863676._fromJSON(_this.auth, blob) : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeCurrentUser",
            value: function removeCurrentUser() {
                return this.persistence._remove(this.fullUserKey);
            }
        },
        {
            key: "savePersistenceForRedirect",
            value: function savePersistenceForRedirect() {
                return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(newPersistence) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var currentUser;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.persistence === newPersistence) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.getCurrentUser()
                                ];
                            case 1:
                                currentUser = _state.sent();
                                return [
                                    4,
                                    _this.removeCurrentUser()
                                ];
                            case 2:
                                _state.sent();
                                _this.persistence = newPersistence;
                                if (currentUser) return [
                                    2,
                                    _this.setCurrentUser(currentUser)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
            }
        }
    ], [
        {
            key: "create",
            value: function create(auth, persistenceHierarchy) {
                var userKey = arguments.length > 2 && arguments[2] !== void 0 /* KeyName.AUTH_USER */  ? arguments[2] : "authUser";
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var availablePersistences, selectedPersistence, key, userToMigrate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, persistence, blob, user, _a, err, migrationHierarchy;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!persistenceHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager($82f70d645a4b3e84$export$158acd800e1ef08b($82f70d645a4b3e84$export$3a6d5c9ae78a2c08), auth, userKey)
                                ];
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(persistence) {
                                            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            persistence._isAvailable()
                                                        ];
                                                    case 1:
                                                        if (_state.sent()) return [
                                                            2,
                                                            persistence
                                                        ];
                                                        return [
                                                            2,
                                                            undefined
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                availablePersistences = _state.sent().filter(function(persistence) {
                                    return persistence;
                                });
                                // Fall back to the first persistence listed, or in memory if none available
                                selectedPersistence = availablePersistences[0] || $82f70d645a4b3e84$export$158acd800e1ef08b($82f70d645a4b3e84$export$3a6d5c9ae78a2c08);
                                key = $82f70d645a4b3e84$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
                                // Pull out the existing user, setting the chosen persistence to that
                                // persistence if the user exists.
                                userToMigrate = null;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = persistenceHierarchy[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                persistence = _step.value;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    persistence._get(key)
                                ];
                            case 5:
                                blob = _state.sent();
                                if (blob) {
                                    user = $82f70d645a4b3e84$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                                    if (persistence !== selectedPersistence) userToMigrate = user;
                                    selectedPersistence = persistence;
                                    return [
                                        3,
                                        8
                                    ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _a = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                // If we find the user in a persistence that does support migration, use
                                // that migration path (of only persistences that support migration)
                                migrationHierarchy = availablePersistences.filter(function(p) {
                                    return p._shouldAllowMigration;
                                });
                                // If the persistence does _not_ allow migration, just finish off here
                                if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                                selectedPersistence = migrationHierarchy[0];
                                if (!userToMigrate) return [
                                    3,
                                    13
                                ];
                                // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
                                // we'll just let it bubble to surface the error.
                                return [
                                    4,
                                    selectedPersistence._set(key, userToMigrate.toJSON())
                                ];
                            case 12:
                                _state.sent();
                                _state.label = 13;
                            case 13:
                                // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
                                // such as users getting stuck with a previous account after signing out and refreshing the tab.
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(persistence) {
                                            var _a;
                                            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(persistence !== selectedPersistence)) return [
                                                            3,
                                                            4
                                                        ];
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            persistence._remove(key)
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        _a = _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PersistenceUserManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $82f70d645a4b3e84$var$_getBrowserName(userAgent) {
    var ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($82f70d645a4b3e84$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($82f70d645a4b3e84$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($82f70d645a4b3e84$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($82f70d645a4b3e84$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($82f70d645a4b3e84$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $82f70d645a4b3e84$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($82f70d645a4b3e84$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        var re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        var matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $82f70d645a4b3e84$var$_isFirefox() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /firefox\//i.test(ua);
}
function $82f70d645a4b3e84$var$_isSafari() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    var ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $82f70d645a4b3e84$var$_isChromeIOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /crios\//i.test(ua);
}
function $82f70d645a4b3e84$var$_isIEMobile() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /iemobile/i.test(ua);
}
function $82f70d645a4b3e84$export$92108d983e8ee699() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /android/i.test(ua);
}
function $82f70d645a4b3e84$var$_isBlackBerry() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /blackberry/i.test(ua);
}
function $82f70d645a4b3e84$var$_isWebOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /webos/i.test(ua);
}
function $82f70d645a4b3e84$export$d66dc83d8cfc8dd() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $82f70d645a4b3e84$export$91c6e00c14e7e6fd() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $82f70d645a4b3e84$var$_isIOSStandalone() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    var _a;
    return $82f70d645a4b3e84$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $82f70d645a4b3e84$var$_isIE10() {
    return (0, $4aa7d5a8ca32ac7d$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $82f70d645a4b3e84$var$_isMobileBrowser() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    // TODO: implement getBrowserName equivalent for OS.
    return $82f70d645a4b3e84$export$d66dc83d8cfc8dd(ua) || $82f70d645a4b3e84$export$92108d983e8ee699(ua) || $82f70d645a4b3e84$var$_isWebOS(ua) || $82f70d645a4b3e84$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $82f70d645a4b3e84$var$_isIEMobile(ua);
}
function $82f70d645a4b3e84$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $82f70d645a4b3e84$export$9f4f30ee63539e24(clientPlatform) {
    var frameworks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $82f70d645a4b3e84$var$_getBrowserName((0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = "".concat($82f70d645a4b3e84$var$_getBrowserName((0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)()), "-").concat(clientPlatform);
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    var reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return "".concat(reportedPlatform, "/", "JsCore" /* ClientImplementation.CORE */ , "/").concat((0, $43ffc92b683abcf2$export$31499a9cd224b78c), "/").concat(reportedFrameworks);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$AuthMiddlewareQueue = /*#__PURE__*/ function() {
    "use strict";
    function AuthMiddlewareQueue(auth) {
        (0, $lfBxf._)(this, AuthMiddlewareQueue);
        this.auth = auth;
        this.queue = [];
    }
    (0, $9tzan._)(AuthMiddlewareQueue, [
        {
            key: "pushCallback",
            value: function pushCallback(callback, onAbort) {
                var _this = this;
                // The callback could be sync or async. Wrap it into a
                // function that is always async.
                var wrappedCallback = function(user) {
                    return new Promise(function(resolve, reject) {
                        try {
                            var result = callback(user);
                            // Either resolve with existing promise or wrap a non-promise
                            // return value into a promise.
                            resolve(result);
                        } catch (e) {
                            // Sync callback throws.
                            reject(e);
                        }
                    });
                };
                // Attach the onAbort if present
                wrappedCallback.onAbort = onAbort;
                this.queue.push(wrappedCallback);
                var index = this.queue.length - 1;
                return function() {
                    // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
                    // indexing of other elements.
                    _this.queue[index] = function() {
                        return Promise.resolve();
                    };
                };
            }
        },
        {
            key: "runMiddleware",
            value: function runMiddleware(nextUser) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var onAbortStack, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, beforeStateCallback, err, e, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, onAbort;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.auth.currentUser === nextUser) return [
                                    2
                                ];
                                // While running the middleware, build a temporary stack of onAbort
                                // callbacks to call if one middleware callback rejects.
                                onAbortStack = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    ,
                                    11
                                ]);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = _this.queue[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                beforeStateCallback = _step.value;
                                return [
                                    4,
                                    beforeStateCallback(nextUser)
                                ];
                            case 4:
                                _state.sent();
                                // Only push the onAbort if the callback succeeds
                                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                e = _state.sent();
                                // Run all onAbort, with separate try/catch to ignore any errors and
                                // continue
                                onAbortStack.reverse();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = onAbortStack[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        onAbort = _step1.value;
                                        try {
                                            onAbort();
                                        } catch (_) {
                                        /* swallow error */ }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                throw _this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                                    originalMessage: e === null || e === void 0 ? void 0 : e.message
                                });
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthMiddlewareQueue;
}();
function $82f70d645a4b3e84$var$_getPasswordPolicy(auth) {
    return $82f70d645a4b3e84$var$__getPasswordPolicy.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__getPasswordPolicy() {
    $82f70d645a4b3e84$var$__getPasswordPolicy = /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$__getPasswordPolicy.apply(this, arguments);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
var $82f70d645a4b3e84$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ var $82f70d645a4b3e84$var$PasswordPolicyImpl = /*#__PURE__*/ function() {
    "use strict";
    function PasswordPolicyImpl(response) {
        (0, $lfBxf._)(this, PasswordPolicyImpl);
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        var responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $82f70d645a4b3e84$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    (0, $9tzan._)(PasswordPolicyImpl, [
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _a, _b, _c, _d, _e, _f;
                var status = {
                    isValid: true,
                    passwordPolicy: this
                };
                // Check the password length and character options.
                this.validatePasswordLengthOptions(password, status);
                this.validatePasswordCharacterOptions(password, status);
                // Combine the status into single isValid property.
                status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
                status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
                status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
                status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
                status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
                status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
                return status;
            }
        },
        {
            /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordLengthOptions",
            value: function validatePasswordLengthOptions(password, status) {
                var minPasswordLength = this.customStrengthOptions.minPasswordLength;
                var maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
                if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
                if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
            }
        },
        {
            /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordCharacterOptions",
            value: function validatePasswordCharacterOptions(password, status) {
                // Assign statuses for requirements even if the password is an empty string.
                this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
                var passwordChar;
                for(var i = 0; i < password.length; i++){
                    passwordChar = password.charAt(i);
                    this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
                }
            }
        },
        {
            /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ key: "updatePasswordCharacterOptionsStatuses",
            value: function updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
                if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
                if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
                if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
                if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
            }
        }
    ]);
    return PasswordPolicyImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$export$91477dc880baac21 = /*#__PURE__*/ function() {
    "use strict";
    function AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
        (0, $lfBxf._)(this, AuthImpl);
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $82f70d645a4b3e84$var$Subscription(this);
        this.idTokenSubscription = new $82f70d645a4b3e84$var$Subscription(this);
        this.beforeStateQueue = new $82f70d645a4b3e84$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $82f70d645a4b3e84$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    (0, $9tzan._)(AuthImpl, [
        {
            key: "_initializeWithPersistence",
            value: function _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
                if (popupRedirectResolver) this._popupRedirectResolver = $82f70d645a4b3e84$export$158acd800e1ef08b(popupRedirectResolver);
                var _this = this;
                // Have to check for app deletion throughout initialization (after each
                // promise resolution)
                this._initializationPromise = this.queue(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, _b, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$PersistenceUserManager.create(_this, persistenceHierarchy)
                                ];
                            case 1:
                                _this.persistenceManager = _state.sent();
                                if (_this._deleted) return [
                                    2
                                ];
                                if (!((_a = _this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._initialize(_this)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    4,
                                    _this.initializeCurrentUser(popupRedirectResolver)
                                ];
                            case 6:
                                _state.sent();
                                _this.lastNotifiedUid = ((_b = _this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
                                if (_this._deleted) return [
                                    2
                                ];
                                _this._isInitialized = true;
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return this._initializationPromise;
            }
        },
        {
            key: "_onStorageEvent",
            value: /**
     * If the persistence is changed in another window, the user manager will let us know
     */ function _onStorageEvent() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var user;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                user = _state.sent();
                                if (!_this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
                                return [
                                    2
                                ];
                                if (!(_this.currentUser && user && _this.currentUser.uid === user.uid)) return [
                                    3,
                                    3
                                ];
                                // Data update, simply copy data changes.
                                _this._currentUser._assign(user);
                                // If tokens changed from previous user tokens, this will trigger
                                // notifyAuthListeners_.
                                return [
                                    4,
                                    _this.currentUser.getIdToken()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 3:
                                // Update current Auth state. Either a new login or logout.
                                // Skip blocking callbacks, they should not apply to a change in another tab.
                                return [
                                    4,
                                    _this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeCurrentUser",
            value: function initializeCurrentUser(popupRedirectResolver) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, previouslyStoredUser, futureCurrentUser, needsTocheckMiddleware, redirectUserEventId, storedUserEventId, result, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                previouslyStoredUser = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                needsTocheckMiddleware = false;
                                if (!(popupRedirectResolver && _this.config.authDomain)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 2:
                                _state.sent();
                                redirectUserEventId = (_a = _this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
                                storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
                                return [
                                    4,
                                    _this.tryRedirectSignIn(popupRedirectResolver)
                                ];
                            case 3:
                                result = _state.sent();
                                // If the stored user (i.e. the old "currentUser") has a redirectId that
                                // matches the redirect user, then we want to initially sign in with the
                                // new user object from result.
                                // TODO(samgho): More thoroughly test all of this
                                if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                                    futureCurrentUser = result.user;
                                    needsTocheckMiddleware = true;
                                }
                                _state.label = 4;
                            case 4:
                                // If no user in persistence, there is no current user. Set to null.
                                if (!futureCurrentUser) return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                if (!!futureCurrentUser._redirectEventId) return [
                                    3,
                                    9
                                ];
                                if (!needsTocheckMiddleware) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(futureCurrentUser)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                // We know this is available since the bit is only set when the
                                // resolver is available
                                _this._popupRedirectResolver._overrideRedirectResult(_this, function() {
                                    return Promise.reject(e);
                                });
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                if (futureCurrentUser) return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                                else return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                _state.label = 9;
                            case 9:
                                $82f70d645a4b3e84$export$890c4ad488842ce7(_this._popupRedirectResolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 10:
                                _state.sent();
                                // If the redirect user's event ID matches the current user's event ID,
                                // DO NOT reload the current user, otherwise they'll be cleared from storage.
                                // This is important for the reauthenticateWithRedirect() flow.
                                if (_this.redirectUser && _this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return [
                                    2,
                                    _this.directlySetCurrentUser(futureCurrentUser)
                                ];
                                return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "tryRedirectSignIn",
            value: function tryRedirectSignIn(redirectResolver) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var result, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // The redirect user needs to be checked (and signed in if available)
                                // during auth initialization. All of the normal sign in and link/reauth
                                // flows call back into auth and push things onto the promise queue. We
                                // need to await the result of the redirect sign in *inside the promise
                                // queue*. This presents a problem: we run into deadlock. See:
                                //    ┌> [Initialization] ─────┐
                                //    ┌> [<other queue tasks>] │
                                //    └─ [getRedirectResult] <─┘
                                //    where [] are tasks on the queue and arrows denote awaits
                                // Initialization will never complete because it's waiting on something
                                // that's waiting for initialization to complete!
                                //
                                // Instead, this method calls getRedirectResult() (stored in
                                // _completeRedirectFn) with an optional parameter that instructs all of
                                // the underlying auth operations to skip anything that mutates auth state.
                                result = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._completeRedirectFn(_this, redirectResolver, true)
                                ];
                            case 2:
                                // We know this._popupRedirectResolver is set since redirectResolver
                                // is passed in. The _completeRedirectFn expects the unwrapped extern.
                                result = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                e = _state.sent();
                                // Swallow any errors here; the code can retrieve them in
                                // getRedirectResult().
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reloadAndSetCurrentUserOrClear",
            value: function reloadAndSetCurrentUserOrClear(user) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                if ((e === null || e === void 0 ? void 0 : e.code) !== "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) // Something's wrong with the user's token. Log them out and remove
                                // them from storage
                                return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2,
                                    _this.directlySetCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "useDeviceLanguage",
            value: function useDeviceLanguage() {
                this.languageCode = $82f70d645a4b3e84$var$_getUserLanguage();
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        _this._deleted = true;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateCurrentUser",
            value: function updateCurrentUser(userExtern) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var user;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        // The public updateCurrentUser method needs to make a copy of the user,
                        // and also check that the project matches
                        user = userExtern ? (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(userExtern) : null;
                        if (user) $82f70d645a4b3e84$export$890c4ad488842ce7(user.auth.config.apiKey === _this.config.apiKey, _this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
                        return [
                            2,
                            _this._updateCurrentUser(user && user._clone(_this))
                        ];
                    });
                })();
            }
        },
        {
            key: "_updateCurrentUser",
            value: function _updateCurrentUser(user) {
                var skipBeforeStateCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                if (user) $82f70d645a4b3e84$export$890c4ad488842ce7(_this.tenantId === user.tenantId, _this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
                                if (!!skipBeforeStateCallbacks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(user)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.queue(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                                        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.directlySetCurrentUser(user)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _this.notifyAuthListeners();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signOut",
            value: function signOut() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Run first, to block _setRedirectUser() if any callbacks fail.
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(null)
                                ];
                            case 1:
                                _state.sent();
                                if (!(_this.redirectPersistenceManager || _this._popupRedirectResolver)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                // Prevent callbacks from being called again in _updateCurrentUser, as
                                // they were already called in the first line.
                                return [
                                    2,
                                    _this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(persistence) {
                var _this = this;
                return this.queue(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.setPersistence($82f70d645a4b3e84$export$158acd800e1ef08b(persistence))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "_getRecaptchaConfig",
            value: function _getRecaptchaConfig() {
                if (this.tenantId == null) return this._agentRecaptchaConfig;
                else return this._tenantRecaptchaConfigs[this.tenantId];
            }
        },
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var passwordPolicy;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this._getPasswordPolicyInternal()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._updatePasswordPolicy()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // Password policy will be defined after fetching.
                                passwordPolicy = _this._getPasswordPolicyInternal();
                                // Check that the policy schema version is supported by the SDK.
                                // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
                                if (passwordPolicy.schemaVersion !== _this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return [
                                    2,
                                    Promise.reject(_this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}))
                                ];
                                return [
                                    2,
                                    passwordPolicy.validatePassword(password)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPasswordPolicyInternal",
            value: function _getPasswordPolicyInternal() {
                if (this.tenantId === null) return this._projectPasswordPolicy;
                else return this._tenantPasswordPolicies[this.tenantId];
            }
        },
        {
            key: "_updatePasswordPolicy",
            value: function _updatePasswordPolicy() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var response, passwordPolicy;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_getPasswordPolicy(_this)
                                ];
                            case 1:
                                response = _state.sent();
                                passwordPolicy = new $82f70d645a4b3e84$var$PasswordPolicyImpl(response);
                                if (_this.tenantId === null) _this._projectPasswordPolicy = passwordPolicy;
                                else _this._tenantPasswordPolicies[_this.tenantId] = passwordPolicy;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPersistence",
            value: function _getPersistence() {
                return this.assertedPersistence.persistence.type;
            }
        },
        {
            key: "_updateErrorMap",
            value: function _updateErrorMap(errorMap) {
                this._errorFactory = new (0, $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
            }
        },
        {
            key: "onAuthStateChanged",
            value: function onAuthStateChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "beforeAuthStateChanged",
            value: function beforeAuthStateChanged(callback, onAbort) {
                return this.beforeStateQueue.pushCallback(callback, onAbort);
            }
        },
        {
            key: "onIdTokenChanged",
            value: function onIdTokenChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "authStateReady",
            value: function authStateReady() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (_this.currentUser) resolve();
                    else {
                        var unsubscribe = _this.onAuthStateChanged(function() {
                            unsubscribe();
                            resolve();
                        }, reject);
                    }
                });
            }
        },
        {
            key: "revokeAccessToken",
            value: /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ function revokeAccessToken(token) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var idToken, request;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.currentUser) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.currentUser.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                // Generalize this to accept other providers once supported.
                                request = {
                                    providerId: "apple.com",
                                    tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                                    token: token,
                                    idToken: idToken
                                };
                                if (_this.tenantId != null) request.tenantId = _this.tenantId;
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$revokeToken(_this, request)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var _a;
                return {
                    apiKey: this.config.apiKey,
                    authDomain: this.config.authDomain,
                    appName: this.name,
                    currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
                };
            }
        },
        {
            key: "_setRedirectUser",
            value: function _setRedirectUser(user, popupRedirectResolver) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var redirectManager;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager(popupRedirectResolver)
                                ];
                            case 1:
                                redirectManager = _state.sent();
                                return [
                                    2,
                                    user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOrInitRedirectPersistenceManager",
            value: function getOrInitRedirectPersistenceManager(popupRedirectResolver) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var resolver;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.redirectPersistenceManager) return [
                                    3,
                                    3
                                ];
                                resolver = popupRedirectResolver && $82f70d645a4b3e84$export$158acd800e1ef08b(popupRedirectResolver) || _this._popupRedirectResolver;
                                $82f70d645a4b3e84$export$890c4ad488842ce7(resolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$PersistenceUserManager.create(_this, [
                                        $82f70d645a4b3e84$export$158acd800e1ef08b(resolver._redirectPersistence)
                                    ], "redirectUser" /* KeyName.REDIRECT_USER */ )
                                ];
                            case 1:
                                _this.redirectPersistenceManager = _state.sent();
                                return [
                                    4,
                                    _this.redirectPersistenceManager.getCurrentUser()
                                ];
                            case 2:
                                _this.redirectUser = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.redirectPersistenceManager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_redirectUserForId",
            value: function _redirectUserForId(id) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, _b;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isInitialized) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.queue(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                                        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                            return [
                                                2
                                            ];
                                        });
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (((_a = _this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return [
                                    2,
                                    _this._currentUser
                                ];
                                if (((_b = _this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return [
                                    2,
                                    _this.redirectUser
                                ];
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_persistUserIfCurrent",
            value: function _persistUserIfCurrent(user) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        if (user === _this.currentUser) return [
                            2,
                            _this.queue(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    return [
                                        2,
                                        _this.directlySetCurrentUser(user)
                                    ];
                                });
                            }))
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** Notifies listeners only if the user is current */ key: "_notifyListenersIfCurrent",
            value: function _notifyListenersIfCurrent(user) {
                if (user === this.currentUser) this.notifyAuthListeners();
            }
        },
        {
            key: "_key",
            value: function _key() {
                return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.isProactiveRefreshEnabled = true;
                if (this.currentUser) this._currentUser._startProactiveRefresh();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.isProactiveRefreshEnabled = false;
                if (this.currentUser) this._currentUser._stopProactiveRefresh();
            }
        },
        {
            key: "_currentUser",
            get: /** Returns the current user cast as the internal type */ function get() {
                return this.currentUser;
            }
        },
        {
            key: "notifyAuthListeners",
            value: function notifyAuthListeners() {
                var _a, _b;
                if (!this._isInitialized) return;
                this.idTokenSubscription.next(this.currentUser);
                var currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
                if (this.lastNotifiedUid !== currentUid) {
                    this.lastNotifiedUid = currentUid;
                    this.authStateSubscription.next(this.currentUser);
                }
            }
        },
        {
            key: "registerStateListener",
            value: function registerStateListener(subscription, nextOrObserver, error, completed) {
                var _this = this;
                if (this._deleted) return function() {};
                var cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
                var isUnsubscribed = false;
                var promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
                $82f70d645a4b3e84$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                // The callback needs to be called asynchronously per the spec.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                promise.then(function() {
                    if (isUnsubscribed) return;
                    cb(_this.currentUser);
                });
                if (typeof nextOrObserver === "function") {
                    var unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe();
                    };
                } else {
                    var unsubscribe1 = subscription.addObserver(nextOrObserver);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe1();
                    };
                }
            }
        },
        {
            key: "directlySetCurrentUser",
            value: /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ function directlySetCurrentUser(user) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.currentUser && _this.currentUser !== user) _this._currentUser._stopProactiveRefresh();
                                if (user && _this.isProactiveRefreshEnabled) user._startProactiveRefresh();
                                _this.currentUser = user;
                                if (!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.setCurrentUser(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.assertedPersistence.removeCurrentUser()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queue",
            value: function queue(action) {
                // In case something errors, the callback still should be called in order
                // to keep the promise chain alive
                this.operations = this.operations.then(action, action);
                return this.operations;
            }
        },
        {
            key: "assertedPersistence",
            get: function get() {
                $82f70d645a4b3e84$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.persistenceManager;
            }
        },
        {
            key: "_logFramework",
            value: function _logFramework(framework) {
                if (!framework || this.frameworks.includes(framework)) return;
                this.frameworks.push(framework);
                // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
                // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
                this.frameworks.sort();
                this.clientVersion = $82f70d645a4b3e84$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
            }
        },
        {
            key: "_getFrameworks",
            value: function _getFrameworks() {
                return this.frameworks;
            }
        },
        {
            key: "_getAdditionalHeaders",
            value: function _getAdditionalHeaders() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, headers, heartbeatsHeader, appCheckToken;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Additional headers on every request
                                headers = (0, $azcHm._)({}, "X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ , _this.clientVersion);
                                if (_this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = _this.app.options.appId;
                                return [
                                    4,
                                    (_a = _this.heartbeatServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader()
                                ];
                            case 1:
                                heartbeatsHeader = _state.sent();
                                if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
                                return [
                                    4,
                                    _this._getAppCheckToken()
                                ];
                            case 2:
                                appCheckToken = _state.sent();
                                if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
                                return [
                                    2,
                                    headers
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getAppCheckToken",
            value: function _getAppCheckToken() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, appCheckTokenResult;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_a = _this.appCheckServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getToken()
                                ];
                            case 1:
                                appCheckTokenResult = _state.sent();
                                if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
                                // In the error case, a dummy token will be returned along with an error field describing
                                // the error. In general, we shouldn't care about the error condition and just use
                                // the token (actual or dummy) to send requests.
                                $82f70d645a4b3e84$var$_logWarn("Error while retrieving App Check token: ".concat(appCheckTokenResult.error));
                                return [
                                    2,
                                    appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthImpl;
}();
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ var $82f70d645a4b3e84$var$Subscription = /*#__PURE__*/ function() {
    "use strict";
    function Subscription(auth) {
        var _this = this;
        (0, $lfBxf._)(this, Subscription);
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $4aa7d5a8ca32ac7d$export$364097d812234b3f)(function(observer) {
            return _this.observer = observer;
        });
    }
    (0, $9tzan._)(Subscription, [
        {
            key: "next",
            get: function get() {
                $82f70d645a4b3e84$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.observer.next.bind(this.observer);
            }
        }
    ]);
    return Subscription;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $82f70d645a4b3e84$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise(function(resolve, reject) {
        var el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = function(e) {
            var error = $82f70d645a4b3e84$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $82f70d645a4b3e84$var$getScriptParentElement().appendChild(el);
    });
}
function $82f70d645a4b3e84$var$_generateCallbackName(prefix) {
    return "__".concat(prefix).concat(Math.floor(Math.random() * 1000000));
}
/* eslint-disable @typescript-eslint/no-require-imports */ var $82f70d645a4b3e84$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
var $82f70d645a4b3e84$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
var $82f70d645a4b3e84$var$FAKE_TOKEN = "NO_RECAPTCHA";
var $82f70d645a4b3e84$var$RecaptchaEnterpriseVerifier = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaEnterpriseVerifier(authExtern) {
        (0, $lfBxf._)(this, RecaptchaEnterpriseVerifier);
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $82f70d645a4b3e84$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $82f70d645a4b3e84$export$a05254e7c3aeba6e(authExtern);
    }
    (0, $9tzan._)(RecaptchaEnterpriseVerifier, [
        {
            key: "verify",
            value: /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ function verify() {
                var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "verify", forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    function retrieveSiteKey(auth) {
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function _retrieveSiteKey() {
                        _retrieveSiteKey = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
                            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                if (!forceRefresh) {
                                    if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return [
                                        2,
                                        auth._agentRecaptchaConfig.siteKey
                                    ];
                                    if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return [
                                        2,
                                        auth._tenantRecaptchaConfigs[auth.tenantId].siteKey
                                    ];
                                }
                                return [
                                    2,
                                    new Promise(function() {
                                        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(resolve, reject) {
                                            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                                $82f70d645a4b3e84$var$getRecaptchaConfig(auth, {
                                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                                                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                                                }).then(function(response) {
                                                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                                                    else {
                                                        var config = new $82f70d645a4b3e84$var$RecaptchaConfig(response);
                                                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                                                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                                                        return resolve(config.siteKey);
                                                    }
                                                }).catch(function(error) {
                                                    reject(error);
                                                });
                                                return [
                                                    2
                                                ];
                                            });
                                        });
                                        return function(resolve, reject) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            });
                        });
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function retrieveRecaptchaToken(siteKey, resolve, reject) {
                        var grecaptcha = window.grecaptcha;
                        if ($82f70d645a4b3e84$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(function() {
                            grecaptcha.enterprise.execute(siteKey, {
                                action: action
                            }).then(function(token) {
                                resolve(token);
                            }).catch(function() {
                                resolve($82f70d645a4b3e84$var$FAKE_TOKEN);
                            });
                        });
                        else reject(Error("No reCAPTCHA enterprise script loaded."));
                    }
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                retrieveSiteKey(_this.auth).then(function(siteKey) {
                                    if (!forceRefresh && $82f70d645a4b3e84$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                                    else {
                                        if (typeof window === "undefined") {
                                            reject(new Error("RecaptchaVerifier is only supported in browser"));
                                            return;
                                        }
                                        $82f70d645a4b3e84$var$_loadJS($82f70d645a4b3e84$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(function() {
                                            retrieveRecaptchaToken(siteKey, resolve, reject);
                                        }).catch(function(error) {
                                            reject(error);
                                        });
                                    }
                                }).catch(function(error) {
                                    reject(error);
                                });
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return RecaptchaEnterpriseVerifier;
}();
function $82f70d645a4b3e84$var$injectRecaptchaFields(auth, request, action) {
    return $82f70d645a4b3e84$var$_injectRecaptchaFields.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_injectRecaptchaFields() {
    $82f70d645a4b3e84$var$_injectRecaptchaFields = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request, action) {
        var captchaResp, verifier, captchaResponse, error, newRequest;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    captchaResp = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    verifier = new $82f70d645a4b3e84$var$RecaptchaEnterpriseVerifier(auth);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        verifier.verify(action)
                    ];
                case 2:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        4,
                        verifier.verify(action, true)
                    ];
                case 4:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    newRequest = Object.assign({}, request);
                    if (!captchaResp) Object.assign(newRequest, {
                        captchaResponse: captchaResponse
                    });
                    else Object.assign(newRequest, {
                        "captchaResp": captchaResponse
                    });
                    Object.assign(newRequest, {
                        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    });
                    Object.assign(newRequest, {
                        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                    });
                    return [
                        2,
                        newRequest
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_injectRecaptchaFields.apply(this, arguments);
}
function $82f70d645a4b3e84$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    return $82f70d645a4b3e84$var$_handleRecaptchaFlow.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_handleRecaptchaFlow() {
    $82f70d645a4b3e84$var$_handleRecaptchaFlow = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(authInstance, request, actionName, actionMethod) {
        var _a, requestWithRecaptcha;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ ))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $82f70d645a4b3e84$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ )
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    return [
                        2,
                        actionMethod(authInstance, requestWithRecaptcha)
                    ];
                case 2:
                    return [
                        2,
                        actionMethod(authInstance, request).catch(function() {
                            var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(error) {
                                var requestWithRecaptcha;
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                3,
                                                2
                                            ];
                                            console.log("".concat(actionName, " is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow."));
                                            return [
                                                4,
                                                $82f70d645a4b3e84$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ )
                                            ];
                                        case 1:
                                            requestWithRecaptcha = _state.sent();
                                            return [
                                                2,
                                                actionMethod(authInstance, requestWithRecaptcha)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.reject(error)
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_handleRecaptchaFlow.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_initializeRecaptchaConfig(auth) {
    return $82f70d645a4b3e84$var$__initializeRecaptchaConfig.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__initializeRecaptchaConfig() {
    $82f70d645a4b3e84$var$__initializeRecaptchaConfig = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var authInternal, response, config, verifier;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        $82f70d645a4b3e84$var$getRecaptchaConfig(authInternal, {
                            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                        })
                    ];
                case 1:
                    response = _state.sent();
                    config = new $82f70d645a4b3e84$var$RecaptchaConfig(response);
                    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
                    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
                    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
                        verifier = new $82f70d645a4b3e84$var$RecaptchaEnterpriseVerifier(authInternal);
                        verifier.verify();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__initializeRecaptchaConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $82f70d645a4b3e84$export$b4171a6734a65d42(app, deps) {
    var provider = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        var auth = provider.getImmediate();
        var initialOptions = provider.getOptions();
        if ((0, $4aa7d5a8ca32ac7d$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    var auth1 = provider.initialize({
        options: deps
    });
    return auth1;
}
function $82f70d645a4b3e84$var$_initializeAuthInstance(auth, deps) {
    var persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    var hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($82f70d645a4b3e84$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $82f70d645a4b3e84$export$3466f893ebf79586(auth, url, options) {
    var authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
    $82f70d645a4b3e84$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $82f70d645a4b3e84$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    var disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    var protocol = $82f70d645a4b3e84$var$extractProtocol(url);
    var _extractHostAndPort = $82f70d645a4b3e84$var$extractHostAndPort(url), host = _extractHostAndPort.host, port = _extractHostAndPort.port;
    var portStr = port === null ? "" : ":".concat(port);
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: "".concat(protocol, "//").concat(host).concat(portStr, "/")
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $82f70d645a4b3e84$var$emitEmulatorWarning();
}
function $82f70d645a4b3e84$var$extractProtocol(url) {
    var protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $82f70d645a4b3e84$var$extractHostAndPort(url) {
    var protocol = $82f70d645a4b3e84$var$extractProtocol(url);
    var authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    var hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    var bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        var host = bracketedIPv6[1];
        return {
            host: host,
            port: $82f70d645a4b3e84$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        var _hostAndPort_split = (0, $3tDj3._)(hostAndPort.split(":"), 2), host1 = _hostAndPort_split[0], port = _hostAndPort_split[1];
        return {
            host: host1,
            port: $82f70d645a4b3e84$var$parsePort(port)
        };
    }
}
function $82f70d645a4b3e84$var$parsePort(portStr) {
    if (!portStr) return null;
    var port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $82f70d645a4b3e84$var$emitEmulatorWarning() {
    function attachBanner() {
        var el = document.createElement("p");
        var sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $82f70d645a4b3e84$export$61196ced6d74a310 = /*#__PURE__*/ function() {
    "use strict";
    function AuthCredential(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod) {
        (0, $lfBxf._)(this, AuthCredential);
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    (0, $9tzan._)(AuthCredential, [
        {
            /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return $82f70d645a4b3e84$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(_auth) {
                return $82f70d645a4b3e84$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(_auth, _idToken) {
                return $82f70d645a4b3e84$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(_auth) {
                return $82f70d645a4b3e84$var$debugFail("not implemented");
            }
        }
    ]);
    return AuthCredential;
}();
function $82f70d645a4b3e84$var$resetPassword(auth, request) {
    return $82f70d645a4b3e84$var$_resetPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_resetPassword() {
    $82f70d645a4b3e84$var$_resetPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_resetPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$updateEmailPassword(auth, request) {
    return $82f70d645a4b3e84$var$_updateEmailPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_updateEmailPassword() {
    $82f70d645a4b3e84$var$_updateEmailPassword = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_updateEmailPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$linkEmailPassword(auth, request) {
    return $82f70d645a4b3e84$var$_linkEmailPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_linkEmailPassword() {
    $82f70d645a4b3e84$var$_linkEmailPassword = // Used for linking an email/password account to an existing idToken. Uses the same request/response
    // format as updateEmailPassword.
    (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_linkEmailPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$applyActionCode$1(auth, request) {
    return $82f70d645a4b3e84$var$_applyActionCode$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_applyActionCode$1() {
    $82f70d645a4b3e84$var$_applyActionCode$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_applyActionCode$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$signInWithPassword(auth, request) {
    return $82f70d645a4b3e84$var$_signInWithPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithPassword() {
    $82f70d645a4b3e84$var$_signInWithPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$sendOobCode(auth, request) {
    return $82f70d645a4b3e84$var$_sendOobCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendOobCode() {
    $82f70d645a4b3e84$var$_sendOobCode = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_sendOobCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$sendEmailVerification$1(auth, request) {
    return $82f70d645a4b3e84$var$_sendEmailVerification$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendEmailVerification$1() {
    $82f70d645a4b3e84$var$_sendEmailVerification$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$sendOobCode(auth, request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_sendEmailVerification$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$sendPasswordResetEmail$1(auth, request) {
    return $82f70d645a4b3e84$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendPasswordResetEmail$1() {
    $82f70d645a4b3e84$var$_sendPasswordResetEmail$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$sendOobCode(auth, request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$sendSignInLinkToEmail$1(auth, request) {
    return $82f70d645a4b3e84$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendSignInLinkToEmail$1() {
    $82f70d645a4b3e84$var$_sendSignInLinkToEmail$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$sendOobCode(auth, request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$verifyAndChangeEmail(auth, request) {
    return $82f70d645a4b3e84$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_verifyAndChangeEmail() {
    $82f70d645a4b3e84$var$_verifyAndChangeEmail = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$sendOobCode(auth, request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$signInWithEmailLink$1(auth, request) {
    return $82f70d645a4b3e84$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithEmailLink$1() {
    $82f70d645a4b3e84$var$_signInWithEmailLink$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$signInWithEmailLinkForLinking(auth, request) {
    return $82f70d645a4b3e84$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithEmailLinkForLinking() {
    $82f70d645a4b3e84$var$_signInWithEmailLinkForLinking = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ var $82f70d645a4b3e84$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $9Hju1._)(EmailAuthCredential, AuthCredential);
    var _super = (0, $hCdf1._)(EmailAuthCredential);
    function EmailAuthCredential(/** @internal */ _email, /** @internal */ _password, signInMethod) {
        var /** @internal */ _tenantId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        (0, $lfBxf._)(this, EmailAuthCredential);
        var _this;
        _this = _super.call(this, "password" /* ProviderId.PASSWORD */ , signInMethod);
        _this._email = _email;
        _this._password = _password;
        _this._tenantId = _tenantId;
        return _this;
    }
    (0, $9tzan._)(EmailAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                return {
                    email: this._email,
                    password: this._password,
                    signInMethod: this.signInMethod,
                    tenantId: this._tenantId
                };
            }
        },
        {
            key: "_getIdTokenResponse",
            value: /** @internal */ function _getIdTokenResponse(auth) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var request;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_this.signInMethod){
                            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                request = {
                                    returnSecureToken: true,
                                    email: _this._email,
                                    password: _this._password,
                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                                };
                                return [
                                    2,
                                    $82f70d645a4b3e84$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $82f70d645a4b3e84$var$signInWithPassword)
                                ];
                            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                return [
                                    2,
                                    $82f70d645a4b3e84$var$signInWithEmailLink$1(auth, {
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            default:
                                $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_linkToIdToken",
            value: /** @internal */ function _linkToIdToken(auth, idToken) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var request;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_this.signInMethod){
                            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                request = {
                                    idToken: idToken,
                                    returnSecureToken: true,
                                    email: _this._email,
                                    password: _this._password,
                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                                };
                                return [
                                    2,
                                    $82f70d645a4b3e84$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $82f70d645a4b3e84$var$linkEmailPassword)
                                ];
                            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                return [
                                    2,
                                    $82f70d645a4b3e84$var$signInWithEmailLinkForLinking(auth, {
                                        idToken: idToken,
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            default:
                                $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return this._getIdTokenResponse(auth);
            }
        }
    ], [
        {
            key: "_fromEmailAndPassword",
            value: /** @internal */ function _fromEmailAndPassword(email, password) {
                return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
            }
        },
        {
            key: "_fromEmailAndCode",
            value: /** @internal */ function _fromEmailAndCode(email, oobCode) {
                var tenantId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
                    if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
                    else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
                }
                return null;
            }
        }
    ]);
    return EmailAuthCredential;
}($82f70d645a4b3e84$export$61196ced6d74a310);
function $82f70d645a4b3e84$var$signInWithIdp(auth, request) {
    return $82f70d645a4b3e84$var$_signInWithIdp.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithIdp() {
    $82f70d645a4b3e84$var$_signInWithIdp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithIdp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $82f70d645a4b3e84$export$a07804094c3ecf2d = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $9Hju1._)(OAuthCredential, AuthCredential);
    var _super = (0, $hCdf1._)(OAuthCredential);
    function OAuthCredential() {
        (0, $lfBxf._)(this, OAuthCredential);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.pendingToken = null;
        return _this;
    }
    (0, $9tzan._)(OAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    idToken: this.idToken,
                    accessToken: this.accessToken,
                    secret: this.secret,
                    nonce: this.nonce,
                    pendingToken: this.pendingToken,
                    providerId: this.providerId,
                    signInMethod: this.signInMethod
                };
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $82f70d645a4b3e84$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $82f70d645a4b3e84$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $82f70d645a4b3e84$var$signInWithIdp(auth, request);
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                var request = {
                    requestUri: $82f70d645a4b3e84$var$IDP_REQUEST_URI$1,
                    returnSecureToken: true
                };
                if (this.pendingToken) request.pendingToken = this.pendingToken;
                else {
                    var postBody = {};
                    if (this.idToken) postBody["id_token"] = this.idToken;
                    if (this.accessToken) postBody["access_token"] = this.accessToken;
                    if (this.secret) postBody["oauth_token_secret"] = this.secret;
                    postBody["providerId"] = this.providerId;
                    if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
                    request.postBody = (0, $4aa7d5a8ca32ac7d$export$ac4103b836844853)(postBody);
                }
                return request;
            }
        }
    ], [
        {
            key: "_fromParams",
            value: /** @internal */ function _fromParams(params) {
                var cred = new OAuthCredential(params.providerId, params.signInMethod);
                if (params.idToken || params.accessToken) {
                    // OAuth 2 and either ID token or access token.
                    if (params.idToken) cred.idToken = params.idToken;
                    if (params.accessToken) cred.accessToken = params.accessToken;
                    // Add nonce if available and no pendingToken is present.
                    if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
                    if (params.pendingToken) cred.pendingToken = params.pendingToken;
                } else if (params.oauthToken && params.oauthTokenSecret) {
                    // OAuth 1 and OAuth token with token secret
                    cred.accessToken = params.oauthToken;
                    cred.secret = params.oauthTokenSecret;
                } else $82f70d645a4b3e84$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return cred;
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, rest = (0, $75cbc07a4214bd1d$export$3c9a16f847548506)(obj, [
                    "providerId",
                    "signInMethod"
                ]);
                if (!providerId || !signInMethod) return null;
                var cred = new OAuthCredential(providerId, signInMethod);
                cred.idToken = rest.idToken || undefined;
                cred.accessToken = rest.accessToken || undefined;
                cred.secret = rest.secret;
                cred.nonce = rest.nonce;
                cred.pendingToken = rest.pendingToken || null;
                return cred;
            }
        }
    ]);
    return OAuthCredential;
}($82f70d645a4b3e84$export$61196ced6d74a310);
function $82f70d645a4b3e84$var$sendPhoneVerificationCode(auth, request) {
    return $82f70d645a4b3e84$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendPhoneVerificationCode() {
    $82f70d645a4b3e84$var$_sendPhoneVerificationCode = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$signInWithPhoneNumber$1(auth, request) {
    return $82f70d645a4b3e84$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithPhoneNumber$1() {
    $82f70d645a4b3e84$var$_signInWithPhoneNumber$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$linkWithPhoneNumber$1(auth, request) {
    return $82f70d645a4b3e84$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_linkWithPhoneNumber$1() {
    $82f70d645a4b3e84$var$_linkWithPhoneNumber$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        var response;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.temporaryProof) throw $82f70d645a4b3e84$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
var $82f70d645a4b3e84$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = (0, $azcHm._)({}, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ );
function $82f70d645a4b3e84$var$verifyPhoneNumberForExisting(auth, request) {
    return $82f70d645a4b3e84$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_verifyPhoneNumberForExisting() {
    $82f70d645a4b3e84$var$_verifyPhoneNumberForExisting = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        var apiRequest;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            apiRequest = Object.assign(Object.assign({}, request), {
                operation: "REAUTH"
            });
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, apiRequest), $82f70d645a4b3e84$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ var $82f70d645a4b3e84$export$3722cfe417b6ed86 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $9Hju1._)(PhoneAuthCredential, AuthCredential);
    var _super = (0, $hCdf1._)(PhoneAuthCredential);
    function PhoneAuthCredential(params) {
        (0, $lfBxf._)(this, PhoneAuthCredential);
        var _this;
        _this = _super.call(this, "phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        _this.params = params;
        return _this;
    }
    (0, $9tzan._)(PhoneAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $82f70d645a4b3e84$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $82f70d645a4b3e84$var$linkWithPhoneNumber$1(auth, Object.assign({
                    idToken: idToken
                }, this._makeVerificationRequest()));
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $82f70d645a4b3e84$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_makeVerificationRequest",
            value: function _makeVerificationRequest() {
                var _this_params = this.params, temporaryProof = _this_params.temporaryProof, phoneNumber = _this_params.phoneNumber, verificationId = _this_params.verificationId, verificationCode = _this_params.verificationCode;
                if (temporaryProof && phoneNumber) return {
                    temporaryProof: temporaryProof,
                    phoneNumber: phoneNumber
                };
                return {
                    sessionInfo: verificationId,
                    code: verificationCode
                };
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                var obj = {
                    providerId: this.providerId
                };
                if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
                if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
                if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
                if (this.params.verificationId) obj.verificationId = this.params.verificationId;
                return obj;
            }
        }
    ], [
        {
            key: "_fromVerification",
            value: /** @internal */ function _fromVerification(verificationId, verificationCode) {
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode
                });
            }
        },
        {
            key: "_fromTokenResponse",
            value: /** @internal */ function _fromTokenResponse(phoneNumber, temporaryProof) {
                return new PhoneAuthCredential({
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        },
        {
            key: "fromJSON",
            value: /** Generates a phone credential based on a plain object or a JSON string. */ function fromJSON(json) {
                if (typeof json === "string") json = JSON.parse(json);
                var verificationId = json.verificationId, verificationCode = json.verificationCode, phoneNumber = json.phoneNumber, temporaryProof = json.temporaryProof;
                if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode,
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        }
    ]);
    return PhoneAuthCredential;
}($82f70d645a4b3e84$export$61196ced6d74a310);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $82f70d645a4b3e84$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $82f70d645a4b3e84$var$parseDeepLink(url) {
    var link = (0, $4aa7d5a8ca32ac7d$export$c1271ca4c8a70741)((0, $4aa7d5a8ca32ac7d$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    var doubleDeepLink = link ? (0, $4aa7d5a8ca32ac7d$export$c1271ca4c8a70741)((0, $4aa7d5a8ca32ac7d$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    var iOSDeepLink = (0, $4aa7d5a8ca32ac7d$export$c1271ca4c8a70741)((0, $4aa7d5a8ca32ac7d$export$1a8408415472d8ed)(url))["deep_link_id"];
    var iOSDoubleDeepLink = iOSDeepLink ? (0, $4aa7d5a8ca32ac7d$export$c1271ca4c8a70741)((0, $4aa7d5a8ca32ac7d$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ var $82f70d645a4b3e84$export$f38c853ae54ed474 = /*#__PURE__*/ function() {
    "use strict";
    function ActionCodeURL(actionLink) {
        (0, $lfBxf._)(this, ActionCodeURL);
        var _a, _b, _c, _d, _e, _f;
        var searchParams = (0, $4aa7d5a8ca32ac7d$export$c1271ca4c8a70741)((0, $4aa7d5a8ca32ac7d$export$1a8408415472d8ed)(actionLink));
        var apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        var code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        var operation = $82f70d645a4b3e84$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $82f70d645a4b3e84$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    (0, $9tzan._)(ActionCodeURL, null, [
        {
            key: "parseLink",
            value: /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ function parseLink(link) {
                var actionLink = $82f70d645a4b3e84$var$parseDeepLink(link);
                try {
                    return new ActionCodeURL(actionLink);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return ActionCodeURL;
}();
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $82f70d645a4b3e84$export$3b513254972cfc9c(link) {
    return $82f70d645a4b3e84$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ var $82f70d645a4b3e84$export$e7c866399fa523f5 = /*#__PURE__*/ function() {
    "use strict";
    function EmailAuthProvider() {
        (0, $lfBxf._)(this, EmailAuthProvider);
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    (0, $9tzan._)(EmailAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ function credential(email, password) {
                return $82f70d645a4b3e84$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
            }
        },
        {
            key: "credentialWithLink",
            value: /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ function credentialWithLink(email, emailLink) {
                var actionCodeUrl = $82f70d645a4b3e84$export$f38c853ae54ed474.parseLink(emailLink);
                $82f70d645a4b3e84$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $82f70d645a4b3e84$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
            }
        }
    ]);
    return EmailAuthProvider;
}();
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $82f70d645a4b3e84$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $82f70d645a4b3e84$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $82f70d645a4b3e84$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ var $82f70d645a4b3e84$var$FederatedAuthProvider = /*#__PURE__*/ function() {
    "use strict";
    function FederatedAuthProvider(providerId) {
        (0, $lfBxf._)(this, FederatedAuthProvider);
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    (0, $9tzan._)(FederatedAuthProvider, [
        {
            /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ key: "setDefaultLanguage",
            value: function setDefaultLanguage(languageCode) {
                this.defaultLanguageCode = languageCode;
            }
        },
        {
            /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ key: "setCustomParameters",
            value: function setCustomParameters(customOAuthParameters) {
                this.customParameters = customOAuthParameters;
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of {@link CustomParameters}.
     */ key: "getCustomParameters",
            value: function getCustomParameters() {
                return this.customParameters;
            }
        }
    ]);
    return FederatedAuthProvider;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ var $82f70d645a4b3e84$var$BaseOAuthProvider = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $9Hju1._)(BaseOAuthProvider, FederatedAuthProvider);
    var _super = (0, $hCdf1._)(BaseOAuthProvider);
    function BaseOAuthProvider() {
        (0, $lfBxf._)(this, BaseOAuthProvider);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        /** @internal */ _this.scopes = [];
        return _this;
    }
    (0, $9tzan._)(BaseOAuthProvider, [
        {
            /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ key: "addScope",
            value: function addScope(scope) {
                // If not already added, add scope to list.
                if (!this.scopes.includes(scope)) this.scopes.push(scope);
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of OAuth scopes.
     */ key: "getScopes",
            value: function getScopes() {
                return (0, $1UA6e._)(this.scopes);
            }
        }
    ]);
    return BaseOAuthProvider;
}($82f70d645a4b3e84$var$FederatedAuthProvider);
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $82f70d645a4b3e84$export$dc98b0b04f4c7758 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $9Hju1._)(OAuthProvider, BaseOAuthProvider);
    var _super = (0, $hCdf1._)(OAuthProvider);
    function OAuthProvider() {
        (0, $lfBxf._)(this, OAuthProvider);
        return _super.apply(this, arguments);
    }
    (0, $9tzan._)(OAuthProvider, [
        {
            /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ key: "credential",
            value: function credential(params) {
                return this._credential(Object.assign(Object.assign({}, params), {
                    nonce: params.rawNonce
                }));
            }
        },
        {
            /** An internal credential method that accepts more permissive options */ key: "_credential",
            value: function _credential(params) {
                $82f70d645a4b3e84$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                // For OAuthCredential, sign in method is same as providerId.
                return $82f70d645a4b3e84$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
                    providerId: this.providerId,
                    signInMethod: this.providerId
                }));
            }
        }
    ], [
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                $82f70d645a4b3e84$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $82f70d645a4b3e84$export$a07804094c3ecf2d._fromParams(obj);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "oauthCredentialFromTaggedObject",
            value: function oauthCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret, pendingToken = tokenResponse.pendingToken, nonce = tokenResponse.nonce, providerId = tokenResponse.providerId;
                if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
                if (!providerId) return null;
                try {
                    return new OAuthProvider(providerId)._credential({
                        idToken: oauthIdToken,
                        accessToken: oauthAccessToken,
                        nonce: nonce,
                        pendingToken: pendingToken
                    });
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return OAuthProvider;
}($82f70d645a4b3e84$var$BaseOAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $82f70d645a4b3e84$export$71cec2538cb2c617 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $9Hju1._)(FacebookAuthProvider, BaseOAuthProvider);
    var _super = (0, $hCdf1._)(FacebookAuthProvider);
    function FacebookAuthProvider() {
        (0, $lfBxf._)(this, FacebookAuthProvider);
        return _super.call(this, "facebook.com" /* ProviderId.FACEBOOK */ );
    }
    (0, $9tzan._)(FacebookAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ function credential(accessToken) {
                return $82f70d645a4b3e84$export$a07804094c3ecf2d._fromParams({
                    providerId: FacebookAuthProvider.PROVIDER_ID,
                    signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return FacebookAuthProvider;
}($82f70d645a4b3e84$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.FACEBOOK. */ $82f70d645a4b3e84$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $82f70d645a4b3e84$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $82f70d645a4b3e84$export$78acf4525d8a74c4 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $9Hju1._)(GoogleAuthProvider, BaseOAuthProvider);
    var _super = (0, $hCdf1._)(GoogleAuthProvider);
    function GoogleAuthProvider() {
        (0, $lfBxf._)(this, GoogleAuthProvider);
        var _this;
        _this = _super.call(this, "google.com" /* ProviderId.GOOGLE */ );
        _this.addScope("profile");
        return _this;
    }
    (0, $9tzan._)(GoogleAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ function credential(idToken, accessToken) {
                return $82f70d645a4b3e84$export$a07804094c3ecf2d._fromParams({
                    providerId: GoogleAuthProvider.PROVIDER_ID,
                    signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
                    idToken: idToken,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken;
                if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
                return null;
                try {
                    return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GoogleAuthProvider;
}($82f70d645a4b3e84$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GOOGLE. */ $82f70d645a4b3e84$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $82f70d645a4b3e84$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $82f70d645a4b3e84$export$8743009a87fcb00f = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $9Hju1._)(GithubAuthProvider, BaseOAuthProvider);
    var _super = (0, $hCdf1._)(GithubAuthProvider);
    function GithubAuthProvider() {
        (0, $lfBxf._)(this, GithubAuthProvider);
        return _super.call(this, "github.com" /* ProviderId.GITHUB */ );
    }
    (0, $9tzan._)(GithubAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ function credential(accessToken) {
                return $82f70d645a4b3e84$export$a07804094c3ecf2d._fromParams({
                    providerId: GithubAuthProvider.PROVIDER_ID,
                    signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GithubAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GithubAuthProvider;
}($82f70d645a4b3e84$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GITHUB. */ $82f70d645a4b3e84$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $82f70d645a4b3e84$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ var $82f70d645a4b3e84$export$f96d196f7728bb5 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $9Hju1._)(SAMLAuthCredential, AuthCredential);
    var _super = (0, $hCdf1._)(SAMLAuthCredential);
    function SAMLAuthCredential(providerId, pendingToken) {
        (0, $lfBxf._)(this, SAMLAuthCredential);
        var _this;
        _this = _super.call(this, providerId, providerId);
        _this.pendingToken = pendingToken;
        return _this;
    }
    (0, $9tzan._)(SAMLAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $82f70d645a4b3e84$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $82f70d645a4b3e84$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $82f70d645a4b3e84$var$signInWithIdp(auth, request);
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    signInMethod: this.signInMethod,
                    providerId: this.providerId,
                    pendingToken: this.pendingToken
                };
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                return {
                    requestUri: $82f70d645a4b3e84$var$IDP_REQUEST_URI,
                    returnSecureToken: true,
                    pendingToken: this.pendingToken
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, pendingToken = obj.pendingToken;
                if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        },
        {
            key: "_create",
            value: /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ function _create(providerId, pendingToken) {
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        }
    ]);
    return SAMLAuthCredential;
}($82f70d645a4b3e84$export$61196ced6d74a310);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ var $82f70d645a4b3e84$export$71511d61b312f219 = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $9Hju1._)(SAMLAuthProvider, FederatedAuthProvider);
    var _super = (0, $hCdf1._)(SAMLAuthProvider);
    function SAMLAuthProvider(providerId) {
        (0, $lfBxf._)(this, SAMLAuthProvider);
        $82f70d645a4b3e84$export$890c4ad488842ce7(providerId.startsWith($82f70d645a4b3e84$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return _super.call(this, providerId);
    }
    (0, $9tzan._)(SAMLAuthProvider, null, [
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var credential = $82f70d645a4b3e84$export$f96d196f7728bb5.fromJSON(json);
                $82f70d645a4b3e84$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return credential;
            }
        },
        {
            key: "samlCredentialFromTaggedObject",
            value: function samlCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var pendingToken = tokenResponse.pendingToken, providerId = tokenResponse.providerId;
                if (!pendingToken || !providerId) return null;
                try {
                    return $82f70d645a4b3e84$export$f96d196f7728bb5._create(providerId, pendingToken);
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return SAMLAuthProvider;
}($82f70d645a4b3e84$var$FederatedAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ var $82f70d645a4b3e84$export$3d8c2f653ac9d0b9 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $9Hju1._)(TwitterAuthProvider, BaseOAuthProvider);
    var _super = (0, $hCdf1._)(TwitterAuthProvider);
    function TwitterAuthProvider() {
        (0, $lfBxf._)(this, TwitterAuthProvider);
        return _super.call(this, "twitter.com" /* ProviderId.TWITTER */ );
    }
    (0, $9tzan._)(TwitterAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ function credential(token, secret) {
                return $82f70d645a4b3e84$export$a07804094c3ecf2d._fromParams({
                    providerId: TwitterAuthProvider.PROVIDER_ID,
                    signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
                    oauthToken: token,
                    oauthTokenSecret: secret
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret;
                if (!oauthAccessToken || !oauthTokenSecret) return null;
                try {
                    return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return TwitterAuthProvider;
}($82f70d645a4b3e84$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.TWITTER. */ $82f70d645a4b3e84$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $82f70d645a4b3e84$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
function $82f70d645a4b3e84$var$signUp(auth, request) {
    return $82f70d645a4b3e84$var$_signUp.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signUp() {
    $82f70d645a4b3e84$var$_signUp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signUp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$UserCredentialImpl = /*#__PURE__*/ function() {
    "use strict";
    function UserCredentialImpl(params) {
        (0, $lfBxf._)(this, UserCredentialImpl);
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    (0, $9tzan._)(UserCredentialImpl, null, [
        {
            key: "_fromIdTokenResponse",
            value: function _fromIdTokenResponse(auth, operationType, idTokenResponse) {
                var isAnonymous = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var user, providerId, userCred;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $82f70d645a4b3e84$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous)
                                ];
                            case 1:
                                user = _state.sent();
                                providerId = $82f70d645a4b3e84$var$providerIdForResponse(idTokenResponse);
                                userCred = new UserCredentialImpl({
                                    user: user,
                                    providerId: providerId,
                                    _tokenResponse: idTokenResponse,
                                    operationType: operationType
                                });
                                return [
                                    2,
                                    userCred
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_forOperation",
            value: function _forOperation(user, operationType, response) {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var providerId;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    user._updateTokensIfNecessary(response, /* reload */ true)
                                ];
                            case 1:
                                _state.sent();
                                providerId = $82f70d645a4b3e84$var$providerIdForResponse(response);
                                return [
                                    2,
                                    new UserCredentialImpl({
                                        user: user,
                                        providerId: providerId,
                                        _tokenResponse: response,
                                        operationType: operationType
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserCredentialImpl;
}();
function $82f70d645a4b3e84$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
function $82f70d645a4b3e84$export$34aec0b863436764(auth) {
    return $82f70d645a4b3e84$var$_signInAnonymously.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInAnonymously() {
    $82f70d645a4b3e84$var$_signInAnonymously = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var _a, authInternal, response, userCredential;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
                    return [
                        2,
                        new $82f70d645a4b3e84$var$UserCredentialImpl({
                            user: authInternal.currentUser,
                            providerId: null,
                            operationType: "signIn" /* OperationType.SIGN_IN */ 
                        })
                    ];
                    return [
                        4,
                        $82f70d645a4b3e84$var$signUp(authInternal, {
                            returnSecureToken: true
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true)
                    ];
                case 3:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_signInAnonymously.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$MultiFactorError = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $9Hju1._)(MultiFactorError, FirebaseError);
    var _super = (0, $hCdf1._)(MultiFactorError);
    function MultiFactorError(auth, error, operationType, user) {
        (0, $lfBxf._)(this, MultiFactorError);
        var _this;
        var _a;
        _this = _super.call(this, error.code, error.message);
        _this.operationType = operationType;
        _this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $aIKKI._)(_this), MultiFactorError.prototype);
        _this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
        return _this;
    }
    (0, $9tzan._)(MultiFactorError, null, [
        {
            key: "_fromErrorAndOperation",
            value: function _fromErrorAndOperation(auth, error, operationType, user) {
                return new MultiFactorError(auth, error, operationType, user);
            }
        }
    ]);
    return MultiFactorError;
}((0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56));
function $82f70d645a4b3e84$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    var idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch(function(error) {
        if (error.code === "auth/multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ) throw $82f70d645a4b3e84$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $82f70d645a4b3e84$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(function(param) {
        var providerId = param.providerId;
        return providerId;
    }).filter(function(pid) {
        return !!pid;
    }));
}
function $82f70d645a4b3e84$export$2f6ca3d3b1f80bf5(user, providerId) {
    return $82f70d645a4b3e84$var$_unlink.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_unlink() {
    $82f70d645a4b3e84$var$_unlink = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, providerId) {
        var userInternal, providerUserInfo, _tmp, _tmp1, providersLeft;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_assertLinkedStatus(true, userInternal, providerId)
                    ];
                case 1:
                    _state.sent();
                    _tmp = [
                        userInternal.auth
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 2:
                    return [
                        4,
                        $82f70d645a4b3e84$var$deleteLinkedAccounts.apply(void 0, _tmp.concat([
                            (_tmp1.idToken = _state.sent(), _tmp1.deleteProvider = [
                                providerId
                            ], _tmp1)
                        ]))
                    ];
                case 3:
                    providerUserInfo = _state.sent().providerUserInfo;
                    providersLeft = $82f70d645a4b3e84$var$providerDataAsNames(providerUserInfo || []);
                    userInternal.providerData = userInternal.providerData.filter(function(pd) {
                        return providersLeft.has(pd.providerId);
                    });
                    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userInternal
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_unlink.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_link$1(user, credential) {
    return $82f70d645a4b3e84$var$__link$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__link$1() {
    $82f70d645a4b3e84$var$__link$1 = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, credential) {
        var bypassAuthState, response, _tmp, _, _tmp1;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _tmp = [
                        user
                    ];
                    _ = credential._linkToIdToken;
                    _tmp1 = [
                        user.auth
                    ];
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_logoutIfInvalidated.apply(void 0, _tmp.concat([
                            _.apply(credential, _tmp1.concat([
                                _state.sent()
                            ])),
                            bypassAuthState
                        ]))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        $82f70d645a4b3e84$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response)
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__link$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_assertLinkedStatus(expected, user, provider) {
    return $82f70d645a4b3e84$var$__assertLinkedStatus.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__assertLinkedStatus() {
    $82f70d645a4b3e84$var$__assertLinkedStatus = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(expected, user, provider) {
        var providerIds, code;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_reloadWithoutSaving(user)
                    ];
                case 1:
                    _state.sent();
                    providerIds = $82f70d645a4b3e84$var$providerDataAsNames(user.providerData);
                    code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
                    $82f70d645a4b3e84$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__assertLinkedStatus.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_reauthenticate(user, credential) {
    return $82f70d645a4b3e84$var$__reauthenticate.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__reauthenticate() {
    $82f70d645a4b3e84$var$__reauthenticate = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, credential) {
        var bypassAuthState, auth, operationType, response, parsed, localId, e;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    auth = user.auth;
                    operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_logoutIfInvalidated(user, $82f70d645a4b3e84$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState)
                    ];
                case 2:
                    response = _state.sent();
                    $82f70d645a4b3e84$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    parsed = $82f70d645a4b3e84$var$_parseToken(response.idToken);
                    $82f70d645a4b3e84$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    localId = parsed.sub;
                    $82f70d645a4b3e84$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    return [
                        2,
                        $82f70d645a4b3e84$var$UserCredentialImpl._forOperation(user, operationType, response)
                    ];
                case 3:
                    e = _state.sent();
                    // Convert user deleted error into user mismatch
                    if ((e === null || e === void 0 ? void 0 : e.code) === "auth/user-not-found" /* AuthErrorCode.USER_DELETED */ ) $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__reauthenticate.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithCredential(auth, credential) {
    return $82f70d645a4b3e84$var$__signInWithCredential.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__signInWithCredential() {
    $82f70d645a4b3e84$var$__signInWithCredential = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, credential) {
        var bypassAuthState, operationType, response, userCredential;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    operationType = "signIn" /* OperationType.SIGN_IN */ ;
                    return [
                        4,
                        $82f70d645a4b3e84$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response)
                    ];
                case 2:
                    userCredential = _state.sent();
                    if (!!bypassAuthState) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        auth._updateCurrentUser(userCredential.user)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__signInWithCredential.apply(this, arguments);
}
function $82f70d645a4b3e84$export$3c2fa207a37baaea(auth, credential) {
    return $82f70d645a4b3e84$var$_signInWithCredential1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithCredential1() {
    $82f70d645a4b3e84$var$_signInWithCredential1 = /**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, credential) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_signInWithCredential($82f70d645a4b3e84$export$a05254e7c3aeba6e(auth), credential)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithCredential1.apply(this, arguments);
}
function $82f70d645a4b3e84$export$ce26c07117d59d6a(user, credential) {
    return $82f70d645a4b3e84$var$_linkWithCredential.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_linkWithCredential() {
    $82f70d645a4b3e84$var$_linkWithCredential = /**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, credential) {
        var userInternal;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_assertLinkedStatus(false, userInternal, credential.providerId)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $82f70d645a4b3e84$var$_link$1(userInternal, credential)
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_linkWithCredential.apply(this, arguments);
}
function $82f70d645a4b3e84$export$6559d589eb85fbb6(user, credential) {
    return $82f70d645a4b3e84$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_reauthenticateWithCredential() {
    $82f70d645a4b3e84$var$_reauthenticateWithCredential = /**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, credential) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_reauthenticate((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user), credential)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $82f70d645a4b3e84$var$signInWithCustomToken$1(auth, request) {
    return $82f70d645a4b3e84$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithCustomToken$1() {
    $82f70d645a4b3e84$var$_signInWithCustomToken$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $82f70d645a4b3e84$export$efca4cbe5dd06740(auth, customToken) {
    return $82f70d645a4b3e84$var$_signInWithCustomToken.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithCustomToken() {
    $82f70d645a4b3e84$var$_signInWithCustomToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, customToken) {
        var authInternal, response, cred;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        $82f70d645a4b3e84$var$signInWithCustomToken$1(authInternal, {
                            token: customToken,
                            returnSecureToken: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 2:
                    cred = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(cred.user)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        cred
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_signInWithCustomToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$MultiFactorInfoImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorInfoImpl(factorId, response) {
        (0, $lfBxf._)(this, MultiFactorInfoImpl);
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    (0, $9tzan._)(MultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(auth, enrollment) {
                if ("phoneInfo" in enrollment) return $82f70d645a4b3e84$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                else if ("totpInfo" in enrollment) return $82f70d645a4b3e84$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                return $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        }
    ]);
    return MultiFactorInfoImpl;
}();
var $82f70d645a4b3e84$var$PhoneMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $9Hju1._)(PhoneMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $hCdf1._)(PhoneMultiFactorInfoImpl);
    function PhoneMultiFactorInfoImpl(response) {
        (0, $lfBxf._)(this, PhoneMultiFactorInfoImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ , response);
        _this.phoneNumber = response.phoneInfo;
        return _this;
    }
    (0, $9tzan._)(PhoneMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new PhoneMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return PhoneMultiFactorInfoImpl;
}($82f70d645a4b3e84$var$MultiFactorInfoImpl);
var $82f70d645a4b3e84$var$TotpMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $9Hju1._)(TotpMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $hCdf1._)(TotpMultiFactorInfoImpl);
    function TotpMultiFactorInfoImpl(response) {
        (0, $lfBxf._)(this, TotpMultiFactorInfoImpl);
        return _super.call(this, "totp" /* FactorId.TOTP */ , response);
    }
    (0, $9tzan._)(TotpMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new TotpMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return TotpMultiFactorInfoImpl;
}($82f70d645a4b3e84$var$MultiFactorInfoImpl);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $82f70d645a4b3e84$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $82f70d645a4b3e84$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $82f70d645a4b3e84$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
function $82f70d645a4b3e84$var$recachePasswordPolicy(auth) {
    return $82f70d645a4b3e84$var$_recachePasswordPolicy.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_recachePasswordPolicy() {
    $82f70d645a4b3e84$var$_recachePasswordPolicy = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var authInternal;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    if (!authInternal._getPasswordPolicyInternal()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        authInternal._updatePasswordPolicy()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_recachePasswordPolicy.apply(this, arguments);
}
function $82f70d645a4b3e84$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    return $82f70d645a4b3e84$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendPasswordResetEmail() {
    $82f70d645a4b3e84$var$_sendPasswordResetEmail = /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, email, actionCodeSettings) {
        var authInternal, request;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    request = {
                        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (actionCodeSettings) $82f70d645a4b3e84$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
                    return [
                        4,
                        $82f70d645a4b3e84$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $82f70d645a4b3e84$var$sendPasswordResetEmail$1)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    return $82f70d645a4b3e84$var$_confirmPasswordReset.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_confirmPasswordReset() {
    $82f70d645a4b3e84$var$_confirmPasswordReset = /**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, oobCode, newPassword) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$resetPassword((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth), {
                            oobCode: oobCode,
                            newPassword: newPassword
                        }).catch(function() {
                            var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(error) {
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $82f70d645a4b3e84$var$recachePasswordPolicy(auth);
                                    throw error;
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    // Do not return the email.
    });
    return $82f70d645a4b3e84$var$_confirmPasswordReset.apply(this, arguments);
}
function $82f70d645a4b3e84$export$a93c5207d687da10(auth, oobCode) {
    return $82f70d645a4b3e84$var$_applyActionCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_applyActionCode() {
    $82f70d645a4b3e84$var$_applyActionCode = /**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, oobCode) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$applyActionCode$1((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth), {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_applyActionCode.apply(this, arguments);
}
function $82f70d645a4b3e84$export$c3950d9923825c02(auth, oobCode) {
    return $82f70d645a4b3e84$var$_checkActionCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_checkActionCode() {
    $82f70d645a4b3e84$var$_checkActionCode = /**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, oobCode) {
        var authModular, response, operation, multiFactorInfo;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authModular = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth);
                    return [
                        4,
                        $82f70d645a4b3e84$var$resetPassword(authModular, {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    response = _state.sent();
                    // Email could be empty only if the request type is EMAIL_SIGNIN or
                    // VERIFY_AND_CHANGE_EMAIL.
                    // New email should not be empty if the request type is
                    // VERIFY_AND_CHANGE_EMAIL.
                    // Multi-factor info could not be empty if the request type is
                    // REVERT_SECOND_FACTOR_ADDITION.
                    operation = response.requestType;
                    $82f70d645a4b3e84$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    switch(operation){
                        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
                            break;
                        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
                            $82f70d645a4b3e84$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                            break;
                        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
                            $82f70d645a4b3e84$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        // fall through
                        default:
                            $82f70d645a4b3e84$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    }
                    // The multi-factor info for revert second factor addition
                    multiFactorInfo = null;
                    if (response.mfaInfo) multiFactorInfo = $82f70d645a4b3e84$var$MultiFactorInfoImpl._fromServerResponse($82f70d645a4b3e84$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
                    return [
                        2,
                        {
                            data: {
                                email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
                                previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
                                multiFactorInfo: multiFactorInfo
                            },
                            operation: operation
                        }
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_checkActionCode.apply(this, arguments);
}
function $82f70d645a4b3e84$export$a9c996f45e5784d0(auth, code) {
    return $82f70d645a4b3e84$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_verifyPasswordResetCode() {
    $82f70d645a4b3e84$var$_verifyPasswordResetCode = /**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, code) {
        var data;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$export$c3950d9923825c02((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth), code)
                    ];
                case 1:
                    data = _state.sent().data;
                    // Email should always be present since a code was sent to it
                    return [
                        2,
                        data.email
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $82f70d645a4b3e84$export$7910e0436ed8d1de(auth, email, password) {
    return $82f70d645a4b3e84$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_createUserWithEmailAndPassword() {
    $82f70d645a4b3e84$var$_createUserWithEmailAndPassword = /**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, email, password) {
        var authInternal, request, signUpResponse, response, userCredential;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    request = {
                        returnSecureToken: true,
                        email: email,
                        password: password,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    signUpResponse = $82f70d645a4b3e84$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $82f70d645a4b3e84$var$signUp);
                    return [
                        4,
                        signUpResponse.catch(function(error) {
                            if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $82f70d645a4b3e84$var$recachePasswordPolicy(auth);
                            throw error;
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 2:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $82f70d645a4b3e84$export$555508cbc6add439(auth, email, password) {
    return $82f70d645a4b3e84$export$3c2fa207a37baaea((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth), $82f70d645a4b3e84$export$e7c866399fa523f5.credential(email, password)).catch(function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(error) {
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $82f70d645a4b3e84$var$recachePasswordPolicy(auth);
                throw error;
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}
function $82f70d645a4b3e84$export$2219238a014317b0(auth, email, actionCodeSettings) {
    return $82f70d645a4b3e84$var$_sendSignInLinkToEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendSignInLinkToEmail() {
    $82f70d645a4b3e84$var$_sendSignInLinkToEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, email, actionCodeSettings) {
        var authInternal, request;
        function setActionCodeSettings(request, actionCodeSettings) {
            $82f70d645a4b3e84$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            if (actionCodeSettings) $82f70d645a4b3e84$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        }
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    request = {
                        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    setActionCodeSettings(request, actionCodeSettings);
                    return [
                        4,
                        $82f70d645a4b3e84$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $82f70d645a4b3e84$var$sendSignInLinkToEmail$1)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_sendSignInLinkToEmail.apply(this, arguments);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $82f70d645a4b3e84$export$4c3d22f3d993c33f(auth, emailLink) {
    var actionCodeUrl = $82f70d645a4b3e84$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
function $82f70d645a4b3e84$export$f787f51d84a910ad(auth, email, emailLink) {
    return $82f70d645a4b3e84$var$_signInWithEmailLink.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithEmailLink() {
    $82f70d645a4b3e84$var$_signInWithEmailLink = /**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, email, emailLink) {
        var authModular, credential;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            authModular = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth);
            credential = $82f70d645a4b3e84$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $82f70d645a4b3e84$var$_getCurrentUrl());
            // Check if the tenant ID in the email link matches the tenant ID on Auth
            // instance.
            $82f70d645a4b3e84$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
            return [
                2,
                $82f70d645a4b3e84$export$3c2fa207a37baaea(authModular, credential)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithEmailLink.apply(this, arguments);
}
function $82f70d645a4b3e84$var$createAuthUri(auth, request) {
    return $82f70d645a4b3e84$var$_createAuthUri.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_createAuthUri() {
    $82f70d645a4b3e84$var$_createAuthUri = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $82f70d645a4b3e84$var$_createAuthUri.apply(this, arguments);
}
function $82f70d645a4b3e84$export$c9170ad7d4cd7e57(auth, email) {
    return $82f70d645a4b3e84$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_fetchSignInMethodsForEmail() {
    $82f70d645a4b3e84$var$_fetchSignInMethodsForEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, email) {
        var continueUri, request, signinMethods;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // createAuthUri returns an error if continue URI is not http or https.
                    // For environments like Cordova, Chrome extensions, native frameworks, file
                    // systems, etc, use http://localhost as continue URL.
                    continueUri = $82f70d645a4b3e84$var$_isHttpOrHttps() ? $82f70d645a4b3e84$var$_getCurrentUrl() : "http://localhost";
                    request = {
                        identifier: email,
                        continueUri: continueUri
                    };
                    return [
                        4,
                        $82f70d645a4b3e84$var$createAuthUri((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth), request)
                    ];
                case 1:
                    signinMethods = _state.sent().signinMethods;
                    return [
                        2,
                        signinMethods || []
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    return $82f70d645a4b3e84$var$_sendEmailVerification.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_sendEmailVerification() {
    $82f70d645a4b3e84$var$_sendEmailVerification = /**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
                        idToken: idToken
                    };
                    if (actionCodeSettings) $82f70d645a4b3e84$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $82f70d645a4b3e84$var$sendEmailVerification$1(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_sendEmailVerification.apply(this, arguments);
}
function $82f70d645a4b3e84$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    return $82f70d645a4b3e84$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_verifyBeforeUpdateEmail() {
    $82f70d645a4b3e84$var$_verifyBeforeUpdateEmail = /**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, newEmail, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
                        idToken: idToken,
                        newEmail: newEmail
                    };
                    if (actionCodeSettings) $82f70d645a4b3e84$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $82f70d645a4b3e84$var$verifyAndChangeEmail(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    // If the local copy of the email on user is outdated, reload the
                    // user.
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $82f70d645a4b3e84$var$updateProfile$1(auth, request) {
    return $82f70d645a4b3e84$var$_updateProfile$1.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_updateProfile$1() {
    $82f70d645a4b3e84$var$_updateProfile$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, request) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_updateProfile$1.apply(this, arguments);
}
function $82f70d645a4b3e84$export$21579262ef46735b(user, _) {
    return $82f70d645a4b3e84$var$_updateProfile.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_updateProfile() {
    $82f70d645a4b3e84$var$_updateProfile = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, param) {
        var displayName, photoUrl, userInternal, idToken, profileRequest, response, passwordProvider;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    displayName = param.displayName, photoUrl = param.photoURL;
                    if (displayName === undefined && photoUrl === undefined) return [
                        2
                    ];
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    profileRequest = {
                        idToken: idToken,
                        displayName: displayName,
                        photoUrl: photoUrl,
                        returnSecureToken: true
                    };
                    return [
                        4,
                        $82f70d645a4b3e84$var$_logoutIfInvalidated(userInternal, $82f70d645a4b3e84$var$updateProfile$1(userInternal.auth, profileRequest))
                    ];
                case 2:
                    response = _state.sent();
                    userInternal.displayName = response.displayName || null;
                    userInternal.photoURL = response.photoUrl || null;
                    // Update the password provider as well
                    passwordProvider = userInternal.providerData.find(function(param) {
                        var providerId = param.providerId;
                        return providerId === "password" /* ProviderId.PASSWORD */ ;
                    });
                    if (passwordProvider) {
                        passwordProvider.displayName = userInternal.displayName;
                        passwordProvider.photoURL = userInternal.photoURL;
                    }
                    return [
                        4,
                        userInternal._updateTokensIfNecessary(response)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_updateProfile.apply(this, arguments);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $82f70d645a4b3e84$export$ab83b03e4111b1d0(user, newEmail) {
    return $82f70d645a4b3e84$var$updateEmailOrPassword((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $82f70d645a4b3e84$export$1a82df3d29112e01(user, newPassword) {
    return $82f70d645a4b3e84$var$updateEmailOrPassword((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user), null, newPassword);
}
function $82f70d645a4b3e84$var$updateEmailOrPassword(user, email, password) {
    return $82f70d645a4b3e84$var$_updateEmailOrPassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_updateEmailOrPassword() {
    $82f70d645a4b3e84$var$_updateEmailOrPassword = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, email, password) {
        var auth, idToken, request, response;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        idToken: idToken,
                        returnSecureToken: true
                    };
                    if (email) request.email = email;
                    if (password) request.password = password;
                    return [
                        4,
                        $82f70d645a4b3e84$var$_logoutIfInvalidated(user, $82f70d645a4b3e84$var$updateEmailPassword(auth, request))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        user._updateTokensIfNecessary(response, /* reload */ true)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_updateEmailOrPassword.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $82f70d645a4b3e84$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    var providerId = idTokenResponse.providerId;
    var profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    var isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        var signInProvider = (_b = (_a = $82f70d645a4b3e84$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            var filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $82f70d645a4b3e84$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $82f70d645a4b3e84$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $82f70d645a4b3e84$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $82f70d645a4b3e84$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $82f70d645a4b3e84$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $82f70d645a4b3e84$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $82f70d645a4b3e84$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
var $82f70d645a4b3e84$var$GenericAdditionalUserInfo = function GenericAdditionalUserInfo(isNewUser, providerId) {
    "use strict";
    var profile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, $lfBxf._)(this, GenericAdditionalUserInfo);
    this.isNewUser = isNewUser;
    this.providerId = providerId;
    this.profile = profile;
};
var $82f70d645a4b3e84$var$FederatedAdditionalUserInfoWithUsername = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $9Hju1._)(FederatedAdditionalUserInfoWithUsername, GenericAdditionalUserInfo);
    var _super = (0, $hCdf1._)(FederatedAdditionalUserInfoWithUsername);
    function FederatedAdditionalUserInfoWithUsername(isNewUser, providerId, profile, username) {
        (0, $lfBxf._)(this, FederatedAdditionalUserInfoWithUsername);
        var _this;
        _this = _super.call(this, isNewUser, providerId, profile);
        _this.username = username;
        return _this;
    }
    return FederatedAdditionalUserInfoWithUsername;
}($82f70d645a4b3e84$var$GenericAdditionalUserInfo);
var $82f70d645a4b3e84$var$FacebookAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $9Hju1._)(FacebookAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $hCdf1._)(FacebookAdditionalUserInfo);
    function FacebookAdditionalUserInfo(isNewUser, profile) {
        (0, $lfBxf._)(this, FacebookAdditionalUserInfo);
        return _super.call(this, isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
    return FacebookAdditionalUserInfo;
}($82f70d645a4b3e84$var$GenericAdditionalUserInfo);
var $82f70d645a4b3e84$var$GithubAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $9Hju1._)(GithubAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $hCdf1._)(GithubAdditionalUserInfo);
    function GithubAdditionalUserInfo(isNewUser, profile) {
        (0, $lfBxf._)(this, GithubAdditionalUserInfo);
        return _super.call(this, isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
    return GithubAdditionalUserInfo;
}($82f70d645a4b3e84$var$FederatedAdditionalUserInfoWithUsername);
var $82f70d645a4b3e84$var$GoogleAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $9Hju1._)(GoogleAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $hCdf1._)(GoogleAdditionalUserInfo);
    function GoogleAdditionalUserInfo(isNewUser, profile) {
        (0, $lfBxf._)(this, GoogleAdditionalUserInfo);
        return _super.call(this, isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
    return GoogleAdditionalUserInfo;
}($82f70d645a4b3e84$var$GenericAdditionalUserInfo);
var $82f70d645a4b3e84$var$TwitterAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $9Hju1._)(TwitterAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $hCdf1._)(TwitterAdditionalUserInfo);
    function TwitterAdditionalUserInfo(isNewUser, profile, screenName) {
        (0, $lfBxf._)(this, TwitterAdditionalUserInfo);
        return _super.call(this, isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
    return TwitterAdditionalUserInfo;
}($82f70d645a4b3e84$var$FederatedAdditionalUserInfoWithUsername);
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $82f70d645a4b3e84$export$8a5498727ef6be21(userCredential) {
    var user = userCredential.user, _tokenResponse = userCredential._tokenResponse;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $82f70d645a4b3e84$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $82f70d645a4b3e84$export$9e5f44173e64f162(auth, persistence) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $82f70d645a4b3e84$export$625550452a3fa3ec(auth) {
    return $82f70d645a4b3e84$var$_initializeRecaptchaConfig(auth);
}
function $82f70d645a4b3e84$export$90a7f3efeed30595(auth, password) {
    return $82f70d645a4b3e84$var$_validatePassword.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_validatePassword() {
    $82f70d645a4b3e84$var$_validatePassword = /**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, password) {
        var authInternal;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
            return [
                2,
                authInternal.validatePassword(password)
            ];
        });
    });
    return $82f70d645a4b3e84$var$_validatePassword.apply(this, arguments);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $82f70d645a4b3e84$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $82f70d645a4b3e84$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $82f70d645a4b3e84$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $82f70d645a4b3e84$export$df995fae86a55f06(auth) {
    (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $82f70d645a4b3e84$export$ef35774e6d314e91(auth, user) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $82f70d645a4b3e84$export$e7094788287c5e9b(auth) {
    return (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $82f70d645a4b3e84$export$96f57966bedc81b4(auth, token) {
    var authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
function $82f70d645a4b3e84$export$a9c23c6ac3fc3eca(user) {
    return $82f70d645a4b3e84$var$_deleteUser.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_deleteUser() {
    $82f70d645a4b3e84$var$_deleteUser = /**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user).delete()
            ];
        });
    });
    return $82f70d645a4b3e84$var$_deleteUser.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$MultiFactorSessionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorSessionImpl(type, credential, user) {
        (0, $lfBxf._)(this, MultiFactorSessionImpl);
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    (0, $9tzan._)(MultiFactorSessionImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                var key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
                return {
                    multiFactorSession: (0, $azcHm._)({}, key, this.credential)
                };
            }
        }
    ], [
        {
            key: "_fromIdtoken",
            value: function _fromIdtoken(idToken, user) {
                return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
            }
        },
        {
            key: "_fromMfaPendingCredential",
            value: function _fromMfaPendingCredential(mfaPendingCredential) {
                return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(obj) {
                var _a, _b;
                if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
                    if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
                    else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
                }
                return null;
            }
        }
    ]);
    return MultiFactorSessionImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$MultiFactorResolverImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorResolverImpl(session, hints, signInResolver) {
        (0, $lfBxf._)(this, MultiFactorResolverImpl);
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    (0, $9tzan._)(MultiFactorResolverImpl, [
        {
            key: "resolveSignIn",
            value: function resolveSignIn(assertionExtern) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var assertion;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        assertion = assertionExtern;
                        return [
                            2,
                            _this.signInResolver(assertion)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromError",
            value: /** @internal */ function _fromError(authExtern, error) {
                var auth = $82f70d645a4b3e84$export$a05254e7c3aeba6e(authExtern);
                var serverResponse = error.customData._serverResponse;
                var hints = (serverResponse.mfaInfo || []).map(function(enrollment) {
                    return $82f70d645a4b3e84$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                });
                $82f70d645a4b3e84$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var session = $82f70d645a4b3e84$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
                return new MultiFactorResolverImpl(session, hints, function() {
                    var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(assertion) {
                        var mfaResponse, idTokenResponse, _, userCredential;
                        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        assertion._process(auth, session)
                                    ];
                                case 1:
                                    mfaResponse = _state.sent();
                                    // Clear out the unneeded fields from the old login response
                                    delete serverResponse.mfaInfo;
                                    delete serverResponse.mfaPendingCredential;
                                    // Use in the new token & refresh token in the old response
                                    idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                                        idToken: mfaResponse.idToken,
                                        refreshToken: mfaResponse.refreshToken
                                    });
                                    _ = error.operationType;
                                    switch(_){
                                        case "signIn" /* OperationType.SIGN_IN */ :
                                            return [
                                                3,
                                                2
                                            ];
                                        case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                                            return [
                                                3,
                                                5
                                            ];
                                    }
                                    return [
                                        3,
                                        6
                                    ];
                                case 2:
                                    return [
                                        4,
                                        $82f70d645a4b3e84$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse)
                                    ];
                                case 3:
                                    userCredential = _state.sent();
                                    return [
                                        4,
                                        auth._updateCurrentUser(userCredential.user)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        2,
                                        userCredential
                                    ];
                                case 5:
                                    $82f70d645a4b3e84$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    return [
                                        2,
                                        $82f70d645a4b3e84$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse)
                                    ];
                                case 6:
                                    $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    _state.label = 7;
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(assertion) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return MultiFactorResolverImpl;
}();
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $82f70d645a4b3e84$export$6554612db691658e(auth, error) {
    var _a;
    var authModular = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(auth);
    var errorInternal = error;
    $82f70d645a4b3e84$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $82f70d645a4b3e84$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $82f70d645a4b3e84$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$startEnrollPhoneMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
function $82f70d645a4b3e84$var$finalizeEnrollPhoneMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
function $82f70d645a4b3e84$var$startEnrollTotpMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
function $82f70d645a4b3e84$var$finalizeEnrollTotpMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
function $82f70d645a4b3e84$var$withdrawMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
var $82f70d645a4b3e84$var$MultiFactorUserImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorUserImpl(user) {
        var _this = this;
        (0, $lfBxf._)(this, MultiFactorUserImpl);
        this.user = user;
        this.enrolledFactors = [];
        user._onReload(function(userInfo) {
            if (userInfo.mfaInfo) _this.enrolledFactors = userInfo.mfaInfo.map(function(enrollment) {
                return $82f70d645a4b3e84$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment);
            });
        });
    }
    (0, $9tzan._)(MultiFactorUserImpl, [
        {
            key: "getSession",
            value: function getSession() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = $82f70d645a4b3e84$var$MultiFactorSessionImpl._fromIdtoken;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply($82f70d645a4b3e84$var$MultiFactorSessionImpl, [
                                        _state.sent(),
                                        _this.user
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "enroll",
            value: function enroll(assertionExtern, displayName) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var assertion, session, finalizeMfaResponse;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                assertion = assertionExtern;
                                return [
                                    4,
                                    _this.getSession()
                                ];
                            case 1:
                                session = _state.sent();
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_logoutIfInvalidated(_this.user, assertion._process(_this.user.auth, session, displayName))
                                ];
                            case 2:
                                finalizeMfaResponse = _state.sent();
                                // New tokens will be issued after enrollment of the new second factors.
                                // They need to be updated on the user.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(finalizeMfaResponse)
                                ];
                            case 3:
                                _state.sent();
                                // The user needs to be reloaded to get the new multi-factor information
                                // from server. USER_RELOADED event will be triggered and `enrolledFactors`
                                // will be updated.
                                return [
                                    2,
                                    _this.user.reload()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unenroll",
            value: function unenroll(infoOrUid) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var mfaEnrollmentId, idToken, idTokenResponse, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_logoutIfInvalidated(_this.user, $82f70d645a4b3e84$var$withdrawMfa(_this.user.auth, {
                                        idToken: idToken,
                                        mfaEnrollmentId: mfaEnrollmentId
                                    }))
                                ];
                            case 3:
                                idTokenResponse = _state.sent();
                                // Remove the second factor from the user's list.
                                _this.enrolledFactors = _this.enrolledFactors.filter(function(param) {
                                    var uid = param.uid;
                                    return uid !== mfaEnrollmentId;
                                });
                                // Depending on whether the backend decided to revoke the user's session,
                                // the tokenResponse may be empty. If the tokens were not updated (and they
                                // are now invalid), reloading the user will discover this and invalidate
                                // the user's state accordingly.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(idTokenResponse)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.user.reload()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromUser",
            value: function _fromUser(user) {
                return new MultiFactorUserImpl(user);
            }
        }
    ]);
    return MultiFactorUserImpl;
}();
var $82f70d645a4b3e84$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $82f70d645a4b3e84$export$493d36ec626b6698(user) {
    var userModular = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
    if (!$82f70d645a4b3e84$var$multiFactorUserCache.has(userModular)) $82f70d645a4b3e84$var$multiFactorUserCache.set(userModular, $82f70d645a4b3e84$var$MultiFactorUserImpl._fromUser(userModular));
    return $82f70d645a4b3e84$var$multiFactorUserCache.get(userModular);
}
var $82f70d645a4b3e84$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
var $82f70d645a4b3e84$var$BrowserPersistenceClass = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPersistenceClass(storageRetriever, type) {
        (0, $lfBxf._)(this, BrowserPersistenceClass);
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    (0, $9tzan._)(BrowserPersistenceClass, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                try {
                    if (!this.storage) return Promise.resolve(false);
                    this.storage.setItem($82f70d645a4b3e84$var$STORAGE_AVAILABLE_KEY, "1");
                    this.storage.removeItem($82f70d645a4b3e84$var$STORAGE_AVAILABLE_KEY);
                    return Promise.resolve(true);
                } catch (_a) {
                    return Promise.resolve(false);
                }
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                this.storage.setItem(key, JSON.stringify(value));
                return Promise.resolve();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var json = this.storage.getItem(key);
                return Promise.resolve(json ? JSON.parse(json) : null);
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                this.storage.removeItem(key);
                return Promise.resolve();
            }
        },
        {
            key: "storage",
            get: function get() {
                return this.storageRetriever();
            }
        }
    ]);
    return BrowserPersistenceClass;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$_iframeCannotSyncWebStorage() {
    var ua = (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)();
    return $82f70d645a4b3e84$var$_isSafari(ua) || $82f70d645a4b3e84$export$d66dc83d8cfc8dd(ua);
}
// The polling period in case events are not supported
var $82f70d645a4b3e84$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
var $82f70d645a4b3e84$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
var $82f70d645a4b3e84$var$BrowserLocalPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $9Hju1._)(BrowserLocalPersistence, BrowserPersistenceClass);
    var _super = (0, $hCdf1._)(BrowserLocalPersistence);
    function BrowserLocalPersistence() {
        (0, $lfBxf._)(this, BrowserLocalPersistence);
        var _this;
        _this = _super.call(this, function() {
            return window.localStorage;
        }, "LOCAL" /* PersistenceType.LOCAL */ );
        _this.boundEventHandler = function(event, poll) {
            return _this.onStorageEvent(event, poll);
        };
        _this.listeners = {};
        _this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        _this.safariLocalStorageNotSynced = $82f70d645a4b3e84$var$_iframeCannotSyncWebStorage() && $82f70d645a4b3e84$var$_isIframe();
        // Whether to use polling instead of depending on window events
        _this.fallbackToPolling = $82f70d645a4b3e84$var$_isMobileBrowser();
        _this._shouldAllowMigration = true;
        return _this;
    }
    (0, $9tzan._)(BrowserLocalPersistence, [
        {
            key: "forAllChangedKeys",
            value: function forAllChangedKeys(cb) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Check all keys with listeners on them.
                    for(var _iterator = Object.keys(this.listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Get value from localStorage.
                        var newValue = this.storage.getItem(key);
                        var oldValue = this.localCache[key];
                        // If local map value does not match, trigger listener with storage event.
                        // Differentiate this simulated event from the real storage event.
                        if (newValue !== oldValue) cb(key, oldValue, newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "onStorageEvent",
            value: function onStorageEvent(event) {
                var poll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                // Key would be null in some situations, like when localStorage is cleared
                if (!event.key) {
                    this.forAllChangedKeys(function(key, _oldValue, newValue) {
                        _this.notifyListeners(key, newValue);
                    });
                    return;
                }
                var key = event.key;
                // Check the mechanism how this event was detected.
                // The first event will dictate the mechanism to be used.
                if (poll) // Environment detects storage changes via polling.
                // Remove storage event listener to prevent possible event duplication.
                this.detachListener();
                else // Environment detects storage changes via storage event listener.
                // Remove polling listener to prevent possible event duplication.
                this.stopPolling();
                // Safari embedded iframe. Storage event will trigger with the delta
                // changes but no changes will be applied to the iframe localStorage.
                if (this.safariLocalStorageNotSynced) {
                    // Get current iframe page value.
                    var storedValue = this.storage.getItem(key);
                    // Value not synchronized, synchronize manually.
                    if (event.newValue !== storedValue) {
                        if (event.newValue !== null) // Value changed from current value.
                        this.storage.setItem(key, event.newValue);
                        else // Current value deleted.
                        this.storage.removeItem(key);
                    } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
                    return;
                }
                var triggerListeners = function() {
                    // Keep local map up to date in case storage event is triggered before
                    // poll.
                    var storedValue = _this.storage.getItem(key);
                    if (!poll && _this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
                    // This seems to trigger in some IE browsers for some reason.
                    return;
                    _this.notifyListeners(key, storedValue);
                };
                var storedValue1 = this.storage.getItem(key);
                if ($82f70d645a4b3e84$var$_isIE10() && storedValue1 !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
                // correct key, oldValue and newValue but localStorage.getItem(key) does
                // not yield the updated value until a few milliseconds. This ensures
                // this recovers from that situation.
                setTimeout(triggerListeners, $82f70d645a4b3e84$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
                else triggerListeners();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, value) {
                this.localCache[key] = value;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(value ? JSON.parse(value) : value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                var _this = this;
                this.stopPolling();
                this.pollTimer = setInterval(function() {
                    _this.forAllChangedKeys(function(key, oldValue, newValue) {
                        _this.onStorageEvent(new StorageEvent("storage", {
                            key: key,
                            oldValue: oldValue,
                            newValue: newValue
                        }), /* poll */ true);
                    });
                }, $82f70d645a4b3e84$var$_POLLING_INTERVAL_MS$1);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "attachListener",
            value: function attachListener() {
                window.addEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "detachListener",
            value: function detachListener() {
                window.removeEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) {
                    // Whether browser can detect storage event when it had already been pushed to the background.
                    // This may happen in some mobile browsers. A localStorage change in the foreground window
                    // will not be detected in the background window via the storage event.
                    // This was detected in iOS 7.x mobile browsers
                    if (this.fallbackToPolling) this.startPolling();
                    else this.attachListener();
                }
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    // Populate the cache to avoid spuriously triggering on first poll.
                    this.localCache[key] = this.storage.getItem(key);
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key].delete(listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) {
                    this.detachListener();
                    this.stopPolling();
                }
            }
        },
        {
            key: "_set",
            value: // Update local cache on base operations:
            function _set(key, value) {
                var _this = this;
                var _this1 = this, _superprop_get__set = function() {
                    return (0, $2234ea2a8ddda7cd$export$afb3516d9d608401)((0, $g0UjU._)(BrowserLocalPersistence.prototype), "_set", _this);
                };
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__set().call(_this1, key, value)
                                ];
                            case 1:
                                _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get1(key) {
                var _this = this;
                var _this1 = this, _superprop_get__get = function() {
                    return (0, $2234ea2a8ddda7cd$export$afb3516d9d608401)((0, $g0UjU._)(BrowserLocalPersistence.prototype), "_get", _this);
                };
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var value;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__get().call(_this1, key)
                                ];
                            case 1:
                                value = _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2,
                                    value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                var _this1 = this, _superprop_get__remove = function() {
                    return (0, $2234ea2a8ddda7cd$export$afb3516d9d608401)((0, $g0UjU._)(BrowserLocalPersistence.prototype), "_remove", _this);
                };
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__remove().call(_this1, key)
                                ];
                            case 1:
                                _state.sent();
                                delete _this1.localCache[key];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BrowserLocalPersistence;
}($82f70d645a4b3e84$var$BrowserPersistenceClass);
$82f70d645a4b3e84$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ var $82f70d645a4b3e84$export$8b22cf2602fb60ce = $82f70d645a4b3e84$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$BrowserSessionPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $9Hju1._)(BrowserSessionPersistence, BrowserPersistenceClass);
    var _super = (0, $hCdf1._)(BrowserSessionPersistence);
    function BrowserSessionPersistence() {
        (0, $lfBxf._)(this, BrowserSessionPersistence);
        return _super.call(this, function() {
            return window.sessionStorage;
        }, "SESSION" /* PersistenceType.SESSION */ );
    }
    (0, $9tzan._)(BrowserSessionPersistence, [
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        }
    ]);
    return BrowserSessionPersistence;
}($82f70d645a4b3e84$var$BrowserPersistenceClass);
$82f70d645a4b3e84$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ var $82f70d645a4b3e84$export$407448d2b89b1813 = $82f70d645a4b3e84$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $82f70d645a4b3e84$var$_allSettled(promises) {
    return Promise.all(promises.map(function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(promise) {
            var value, reason;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 1:
                        value = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: true,
                                value: value
                            }
                        ];
                    case 2:
                        reason = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: false,
                                reason: reason
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(promise) {
            return _ref.apply(this, arguments);
        };
    }()));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ var $82f70d645a4b3e84$var$Receiver = /*#__PURE__*/ function() {
    "use strict";
    function Receiver(eventTarget) {
        (0, $lfBxf._)(this, Receiver);
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    (0, $9tzan._)(Receiver, [
        {
            key: "isListeningto",
            value: function isListeningto(eventTarget) {
                return this.eventTarget === eventTarget;
            }
        },
        {
            key: "handleEvent",
            value: /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ function handleEvent(event) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var messageEvent, _messageEvent_data, eventId, eventType, data, handlers, promises, response;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                messageEvent = event;
                                _messageEvent_data = messageEvent.data, eventId = _messageEvent_data.eventId, eventType = _messageEvent_data.eventType, data = _messageEvent_data.data;
                                handlers = _this.handlersMap[eventType];
                                if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return [
                                    2
                                ];
                                messageEvent.ports[0].postMessage({
                                    status: "ack" /* _Status.ACK */ ,
                                    eventId: eventId,
                                    eventType: eventType
                                });
                                promises = Array.from(handlers).map(function() {
                                    var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(handler) {
                                        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                            return [
                                                2,
                                                handler(messageEvent.origin, data)
                                            ];
                                        });
                                    });
                                    return function(handler) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_allSettled(promises)
                                ];
                            case 1:
                                response = _state.sent();
                                messageEvent.ports[0].postMessage({
                                    status: "done" /* _Status.DONE */ ,
                                    eventId: eventId,
                                    eventType: eventType,
                                    response: response
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ key: "_subscribe",
            value: function _subscribe(eventType, eventHandler) {
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
                if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
                this.handlersMap[eventType].add(eventHandler);
            }
        },
        {
            /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ key: "_unsubscribe",
            value: function _unsubscribe(eventType, eventHandler) {
                if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
                if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
            }
        }
    ], [
        {
            key: "_getInstance",
            value: /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ function _getInstance(eventTarget) {
                // The results are stored in an array since objects can't be keys for other
                // objects. In addition, setting a unique property on an event target as a
                // hash map key may not be allowed due to CORS restrictions.
                var existingInstance = this.receivers.find(function(receiver) {
                    return receiver.isListeningto(eventTarget);
                });
                if (existingInstance) return existingInstance;
                var newInstance = new Receiver(eventTarget);
                this.receivers.push(newInstance);
                return newInstance;
            }
        }
    ]);
    return Receiver;
}();
$82f70d645a4b3e84$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$export$faec65b429be379() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var random = "";
    for(var i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ var $82f70d645a4b3e84$var$Sender = /*#__PURE__*/ function() {
    "use strict";
    function Sender(target) {
        (0, $lfBxf._)(this, Sender);
        this.target = target;
        this.handlers = new Set();
    }
    (0, $9tzan._)(Sender, [
        {
            /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ key: "removeMessageHandler",
            value: function removeMessageHandler(handler) {
                if (handler.messageChannel) {
                    handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
                    handler.messageChannel.port1.close();
                }
                this.handlers.delete(handler);
            }
        },
        {
            key: "_send",
            value: /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ function _send(eventType, data) {
                var timeout = arguments.length > 2 && arguments[2] !== void 0 /* _TimeoutDuration.ACK */  ? arguments[2] : 50;
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var messageChannel, completionTimer, handler;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
                        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var eventId = $82f70d645a4b3e84$export$faec65b429be379("", 20);
                                messageChannel.port1.start();
                                var ackTimer = setTimeout(function() {
                                    reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
                                }, timeout);
                                handler = {
                                    messageChannel: messageChannel,
                                    onMessage: function(event) {
                                        var messageEvent = event;
                                        if (messageEvent.data.eventId !== eventId) return;
                                        switch(messageEvent.data.status){
                                            case "ack" /* _Status.ACK */ :
                                                // The receiver should ACK first.
                                                clearTimeout(ackTimer);
                                                completionTimer = setTimeout(function() {
                                                    reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                                                }, 3000 /* _TimeoutDuration.COMPLETION */ );
                                                break;
                                            case "done" /* _Status.DONE */ :
                                                // Once the receiver's handlers are finished we will get the results.
                                                clearTimeout(completionTimer);
                                                resolve(messageEvent.data.response);
                                                break;
                                            default:
                                                clearTimeout(ackTimer);
                                                clearTimeout(completionTimer);
                                                reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                                                break;
                                        }
                                    }
                                };
                                _this.handlers.add(handler);
                                messageChannel.port1.addEventListener("message", handler.onMessage);
                                _this.target.postMessage({
                                    eventType: eventType,
                                    eventId: eventId,
                                    data: data
                                }, [
                                    messageChannel.port2
                                ]);
                            }).finally(function() {
                                if (handler) _this.removeMessageHandler(handler);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return Sender;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $82f70d645a4b3e84$var$_window() {
    return window;
}
function $82f70d645a4b3e84$var$_setWindowLocation(url) {
    $82f70d645a4b3e84$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$_isWorker() {
    return typeof $82f70d645a4b3e84$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $82f70d645a4b3e84$var$_window()["importScripts"] === "function";
}
function $82f70d645a4b3e84$var$_getActiveServiceWorker() {
    return $82f70d645a4b3e84$var$__getActiveServiceWorker.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__getActiveServiceWorker() {
    $82f70d645a4b3e84$var$__getActiveServiceWorker = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
        var registration, _a;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return [
                        2,
                        null
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.serviceWorker.ready
                    ];
                case 2:
                    registration = _state.sent();
                    return [
                        2,
                        registration.active
                    ];
                case 3:
                    _a = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__getActiveServiceWorker.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $82f70d645a4b3e84$var$_getWorkerGlobalScope() {
    return $82f70d645a4b3e84$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$DB_NAME = "firebaseLocalStorageDb";
var $82f70d645a4b3e84$var$DB_VERSION = 1;
var $82f70d645a4b3e84$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
var $82f70d645a4b3e84$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ var $82f70d645a4b3e84$var$DBPromise = /*#__PURE__*/ function() {
    "use strict";
    function DBPromise(request) {
        (0, $lfBxf._)(this, DBPromise);
        this.request = request;
    }
    (0, $9tzan._)(DBPromise, [
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    _this.request.addEventListener("success", function() {
                        resolve(_this.request.result);
                    });
                    _this.request.addEventListener("error", function() {
                        reject(_this.request.error);
                    });
                });
            }
        }
    ]);
    return DBPromise;
}();
function $82f70d645a4b3e84$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $82f70d645a4b3e84$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($82f70d645a4b3e84$var$DB_OBJECTSTORE_NAME);
}
function $82f70d645a4b3e84$var$_deleteDatabase() {
    var request = indexedDB.deleteDatabase($82f70d645a4b3e84$var$DB_NAME);
    return new $82f70d645a4b3e84$var$DBPromise(request).toPromise();
}
function $82f70d645a4b3e84$var$_openDatabase() {
    var request = indexedDB.open($82f70d645a4b3e84$var$DB_NAME, $82f70d645a4b3e84$var$DB_VERSION);
    return new Promise(function(resolve, reject) {
        request.addEventListener("error", function() {
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", function() {
            var db = request.result;
            try {
                db.createObjectStore($82f70d645a4b3e84$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $82f70d645a4b3e84$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", /*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
            var db;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        db = request.result;
                        if (!!db.objectStoreNames.contains($82f70d645a4b3e84$var$DB_OBJECTSTORE_NAME)) return [
                            3,
                            3
                        ];
                        // Need to close the database or else you get a `blocked` event
                        db.close();
                        return [
                            4,
                            $82f70d645a4b3e84$var$_deleteDatabase()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            $82f70d645a4b3e84$var$_openDatabase()
                        ];
                    case 2:
                        resolve.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        resolve(db);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }));
    });
}
function $82f70d645a4b3e84$var$_putObject(db, key, value) {
    return $82f70d645a4b3e84$var$__putObject.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__putObject() {
    $82f70d645a4b3e84$var$__putObject = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(db, key, value) {
        var _obj, request;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            request = $82f70d645a4b3e84$var$getObjectStore(db, true).put((_obj = {}, (0, $azcHm._)(_obj, $82f70d645a4b3e84$var$DB_DATA_KEYPATH, key), (0, $azcHm._)(_obj, "value", value), _obj));
            return [
                2,
                new $82f70d645a4b3e84$var$DBPromise(request).toPromise()
            ];
        });
    });
    return $82f70d645a4b3e84$var$__putObject.apply(this, arguments);
}
function $82f70d645a4b3e84$var$getObject(db, key) {
    return $82f70d645a4b3e84$var$_getObject.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getObject() {
    $82f70d645a4b3e84$var$_getObject = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(db, key) {
        var request, data;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = $82f70d645a4b3e84$var$getObjectStore(db, false).get(key);
                    return [
                        4,
                        new $82f70d645a4b3e84$var$DBPromise(request).toPromise()
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data === undefined ? null : data.value
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_getObject.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_deleteObject(db, key) {
    var request = $82f70d645a4b3e84$var$getObjectStore(db, true).delete(key);
    return new $82f70d645a4b3e84$var$DBPromise(request).toPromise();
}
var $82f70d645a4b3e84$var$_POLLING_INTERVAL_MS = 800;
var $82f70d645a4b3e84$var$_TRANSACTION_RETRY_COUNT = 3;
var $82f70d645a4b3e84$var$IndexedDBLocalPersistence = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDBLocalPersistence() {
        (0, $lfBxf._)(this, IndexedDBLocalPersistence);
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function() {}, function() {});
    }
    (0, $9tzan._)(IndexedDBLocalPersistence, [
        {
            key: "_openDb",
            value: function _openDb() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.db) return [
                                    2,
                                    _this.db
                                ];
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_openDatabase()
                                ];
                            case 1:
                                _this.db = _state.sent();
                                return [
                                    2,
                                    _this.db
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withRetries",
            value: function _withRetries(op) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var numAttempts, db, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                numAttempts = 0;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this._openDb()
                                ];
                            case 3:
                                db = _state.sent();
                                return [
                                    4,
                                    op(db)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                e = _state.sent();
                                if (numAttempts++ > $82f70d645a4b3e84$var$_TRANSACTION_RETRY_COUNT) throw e;
                                if (_this.db) {
                                    _this.db.close();
                                    _this.db = undefined;
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeServiceWorkerMessaging",
            value: /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ function initializeServiceWorkerMessaging() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            $82f70d645a4b3e84$var$_isWorker() ? _this.initializeReceiver() : _this.initializeSender()
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeReceiver",
            value: /**
     * As the worker we should listen to events from the main window.
     */ function initializeReceiver() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        _this.receiver = $82f70d645a4b3e84$var$Receiver._getInstance($82f70d645a4b3e84$var$_getWorkerGlobalScope());
                        // Refresh from persistence if we receive a KeyChanged message.
                        _this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , function() {
                            var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(_origin, data) {
                                var keys;
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._poll()
                                            ];
                                        case 1:
                                            keys = _state.sent();
                                            return [
                                                2,
                                                {
                                                    keyProcessed: keys.includes(data.key)
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(_origin, data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        // Let the sender know that we are listening so they give us more timeout.
                        _this.receiver._subscribe("ping" /* _EventType.PING */ , function() {
                            var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(_origin, _data) {
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    return [
                                        2,
                                        [
                                            "keyChanged" /* _EventType.KEY_CHANGED */ 
                                        ]
                                    ];
                                });
                            });
                            return function(_origin, _data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeSender",
            value: /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ function initializeSender() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, _b, results;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_getActiveServiceWorker()
                                ];
                            case 1:
                                // Check to see if there's an active service worker.
                                _this.activeServiceWorker = _state.sent();
                                if (!_this.activeServiceWorker) return [
                                    2
                                ];
                                _this.sender = new $82f70d645a4b3e84$var$Sender(_this.activeServiceWorker);
                                return [
                                    4,
                                    _this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ )
                                ];
                            case 2:
                                results = _state.sent();
                                if (!results) return [
                                    2
                                ];
                                if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) _this.serviceWorkerReceiverAvailable = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyServiceWorker",
            value: /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ function notifyServiceWorker(key) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.sender || !_this.activeServiceWorker || $82f70d645a4b3e84$var$_getServiceWorkerController() !== _this.activeServiceWorker) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                                        key: key
                                    }, // Use long timeout if receiver has previously responded to a ping from us.
                                    _this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ )
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var db, _a;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!indexedDB) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_openDatabase()
                                ];
                            case 1:
                                db = _state.sent();
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_putObject(db, $82f70d645a4b3e84$var$STORAGE_AVAILABLE_KEY, "1")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_deleteObject(db, $82f70d645a4b3e84$var$STORAGE_AVAILABLE_KEY)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                _a = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withPendingWrite",
            value: function _withPendingWrite(write) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.pendingWrites++;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    write()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.pendingWrites--;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $82f70d645a4b3e84$var$_putObject(db, key, value);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            _this.localCache[key] = value;
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var obj;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        return $82f70d645a4b3e84$var$getObject(db, key);
                                    })
                                ];
                            case 1:
                                obj = _state.sent();
                                _this.localCache[key] = obj;
                                return [
                                    2,
                                    obj
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $82f70d645a4b3e84$var$_deleteObject(db, key);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            delete _this.localCache[key];
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_poll",
            value: function _poll() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var result, keys, keysInResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, localKey;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        var getAllRequest = $82f70d645a4b3e84$var$getObjectStore(db, false).getAll();
                                        return new $82f70d645a4b3e84$var$DBPromise(getAllRequest).toPromise();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) return [
                                    2,
                                    []
                                ];
                                // If we have pending writes in progress abort, we'll get picked up on the next poll
                                if (_this.pendingWrites !== 0) return [
                                    2,
                                    []
                                ];
                                keys = [];
                                keysInResult = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = result[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = _step.value, key = _step_value.fbase_key, value = _step_value.value;
                                        keysInResult.add(key);
                                        if (JSON.stringify(_this.localCache[key]) !== JSON.stringify(value)) {
                                            _this.notifyListeners(key, value);
                                            keys.push(key);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = Object.keys(_this.localCache)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        localKey = _step1.value;
                                        if (_this.localCache[localKey] && !keysInResult.has(localKey)) {
                                            // Deleted
                                            _this.notifyListeners(localKey, null);
                                            keys.push(localKey);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    keys
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, newValue) {
                this.localCache[key] = newValue;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                this.stopPolling();
                var _this = this;
                this.pollTimer = setInterval(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            _this._poll()
                        ];
                    });
                }), $82f70d645a4b3e84$var$_POLLING_INTERVAL_MS);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) this.startPolling();
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    // Populate the cache to avoid spuriously triggering on first poll.
                    this._get(key); // This can happen in the background async and we can return immediately.
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key].delete(listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) this.stopPolling();
            }
        }
    ]);
    return IndexedDBLocalPersistence;
}();
$82f70d645a4b3e84$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ var $82f70d645a4b3e84$export$23f2a1d2818174ef = $82f70d645a4b3e84$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$startSignInPhoneMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
function $82f70d645a4b3e84$var$finalizeSignInPhoneMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
function $82f70d645a4b3e84$var$finalizeSignInTotpMfa(auth, request) {
    return $82f70d645a4b3e84$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $82f70d645a4b3e84$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$_SOLVE_TIME_MS = 500;
var $82f70d645a4b3e84$var$_EXPIRATION_TIME_MS = 60000;
var $82f70d645a4b3e84$var$_WIDGET_ID_START = 1000000000000;
var $82f70d645a4b3e84$var$MockReCaptcha = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptcha(auth) {
        (0, $lfBxf._)(this, MockReCaptcha);
        this.auth = auth;
        this.counter = $82f70d645a4b3e84$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    (0, $9tzan._)(MockReCaptcha, [
        {
            key: "render",
            value: function render(container, parameters) {
                var id = this.counter;
                this._widgets.set(id, new $82f70d645a4b3e84$var$MockWidget(container, this.auth.name, parameters || {}));
                this.counter++;
                return id;
            }
        },
        {
            key: "reset",
            value: function reset(optWidgetId) {
                var _a;
                var id = optWidgetId || $82f70d645a4b3e84$var$_WIDGET_ID_START;
                (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
                this._widgets.delete(id);
            }
        },
        {
            key: "getResponse",
            value: function getResponse(optWidgetId) {
                var _a;
                var id = optWidgetId || $82f70d645a4b3e84$var$_WIDGET_ID_START;
                return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
            }
        },
        {
            key: "execute",
            value: function execute(optWidgetId) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, id;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        id = optWidgetId || $82f70d645a4b3e84$var$_WIDGET_ID_START;
                        (_a = _this._widgets.get(id)) === null || _a === void 0 || _a.execute();
                        return [
                            2,
                            ""
                        ];
                    });
                })();
            }
        }
    ]);
    return MockReCaptcha;
}();
var $82f70d645a4b3e84$var$MockWidget = /*#__PURE__*/ function() {
    "use strict";
    function MockWidget(containerOrId, appName, params) {
        var _this = this;
        (0, $lfBxf._)(this, MockWidget);
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = function() {
            _this.execute();
        };
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $82f70d645a4b3e84$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    (0, $9tzan._)(MockWidget, [
        {
            key: "getResponse",
            value: function getResponse() {
                this.checkIfDeleted();
                return this.responseToken;
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.checkIfDeleted();
                this.deleted = true;
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                }
                this.container.removeEventListener("click", this.clickHandler);
            }
        },
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                this.checkIfDeleted();
                if (this.timerId) return;
                this.timerId = window.setTimeout(function() {
                    _this.responseToken = $82f70d645a4b3e84$var$generateRandomAlphaNumericString(50);
                    var _this_params = _this.params, callback = _this_params.callback, expiredCallback = _this_params["expired-callback"];
                    if (callback) try {
                        callback(_this.responseToken);
                    } catch (e) {}
                    _this.timerId = window.setTimeout(function() {
                        _this.timerId = null;
                        _this.responseToken = null;
                        if (expiredCallback) try {
                            expiredCallback();
                        } catch (e) {}
                        if (_this.isVisible) _this.execute();
                    }, $82f70d645a4b3e84$var$_EXPIRATION_TIME_MS);
                }, $82f70d645a4b3e84$var$_SOLVE_TIME_MS);
            }
        },
        {
            key: "checkIfDeleted",
            value: function checkIfDeleted() {
                if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
            }
        }
    ]);
    return MockWidget;
}();
function $82f70d645a4b3e84$var$generateRandomAlphaNumericString(len) {
    var chars = [];
    var allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
var $82f70d645a4b3e84$var$_JSLOAD_CALLBACK = $82f70d645a4b3e84$var$_generateCallbackName("rcb");
var $82f70d645a4b3e84$var$NETWORK_TIMEOUT_DELAY = new $82f70d645a4b3e84$var$Delay(30000, 60000);
var $82f70d645a4b3e84$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ var $82f70d645a4b3e84$var$ReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function ReCaptchaLoaderImpl() {
        (0, $lfBxf._)(this, ReCaptchaLoaderImpl);
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $82f70d645a4b3e84$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    (0, $9tzan._)(ReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                var hl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var _this = this;
                $82f70d645a4b3e84$export$890c4ad488842ce7($82f70d645a4b3e84$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                if (this.shouldResolveImmediately(hl) && $82f70d645a4b3e84$var$isV2($82f70d645a4b3e84$var$_window().grecaptcha)) return Promise.resolve($82f70d645a4b3e84$var$_window().grecaptcha);
                return new Promise(function(resolve, reject) {
                    var networkTimeout = $82f70d645a4b3e84$var$_window().setTimeout(function() {
                        reject($82f70d645a4b3e84$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                    }, $82f70d645a4b3e84$var$NETWORK_TIMEOUT_DELAY.get());
                    $82f70d645a4b3e84$var$_window()[$82f70d645a4b3e84$var$_JSLOAD_CALLBACK] = function() {
                        $82f70d645a4b3e84$var$_window().clearTimeout(networkTimeout);
                        delete $82f70d645a4b3e84$var$_window()[$82f70d645a4b3e84$var$_JSLOAD_CALLBACK];
                        var recaptcha = $82f70d645a4b3e84$var$_window().grecaptcha;
                        if (!recaptcha || !$82f70d645a4b3e84$var$isV2(recaptcha)) {
                            reject($82f70d645a4b3e84$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                            return;
                        }
                        // Wrap the greptcha render function so that we know if the developer has
                        // called it separately
                        var render = recaptcha.render;
                        recaptcha.render = function(container, params) {
                            var widgetId = render(container, params);
                            _this.counter++;
                            return widgetId;
                        };
                        _this.hostLanguage = hl;
                        resolve(recaptcha);
                    };
                    var url = "".concat($82f70d645a4b3e84$var$RECAPTCHA_BASE, "?").concat((0, $4aa7d5a8ca32ac7d$export$ac4103b836844853)({
                        onload: $82f70d645a4b3e84$var$_JSLOAD_CALLBACK,
                        render: "explicit",
                        hl: hl
                    }));
                    $82f70d645a4b3e84$var$_loadJS(url).catch(function() {
                        clearTimeout(networkTimeout);
                        reject($82f70d645a4b3e84$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    });
                });
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {
                this.counter--;
            }
        },
        {
            key: "shouldResolveImmediately",
            value: function shouldResolveImmediately(hl) {
                var _a;
                // We can resolve immediately if:
                //   • grecaptcha is already defined AND (
                //     1. the requested language codes are the same OR
                //     2. there exists already a ReCaptcha on the page
                //     3. the library was already loaded by the app
                // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
                // that are already in the page
                return !!((_a = $82f70d645a4b3e84$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
            }
        }
    ]);
    return ReCaptchaLoaderImpl;
}();
function $82f70d645a4b3e84$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
var $82f70d645a4b3e84$var$MockReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptchaLoaderImpl() {
        (0, $lfBxf._)(this, MockReCaptchaLoaderImpl);
    }
    (0, $9tzan._)(MockReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            new $82f70d645a4b3e84$var$MockReCaptcha(auth)
                        ];
                    });
                })();
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {}
        }
    ]);
    return MockReCaptchaLoaderImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
var $82f70d645a4b3e84$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ var $82f70d645a4b3e84$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaVerifier(authExtern, containerOrId) {
        var parameters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Object.assign({}, $82f70d645a4b3e84$var$DEFAULT_PARAMS);
        (0, $lfBxf._)(this, RecaptchaVerifier);
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $82f70d645a4b3e84$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $82f70d645a4b3e84$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $82f70d645a4b3e84$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $82f70d645a4b3e84$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $82f70d645a4b3e84$var$MockReCaptchaLoaderImpl() : new $82f70d645a4b3e84$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    }
    (0, $9tzan._)(RecaptchaVerifier, [
        {
            key: "verify",
            value: /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ function verify() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var id, recaptcha, response;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertNotDestroyed();
                                return [
                                    4,
                                    _this.render()
                                ];
                            case 1:
                                id = _state.sent();
                                recaptcha = _this.getAssertedRecaptcha();
                                response = recaptcha.getResponse(id);
                                if (response) return [
                                    2,
                                    response
                                ];
                                return [
                                    2,
                                    new Promise(function(resolve) {
                                        var tokenChange = function(token) {
                                            if (!token) return; // Ignore token expirations.
                                            _this.tokenChangeListeners.delete(tokenChange);
                                            resolve(token);
                                        };
                                        _this.tokenChangeListeners.add(tokenChange);
                                        if (_this.isInvisible) recaptcha.execute(id);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ key: "render",
            value: function render() {
                var _this = this;
                try {
                    this.assertNotDestroyed();
                } catch (e) {
                    // This method returns a promise. Since it's not async (we want to return the
                    // _same_ promise if rendering is still occurring), the API surface should
                    // reject with the error rather than just throw
                    return Promise.reject(e);
                }
                if (this.renderPromise) return this.renderPromise;
                this.renderPromise = this.makeRenderPromise().catch(function(e) {
                    _this.renderPromise = null;
                    throw e;
                });
                return this.renderPromise;
            }
        },
        {
            /** @internal */ key: "_reset",
            value: function _reset() {
                this.assertNotDestroyed();
                if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
            }
        },
        {
            /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ key: "clear",
            value: function clear() {
                var _this = this;
                this.assertNotDestroyed();
                this.destroyed = true;
                this._recaptchaLoader.clearedOneInstance();
                if (!this.isInvisible) this.container.childNodes.forEach(function(node) {
                    _this.container.removeChild(node);
                });
            }
        },
        {
            key: "validateStartingState",
            value: function validateStartingState() {
                $82f70d645a4b3e84$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $82f70d645a4b3e84$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
            }
        },
        {
            key: "makeTokenCallback",
            value: function makeTokenCallback(existing) {
                var _this = this;
                return function(token) {
                    _this.tokenChangeListeners.forEach(function(listener) {
                        return listener(token);
                    });
                    if (typeof existing === "function") existing(token);
                    else if (typeof existing === "string") {
                        var globalFunc = $82f70d645a4b3e84$var$_window()[existing];
                        if (typeof globalFunc === "function") globalFunc(token);
                    }
                };
            }
        },
        {
            key: "assertNotDestroyed",
            value: function assertNotDestroyed() {
                $82f70d645a4b3e84$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        },
        {
            key: "makeRenderPromise",
            value: function makeRenderPromise() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var container, guaranteedEmpty;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.init()
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.widgetId) {
                                    container = _this.container;
                                    if (!_this.isInvisible) {
                                        guaranteedEmpty = document.createElement("div");
                                        container.appendChild(guaranteedEmpty);
                                        container = guaranteedEmpty;
                                    }
                                    _this.widgetId = _this.getAssertedRecaptcha().render(container, _this.parameters);
                                }
                                return [
                                    2,
                                    _this.widgetId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var siteKey;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $82f70d645a4b3e84$export$890c4ad488842ce7($82f70d645a4b3e84$var$_isHttpOrHttps() && !$82f70d645a4b3e84$var$_isWorker(), _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._recaptchaLoader.load(_this.auth, _this.auth.languageCode || undefined)
                                ];
                            case 2:
                                _this.recaptcha = _state.sent();
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$getRecaptchaParams(_this.auth)
                                ];
                            case 3:
                                siteKey = _state.sent();
                                $82f70d645a4b3e84$export$890c4ad488842ce7(siteKey, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                _this.parameters.sitekey = siteKey;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssertedRecaptcha",
            value: function getAssertedRecaptcha() {
                $82f70d645a4b3e84$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.recaptcha;
            }
        }
    ]);
    return RecaptchaVerifier;
}();
function $82f70d645a4b3e84$var$domReady() {
    var resolver = null;
    return new Promise(function(resolve) {
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = function() {
            return resolve();
        };
        window.addEventListener("load", resolver);
    }).catch(function(e) {
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$ConfirmationResultImpl = /*#__PURE__*/ function() {
    "use strict";
    function ConfirmationResultImpl(verificationId, onConfirmation) {
        (0, $lfBxf._)(this, ConfirmationResultImpl);
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    (0, $9tzan._)(ConfirmationResultImpl, [
        {
            key: "confirm",
            value: function confirm(verificationCode) {
                var authCredential = $82f70d645a4b3e84$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
                return this.onConfirmation(authCredential);
            }
        }
    ]);
    return ConfirmationResultImpl;
}();
function $82f70d645a4b3e84$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    return $82f70d645a4b3e84$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithPhoneNumber() {
    $82f70d645a4b3e84$var$_signInWithPhoneNumber = /**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, phoneNumber, appVerifier) {
        var authInternal, verificationId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $82f70d645a4b3e84$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $82f70d645a4b3e84$export$3c2fa207a37baaea(authInternal, cred);
                        })
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    return $82f70d645a4b3e84$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_linkWithPhoneNumber() {
    $82f70d645a4b3e84$var$_linkWithPhoneNumber = /**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ )
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(appVerifier))
                    ];
                case 2:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $82f70d645a4b3e84$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $82f70d645a4b3e84$export$ce26c07117d59d6a(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    return $82f70d645a4b3e84$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_reauthenticateWithPhoneNumber() {
    $82f70d645a4b3e84$var$_reauthenticateWithPhoneNumber = /**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $82f70d645a4b3e84$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $82f70d645a4b3e84$export$6559d589eb85fbb6(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_verifyPhoneNumber(auth, options, verifier) {
    return $82f70d645a4b3e84$var$__verifyPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__verifyPhoneNumber() {
    $82f70d645a4b3e84$var$__verifyPhoneNumber = /**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, options, verifier) {
        var _a, recaptchaToken, phoneInfoOptions, session, response, mfaEnrollmentId, response1, sessionInfo;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        verifier.verify()
                    ];
                case 1:
                    recaptchaToken = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        ,
                        10,
                        11
                    ]);
                    $82f70d645a4b3e84$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    $82f70d645a4b3e84$export$890c4ad488842ce7(verifier.type === $82f70d645a4b3e84$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    if (typeof options === "string") phoneInfoOptions = {
                        phoneNumber: options
                    };
                    else phoneInfoOptions = options;
                    if (!("session" in phoneInfoOptions)) return [
                        3,
                        7
                    ];
                    session = phoneInfoOptions.session;
                    if (!("phoneNumber" in phoneInfoOptions)) return [
                        3,
                        4
                    ];
                    $82f70d645a4b3e84$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        4,
                        $82f70d645a4b3e84$var$startEnrollPhoneMfa(auth, {
                            idToken: session.credential,
                            phoneEnrollmentInfo: {
                                phoneNumber: phoneInfoOptions.phoneNumber,
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.phoneSessionInfo.sessionInfo
                    ];
                case 4:
                    $82f70d645a4b3e84$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                    $82f70d645a4b3e84$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                    return [
                        4,
                        $82f70d645a4b3e84$var$startSignInPhoneMfa(auth, {
                            mfaPendingCredential: session.credential,
                            mfaEnrollmentId: mfaEnrollmentId,
                            phoneSignInInfo: {
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 5:
                    response1 = _state.sent();
                    return [
                        2,
                        response1.phoneResponseInfo.sessionInfo
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        $82f70d645a4b3e84$var$sendPhoneVerificationCode(auth, {
                            phoneNumber: phoneInfoOptions.phoneNumber,
                            recaptchaToken: recaptchaToken
                        })
                    ];
                case 8:
                    sessionInfo = _state.sent().sessionInfo;
                    return [
                        2,
                        sessionInfo
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    verifier._reset();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__verifyPhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$export$3b14a55fb2447963(user, credential) {
    return $82f70d645a4b3e84$var$_updatePhoneNumber.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_updatePhoneNumber() {
    $82f70d645a4b3e84$var$_updatePhoneNumber = /**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, credential) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_link$1((0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user), credential)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_updatePhoneNumber.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ var $82f70d645a4b3e84$export$56c0d5a1e737357d = /*#__PURE__*/ function() {
    "use strict";
    function PhoneAuthProvider(auth) {
        (0, $lfBxf._)(this, PhoneAuthProvider);
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
    }
    (0, $9tzan._)(PhoneAuthProvider, [
        {
            /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ key: "verifyPhoneNumber",
            value: function verifyPhoneNumber(phoneOptions, applicationVerifier) {
                return $82f70d645a4b3e84$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(applicationVerifier));
            }
        }
    ], [
        {
            key: "credential",
            value: /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ function credential(verificationId, verificationCode) {
                return $82f70d645a4b3e84$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                var credential = userCredential;
                return PhoneAuthProvider.credentialFromTaggedObject(credential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ function credentialFromError(error) {
                return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var phoneNumber = tokenResponse.phoneNumber, temporaryProof = tokenResponse.temporaryProof;
                if (phoneNumber && temporaryProof) return $82f70d645a4b3e84$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
                return null;
            }
        }
    ]);
    return PhoneAuthProvider;
}();
/** Always set to {@link ProviderId}.PHONE. */ $82f70d645a4b3e84$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $82f70d645a4b3e84$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $82f70d645a4b3e84$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $82f70d645a4b3e84$export$158acd800e1ef08b(resolverOverride);
    $82f70d645a4b3e84$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$IdpCredential = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $9Hju1._)(IdpCredential, AuthCredential);
    var _super = (0, $hCdf1._)(IdpCredential);
    function IdpCredential(params) {
        (0, $lfBxf._)(this, IdpCredential);
        var _this;
        _this = _super.call(this, "custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        _this.params = params;
        return _this;
    }
    (0, $9tzan._)(IdpCredential, [
        {
            key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $82f70d645a4b3e84$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $82f70d645a4b3e84$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
            }
        },
        {
            key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $82f70d645a4b3e84$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_buildIdpRequest",
            value: function _buildIdpRequest(idToken) {
                var request = {
                    requestUri: this.params.requestUri,
                    sessionId: this.params.sessionId,
                    postBody: this.params.postBody,
                    tenantId: this.params.tenantId,
                    pendingToken: this.params.pendingToken,
                    returnSecureToken: true,
                    returnIdpCredential: true
                };
                if (idToken) request.idToken = idToken;
                return request;
            }
        }
    ]);
    return IdpCredential;
}($82f70d645a4b3e84$export$61196ced6d74a310);
function $82f70d645a4b3e84$var$_signIn(params) {
    return $82f70d645a4b3e84$var$_signInWithCredential(params.auth, new $82f70d645a4b3e84$var$IdpCredential(params), params.bypassAuthState);
}
function $82f70d645a4b3e84$var$_reauth(params) {
    var auth = params.auth, user = params.user;
    $82f70d645a4b3e84$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $82f70d645a4b3e84$var$_reauthenticate(user, new $82f70d645a4b3e84$var$IdpCredential(params), params.bypassAuthState);
}
function $82f70d645a4b3e84$var$_link(params) {
    return $82f70d645a4b3e84$var$__link.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__link() {
    $82f70d645a4b3e84$var$__link = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(params) {
        var auth, user;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            auth = params.auth, user = params.user;
            $82f70d645a4b3e84$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            return [
                2,
                $82f70d645a4b3e84$var$_link$1(user, new $82f70d645a4b3e84$var$IdpCredential(params), params.bypassAuthState)
            ];
        });
    });
    return $82f70d645a4b3e84$var$__link.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ var $82f70d645a4b3e84$var$AbstractPopupRedirectOperation = /*#__PURE__*/ function() {
    "use strict";
    function AbstractPopupRedirectOperation(auth, filter, resolver, user) {
        var bypassAuthState = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $lfBxf._)(this, AbstractPopupRedirectOperation);
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    (0, $9tzan._)(AbstractPopupRedirectOperation, [
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                return new Promise(function() {
                    var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(resolve, reject) {
                        var e;
                        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.pendingPromise = {
                                        resolve: resolve,
                                        reject: reject
                                    };
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        _this.resolver._initialize(_this.auth)
                                    ];
                                case 2:
                                    _this.eventManager = _state.sent();
                                    return [
                                        4,
                                        _this.onExecution()
                                    ];
                                case 3:
                                    _state.sent();
                                    _this.eventManager.registerConsumer(_this);
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    e = _state.sent();
                                    _this.reject(e);
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(resolve, reject) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var urlResponse, sessionId, postBody, tenantId, error, type, params, _, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                urlResponse = event.urlResponse, sessionId = event.sessionId, postBody = event.postBody, tenantId = event.tenantId, error = event.error, type = event.type;
                                if (error) {
                                    _this.reject(error);
                                    return [
                                        2
                                    ];
                                }
                                params = {
                                    auth: _this.auth,
                                    requestUri: urlResponse,
                                    sessionId: sessionId,
                                    tenantId: tenantId || undefined,
                                    postBody: postBody || undefined,
                                    user: _this.user,
                                    bypassAuthState: _this.bypassAuthState
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _ = _this.resolve;
                                return [
                                    4,
                                    _this.getIdpTask(type)(params)
                                ];
                            case 2:
                                _.apply(_this, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.reject(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onError",
            value: function onError(error) {
                this.reject(error);
            }
        },
        {
            key: "getIdpTask",
            value: function getIdpTask(type) {
                switch(type){
                    case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
                    case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                        return $82f70d645a4b3e84$var$_signIn;
                    case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
                    case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                        return $82f70d645a4b3e84$var$_link;
                    case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
                    case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                        return $82f70d645a4b3e84$var$_reauth;
                    default:
                        $82f70d645a4b3e84$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }
            }
        },
        {
            key: "resolve",
            value: function resolve(cred) {
                $82f70d645a4b3e84$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.resolve(cred);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "reject",
            value: function reject(error) {
                $82f70d645a4b3e84$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.reject(error);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "unregisterAndCleanUp",
            value: function unregisterAndCleanUp() {
                if (this.eventManager) this.eventManager.unregisterConsumer(this);
                this.pendingPromise = null;
                this.cleanUp();
            }
        }
    ]);
    return AbstractPopupRedirectOperation;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $82f70d645a4b3e84$var$Delay(2000, 10000);
function $82f70d645a4b3e84$export$db3b6bfb95261072(auth, provider, resolver) {
    return $82f70d645a4b3e84$var$_signInWithPopup.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_signInWithPopup() {
    $82f70d645a4b3e84$var$_signInWithPopup = /**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, provider, resolver) {
        var authInternal, resolverInternal, action;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
            $82f70d645a4b3e84$var$_assertInstanceOf(auth, provider, $82f70d645a4b3e84$var$FederatedAuthProvider);
            resolverInternal = $82f70d645a4b3e84$var$_withDefaultResolver(authInternal, resolver);
            action = new $82f70d645a4b3e84$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $82f70d645a4b3e84$var$_signInWithPopup.apply(this, arguments);
}
function $82f70d645a4b3e84$export$f1e1789686576879(user, provider, resolver) {
    return $82f70d645a4b3e84$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_reauthenticateWithPopup() {
    $82f70d645a4b3e84$var$_reauthenticateWithPopup = /**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
            $82f70d645a4b3e84$var$_assertInstanceOf(userInternal.auth, provider, $82f70d645a4b3e84$var$FederatedAuthProvider);
            resolverInternal = $82f70d645a4b3e84$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $82f70d645a4b3e84$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $82f70d645a4b3e84$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $82f70d645a4b3e84$export$4368d992c4eafac0(user, provider, resolver) {
    return $82f70d645a4b3e84$var$_linkWithPopup.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_linkWithPopup() {
    $82f70d645a4b3e84$var$_linkWithPopup = /**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
            $82f70d645a4b3e84$var$_assertInstanceOf(userInternal.auth, provider, $82f70d645a4b3e84$var$FederatedAuthProvider);
            resolverInternal = $82f70d645a4b3e84$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $82f70d645a4b3e84$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $82f70d645a4b3e84$var$_linkWithPopup.apply(this, arguments);
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ var $82f70d645a4b3e84$var$PopupOperation = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $9Hju1._)(PopupOperation, AbstractPopupRedirectOperation);
    var _super = (0, $hCdf1._)(PopupOperation);
    function PopupOperation(auth, filter, provider, resolver, user) {
        (0, $lfBxf._)(this, PopupOperation);
        var _this;
        _this = _super.call(this, auth, filter, resolver, user);
        _this.provider = provider;
        _this.authWindow = null;
        _this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = (0, $aIKKI._)(_this);
        return _this;
    }
    (0, $9tzan._)(PopupOperation, [
        {
            key: "executeNotNull",
            value: function executeNotNull() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var result;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.execute()
                                ];
                            case 1:
                                result = _state.sent();
                                $82f70d645a4b3e84$export$890c4ad488842ce7(result, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var eventId;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $82f70d645a4b3e84$export$1fbe638ecf81657e(_this.filter.length === 1, "Popup operations only handle one event");
                                eventId = $82f70d645a4b3e84$export$faec65b429be379();
                                return [
                                    4,
                                    _this.resolver._openPopup(_this.auth, _this.provider, _this.filter[0], eventId)
                                ];
                            case 1:
                                _this.authWindow = _state.sent();
                                _this.authWindow.associatedEvent = eventId;
                                // Check for web storage support and origin validation _after_ the popup is
                                // loaded. These operations are slow (~1 second or so) Rather than
                                // waiting on them before opening the window, optimistically open the popup
                                // and check for storage support at the same time. If storage support is
                                // not available, this will cause the whole thing to reject properly. It
                                // will also close the popup, but since the promise has already rejected,
                                // the popup closed by user poll will reject into the void.
                                _this.resolver._originValidation(_this.auth).catch(function(e) {
                                    _this.reject(e);
                                });
                                _this.resolver._isIframeWebStorageSupported(_this.auth, function(isSupported) {
                                    if (!isSupported) _this.reject($82f70d645a4b3e84$export$9d398bebfec1c039(_this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
                                });
                                // Handle user closure. Notice this does *not* use await
                                _this.pollUserCancellation();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "eventId",
            get: function get() {
                var _a;
                return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.reject($82f70d645a4b3e84$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {
                if (this.authWindow) this.authWindow.close();
                if (this.pollId) window.clearTimeout(this.pollId);
                this.authWindow = null;
                this.pollId = null;
                PopupOperation.currentPopupAction = null;
            }
        },
        {
            key: "pollUserCancellation",
            value: function pollUserCancellation() {
                var _this = this;
                var poll = function() {
                    var _a, _b;
                    if ((_b = (_a = _this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                        // Make sure that there is sufficient time for whatever action to
                        // complete. The window could have closed but the sign in network
                        // call could still be in flight. This is specifically true for
                        // Firefox or if the opener is in an iframe, in which case the oauth
                        // helper closes the popup.
                        _this.pollId = window.setTimeout(function() {
                            _this.pollId = null;
                            _this.reject($82f70d645a4b3e84$export$9d398bebfec1c039(_this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                        }, 8000 /* _Timeout.AUTH_EVENT */ );
                        return;
                    }
                    _this.pollId = window.setTimeout(poll, $82f70d645a4b3e84$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
                };
                poll();
            }
        }
    ]);
    return PopupOperation;
}($82f70d645a4b3e84$var$AbstractPopupRedirectOperation);
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$82f70d645a4b3e84$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
var $82f70d645a4b3e84$var$redirectOutcomeMap = new Map();
var $82f70d645a4b3e84$var$RedirectAction = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $9Hju1._)(RedirectAction, AbstractPopupRedirectOperation);
    var _super = (0, $hCdf1._)(RedirectAction);
    function RedirectAction(auth, resolver) {
        var bypassAuthState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $lfBxf._)(this, RedirectAction);
        var _this;
        _this = _super.call(this, auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        _this.eventId = null;
        return _this;
    }
    (0, $9tzan._)(RedirectAction, [
        {
            key: "execute",
            value: /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ function execute() {
                var _this = this;
                var _this1 = this, _superprop_get_execute = function() {
                    return (0, $2234ea2a8ddda7cd$export$afb3516d9d608401)((0, $g0UjU._)(RedirectAction.prototype), "execute", _this);
                };
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var readyOutcome, hasPendingRedirect, result, _tmp, e;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                readyOutcome = $82f70d645a4b3e84$var$redirectOutcomeMap.get(_this1.auth._key());
                                if (!!readyOutcome) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_getAndClearPendingRedirectStatus(_this1.resolver, _this1.auth)
                                ];
                            case 2:
                                hasPendingRedirect = _state.sent();
                                if (!hasPendingRedirect) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _superprop_get_execute().call(_this1)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = null;
                                _state.label = 5;
                            case 5:
                                result = _tmp;
                                readyOutcome = function() {
                                    return Promise.resolve(result);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                readyOutcome = function() {
                                    return Promise.reject(e);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                $82f70d645a4b3e84$var$redirectOutcomeMap.set(_this1.auth._key(), readyOutcome);
                                _state.label = 8;
                            case 8:
                                // If we're not bypassing auth state, the ready outcome should be set to
                                // null.
                                if (!_this1.bypassAuthState) $82f70d645a4b3e84$var$redirectOutcomeMap.set(_this1.auth._key(), function() {
                                    return Promise.resolve(null);
                                });
                                return [
                                    2,
                                    readyOutcome()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                var _this1 = this, _superprop_get_onAuthEvent = function() {
                    return (0, $2234ea2a8ddda7cd$export$afb3516d9d608401)((0, $g0UjU._)(RedirectAction.prototype), "onAuthEvent", _this);
                };
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var user;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return [
                                    2,
                                    _superprop_get_onAuthEvent().call(_this1, event)
                                ];
                                else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
                                    // This is a sentinel value indicating there's no pending redirect
                                    _this1.resolve(null);
                                    return [
                                        2
                                    ];
                                }
                                if (!event.eventId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.auth._redirectUserForId(event.eventId)
                                ];
                            case 1:
                                user = _state.sent();
                                if (user) {
                                    _this1.user = user;
                                    return [
                                        2,
                                        _superprop_get_onAuthEvent().call(_this1, event)
                                    ];
                                } else _this1.resolve(null);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {}
        }
    ]);
    return RedirectAction;
}($82f70d645a4b3e84$var$AbstractPopupRedirectOperation);
function $82f70d645a4b3e84$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    return $82f70d645a4b3e84$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__getAndClearPendingRedirectStatus() {
    $82f70d645a4b3e84$var$__getAndClearPendingRedirectStatus = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(resolver, auth) {
        var key, persistence, hasPendingRedirect;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $82f70d645a4b3e84$var$pendingRedirectKey(auth);
                    persistence = $82f70d645a4b3e84$var$resolverPersistence(resolver);
                    return [
                        4,
                        persistence._isAvailable()
                    ];
                case 1:
                    if (!_state.sent()) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        persistence._get(key)
                    ];
                case 2:
                    hasPendingRedirect = _state.sent() === "true";
                    return [
                        4,
                        persistence._remove(key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        hasPendingRedirect
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_setPendingRedirectStatus(resolver, auth) {
    return $82f70d645a4b3e84$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__setPendingRedirectStatus() {
    $82f70d645a4b3e84$var$__setPendingRedirectStatus = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(resolver, auth) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                $82f70d645a4b3e84$var$resolverPersistence(resolver)._set($82f70d645a4b3e84$var$pendingRedirectKey(auth), "true")
            ];
        });
    });
    return $82f70d645a4b3e84$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $82f70d645a4b3e84$export$b9a6b53f9be3734() {
    $82f70d645a4b3e84$var$redirectOutcomeMap.clear();
}
function $82f70d645a4b3e84$export$a33b77bbdbb8366c(auth, result) {
    $82f70d645a4b3e84$var$redirectOutcomeMap.set(auth._key(), result);
}
function $82f70d645a4b3e84$var$resolverPersistence(resolver) {
    return $82f70d645a4b3e84$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $82f70d645a4b3e84$var$pendingRedirectKey(auth) {
    return $82f70d645a4b3e84$export$cf2f7c5792f80b46($82f70d645a4b3e84$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $82f70d645a4b3e84$export$2d1720544b23b823(auth, provider, resolver) {
    return $82f70d645a4b3e84$var$_signInWithRedirect(auth, provider, resolver);
}
function $82f70d645a4b3e84$var$_signInWithRedirect(auth, provider, resolver) {
    return $82f70d645a4b3e84$var$__signInWithRedirect.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__signInWithRedirect() {
    $82f70d645a4b3e84$var$__signInWithRedirect = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, provider, resolver) {
        var authInternal, resolverInternal;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    $82f70d645a4b3e84$var$_assertInstanceOf(auth, provider, $82f70d645a4b3e84$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $82f70d645a4b3e84$var$_withDefaultResolver(authInternal, resolver);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_setPendingRedirectStatus(resolverInternal, authInternal)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ )
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__signInWithRedirect.apply(this, arguments);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $82f70d645a4b3e84$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $82f70d645a4b3e84$var$_reauthenticateWithRedirect(user, provider, resolver);
}
function $82f70d645a4b3e84$var$_reauthenticateWithRedirect(user, provider, resolver) {
    return $82f70d645a4b3e84$var$__reauthenticateWithRedirect.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__reauthenticateWithRedirect() {
    $82f70d645a4b3e84$var$__reauthenticateWithRedirect = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    $82f70d645a4b3e84$var$_assertInstanceOf(userInternal.auth, provider, $82f70d645a4b3e84$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    // Allow the resolver to error before persisting the redirect user
                    resolverInternal = $82f70d645a4b3e84$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$prepareUserForRedirect(userInternal)
                    ];
                case 3:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__reauthenticateWithRedirect.apply(this, arguments);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $82f70d645a4b3e84$export$39b482c5e57630a8(user, provider, resolver) {
    return $82f70d645a4b3e84$var$_linkWithRedirect(user, provider, resolver);
}
function $82f70d645a4b3e84$var$_linkWithRedirect(user, provider, resolver) {
    return $82f70d645a4b3e84$var$__linkWithRedirect.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__linkWithRedirect() {
    $82f70d645a4b3e84$var$__linkWithRedirect = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(user);
                    $82f70d645a4b3e84$var$_assertInstanceOf(userInternal.auth, provider, $82f70d645a4b3e84$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    // Allow the resolver to error before persisting the redirect user
                    resolverInternal = $82f70d645a4b3e84$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $82f70d645a4b3e84$var$_assertLinkedStatus(false, userInternal, provider.providerId)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $82f70d645a4b3e84$var$prepareUserForRedirect(userInternal)
                    ];
                case 4:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__linkWithRedirect.apply(this, arguments);
}
function $82f70d645a4b3e84$export$35e795649ee09318(auth, resolver) {
    return $82f70d645a4b3e84$var$_getRedirectResult.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_getRedirectResult() {
    $82f70d645a4b3e84$var$_getRedirectResult = /**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, resolver) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth)._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $82f70d645a4b3e84$export$53a70dd1ebbae346(auth, resolver, false)
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_getRedirectResult.apply(this, arguments);
}
function $82f70d645a4b3e84$export$53a70dd1ebbae346(auth, resolverExtern) {
    return $82f70d645a4b3e84$var$__getRedirectResult.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__getRedirectResult() {
    $82f70d645a4b3e84$var$__getRedirectResult = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, resolverExtern) {
        var bypassAuthState, authInternal, resolver, action, result;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    authInternal = $82f70d645a4b3e84$export$a05254e7c3aeba6e(auth);
                    resolver = $82f70d645a4b3e84$var$_withDefaultResolver(authInternal, resolverExtern);
                    action = new $82f70d645a4b3e84$var$RedirectAction(authInternal, resolver, bypassAuthState);
                    return [
                        4,
                        action.execute()
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result && !bypassAuthState)) return [
                        3,
                        4
                    ];
                    delete result.user._redirectEventId;
                    return [
                        4,
                        authInternal._persistUserIfCurrent(result.user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        authInternal._setRedirectUser(null, resolverExtern)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__getRedirectResult.apply(this, arguments);
}
function $82f70d645a4b3e84$var$prepareUserForRedirect(user) {
    return $82f70d645a4b3e84$var$_prepareUserForRedirect.apply(this, arguments);
}
function $82f70d645a4b3e84$var$_prepareUserForRedirect() {
    $82f70d645a4b3e84$var$_prepareUserForRedirect = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user) {
        var eventId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventId = $82f70d645a4b3e84$export$faec65b429be379("".concat(user.uid, ":::"));
                    user._redirectEventId = eventId;
                    return [
                        4,
                        user.auth._setRedirectUser(user)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        user.auth._persistUserIfCurrent(user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        eventId
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$_prepareUserForRedirect.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
var $82f70d645a4b3e84$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
var $82f70d645a4b3e84$export$24baa2b76016ce0e = /*#__PURE__*/ function() {
    "use strict";
    function AuthEventManager(auth) {
        (0, $lfBxf._)(this, AuthEventManager);
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    (0, $9tzan._)(AuthEventManager, [
        {
            key: "registerConsumer",
            value: function registerConsumer(authEventConsumer) {
                this.consumers.add(authEventConsumer);
                if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
                    this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
                    this.saveEventToCache(this.queuedRedirectEvent);
                    this.queuedRedirectEvent = null;
                }
            }
        },
        {
            key: "unregisterConsumer",
            value: function unregisterConsumer(authEventConsumer) {
                this.consumers.delete(authEventConsumer);
            }
        },
        {
            key: "onEvent",
            value: function onEvent(event) {
                var _this = this;
                // Check if the event has already been handled
                if (this.hasEventBeenHandled(event)) return false;
                var handled = false;
                this.consumers.forEach(function(consumer) {
                    if (_this.isEventForConsumer(event, consumer)) {
                        handled = true;
                        _this.sendToConsumer(event, consumer);
                        _this.saveEventToCache(event);
                    }
                });
                if (this.hasHandledPotentialRedirect || !$82f70d645a4b3e84$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
                // bail now
                return handled;
                this.hasHandledPotentialRedirect = true;
                // If the redirect wasn't handled, hang on to it
                if (!handled) {
                    this.queuedRedirectEvent = event;
                    handled = true;
                }
                return handled;
            }
        },
        {
            key: "sendToConsumer",
            value: function sendToConsumer(event, consumer) {
                var _a;
                if (event.error && !$82f70d645a4b3e84$var$isNullRedirectEvent(event)) {
                    var code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
                    consumer.onError($82f70d645a4b3e84$export$9d398bebfec1c039(this.auth, code));
                } else consumer.onAuthEvent(event);
            }
        },
        {
            key: "isEventForConsumer",
            value: function isEventForConsumer(event, consumer) {
                var eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
                return consumer.filter.includes(event.type) && eventIdMatches;
            }
        },
        {
            key: "hasEventBeenHandled",
            value: function hasEventBeenHandled(event) {
                if (Date.now() - this.lastProcessedEventTime >= $82f70d645a4b3e84$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
                return this.cachedEventUids.has($82f70d645a4b3e84$var$eventUid(event));
            }
        },
        {
            key: "saveEventToCache",
            value: function saveEventToCache(event) {
                this.cachedEventUids.add($82f70d645a4b3e84$var$eventUid(event));
                this.lastProcessedEventTime = Date.now();
            }
        }
    ]);
    return AuthEventManager;
}();
function $82f70d645a4b3e84$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter(function(v) {
        return v;
    }).join("-");
}
function $82f70d645a4b3e84$var$isNullRedirectEvent(param) {
    var type = param.type, error = param.error;
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === "auth/no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ;
}
function $82f70d645a4b3e84$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $82f70d645a4b3e84$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
function $82f70d645a4b3e84$export$3d12bd131bb975d1(auth) {
    return $82f70d645a4b3e84$var$__getProjectConfig.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__getProjectConfig() {
    $82f70d645a4b3e84$var$__getProjectConfig = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $82f70d645a4b3e84$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request)
            ];
        });
    });
    return $82f70d645a4b3e84$var$__getProjectConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
var $82f70d645a4b3e84$var$HTTP_REGEX = /^https?/;
function $82f70d645a4b3e84$var$_validateOrigin(auth) {
    return $82f70d645a4b3e84$var$__validateOrigin.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__validateOrigin() {
    $82f70d645a4b3e84$var$__validateOrigin = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var authorizedDomains, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, domain;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Skip origin validation if we are in an emulated environment
                    if (auth.config.emulator) return [
                        2
                    ];
                    return [
                        4,
                        $82f70d645a4b3e84$export$3d12bd131bb975d1(auth)
                    ];
                case 1:
                    authorizedDomains = _state.sent().authorizedDomains;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = authorizedDomains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            domain = _step.value;
                            try {
                                if ($82f70d645a4b3e84$var$matchDomain(domain)) return [
                                    2
                                ];
                            } catch (_a) {
                            // Do nothing if there's a URL error; just continue searching
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // In the old SDK, this error also provides helpful messages.
                    $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
                    return [
                        2
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__validateOrigin.apply(this, arguments);
}
function $82f70d645a4b3e84$var$matchDomain(expected) {
    var currentUrl = $82f70d645a4b3e84$var$_getCurrentUrl();
    var _ref = new URL(currentUrl), protocol = _ref.protocol, hostname = _ref.hostname;
    if (expected.startsWith("chrome-extension://")) {
        var ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$82f70d645a4b3e84$var$HTTP_REGEX.test(protocol)) return false;
    if ($82f70d645a4b3e84$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    var escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    var re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$NETWORK_TIMEOUT = new $82f70d645a4b3e84$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $82f70d645a4b3e84$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    var beacon = $82f70d645a4b3e84$var$_window().___jsl;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) try {
        // Get gapi hint.
        for(var _iterator = Object.keys(beacon.H)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var hint = _step.value;
            // Requested modules.
            beacon.H[hint].r = beacon.H[hint].r || [];
            // Loaded modules.
            beacon.H[hint].L = beacon.H[hint].L || [];
            // Set requested modules to a copy of the loaded modules.
            beacon.H[hint].r = (0, $1UA6e._)(beacon.H[hint].L);
            // Clear pending callbacks.
            if (beacon.CP) for(var i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
            beacon.CP[i] = null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $82f70d645a4b3e84$var$loadGapi(auth) {
    return new Promise(function(resolve, reject) {
        var loadGapiIframe = // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $82f70d645a4b3e84$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: function() {
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: function() {
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $82f70d645a4b3e84$var$resetUnloadedGapiModules();
                    reject($82f70d645a4b3e84$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $82f70d645a4b3e84$var$NETWORK_TIMEOUT.get()
            });
        };
        var _a, _b, _c;
        if ((_b = (_a = $82f70d645a4b3e84$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $82f70d645a4b3e84$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            var cbName = $82f70d645a4b3e84$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $82f70d645a4b3e84$var$_window()[cbName] = function() {
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($82f70d645a4b3e84$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $82f70d645a4b3e84$var$_loadJS("https://apis.google.com/js/api.js?onload=".concat(cbName)).catch(function(e) {
                return reject(e);
            });
        }
    }).catch(function(error) {
        // Reset cached promise to allow for retrial.
        $82f70d645a4b3e84$var$cachedGApiLoader = null;
        throw error;
    });
}
var $82f70d645a4b3e84$var$cachedGApiLoader = null;
function $82f70d645a4b3e84$var$_loadGapi(auth) {
    $82f70d645a4b3e84$var$cachedGApiLoader = $82f70d645a4b3e84$var$cachedGApiLoader || $82f70d645a4b3e84$var$loadGapi(auth);
    return $82f70d645a4b3e84$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$PING_TIMEOUT = new $82f70d645a4b3e84$var$Delay(5000, 15000);
var $82f70d645a4b3e84$var$IFRAME_PATH = "__/auth/iframe";
var $82f70d645a4b3e84$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
var $82f70d645a4b3e84$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
var $82f70d645a4b3e84$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $82f70d645a4b3e84$var$getIframeUrl(auth) {
    var config = auth.config;
    $82f70d645a4b3e84$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    var url = config.emulator ? $82f70d645a4b3e84$var$_emulatorUrl(config, $82f70d645a4b3e84$var$EMULATED_IFRAME_PATH) : "https://".concat(auth.config.authDomain, "/").concat($82f70d645a4b3e84$var$IFRAME_PATH);
    var params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $43ffc92b683abcf2$export$31499a9cd224b78c)
    };
    var eid = $82f70d645a4b3e84$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    var frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return "".concat(url, "?").concat((0, $4aa7d5a8ca32ac7d$export$ac4103b836844853)(params).slice(1));
}
function $82f70d645a4b3e84$var$_openIframe(auth) {
    return $82f70d645a4b3e84$var$__openIframe.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__openIframe() {
    $82f70d645a4b3e84$var$__openIframe = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth) {
        var context, gapi1;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $82f70d645a4b3e84$var$_loadGapi(auth)
                    ];
                case 1:
                    context = _state.sent();
                    gapi1 = $82f70d645a4b3e84$var$_window().gapi;
                    $82f70d645a4b3e84$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        2,
                        context.open({
                            where: document.body,
                            url: $82f70d645a4b3e84$var$getIframeUrl(auth),
                            messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
                            attributes: $82f70d645a4b3e84$var$IFRAME_ATTRIBUTES,
                            dontclear: true
                        }, function(iframe) {
                            return new Promise(function() {
                                var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(resolve, reject) {
                                    var networkError, networkErrorTimer;
                                    // Clear timer and resolve pending iframe ready promise.
                                    function clearTimerAndResolve() {
                                        $82f70d645a4b3e84$var$_window().clearTimeout(networkErrorTimer);
                                        resolve(iframe);
                                    }
                                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    iframe.restyle({
                                                        // Prevent iframe from closing on mouse out.
                                                        setHideOnLeave: false
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                networkError = $82f70d645a4b3e84$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
                                                // Confirm iframe is correctly loaded.
                                                // To fallback on failure, set a timeout.
                                                networkErrorTimer = $82f70d645a4b3e84$var$_window().setTimeout(function() {
                                                    reject(networkError);
                                                }, $82f70d645a4b3e84$var$PING_TIMEOUT.get());
                                                // This returns an IThenable. However the reject part does not call
                                                // when the iframe is not loaded.
                                                iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, function() {
                                                    reject(networkError);
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        })
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__openIframe.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
var $82f70d645a4b3e84$var$DEFAULT_WIDTH = 500;
var $82f70d645a4b3e84$var$DEFAULT_HEIGHT = 600;
var $82f70d645a4b3e84$var$TARGET_BLANK = "_blank";
var $82f70d645a4b3e84$var$FIREFOX_EMPTY_URL = "http://localhost";
var $82f70d645a4b3e84$export$c03999cb2f36933f = /*#__PURE__*/ function() {
    "use strict";
    function AuthPopup(window1) {
        (0, $lfBxf._)(this, AuthPopup);
        this.window = window1;
        this.associatedEvent = null;
    }
    (0, $9tzan._)(AuthPopup, [
        {
            key: "close",
            value: function close() {
                if (this.window) try {
                    this.window.close();
                } catch (e) {}
            }
        }
    ]);
    return AuthPopup;
}();
function $82f70d645a4b3e84$var$_open(auth, url, name) {
    var width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $82f70d645a4b3e84$var$DEFAULT_WIDTH, height = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $82f70d645a4b3e84$var$DEFAULT_HEIGHT;
    var top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    var left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    var target = "";
    var options = Object.assign(Object.assign({}, $82f70d645a4b3e84$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    var ua = (0, $4aa7d5a8ca32ac7d$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $82f70d645a4b3e84$var$_isChromeIOS(ua) ? $82f70d645a4b3e84$var$TARGET_BLANK : name;
    if ($82f70d645a4b3e84$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $82f70d645a4b3e84$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    var optionsString = Object.entries(options).reduce(function(accum, param) {
        var _param = (0, $3tDj3._)(param, 2), key = _param[0], value = _param[1];
        return "".concat(accum).concat(key, "=").concat(value, ",");
    }, "");
    if ($82f70d645a4b3e84$var$_isIOSStandalone(ua) && target !== "_self") {
        $82f70d645a4b3e84$var$openAsNewWindowIOS(url || "", target);
        return new $82f70d645a4b3e84$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    var newWin = window.open(url || "", target, optionsString);
    $82f70d645a4b3e84$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $82f70d645a4b3e84$export$c03999cb2f36933f(newWin);
}
function $82f70d645a4b3e84$var$openAsNewWindowIOS(url, target) {
    var el = document.createElement("a");
    el.href = url;
    el.target = target;
    var click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ var $82f70d645a4b3e84$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ var $82f70d645a4b3e84$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ var $82f70d645a4b3e84$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
function $82f70d645a4b3e84$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    return $82f70d645a4b3e84$var$__getRedirectUrl.apply(this, arguments);
}
function $82f70d645a4b3e84$var$__getRedirectUrl() {
    $82f70d645a4b3e84$var$__getRedirectUrl = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(auth, provider, authType, redirectUrl, eventId, additionalParams) {
        var params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, scopes, paramsDict, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, appCheckToken, appCheckTokenFragment;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $82f70d645a4b3e84$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
                    $82f70d645a4b3e84$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
                    params = {
                        apiKey: auth.config.apiKey,
                        appName: auth.name,
                        authType: authType,
                        redirectUrl: redirectUrl,
                        v: (0, $43ffc92b683abcf2$export$31499a9cd224b78c),
                        eventId: eventId
                    };
                    if (provider instanceof $82f70d645a4b3e84$var$FederatedAuthProvider) {
                        provider.setDefaultLanguage(auth.languageCode);
                        params.providerId = provider.providerId || "";
                        if (!(0, $4aa7d5a8ca32ac7d$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // TODO set additionalParams from the provider as well?
                            for(_iterator = Object.entries(additionalParams || {})[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $3tDj3._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                params[key] = value;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (provider instanceof $82f70d645a4b3e84$var$BaseOAuthProvider) {
                        scopes = provider.getScopes().filter(function(scope) {
                            return scope !== "";
                        });
                        if (scopes.length > 0) params.scopes = scopes.join(",");
                    }
                    if (auth.tenantId) params.tid = auth.tenantId;
                    // TODO: maybe set eid as endipointId
                    // TODO: maybe set fw as Frameworks.join(",")
                    paramsDict = params;
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = Object.keys(paramsDict)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            key1 = _step1.value;
                            if (paramsDict[key1] === undefined) delete paramsDict[key1];
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        auth._getAppCheckToken()
                    ];
                case 1:
                    appCheckToken = _state.sent();
                    appCheckTokenFragment = appCheckToken ? "#".concat($82f70d645a4b3e84$var$FIREBASE_APP_CHECK_FRAGMENT_ID, "=").concat(encodeURIComponent(appCheckToken)) : "";
                    // Start at index 1 to skip the leading '&' in the query string
                    return [
                        2,
                        "".concat($82f70d645a4b3e84$var$getHandlerBase(auth), "?").concat((0, $4aa7d5a8ca32ac7d$export$ac4103b836844853)(paramsDict).slice(1)).concat(appCheckTokenFragment)
                    ];
            }
        });
    });
    return $82f70d645a4b3e84$var$__getRedirectUrl.apply(this, arguments);
}
function $82f70d645a4b3e84$var$getHandlerBase(param) {
    var config = param.config;
    if (!config.emulator) return "https://".concat(config.authDomain, "/").concat($82f70d645a4b3e84$var$WIDGET_PATH);
    return $82f70d645a4b3e84$var$_emulatorUrl(config, $82f70d645a4b3e84$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ var $82f70d645a4b3e84$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
var $82f70d645a4b3e84$var$BrowserPopupRedirectResolver = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPopupRedirectResolver() {
        (0, $lfBxf._)(this, BrowserPopupRedirectResolver);
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $82f70d645a4b3e84$export$407448d2b89b1813;
        this._completeRedirectFn = $82f70d645a4b3e84$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $82f70d645a4b3e84$export$a33b77bbdbb8366c;
    }
    (0, $9tzan._)(BrowserPopupRedirectResolver, [
        {
            key: "_openPopup",
            value: // Wrapping in async even though we don't await anywhere in order
            // to make sure errors are raised as promise rejections
            function _openPopup(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, url;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $82f70d645a4b3e84$export$1fbe638ecf81657e((_a = _this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
                                return [
                                    4,
                                    $82f70d645a4b3e84$export$28f7fcd39efa255(auth, provider, authType, $82f70d645a4b3e84$var$_getCurrentUrl(), eventId)
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    2,
                                    $82f70d645a4b3e84$var$_open(auth, url, $82f70d645a4b3e84$export$faec65b429be379())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_openRedirect",
            value: function _openRedirect(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var url;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._originValidation(auth)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    $82f70d645a4b3e84$export$28f7fcd39efa255(auth, provider, authType, $82f70d645a4b3e84$var$_getCurrentUrl(), eventId)
                                ];
                            case 2:
                                url = _state.sent();
                                $82f70d645a4b3e84$var$_setWindowLocation(url);
                                return [
                                    2,
                                    new Promise(function() {})
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_initialize",
            value: function _initialize(auth) {
                var _this = this;
                var key = auth._key();
                if (this.eventManagers[key]) {
                    var _this_eventManagers_key = this.eventManagers[key], manager = _this_eventManagers_key.manager, promise = _this_eventManagers_key.promise;
                    if (manager) return Promise.resolve(manager);
                    else {
                        $82f70d645a4b3e84$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                        return promise;
                    }
                }
                var promise1 = this.initAndGetManager(auth);
                this.eventManagers[key] = {
                    promise: promise1
                };
                // If the promise is rejected, the key should be removed so that the
                // operation can be retried later.
                promise1.catch(function() {
                    delete _this.eventManagers[key];
                });
                return promise1;
            }
        },
        {
            key: "initAndGetManager",
            value: function initAndGetManager(auth) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var iframe, manager;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$_openIframe(auth)
                                ];
                            case 1:
                                iframe = _state.sent();
                                manager = new $82f70d645a4b3e84$export$24baa2b76016ce0e(auth);
                                iframe.register("authEvent", function(iframeEvent) {
                                    $82f70d645a4b3e84$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
                                    // TODO: Consider splitting redirect and popup events earlier on
                                    var handled = manager.onEvent(iframeEvent.authEvent);
                                    return {
                                        status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
                                    };
                                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                                _this.eventManagers[auth._key()] = {
                                    manager: manager
                                };
                                _this.iframes[auth._key()] = iframe;
                                return [
                                    2,
                                    manager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isIframeWebStorageSupported",
            value: function _isIframeWebStorageSupported(auth, cb) {
                var iframe = this.iframes[auth._key()];
                iframe.send($82f70d645a4b3e84$var$WEB_STORAGE_SUPPORT_KEY, {
                    type: $82f70d645a4b3e84$var$WEB_STORAGE_SUPPORT_KEY
                }, function(result) {
                    var _a;
                    var isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$82f70d645a4b3e84$var$WEB_STORAGE_SUPPORT_KEY];
                    if (isSupported !== undefined) cb(!!isSupported);
                    $82f70d645a4b3e84$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
            }
        },
        {
            key: "_originValidation",
            value: function _originValidation(auth) {
                var key = auth._key();
                if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $82f70d645a4b3e84$var$_validateOrigin(auth);
                return this.originValidationPromises[key];
            }
        },
        {
            key: "_shouldInitProactively",
            get: function get() {
                // Mobile browsers and Safari need to optimistically initialize
                return $82f70d645a4b3e84$var$_isMobileBrowser() || $82f70d645a4b3e84$var$_isSafari() || $82f70d645a4b3e84$export$d66dc83d8cfc8dd();
            }
        }
    ]);
    return BrowserPopupRedirectResolver;
}();
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ var $82f70d645a4b3e84$export$342063e11d6c3cad = $82f70d645a4b3e84$var$BrowserPopupRedirectResolver;
var $82f70d645a4b3e84$var$MultiFactorAssertionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorAssertionImpl(factorId) {
        (0, $lfBxf._)(this, MultiFactorAssertionImpl);
        this.factorId = factorId;
    }
    (0, $9tzan._)(MultiFactorAssertionImpl, [
        {
            key: "_process",
            value: function _process(auth, session, displayName) {
                switch(session.type){
                    case "enroll" /* MultiFactorSessionType.ENROLL */ :
                        return this._finalizeEnroll(auth, session.credential, displayName);
                    case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                        return this._finalizeSignIn(auth, session.credential);
                    default:
                        return $82f70d645a4b3e84$var$debugFail("unexpected MultiFactorSessionType");
                }
            }
        }
    ]);
    return MultiFactorAssertionImpl;
}();
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ var $82f70d645a4b3e84$var$PhoneMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $9Hju1._)(PhoneMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $hCdf1._)(PhoneMultiFactorAssertionImpl);
    function PhoneMultiFactorAssertionImpl(credential) {
        (0, $lfBxf._)(this, PhoneMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ );
        _this.credential = credential;
        return _this;
    }
    (0, $9tzan._)(PhoneMultiFactorAssertionImpl, [
        {
            /** @internal */ key: "_finalizeEnroll",
            value: function _finalizeEnroll(auth, idToken, displayName) {
                return $82f70d645a4b3e84$var$finalizeEnrollPhoneMfa(auth, {
                    idToken: idToken,
                    displayName: displayName,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        },
        {
            /** @internal */ key: "_finalizeSignIn",
            value: function _finalizeSignIn(auth, mfaPendingCredential) {
                return $82f70d645a4b3e84$var$finalizeSignInPhoneMfa(auth, {
                    mfaPendingCredential: mfaPendingCredential,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        }
    ], [
        {
            key: "_fromCredential",
            value: /** @internal */ function _fromCredential(credential) {
                return new PhoneMultiFactorAssertionImpl(credential);
            }
        }
    ]);
    return PhoneMultiFactorAssertionImpl;
}($82f70d645a4b3e84$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ var $82f70d645a4b3e84$export$953cecd6e717a553 = /*#__PURE__*/ function() {
    "use strict";
    function PhoneMultiFactorGenerator() {
        (0, $lfBxf._)(this, PhoneMultiFactorGenerator);
    }
    (0, $9tzan._)(PhoneMultiFactorGenerator, null, [
        {
            key: "assertion",
            value: /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ function assertion(credential) {
                return $82f70d645a4b3e84$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
            }
        }
    ]);
    return PhoneMultiFactorGenerator;
}();
/**
 * The identifier of the phone second factor: `phone`.
 */ $82f70d645a4b3e84$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ var $82f70d645a4b3e84$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function TotpMultiFactorGenerator() {
        (0, $lfBxf._)(this, TotpMultiFactorGenerator);
    }
    (0, $9tzan._)(TotpMultiFactorGenerator, null, [
        {
            key: "assertionForEnrollment",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ function assertionForEnrollment(secret, oneTimePassword) {
                return $82f70d645a4b3e84$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
            }
        },
        {
            key: "assertionForSignIn",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ function assertionForSignIn(enrollmentId, oneTimePassword) {
                return $82f70d645a4b3e84$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
            }
        },
        {
            key: "generateSecret",
            value: /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ function generateSecret(session) {
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var _a, mfaSession, response;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaSession = session;
                                $82f70d645a4b3e84$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $82f70d645a4b3e84$var$startEnrollTotpMfa(mfaSession.user.auth, {
                                        idToken: mfaSession.credential,
                                        totpEnrollmentInfo: {}
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    $82f70d645a4b3e84$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TotpMultiFactorGenerator;
}();
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $82f70d645a4b3e84$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
var $82f70d645a4b3e84$var$TotpMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $9Hju1._)(TotpMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $hCdf1._)(TotpMultiFactorAssertionImpl);
    function TotpMultiFactorAssertionImpl(otp, enrollmentId, secret) {
        (0, $lfBxf._)(this, TotpMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "totp" /* FactorId.TOTP */ );
        _this.otp = otp;
        _this.enrollmentId = enrollmentId;
        _this.secret = secret;
        return _this;
    }
    (0, $9tzan._)(TotpMultiFactorAssertionImpl, [
        {
            key: "_finalizeEnroll",
            value: /** @internal */ function _finalizeEnroll(auth, idToken, displayName) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        $82f70d645a4b3e84$export$890c4ad488842ce7(typeof _this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        return [
                            2,
                            $82f70d645a4b3e84$var$finalizeEnrollTotpMfa(auth, {
                                idToken: idToken,
                                displayName: displayName,
                                totpVerificationInfo: _this.secret._makeTotpVerificationInfo(_this.otp)
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "_finalizeSignIn",
            value: /** @internal */ function _finalizeSignIn(auth, mfaPendingCredential) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var totpVerificationInfo;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        $82f70d645a4b3e84$export$890c4ad488842ce7(_this.enrollmentId !== undefined && _this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        totpVerificationInfo = {
                            verificationCode: _this.otp
                        };
                        return [
                            2,
                            $82f70d645a4b3e84$var$finalizeSignInTotpMfa(auth, {
                                mfaPendingCredential: mfaPendingCredential,
                                mfaEnrollmentId: _this.enrollmentId,
                                totpVerificationInfo: totpVerificationInfo
                            })
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromSecret",
            value: /** @internal */ function _fromSecret(secret, otp) {
                return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
            }
        },
        {
            key: "_fromEnrollmentId",
            value: /** @internal */ function _fromEnrollmentId(enrollmentId, otp) {
                return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
            }
        }
    ]);
    return TotpMultiFactorAssertionImpl;
}($82f70d645a4b3e84$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ var $82f70d645a4b3e84$export$7ccc53e8f1e7dfc5 = /*#__PURE__*/ function() {
    "use strict";
    function TotpSecret(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth) {
        (0, $lfBxf._)(this, TotpSecret);
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    (0, $9tzan._)(TotpSecret, [
        {
            /** @internal */ key: "_makeTotpVerificationInfo",
            value: function _makeTotpVerificationInfo(otp) {
                return {
                    sessionInfo: this.sessionInfo,
                    verificationCode: otp
                };
            }
        },
        {
            /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ key: "generateQrCodeUrl",
            value: function generateQrCodeUrl(accountName, issuer) {
                var _a;
                var useDefaults = false;
                if ($82f70d645a4b3e84$var$_isEmptyString(accountName) || $82f70d645a4b3e84$var$_isEmptyString(issuer)) useDefaults = true;
                if (useDefaults) {
                    if ($82f70d645a4b3e84$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
                    if ($82f70d645a4b3e84$var$_isEmptyString(issuer)) issuer = this.auth.name;
                }
                return "otpauth://totp/".concat(issuer, ":").concat(accountName, "?secret=").concat(this.secretKey, "&issuer=").concat(issuer, "&algorithm=").concat(this.hashingAlgorithm, "&digits=").concat(this.codeLength);
            }
        }
    ], [
        {
            key: "_fromStartTotpMfaEnrollmentResponse",
            value: /** @internal */ function _fromStartTotpMfaEnrollmentResponse(response, auth) {
                return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
            }
        }
    ]);
    return TotpSecret;
}();
/** @internal */ function $82f70d645a4b3e84$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $82f70d645a4b3e84$var$name = "@firebase/auth";
var $82f70d645a4b3e84$var$version = "1.4.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$AuthInterop = /*#__PURE__*/ function() {
    "use strict";
    function AuthInterop(auth) {
        (0, $lfBxf._)(this, AuthInterop);
        this.auth = auth;
        this.internalListeners = new Map();
    }
    (0, $9tzan._)(AuthInterop, [
        {
            key: "getUid",
            value: function getUid() {
                var _a;
                this.assertAuthConfigured();
                return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
            }
        },
        {
            key: "getToken",
            value: function getToken(forceRefresh) {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var accessToken;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertAuthConfigured();
                                return [
                                    4,
                                    _this.auth._initializationPromise
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.auth.currentUser) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    _this.auth.currentUser.getIdToken(forceRefresh)
                                ];
                            case 2:
                                accessToken = _state.sent();
                                return [
                                    2,
                                    {
                                        accessToken: accessToken
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAuthTokenListener",
            value: function addAuthTokenListener(listener) {
                this.assertAuthConfigured();
                if (this.internalListeners.has(listener)) return;
                var unsubscribe = this.auth.onIdTokenChanged(function(user) {
                    listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
                });
                this.internalListeners.set(listener, unsubscribe);
                this.updateProactiveRefresh();
            }
        },
        {
            key: "removeAuthTokenListener",
            value: function removeAuthTokenListener(listener) {
                this.assertAuthConfigured();
                var unsubscribe = this.internalListeners.get(listener);
                if (!unsubscribe) return;
                this.internalListeners.delete(listener);
                unsubscribe();
                this.updateProactiveRefresh();
            }
        },
        {
            key: "assertAuthConfigured",
            value: function assertAuthConfigured() {
                $82f70d645a4b3e84$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
            }
        },
        {
            key: "updateProactiveRefresh",
            value: function updateProactiveRefresh() {
                if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
                else this.auth._stopProactiveRefresh();
            }
        }
    ]);
    return AuthInterop;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $82f70d645a4b3e84$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $82f70d645a4b3e84$var$registerAuth(clientPlatform) {
    (0, $43ffc92b683abcf2$export$c930050e7bb63965)(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , function(container, param) {
        var deps = param.options;
        var app = container.getProvider("app").getImmediate();
        var heartbeatServiceProvider = container.getProvider("heartbeat");
        var appCheckServiceProvider = container.getProvider("app-check-internal");
        var _app_options = app.options, apiKey = _app_options.apiKey, authDomain = _app_options.authDomain;
        $82f70d645a4b3e84$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        var config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $82f70d645a4b3e84$export$9f4f30ee63539e24(clientPlatform)
        };
        var authInstance = new $82f70d645a4b3e84$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $82f70d645a4b3e84$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback(function(container, _instanceIdentifier, _instance) {
        var authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $43ffc92b683abcf2$export$c930050e7bb63965)(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , function(container) {
        var auth = $82f70d645a4b3e84$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return function(auth) {
            return new $82f70d645a4b3e84$var$AuthInterop(auth);
        }(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $43ffc92b683abcf2$export$d29d5299a7137abc)($82f70d645a4b3e84$var$name, $82f70d645a4b3e84$var$version, $82f70d645a4b3e84$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $43ffc92b683abcf2$export$d29d5299a7137abc)($82f70d645a4b3e84$var$name, $82f70d645a4b3e84$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $82f70d645a4b3e84$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
var $82f70d645a4b3e84$var$authIdTokenMaxAge = (0, $4aa7d5a8ca32ac7d$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $82f70d645a4b3e84$var$DEFAULT_ID_TOKEN_MAX_AGE;
var $82f70d645a4b3e84$var$lastPostedIdToken = null;
var $82f70d645a4b3e84$var$mintCookieFactory = function(url) {
    return function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(user) {
            var idTokenResult, _tmp, idTokenAge, idToken;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = user;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            user.getIdTokenResult()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        idTokenResult = _tmp;
                        idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
                        if (idTokenAge && idTokenAge > $82f70d645a4b3e84$var$authIdTokenMaxAge) return [
                            2
                        ];
                        // Specifically trip null => undefined when logged out, to delete any existing cookie
                        idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
                        if ($82f70d645a4b3e84$var$lastPostedIdToken === idToken) return [
                            2
                        ];
                        $82f70d645a4b3e84$var$lastPostedIdToken = idToken;
                        return [
                            4,
                            fetch(url, {
                                method: idToken ? "POST" : "DELETE",
                                headers: idToken ? {
                                    "Authorization": "Bearer ".concat(idToken)
                                } : {}
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(user) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $82f70d645a4b3e84$export$ae1af26003f05816() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $43ffc92b683abcf2$export$f9962582c9e66d99)();
    var provider = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    var auth = $82f70d645a4b3e84$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $82f70d645a4b3e84$export$342063e11d6c3cad,
        persistence: [
            $82f70d645a4b3e84$export$23f2a1d2818174ef,
            $82f70d645a4b3e84$export$8b22cf2602fb60ce,
            $82f70d645a4b3e84$export$407448d2b89b1813
        ]
    });
    var authTokenSyncUrl = (0, $4aa7d5a8ca32ac7d$export$5539a1a3afe87d6)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        var mintCookie = $82f70d645a4b3e84$var$mintCookieFactory(authTokenSyncUrl);
        $82f70d645a4b3e84$export$d141bba7fdc215a3(auth, mintCookie, function() {
            return mintCookie(auth.currentUser);
        });
        $82f70d645a4b3e84$export$efccba1c4a2ef57b(auth, function(user) {
            return mintCookie(user);
        });
    }
    var authEmulatorHost = (0, $4aa7d5a8ca32ac7d$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $82f70d645a4b3e84$export$3466f893ebf79586(auth, "http://".concat(authEmulatorHost));
    return auth;
}
$82f70d645a4b3e84$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );













var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $azcHm = parcelRequire("azcHm");

var $3tDj3 = parcelRequire("3tDj3");

var $1UA6e = parcelRequire("1UA6e");







var $azcHm = parcelRequire("azcHm");

var $1UA6e = parcelRequire("1UA6e");








var $1UA6e = parcelRequire("1UA6e");


var $1UA6e = parcelRequire("1UA6e");
var $0304974c58968778$export$23f2a1d2818174ef = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var $0304974c58968778$var$idbProxyableTypes;
var $0304974c58968778$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $0304974c58968778$var$getIdbProxyableTypes() {
    return $0304974c58968778$var$idbProxyableTypes || ($0304974c58968778$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $0304974c58968778$var$getCursorAdvanceMethods() {
    return $0304974c58968778$var$cursorAdvanceMethods || ($0304974c58968778$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var $0304974c58968778$var$cursorRequestMap = new WeakMap();
var $0304974c58968778$var$transactionDoneMap = new WeakMap();
var $0304974c58968778$var$transactionStoreNamesMap = new WeakMap();
var $0304974c58968778$var$transformCache = new WeakMap();
var $0304974c58968778$export$407448d2b89b1813 = new WeakMap();
function $0304974c58968778$var$promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        var success = function() {
            resolve($0304974c58968778$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $0304974c58968778$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $0304974c58968778$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $0304974c58968778$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($0304974c58968778$var$transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $0304974c58968778$var$transactionDoneMap.set(tx, done);
}
var $0304974c58968778$var$idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $0304974c58968778$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $0304974c58968778$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $0304974c58968778$export$efccba1c4a2ef57b(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $0304974c58968778$export$43caf9889c228507(callback) {
    $0304974c58968778$var$idbProxyTraps = callback($0304974c58968778$var$idbProxyTraps);
}
function $0304974c58968778$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            $0304974c58968778$export$3b14a55fb2447963(this),
            storeNames
        ].concat((0, $1UA6e._)(args)));
        $0304974c58968778$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $0304974c58968778$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($0304974c58968778$var$getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($0304974c58968778$export$3b14a55fb2447963(this), args);
        return $0304974c58968778$export$efccba1c4a2ef57b($0304974c58968778$var$cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $0304974c58968778$export$efccba1c4a2ef57b(func.apply($0304974c58968778$export$3b14a55fb2447963(this), args));
    };
}
function $0304974c58968778$var$transformCachableValue(value) {
    if (typeof value === "function") return $0304974c58968778$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $0304974c58968778$var$cacheDonePromiseForTransaction(value);
    if ($0304974c58968778$export$23f2a1d2818174ef(value, $0304974c58968778$var$getIdbProxyableTypes())) return new Proxy(value, $0304974c58968778$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $0304974c58968778$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $0304974c58968778$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($0304974c58968778$var$transformCache.has(value)) return $0304974c58968778$var$transformCache.get(value);
    var newValue = $0304974c58968778$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $0304974c58968778$var$transformCache.set(value, newValue);
        $0304974c58968778$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
var $0304974c58968778$export$3b14a55fb2447963 = function(value) {
    return $0304974c58968778$export$407448d2b89b1813.get(value);
};


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $3496a9a31daa3fe3$export$ca0ed41b1a2af7e(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, $0304974c58968778$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", function(event) {
        upgrade((0, $0304974c58968778$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $0304974c58968778$export$efccba1c4a2ef57b)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", function() {
        return blocked();
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener("close", function() {
            return terminated();
        });
        if (blocking) db.addEventListener("versionchange", function() {
            return blocking();
        });
    }).catch(function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $3496a9a31daa3fe3$export$9d6df0ac66a98bb2(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", function() {
        return blocked();
    });
    return (0, $0304974c58968778$export$efccba1c4a2ef57b)(request).then(function() {
        return undefined;
    });
}
var $3496a9a31daa3fe3$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
var $3496a9a31daa3fe3$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
var $3496a9a31daa3fe3$var$cachedMethods = new Map();
function $3496a9a31daa3fe3$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($3496a9a31daa3fe3$var$cachedMethods.get(prop)) return $3496a9a31daa3fe3$var$cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, "");
    var useIndex = prop !== targetFuncName;
    var isWrite = $3496a9a31daa3fe3$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $3496a9a31daa3fe3$var$readMethods.includes(targetFuncName))) return;
    var method = function() {
        var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(storeName) {
            var _len, args, _key, _target, tx, _$target;
            var _arguments = arguments;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
                        tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            Promise.all([
                                (_target = _$target)[targetFuncName].apply(_target, (0, $1UA6e._)(args)),
                                isWrite && tx.done
                            ])
                        ];
                    case 1:
                        // Must reject if op rejects.
                        // If it's a write operation, must reject if tx.done rejects.
                        // Must reject with op rejection first.
                        // Must resolve with op value.
                        // Must handle both promises (no unhandled rejections)
                        return [
                            2,
                            _state.sent()[0]
                        ];
                }
            });
        });
        return function method(storeName) {
            return _ref.apply(this, arguments);
        };
    }();
    $3496a9a31daa3fe3$var$cachedMethods.set(prop, method);
    return method;
}
(0, $0304974c58968778$export$43caf9889c228507)(function(oldTraps) {
    return (0, $80cf69b4a84d1e85$export$4fa2f4023c9cbda5)((0, $29c5440143c029da$export$581ff339ea0ba762)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return $3496a9a31daa3fe3$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!$3496a9a31daa3fe3$var$getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});


var $6b4b2b7620755cb2$var$name = "@firebase/installations";
var $6b4b2b7620755cb2$var$version = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b4b2b7620755cb2$var$PENDING_TIMEOUT_MS = 10000;
var $6b4b2b7620755cb2$var$PACKAGE_VERSION = "w:".concat($6b4b2b7620755cb2$var$version);
var $6b4b2b7620755cb2$var$INTERNAL_AUTH_VERSION = "FIS_v2";
var $6b4b2b7620755cb2$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
var $6b4b2b7620755cb2$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
var $6b4b2b7620755cb2$var$SERVICE = "installations";
var $6b4b2b7620755cb2$var$SERVICE_NAME = "Installations";
var $6b4b2b7620755cb2$var$_obj;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b4b2b7620755cb2$var$ERROR_DESCRIPTION_MAP = ($6b4b2b7620755cb2$var$_obj = {}, (0, $azcHm._)($6b4b2b7620755cb2$var$_obj, "missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , 'Missing App configuration value: "{$valueName}"'), (0, $azcHm._)($6b4b2b7620755cb2$var$_obj, "not-registered" /* ErrorCode.NOT_REGISTERED */ , "Firebase Installation is not registered."), (0, $azcHm._)($6b4b2b7620755cb2$var$_obj, "installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ , "Firebase Installation not found."), (0, $azcHm._)($6b4b2b7620755cb2$var$_obj, "request-failed" /* ErrorCode.REQUEST_FAILED */ , '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"'), (0, $azcHm._)($6b4b2b7620755cb2$var$_obj, "app-offline" /* ErrorCode.APP_OFFLINE */ , "Could not process request. Application offline."), (0, $azcHm._)($6b4b2b7620755cb2$var$_obj, "delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ , "Can't delete installation while there is a pending registration request."), $6b4b2b7620755cb2$var$_obj);
var $6b4b2b7620755cb2$var$ERROR_FACTORY = new (0, $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40)($6b4b2b7620755cb2$var$SERVICE, $6b4b2b7620755cb2$var$SERVICE_NAME, $6b4b2b7620755cb2$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $6b4b2b7620755cb2$var$isServerError(error) {
    return error instanceof (0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6b4b2b7620755cb2$var$getInstallationsEndpoint(param) {
    var projectId = param.projectId;
    return "".concat($6b4b2b7620755cb2$var$INSTALLATIONS_API_URL, "/projects/").concat(projectId, "/installations");
}
function $6b4b2b7620755cb2$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $6b4b2b7620755cb2$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function $6b4b2b7620755cb2$var$getErrorFromResponse(requestName, response) {
    return $6b4b2b7620755cb2$var$_getErrorFromResponse.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_getErrorFromResponse() {
    $6b4b2b7620755cb2$var$_getErrorFromResponse = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(requestName, response) {
        var responseJson, errorData;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        response.json()
                    ];
                case 1:
                    responseJson = _state.sent();
                    errorData = responseJson.error;
                    return [
                        2,
                        $6b4b2b7620755cb2$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_getErrorFromResponse.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$getHeaders(param) {
    var apiKey = param.apiKey;
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $6b4b2b7620755cb2$var$getHeadersWithAuth(appConfig, param) {
    var refreshToken = param.refreshToken;
    var headers = $6b4b2b7620755cb2$var$getHeaders(appConfig);
    headers.append("Authorization", $6b4b2b7620755cb2$var$getAuthorizationHeader(refreshToken));
    return headers;
}
function $6b4b2b7620755cb2$var$retryIfServerError(fn) {
    return $6b4b2b7620755cb2$var$_retryIfServerError.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_retryIfServerError() {
    $6b4b2b7620755cb2$var$_retryIfServerError = /**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(fn) {
        var result;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fn()
                    ];
                case 1:
                    result = _state.sent();
                    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
                    return [
                        2,
                        fn()
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_retryIfServerError.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $6b4b2b7620755cb2$var$getAuthorizationHeader(refreshToken) {
    return "".concat($6b4b2b7620755cb2$var$INTERNAL_AUTH_VERSION, " ").concat(refreshToken);
}
function $6b4b2b7620755cb2$var$createInstallationRequest(_, _1) {
    return $6b4b2b7620755cb2$var$_createInstallationRequest.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_createInstallationRequest() {
    $6b4b2b7620755cb2$var$_createInstallationRequest = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(param, param1) {
        var appConfig, heartbeatServiceProvider, fid, endpoint, headers, heartbeatService, heartbeatsHeader, body, request, response, responseValue, registeredInstallationEntry;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appConfig = param.appConfig, heartbeatServiceProvider = param.heartbeatServiceProvider, fid = param1.fid;
                    endpoint = $6b4b2b7620755cb2$var$getInstallationsEndpoint(appConfig);
                    headers = $6b4b2b7620755cb2$var$getHeaders(appConfig);
                    // If heartbeat service exists, add the heartbeat string to the header.
                    heartbeatService = heartbeatServiceProvider.getImmediate({
                        optional: true
                    });
                    if (!heartbeatService) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        heartbeatService.getHeartbeatsHeader()
                    ];
                case 1:
                    heartbeatsHeader = _state.sent();
                    if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
                    _state.label = 2;
                case 2:
                    body = {
                        fid: fid,
                        authVersion: $6b4b2b7620755cb2$var$INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: $6b4b2b7620755cb2$var$PACKAGE_VERSION
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4,
                        $6b4b2b7620755cb2$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 3:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 4:
                    responseValue = _state.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
                        refreshToken: responseValue.refreshToken,
                        authToken: $6b4b2b7620755cb2$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [
                        2,
                        registeredInstallationEntry
                    ];
                case 5:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getErrorFromResponse("Create Installation", response)
                    ];
                case 6:
                    throw _state.sent();
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_createInstallationRequest.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $6b4b2b7620755cb2$var$sleep(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6b4b2b7620755cb2$var$bufferToBase64UrlSafe(array) {
    var _String;
    var b64 = btoa((_String = String).fromCharCode.apply(_String, (0, $1UA6e._)(array)));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b4b2b7620755cb2$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var $6b4b2b7620755cb2$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $6b4b2b7620755cb2$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        var fid = $6b4b2b7620755cb2$var$encode(fidByteArray);
        return $6b4b2b7620755cb2$var$VALID_FID_PATTERN.test(fid) ? fid : $6b4b2b7620755cb2$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $6b4b2b7620755cb2$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $6b4b2b7620755cb2$var$encode(fidByteArray) {
    var b64String = $6b4b2b7620755cb2$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $6b4b2b7620755cb2$var$getKey(appConfig) {
    return "".concat(appConfig.appName, "!").concat(appConfig.appId);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b4b2b7620755cb2$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $6b4b2b7620755cb2$var$fidChanged(appConfig, fid) {
    var key = $6b4b2b7620755cb2$var$getKey(appConfig);
    $6b4b2b7620755cb2$var$callFidChangeCallbacks(key, fid);
    $6b4b2b7620755cb2$var$broadcastFidChange(key, fid);
}
function $6b4b2b7620755cb2$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $6b4b2b7620755cb2$var$getBroadcastChannel();
    var key = $6b4b2b7620755cb2$var$getKey(appConfig);
    var callbackSet = $6b4b2b7620755cb2$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $6b4b2b7620755cb2$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $6b4b2b7620755cb2$var$removeCallback(appConfig, callback) {
    var key = $6b4b2b7620755cb2$var$getKey(appConfig);
    var callbackSet = $6b4b2b7620755cb2$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $6b4b2b7620755cb2$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $6b4b2b7620755cb2$var$closeBroadcastChannel();
}
function $6b4b2b7620755cb2$var$callFidChangeCallbacks(key, fid) {
    var callbacks = $6b4b2b7620755cb2$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var callback = _step.value;
            callback(fid);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $6b4b2b7620755cb2$var$broadcastFidChange(key, fid) {
    var channel = $6b4b2b7620755cb2$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $6b4b2b7620755cb2$var$closeBroadcastChannel();
}
var $6b4b2b7620755cb2$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $6b4b2b7620755cb2$var$getBroadcastChannel() {
    if (!$6b4b2b7620755cb2$var$broadcastChannel && "BroadcastChannel" in self) {
        $6b4b2b7620755cb2$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $6b4b2b7620755cb2$var$broadcastChannel.onmessage = function(e) {
            $6b4b2b7620755cb2$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $6b4b2b7620755cb2$var$broadcastChannel;
}
function $6b4b2b7620755cb2$var$closeBroadcastChannel() {
    if ($6b4b2b7620755cb2$var$fidChangeCallbacks.size === 0 && $6b4b2b7620755cb2$var$broadcastChannel) {
        $6b4b2b7620755cb2$var$broadcastChannel.close();
        $6b4b2b7620755cb2$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b4b2b7620755cb2$var$DATABASE_NAME = "firebase-installations-database";
var $6b4b2b7620755cb2$var$DATABASE_VERSION = 1;
var $6b4b2b7620755cb2$var$OBJECT_STORE_NAME = "firebase-installations-store";
var $6b4b2b7620755cb2$var$dbPromise = null;
function $6b4b2b7620755cb2$var$getDbPromise() {
    if (!$6b4b2b7620755cb2$var$dbPromise) $6b4b2b7620755cb2$var$dbPromise = (0, $3496a9a31daa3fe3$export$ca0ed41b1a2af7e)($6b4b2b7620755cb2$var$DATABASE_NAME, $6b4b2b7620755cb2$var$DATABASE_VERSION, {
        upgrade: function(db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($6b4b2b7620755cb2$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $6b4b2b7620755cb2$var$dbPromise;
}
function $6b4b2b7620755cb2$var$set(appConfig, value) {
    return $6b4b2b7620755cb2$var$_set.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_set() {
    $6b4b2b7620755cb2$var$_set = /** Assigns or overwrites the record for the given key with the given value. */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(appConfig, value) {
        var key, db, tx, objectStore, oldValue;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $6b4b2b7620755cb2$var$getKey(appConfig);
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($6b4b2b7620755cb2$var$OBJECT_STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($6b4b2b7620755cb2$var$OBJECT_STORE_NAME);
                    return [
                        4,
                        objectStore.get(key)
                    ];
                case 2:
                    oldValue = _state.sent();
                    return [
                        4,
                        objectStore.put(value, key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 4:
                    _state.sent();
                    if (!oldValue || oldValue.fid !== value.fid) $6b4b2b7620755cb2$var$fidChanged(appConfig, value.fid);
                    return [
                        2,
                        value
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_set.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$remove(appConfig) {
    return $6b4b2b7620755cb2$var$_remove.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_remove() {
    $6b4b2b7620755cb2$var$_remove = /** Removes record(s) from the objectStore that match the given key. */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(appConfig) {
        var key, db, tx;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $6b4b2b7620755cb2$var$getKey(appConfig);
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($6b4b2b7620755cb2$var$OBJECT_STORE_NAME, "readwrite");
                    return [
                        4,
                        tx.objectStore($6b4b2b7620755cb2$var$OBJECT_STORE_NAME).delete(key)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_remove.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$update(appConfig, updateFn) {
    return $6b4b2b7620755cb2$var$_update.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_update() {
    $6b4b2b7620755cb2$var$_update = /**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(appConfig, updateFn) {
        var key, db, tx, store, oldValue, newValue;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $6b4b2b7620755cb2$var$getKey(appConfig);
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($6b4b2b7620755cb2$var$OBJECT_STORE_NAME, "readwrite");
                    store = tx.objectStore($6b4b2b7620755cb2$var$OBJECT_STORE_NAME);
                    return [
                        4,
                        store.get(key)
                    ];
                case 2:
                    oldValue = _state.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        store.delete(key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        store.put(newValue, key)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        tx.done
                    ];
                case 7:
                    _state.sent();
                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $6b4b2b7620755cb2$var$fidChanged(appConfig, newValue.fid);
                    return [
                        2,
                        newValue
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_update.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$getInstallationEntry(installations) {
    return $6b4b2b7620755cb2$var$_getInstallationEntry.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_getInstallationEntry() {
    $6b4b2b7620755cb2$var$_getInstallationEntry = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var registrationPromise, installationEntry, _tmp;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$update(installations.appConfig, function(oldEntry) {
                            var installationEntry = $6b4b2b7620755cb2$var$updateOrCreateInstallationEntry(oldEntry);
                            var entryWithPromise = $6b4b2b7620755cb2$var$triggerRegistrationIfNecessary(installations, installationEntry);
                            registrationPromise = entryWithPromise.registrationPromise;
                            return entryWithPromise.installationEntry;
                        })
                    ];
                case 1:
                    installationEntry = _state.sent();
                    if (!(installationEntry.fid === $6b4b2b7620755cb2$var$INVALID_FID)) return [
                        3,
                        3
                    ];
                    _tmp = {};
                    return [
                        4,
                        registrationPromise
                    ];
                case 2:
                    // FID generation failed. Waiting for the FID from the server.
                    return [
                        2,
                        (_tmp.installationEntry = _state.sent(), _tmp)
                    ];
                case 3:
                    return [
                        2,
                        {
                            installationEntry: installationEntry,
                            registrationPromise: registrationPromise
                        }
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_getInstallationEntry.apply(this, arguments);
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $6b4b2b7620755cb2$var$updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: $6b4b2b7620755cb2$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $6b4b2b7620755cb2$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $6b4b2b7620755cb2$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject($6b4b2b7620755cb2$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        var registrationPromise = $6b4b2b7620755cb2$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $6b4b2b7620755cb2$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
function $6b4b2b7620755cb2$var$registerInstallation(installations, installationEntry) {
    return $6b4b2b7620755cb2$var$_registerInstallation.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_registerInstallation() {
    $6b4b2b7620755cb2$var$_registerInstallation = /** This will be executed only once for each new Firebase Installation. */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations, installationEntry) {
        var registeredInstallationEntry, e;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        7
                    ]);
                    return [
                        4,
                        $6b4b2b7620755cb2$var$createInstallationRequest(installations, installationEntry)
                    ];
                case 1:
                    registeredInstallationEntry = _state.sent();
                    return [
                        2,
                        $6b4b2b7620755cb2$var$set(installations.appConfig, registeredInstallationEntry)
                    ];
                case 2:
                    e = _state.sent();
                    if (!($6b4b2b7620755cb2$var$isServerError(e) && e.customData.serverCode === 409)) return [
                        3,
                        4
                    ];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [
                        4,
                        $6b4b2b7620755cb2$var$remove(installations.appConfig)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    // Registration failed. Set FID as not registered.
                    return [
                        4,
                        $6b4b2b7620755cb2$var$set(installations.appConfig, {
                            fid: installationEntry.fid,
                            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
                        })
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    throw e;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_registerInstallation.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$waitUntilFidRegistration(installations) {
    return $6b4b2b7620755cb2$var$_waitUntilFidRegistration.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_waitUntilFidRegistration() {
    $6b4b2b7620755cb2$var$_waitUntilFidRegistration = /** Call if FID registration is pending in another request. */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var entry, _ref, installationEntry, registrationPromise;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$updateInstallationRequest(installations.appConfig)
                    ];
                case 1:
                    entry = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ )) return [
                        3,
                        5
                    ];
                    // createInstallation request still in progress.
                    return [
                        4,
                        $6b4b2b7620755cb2$var$sleep(100)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $6b4b2b7620755cb2$var$updateInstallationRequest(installations.appConfig)
                    ];
                case 4:
                    entry = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 5:
                    if (!(entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ )) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getInstallationEntry(installations)
                    ];
                case 6:
                    _ref = _state.sent(), installationEntry = _ref.installationEntry, registrationPromise = _ref.registrationPromise;
                    if (registrationPromise) return [
                        2,
                        registrationPromise
                    ];
                    else // if there is no registrationPromise, entry is registered.
                    return [
                        2,
                        installationEntry
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        2,
                        entry
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_waitUntilFidRegistration.apply(this, arguments);
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $6b4b2b7620755cb2$var$updateInstallationRequest(appConfig) {
    return $6b4b2b7620755cb2$var$update(appConfig, function(oldEntry) {
        if (!oldEntry) throw $6b4b2b7620755cb2$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $6b4b2b7620755cb2$var$clearTimedOutRequest(oldEntry);
    });
}
function $6b4b2b7620755cb2$var$clearTimedOutRequest(entry) {
    if ($6b4b2b7620755cb2$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $6b4b2b7620755cb2$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $6b4b2b7620755cb2$var$PENDING_TIMEOUT_MS < Date.now();
}
function $6b4b2b7620755cb2$var$generateAuthTokenRequest(_, installationEntry) {
    return $6b4b2b7620755cb2$var$_generateAuthTokenRequest.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_generateAuthTokenRequest() {
    $6b4b2b7620755cb2$var$_generateAuthTokenRequest = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(param, installationEntry) {
        var appConfig, heartbeatServiceProvider, endpoint, headers, heartbeatService, heartbeatsHeader, body, request, response, responseValue, completedAuthToken;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appConfig = param.appConfig, heartbeatServiceProvider = param.heartbeatServiceProvider;
                    endpoint = $6b4b2b7620755cb2$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = $6b4b2b7620755cb2$var$getHeadersWithAuth(appConfig, installationEntry);
                    // If heartbeat service exists, add the heartbeat string to the header.
                    heartbeatService = heartbeatServiceProvider.getImmediate({
                        optional: true
                    });
                    if (!heartbeatService) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        heartbeatService.getHeartbeatsHeader()
                    ];
                case 1:
                    heartbeatsHeader = _state.sent();
                    if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
                    _state.label = 2;
                case 2:
                    body = {
                        installation: {
                            sdkVersion: $6b4b2b7620755cb2$var$PACKAGE_VERSION,
                            appId: appConfig.appId
                        }
                    };
                    request = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [
                        4,
                        $6b4b2b7620755cb2$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 3:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 4:
                    responseValue = _state.sent();
                    completedAuthToken = $6b4b2b7620755cb2$var$extractAuthTokenInfoFromResponse(responseValue);
                    return [
                        2,
                        completedAuthToken
                    ];
                case 5:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getErrorFromResponse("Generate Auth Token", response)
                    ];
                case 6:
                    throw _state.sent();
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_generateAuthTokenRequest.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$getGenerateAuthTokenEndpoint(appConfig, param) {
    var fid = param.fid;
    return "".concat($6b4b2b7620755cb2$var$getInstallationsEndpoint(appConfig), "/").concat(fid, "/authTokens:generate");
}
function $6b4b2b7620755cb2$var$refreshAuthToken(installations) {
    return $6b4b2b7620755cb2$var$_refreshAuthToken.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_refreshAuthToken() {
    $6b4b2b7620755cb2$var$_refreshAuthToken = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var forceRefresh, tokenPromise, entry, authToken, _tmp;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    return [
                        4,
                        $6b4b2b7620755cb2$var$update(installations.appConfig, function(oldEntry) {
                            if (!$6b4b2b7620755cb2$var$isEntryRegistered(oldEntry)) throw $6b4b2b7620755cb2$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
                            var oldAuthToken = oldEntry.authToken;
                            if (!forceRefresh && $6b4b2b7620755cb2$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
                            return oldEntry;
                            else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
                                // There already is a token request in progress.
                                tokenPromise = $6b4b2b7620755cb2$var$waitUntilAuthTokenRequest(installations, forceRefresh);
                                return oldEntry;
                            } else {
                                // No token or token expired.
                                if (!navigator.onLine) throw $6b4b2b7620755cb2$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
                                var inProgressEntry = $6b4b2b7620755cb2$var$makeAuthTokenRequestInProgressEntry(oldEntry);
                                tokenPromise = $6b4b2b7620755cb2$var$fetchAuthTokenFromServer(installations, inProgressEntry);
                                return inProgressEntry;
                            }
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    if (!tokenPromise) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        tokenPromise
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp = entry.authToken;
                    _state.label = 4;
                case 4:
                    authToken = _tmp;
                    return [
                        2,
                        authToken
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_refreshAuthToken.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    return $6b4b2b7620755cb2$var$_waitUntilAuthTokenRequest.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_waitUntilAuthTokenRequest() {
    $6b4b2b7620755cb2$var$_waitUntilAuthTokenRequest = /**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations, forceRefresh) {
        var entry, authToken;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$updateAuthTokenRequest(installations.appConfig)
                    ];
                case 1:
                    entry = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ )) return [
                        3,
                        5
                    ];
                    // generateAuthToken still in progress.
                    return [
                        4,
                        $6b4b2b7620755cb2$var$sleep(100)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $6b4b2b7620755cb2$var$updateAuthTokenRequest(installations.appConfig)
                    ];
                case 4:
                    entry = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
                    return [
                        2,
                        $6b4b2b7620755cb2$var$refreshAuthToken(installations, forceRefresh)
                    ];
                    else return [
                        2,
                        authToken
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_waitUntilAuthTokenRequest.apply(this, arguments);
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $6b4b2b7620755cb2$var$updateAuthTokenRequest(appConfig) {
    return $6b4b2b7620755cb2$var$update(appConfig, function(oldEntry) {
        if (!$6b4b2b7620755cb2$var$isEntryRegistered(oldEntry)) throw $6b4b2b7620755cb2$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        var oldAuthToken = oldEntry.authToken;
        if ($6b4b2b7620755cb2$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
function $6b4b2b7620755cb2$var$fetchAuthTokenFromServer(installations, installationEntry) {
    return $6b4b2b7620755cb2$var$_fetchAuthTokenFromServer.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_fetchAuthTokenFromServer() {
    $6b4b2b7620755cb2$var$_fetchAuthTokenFromServer = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations, installationEntry) {
        var authToken, updatedInstallationEntry, e, updatedInstallationEntry1;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4,
                        $6b4b2b7620755cb2$var$generateAuthTokenRequest(installations, installationEntry)
                    ];
                case 1:
                    authToken = _state.sent();
                    updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                        authToken: authToken
                    });
                    return [
                        4,
                        $6b4b2b7620755cb2$var$set(installations.appConfig, updatedInstallationEntry)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        authToken
                    ];
                case 3:
                    e = _state.sent();
                    if (!($6b4b2b7620755cb2$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404))) return [
                        3,
                        5
                    ];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [
                        4,
                        $6b4b2b7620755cb2$var$remove(installations.appConfig)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    updatedInstallationEntry1 = Object.assign(Object.assign({}, installationEntry), {
                        authToken: {
                            requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                        }
                    });
                    return [
                        4,
                        $6b4b2b7620755cb2$var$set(installations.appConfig, updatedInstallationEntry1)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    throw e;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_fetchAuthTokenFromServer.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $6b4b2b7620755cb2$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$6b4b2b7620755cb2$var$isAuthTokenExpired(authToken);
}
function $6b4b2b7620755cb2$var$isAuthTokenExpired(authToken) {
    var now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $6b4b2b7620755cb2$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $6b4b2b7620755cb2$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $6b4b2b7620755cb2$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $6b4b2b7620755cb2$var$PENDING_TIMEOUT_MS < Date.now();
}
function $6b4b2b7620755cb2$export$218c8c3169c024d2(installations) {
    return $6b4b2b7620755cb2$var$_getId.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_getId() {
    $6b4b2b7620755cb2$var$_getId = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var installationsImpl, _ref, installationEntry, registrationPromise;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    installationsImpl = installations;
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getInstallationEntry(installationsImpl)
                    ];
                case 1:
                    _ref = _state.sent(), installationEntry = _ref.installationEntry, registrationPromise = _ref.registrationPromise;
                    if (registrationPromise) registrationPromise.catch(console.error);
                    else // If the installation is already registered, update the authentication
                    // token if needed.
                    $6b4b2b7620755cb2$var$refreshAuthToken(installationsImpl).catch(console.error);
                    return [
                        2,
                        installationEntry.fid
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_getId.apply(this, arguments);
}
function $6b4b2b7620755cb2$export$257b2d10b709d8ef(installations) {
    return $6b4b2b7620755cb2$var$_getToken.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_getToken() {
    $6b4b2b7620755cb2$var$_getToken = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var forceRefresh, installationsImpl, authToken;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    installationsImpl = installations;
                    return [
                        4,
                        $6b4b2b7620755cb2$var$completeInstallationRegistration(installationsImpl)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $6b4b2b7620755cb2$var$refreshAuthToken(installationsImpl, forceRefresh)
                    ];
                case 2:
                    authToken = _state.sent();
                    return [
                        2,
                        authToken.token
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_getToken.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$completeInstallationRegistration(installations) {
    return $6b4b2b7620755cb2$var$_completeInstallationRegistration.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_completeInstallationRegistration() {
    $6b4b2b7620755cb2$var$_completeInstallationRegistration = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var registrationPromise;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getInstallationEntry(installations)
                    ];
                case 1:
                    registrationPromise = _state.sent().registrationPromise;
                    if (!registrationPromise) return [
                        3,
                        3
                    ];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [
                        4,
                        registrationPromise
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_completeInstallationRegistration.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$deleteInstallationRequest(appConfig, installationEntry) {
    return $6b4b2b7620755cb2$var$_deleteInstallationRequest.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_deleteInstallationRequest() {
    $6b4b2b7620755cb2$var$_deleteInstallationRequest = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(appConfig, installationEntry) {
        var endpoint, headers, request, response;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    endpoint = $6b4b2b7620755cb2$var$getDeleteEndpoint(appConfig, installationEntry);
                    headers = $6b4b2b7620755cb2$var$getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: "DELETE",
                        headers: headers
                    };
                    return [
                        4,
                        $6b4b2b7620755cb2$var$retryIfServerError(function() {
                            return fetch(endpoint, request);
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $6b4b2b7620755cb2$var$getErrorFromResponse("Delete Installation", response)
                    ];
                case 2:
                    throw _state.sent();
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_deleteInstallationRequest.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$getDeleteEndpoint(appConfig, param) {
    var fid = param.fid;
    return "".concat($6b4b2b7620755cb2$var$getInstallationsEndpoint(appConfig), "/").concat(fid);
}
function $6b4b2b7620755cb2$export$5f6b87a08674814c(installations) {
    return $6b4b2b7620755cb2$var$_deleteInstallations.apply(this, arguments);
}
function $6b4b2b7620755cb2$var$_deleteInstallations() {
    $6b4b2b7620755cb2$var$_deleteInstallations = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(installations) {
        var appConfig, entry;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appConfig = installations.appConfig;
                    return [
                        4,
                        $6b4b2b7620755cb2$var$update(appConfig, function(oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
                            return undefined;
                            return oldEntry;
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    if (!entry) return [
                        3,
                        6
                    ];
                    if (!(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ )) return [
                        3,
                        2
                    ];
                    // Can't delete while trying to register.
                    throw $6b4b2b7620755cb2$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
                case 2:
                    if (!(entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ )) return [
                        3,
                        6
                    ];
                    if (!!navigator.onLine) return [
                        3,
                        3
                    ];
                    throw $6b4b2b7620755cb2$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
                case 3:
                    return [
                        4,
                        $6b4b2b7620755cb2$var$deleteInstallationRequest(appConfig, entry)
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        $6b4b2b7620755cb2$var$remove(appConfig)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $6b4b2b7620755cb2$var$_deleteInstallations.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $6b4b2b7620755cb2$export$ceb4c11381bc36e8(installations, callback) {
    var appConfig = installations.appConfig;
    $6b4b2b7620755cb2$var$addCallback(appConfig, callback);
    return function() {
        $6b4b2b7620755cb2$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $6b4b2b7620755cb2$export$9bfc115e43431ff5() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $43ffc92b683abcf2$export$f9962582c9e66d99)();
    var installationsImpl = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6b4b2b7620755cb2$var$extractAppConfig(app) {
    if (!app || !app.options) throw $6b4b2b7620755cb2$var$getMissingValueError("App Configuration");
    if (!app.name) throw $6b4b2b7620755cb2$var$getMissingValueError("App Name");
    // Required app config keys
    var configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = configKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var keyName = _step.value;
            if (!app.options[keyName]) throw $6b4b2b7620755cb2$var$getMissingValueError(keyName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $6b4b2b7620755cb2$var$getMissingValueError(valueName) {
    return $6b4b2b7620755cb2$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6b4b2b7620755cb2$var$INSTALLATIONS_NAME = "installations";
var $6b4b2b7620755cb2$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
var $6b4b2b7620755cb2$var$publicFactory = function(container) {
    var app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    var appConfig = $6b4b2b7620755cb2$var$extractAppConfig(app);
    var heartbeatServiceProvider = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, "heartbeat");
    var installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: function() {
            return Promise.resolve();
        }
    };
    return installationsImpl;
};
var $6b4b2b7620755cb2$var$internalFactory = function(container) {
    var app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    var installations = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, $6b4b2b7620755cb2$var$INSTALLATIONS_NAME).getImmediate();
    var installationsInternal = {
        getId: function() {
            return $6b4b2b7620755cb2$export$218c8c3169c024d2(installations);
        },
        getToken: function(forceRefresh) {
            return $6b4b2b7620755cb2$export$257b2d10b709d8ef(installations, forceRefresh);
        }
    };
    return installationsInternal;
};
function $6b4b2b7620755cb2$var$registerInstallations() {
    (0, $43ffc92b683abcf2$export$c930050e7bb63965)(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)($6b4b2b7620755cb2$var$INSTALLATIONS_NAME, $6b4b2b7620755cb2$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $43ffc92b683abcf2$export$c930050e7bb63965)(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)($6b4b2b7620755cb2$var$INSTALLATIONS_NAME_INTERNAL, $6b4b2b7620755cb2$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * Firebase Installations
 *
 * @packageDocumentation
 */ $6b4b2b7620755cb2$var$registerInstallations();
(0, $43ffc92b683abcf2$export$d29d5299a7137abc)($6b4b2b7620755cb2$var$name, $6b4b2b7620755cb2$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $43ffc92b683abcf2$export$d29d5299a7137abc)($6b4b2b7620755cb2$var$name, $6b4b2b7620755cb2$var$version, "esm2017");


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ var $48b65f6ca82b57b5$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
var $48b65f6ca82b57b5$var$GA_FID_KEY = "firebase_id";
var $48b65f6ca82b57b5$var$ORIGIN_KEY = "origin";
var $48b65f6ca82b57b5$var$FETCH_TIMEOUT_MILLIS = 60000;
var $48b65f6ca82b57b5$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
var $48b65f6ca82b57b5$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $48b65f6ca82b57b5$var$logger = new (0, $2ef812b47e0043d3$export$efa9a398d6368992)("@firebase/analytics");
var $48b65f6ca82b57b5$var$_obj;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $48b65f6ca82b57b5$var$ERRORS = ($48b65f6ca82b57b5$var$_obj = {}, (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "already-exists" /* AnalyticsError.ALREADY_EXISTS */ , "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId."), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ , "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance."), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ , "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect."), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , "Firebase Analytics Interop Component failed to instantiate: {$reason}"), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}"), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}"), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}."), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}"), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "no-api-key" /* AnalyticsError.NO_API_KEY */ , 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.'), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "no-app-id" /* AnalyticsError.NO_APP_ID */ , 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.'), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "no-client-id" /* AnalyticsError.NO_CLIENT_ID */ , 'The "client_id" field is empty.'), (0, $azcHm._)($48b65f6ca82b57b5$var$_obj, "invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , "Trusted Types detected an invalid gtag resource: {$gtagURL}."), $48b65f6ca82b57b5$var$_obj);
var $48b65f6ca82b57b5$var$ERROR_FACTORY = new (0, $4aa7d5a8ca32ac7d$export$3fa6e1b18a3b2d40)("analytics", "Analytics", $48b65f6ca82b57b5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $48b65f6ca82b57b5$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($48b65f6ca82b57b5$var$GTAG_URL)) {
        var err = $48b65f6ca82b57b5$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $48b65f6ca82b57b5$var$logger.warn(err.message);
        return "";
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $48b65f6ca82b57b5$var$promiseAllSettled(promises) {
    return Promise.all(promises.map(function(promise) {
        return promise.catch(function(e) {
            return e;
        });
    }));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $48b65f6ca82b57b5$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    var trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $48b65f6ca82b57b5$var$insertScriptTag(dataLayerName, measurementId) {
    var trustedTypesPolicy = $48b65f6ca82b57b5$var$createTrustedTypesPolicy("firebase-js-sdk-policy", {
        createScriptURL: $48b65f6ca82b57b5$var$createGtagTrustedTypesScriptURL
    });
    var script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    var gtagScriptURL = "".concat($48b65f6ca82b57b5$var$GTAG_URL, "?l=").concat(dataLayerName, "&id=").concat(measurementId);
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $48b65f6ca82b57b5$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    var dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
function $48b65f6ca82b57b5$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    return $48b65f6ca82b57b5$var$_gtagOnConfig.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_gtagOnConfig() {
    $48b65f6ca82b57b5$var$_gtagOnConfig = /**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
        var correspondingAppId, dynamicConfigResults, foundConfig, e;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If config is already fetched, we know the appId and can use it to look up what FID promise we
                    /// are waiting for, and wait only on that one.
                    correspondingAppId = measurementIdToAppId[measurementId];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    if (!correspondingAppId) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        initializationPromisesMap[correspondingAppId]
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    return [
                        4,
                        $48b65f6ca82b57b5$var$promiseAllSettled(dynamicConfigPromisesList)
                    ];
                case 4:
                    dynamicConfigResults = _state.sent();
                    foundConfig = dynamicConfigResults.find(function(config) {
                        return config.measurementId === measurementId;
                    });
                    if (!foundConfig) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        initializationPromisesMap[foundConfig.appId]
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        8
                    ];
                case 7:
                    e = _state.sent();
                    $48b65f6ca82b57b5$var$logger.error(e);
                    return [
                        3,
                        8
                    ];
                case 8:
                    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_gtagOnConfig.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    return $48b65f6ca82b57b5$var$_gtagOnEvent.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_gtagOnEvent() {
    $48b65f6ca82b57b5$var$_gtagOnEvent = /**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
        var initializationPromisesToWaitFor, gaSendToList, dynamicConfigResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, e;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    initializationPromisesToWaitFor = [];
                    if (!(gtagParams && gtagParams["send_to"])) return [
                        3,
                        2
                    ];
                    gaSendToList = gtagParams["send_to"];
                    // Make it an array if is isn't, so it can be dealt with the same way.
                    if (!Array.isArray(gaSendToList)) gaSendToList = [
                        gaSendToList
                    ];
                    return [
                        4,
                        $48b65f6ca82b57b5$var$promiseAllSettled(dynamicConfigPromisesList)
                    ];
                case 1:
                    dynamicConfigResults = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var sendToId = _step.value;
                            // Any fetched dynamic measurement ID that matches this 'send_to' ID
                            var foundConfig = dynamicConfigResults.find(function(config) {
                                return config.measurementId === sendToId;
                            });
                            var initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                            if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                            else {
                                // Found an item in 'send_to' that is not associated
                                // directly with an FID, possibly a group.  Empty this array,
                                // exit the loop early, and let it get populated below.
                                initializationPromisesToWaitFor = [];
                                return "break";
                            }
                        };
                        for(_iterator = gaSendToList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _ret = _loop();
                            if (_ret === "break") break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _state.label = 2;
                case 2:
                    // This will be unpopulated if there was no 'send_to' field , or
                    // if not all entries in the 'send_to' field could be mapped to
                    // a FID. In these cases, wait on all pending initialization promises.
                    if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
                    // Run core gtag function with args after all relevant initialization
                    // promises have been resolved.
                    return [
                        4,
                        Promise.all(initializationPromisesToWaitFor)
                    ];
                case 3:
                    _state.sent();
                    // Workaround for http://b/141370449 - third argument cannot be undefined.
                    gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    $48b65f6ca82b57b5$var$logger.error(e);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_gtagOnEvent.apply(this, arguments);
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $48b65f6ca82b57b5$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    function gtagWrapper(command) {
        return _gtagWrapper.apply(this, arguments);
    }
    function _gtagWrapper() {
        _gtagWrapper = /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(command) {
            var _len, args, _key, _args, measurementId, gtagParams, _args1, measurementId1, gtagParams1, _args2, gtagParams2, _args3, measurementId2, fieldName, callback, _args4, customParams, e;
            var _arguments = arguments;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        if (!(command === "event" /* GtagCommand.EVENT */ )) return [
                            3,
                            3
                        ];
                        _args = (0, $3tDj3._)(args, 2), measurementId = _args[0], gtagParams = _args[1];
                        // If EVENT, second arg must be measurementId.
                        return [
                            4,
                            $48b65f6ca82b57b5$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        if (!(command === "config" /* GtagCommand.CONFIG */ )) return [
                            3,
                            5
                        ];
                        _args1 = (0, $3tDj3._)(args, 2), measurementId1 = _args1[0], gtagParams1 = _args1[1];
                        // If CONFIG, second arg must be measurementId.
                        return [
                            4,
                            $48b65f6ca82b57b5$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId1, gtagParams1)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (command === "consent" /* GtagCommand.CONSENT */ ) {
                            _args2 = (0, $3tDj3._)(args, 1), gtagParams2 = _args2[0];
                            gtagCore("consent" /* GtagCommand.CONSENT */ , "update", gtagParams2);
                        } else if (command === "get" /* GtagCommand.GET */ ) {
                            _args3 = (0, $3tDj3._)(args, 3), measurementId2 = _args3[0], fieldName = _args3[1], callback = _args3[2];
                            gtagCore("get" /* GtagCommand.GET */ , measurementId2, fieldName, callback);
                        } else if (command === "set" /* GtagCommand.SET */ ) {
                            _args4 = (0, $3tDj3._)(args, 1), customParams = _args4[0];
                            // If SET, second arg must be params.
                            gtagCore("set" /* GtagCommand.SET */ , customParams);
                        } else gtagCore.apply(void 0, [
                            command
                        ].concat((0, $1UA6e._)(args)));
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        $48b65f6ca82b57b5$var$logger.error(e);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return _gtagWrapper.apply(this, arguments);
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $48b65f6ca82b57b5$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    var gtagCore = function gtagCore() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++){
            _args[_key] = arguments[_key];
        }
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $48b65f6ca82b57b5$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $48b65f6ca82b57b5$var$findGtagScriptOnPage(dataLayerName) {
    var scriptTags = window.document.getElementsByTagName("script");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(scriptTags)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tag = _step.value;
            if (tag.src && tag.src.includes($48b65f6ca82b57b5$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ var $48b65f6ca82b57b5$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ var $48b65f6ca82b57b5$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ var $48b65f6ca82b57b5$var$RetryData = /*#__PURE__*/ function() {
    "use strict";
    function RetryData() {
        var throttleMetadata = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $48b65f6ca82b57b5$var$BASE_INTERVAL_MILLIS;
        (0, $lfBxf._)(this, RetryData);
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    (0, $9tzan._)(RetryData, [
        {
            key: "getThrottleMetadata",
            value: function getThrottleMetadata(appId) {
                return this.throttleMetadata[appId];
            }
        },
        {
            key: "setThrottleMetadata",
            value: function setThrottleMetadata(appId, metadata) {
                this.throttleMetadata[appId] = metadata;
            }
        },
        {
            key: "deleteThrottleMetadata",
            value: function deleteThrottleMetadata(appId) {
                delete this.throttleMetadata[appId];
            }
        }
    ]);
    return RetryData;
}();
var $48b65f6ca82b57b5$var$defaultRetryData = new $48b65f6ca82b57b5$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $48b65f6ca82b57b5$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $48b65f6ca82b57b5$var$fetchDynamicConfig(appFields) {
    return $48b65f6ca82b57b5$var$_fetchDynamicConfig.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_fetchDynamicConfig() {
    $48b65f6ca82b57b5$var$_fetchDynamicConfig = /**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(appFields) {
        var _a, appId, apiKey, request, appUrl, response, errorMessage, jsonResponse, _ignored;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appId = appFields.appId, apiKey = appFields.apiKey;
                    request = {
                        method: "GET",
                        headers: $48b65f6ca82b57b5$var$getHeaders(apiKey)
                    };
                    appUrl = $48b65f6ca82b57b5$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
                    return [
                        4,
                        fetch(appUrl, request)
                    ];
                case 1:
                    response = _state.sent();
                    if (!(response.status !== 200 && response.status !== 304)) return [
                        3,
                        6
                    ];
                    errorMessage = "";
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    jsonResponse = _state.sent();
                    if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
                    return [
                        3,
                        5
                    ];
                case 4:
                    _ignored = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
                        httpStatus: response.status,
                        responseMessage: errorMessage
                    });
                case 6:
                    return [
                        2,
                        response.json()
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_fetchDynamicConfig.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$fetchDynamicConfigWithRetry(app) {
    return $48b65f6ca82b57b5$var$_fetchDynamicConfigWithRetry.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_fetchDynamicConfigWithRetry() {
    $48b65f6ca82b57b5$var$_fetchDynamicConfigWithRetry = /**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(app) {
        var // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
        retryData, timeoutMillis, _app_options, appId, apiKey, measurementId, throttleMetadata, signal;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            retryData = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : $48b65f6ca82b57b5$var$defaultRetryData, timeoutMillis = _arguments.length > 2 ? _arguments[2] : void 0;
            _app_options = app.options, appId = _app_options.appId, apiKey = _app_options.apiKey, measurementId = _app_options.measurementId;
            if (!appId) throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
            if (!apiKey) {
                if (measurementId) return [
                    2,
                    {
                        measurementId: measurementId,
                        appId: appId
                    }
                ];
                throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
            }
            throttleMetadata = retryData.getThrottleMetadata(appId) || {
                backoffCount: 0,
                throttleEndTimeMillis: Date.now()
            };
            signal = new $48b65f6ca82b57b5$var$AnalyticsAbortSignal();
            setTimeout(/*#__PURE__*/ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                    // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                    signal.abort();
                    return [
                        2
                    ];
                });
            }), timeoutMillis !== undefined ? timeoutMillis : $48b65f6ca82b57b5$var$FETCH_TIMEOUT_MILLIS);
            return [
                2,
                $48b65f6ca82b57b5$var$attemptFetchDynamicConfigWithRetry({
                    appId: appId,
                    apiKey: apiKey,
                    measurementId: measurementId
                }, throttleMetadata, signal, retryData)
            ];
        });
    });
    return $48b65f6ca82b57b5$var$_fetchDynamicConfigWithRetry.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$attemptFetchDynamicConfigWithRetry(appFields, _, signal) {
    return $48b65f6ca82b57b5$var$_attemptFetchDynamicConfigWithRetry.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_attemptFetchDynamicConfigWithRetry() {
    $48b65f6ca82b57b5$var$_attemptFetchDynamicConfigWithRetry = /**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(appFields, param, signal) {
        var throttleEndTimeMillis, backoffCount, retryData, _a, appId, measurementId, e, response, e1, error, backoffMillis, throttleMetadata;
        var _arguments = arguments;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    throttleEndTimeMillis = param.throttleEndTimeMillis, backoffCount = param.backoffCount, retryData = _arguments.length > 3 && _arguments[3] !== void 0 // for testing
                     ? _arguments[3] : $48b65f6ca82b57b5$var$defaultRetryData;
                    appId = appFields.appId, measurementId = appFields.measurementId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $48b65f6ca82b57b5$var$setAbortableTimeout(signal, throttleEndTimeMillis)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    if (measurementId) {
                        $48b65f6ca82b57b5$var$logger.warn("Timed out fetching this Firebase app's measurement ID from the server." + " Falling back to the measurement ID ".concat(measurementId) + ' provided in the "measurementId" field in the local Firebase config. ['.concat(e === null || e === void 0 ? void 0 : e.message, "]"));
                        return [
                            2,
                            {
                                appId: appId,
                                measurementId: measurementId
                            }
                        ];
                    }
                    throw e;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        $48b65f6ca82b57b5$var$fetchDynamicConfig(appFields)
                    ];
                case 5:
                    response = _state.sent();
                    // Note the SDK only clears throttle state if response is success or non-retriable.
                    retryData.deleteThrottleMetadata(appId);
                    return [
                        2,
                        response
                    ];
                case 6:
                    e1 = _state.sent();
                    error = e1;
                    if (!$48b65f6ca82b57b5$var$isRetriableError(error)) {
                        retryData.deleteThrottleMetadata(appId);
                        if (measurementId) {
                            $48b65f6ca82b57b5$var$logger.warn("Failed to fetch this Firebase app's measurement ID from the server." + " Falling back to the measurement ID ".concat(measurementId) + ' provided in the "measurementId" field in the local Firebase config. ['.concat(error === null || error === void 0 ? void 0 : error.message, "]"));
                            return [
                                2,
                                {
                                    appId: appId,
                                    measurementId: measurementId
                                }
                            ];
                        } else throw e1;
                    }
                    backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $4aa7d5a8ca32ac7d$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $48b65f6ca82b57b5$var$LONG_RETRY_FACTOR) : (0, $4aa7d5a8ca32ac7d$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
                    // Increments backoff state.
                    throttleMetadata = {
                        throttleEndTimeMillis: Date.now() + backoffMillis,
                        backoffCount: backoffCount + 1
                    };
                    // Persists state.
                    retryData.setThrottleMetadata(appId, throttleMetadata);
                    $48b65f6ca82b57b5$var$logger.debug("Calling attemptFetch again in ".concat(backoffMillis, " millis"));
                    return [
                        2,
                        $48b65f6ca82b57b5$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData)
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_attemptFetchDynamicConfigWithRetry.apply(this, arguments);
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $48b65f6ca82b57b5$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function(resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function() {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($48b65f6ca82b57b5$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $48b65f6ca82b57b5$var$isRetriableError(e) {
    if (!(e instanceof (0, $4aa7d5a8ca32ac7d$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ var $48b65f6ca82b57b5$var$AnalyticsAbortSignal = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsAbortSignal() {
        (0, $lfBxf._)(this, AnalyticsAbortSignal);
        this.listeners = [];
    }
    (0, $9tzan._)(AnalyticsAbortSignal, [
        {
            key: "addEventListener",
            value: function addEventListener(listener) {
                this.listeners.push(listener);
            }
        },
        {
            key: "abort",
            value: function abort() {
                this.listeners.forEach(function(listener) {
                    return listener();
                });
            }
        }
    ]);
    return AnalyticsAbortSignal;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ var $48b65f6ca82b57b5$var$defaultEventParametersForInit;
function $48b65f6ca82b57b5$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    return $48b65f6ca82b57b5$var$_logEvent$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_logEvent$1() {
    $48b65f6ca82b57b5$var$_logEvent$1 = /**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagFunction, initializationPromise, eventName, eventParams, options) {
        var measurementId, params;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
                    return [
                        2
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    params = Object.assign(Object.assign({}, eventParams), {
                        "send_to": measurementId
                    });
                    gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_logEvent$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    return $48b65f6ca82b57b5$var$_setCurrentScreen$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_setCurrentScreen$1() {
    $48b65f6ca82b57b5$var$_setCurrentScreen$1 = /**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagFunction, initializationPromise, screenName, options) {
        var measurementId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    gtagFunction("set" /* GtagCommand.SET */ , {
                        "screen_name": screenName
                    });
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
                        update: true,
                        "screen_name": screenName
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_setCurrentScreen$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    return $48b65f6ca82b57b5$var$_setUserId$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_setUserId$1() {
    $48b65f6ca82b57b5$var$_setUserId$1 = /**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagFunction, initializationPromise, id, options) {
        var measurementId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    gtagFunction("set" /* GtagCommand.SET */ , {
                        "user_id": id
                    });
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
                        update: true,
                        "user_id": id
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_setUserId$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    return $48b65f6ca82b57b5$var$_setUserProperties$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_setUserProperties$1() {
    $48b65f6ca82b57b5$var$_setUserProperties$1 = /**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagFunction, initializationPromise, properties, options) {
        var flatProperties, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key, measurementId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(options && options.global)) return [
                        3,
                        1
                    ];
                    flatProperties = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = Object.keys(properties)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            key = _step.value;
                            // use dot notation for merge behavior in gtag.js
                            flatProperties["user_properties.".concat(key)] = properties[key];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 1:
                    return [
                        4,
                        initializationPromise
                    ];
                case 2:
                    measurementId = _state.sent();
                    gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
                        update: true,
                        "user_properties": properties
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_setUserProperties$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    return $48b65f6ca82b57b5$var$_internalGetGoogleAnalyticsClientId.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_internalGetGoogleAnalyticsClientId() {
    $48b65f6ca82b57b5$var$_internalGetGoogleAnalyticsClientId = /**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(gtagFunction, initializationPromise) {
        var measurementId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        initializationPromise
                    ];
                case 1:
                    measurementId = _state.sent();
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            gtagFunction("get" /* GtagCommand.GET */ , measurementId, "client_id", function(clientId) {
                                if (!clientId) reject($48b65f6ca82b57b5$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
                                resolve(clientId);
                            });
                        })
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_internalGetGoogleAnalyticsClientId.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    return $48b65f6ca82b57b5$var$_setAnalyticsCollectionEnabled$1.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_setAnalyticsCollectionEnabled$1() {
    $48b65f6ca82b57b5$var$_setAnalyticsCollectionEnabled$1 = /**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(initializationPromise, enabled) {
        var measurementId;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        initializationPromise
                    ];
                case 1:
                    measurementId = _state.sent();
                    window["ga-disable-".concat(measurementId)] = !enabled;
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_setAnalyticsCollectionEnabled$1.apply(this, arguments);
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ var $48b65f6ca82b57b5$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $48b65f6ca82b57b5$var$_setConsentDefaultForInit(consentSettings) {
    $48b65f6ca82b57b5$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $48b65f6ca82b57b5$var$_setDefaultEventParametersForInit(customParams) {
    $48b65f6ca82b57b5$var$defaultEventParametersForInit = customParams;
}
function $48b65f6ca82b57b5$var$validateIndexedDB() {
    return $48b65f6ca82b57b5$var$_validateIndexedDB.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_validateIndexedDB() {
    $48b65f6ca82b57b5$var$_validateIndexedDB = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
        var e;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!(0, $4aa7d5a8ca32ac7d$export$3865db50535c2055)()) return [
                        3,
                        1
                    ];
                    $48b65f6ca82b57b5$var$logger.warn($48b65f6ca82b57b5$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: "IndexedDB is not available in this environment."
                    }).message);
                    return [
                        2,
                        false
                    ];
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $4aa7d5a8ca32ac7d$export$a8a3018f3d187a4d)()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    $48b65f6ca82b57b5$var$logger.warn($48b65f6ca82b57b5$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
                        errorInfo: e === null || e === void 0 ? void 0 : e.toString()
                    }).message);
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_validateIndexedDB.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    return $48b65f6ca82b57b5$var$__initializeAnalytics.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$__initializeAnalytics() {
    $48b65f6ca82b57b5$var$__initializeAnalytics = /**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
        var _a, dynamicConfigPromise, fidPromise, _ref, dynamicConfig, fid, configProperties;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dynamicConfigPromise = $48b65f6ca82b57b5$var$fetchDynamicConfigWithRetry(app);
                    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
                    dynamicConfigPromise.then(function(config) {
                        measurementIdToAppId[config.measurementId] = config.appId;
                        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $48b65f6ca82b57b5$var$logger.warn("The measurement ID in the local Firebase config (".concat(app.options.measurementId, ")") + " does not match the measurement ID fetched from the server (".concat(config.measurementId, ").") + " To ensure analytics events are always sent to the correct Analytics property," + " update the" + " measurement ID field in the local config or remove it from the local config.");
                    }).catch(function(e) {
                        return $48b65f6ca82b57b5$var$logger.error(e);
                    });
                    // Add to list to track state of all dynamic config promises.
                    dynamicConfigPromisesList.push(dynamicConfigPromise);
                    fidPromise = $48b65f6ca82b57b5$var$validateIndexedDB().then(function(envIsValid) {
                        if (envIsValid) return installations.getId();
                        else return undefined;
                    });
                    return [
                        4,
                        Promise.all([
                            dynamicConfigPromise,
                            fidPromise
                        ])
                    ];
                case 1:
                    _ref = (0, $3tDj3._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), dynamicConfig = _ref[0], fid = _ref[1];
                    // Detect if user has already put the gtag <script> tag on this page with the passed in
                    // data layer name.
                    if (!$48b65f6ca82b57b5$var$findGtagScriptOnPage(dataLayerName)) $48b65f6ca82b57b5$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
                    // Detects if there are consent settings that need to be configured.
                    if ($48b65f6ca82b57b5$var$defaultConsentSettingsForInit) {
                        gtagCore("consent" /* GtagCommand.CONSENT */ , "default", $48b65f6ca82b57b5$var$defaultConsentSettingsForInit);
                        $48b65f6ca82b57b5$var$_setConsentDefaultForInit(undefined);
                    }
                    // This command initializes gtag.js and only needs to be called once for the entire web app,
                    // but since it is idempotent, we can call it multiple times.
                    // We keep it together with other initialization logic for better code structure.
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    gtagCore("js", new Date());
                    // User config added first. We don't want users to accidentally overwrite
                    // base Firebase config properties.
                    configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
                    // guard against developers accidentally setting properties with prefix `firebase_`
                    configProperties[$48b65f6ca82b57b5$var$ORIGIN_KEY] = "firebase";
                    configProperties.update = true;
                    if (fid != null) configProperties[$48b65f6ca82b57b5$var$GA_FID_KEY] = fid;
                    // It should be the first config command called on this GA-ID
                    // Initialize this GA-ID and set FID on it using the gtag config API.
                    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
                    // `configProperties`.
                    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
                    // Detects if there is data that will be set on every event logged from the SDK.
                    if ($48b65f6ca82b57b5$var$defaultEventParametersForInit) {
                        gtagCore("set" /* GtagCommand.SET */ , $48b65f6ca82b57b5$var$defaultEventParametersForInit);
                        $48b65f6ca82b57b5$var$_setDefaultEventParametersForInit(undefined);
                    }
                    return [
                        2,
                        dynamicConfig.measurementId
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$__initializeAnalytics.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ var $48b65f6ca82b57b5$var$AnalyticsService = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsService(app) {
        (0, $lfBxf._)(this, AnalyticsService);
        this.app = app;
    }
    (0, $9tzan._)(AnalyticsService, [
        {
            key: "_delete",
            value: function _delete() {
                delete $48b65f6ca82b57b5$var$initializationPromisesMap[this.app.options.appId];
                return Promise.resolve();
            }
        }
    ]);
    return AnalyticsService;
}();
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ var $48b65f6ca82b57b5$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ var $48b65f6ca82b57b5$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ var $48b65f6ca82b57b5$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ var $48b65f6ca82b57b5$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ var $48b65f6ca82b57b5$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ var $48b65f6ca82b57b5$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ var $48b65f6ca82b57b5$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ var $48b65f6ca82b57b5$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $48b65f6ca82b57b5$export$a5a6e0b888b2c992(options) {
    if ($48b65f6ca82b57b5$var$globalInitDone) throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $48b65f6ca82b57b5$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $48b65f6ca82b57b5$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $48b65f6ca82b57b5$var$warnOnBrowserContextMismatch() {
    var mismatchedEnvMessages = [];
    if ((0, $4aa7d5a8ca32ac7d$export$caa8774a9107a58e)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $4aa7d5a8ca32ac7d$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        var details = mismatchedEnvMessages.map(function(message, index) {
            return "(".concat(index + 1, ") ").concat(message);
        }).join(" ");
        var err = $48b65f6ca82b57b5$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $48b65f6ca82b57b5$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $48b65f6ca82b57b5$var$factory(app, installations, options) {
    $48b65f6ca82b57b5$var$warnOnBrowserContextMismatch();
    var appId = app.options.appId;
    if (!appId) throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $48b65f6ca82b57b5$var$logger.warn('The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest' + " measurement ID for this Firebase app. Falling back to the measurement ID ".concat(app.options.measurementId) + ' provided in the "measurementId" field in the local Firebase config.');
        else throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($48b65f6ca82b57b5$var$initializationPromisesMap[appId] != null) throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$48b65f6ca82b57b5$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $48b65f6ca82b57b5$var$getOrCreateDataLayer($48b65f6ca82b57b5$var$dataLayerName);
        var _wrapOrCreateGtag = $48b65f6ca82b57b5$var$wrapOrCreateGtag($48b65f6ca82b57b5$var$initializationPromisesMap, $48b65f6ca82b57b5$var$dynamicConfigPromisesList, $48b65f6ca82b57b5$var$measurementIdToAppId, $48b65f6ca82b57b5$var$dataLayerName, $48b65f6ca82b57b5$var$gtagName), wrappedGtag = _wrapOrCreateGtag.wrappedGtag, gtagCore = _wrapOrCreateGtag.gtagCore;
        $48b65f6ca82b57b5$var$wrappedGtagFunction = wrappedGtag;
        $48b65f6ca82b57b5$var$gtagCoreFunction = gtagCore;
        $48b65f6ca82b57b5$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $48b65f6ca82b57b5$var$initializationPromisesMap[appId] = $48b65f6ca82b57b5$var$_initializeAnalytics(app, $48b65f6ca82b57b5$var$dynamicConfigPromisesList, $48b65f6ca82b57b5$var$measurementIdToAppId, installations, $48b65f6ca82b57b5$var$gtagCoreFunction, $48b65f6ca82b57b5$var$dataLayerName, options);
    var analyticsInstance = new $48b65f6ca82b57b5$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $48b65f6ca82b57b5$export$b0297573c90085aa() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $43ffc92b683abcf2$export$f9962582c9e66d99)();
    app = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(app);
    // Dependencies
    var analyticsProvider = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, $48b65f6ca82b57b5$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $48b65f6ca82b57b5$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $48b65f6ca82b57b5$export$e1ffb6ba450b0317(app) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Dependencies
    var analyticsProvider = (0, $43ffc92b683abcf2$export$fa0d6da0f5838f50)(app, $48b65f6ca82b57b5$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        var existingInstance = analyticsProvider.getImmediate();
        if ((0, $4aa7d5a8ca32ac7d$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    var analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
function $48b65f6ca82b57b5$export$48c17662a6902497() {
    return $48b65f6ca82b57b5$var$_isSupported.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_isSupported() {
    $48b65f6ca82b57b5$var$_isSupported = /**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
        var isDBOpenable, error;
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ((0, $4aa7d5a8ca32ac7d$export$caa8774a9107a58e)()) return [
                        2,
                        false
                    ];
                    if (!(0, $4aa7d5a8ca32ac7d$export$f172b7eb6cf60599)()) return [
                        2,
                        false
                    ];
                    if (!(0, $4aa7d5a8ca32ac7d$export$3865db50535c2055)()) return [
                        2,
                        false
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $4aa7d5a8ca32ac7d$export$a8a3018f3d187a4d)()
                    ];
                case 2:
                    isDBOpenable = _state.sent();
                    return [
                        2,
                        isDBOpenable
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $48b65f6ca82b57b5$var$_isSupported.apply(this, arguments);
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $48b65f6ca82b57b5$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(analyticsInstance);
    $48b65f6ca82b57b5$var$setCurrentScreen$1($48b65f6ca82b57b5$var$wrappedGtagFunction, $48b65f6ca82b57b5$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch(function(e) {
        return $48b65f6ca82b57b5$var$logger.error(e);
    });
}
function $48b65f6ca82b57b5$export$108b704ce5c937fe(analyticsInstance) {
    return $48b65f6ca82b57b5$var$_getGoogleAnalyticsClientId.apply(this, arguments);
}
function $48b65f6ca82b57b5$var$_getGoogleAnalyticsClientId() {
    $48b65f6ca82b57b5$var$_getGoogleAnalyticsClientId = /**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(analyticsInstance) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            analyticsInstance = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(analyticsInstance);
            return [
                2,
                $48b65f6ca82b57b5$var$internalGetGoogleAnalyticsClientId($48b65f6ca82b57b5$var$wrappedGtagFunction, $48b65f6ca82b57b5$var$initializationPromisesMap[analyticsInstance.app.options.appId])
            ];
        });
    });
    return $48b65f6ca82b57b5$var$_getGoogleAnalyticsClientId.apply(this, arguments);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $48b65f6ca82b57b5$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(analyticsInstance);
    $48b65f6ca82b57b5$var$setUserId$1($48b65f6ca82b57b5$var$wrappedGtagFunction, $48b65f6ca82b57b5$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch(function(e) {
        return $48b65f6ca82b57b5$var$logger.error(e);
    });
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $48b65f6ca82b57b5$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(analyticsInstance);
    $48b65f6ca82b57b5$var$setUserProperties$1($48b65f6ca82b57b5$var$wrappedGtagFunction, $48b65f6ca82b57b5$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch(function(e) {
        return $48b65f6ca82b57b5$var$logger.error(e);
    });
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $48b65f6ca82b57b5$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(analyticsInstance);
    $48b65f6ca82b57b5$var$setAnalyticsCollectionEnabled$1($48b65f6ca82b57b5$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch(function(e) {
        return $48b65f6ca82b57b5$var$logger.error(e);
    });
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $48b65f6ca82b57b5$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($48b65f6ca82b57b5$var$wrappedGtagFunction) $48b65f6ca82b57b5$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $48b65f6ca82b57b5$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $48b65f6ca82b57b5$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $4aa7d5a8ca32ac7d$export$4befe9b5fa509a1b)(analyticsInstance);
    $48b65f6ca82b57b5$var$logEvent$1($48b65f6ca82b57b5$var$wrappedGtagFunction, $48b65f6ca82b57b5$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch(function(e) {
        return $48b65f6ca82b57b5$var$logger.error(e);
    });
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $48b65f6ca82b57b5$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($48b65f6ca82b57b5$var$wrappedGtagFunction) $48b65f6ca82b57b5$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , "update", consentSettings);
    else $48b65f6ca82b57b5$var$_setConsentDefaultForInit(consentSettings);
}
var $48b65f6ca82b57b5$var$name = "@firebase/analytics";
var $48b65f6ca82b57b5$var$version = "0.10.0";
/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */ function $48b65f6ca82b57b5$var$registerAnalytics() {
    (0, $43ffc92b683abcf2$export$c930050e7bb63965)(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)($48b65f6ca82b57b5$var$ANALYTICS_TYPE, function(container, param) {
        var analyticsOptions = param.options;
        // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider("app").getImmediate();
        var installations = container.getProvider("installations-internal").getImmediate();
        return $48b65f6ca82b57b5$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $43ffc92b683abcf2$export$c930050e7bb63965)(new (0, $761466ca98ea5fb8$export$16fa2f45be04daa8)("analytics-internal", internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $43ffc92b683abcf2$export$d29d5299a7137abc)($48b65f6ca82b57b5$var$name, $48b65f6ca82b57b5$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $43ffc92b683abcf2$export$d29d5299a7137abc)($48b65f6ca82b57b5$var$name, $48b65f6ca82b57b5$var$version, "esm2017");
    function internalFactory(container) {
        try {
            var analytics = container.getProvider($48b65f6ca82b57b5$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: function(eventName, eventParams, options) {
                    return $48b65f6ca82b57b5$export$5e9eec8001665ac5(analytics, eventName, eventParams, options);
                }
            };
        } catch (e) {
            throw $48b65f6ca82b57b5$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$48b65f6ca82b57b5$var$registerAnalytics();





var $lcrTp = parcelRequire("lcrTp");
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var $b899d5af3bd35eb4$var$firebaseConfig = {
    apiKey: "AIzaSyCU1XAzRdEH0q3sWWcjhGtyXGRrXB6TLC4",
    authDomain: "food-app-7a3c9.firebaseapp.com",
    projectId: "food-app-7a3c9",
    storageBucket: "food-app-7a3c9.appspot.com",
    messagingSenderId: "869864697008",
    appId: "1:869864697008:web:48997b5ac88fe1f2261f75",
    measurementId: "G-KV70J01DLJ"
};
var $b899d5af3bd35eb4$export$729c8b7179294ba = (0, $43ffc92b683abcf2$export$c55cfd413944906d)($b899d5af3bd35eb4$var$firebaseConfig);
var $b899d5af3bd35eb4$var$analytics = (0, $48b65f6ca82b57b5$export$b0297573c90085aa)($b899d5af3bd35eb4$export$729c8b7179294ba);
var $b899d5af3bd35eb4$var$auth = (0, $82f70d645a4b3e84$export$ae1af26003f05816)($b899d5af3bd35eb4$export$729c8b7179294ba);
var $b899d5af3bd35eb4$var$googleProvider = new (0, $82f70d645a4b3e84$export$78acf4525d8a74c4)();
var $b899d5af3bd35eb4$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $lcrTp.createContext)();
var $b899d5af3bd35eb4$export$87091915187a1a85 = function(props) {
    return /*#__PURE__*/ (0, $kZF3u.jsx)($b899d5af3bd35eb4$export$a0fd8390cfe8ae69.Provider, {
        value: {
            signUp: $b899d5af3bd35eb4$var$signUp,
            signIn: $b899d5af3bd35eb4$var$signIn,
            signInWithGoogle: $b899d5af3bd35eb4$var$signInWithGoogle,
            signout: $b899d5af3bd35eb4$var$signout
        },
        children: props.children
    });
};
function $b899d5af3bd35eb4$var$signUp(email, password, name) {
    return $b899d5af3bd35eb4$var$_signUp.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$_signUp() {
    $b899d5af3bd35eb4$var$_signUp = //functions
    (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(email, password, name) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $82f70d645a4b3e84$export$7910e0436ed8d1de)($b899d5af3bd35eb4$var$auth, email, password).then(function(val) {
                            (0, $82f70d645a4b3e84$export$4a5767248b18ef41)($b899d5af3bd35eb4$var$auth, function(user) {
                                console.log("firebase signup on auth change run");
                                if (user) {
                                    console.log("signup", user, name);
                                    (0, $82f70d645a4b3e84$export$21579262ef46735b)(user, {
                                        displayName: name
                                    });
                                }
                            });
                        }).catch(function(err) {
                            return alert(err);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $b899d5af3bd35eb4$var$_signUp.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$signIn(email, password) {
    return $b899d5af3bd35eb4$var$_signIn.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$_signIn() {
    $b899d5af3bd35eb4$var$_signIn = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(email, password) {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $82f70d645a4b3e84$export$555508cbc6add439)($b899d5af3bd35eb4$var$auth, email, password).then(function(val) {
                            console.log("signin successfully");
                        }).catch(function(err) {
                            return alert(err);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $b899d5af3bd35eb4$var$_signIn.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$signInWithGoogle() {
    return $b899d5af3bd35eb4$var$_signInWithGoogle.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$_signInWithGoogle() {
    $b899d5af3bd35eb4$var$_signInWithGoogle = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $82f70d645a4b3e84$export$db3b6bfb95261072)($b899d5af3bd35eb4$var$auth, $b899d5af3bd35eb4$var$googleProvider)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $b899d5af3bd35eb4$var$_signInWithGoogle.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$signout() {
    return $b899d5af3bd35eb4$var$_signout.apply(this, arguments);
}
function $b899d5af3bd35eb4$var$_signout() {
    $b899d5af3bd35eb4$var$_signout = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
        return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
            (0, $82f70d645a4b3e84$export$e7094788287c5e9b)($b899d5af3bd35eb4$var$auth);
            return [
                2
            ];
        });
    });
    return $b899d5af3bd35eb4$var$_signout.apply(this, arguments);
}



var $fd57e2fe3dae6048$var$Header = function() {
    var handleThemeClick = function handleThemeClick() {
        console.log(themeData);
        //themeData=="light" ? dispatch(toogleTheme("dark")) : dispatch(toogleTheme("light"));
        if (themeData == "light") {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $97e825b352217d68$export$9443a770e75d2a08)("dark"));
        } else {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $97e825b352217d68$export$9443a770e75d2a08)("light"));
        }
    };
    console.log("HEADER RENDERED");
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)("Login"), 2), btn = _useState[0], setbtn = _useState[1];
    var status = (0, $67361a66487702b6$export$2e2bcd8739ae039)();
    var data = (0, $lcrTp.useContext)((0, $3589c1d122ad772c$export$2e2bcd8739ae039));
    // const { dummyData, changeDummyData } = data;
    // let { myName } = dummyData;
    var themeData = (0, $9ebbf69bd910f984$export$2105062e25df4afe)(function(store) {
        return store.themeChanger.theme;
    });
    var dispatch = (0, $9ebbf69bd910f984$export$8ad76b76a4c905f8)();
    // console.log(dummyData);
    var cartItems = (0, $9ebbf69bd910f984$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    }); // cartItems = [] (initialstate.items)
    // console.log(cartItems);
    var pathname = (0, $e3ffdf28351c8739$export$45d76561a5302f2b)().pathname; // gives current route
    var firebase = (0, $lcrTp.useContext)((0, $b899d5af3bd35eb4$export$a0fd8390cfe8ae69));
    var _useState1 = (0, $3tDj3._)((0, $lcrTp.useState)(null), 2), isUserLoggedIn = _useState1[0], setisUserLoggedIn = _useState1[1];
    var auth = (0, $82f70d645a4b3e84$export$ae1af26003f05816)((0, $b899d5af3bd35eb4$export$729c8b7179294ba));
    (0, $lcrTp.useEffect)(function() {
        console.log("header use effect called");
        (0, $82f70d645a4b3e84$export$4a5767248b18ef41)(auth, function(user) {
            console.log("header on auth change run");
            if (user != isUserLoggedIn) {
                console.log("header ", user, user === null || user === void 0 ? void 0 : user.displayName);
                setisUserLoggedIn(user);
            } else setisUserLoggedIn(null);
        });
    }, []);
    //console.log("isuserloggedin= ",isUserLoggedIn);
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: "header flex justify-between items-center gap-8 px-4 mb-5   mx-auto py-4",
        id: "header",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                    className: "w-24",
                    src: "https://ucarecdn.com/eac2b467-5e68-451d-8254-56aa57a0b678/-/preview/512x512/"
                })
            }),
            /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                to: pathname == "/header" ? "/" : "/header",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                        className: "md:hidden  ",
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                            src: themeData == "dark" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Hamburger_icon_white.svg/1200px-Hamburger_icon_white.svg.png" : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Hamburger_icon.svg/1024px-Hamburger_icon.svg.png",
                            className: "w-6"
                        })
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $kZF3u.jsxs)("ul", {
                className: " hidden md:flex items-center gap-8 lg:gap-10 ",
                id: "list",
                children: [
                    (isUserLoggedIn === null || isUserLoggedIn === void 0 ? void 0 : isUserLoggedIn.displayName) && /*#__PURE__*/ (0, $kZF3u.jsxs)("li", {
                        children: [
                            "Hey, ",
                            isUserLoggedIn === null || isUserLoggedIn === void 0 ? void 0 : isUserLoggedIn.displayName,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsxs)("li", {
                        children: [
                            "Online Status:",
                            status ? "\u2705" : "\u274C",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/about",
                            children: "About Us"
                        })
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/grocery",
                            children: "Grocery"
                        })
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                        children: /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/cart",
                            children: [
                                /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Shopping_cart_icon.svg/1250px-Shopping_cart_icon.svg.png",
                                    className: "w-8 inline",
                                    alt: "cart"
                                }),
                                /*#__PURE__*/ (0, $kZF3u.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "(",
                                        cartItems.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                        children: (isUserLoggedIn === null || isUserLoggedIn === void 0 ? void 0 : isUserLoggedIn.displayName) ? /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                            className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                            onClick: function() {
                                return firebase.signout();
                            },
                            children: "Logout"
                        }) : /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: [
                                /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                    className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                                    children: "Login"
                                }),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                            className: "w-8 ",
                            onClick: handleThemeClick,
                            children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                src: themeData == "light" ? (0, $df6b3e332a139c88$export$3e936a8db52a10a0) : (0, $df6b3e332a139c88$export$f30cb9bc4f736419)
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $fd57e2fe3dae6048$export$2e2bcd8739ae039 = $fd57e2fe3dae6048$var$Header;



var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");


var $kZF3u = parcelRequire("kZF3u");

var $2c7220131b1ebb76$var$Card = function(props) {
    var _props_data;
    // console.log(props);
    var _ref = props === null || props === void 0 ? void 0 : (_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.info, cloudinaryImageId = _ref.cloudinaryImageId, name = _ref.name, avgRatingString = _ref.avgRatingString, sla = _ref.sla, areaName = _ref.areaName, cuisines = _ref.cuisines;
    //   console.log(isVeg , myData.name);
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: "card  w-80  p-2 hover:cursor-pointer hover:scale-95 transition  duration-200  ",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                    className: "res-icon rounded-xl w-full h-[250px]  mb-3 object-cover",
                    src: (0, $df6b3e332a139c88$export$bcede3532aa4b7f7) + cloudinaryImageId,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: "res-name text-xl font-bold  text-ellipsis whitespace-nowrap  overflow-hidden",
                children: name
            }),
            /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                className: "res-rating flex  items-center ",
                children: [
                    /*#__PURE__*/ (0, $kZF3u.jsx)("span", {
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                            src: (0, $df6b3e332a139c88$export$4cb72355748c04dd),
                            className: "w-5 "
                        })
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("span", {
                        className: "rating mr-4 ml-1",
                        children: avgRatingString
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsxs)("span", {
                        className: "  ",
                        children: [
                            " ",
                            sla.slaString
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: "res-cusine text-[#02060c60] dark:text-[#dedede] duration-100 text-ellipsis whitespace-nowrap  overflow-hidden ",
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                className: "res-location text-[#02060c60] dark:text-[#dedede] duration-100 ",
                children: [
                    areaName,
                    " "
                ]
            })
        ]
    });
};
var $2c7220131b1ebb76$export$e707e773b106c157 = function(Card) {
    return function(props) {
        return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
            className: "relative ",
            children: [
                /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "w-10 absolute z-20 m-4 right-0 shadow-lg  ",
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                        src: (0, $df6b3e332a139c88$export$f89a830e1c49df8f),
                        alt: "veg",
                        className: ""
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)(Card, (0, $29c5440143c029da$export$581ff339ea0ba762)({}, props))
            ]
        });
    };
};
var $2c7220131b1ebb76$export$2e2bcd8739ae039 = $2c7220131b1ebb76$var$Card;



var $lcrTp = parcelRequire("lcrTp");

var $kZF3u = parcelRequire("kZF3u");
var $e15e80a816a839ce$export$809644b82cfe94b1 = function() {
    var arrOfCards = [];
    for(var i = 0; i < 16; i++)arrOfCards.push(/*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        class: "w-80 animate-pulse h-[378px]",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                class: "w-full h-64 bg-gray-300 rounded-lg dark:bg-gray-600"
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("h1", {
                class: "w-56 h-2 mt-4 bg-gray-200 rounded-lg dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("p", {
                class: "w-24 h-2 mt-4 bg-gray-200 rounded-lg dark:bg-gray-700"
            })
        ]
    }));
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        className: " mx-auto p-3 ",
        children: /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
            className: "Cardcontainer grid grid-cols-[repeat(auto-fit,_minmax(310px,_1fr))] gap-6 justify-items-center items-center  ",
            children: arrOfCards
        })
    });
};





var $kZF3u = parcelRequire("kZF3u");
var $4192f4539d43e997$var$Offline = function() {
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        children: "Oops no internet"
    });
};
var $4192f4539d43e997$export$2e2bcd8739ae039 = $4192f4539d43e997$var$Offline;



var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");


var $3tDj3 = parcelRequire("3tDj3");


var $lcrTp = parcelRequire("lcrTp");

var $6a504aa8891277a5$export$545a45b8c6148dec = [
    {
        info: {
            id: "570170",
            name: "Gianis - Ice Cream, Shakes & Sundaes",
            cloudinaryImageId: "2365e2117e199c2b9a2cfa643c31b05c",
            locality: "Charmwood Village",
            areaName: "Charmwood Village",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Ice Cream",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.6,
            veg: true,
            parentId: "427371",
            avgRatingString: "4.6",
            totalRatingsString: "100+",
            promoted: true,
            adTrackingId: "cid=11367948~p=3~eid=0000018d-e6da-9519-7de6-c9bc005a035a~srvts=1708975101209~45995",
            sla: {
                deliveryTime: 37,
                lastMileTravel: 3.7,
                serviceability: "SERVICEABLE",
                slaString: "35-40 mins",
                lastMileTravelString: "3.7 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    description: "",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {},
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=570170",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "543889",
            name: "Kwality Walls Frozen Dessert and Ice Cream Shop",
            cloudinaryImageId: "erypfb2cluupyteh91id",
            locality: "Sarita Vihar",
            areaName: "Badarpur",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Desserts",
                "Ice Cream",
                "Ice Cream Cakes"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "582",
            avgRatingString: "4.4",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 36,
                lastMileTravel: 4,
                serviceability: "SERVICEABLE",
                slaString: "35-40 mins",
                lastMileTravelString: "4.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:30:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=543889",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "655871",
            name: "Big Bowl",
            cloudinaryImageId: "c99751d54e4e1847186c62b3309c1327",
            locality: "KALKAJI",
            areaName: "Badarpur Metro Station",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "North Indian",
                "Chinese",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4,
            parentId: "434792",
            avgRatingString: "4.0",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 2.9,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "2.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=655871",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "574330",
            name: "NOTO - Ice Creams & Desserts",
            cloudinaryImageId: "81ac87e5c89c16adc867be38ce5a1ba3",
            locality: "Sector 4",
            areaName: "Madangir",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Ice Cream",
                "Desserts"
            ],
            avgRating: 4.3,
            veg: true,
            parentId: "468478",
            avgRatingString: "4.3",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 33,
                lastMileTravel: 9.9,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "9.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "brand",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    description: "",
                                    shortDescription: "brand",
                                    fontColor: "#7E808C"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=574330",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "39265",
            name: "KFC",
            cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
            locality: "Crown Interiorz Mall",
            areaName: "Sector 35",
            costForTwo: "\u20B9450 for two",
            cuisines: [
                "Burgers",
                "Biryani",
                "American",
                "Snacks",
                "Fast Food"
            ],
            avgRating: 4.1,
            parentId: "547",
            avgRatingString: "4.1",
            totalRatingsString: "5K+",
            sla: {
                deliveryTime: 49,
                lastMileTravel: 6.2,
                serviceability: "SERVICEABLE",
                slaString: "45-50 mins",
                lastMileTravelString: "6.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 03:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {},
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=39265",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "655870",
            name: "Chinese Wok",
            cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
            locality: "KALKAJI",
            areaName: "Badarpur Metro Station",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Chinese",
                "Asian",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4,
            parentId: "61955",
            avgRatingString: "4.0",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 2.9,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "2.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=655870",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "736173",
            name: "Olio - The Wood Fired Pizzeria",
            cloudinaryImageId: "7e651e00dbf998af59ae7c5e3296c982",
            locality: "Neelam Bata Chowk",
            areaName: "Sector 31",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Pizzas",
                "Pastas",
                "Fast Food",
                "Snacks",
                "Beverages"
            ],
            avgRating: 4.3,
            parentId: "11633",
            avgRatingString: "4.3",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 51,
                lastMileTravel: 9.2,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "9.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ],
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    description: "",
                                    shortDescription: "options available",
                                    fontColor: "#7E808C"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9179"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=736173",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "342847",
            name: "Aromas Of Biryani",
            cloudinaryImageId: "szsru4s2q7tcm2psvjqy",
            locality: "Huda Market",
            areaName: "Sector 37",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Biryani",
                "Beverages"
            ],
            avgRating: 4.3,
            parentId: "36155",
            avgRatingString: "4.3",
            totalRatingsString: "20+",
            sla: {
                deliveryTime: 51,
                lastMileTravel: 4.9,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "4.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "20% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=342847",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "327586",
            name: "Delights by INOX",
            cloudinaryImageId: "b857fcf611707fedd3773eb02688f925",
            locality: "Interiorz Mall",
            areaName: "Sector 35",
            costForTwo: "\u20B9400 for two",
            cuisines: [
                "Fast Food",
                "Biryani"
            ],
            avgRating: 2.5,
            veg: true,
            parentId: "385095",
            avgRatingString: "2.5",
            totalRatingsString: "10+",
            sla: {
                deliveryTime: 54,
                lastMileTravel: 6.3,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "6.3 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    imageId: "v1695133679/badges/Pure_Veg111.png",
                                    description: "pureveg"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=327586",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "729306",
            name: "Baap Of rolls",
            cloudinaryImageId: "76ec5cd6480589bec2976d76eb68180c",
            locality: "Gautam Budh Nagar",
            areaName: "Badarpur Border",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Fast Food",
                "Beverages"
            ],
            avgRating: 3.8,
            parentId: "14310",
            avgRatingString: "3.8",
            totalRatingsString: "50+",
            sla: {
                deliveryTime: 47,
                lastMileTravel: 3,
                serviceability: "SERVICEABLE",
                slaString: "45-50 mins",
                lastMileTravelString: "3.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=729306",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "655872",
            name: "The Momo Co.",
            cloudinaryImageId: "9668a5819fcba35364dcff30d5f5cfbb",
            locality: "KALKAJI",
            areaName: "Badarpur Metro Station",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Chinese",
                "Asian",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4,
            parentId: "11442",
            avgRatingString: "4.0",
            totalRatingsString: "50+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 2.9,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "2.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=655872",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "447688",
            name: "Chicago Pizza",
            cloudinaryImageId: "z7vplkcpx1l3bfivhtqb",
            locality: "Green Fields Colony",
            areaName: "Green Fields Colony",
            costForTwo: "\u20B9350 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Beverages"
            ],
            avgRating: 4,
            parentId: "60277",
            avgRatingString: "4.0",
            totalRatingsString: "1K+",
            sla: {
                deliveryTime: 48,
                lastMileTravel: 7.2,
                serviceability: "SERVICEABLE",
                slaString: "45-50 mins",
                lastMileTravelString: "7.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 04:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=447688",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "622927",
            name: "The Dessert Heaven - Pure Veg",
            cloudinaryImageId: "bca418d5554239d48ac1f8ba84a42d79",
            locality: "Sector 31",
            areaName: "Inder Colony",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Bakery",
                "Desserts",
                "Sweets",
                "Ice Cream"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "350292",
            avgRatingString: "4.4",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 54,
                lastMileTravel: 9.2,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "9.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    shortDescription: "options available",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=622927",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "775707",
            name: "RollsKing",
            cloudinaryImageId: "35662624fc589e6ab075b6af6dbb65d1",
            locality: "Greenfields_FBD",
            areaName: "Greenfields_FBD",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Fast Food",
                "Rolls & Wraps",
                "North Indian",
                "Snacks"
            ],
            avgRating: 4.3,
            parentId: "4697",
            avgRatingString: "4.3",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 3.7,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "3.7 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            isNewlyOnboarded: true,
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=775707",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "622931",
            name: "Cheesecakes By CakeZone",
            cloudinaryImageId: "76d5f4055f9d5796bc7b72dfba8bd92b",
            locality: "Sector 31",
            areaName: "Inder Colony",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Bakery",
                "Desserts"
            ],
            avgRating: 3.9,
            veg: true,
            parentId: "348057",
            avgRatingString: "3.9",
            totalRatingsString: "50+",
            sla: {
                deliveryTime: 53,
                lastMileTravel: 9.2,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "9.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    imageId: "newg.png",
                                    description: "Gourmet"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B9125 OFF",
                subHeader: "ABOVE \u20B9399",
                discountTag: "FLAT DEAL"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=622931",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "733025",
            name: "The Belgian Waffle Co.",
            cloudinaryImageId: "5116a385bac0548e06c33c08350fbf11",
            locality: "ASHOKA ENCLAVE",
            areaName: "CROWN INTERIOR MALL",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Waffle",
                "Desserts",
                "Ice Cream"
            ],
            avgRating: 4.6,
            veg: true,
            parentId: "2233",
            avgRatingString: "4.6",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 7.1,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "7.1 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 03:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {},
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=733025",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    }
];
var $6a504aa8891277a5$export$6f49b4016bfc8d56 = {
    statusCode: 0,
    data: {
        statusMessage: "done successfully",
        cards: [
            {
                groupedCard: {
                    cardGroupMap: {
                        REGULAR: {
                            cards: [
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                            badges: {},
                                            vegOnlyDetails: {
                                                imageId: "AutoVegOnly_qkjowj",
                                                title: "Showing only vegetarian options.",
                                                description: "Tap on the VEG ONLY button to turn off the setting"
                                            },
                                            topRatedFilter: {},
                                            kidsCategoryFilter: {
                                                attributes: {
                                                    displayText: "Kids Favourites",
                                                    tooltip: {
                                                        enabled: true,
                                                        displayText: "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                                    }
                                                }
                                            },
                                            vegFilter: {
                                                attributes: {
                                                    displayText: "VEG"
                                                }
                                            },
                                            nonvegFilter: {
                                                attributes: {
                                                    displayText: "NONVEG"
                                                }
                                            }
                                        },
                                        relevance: {
                                            type: "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                                            sectionId: "MENU_FILTER_TOGGLE"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                                            title: "Top Picks",
                                            carousel: [
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814328",
                                                    creativeId: "TopPicks/24054943B.png",
                                                    title: "Chicken Shawarma",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "24054943",
                                                            name: "Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                                                            imageId: "whobcsb2vwalztixhopi",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203095",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203096",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814329",
                                                    creativeId: "TopPicks/24054946B.png",
                                                    title: "Chicken Momos (8 Pieces)",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "24054946",
                                                            name: "Chicken Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "50 ml | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "rqztsxexf4uhepjpwfm6",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203107",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Recommended",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054943",
                                                            name: "Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                                                            imageId: "whobcsb2vwalztixhopi",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203095",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203096",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "2923 ratings",
                                                                    ratingCountV2: "2923"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211921",
                                                            name: "Creamy Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add on cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            imageId: "fb2tuglzzfa6obm7d6cs",
                                                            inStock: 1,
                                                            price: 16900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203092",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203106",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "489 ratings",
                                                                    ratingCountV2: "489"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054944",
                                                            name: "Roasted Chicken Shawarma Bowl",
                                                            category: "Shawarma",
                                                            description: "50 ml | Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and put in a microwave safe bowl and served fresh to our beloved customers.",
                                                            imageId: "ow3qpjqq51rxzcv1klkb",
                                                            inStock: 1,
                                                            price: 26900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203097",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203098",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "492 ratings",
                                                                    ratingCountV2: "492"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "33883619",
                                                            name: "Paneer Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine.",
                                                            imageId: "47876777e4c1f5a567e1a439304600e3",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203101",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203102",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and mint sauce",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "371 ratings",
                                                                    ratingCountV2: "371"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054946",
                                                            name: "Chicken Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "50 ml | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "rqztsxexf4uhepjpwfm6",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203107",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "1454 ratings",
                                                                    ratingCountV2: "1454"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "130267359",
                                                            name: "Cheese Corn Momos ( Newly Added )",
                                                            category: "Momos",
                                                            description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos qsr chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "272cb272dc392196faf2e343425cf6f5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "127592292",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123277941",
                                                            name: "Kurkure Paneer Momos (8 Pieces)",
                                                            category: "Kurkure, Chinese & Indian Fusion",
                                                            description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                            imageId: "734063890947eed2463996c6d4ec3268",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106473894",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "18 ratings",
                                                                    ratingCountV2: "18"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123277940",
                                                            name: "Chicken Tangdi Fry (2 Pieces)",
                                                            category: "Kurkure, Chinese & Indian Fusion",
                                                            description: "Crispy ",
                                                            imageId: "0d82c121cd2643716ce05e96f1c4698f",
                                                            inStock: 1,
                                                            price: 21900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054948",
                                                            name: "Mineral Water (1 L)",
                                                            category: "Beverages",
                                                            description: "Serves 1 | Bisleri or. Kinley",
                                                            imageId: "e1gzxr4vc6rodmebeofq",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 3500,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "102 ratings",
                                                                    ratingCountV2: "102"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ],
                                            type: "CATEGORY_TYPE_RECOMMENDED"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Shawarma",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054943",
                                                            name: "Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                                                            imageId: "whobcsb2vwalztixhopi",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203095",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203096",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "2923 ratings",
                                                                    ratingCountV2: "2923"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211921",
                                                            name: "Creamy Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add on cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            imageId: "fb2tuglzzfa6obm7d6cs",
                                                            inStock: 1,
                                                            price: 16900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203092",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203106",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "489 ratings",
                                                                    ratingCountV2: "489"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054944",
                                                            name: "Roasted Chicken Shawarma Bowl",
                                                            category: "Shawarma",
                                                            description: "Medium Spicy | With Bone | 50 ml | Serves 1 | Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and put in a microwave safe bowl and served fresh to our beloved customers.",
                                                            imageId: "ow3qpjqq51rxzcv1klkb",
                                                            inStock: 1,
                                                            price: 26900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203097",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203098",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "492 ratings",
                                                                    ratingCountV2: "492"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211923",
                                                            name: "Creamy Roasted Chicken Shawarma Bowl",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add in cream and put in a microwave safe bowl and served fresh.",
                                                            imageId: "a01b7b506c94dab1493011b1cd3335b8",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203099",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203100",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "92 ratings",
                                                                    ratingCountV2: "92"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270735",
                                                            name: "Chicken Shawarma Roll + Roasted Shawarma Bowl ** Save Rs.30 Extra",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            inStock: 1,
                                                            price: 37900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106459174",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "33883619",
                                                            name: "Paneer Shawarma",
                                                            category: "Shawarma",
                                                            description: "Medium Spicy | Comes with Served with mayonnaise and mint sauce | Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine.",
                                                            imageId: "47876777e4c1f5a567e1a439304600e3",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203101",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203102",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and mint sauce",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "371 ratings",
                                                                    ratingCountV2: "371"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211924",
                                                            name: "Creamy Paneer Shawarma",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine. Just try it out & appreciate the chef's skills.",
                                                            imageId: "47876777e4c1f5a567e1a439304600e3",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203105",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203104",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.6",
                                                                    ratingCount: "74 ratings",
                                                                    ratingCountV2: "74"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270733",
                                                            name: "Chicken Shawarma [ Super Saver Box ]",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            price: 26900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "31395427",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "Box Of 2 [ Save Rs.10 Extra ]",
                                                                                default: 1,
                                                                                id: "97251713",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 3 [ Save Rs.30 Extra ]",
                                                                                price: 12000,
                                                                                id: "97251714",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 4 [ Save Rs.50 Extra ]",
                                                                                price: 24000,
                                                                                id: "97251715",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 5 [ Save Rs.70 Extra ]",
                                                                                price: 36000,
                                                                                id: "97251716",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 10 [ Save Rs.200 Extra ]",
                                                                                price: 93000,
                                                                                id: "97251717",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106459172",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "106465569",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "98089557",
                                                                            name: "Extra Spicy Fillings",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 1,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            nextAvailableAtMessage: "Next available at 4:58 pm, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270734",
                                                            name: "Creamy Chicken Shawarma [ Super Saver Box ]",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarma are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo, some veggies, cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            price: 30900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "31395428",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "Box Of 2 [ Save Rs.30 Extra ]",
                                                                                default: 1,
                                                                                id: "97251718",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 3 [ Save Rs.50 Extra ]",
                                                                                price: 14000,
                                                                                id: "97251719",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 4 [ Save Rs.70 Extra ]",
                                                                                price: 28000,
                                                                                id: "97251720",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 5 [ Save Rs.100 Extra ]",
                                                                                price: 41000,
                                                                                id: "97251721",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106465570",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "98089557",
                                                                            name: "Extra Spicy Fillings",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 1,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "106459173",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Momos",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054946",
                                                            name: "Chicken Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "Medium Spicy | Comes with Served with mayonnaise and red chilli sauce | 50 ml | Serves 1 | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "rqztsxexf4uhepjpwfm6",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203107",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "1454 ratings",
                                                                    ratingCountV2: "1454"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054945",
                                                            name: "Paneer Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "Medium Spicy | Comes with Served with mayonnaise and red chilli sauce | 50 ml | Serves 1 | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and soft paneer pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "oifv5eatmljnshmmyjpd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203108",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "472 ratings",
                                                                    ratingCountV2: "472"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "130267359",
                                                            name: "Cheese Corn Momos ( Newly Added )",
                                                            category: "Momos",
                                                            description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos qsr chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "272cb272dc392196faf2e343425cf6f5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "127592292",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Kurkure, Chinese & Indian Fusion",
                                            categories: [
                                                {
                                                    title: "Kurkure",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270791",
                                                                    name: "Kurkure Chicken Shawarma",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This newly added shawarma in our menu is a fusion of lebanese and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot, rolled and served fresh and hot to our beloved customers.",
                                                                    imageId: "3f6b5a81b57213aeb0758590ad62a2e7",
                                                                    inStock: 1,
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106459176",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "16 ratings",
                                                                            ratingCountV2: "16"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270792",
                                                                    name: "Kurkure Chicken Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                                    imageId: "f31815d1558ff35607a3a83ce0d9b40a",
                                                                    inStock: 1,
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106459177",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {
                                                                        text: "Bestseller",
                                                                        textColor: "#ffffff",
                                                                        topBackgroundColor: "#d53d4c",
                                                                        bottomBackgroundColor: "#b02331"
                                                                    },
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    isBestseller: true,
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.5",
                                                                            ratingCount: "37 ratings",
                                                                            ratingCountV2: "37"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123277941",
                                                                    name: "Kurkure Paneer Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                                    imageId: "734063890947eed2463996c6d4ec3268",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106473894",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "18 ratings",
                                                                            ratingCountV2: "18"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "130267360",
                                                                    name: "Kurkure Cheese Corn Momos (new Launch)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "127592293",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270790",
                                                                    name: "Kurkure Leg (2 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering dishes since then and has become 2nd largest shawarma chain in north india. This newly added kurkure leg piece in our menu is a fusion of different cuisines. Inside, it's juicy tender chicken but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106459175",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    title: "Chinese",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270794",
                                                                    name: "Chicken Chilli Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270796",
                                                                    name: "Paneer Chilli Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270799",
                                                                    name: "Chicken 65 Dry (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.0",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270801",
                                                                    name: "Chilli Chicken Boneless Thigh (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    price: 32900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.4",
                                                                            ratingCount: "5 ratings",
                                                                            ratingCountV2: "5"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    title: "Fried",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123277940",
                                                                    name: "Chicken Tangdi Fry (2 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Crispy ",
                                                                    imageId: "0d82c121cd2643716ce05e96f1c4698f",
                                                                    inStock: 1,
                                                                    price: 21900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "9 ratings",
                                                                            ratingCountV2: "9"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270809",
                                                                    name: "Chicken Lollipop Fry (4 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Crispy",
                                                                    imageId: "59695d3e4cca656d5fdc5f577afcc03c",
                                                                    inStock: 1,
                                                                    price: 21900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.7",
                                                                            ratingCount: "31 ratings",
                                                                            ratingCountV2: "31"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Beverages",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054947",
                                                            name: "Coke (750 Ml)",
                                                            category: "Beverages",
                                                            description: "Serves 1 | Served cold",
                                                            imageId: "iry5fu453gvnzexxnwu9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 8900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "394 ratings",
                                                                    ratingCountV2: "394"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054948",
                                                            name: "Mineral Water (1 L)",
                                                            category: "Beverages",
                                                            description: "Serves 1 | Bisleri or. Kinley",
                                                            imageId: "e1gzxr4vc6rodmebeofq",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 3500,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "102 ratings",
                                                                    ratingCountV2: "102"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Biryani",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490562",
                                                            name: "Chicken Dum Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "ugchcdpg05ivuametha2",
                                                            price: 11900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494729",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Gm | (3 Pcs Wings Or Boneless)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465613",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Gm | (5-6 Pcs Wings Or Boneless Pcs)",
                                                                                price: 12600,
                                                                                id: "14465614",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (9-10 Pcs Wings Or Boneless)",
                                                                                price: 26000,
                                                                                id: "14465615",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with mint curd chutney & spicy tomato chutney",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.4",
                                                                    ratingCount: "1687 ratings",
                                                                    ratingCountV2: "1687"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490556",
                                                            name: "Chicken Leg Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "vzxgkbawopprfnhddtkk",
                                                            price: 12500,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494727",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Grams | (1 Leg Piece + Some Boneless Or Wings)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465607",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Grams | (2 Leg Pieces + Some Boneless Or Wings)",
                                                                                price: 13400,
                                                                                id: "14465608",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (4 Leg Pieces + Some Boneless Or Wings)",
                                                                                price: 27400,
                                                                                id: "14465609",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with mint curd chutney & spicy tomato chutney",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "1151 ratings",
                                                                    ratingCountV2: "1151"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490555",
                                                            name: "Chicken Thigh Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "fo6gm5nvjqwshcznoyjk",
                                                            price: 13500,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494726",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Grams | (1 Thigh Piece + Boneless Or Wings)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465604",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Grams | (2 Thigh Pieces + Some Boneless Or Wings)",
                                                                                price: 14000,
                                                                                id: "14465605",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (4 Thigh Pieces + Some Boneless Or Wings)",
                                                                                price: 34400,
                                                                                id: "14465606",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "517 ratings",
                                                                    ratingCountV2: "517"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490560",
                                                            name: "Boneless Chicken Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Boneless | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "jlvokk4v2bofhxbzqacs",
                                                            price: 12500,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494728",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Gm | (3 Pcs Boneless)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465610",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Gm | (5-6 Pcs Boneless)",
                                                                                price: 13400,
                                                                                id: "14465611",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (9-10 Pcs Boneless)",
                                                                                price: 29400,
                                                                                id: "14465612",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with mint curd chutney & spicy tomato chutney",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "873 ratings",
                                                                    ratingCountV2: "873"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270736",
                                                            name: "Boiled Boneless Chicken Breast ( Gym Diet )",
                                                            category: "Biryani",
                                                            description: "It is mainly for fitness enthusiasts and gym goers so please don't expect flavourful taste or aroma of signature spices of uncle chicken. It is boiled along with dum biryani so sometimes a little natural food colour may also be present but rest assured, nothing extra would be present not even salt. Just pure tender chicken breast.",
                                                            imageId: "thjhcqbnjjtlozzbod8u",
                                                            price: 24900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "31395429",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "200 Gms",
                                                                                default: 1,
                                                                                id: "97251722",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "400 Gms [ Save Rs.40 Extra ]",
                                                                                price: 21100,
                                                                                id: "97251723",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                            type: "FSSAI",
                                            imageId: "fssai_final_edss9i",
                                            text: [
                                                "License No. 20818003000369"
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                            name: "Uncle Chicken - Shawarma, Biryani & Momos",
                                            area: "Sector 14",
                                            completeAddress: "Shop No. 165, Huda Market Maharishi Parashar Marg, Sector 14 Faridabad, Haryana, 121007"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        ],
        firstOffsetRequest: true,
        isQCLink: false
    },
    tid: "3e45fb63-b7f2-4d01-9691-275ef61e28c5",
    sid: "cj92ea31-6ce9-4e9b-84c5-807d086719a9",
    deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
    csrfToken: "Z42msBkwELWD-99dLS0tCskhkPNN1qqd2Widzx08"
};
var $6a504aa8891277a5$export$52daddf863f66fd0 = {
    statusCode: 0,
    data: {
        statusMessage: "done successfully",
        pageOffset: {
            nextOffset: "COVCELQ4KICgsd224q7FZDCnEzgE",
            widgetOffset: {
                NewListingView_category_bar_chicletranking_TwoRows: "",
                NewListingView_category_bar_chicletranking_TwoRows_Rendition: "",
                Restaurant_Group_WebView_SEO_PB_Theme: "",
                collectionV5RestaurantListWidget_SimRestoRelevance_food_seo: "10",
                inlineFacetFilter: "",
                restaurantCountWidget: ""
            }
        },
        cards: [
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        header: {
                            title: "What's on your mind?",
                            headerStyling: {
                                padding: {
                                    left: 16,
                                    top: 16,
                                    bottom: 4
                                }
                            }
                        },
                        layout: {
                            rows: 1,
                            columns: 10,
                            horizontalScrollEnabled: true,
                            itemSpacing: 24,
                            widgetPadding: {},
                            containerStyle: {
                                containerPadding: {
                                    left: 8,
                                    top: 8,
                                    right: 12,
                                    bottom: 4
                                }
                            },
                            scrollBar: {},
                            widgetTheme: {
                                defaultMode: {
                                    backgroundColour: "#FFFFFF",
                                    theme: "THEME_TYPE_LIGHT"
                                },
                                darkMode: {
                                    theme: "THEME_TYPE_DARK"
                                }
                            }
                        },
                        imageGridCards: {
                            info: [
                                {
                                    id: "762797",
                                    imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                        text: "Burgers",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for burger",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750580",
                                    imageId: "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                        text: "pizzas",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for pizza",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750597",
                                    imageId: "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                                        text: "Ice Cream",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for icecream",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750582",
                                    imageId: "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83645?collection_id=83645&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                                        text: "North Indian",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for north indian",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian&search_context=northindian",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750223",
                                    imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                                        text: "Rolls",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for roll",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750592",
                                    imageId: "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                        text: "Biryani",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for biryani",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750588",
                                    imageId: "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                                        text: "Chinese",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for chinese",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750584",
                                    imageId: "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                        text: "South Indian",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for south indian",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "749769",
                                    imageId: "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2",
                                        text: "Momos",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for momos",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "749774",
                                    imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                        text: "Noodles",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for noodles",
                                        altTextCta: "open"
                                    },
                                    entityId: "80464",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "749874",
                                    imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                                        text: "Cakes",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for cakes",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750207",
                                    imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                                        text: "Pasta",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for pasta",
                                        altTextCta: "open"
                                    },
                                    entityId: "80480",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750217",
                                    imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
                                        text: "Pav Bhaji",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for pav bhaji",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750636",
                                    imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                                        text: "Kebabs",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for kebabs",
                                        altTextCta: "open"
                                    },
                                    entityId: "80452",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750203",
                                    imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                                        text: "Paratha",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for paratha",
                                        altTextCta: "open"
                                    },
                                    entityId: "80476",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750226",
                                    imageId: "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80395?collection_id=80395&tags=layout_CCS_Salad&type=rcv2",
                                        text: "Salad",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for salad",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=80395&tags=layout_CCS_Salad",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750593",
                                    imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Gulab_Jamun.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80432?collection_id=80432&tags=layout_BAU_Contextual%2Cgulab_jamun&type=rcv2",
                                        text: "Gulab Jamun",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for gulab jamun",
                                        altTextCta: "open"
                                    },
                                    entityId: "80432",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750209",
                                    imageId: "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80358?collection_id=80358&tags=layout_BAU_Contextual%2Clayout_ux4&type=rcv2",
                                        text: "Pastry",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for Pastry",
                                        altTextCta: "open"
                                    },
                                    entityId: "80358",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750235",
                                    imageId: "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
                                        text: "Sandwich",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for sandwich",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750239",
                                    imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                                        text: "Shake",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for shakes",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                                    frequencyCapping: {}
                                }
                            ],
                            style: {
                                width: {
                                    type: "TYPE_RELATIVE",
                                    value: 0.2941,
                                    reference: "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                },
                                height: {
                                    type: "TYPE_RELATIVE",
                                    value: 1.2444,
                                    reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                }
                            }
                        },
                        id: "whats_on_your_mind",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                                info: [
                                    {
                                        id: "762797",
                                        imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                            text: "Burgers",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for burger",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750580",
                                        imageId: "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                            text: "pizzas",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for pizza",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750597",
                                        imageId: "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                                            text: "Ice Cream",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for icecream",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750582",
                                        imageId: "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83645?collection_id=83645&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                                            text: "North Indian",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for north indian",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian&search_context=northindian",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750223",
                                        imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                                            text: "Rolls",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for roll",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750592",
                                        imageId: "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                            text: "Biryani",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for biryani",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750588",
                                        imageId: "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                                            text: "Chinese",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for chinese",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750584",
                                        imageId: "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                            text: "South Indian",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for south indian",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "749769",
                                        imageId: "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2",
                                            text: "Momos",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for momos",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "749774",
                                        imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                            text: "Noodles",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for noodles",
                                            altTextCta: "open"
                                        },
                                        entityId: "80464",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "749874",
                                        imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                                            text: "Cakes",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for cakes",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750207",
                                        imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                                            text: "Pasta",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for pasta",
                                            altTextCta: "open"
                                        },
                                        entityId: "80480",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750217",
                                        imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
                                            text: "Pav Bhaji",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for pav bhaji",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750636",
                                        imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                                            text: "Kebabs",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for kebabs",
                                            altTextCta: "open"
                                        },
                                        entityId: "80452",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750203",
                                        imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                                            text: "Paratha",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for paratha",
                                            altTextCta: "open"
                                        },
                                        entityId: "80476",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750226",
                                        imageId: "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80395?collection_id=80395&tags=layout_CCS_Salad&type=rcv2",
                                            text: "Salad",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for salad",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=80395&tags=layout_CCS_Salad",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750593",
                                        imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Gulab_Jamun.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80432?collection_id=80432&tags=layout_BAU_Contextual%2Cgulab_jamun&type=rcv2",
                                            text: "Gulab Jamun",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for gulab jamun",
                                            altTextCta: "open"
                                        },
                                        entityId: "80432",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750209",
                                        imageId: "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80358?collection_id=80358&tags=layout_BAU_Contextual%2Clayout_ux4&type=rcv2",
                                            text: "Pastry",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for Pastry",
                                            altTextCta: "open"
                                        },
                                        entityId: "80358",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750235",
                                        imageId: "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
                                            text: "Sandwich",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for sandwich",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750239",
                                        imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                                            text: "Shake",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for shakes",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                                        frequencyCapping: {}
                                    }
                                ],
                                style: {
                                    width: {
                                        type: "TYPE_RELATIVE",
                                        value: 0.2941,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                    },
                                    height: {
                                        type: "TYPE_RELATIVE",
                                        value: 1.2444,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        header: {
                            title: "Top restaurant chains in Faridabad",
                            action: {},
                            headerStyling: {
                                padding: {
                                    left: 16,
                                    top: 28,
                                    bottom: 18
                                }
                            }
                        },
                        layout: {
                            rows: 1,
                            columns: 20,
                            horizontalScrollEnabled: true,
                            itemSpacing: 32,
                            widgetPadding: {},
                            containerStyle: {
                                containerPadding: {
                                    left: 16,
                                    right: 12,
                                    bottom: 12
                                }
                            },
                            scrollBar: {
                                scrollThumbColor: "#E46D47",
                                scrollTrackColor: "#02060C",
                                width: 54,
                                height: 4,
                                scrollStyling: {
                                    padding: {
                                        top: 6,
                                        bottom: 24
                                    }
                                }
                            },
                            widgetTheme: {
                                defaultMode: {
                                    backgroundColour: "#1B3028",
                                    theme: "THEME_TYPE_DARK"
                                },
                                darkMode: {
                                    backgroundColour: "#1B3028",
                                    theme: "THEME_TYPE_DARK"
                                }
                            }
                        },
                        id: "top_brands_for_you",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                restaurants: [
                                    {
                                        info: {
                                            id: "21986",
                                            name: "Dark Brown",
                                            cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Italian-American",
                                                "Continental",
                                                "Burgers",
                                                "Pizzas",
                                                "Pastas",
                                                "Chinese",
                                                "Beverages",
                                                "Salads",
                                                "Asian",
                                                "Healthy Food",
                                                "Fast Food",
                                                "Chaat",
                                                "Snacks",
                                                "Desserts",
                                                "American",
                                                "Italian",
                                                "Momos",
                                                "Rolls & Wraps",
                                                "Cafe"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "16162",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.8,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.8 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9100 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL",
                                                discountCalloutInfo: {
                                                    message: "Free Delivery",
                                                    logoCtx: {
                                                        logo: "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/dark-brown-shopping-centre-market-sector-15-faridabad-21986",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "253728",
                                            name: "McDonald's",
                                            cloudinaryImageId: "535fc9f9c135f7982317bbb6a64a1ffc",
                                            locality: "Crown Plaza Mall",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "American"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "630",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 29,
                                                lastMileTravel: 1.7,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.7 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:15:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Burger.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "50% OFF",
                                                subHeader: "UPTO \u20B980"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/mcdonalds-crown-plaza-mall-sector-15-faridabad-253728",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "207998",
                                            name: "Burger King",
                                            cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
                                            locality: "Eldeco Station 1 Mall",
                                            areaName: "Sector 12",
                                            costForTwo: "\u20B9350 for two",
                                            cuisines: [
                                                "Burgers",
                                                "American"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "166",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 26,
                                                lastMileTravel: 3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "3.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 05:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Burger.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/burger-king-eldeco-station-1-mall-sector-12-faridabad-207998",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "28805",
                                            name: "Domino's Pizza",
                                            cloudinaryImageId: "d0450ce1a6ba19ea60cd724471ed54a8",
                                            locality: "Town Park",
                                            areaName: "Sector 16",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Italian",
                                                "Pastas",
                                                "Desserts"
                                            ],
                                            avgRating: 3.9,
                                            parentId: "2456",
                                            avgRatingString: "3.9",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 30,
                                                lastMileTravel: 0.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "30 mins",
                                                lastMileTravelString: "0.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 02:55:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Pizza.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Pizza.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "30% OFF",
                                                subHeader: "UPTO \u20B975"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/dominos-pizza-town-park-sector-16-faridabad-28805",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "356223",
                                            name: "KFC",
                                            cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
                                            locality: "Sector-79",
                                            areaName: "Omaxe World Street",
                                            costForTwo: "\u20B9450 for two",
                                            cuisines: [
                                                "Burgers",
                                                "Biryani",
                                                "American",
                                                "Snacks",
                                                "Fast Food"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "547",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "5.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 02:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Burger.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9179"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/kfc-sector-79-omaxe-world-street-faridabad-356223",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "349817",
                                            name: "Pizza Hut",
                                            cloudinaryImageId: "2b4f62d606d1b2bfba9ba9e5386fabb7",
                                            locality: "Sector-79",
                                            areaName: "Omaxe World Street",
                                            costForTwo: "\u20B9350 for two",
                                            cuisines: [
                                                "Pizzas"
                                            ],
                                            avgRating: 3.7,
                                            parentId: "721",
                                            avgRatingString: "3.7",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 36,
                                                lastMileTravel: 5.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "35-40 mins",
                                                lastMileTravelString: "5.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "20% OFF",
                                                subHeader: "UPTO \u20B950"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/pizza-hut-sector-79-omaxe-world-street-faridabad-349817",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "518208",
                                            name: "Nirula's",
                                            cloudinaryImageId: "a66fa8f5befa65947d9e20f29a863ce0",
                                            locality: "Sector-15 Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9500 for two",
                                            cuisines: [
                                                "Ice Cream",
                                                "Pizzas",
                                                "Fast Food"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "1738",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 19,
                                                lastMileTravel: 2.1,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-20 mins",
                                                lastMileTravelString: "2.1 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:30:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            aggregatedDiscountInfoV2: {},
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/nirulas-market-sector-15-faridabad-518208",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "374000",
                                            name: "The Brooklyn Creamery - Healthy Ice Cream",
                                            cloudinaryImageId: "b1b35780a9b1dfeb26d680506d494eaa",
                                            locality: "Sector 16A",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9200 for two",
                                            cuisines: [
                                                "Desserts",
                                                "Ice Cream",
                                                "Healthy Food"
                                            ],
                                            avgRating: 4.3,
                                            veg: true,
                                            parentId: "236673",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 17,
                                                lastMileTravel: 1,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-20 mins",
                                                lastMileTravelString: "1.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "brand",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "brand"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/the-brooklyn-creamery-healthy-ice-cream-sector-16a-sector-19-faridabad-374000",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "206561",
                                            name: "House of Chow",
                                            cloudinaryImageId: "6e97ac8f5c89213610309ef1940afa05",
                                            locality: "Town Park",
                                            areaName: "Sector 12",
                                            costForTwo: "\u20B9300 for two",
                                            cuisines: [
                                                "Pan-Asian",
                                                "Chinese",
                                                "Thai",
                                                "Oriental"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "9064",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "5K+",
                                            sla: {
                                                deliveryTime: 28,
                                                lastMileTravel: 3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "3.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "C",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9125 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/house-of-chow-town-park-sector-12-faridabad-206561",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "56999",
                                            name: "La Pino'z Pizza",
                                            cloudinaryImageId: "mzb8tq7ccskyvadm9mt2",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 3.8,
                                            parentId: "4961",
                                            avgRatingString: "3.8",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 26,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 03:45:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9199"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/la-pinoz-pizza-shopping-centre-market-sector-15-faridabad-56999",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "170934",
                                            name: "Wow! Momo",
                                            cloudinaryImageId: "64fd45fd9f44c1737bc446e470bed666",
                                            locality: "Sector 15",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9300 for two",
                                            cuisines: [
                                                "Tibetan",
                                                "Healthy Food",
                                                "Asian",
                                                "Chinese",
                                                "Snacks",
                                                "Continental",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 3.9,
                                            parentId: "1776",
                                            avgRatingString: "3.9",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 24,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-25 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 02:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Chinese.png",
                                                        description: "Delivery!"
                                                    },
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Momos.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Chinese.png"
                                                                }
                                                            },
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Momos.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B999"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/wow-momo-sector-15-faridabad-170934",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "337231",
                                            name: "Biryani Blues",
                                            cloudinaryImageId: "97377e54937c079fe269d744aa66274a",
                                            locality: "Sector 79",
                                            areaName: "Sector 79",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Biryani",
                                                "Hyderabadi",
                                                "Lucknowi",
                                                "Kebabs"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "13813",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 29,
                                                lastMileTravel: 5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "5.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 04:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Biryani.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Biryani.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "50% OFF",
                                                subHeader: "UPTO \u20B995"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/biryani-blues-sector-79-faridabad-337231",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "156075",
                                            name: "The Good Bowl",
                                            cloudinaryImageId: "6e04be27387483a7c00444f8e8241108",
                                            locality: "Kapori colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Biryani",
                                                "North Indian",
                                                "Pastas",
                                                "Punjabi",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "7918",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 26,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9110"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/the-good-bowl-kapori-colony-sector-19-faridabad-156075",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39278",
                                            name: "Faasos - Wraps, Rolls & Shawarma",
                                            cloudinaryImageId: "af33b81798b11deba338e94b7585d348",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9200 for two",
                                            cuisines: [
                                                "Kebabs",
                                                "Fast Food",
                                                "Snacks",
                                                "American",
                                                "Healthy Food",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "21809",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9129"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/faasos-wraps-rolls-and-shawarma-kapori-colony-sector-19-faridabad-39278",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39279",
                                            name: "Behrouz Biryani",
                                            cloudinaryImageId: "a4ffed13eb197c6df43dfe1c756560e5",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9500 for two",
                                            cuisines: [
                                                "Biryani",
                                                "North Indian",
                                                "Kebabs",
                                                "Mughlai",
                                                "Beverages",
                                                "Desserts"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "1803",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "5K+",
                                            sla: {
                                                deliveryTime: 24,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-25 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Biryani.png",
                                                        description: "Delivery!"
                                                    },
                                                    {
                                                        imageId: "newg.png",
                                                        description: "Gourmet"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Biryani.png"
                                                                }
                                                            },
                                                            {
                                                                attributes: {
                                                                    description: "Gourmet",
                                                                    imageId: "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9125 OFF",
                                                subHeader: "ABOVE \u20B9199",
                                                discountTag: "FLAT DEAL"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/behrouz-biryani-kapori-colony-sector-19-faridabad-39279",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "62981",
                                            name: "LunchBox - Meals and Thalis",
                                            cloudinaryImageId: "4edcfc66d91018d69894941ebb3c8d16",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9200 for two",
                                            cuisines: [
                                                "Biryani",
                                                "North Indian",
                                                "Punjabi",
                                                "Healthy Food",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4,
                                            parentId: "4925",
                                            avgRatingString: "4.0",
                                            totalRatingsString: "5K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9159"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/lunchbox-meals-and-thalis-kapori-colony-sector-19-faridabad-62981",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39280",
                                            name: "Oven Story Pizza - Standout Toppings",
                                            cloudinaryImageId: "b39e4312ae2e9f65c3b58faaed83f488",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "3534",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 30,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "26-35 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9125 OFF",
                                                subHeader: "ABOVE \u20B9199",
                                                discountTag: "FLAT DEAL"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-kapori-colony-sector-19-faridabad-39280",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "263954",
                                            name: "Chai Point",
                                            cloudinaryImageId: "znobbbace3njt7oxau2f",
                                            locality: "Adb Pwd Colony",
                                            areaName: "Sector 16",
                                            costForTwo: "\u20B9150 for two",
                                            cuisines: [
                                                "Bakery",
                                                "Beverages",
                                                "Maharashtrian",
                                                "Snacks",
                                                "Street Food",
                                                "South Indian",
                                                "Punjabi",
                                                "Chaat",
                                                "Indian",
                                                "American",
                                                "Fast Food",
                                                "Desserts",
                                                "Cafe",
                                                "Healthy Food",
                                                "Home Food",
                                                "North Indian"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "1607",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 23,
                                                lastMileTravel: 0.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-25 mins",
                                                lastMileTravelString: "0.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-11 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chai-point-adb-pwd-colony-sector-16-faridabad-263954",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "353657",
                                            name: "Chaayos Chai+Snacks=Relax",
                                            cloudinaryImageId: "cace805a6ba74137571d0f7ac92302b1",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Bakery",
                                                "Beverages",
                                                "Chaat",
                                                "Desserts",
                                                "Home Food",
                                                "Italian",
                                                "Maharashtrian",
                                                "Snacks",
                                                "Street Food",
                                                "Sweets"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "281782",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 20,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-20 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-11 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chaayos-chai-snacks-relax-shopping-centre-market-sector-15-faridabad-353657",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39281",
                                            name: "Firangi Bake",
                                            cloudinaryImageId: "rbvv4z3539ntnlrfcwhs",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Mexican",
                                                "Healthy Food",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "3952",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9199"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/firangi-bake-kapori-colony-sector-19-faridabad-39281",
                                            type: "WEBLINK"
                                        }
                                    }
                                ],
                                theme: "Restaurant_Group_WebView_SEO_PB_Theme",
                                widgetType: "WIDGET_TYPE_POPULAR_BRANDS",
                                style: {
                                    width: {
                                        type: "TYPE_RELATIVE",
                                        value: 0.41111112,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                                    },
                                    height: {
                                        type: "TYPE_RELATIVE",
                                        value: 0.7027027,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    },
                                    layoutAlignment: "LAYOUT_ALIGNMENT_LEFT"
                                },
                                collectionId: "84124"
                            }
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
                        title: "Restaurants with online food delivery in Faridabad",
                        id: "popular_restaurants_title"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
                        sortConfigs: [
                            {
                                key: "relevance",
                                title: "Relevance (Default)",
                                selected: true,
                                defaultSelection: true
                            },
                            {
                                key: "deliveryTimeAsc",
                                title: "Delivery Time"
                            },
                            {
                                key: "modelBasedRatingDesc",
                                title: "Rating"
                            },
                            {
                                key: "costForTwoAsc",
                                title: "Cost: Low to High"
                            },
                            {
                                key: "costForTwoDesc",
                                title: "Cost: High to Low"
                            }
                        ],
                        restaurantCount: 490,
                        facetList: [
                            {
                                label: "Delivery Time",
                                id: "deliveryTime",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Fast Delivery",
                                        id: "deliveryTimefacetquery1",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                subLabel: "Filter by"
                            },
                            {
                                label: "Cuisines",
                                id: "catalog_cuisines",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Afghani",
                                        id: "query_afghani",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "American",
                                        id: "query_american",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Andhra",
                                        id: "query_andhra",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Arabian",
                                        id: "query_arabian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Asian",
                                        id: "query_asian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Awadhi",
                                        id: "query_awadhi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Bakery",
                                        id: "query_bakery",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Bangladeshi",
                                        id: "query_bangladeshi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Barbecue",
                                        id: "query_barbecue",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Bengali",
                                        id: "query_bengali",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Beverages",
                                        id: "query_beverages",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Biryani",
                                        id: "query_biryani",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "British",
                                        id: "query_british",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Burgers",
                                        id: "query_burgers",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Burmese",
                                        id: "query_burmese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Cafe",
                                        id: "query_cafe",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Cakes and Pastries",
                                        id: "query_cakes_and_pastries",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Chaat",
                                        id: "query_chaat",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Chettinad",
                                        id: "query_chettinad",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Chinese",
                                        id: "query_chinese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Coastal",
                                        id: "query_coastal",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Confectionery",
                                        id: "query_confectionery",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Continental",
                                        id: "query_continental",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Desserts",
                                        id: "query_desserts",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "European",
                                        id: "query_european",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Fast Food",
                                        id: "query_fast_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "French",
                                        id: "query_french",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Grill",
                                        id: "query_grill",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Healthy Food",
                                        id: "query_healthy_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Home Food",
                                        id: "query_home_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Hyderabadi",
                                        id: "query_hyderabadi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Ice Cream",
                                        id: "query_ice_cream",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Ice Cream Cakes",
                                        id: "query_ice_cream_cakes",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Indian",
                                        id: "query_indian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Italian",
                                        id: "query_italian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Italian-American",
                                        id: "query_italian-american",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Japanese",
                                        id: "query_japanese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Juices",
                                        id: "query_juices",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Kebabs",
                                        id: "query_kebabs",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Keto",
                                        id: "query_keto",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Lebanese",
                                        id: "query_lebanese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Lucknowi",
                                        id: "query_lucknowi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Maharashtrian",
                                        id: "query_maharashtrian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Meat",
                                        id: "query_meat",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Mexican",
                                        id: "query_mexican",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Momos",
                                        id: "query_momos",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Mughlai",
                                        id: "query_mughlai",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Navratri Special",
                                        id: "query_navratri_special",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Nepalese",
                                        id: "query_nepalese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "North Eastern",
                                        id: "query_north_eastern",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "North Indian",
                                        id: "query_north_indian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Oriental",
                                        id: "query_oriental",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Paan",
                                        id: "query_paan",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Pan-Asian",
                                        id: "query_pan-asian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Pastas",
                                        id: "query_pastas",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Pizzas",
                                        id: "query_pizzas",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Punjabi",
                                        id: "query_punjabi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Rolls & Wraps",
                                        id: "query_rolls_&_wraps",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Salads",
                                        id: "query_salads",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Seafood",
                                        id: "query_seafood",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Snacks",
                                        id: "query_snacks",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "South Indian",
                                        id: "query_south_indian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Street Food",
                                        id: "query_street_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Sweets",
                                        id: "query_sweets",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Tandoor",
                                        id: "query_tandoor",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Thai",
                                        id: "query_thai",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Thalis",
                                        id: "query_thalis",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Tibetan",
                                        id: "query_tibetan",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Waffle",
                                        id: "query_waffle",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "rolls",
                                        id: "query_rolls",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                canSearch: true,
                                subLabel: "Filter by cuisine",
                                openFilter: true
                            },
                            {
                                label: "Explore",
                                id: "explore",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "New on Swiggy",
                                        id: "newfacetquery1",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD"
                            },
                            {
                                label: "Ratings",
                                id: "rating",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Ratings 4.5+",
                                        id: "ratingfacetquery3",
                                        analytics: {}
                                    },
                                    {
                                        label: "Ratings 4.0+",
                                        id: "ratingfacetquery4",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Ratings 3.5+",
                                        id: "ratingfacetquery5",
                                        analytics: {}
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                subLabel: "Filter by"
                            },
                            {
                                label: "Veg/Non-Veg",
                                id: "isVeg",
                                selection: "SELECT_TYPE_SINGLESELECT",
                                facetInfo: [
                                    {
                                        label: "Pure Veg",
                                        id: "isVegfacetquery2",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Non Veg",
                                        id: "isVegfacetquery3",
                                        analytics: {}
                                    }
                                ],
                                viewType: "VIEW_TYPE_FLATTENED",
                                subLabel: "Filter by"
                            },
                            {
                                label: "Offers",
                                id: "restaurantOfferMultiTd",
                                selection: "SELECT_TYPE_SINGLESELECT",
                                facetInfo: [
                                    {
                                        label: "Offers",
                                        id: "restaurantOfferMultiTdfacetquery3",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_FLATTENED",
                                subLabel: "Restaurants with"
                            },
                            {
                                label: "Cost for two",
                                id: "costForTwo",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Rs. 300-Rs. 600",
                                        id: "costForTwofacetquery3",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Greater than Rs. 600",
                                        id: "costForTwofacetquery4",
                                        analytics: {}
                                    },
                                    {
                                        label: "Less than Rs. 300",
                                        id: "costForTwofacetquery5",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                subLabel: "Filter by"
                            }
                        ]
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        layout: {
                            columns: 4
                        },
                        id: "restaurant_grid_listing",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                restaurants: [
                                    {
                                        info: {
                                            id: "576302",
                                            name: "Chinese Wok",
                                            cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
                                            locality: "Block E",
                                            areaName: "Sector 86",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Chinese",
                                                "Asian",
                                                "Tibetan",
                                                "Desserts"
                                            ],
                                            avgRating: 4,
                                            parentId: "61955",
                                            avgRatingString: "4.0",
                                            totalRatingsString: "500+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "5.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Chinese.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Chinese.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9179"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chinese-wok-block-e-sector-86-faridabad-576302",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "483332",
                                            name: "BOX8 - Desi Meals",
                                            cloudinaryImageId: "69a061b7e0f951cef2b4947946f94ec6",
                                            locality: "KC Road",
                                            areaName: "Badkal Lake",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Biryani",
                                                "Thalis",
                                                "Home Food"
                                            ],
                                            avgRating: 4.4,
                                            parentId: "10655",
                                            avgRatingString: "4.4",
                                            totalRatingsString: "500+",
                                            sla: {
                                                deliveryTime: 20,
                                                lastMileTravel: 4.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-25 mins",
                                                lastMileTravelString: "4.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:45:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9179"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/box8-desi-meals-kc-road-badkal-lake-faridabad-483332",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "447688",
                                            name: "Chicago Pizza",
                                            cloudinaryImageId: "z7vplkcpx1l3bfivhtqb",
                                            locality: "Green Fields Colony",
                                            areaName: "Green Fields Colony",
                                            costForTwo: "\u20B9350 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Italian",
                                                "Beverages"
                                            ],
                                            avgRating: 3.8,
                                            parentId: "60277",
                                            avgRatingString: "3.8",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 42,
                                                lastMileTravel: 7.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "40-45 mins",
                                                lastMileTravelString: "7.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chicago-pizza-green-fields-colony-faridabad-447688",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "21986",
                                            name: "Dark Brown",
                                            cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Italian-American",
                                                "Continental",
                                                "Burgers",
                                                "Pizzas",
                                                "Pastas",
                                                "Chinese",
                                                "Beverages",
                                                "Salads",
                                                "Asian",
                                                "Healthy Food",
                                                "Fast Food",
                                                "Chaat",
                                                "Snacks",
                                                "Desserts",
                                                "American",
                                                "Italian",
                                                "Momos",
                                                "Rolls & Wraps",
                                                "Cafe"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "16162",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.8,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.8 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9100 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL",
                                                discountCalloutInfo: {
                                                    message: "Free Delivery",
                                                    logoCtx: {
                                                        logo: "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/dark-brown-shopping-centre-market-sector-15-faridabad-21986",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "160794",
                                            name: "Jujube Asian Cookhouse",
                                            cloudinaryImageId: "aec4411704260f0a4e0749b44c0b6eeb",
                                            locality: "Sector 15",
                                            areaName: "Sector 16_FBD",
                                            costForTwo: "\u20B9500 for two",
                                            cuisines: [
                                                "Asian"
                                            ],
                                            avgRating: 4.3,
                                            parentId: "15279",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "newg.png",
                                                        description: "Gourmet"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Gourmet",
                                                                    imageId: "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/jujube-asian-cookhouse-sector-15-sector-16-fbd-faridabad-160794",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "255729",
                                            name: "Silbuttah - The Indian Story By Berco's",
                                            cloudinaryImageId: "db6d3861e995a9ac4f7e461ddaed1b9f",
                                            locality: "Sector 12",
                                            areaName: "Sector 12",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Mughlai",
                                                "Kebabs"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "459398",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "3.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "newg.png",
                                                        description: "Gourmet"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Gourmet",
                                                                    imageId: "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "40% OFF",
                                                subHeader: "UPTO \u20B980"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/silbuttah-the-indian-story-by-bercos-sector-12-faridabad-255729",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "328851",
                                            name: "HR-51",
                                            cloudinaryImageId: "cf2chuvk0swv15ypwasv",
                                            locality: "Friends Colony",
                                            areaName: "Sector 14",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Chinese",
                                                "Snacks"
                                            ],
                                            avgRating: 3.7,
                                            parentId: "13822",
                                            avgRatingString: "3.7",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 28,
                                                lastMileTravel: 2.8,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "2.8 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 03:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9100 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL",
                                                discountCalloutInfo: {
                                                    message: "Free Delivery",
                                                    logoCtx: {
                                                        logo: "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/hr-51-friends-colony-sector-14-faridabad-328851",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "622189",
                                            name: "MOJO Pizza - 2X Toppings",
                                            cloudinaryImageId: "59b64f9bb67234987652437f21d379c2",
                                            locality: "K C Road",
                                            areaName: "New Industrial Township",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Italian",
                                                "Fast Food",
                                                "Desserts"
                                            ],
                                            avgRating: 4.3,
                                            parentId: "11329",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 4.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-30 mins",
                                                lastMileTravelString: "4.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:45:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9169"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/mojo-pizza-2x-toppings-k-c-road-new-industrial-township-faridabad-622189",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "483340",
                                            name: "NH1 Bowls - Highway To North",
                                            cloudinaryImageId: "94654fdf308764cd0faf83dba35bcdc3",
                                            locality: "KC Road",
                                            areaName: "Badkal Lake",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Punjabi",
                                                "Home Food"
                                            ],
                                            avgRating: 4.3,
                                            parentId: "22452",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 19,
                                                lastMileTravel: 4.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "14-24 mins",
                                                lastMileTravelString: "4.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:45:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9159"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/nh1-bowls-highway-to-north-kc-road-badkal-lake-faridabad-483340",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    }
                                ],
                                theme: "SeoRestaurantListingGridWidget"
                            }
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
                        message: "Show More",
                        id: "show_more_button"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        title: "Best Places to Eat Across Cities",
                        brands: [
                            {
                                text: "Best Restaurants in Bangalore",
                                link: "https://www.swiggy.com/city/bangalore/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Pune",
                                link: "https://www.swiggy.com/city/pune/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Mumbai",
                                link: "https://www.swiggy.com/city/mumbai/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Delhi",
                                link: "https://www.swiggy.com/city/delhi/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Hyderabad",
                                link: "https://www.swiggy.com/city/hyderabad/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Kolkata",
                                link: "https://www.swiggy.com/city/kolkata/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Chennai",
                                link: "https://www.swiggy.com/city/chennai/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Chandigarh",
                                link: "https://www.swiggy.com/city/chandigarh/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Ahmedabad",
                                link: "https://www.swiggy.com/city/ahmedabad/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Jaipur",
                                link: "https://www.swiggy.com/city/jaipur/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Nagpur",
                                link: "https://www.swiggy.com/city/nagpur/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Bhubaneswar",
                                link: "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Kochi",
                                link: "https://www.swiggy.com/city/kochi/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Surat",
                                link: "https://www.swiggy.com/city/surat/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Dehradun",
                                link: "https://www.swiggy.com/city/dehradun/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Ludhiana",
                                link: "https://www.swiggy.com/city/ludhiana/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Patna",
                                link: "https://www.swiggy.com/city/patna/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Mangaluru",
                                link: "https://www.swiggy.com/city/mangaluru/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Bhopal",
                                link: "https://www.swiggy.com/city/bhopal/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Gurgaon",
                                link: "https://www.swiggy.com/city/gurgaon/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Coimbatore",
                                link: "https://www.swiggy.com/city/coimbatore/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Agra",
                                link: "https://www.swiggy.com/city/agra/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Noida",
                                link: "https://www.swiggy.com/city/noida/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Vijayawada",
                                link: "https://www.swiggy.com/city/vijayawada/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Guwahati",
                                link: "https://www.swiggy.com/city/guwahati/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Mysore",
                                link: "https://www.swiggy.com/city/mysore/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Pondicherry",
                                link: "https://www.swiggy.com/city/pondicherry/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Thiruvananthapuram",
                                link: "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Ranchi",
                                link: "https://www.swiggy.com/city/ranchi/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Vizag",
                                link: "https://www.swiggy.com/city/vizag/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Udaipur",
                                link: "https://www.swiggy.com/city/udaipur/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Vadodara",
                                link: "https://www.swiggy.com/city/vadodara/best-restaurants"
                            }
                        ],
                        id: "restaurant_near_me_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        title: "Best Cuisines Near Me",
                        brands: [
                            {
                                text: "Chinese Restaurant Near Me",
                                link: "https://www.swiggy.com/chinese-restaurants-near-me"
                            },
                            {
                                text: "South Indian Restaurant Near Me",
                                link: "https://www.swiggy.com/south-indian-restaurants-near-me"
                            },
                            {
                                text: "Indian Restaurant Near Me",
                                link: "https://www.swiggy.com/indian-restaurants-near-me"
                            },
                            {
                                text: "Kerala Restaurant Near Me",
                                link: "https://www.swiggy.com/kerala-restaurants-near-me"
                            },
                            {
                                text: "Korean Restaurant Near Me",
                                link: "https://www.swiggy.com/korean-restaurants-near-me"
                            },
                            {
                                text: "North Indian Restaurant Near Me",
                                link: "https://www.swiggy.com/north-indian-restaurants-near-me"
                            },
                            {
                                text: "Seafood Restaurant Near Me",
                                link: "https://www.swiggy.com/seafood-restaurants-near-me"
                            },
                            {
                                text: "Bengali Restaurant Near Me",
                                link: "https://www.swiggy.com/bengali-restaurants-near-me"
                            },
                            {
                                text: "Punjabi Restaurant Near Me",
                                link: "https://www.swiggy.com/punjabi-restaurants-near-me"
                            },
                            {
                                text: "Italian Restaurant Near Me",
                                link: "https://www.swiggy.com/italian-restaurants-near-me"
                            },
                            {
                                text: "Andhra Restaurant Near Me",
                                link: "https://www.swiggy.com/andhra-restaurants-near-me"
                            },
                            {
                                text: "Biryani Restaurant Near Me",
                                link: "https://www.swiggy.com/biryani-restaurants-near-me"
                            },
                            {
                                text: "Japanese Restaurant Near Me",
                                link: "https://www.swiggy.com/japanese-restaurants-near-me"
                            },
                            {
                                text: "Arabian Restaurant Near Me",
                                link: "https://www.swiggy.com/arabian-restaurants-near-me"
                            },
                            {
                                text: "Fast Food Restaurant Near Me",
                                link: "https://www.swiggy.com/fast-food-restaurants-near-me"
                            },
                            {
                                text: "Jain Restaurant Near Me",
                                link: "https://www.swiggy.com/jain-restaurants-near-me"
                            },
                            {
                                text: "Gujarati Restaurant Near Me",
                                link: "https://www.swiggy.com/gujarati-restaurants-near-me"
                            },
                            {
                                text: "Thai Restaurant Near Me",
                                link: "https://www.swiggy.com/thai-restaurants-near-me"
                            },
                            {
                                text: "Pizzas Restaurant Near Me",
                                link: "https://www.swiggy.com/pizzas-restaurants-near-me"
                            },
                            {
                                text: "Asian Restaurant Near Me",
                                link: "https://www.swiggy.com/asian-restaurants-near-me"
                            },
                            {
                                text: "Cafe Restaurant Near Me",
                                link: "https://www.swiggy.com/cafe-restaurants-near-me"
                            },
                            {
                                text: "Continental Restaurant Near Me",
                                link: "https://www.swiggy.com/continental-restaurants-near-me"
                            },
                            {
                                text: "Mexican Restaurant Near Me",
                                link: "https://www.swiggy.com/mexican-restaurants-near-me"
                            },
                            {
                                text: "Mughlai Restaurant Near Me",
                                link: "https://www.swiggy.com/mughlai-restaurants-near-me"
                            },
                            {
                                text: "Sushi Restaurant Near Me",
                                link: "https://www.swiggy.com/sushi-restaurants-near-me"
                            },
                            {
                                text: "Mangalorean Restaurant Near Me",
                                link: "https://www.swiggy.com/mangalorean-restaurants-near-me"
                            },
                            {
                                text: "Tibetan Restaurant Near Me",
                                link: "https://www.swiggy.com/tibetan-restaurants-near-me"
                            },
                            {
                                text: "Barbecue Restaurant Near Me",
                                link: "https://www.swiggy.com/barbecue-restaurants-near-me"
                            },
                            {
                                text: "Maharashtrian Restaurant Near Me",
                                link: "https://www.swiggy.com/maharashtrian-restaurants-near-me"
                            },
                            {
                                text: "Nepalese Restaurant Near Me",
                                link: "https://www.swiggy.com/nepalese-restaurants-near-me"
                            },
                            {
                                text: "Rajasthani Restaurant Near Me",
                                link: "https://www.swiggy.com/rajasthani-restaurants-near-me"
                            },
                            {
                                text: "Turkish Restaurant Near Me",
                                link: "https://www.swiggy.com/turkish-restaurants-near-me"
                            }
                        ],
                        id: "restaurant_near_me_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        title: "Explore Every Restaurants Near Me",
                        brands: [
                            {
                                text: "Explore Restaurants Near Me",
                                link: "https://www.swiggy.com/restaurants-near-me"
                            },
                            {
                                text: "Explore Top Rated Restaurants Near Me",
                                link: "https://www.swiggy.com/best-restaurants-near-me"
                            }
                        ],
                        id: "restaurant_near_me_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
                        title: "For better experience,download the Swiggy app now",
                        androidAppImage: "portal/m/play_store.png",
                        androidAppLink: "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
                        iosAppImage: "portal/m/app_store.png",
                        iosAppLink: "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
                        id: "app_install_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
                        cities: [
                            {
                                text: "Bangalore",
                                link: "https://www.swiggy.com/city/bangalore"
                            },
                            {
                                text: "Gurgaon",
                                link: "https://www.swiggy.com/city/gurgaon"
                            },
                            {
                                text: "Hyderabad",
                                link: "https://www.swiggy.com/city/hyderabad"
                            },
                            {
                                text: "Delhi",
                                link: "https://www.swiggy.com/city/delhi"
                            },
                            {
                                text: "Mumbai",
                                link: "https://www.swiggy.com/city/mumbai"
                            },
                            {
                                text: "Pune",
                                link: "https://www.swiggy.com/city/pune"
                            },
                            {
                                text: "Kolkata",
                                link: "https://www.swiggy.com/city/kolkata"
                            },
                            {
                                text: "Chennai",
                                link: "https://www.swiggy.com/city/chennai"
                            },
                            {
                                text: "Ahmedabad",
                                link: "https://www.swiggy.com/city/ahmedabad"
                            },
                            {
                                text: "Chandigarh",
                                link: "https://www.swiggy.com/city/chandigarh"
                            },
                            {
                                text: "Jaipur",
                                link: "https://www.swiggy.com/city/jaipur"
                            },
                            {
                                text: "Kochi",
                                link: "https://www.swiggy.com/city/kochi"
                            },
                            {
                                text: "Coimbatore",
                                link: "https://www.swiggy.com/city/coimbatore"
                            },
                            {
                                text: "Lucknow",
                                link: "https://www.swiggy.com/city/lucknow"
                            },
                            {
                                text: "Nagpur",
                                link: "https://www.swiggy.com/city/nagpur"
                            },
                            {
                                text: "Vadodara",
                                link: "https://www.swiggy.com/city/vadodara"
                            },
                            {
                                text: "Indore",
                                link: "https://www.swiggy.com/city/indore"
                            },
                            {
                                text: "Guwahati",
                                link: "https://www.swiggy.com/city/guwahati"
                            },
                            {
                                text: "Vizag",
                                link: "https://www.swiggy.com/city/vizag"
                            },
                            {
                                text: "Surat",
                                link: "https://www.swiggy.com/city/surat"
                            },
                            {
                                text: "Dehradun",
                                link: "https://www.swiggy.com/city/dehradun"
                            },
                            {
                                text: "Noida",
                                link: "https://www.swiggy.com/city/noida"
                            },
                            {
                                text: "Ludhiana",
                                link: "https://www.swiggy.com/city/ludhiana"
                            },
                            {
                                text: "Trichy",
                                link: "https://www.swiggy.com/city/trichy"
                            },
                            {
                                text: "Vijayawada",
                                link: "https://www.swiggy.com/city/vijayawada"
                            },
                            {
                                text: "Kanpur",
                                link: "https://www.swiggy.com/city/kanpur"
                            },
                            {
                                text: "Mysore",
                                link: "https://www.swiggy.com/city/mysore"
                            },
                            {
                                text: "Nashik",
                                link: "https://www.swiggy.com/city/nashik"
                            },
                            {
                                text: "Udaipur",
                                link: "https://www.swiggy.com/city/udaipur"
                            },
                            {
                                text: "Pondicherry",
                                link: "https://www.swiggy.com/city/pondicherry"
                            },
                            {
                                text: "Agra",
                                link: "https://www.swiggy.com/city/agra"
                            },
                            {
                                text: "Aurangabad",
                                link: "https://www.swiggy.com/city/aurangabad"
                            },
                            {
                                text: "Jalandhar",
                                link: "https://www.swiggy.com/city/jalandhar"
                            },
                            {
                                text: "Kota",
                                link: "https://www.swiggy.com/city/kota"
                            },
                            {
                                text: "Madurai",
                                link: "https://www.swiggy.com/city/madurai"
                            },
                            {
                                text: "Allahabad",
                                link: "https://www.swiggy.com/city/allahabad"
                            },
                            {
                                text: "Manipal",
                                link: "https://www.swiggy.com/city/manipal"
                            },
                            {
                                text: "Amritsar",
                                link: "https://www.swiggy.com/city/amritsar"
                            },
                            {
                                text: "Bareilly",
                                link: "https://www.swiggy.com/city/bareilly"
                            },
                            {
                                text: "Meerut",
                                link: "https://www.swiggy.com/city/meerut"
                            },
                            {
                                text: "Bhopal",
                                link: "https://www.swiggy.com/city/bhopal"
                            },
                            {
                                text: "Ooty",
                                link: "https://www.swiggy.com/city/ooty"
                            },
                            {
                                text: "Bhubaneswar",
                                link: "https://www.swiggy.com/city/bhubaneswar"
                            },
                            {
                                text: "Raipur",
                                link: "https://www.swiggy.com/city/raipur"
                            },
                            {
                                text: "Bikaner",
                                link: "https://www.swiggy.com/city/bikaner"
                            },
                            {
                                text: "Rajkot",
                                link: "https://www.swiggy.com/city/rajkot"
                            },
                            {
                                text: "Kozhikode",
                                link: "https://www.swiggy.com/city/kozhikode"
                            },
                            {
                                text: "Central Goa",
                                link: "https://www.swiggy.com/city/central-goa"
                            },
                            {
                                text: "Sirsa",
                                link: "https://www.swiggy.com/city/sirsa"
                            },
                            {
                                text: "Gwalior",
                                link: "https://www.swiggy.com/city/gwalior"
                            },
                            {
                                text: "Thrissur",
                                link: "https://www.swiggy.com/city/thrissur"
                            },
                            {
                                text: "Kharagpur",
                                link: "https://www.swiggy.com/city/kharagpur"
                            },
                            {
                                text: "Tirupati",
                                link: "https://www.swiggy.com/city/tirupati"
                            },
                            {
                                text: "Tirupur",
                                link: "https://www.swiggy.com/city/tirupur"
                            },
                            {
                                text: "Vellore",
                                link: "https://www.swiggy.com/city/vellore"
                            },
                            {
                                text: "Thiruvananthapuram",
                                link: "https://www.swiggy.com/city/thiruvananthapuram"
                            },
                            {
                                text: "Warangal",
                                link: "https://www.swiggy.com/city/warangal"
                            },
                            {
                                text: "Varanasi",
                                link: "https://www.swiggy.com/city/varanasi"
                            },
                            {
                                text: "Mangaluru",
                                link: "https://www.swiggy.com/city/mangaluru"
                            },
                            {
                                text: "Patna",
                                link: "https://www.swiggy.com/city/patna"
                            },
                            {
                                text: "Ranchi",
                                link: "https://www.swiggy.com/city/ranchi"
                            },
                            {
                                text: "Faridabad",
                                link: "https://www.swiggy.com/city/faridabad"
                            },
                            {
                                text: "Guntur",
                                link: "https://www.swiggy.com/city/guntur"
                            },
                            {
                                text: "Ujjain",
                                link: "https://www.swiggy.com/city/ujjain"
                            },
                            {
                                text: "Patiala",
                                link: "https://www.swiggy.com/city/patiala"
                            },
                            {
                                text: "Karnal",
                                link: "https://www.swiggy.com/city/karnal"
                            },
                            {
                                text: "Kakinada",
                                link: "https://www.swiggy.com/city/kakinada"
                            },
                            {
                                text: "Rajahmundry",
                                link: "https://www.swiggy.com/city/rajahmundry"
                            },
                            {
                                text: "Bilaspur",
                                link: "https://www.swiggy.com/city/bilaspur"
                            },
                            {
                                text: "Bhilai",
                                link: "https://www.swiggy.com/city/bhilai"
                            },
                            {
                                text: "Anand",
                                link: "https://www.swiggy.com/city/anand"
                            },
                            {
                                text: "Bhavnagar",
                                link: "https://www.swiggy.com/city/bhavnagar"
                            },
                            {
                                text: "Jammu",
                                link: "https://www.swiggy.com/city/jammu"
                            },
                            {
                                text: "Muktsar",
                                link: "https://www.swiggy.com/city/muktsar"
                            },
                            {
                                text: "Panipat",
                                link: "https://www.swiggy.com/city/panipat"
                            },
                            {
                                text: "Dhanbad",
                                link: "https://www.swiggy.com/city/dhanbad"
                            },
                            {
                                text: "Hubli",
                                link: "https://www.swiggy.com/city/hubli"
                            },
                            {
                                text: "Belgaum",
                                link: "https://www.swiggy.com/city/belgaum"
                            },
                            {
                                text: "Jabalpur",
                                link: "https://www.swiggy.com/city/jabalpur"
                            },
                            {
                                text: "Kolhapur",
                                link: "https://www.swiggy.com/city/kolhapur"
                            },
                            {
                                text: "Solapur",
                                link: "https://www.swiggy.com/city/solapur"
                            },
                            {
                                text: "Shillong",
                                link: "https://www.swiggy.com/city/shillong"
                            },
                            {
                                text: "Cuttack",
                                link: "https://www.swiggy.com/city/cuttack"
                            },
                            {
                                text: "Aligarh",
                                link: "https://www.swiggy.com/city/aligarh"
                            },
                            {
                                text: "Salem",
                                link: "https://www.swiggy.com/city/salem"
                            },
                            {
                                text: "Jodhpur",
                                link: "https://www.swiggy.com/city/jodhpur"
                            },
                            {
                                text: "Ajmer",
                                link: "https://www.swiggy.com/city/ajmer"
                            },
                            {
                                text: "Jhansi",
                                link: "https://www.swiggy.com/city/jhansi"
                            },
                            {
                                text: "Gorakhpur",
                                link: "https://www.swiggy.com/city/gorakhpur"
                            },
                            {
                                text: "Thanjavur",
                                link: "https://www.swiggy.com/city/thanjavur"
                            },
                            {
                                text: "Erode",
                                link: "https://www.swiggy.com/city/erode"
                            },
                            {
                                text: "Nellore",
                                link: "https://www.swiggy.com/city/nellore"
                            },
                            {
                                text: "Rourkela",
                                link: "https://www.swiggy.com/city/rourkela"
                            },
                            {
                                text: "Anantapur",
                                link: "https://www.swiggy.com/city/anantapur"
                            },
                            {
                                text: "Kurnool",
                                link: "https://www.swiggy.com/city/kurnool"
                            },
                            {
                                text: "Ahmednagar",
                                link: "https://www.swiggy.com/city/ahmednagar"
                            },
                            {
                                text: "Phagwara",
                                link: "https://www.swiggy.com/city/phagwara"
                            },
                            {
                                text: "Ambala",
                                link: "https://www.swiggy.com/city/ambala"
                            },
                            {
                                text: "Ballari",
                                link: "https://www.swiggy.com/city/ballari"
                            },
                            {
                                text: "Saharanpur",
                                link: "https://www.swiggy.com/city/saharanpur"
                            },
                            {
                                text: "Tirunelveli",
                                link: "https://www.swiggy.com/city/tirunelveli"
                            },
                            {
                                text: "Bathinda",
                                link: "https://www.swiggy.com/city/bathinda"
                            },
                            {
                                text: "Mathura",
                                link: "https://www.swiggy.com/city/mathura"
                            },
                            {
                                text: "Haridwar",
                                link: "https://www.swiggy.com/city/haridwar"
                            },
                            {
                                text: "Ratnagiri",
                                link: "https://www.swiggy.com/city/ratnagiri"
                            },
                            {
                                text: "Sangli",
                                link: "https://www.swiggy.com/city/sangli"
                            },
                            {
                                text: "Amravati",
                                link: "https://www.swiggy.com/city/amravati"
                            },
                            {
                                text: "Rishikesh",
                                link: "https://www.swiggy.com/city/rishikesh"
                            },
                            {
                                text: "Nagercoil",
                                link: "https://www.swiggy.com/city/nagercoil"
                            },
                            {
                                text: "KanyaKumari",
                                link: "https://www.swiggy.com/city/kanyakumari"
                            },
                            {
                                text: "Kadapa",
                                link: "https://www.swiggy.com/city/kadapa"
                            },
                            {
                                text: "Nizamabad",
                                link: "https://www.swiggy.com/city/nizamabad"
                            },
                            {
                                text: "Shivamogga",
                                link: "https://www.swiggy.com/city/shivamogga"
                            },
                            {
                                text: "Davanagere",
                                link: "https://www.swiggy.com/city/davanagere"
                            },
                            {
                                text: "Roorkee",
                                link: "https://www.swiggy.com/city/roorkee"
                            },
                            {
                                text: "Nanded",
                                link: "https://www.swiggy.com/city/nanded"
                            },
                            {
                                text: "Rewa",
                                link: "https://www.swiggy.com/city/rewa"
                            },
                            {
                                text: "Satna",
                                link: "https://www.swiggy.com/city/satna"
                            },
                            {
                                text: "Muzaffarpur",
                                link: "https://www.swiggy.com/city/muzaffarpur"
                            },
                            {
                                text: "Valsad",
                                link: "https://www.swiggy.com/city/valsad"
                            },
                            {
                                text: "Vapi",
                                link: "https://www.swiggy.com/city/vapi"
                            },
                            {
                                text: "Chhapra",
                                link: "https://www.swiggy.com/city/chhapra"
                            },
                            {
                                text: "Dharamshala",
                                link: "https://www.swiggy.com/city/dharamshala"
                            },
                            {
                                text: "Kollam",
                                link: "https://www.swiggy.com/city/kollam"
                            },
                            {
                                text: "Silchar",
                                link: "https://www.swiggy.com/city/silchar"
                            },
                            {
                                text: "Alappuzha",
                                link: "https://www.swiggy.com/city/alappuzha"
                            },
                            {
                                text: "Sonipat",
                                link: "https://www.swiggy.com/city/sonipat"
                            },
                            {
                                text: "Rohtak",
                                link: "https://www.swiggy.com/city/rohtak"
                            },
                            {
                                text: "Mehsana",
                                link: "https://www.swiggy.com/city/mehsana"
                            },
                            {
                                text: "Kullu",
                                link: "https://www.swiggy.com/city/kullu"
                            },
                            {
                                text: "Dhule",
                                link: "https://www.swiggy.com/city/dhule"
                            },
                            {
                                text: "Dharwad",
                                link: "https://www.swiggy.com/city/dharwad"
                            },
                            {
                                text: "Latur",
                                link: "https://www.swiggy.com/city/latur"
                            },
                            {
                                text: "Vizianagaram",
                                link: "https://www.swiggy.com/city/vizianagaram"
                            },
                            {
                                text: "Khammam",
                                link: "https://www.swiggy.com/city/khammam"
                            },
                            {
                                text: "Hampi",
                                link: "https://www.swiggy.com/city/hampi"
                            },
                            {
                                text: "Nainital",
                                link: "https://www.swiggy.com/city/nainital"
                            },
                            {
                                text: "Akola",
                                link: "https://www.swiggy.com/city/akola"
                            },
                            {
                                text: "Kalaburagi",
                                link: "https://www.swiggy.com/city/kalaburagi"
                            },
                            {
                                text: "Gaya",
                                link: "https://www.swiggy.com/city/gaya"
                            },
                            {
                                text: "Muzaffarnagar",
                                link: "https://www.swiggy.com/city/muzaffarnagar"
                            },
                            {
                                text: "Dewas",
                                link: "https://www.swiggy.com/city/dewas"
                            },
                            {
                                text: "Korba",
                                link: "https://www.swiggy.com/city/korba"
                            },
                            {
                                text: "Mussoorie",
                                link: "https://www.swiggy.com/city/mussoorie"
                            },
                            {
                                text: "Jalgaon",
                                link: "https://www.swiggy.com/city/jalgaon"
                            },
                            {
                                text: "Yamuna Nagar",
                                link: "https://www.swiggy.com/city/yamuna-nagar"
                            },
                            {
                                text: "Bhagalpur",
                                link: "https://www.swiggy.com/city/bhagalpur"
                            },
                            {
                                text: "Hapur",
                                link: "https://www.swiggy.com/city/hapur"
                            },
                            {
                                text: "Morena",
                                link: "https://www.swiggy.com/city/morena"
                            },
                            {
                                text: "Hassan",
                                link: "https://www.swiggy.com/city/hassan"
                            },
                            {
                                text: "Hisar",
                                link: "https://www.swiggy.com/city/hisar"
                            },
                            {
                                text: "Godhra",
                                link: "https://www.swiggy.com/city/godhra"
                            },
                            {
                                text: "Kolar ",
                                link: "https://www.swiggy.com/city/kolar"
                            },
                            {
                                text: "Rampur",
                                link: "https://www.swiggy.com/city/rampur"
                            },
                            {
                                text: "Sitapur",
                                link: "https://www.swiggy.com/city/sitapur"
                            },
                            {
                                text: "Etawah",
                                link: "https://www.swiggy.com/city/etawah"
                            },
                            {
                                text: "Porbandar",
                                link: "https://www.swiggy.com/city/porbandar"
                            },
                            {
                                text: "Nadiad",
                                link: "https://www.swiggy.com/city/nadiad"
                            },
                            {
                                text: "Sagar",
                                link: "https://www.swiggy.com/city/sagar"
                            },
                            {
                                text: "Morbi",
                                link: "https://www.swiggy.com/city/morbi"
                            },
                            {
                                text: "Chhindwara",
                                link: "https://www.swiggy.com/city/chhindwara"
                            },
                            {
                                text: "Tumakuru",
                                link: "https://www.swiggy.com/city/tumakuru"
                            },
                            {
                                text: "Singrauli",
                                link: "https://www.swiggy.com/city/singrauli"
                            },
                            {
                                text: "Thoothukudi",
                                link: "https://www.swiggy.com/city/thoothukudi"
                            },
                            {
                                text: "Katni",
                                link: "https://www.swiggy.com/city/katni"
                            },
                            {
                                text: "Khandwa",
                                link: "https://www.swiggy.com/city/khandwa"
                            },
                            {
                                text: "Eluru",
                                link: "https://www.swiggy.com/city/eluru"
                            },
                            {
                                text: "Malappuram",
                                link: "https://www.swiggy.com/city/malappuram"
                            },
                            {
                                text: "Dibrugarh",
                                link: "https://www.swiggy.com/city/dibrugarh"
                            },
                            {
                                text: "Deoghar",
                                link: "https://www.swiggy.com/city/deoghar"
                            },
                            {
                                text: "Khanna",
                                link: "https://www.swiggy.com/city/khanna"
                            },
                            {
                                text: "Bidar",
                                link: "https://www.swiggy.com/city/bidar"
                            },
                            {
                                text: "Madikeri",
                                link: "https://www.swiggy.com/city/madikeri"
                            },
                            {
                                text: "Haldwani",
                                link: "https://www.swiggy.com/city/haldwani"
                            },
                            {
                                text: "Farrukhabad",
                                link: "https://www.swiggy.com/city/farrukhabad"
                            },
                            {
                                text: "Malegaon",
                                link: "https://www.swiggy.com/city/malegaon"
                            },
                            {
                                text: "Dindigul",
                                link: "https://www.swiggy.com/city/dindigul"
                            },
                            {
                                text: "Shahjahanpur",
                                link: "https://www.swiggy.com/city/shahjahanpur"
                            },
                            {
                                text: "Beed",
                                link: "https://www.swiggy.com/city/beed"
                            },
                            {
                                text: "Junagadh",
                                link: "https://www.swiggy.com/city/junagadh"
                            },
                            {
                                text: "Asansol",
                                link: "https://www.swiggy.com/city/asansol"
                            },
                            {
                                text: "Beawar",
                                link: "https://www.swiggy.com/city/beawar"
                            },
                            {
                                text: "Kishangarh",
                                link: "https://www.swiggy.com/city/kishangarh"
                            },
                            {
                                text: "Parbhani",
                                link: "https://www.swiggy.com/city/parbhani"
                            },
                            {
                                text: "Gondia",
                                link: "https://www.swiggy.com/city/gondia"
                            },
                            {
                                text: "Ichalkaranji",
                                link: "https://www.swiggy.com/city/ichalkaranji"
                            },
                            {
                                text: "Jalna",
                                link: "https://www.swiggy.com/city/jalna"
                            },
                            {
                                text: "Yavatmal",
                                link: "https://www.swiggy.com/city/yavatmal"
                            },
                            {
                                text: "Shivpuri",
                                link: "https://www.swiggy.com/city/shivpuri"
                            },
                            {
                                text: "Moga",
                                link: "https://www.swiggy.com/city/moga"
                            },
                            {
                                text: "Abohar",
                                link: "https://www.swiggy.com/city/abohar"
                            },
                            {
                                text: "Adoni",
                                link: "https://www.swiggy.com/city/adoni"
                            },
                            {
                                text: "Madanapalle",
                                link: "https://www.swiggy.com/city/madanapalle"
                            },
                            {
                                text: "Tiruvannamalai",
                                link: "https://www.swiggy.com/city/tiruvannamalai"
                            },
                            {
                                text: "Satara",
                                link: "https://www.swiggy.com/city/satara"
                            },
                            {
                                text: "Ambur",
                                link: "https://www.swiggy.com/city/ambur"
                            },
                            {
                                text: "Karimnagar",
                                link: "https://www.swiggy.com/city/karimnagar"
                            },
                            {
                                text: "Ratlam",
                                link: "https://www.swiggy.com/city/ratlam"
                            },
                            {
                                text: "Moradabad",
                                link: "https://www.swiggy.com/city/moradabad"
                            },
                            {
                                text: "Machilipatnam",
                                link: "https://www.swiggy.com/city/machilipatnam"
                            },
                            {
                                text: "Ongole",
                                link: "https://www.swiggy.com/city/ongole"
                            },
                            {
                                text: "Kottayam",
                                link: "https://www.swiggy.com/city/kottayam"
                            },
                            {
                                text: "Darbhanga",
                                link: "https://www.swiggy.com/city/darbhanga"
                            },
                            {
                                text: "Kurukshetra",
                                link: "https://www.swiggy.com/city/kurukshetra"
                            },
                            {
                                text: "Unnao",
                                link: "https://www.swiggy.com/city/unnao"
                            },
                            {
                                text: "Bulandshahr",
                                link: "https://www.swiggy.com/city/bulandshahr"
                            },
                            {
                                text: "Durgapur",
                                link: "https://www.swiggy.com/city/durgapur"
                            },
                            {
                                text: "Siliguri",
                                link: "https://www.swiggy.com/city/siliguri"
                            },
                            {
                                text: "Pali",
                                link: "https://www.swiggy.com/city/pali"
                            },
                            {
                                text: "Tadepalligudem",
                                link: "https://www.swiggy.com/city/tadepalligudem"
                            },
                            {
                                text: "Ramagundam",
                                link: "https://www.swiggy.com/city/ramagundam"
                            },
                            {
                                text: "Mahbubnagar",
                                link: "https://www.swiggy.com/city/mahbubnagar"
                            },
                            {
                                text: "Bhiwani",
                                link: "https://www.swiggy.com/city/bhiwani"
                            },
                            {
                                text: "Cuddalore",
                                link: "https://www.swiggy.com/city/cuddalore"
                            },
                            {
                                text: "Kaithal",
                                link: "https://www.swiggy.com/city/kaithal"
                            },
                            {
                                text: "Jagtial",
                                link: "https://www.swiggy.com/city/jagtial"
                            },
                            {
                                text: "Palakkad",
                                link: "https://www.swiggy.com/city/palakkad"
                            },
                            {
                                text: "Guna",
                                link: "https://www.swiggy.com/city/guna"
                            },
                            {
                                text: "Kumbakonam",
                                link: "https://www.swiggy.com/city/kumbakonam"
                            },
                            {
                                text: "Maunath Bhanjan",
                                link: "https://www.swiggy.com/city/maunath-bhanjan"
                            },
                            {
                                text: "Baripada",
                                link: "https://www.swiggy.com/city/baripada"
                            },
                            {
                                text: "Orai",
                                link: "https://www.swiggy.com/city/orai"
                            },
                            {
                                text: "Bhadrak",
                                link: "https://www.swiggy.com/city/bhadrak"
                            },
                            {
                                text: "Batala",
                                link: "https://www.swiggy.com/city/batala"
                            },
                            {
                                text: "Firozpur",
                                link: "https://www.swiggy.com/city/firozpur"
                            },
                            {
                                text: "Barnala",
                                link: "https://www.swiggy.com/city/barnala"
                            },
                            {
                                text: "Raigarh",
                                link: "https://www.swiggy.com/city/raigarh"
                            },
                            {
                                text: "Nagaon",
                                link: "https://www.swiggy.com/city/nagaon"
                            },
                            {
                                text: "Mainpuri",
                                link: "https://www.swiggy.com/city/mainpuri"
                            },
                            {
                                text: "Balurghat",
                                link: "https://www.swiggy.com/city/balurghat"
                            },
                            {
                                text: "Giridih",
                                link: "https://www.swiggy.com/city/giridih"
                            },
                            {
                                text: "Ghazipur",
                                link: "https://www.swiggy.com/city/ghazipur"
                            },
                            {
                                text: "Jagdalpur",
                                link: "https://www.swiggy.com/city/jagdalpur"
                            },
                            {
                                text: "Vidisha",
                                link: "https://www.swiggy.com/city/vidisha"
                            },
                            {
                                text: "Dimapur",
                                link: "https://www.swiggy.com/city/dimapur"
                            },
                            {
                                text: "Shikohabad",
                                link: "https://www.swiggy.com/city/shikohabad"
                            },
                            {
                                text: "Imphal",
                                link: "https://www.swiggy.com/city/imphal"
                            },
                            {
                                text: "Lakhimpur",
                                link: "https://www.swiggy.com/city/lakhimpur"
                            },
                            {
                                text: "Rudrapur",
                                link: "https://www.swiggy.com/city/rudrapur"
                            },
                            {
                                text: "Ambikapur",
                                link: "https://www.swiggy.com/city/ambikapur"
                            },
                            {
                                text: "Rae Bareli",
                                link: "https://www.swiggy.com/city/rae-bareli"
                            },
                            {
                                text: "Tinsukia",
                                link: "https://www.swiggy.com/city/tinsukia"
                            },
                            {
                                text: "Rajapalayam",
                                link: "https://www.swiggy.com/city/rajapalayam"
                            },
                            {
                                text: "Rajnandgaon",
                                link: "https://www.swiggy.com/city/rajnandgaon"
                            },
                            {
                                text: "Kashipur",
                                link: "https://www.swiggy.com/city/kashipur"
                            },
                            {
                                text: "Ranibennur",
                                link: "https://www.swiggy.com/city/ranibennur"
                            },
                            {
                                text: "Burhanpur",
                                link: "https://www.swiggy.com/city/burhanpur"
                            },
                            {
                                text: "Bhadravati",
                                link: "https://www.swiggy.com/city/bhadravati"
                            },
                            {
                                text: "Chittoor",
                                link: "https://www.swiggy.com/city/chittoor"
                            },
                            {
                                text: "Pudukkottai",
                                link: "https://www.swiggy.com/city/pudukkottai"
                            },
                            {
                                text: "Hardoi",
                                link: "https://www.swiggy.com/city/hardoi"
                            },
                            {
                                text: "Basti",
                                link: "https://www.swiggy.com/city/basti"
                            },
                            {
                                text: "Karaikkudi",
                                link: "https://www.swiggy.com/city/karaikkudi"
                            },
                            {
                                text: "Lalitpur",
                                link: "https://www.swiggy.com/city/lalitpur"
                            },
                            {
                                text: "Hospet",
                                link: "https://www.swiggy.com/city/hospet"
                            },
                            {
                                text: "Budaun",
                                link: "https://www.swiggy.com/city/budaun"
                            },
                            {
                                text: "Neemuch",
                                link: "https://www.swiggy.com/city/neemuch"
                            },
                            {
                                text: "Pilibhit",
                                link: "https://www.swiggy.com/city/pilibhit"
                            },
                            {
                                text: "Barshi",
                                link: "https://www.swiggy.com/city/barshi"
                            },
                            {
                                text: "Sri Ganganagar",
                                link: "https://www.swiggy.com/city/sri-ganganagar"
                            },
                            {
                                text: "Wardha",
                                link: "https://www.swiggy.com/city/wardha"
                            },
                            {
                                text: "Sehore",
                                link: "https://www.swiggy.com/city/sehore"
                            },
                            {
                                text: "Bhimavaram",
                                link: "https://www.swiggy.com/city/bhimavaram"
                            },
                            {
                                text: "Hanumangarh",
                                link: "https://www.swiggy.com/city/hanumangarh"
                            },
                            {
                                text: "Pathankot",
                                link: "https://www.swiggy.com/city/pathankot"
                            },
                            {
                                text: "Puri",
                                link: "https://www.swiggy.com/city/puri"
                            },
                            {
                                text: "Fatehpur",
                                link: "https://www.swiggy.com/city/fatehpur"
                            },
                            {
                                text: "Surendranagar Dudhrej",
                                link: "https://www.swiggy.com/city/surendranagar-dudhrej"
                            },
                            {
                                text: "Jamnagar",
                                link: "https://www.swiggy.com/city/jamnagar"
                            },
                            {
                                text: "Bhuj",
                                link: "https://www.swiggy.com/city/bhuj"
                            },
                            {
                                text: "Gandhidham",
                                link: "https://www.swiggy.com/city/gandhidham"
                            },
                            {
                                text: "Bharuch",
                                link: "https://www.swiggy.com/city/bharuch"
                            },
                            {
                                text: "Navsari",
                                link: "https://www.swiggy.com/city/navsari"
                            },
                            {
                                text: "Amreli",
                                link: "https://www.swiggy.com/city/amreli"
                            },
                            {
                                text: "Palanpur",
                                link: "https://www.swiggy.com/city/palanpur"
                            },
                            {
                                text: "Bhilwara",
                                link: "https://www.swiggy.com/city/bhilwara"
                            },
                            {
                                text: "Suratgarh",
                                link: "https://www.swiggy.com/city/suratgarh"
                            },
                            {
                                text: "Sikar",
                                link: "https://www.swiggy.com/city/sikar"
                            },
                            {
                                text: "Churu",
                                link: "https://www.swiggy.com/city/churu"
                            },
                            {
                                text: "Alwar",
                                link: "https://www.swiggy.com/city/alwar"
                            },
                            {
                                text: "Bhiwadi",
                                link: "https://www.swiggy.com/city/bhiwadi"
                            },
                            {
                                text: "Bharatpur",
                                link: "https://www.swiggy.com/city/bharatpur"
                            },
                            {
                                text: "Mount Abu",
                                link: "https://www.swiggy.com/city/mount-abu"
                            },
                            {
                                text: "Bundi",
                                link: "https://www.swiggy.com/city/bundi"
                            },
                            {
                                text: "Sawai Madhopur",
                                link: "https://www.swiggy.com/city/sawai-madhopur"
                            },
                            {
                                text: "Purulia",
                                link: "https://www.swiggy.com/city/purulia"
                            },
                            {
                                text: "Bardhaman",
                                link: "https://www.swiggy.com/city/bardhaman"
                            },
                            {
                                text: "Raniganj",
                                link: "https://www.swiggy.com/city/raniganj"
                            },
                            {
                                text: "Darjeeling",
                                link: "https://www.swiggy.com/city/darjeeling"
                            },
                            {
                                text: "Jalpaiguri",
                                link: "https://www.swiggy.com/city/jalpaiguri"
                            },
                            {
                                text: "Chittorgarh",
                                link: "https://www.swiggy.com/city/chittorgarh"
                            },
                            {
                                text: "Dholpur",
                                link: "https://www.swiggy.com/city/dholpur"
                            },
                            {
                                text: "Uluberia",
                                link: "https://www.swiggy.com/city/uluberia"
                            },
                            {
                                text: "Nabadwip",
                                link: "https://www.swiggy.com/city/nabadwip"
                            },
                            {
                                text: "Bongaon",
                                link: "https://www.swiggy.com/city/bongaon"
                            },
                            {
                                text: "Kanchrapara",
                                link: "https://www.swiggy.com/city/kanchrapara"
                            },
                            {
                                text: "Habra",
                                link: "https://www.swiggy.com/city/habra"
                            },
                            {
                                text: "Firozabad",
                                link: "https://www.swiggy.com/city/firozabad"
                            },
                            {
                                text: "Nalgonda",
                                link: "https://www.swiggy.com/city/nalgonda"
                            },
                            {
                                text: "Chandrapur",
                                link: "https://www.swiggy.com/city/chandrapur"
                            },
                            {
                                text: "Bijapur",
                                link: "https://www.swiggy.com/city/bijapur"
                            },
                            {
                                text: "Bhusawal",
                                link: "https://www.swiggy.com/city/bhusawal"
                            },
                            {
                                text: "Raichur",
                                link: "https://www.swiggy.com/city/raichur"
                            },
                            {
                                text: "Bahraich",
                                link: "https://www.swiggy.com/city/bahraich"
                            },
                            {
                                text: "Azamgarh",
                                link: "https://www.swiggy.com/city/azamgarh"
                            },
                            {
                                text: "Bahadurgarh",
                                link: "https://www.swiggy.com/city/bahadurgarh"
                            },
                            {
                                text: "Jind",
                                link: "https://www.swiggy.com/city/jind"
                            },
                            {
                                text: "Rewari",
                                link: "https://www.swiggy.com/city/rewari"
                            },
                            {
                                text: "Palwal",
                                link: "https://www.swiggy.com/city/palwal"
                            },
                            {
                                text: "Hathras",
                                link: "https://www.swiggy.com/city/hathras"
                            },
                            {
                                text: "Sambalpur",
                                link: "https://www.swiggy.com/city/sambalpur"
                            },
                            {
                                text: "Banda",
                                link: "https://www.swiggy.com/city/banda"
                            },
                            {
                                text: "Hoshiarpur",
                                link: "https://www.swiggy.com/city/hoshiarpur"
                            },
                            {
                                text: "Faridkot",
                                link: "https://www.swiggy.com/city/faridkot"
                            },
                            {
                                text: "Mandsaur",
                                link: "https://www.swiggy.com/city/mandsaur"
                            },
                            {
                                text: "Suryapet",
                                link: "https://www.swiggy.com/city/suryapet"
                            },
                            {
                                text: "Adilabad",
                                link: "https://www.swiggy.com/city/adilabad"
                            },
                            {
                                text: "Narasaraopet",
                                link: "https://www.swiggy.com/city/narasaraopet"
                            },
                            {
                                text: "Faizabad",
                                link: "https://www.swiggy.com/city/faizabad"
                            },
                            {
                                text: "Tadpatri",
                                link: "https://www.swiggy.com/city/tadpatri"
                            },
                            {
                                text: "Gonda",
                                link: "https://www.swiggy.com/city/gonda"
                            },
                            {
                                text: "Mughalsarai",
                                link: "https://www.swiggy.com/city/mughalsarai"
                            },
                            {
                                text: "Medinipur",
                                link: "https://www.swiggy.com/city/medinipur"
                            },
                            {
                                text: "Nagda",
                                link: "https://www.swiggy.com/city/nagda"
                            },
                            {
                                text: "Raiganj",
                                link: "https://www.swiggy.com/city/raiganj"
                            },
                            {
                                text: "Deoria City",
                                link: "https://www.swiggy.com/city/deoria-city"
                            },
                            {
                                text: "Sultanpur",
                                link: "https://www.swiggy.com/city/sultanpur"
                            },
                            {
                                text: "Shamli",
                                link: "https://www.swiggy.com/city/shamli"
                            },
                            {
                                text: "Krishnanagar",
                                link: "https://www.swiggy.com/city/krishnanagar"
                            },
                            {
                                text: "Ballia",
                                link: "https://www.swiggy.com/city/ballia"
                            },
                            {
                                text: "Guntakal",
                                link: "https://www.swiggy.com/city/guntakal"
                            },
                            {
                                text: "Miryalaguda",
                                link: "https://www.swiggy.com/city/miryalaguda"
                            },
                            {
                                text: "Etah",
                                link: "https://www.swiggy.com/city/etah"
                            },
                            {
                                text: "Berhampore",
                                link: "https://www.swiggy.com/city/berhampore"
                            },
                            {
                                text: "Gudivada",
                                link: "https://www.swiggy.com/city/gudivada"
                            },
                            {
                                text: "Haldia",
                                link: "https://www.swiggy.com/city/haldia"
                            },
                            {
                                text: "Santipur",
                                link: "https://www.swiggy.com/city/santipur"
                            },
                            {
                                text: "Basirhat",
                                link: "https://www.swiggy.com/city/basirhat"
                            },
                            {
                                text: "Udgir",
                                link: "https://www.swiggy.com/city/udgir"
                            },
                            {
                                text: "Proddatur",
                                link: "https://www.swiggy.com/city/proddatur"
                            },
                            {
                                text: "Nagapattinam",
                                link: "https://www.swiggy.com/city/nagapattinam"
                            },
                            {
                                text: "Chikmagalur",
                                link: "https://www.swiggy.com/city/chikmagalur"
                            },
                            {
                                text: "Chandausi",
                                link: "https://www.swiggy.com/city/chandausi"
                            },
                            {
                                text: "Bhind",
                                link: "https://www.swiggy.com/city/bhind"
                            },
                            {
                                text: "Mandya",
                                link: "https://www.swiggy.com/city/mandya"
                            },
                            {
                                text: "Bagalkot",
                                link: "https://www.swiggy.com/city/bagalkot"
                            },
                            {
                                text: "Nandurbar",
                                link: "https://www.swiggy.com/city/nandurbar"
                            },
                            {
                                text: "Chitradurga",
                                link: "https://www.swiggy.com/city/chitradurga"
                            },
                            {
                                text: "Osmanabad",
                                link: "https://www.swiggy.com/city/osmanabad"
                            },
                            {
                                text: "Modinagar",
                                link: "https://www.swiggy.com/city/modinagar"
                            },
                            {
                                text: "Gadag-Betigeri",
                                link: "https://www.swiggy.com/city/gadag-betigeri"
                            },
                            {
                                text: "Hoshangabad",
                                link: "https://www.swiggy.com/city/hoshangabad"
                            },
                            {
                                text: "Jaunpur",
                                link: "https://www.swiggy.com/city/jaunpur"
                            },
                            {
                                text: "Port Blair",
                                link: "https://www.swiggy.com/city/port-blair"
                            },
                            {
                                text: "Jorhat",
                                link: "https://www.swiggy.com/city/jorhat"
                            },
                            {
                                text: "Nandyal",
                                link: "https://www.swiggy.com/city/nandyal"
                            },
                            {
                                text: "Biharsharif",
                                link: "https://www.swiggy.com/city/biharsharif"
                            },
                            {
                                text: "Buxar",
                                link: "https://www.swiggy.com/city/buxar"
                            },
                            {
                                text: "Siwan",
                                link: "https://www.swiggy.com/city/siwan"
                            },
                            {
                                text: "Dehri",
                                link: "https://www.swiggy.com/city/dehri"
                            },
                            {
                                text: "Bettiah",
                                link: "https://www.swiggy.com/city/bettiah"
                            },
                            {
                                text: "Kishanganj",
                                link: "https://www.swiggy.com/city/kishanganj"
                            },
                            {
                                text: "Saharsa",
                                link: "https://www.swiggy.com/city/saharsa"
                            },
                            {
                                text: "Hajipur",
                                link: "https://www.swiggy.com/city/hajipur"
                            },
                            {
                                text: "Motihari",
                                link: "https://www.swiggy.com/city/motihari"
                            },
                            {
                                text: "Sasaram",
                                link: "https://www.swiggy.com/city/sasaram"
                            },
                            {
                                text: "Munger",
                                link: "https://www.swiggy.com/city/munger"
                            },
                            {
                                text: "Katihar",
                                link: "https://www.swiggy.com/city/katihar"
                            },
                            {
                                text: "Arrah",
                                link: "https://www.swiggy.com/city/arrah"
                            },
                            {
                                text: "Srikakulam",
                                link: "https://www.swiggy.com/city/srikakulam"
                            },
                            {
                                text: "Begusarai",
                                link: "https://www.swiggy.com/city/begusarai"
                            },
                            {
                                text: "Neyveli",
                                link: "https://www.swiggy.com/city/neyveli"
                            },
                            {
                                text: "Waidhan",
                                link: "https://www.swiggy.com/city/waidhan"
                            },
                            {
                                text: "Markapur",
                                link: "https://www.swiggy.com/city/markapur"
                            },
                            {
                                text: "Chikkaballapur",
                                link: "https://www.swiggy.com/city/chikkaballapur"
                            },
                            {
                                text: "Bhatkal",
                                link: "https://www.swiggy.com/city/bhatkal"
                            },
                            {
                                text: "Gokak",
                                link: "https://www.swiggy.com/city/gokak"
                            },
                            {
                                text: "Itarsi",
                                link: "https://www.swiggy.com/city/itarsi"
                            },
                            {
                                text: "Dhar",
                                link: "https://www.swiggy.com/city/dhar"
                            },
                            {
                                text: "Chalisgaon",
                                link: "https://www.swiggy.com/city/chalisgaon"
                            },
                            {
                                text: "Thiruvallur",
                                link: "https://www.swiggy.com/city/thiruvallur"
                            },
                            {
                                text: "Namakkal",
                                link: "https://www.swiggy.com/city/namakkal"
                            },
                            {
                                text: "Dharmapuri",
                                link: "https://www.swiggy.com/city/dharmapuri"
                            },
                            {
                                text: "Bhandara",
                                link: "https://www.swiggy.com/city/bhandara"
                            },
                            {
                                text: "Virudhunagar",
                                link: "https://www.swiggy.com/city/virudhunagar"
                            },
                            {
                                text: "Siddipet",
                                link: "https://www.swiggy.com/city/siddipet"
                            },
                            {
                                text: "Gadwal",
                                link: "https://www.swiggy.com/city/gadwal"
                            },
                            {
                                text: "Bodhan-Rural",
                                link: "https://www.swiggy.com/city/bodhan-rural"
                            },
                            {
                                text: "Kamareddy",
                                link: "https://www.swiggy.com/city/kamareddy"
                            },
                            {
                                text: "Jhunjhunu",
                                link: "https://www.swiggy.com/city/jhunjhunu"
                            },
                            {
                                text: "Kapurthala",
                                link: "https://www.swiggy.com/city/kapurthala"
                            },
                            {
                                text: "Sangrur",
                                link: "https://www.swiggy.com/city/sangrur"
                            },
                            {
                                text: "Gurdaspur",
                                link: "https://www.swiggy.com/city/gurdaspur"
                            },
                            {
                                text: "Ramgarh",
                                link: "https://www.swiggy.com/city/ramgarh"
                            },
                            {
                                text: "Bantwal",
                                link: "https://www.swiggy.com/city/bantwal"
                            },
                            {
                                text: "Doddaballapura",
                                link: "https://www.swiggy.com/city/doddaballapura"
                            },
                            {
                                text: "Buldana",
                                link: "https://www.swiggy.com/city/buldana"
                            },
                            {
                                text: "Karad",
                                link: "https://www.swiggy.com/city/karad"
                            },
                            {
                                text: "Krishnagiri",
                                link: "https://www.swiggy.com/city/krishnagiri"
                            },
                            {
                                text: "Tiptur",
                                link: "https://www.swiggy.com/city/tiptur"
                            },
                            {
                                text: "Bhadrachalam",
                                link: "https://www.swiggy.com/city/bhadrachalam"
                            },
                            {
                                text: "Mancherial",
                                link: "https://www.swiggy.com/city/mancherial"
                            },
                            {
                                text: "Balrampur",
                                link: "https://www.swiggy.com/city/balrampur"
                            },
                            {
                                text: "Bharabanki",
                                link: "https://www.swiggy.com/city/bharabanki"
                            },
                            {
                                text: "Malout",
                                link: "https://www.swiggy.com/city/malout"
                            },
                            {
                                text: "Fatehgarh Sahib",
                                link: "https://www.swiggy.com/city/fatehgarh-sahib"
                            },
                            {
                                text: "Ropar",
                                link: "https://www.swiggy.com/city/ropar"
                            },
                            {
                                text: "Nangal",
                                link: "https://www.swiggy.com/city/nangal"
                            },
                            {
                                text: "Narnaul",
                                link: "https://www.swiggy.com/city/narnaul"
                            },
                            {
                                text: "Naraingarh",
                                link: "https://www.swiggy.com/city/naraingarh"
                            },
                            {
                                text: "Himmatnagar",
                                link: "https://www.swiggy.com/city/himmatnagar"
                            },
                            {
                                text: "Dausa",
                                link: "https://www.swiggy.com/city/dausa"
                            },
                            {
                                text: "Jahanabad",
                                link: "https://www.swiggy.com/city/jahanabad"
                            },
                            {
                                text: "Samastipur",
                                link: "https://www.swiggy.com/city/samastipur"
                            },
                            {
                                text: "Purnea",
                                link: "https://www.swiggy.com/city/purnea"
                            },
                            {
                                text: "Berhampur",
                                link: "https://www.swiggy.com/city/berhampur"
                            },
                            {
                                text: "Malda",
                                link: "https://www.swiggy.com/city/malda"
                            },
                            {
                                text: "Tuni",
                                link: "https://www.swiggy.com/city/tuni"
                            },
                            {
                                text: "Puttur",
                                link: "https://www.swiggy.com/city/puttur"
                            },
                            {
                                text: "Rayachoty",
                                link: "https://www.swiggy.com/city/rayachoty"
                            },
                            {
                                text: "Nirmal",
                                link: "https://www.swiggy.com/city/nirmal"
                            },
                            {
                                text: "Mirzapur",
                                link: "https://www.swiggy.com/city/mirzapur"
                            },
                            {
                                text: "Tanuku",
                                link: "https://www.swiggy.com/city/tanuku"
                            },
                            {
                                text: "Dahod",
                                link: "https://www.swiggy.com/city/dahod"
                            },
                            {
                                text: "Barmer",
                                link: "https://www.swiggy.com/city/barmer"
                            },
                            {
                                text: "Gangapur City",
                                link: "https://www.swiggy.com/city/gangapur-city"
                            },
                            {
                                text: "Mandi Gobindgarh",
                                link: "https://www.swiggy.com/city/mandi-gobindgarh"
                            },
                            {
                                text: "Tarn Taran Sahib",
                                link: "https://www.swiggy.com/city/tarn-taran-sahib"
                            },
                            {
                                text: "Nakodar",
                                link: "https://www.swiggy.com/city/nakodar"
                            },
                            {
                                text: "Ankleshwar",
                                link: "https://www.swiggy.com/city/ankleshwar"
                            },
                            {
                                text: "Vyara",
                                link: "https://www.swiggy.com/city/vyara"
                            },
                            {
                                text: "Bardoli",
                                link: "https://www.swiggy.com/city/bardoli"
                            },
                            {
                                text: "Halol",
                                link: "https://www.swiggy.com/city/halol"
                            },
                            {
                                text: "Bijnor",
                                link: "https://www.swiggy.com/city/bijnor"
                            },
                            {
                                text: "Sangamner",
                                link: "https://www.swiggy.com/city/sangamner"
                            },
                            {
                                text: "Baramati",
                                link: "https://www.swiggy.com/city/baramati"
                            },
                            {
                                text: "Betul",
                                link: "https://www.swiggy.com/city/betul"
                            },
                            {
                                text: "Chhatarpur",
                                link: "https://www.swiggy.com/city/chhatarpur"
                            },
                            {
                                text: "Balaghat",
                                link: "https://www.swiggy.com/city/balaghat"
                            },
                            {
                                text: "Sivakasi",
                                link: "https://www.swiggy.com/city/sivakasi"
                            },
                            {
                                text: "Viluppuram",
                                link: "https://www.swiggy.com/city/viluppuram"
                            },
                            {
                                text: "Ramanathapuram",
                                link: "https://www.swiggy.com/city/ramanathapuram"
                            },
                            {
                                text: "Sirsi",
                                link: "https://www.swiggy.com/city/sirsi"
                            },
                            {
                                text: "Theni",
                                link: "https://www.swiggy.com/city/theni"
                            },
                            {
                                text: "Karur",
                                link: "https://www.swiggy.com/city/karur"
                            },
                            {
                                text: "Karwar",
                                link: "https://www.swiggy.com/city/karwar"
                            },
                            {
                                text: "Sindhanur",
                                link: "https://www.swiggy.com/city/sindhanur"
                            },
                            {
                                text: "Kannur",
                                link: "https://www.swiggy.com/city/kannur"
                            },
                            {
                                text: "Noida 1",
                                link: "https://www.swiggy.com/city/noida-1"
                            },
                            {
                                text: "Thiruvalla",
                                link: "https://www.swiggy.com/city/thiruvalla"
                            },
                            {
                                text: "Thodupuzha",
                                link: "https://www.swiggy.com/city/thodupuzha"
                            },
                            {
                                text: "Kadiri",
                                link: "https://www.swiggy.com/city/kadiri"
                            },
                            {
                                text: "Kavali",
                                link: "https://www.swiggy.com/city/kavali"
                            },
                            {
                                text: "Tezpur",
                                link: "https://www.swiggy.com/city/tezpur"
                            },
                            {
                                text: "Kayamkulam",
                                link: "https://www.swiggy.com/city/kayamkulam"
                            },
                            {
                                text: "Kottarakkara",
                                link: "https://www.swiggy.com/city/kottarakkara"
                            },
                            {
                                text: "Mandi Dabwali",
                                link: "https://www.swiggy.com/city/mandi-dabwali"
                            },
                            {
                                text: "Fatehabad",
                                link: "https://www.swiggy.com/city/fatehabad"
                            },
                            {
                                text: "Jagraon",
                                link: "https://www.swiggy.com/city/jagraon"
                            },
                            {
                                text: "Mansa",
                                link: "https://www.swiggy.com/city/mansa"
                            },
                            {
                                text: "Pinjore City",
                                link: "https://www.swiggy.com/city/pinjore-city"
                            },
                            {
                                text: "Fazilka",
                                link: "https://www.swiggy.com/city/fazilka"
                            },
                            {
                                text: "Baddi",
                                link: "https://www.swiggy.com/city/baddi"
                            },
                            {
                                text: "Solan",
                                link: "https://www.swiggy.com/city/solan"
                            },
                            {
                                text: "Daltonganj",
                                link: "https://www.swiggy.com/city/daltonganj"
                            },
                            {
                                text: "Balangir",
                                link: "https://www.swiggy.com/city/balangir"
                            },
                            {
                                text: "Kothagudem",
                                link: "https://www.swiggy.com/city/kothagudem"
                            },
                            {
                                text: "Hansi",
                                link: "https://www.swiggy.com/city/hansi"
                            },
                            {
                                text: "Aurangabad_Bihar",
                                link: "https://www.swiggy.com/city/aurangabadbihar"
                            },
                            {
                                text: "Gopalganj",
                                link: "https://www.swiggy.com/city/gopalganj"
                            },
                            {
                                text: "Jharsuguda",
                                link: "https://www.swiggy.com/city/jharsuguda"
                            },
                            {
                                text: "Tohana",
                                link: "https://www.swiggy.com/city/tohana"
                            },
                            {
                                text: "Jhalawar",
                                link: "https://www.swiggy.com/city/jhalawar"
                            },
                            {
                                text: "Sivasagar",
                                link: "https://www.swiggy.com/city/sivasagar"
                            },
                            {
                                text: "Bagdogra",
                                link: "https://www.swiggy.com/city/bagdogra"
                            },
                            {
                                text: "Kendrapada",
                                link: "https://www.swiggy.com/city/kendrapada"
                            },
                            {
                                text: "Mallapuram (Do not Use)",
                                link: "https://www.swiggy.com/city/mallapuram-do-not-use"
                            },
                            {
                                text: "Veraval",
                                link: "https://www.swiggy.com/city/veraval"
                            },
                            {
                                text: "Daman",
                                link: "https://www.swiggy.com/city/daman"
                            },
                            {
                                text: "Chiplun",
                                link: "https://www.swiggy.com/city/chiplun"
                            },
                            {
                                text: "Silvassa",
                                link: "https://www.swiggy.com/city/silvassa"
                            },
                            {
                                text: "Lonavla",
                                link: "https://www.swiggy.com/city/lonavla"
                            },
                            {
                                text: "Bongaigaon",
                                link: "https://www.swiggy.com/city/bongaigaon"
                            },
                            {
                                text: "Golaghat",
                                link: "https://www.swiggy.com/city/golaghat"
                            },
                            {
                                text: "Duliajan",
                                link: "https://www.swiggy.com/city/duliajan"
                            },
                            {
                                text: "Bolpur",
                                link: "https://www.swiggy.com/city/bolpur"
                            },
                            {
                                text: "Madhubani",
                                link: "https://www.swiggy.com/city/madhubani"
                            },
                            {
                                text: "Balasore",
                                link: "https://www.swiggy.com/city/balasore"
                            },
                            {
                                text: "Palampur",
                                link: "https://www.swiggy.com/city/palampur"
                            },
                            {
                                text: "Kotdwar",
                                link: "https://www.swiggy.com/city/kotdwar"
                            },
                            {
                                text: "Koppal",
                                link: "https://www.swiggy.com/city/koppal"
                            },
                            {
                                text: "Chikhli",
                                link: "https://www.swiggy.com/city/chikhli"
                            },
                            {
                                text: "Dahanu",
                                link: "https://www.swiggy.com/city/dahanu"
                            },
                            {
                                text: "Itanagar",
                                link: "https://www.swiggy.com/city/itanagar"
                            },
                            {
                                text: "Rangpo",
                                link: "https://www.swiggy.com/city/rangpo"
                            },
                            {
                                text: "Aizawl",
                                link: "https://www.swiggy.com/city/aizawl"
                            },
                            {
                                text: "Gangtok",
                                link: "https://www.swiggy.com/city/gangtok"
                            },
                            {
                                text: "Mayiladuthurai",
                                link: "https://www.swiggy.com/city/mayiladuthurai"
                            },
                            {
                                text: "Kannauj",
                                link: "https://www.swiggy.com/city/kannauj"
                            },
                            {
                                text: "Cooch Behar",
                                link: "https://www.swiggy.com/city/cooch-behar"
                            },
                            {
                                text: "Palani",
                                link: "https://www.swiggy.com/city/palani"
                            },
                            {
                                text: "Bilimora",
                                link: "https://www.swiggy.com/city/bilimora"
                            },
                            {
                                text: "Boisar",
                                link: "https://www.swiggy.com/city/boisar"
                            },
                            {
                                text: "Kohima",
                                link: "https://www.swiggy.com/city/kohima"
                            },
                            {
                                text: "Naharlagun",
                                link: "https://www.swiggy.com/city/naharlagun"
                            },
                            {
                                text: "Dumka",
                                link: "https://www.swiggy.com/city/dumka"
                            },
                            {
                                text: "Rajsamand",
                                link: "https://www.swiggy.com/city/rajsamand"
                            },
                            {
                                text: "Gauriganj",
                                link: "https://www.swiggy.com/city/gauriganj"
                            },
                            {
                                text: "Bodinayakanur",
                                link: "https://www.swiggy.com/city/bodinayakanur"
                            },
                            {
                                text: "Bhawanipatna",
                                link: "https://www.swiggy.com/city/bhawanipatna"
                            },
                            {
                                text: "Baran",
                                link: "https://www.swiggy.com/city/baran"
                            },
                            {
                                text: "Narsinghpur",
                                link: "https://www.swiggy.com/city/narsinghpur"
                            },
                            {
                                text: "Kovilpatti",
                                link: "https://www.swiggy.com/city/kovilpatti"
                            },
                            {
                                text: "Pusad",
                                link: "https://www.swiggy.com/city/pusad"
                            },
                            {
                                text: "Kendujhar",
                                link: "https://www.swiggy.com/city/kendujhar"
                            },
                            {
                                text: "Manali",
                                link: "https://www.swiggy.com/city/manali"
                            },
                            {
                                text: "Diu",
                                link: "https://www.swiggy.com/city/diu"
                            },
                            {
                                text: "Khamgaon",
                                link: "https://www.swiggy.com/city/khamgaon"
                            },
                            {
                                text: "Ramanagara",
                                link: "https://www.swiggy.com/city/ramanagara"
                            },
                            {
                                text: "Alipurduar",
                                link: "https://www.swiggy.com/city/alipurduar"
                            },
                            {
                                text: "Almora",
                                link: "https://www.swiggy.com/city/almora"
                            },
                            {
                                text: "Jhargram",
                                link: "https://www.swiggy.com/city/jhargram"
                            },
                            {
                                text: "Arambagh",
                                link: "https://www.swiggy.com/city/arambagh"
                            },
                            {
                                text: "Bhadohi",
                                link: "https://www.swiggy.com/city/bhadohi"
                            },
                            {
                                text: "Tenkasi",
                                link: "https://www.swiggy.com/city/tenkasi"
                            },
                            {
                                text: "Srivilliputhur",
                                link: "https://www.swiggy.com/city/srivilliputhur"
                            },
                            {
                                text: "Chidambaram",
                                link: "https://www.swiggy.com/city/chidambaram"
                            },
                            {
                                text: "Rajgarh",
                                link: "https://www.swiggy.com/city/rajgarh"
                            },
                            {
                                text: "Pratapgarh",
                                link: "https://www.swiggy.com/city/pratapgarh"
                            },
                            {
                                text: "Washim",
                                link: "https://www.swiggy.com/city/washim"
                            },
                            {
                                text: "Raghunathpur",
                                link: "https://www.swiggy.com/city/raghunathpur"
                            },
                            {
                                text: "Suri",
                                link: "https://www.swiggy.com/city/suri"
                            },
                            {
                                text: "Kadayanallur",
                                link: "https://www.swiggy.com/city/kadayanallur"
                            },
                            {
                                text: "Thiruvarur",
                                link: "https://www.swiggy.com/city/thiruvarur"
                            },
                            {
                                text: "Ranaghat-WB",
                                link: "https://www.swiggy.com/city/ranaghat-wb"
                            },
                            {
                                text: "Wayanad",
                                link: "https://www.swiggy.com/city/wayanad"
                            },
                            {
                                text: "Perambalur",
                                link: "https://www.swiggy.com/city/perambalur"
                            },
                            {
                                text: "Paramakudi",
                                link: "https://www.swiggy.com/city/paramakudi"
                            },
                            {
                                text: "Bela Pratapgarh",
                                link: "https://www.swiggy.com/city/bela-pratapgarh"
                            },
                            {
                                text: "Mahoba",
                                link: "https://www.swiggy.com/city/mahoba"
                            },
                            {
                                text: "Sitamarhi",
                                link: "https://www.swiggy.com/city/sitamarhi"
                            },
                            {
                                text: "Chakdaha",
                                link: "https://www.swiggy.com/city/chakdaha"
                            },
                            {
                                text: "Khalilabad",
                                link: "https://www.swiggy.com/city/khalilabad"
                            },
                            {
                                text: "Pattukkottai",
                                link: "https://www.swiggy.com/city/pattukkottai"
                            },
                            {
                                text: "Tindivanam",
                                link: "https://www.swiggy.com/city/tindivanam"
                            },
                            {
                                text: "Tiruttani",
                                link: "https://www.swiggy.com/city/tiruttani"
                            },
                            {
                                text: "Gangarampur",
                                link: "https://www.swiggy.com/city/gangarampur"
                            },
                            {
                                text: "Dharapuram",
                                link: "https://www.swiggy.com/city/dharapuram"
                            },
                            {
                                text: "Arakkonam",
                                link: "https://www.swiggy.com/city/arakkonam"
                            },
                            {
                                text: "Sirkali",
                                link: "https://www.swiggy.com/city/sirkali"
                            },
                            {
                                text: "Mettupalayam",
                                link: "https://www.swiggy.com/city/mettupalayam"
                            },
                            {
                                text: "Digboi",
                                link: "https://www.swiggy.com/city/digboi"
                            },
                            {
                                text: "Biswanath Chariali",
                                link: "https://www.swiggy.com/city/biswanath-chariali"
                            },
                            {
                                text: "Nalbari",
                                link: "https://www.swiggy.com/city/nalbari"
                            },
                            {
                                text: "Shirdi city",
                                link: "https://www.swiggy.com/city/shirdi-city"
                            },
                            {
                                text: "Mukerian",
                                link: "https://www.swiggy.com/city/mukerian"
                            },
                            {
                                text: "Hosur",
                                link: "https://www.swiggy.com/city/hosur"
                            },
                            {
                                text: "Palakollu",
                                link: "https://www.swiggy.com/city/palakollu"
                            },
                            {
                                text: "Ravulapalem",
                                link: "https://www.swiggy.com/city/ravulapalem"
                            },
                            {
                                text: "Barh",
                                link: "https://www.swiggy.com/city/barh"
                            },
                            {
                                text: "Palghar",
                                link: "https://www.swiggy.com/city/palghar"
                            },
                            {
                                text: "Kushalnagar",
                                link: "https://www.swiggy.com/city/kushalnagar"
                            },
                            {
                                text: "Dungarpur",
                                link: "https://www.swiggy.com/city/dungarpur"
                            },
                            {
                                text: "Chaibasa",
                                link: "https://www.swiggy.com/city/chaibasa"
                            },
                            {
                                text: "Haveri",
                                link: "https://www.swiggy.com/city/haveri"
                            },
                            {
                                text: "Karaikal",
                                link: "https://www.swiggy.com/city/karaikal"
                            },
                            {
                                text: "Jjajjar",
                                link: "https://www.swiggy.com/city/jjajjar"
                            },
                            {
                                text: "Kokrajhar",
                                link: "https://www.swiggy.com/city/kokrajhar"
                            },
                            {
                                text: "Rangia",
                                link: "https://www.swiggy.com/city/rangia"
                            },
                            {
                                text: "Hamirpur",
                                link: "https://www.swiggy.com/city/hamirpur"
                            },
                            {
                                text: "Una",
                                link: "https://www.swiggy.com/city/una"
                            },
                            {
                                text: "Sulthan Bathery",
                                link: "https://www.swiggy.com/city/sulthan-bathery"
                            },
                            {
                                text: "Rayagada",
                                link: "https://www.swiggy.com/city/rayagada"
                            },
                            {
                                text: "Paradeep",
                                link: "https://www.swiggy.com/city/paradeep"
                            },
                            {
                                text: "Mandapeta",
                                link: "https://www.swiggy.com/city/mandapeta"
                            },
                            {
                                text: "Jamui",
                                link: "https://www.swiggy.com/city/jamui"
                            },
                            {
                                text: "Pilkhuwa",
                                link: "https://www.swiggy.com/city/pilkhuwa"
                            },
                            {
                                text: "Parvathipuram",
                                link: "https://www.swiggy.com/city/parvathipuram"
                            },
                            {
                                text: "Ambajogai",
                                link: "https://www.swiggy.com/city/ambajogai"
                            },
                            {
                                text: "Araria",
                                link: "https://www.swiggy.com/city/araria"
                            },
                            {
                                text: "North Lakhimpur",
                                link: "https://www.swiggy.com/city/north-lakhimpur"
                            },
                            {
                                text: "Rajampet",
                                link: "https://www.swiggy.com/city/rajampet"
                            },
                            {
                                text: "Udumalaipettai",
                                link: "https://www.swiggy.com/city/udumalaipettai"
                            },
                            {
                                text: "Tirupattur",
                                link: "https://www.swiggy.com/city/tirupattur"
                            },
                            {
                                text: "Hojai",
                                link: "https://www.swiggy.com/city/hojai"
                            },
                            {
                                text: "Khagaria",
                                link: "https://www.swiggy.com/city/khagaria"
                            },
                            {
                                text: "Dasuya",
                                link: "https://www.swiggy.com/city/dasuya"
                            },
                            {
                                text: "Gudur",
                                link: "https://www.swiggy.com/city/gudur"
                            },
                            {
                                text: "Sullurpeta",
                                link: "https://www.swiggy.com/city/sullurpeta"
                            },
                            {
                                text: "Piler",
                                link: "https://www.swiggy.com/city/piler"
                            },
                            {
                                text: "SankaranKoil",
                                link: "https://www.swiggy.com/city/sankarankoil"
                            },
                            {
                                text: "Nabha",
                                link: "https://www.swiggy.com/city/nabha"
                            },
                            {
                                text: "LPU - Phagwara",
                                link: "https://www.swiggy.com/city/lpu-phagwara"
                            },
                            {
                                text: "Jangipur",
                                link: "https://www.swiggy.com/city/jangipur"
                            },
                            {
                                text: "Roha",
                                link: "https://www.swiggy.com/city/roha"
                            }
                        ],
                        id: "footer_content"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
                        citySlug: "faridabad",
                        lat: "28.4089123",
                        lng: "77.3177894",
                        userAgent: "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/123.0.0.0 Safari/537.36",
                        gandalfRequest: '{"sortAttribute":"relevance","isFiltered":false,"queryId":"seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e","seoParams":{"apiName":"FoodHomePage","brandId":"","seoUrl":"www.swiggy.com","pageType":"FOOD_HOME_PAGE"}}',
                        id: "meta_data",
                        metaInfo: {
                            pageType: "FOOD_HOME_PAGE",
                            pageTitle: "Order Food Online from India's Best Food Delivery Service | Swiggy",
                            pageMetaDescription: "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
                            pageKeywords: "Food delivery, Online food order, Online food dleivery"
                        },
                        screenType: "filteredCollection",
                        seoParams: {
                            apiName: "FoodHomePage",
                            seoUrl: "www.swiggy.com",
                            pageType: "FOOD_HOME_PAGE"
                        }
                    }
                }
            }
        ],
        firstOffsetRequest: true,
        cacheExpiryTime: 240,
        nextFetch: 1
    },
    tid: "77533f11-5e8d-4b54-a4a7-1c92985210c7",
    sid: "d3bd968b-8262-4755-a5c0-d4ee42f09309",
    deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
    csrfToken: "UwmkelsQ8Duk-9B3iU9InosXfu2k2oHASD-Klhgc"
};
var $6a504aa8891277a5$export$bc4d6c843416a567 = {
    statusCode: 0,
    data: {
        statusMessage: "done successfully",
        cards: [
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
                        text: "Dark Brown",
                        headerStyling: {
                            textColor: "text_Highest_Emphasis",
                            textVariant: "header_H3_Black"
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
                        tabs: [
                            {
                                id: "Order Online",
                                title: "Order Online"
                            }
                        ]
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                        info: {
                            id: "21986",
                            name: "Dark Brown",
                            city: "Faridabad",
                            slugs: {
                                restaurant: "dark-brown-sector-15-sector-15_archive",
                                city: "faridabad"
                            },
                            uniqueId: "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                            cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                            locality: "Shopping Centre Market",
                            areaName: "Sector 15",
                            costForTwo: "25000",
                            costForTwoMessage: "\u20B9250 for two",
                            cuisines: [
                                "Italian-American",
                                "Continental"
                            ],
                            avgRating: 4.2,
                            feeDetails: {
                                restaurantId: "21986",
                                fees: [
                                    {
                                        name: "TYPE_DISTANCE",
                                        fee: 4200
                                    },
                                    {
                                        name: "TYPE_TIME"
                                    }
                                ],
                                totalFee: 4200,
                                title: "Delivery Charge",
                                amount: "4200",
                                icon: "v1648635511/Delivery_fee_new_cjxumu"
                            },
                            parentId: "16162",
                            avgRatingString: "4.2",
                            totalRatingsString: "10K+ ratings",
                            sla: {
                                restaurantId: "21986",
                                deliveryTime: 26,
                                minDeliveryTime: 25,
                                maxDeliveryTime: 30,
                                lastMileTravel: 1.8,
                                serviceability: "SERVICEABLE",
                                stressFactor: 1,
                                rainMode: "RAIN_MODE_NONE",
                                longDistance: "LONG_DISTANCE_NOT_LONG_DISTANCE",
                                zoneId: 749,
                                slaString: "25-30 MINS",
                                lastMileTravelString: "1.7 km",
                                iconType: "ICON_TYPE_EMPTY"
                            },
                            availability: {
                                nextCloseTime: "2024-04-05 00:00:00",
                                visibility: true,
                                opened: true,
                                restaurantClosedMeta: {}
                            },
                            aggregatedDiscountInfo: {
                                header: "FLAT100 off",
                                shortDescriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                descriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                visible: true
                            },
                            badges: {},
                            slugString: "dark-brown-sector-15-sector-15_archive",
                            multiOutlet: true,
                            isOpen: true,
                            labels: [
                                {
                                    title: "Timings",
                                    message: "null"
                                },
                                {
                                    title: "Address",
                                    message: "Shop - 144, booth no.163, Huda Market, sec15, faridabad"
                                },
                                {
                                    title: "Cuisines",
                                    message: "Italian-American,Continental"
                                }
                            ],
                            totalRatings: 10000,
                            aggregatedDiscountInfoV2: {
                                header: "FLAT100 off",
                                shortDescriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                descriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                couponDetailsCta: "View coupon details"
                            },
                            type: "F",
                            nudgeBanners: [
                                {
                                    minValue: 125,
                                    maxValue: 179,
                                    priority: 2,
                                    couponCode: "SAVINGS4ME",
                                    discountInfo: {
                                        discountType: "Percentage",
                                        value: 20
                                    },
                                    logoCtx: {}
                                },
                                {
                                    minValue: 279,
                                    maxValue: 399,
                                    priority: 3,
                                    couponCode: "MDM150",
                                    discountInfo: {
                                        discountType: "Flat",
                                        value: 150
                                    },
                                    lockedMessage: "Add items worth \u20B9<amount> to save \u20B9150 | Code MDM150",
                                    unlockedMessage: "MDM150 Coupon Unlocked! Use it to save \u20B9150",
                                    logoCtx: {}
                                }
                            ],
                            headerBanner: {
                                url: "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/21986"
                            },
                            expectationNotifiers: [
                                {
                                    icon: {
                                        imageId: "v1648635511/Delivery_fee_new_cjxumu"
                                    },
                                    popup: {
                                        cta: {}
                                    },
                                    type: "DISTANCE_FEE_NON_FOOD_LM",
                                    enrichedText: "<b>1.8 km</b> | <del>\u20B942</del> Free Delivery on your order",
                                    halfCardPopup: {
                                        halfCardPopupHeader: {}
                                    }
                                }
                            ],
                            ratingSlab: "RATING_SLAB_5",
                            orderabilityCommunication: {
                                title: {},
                                subTitle: {},
                                message: {},
                                customIcon: {}
                            },
                            cartOrderabilityNudgeBanner: {
                                parameters: {},
                                presentation: {}
                            },
                            latLong: "28.395346190109397,77.32197622453688",
                            backgroundImageOverlayInfo: {}
                        },
                        analytics: {}
                    },
                    relevance: {
                        type: "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
                        sectionId: "POP_UP_CROUTON_MENU"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        layout: {
                            rows: 1,
                            columns: 5,
                            horizontalScrollEnabled: true,
                            itemSpacing: 12,
                            lineSpacing: 10,
                            widgetPadding: {},
                            containerStyle: {
                                containerPadding: {
                                    left: 10,
                                    right: 10,
                                    bottom: 16
                                }
                            },
                            scrollBar: {}
                        },
                        id: "offerCollectionWidget_UX4",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                                offers: [
                                    {
                                        info: {
                                            header: "FLAT \u20B9100 OFF",
                                            offerTag: "LATE NIGHT",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "21b510e6-d1e5-49f2-9a0c-7c8df2376113"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE LNBINGE",
                                            description: "ABOVE \u20B9249",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "20% OFF UPTO \u20B945",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "bec108ac-7985-4c49-a231-2f489c7bfa89"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE SAVINGS4ME",
                                            description: "ABOVE \u20B9179",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "FLAT \u20B9150 OFF",
                                            offerTag: "FLAT DEAL",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "2b0a5844-c1d1-48db-a745-1fc78a37b6e4"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE MDM150",
                                            description: "ABOVE \u20B9399",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "15% OFF UPTO \u20B9150",
                                            offerTagColor: "#E46D47",
                                            logoBottom: "MARKETING_BANNERS/IMAGES/OFFERS/2024/3/31/5e5be43d-5232-4afc-843d-d828639ae129_HSBC.png",
                                            offerIds: [
                                                "7b012c7c-a7e1-49d7-a84a-2ba6e1224780"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE HSBCMANIA",
                                            description: "ABOVE \u20B9499",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "MARKETING_BANNERS/IMAGES/OFFERS/2024/3/31/5e5be43d-5232-4afc-843d-d828639ae129_HSBC.png",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "FLAT \u20B9125 OFF",
                                            offerTag: "FLAT DEAL",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "84cd7bc1-65e3-4f0a-9280-844a68d9d474"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE FLAT125",
                                            description: "ABOVE \u20B9249",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    }
                                ],
                                habitMilestoneInfo: {
                                    callout: {}
                                },
                                loyaltyDiscoverPresentationInfo: {
                                    logoCtx: {}
                                }
                            }
                        }
                    }
                }
            },
            {
                groupedCard: {
                    cardGroupMap: {
                        REGULAR: {
                            cards: [
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                            badges: {},
                                            vegOnlyDetails: {
                                                imageId: "AutoVegOnly_qkjowj",
                                                title: "Showing only vegetarian options.",
                                                description: "Tap on the VEG ONLY button to turn off the setting"
                                            },
                                            topRatedFilter: {},
                                            kidsCategoryFilter: {
                                                attributes: {
                                                    displayText: "Kids Favourites",
                                                    tooltip: {
                                                        enabled: true,
                                                        displayText: "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                                    }
                                                }
                                            },
                                            vegFilter: {
                                                attributes: {
                                                    displayText: "VEG"
                                                }
                                            },
                                            nonvegFilter: {
                                                attributes: {
                                                    displayText: "NONVEG"
                                                }
                                            }
                                        },
                                        relevance: {
                                            type: "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                                            sectionId: "MENU_FILTER_TOGGLE"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                                            title: "Top Picks",
                                            carousel: [
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814238",
                                                    creativeId: "TopPicks/12563599B.png",
                                                    title: "Grilled Veg Paneer Sandwich",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "12563599",
                                                            name: "Grilled Veg Paneer Sandwich",
                                                            category: "Sandwich",
                                                            description: "Grilled Paneer + Tomato + Onion + Tandoori Mayonnaise",
                                                            imageId: "str6dgmj5eya9agsgnvb",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814237",
                                                    creativeId: "TopPicks/4077858B.png",
                                                    title: "Davidoff Coffee",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "4077858",
                                                            name: "Davidoff Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814239",
                                                    creativeId: "TopPicks/96805980B.png",
                                                    title: "Hot Brownie With Hot Chocolate",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "96805980",
                                                            name: "Hot Brownie With Hot Chocolate",
                                                            category: "Desserts",
                                                            description: "Serves 1",
                                                            imageId: "9079c5941e9c9ec99c9e1b3aed4c53ea",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814235",
                                                    creativeId: "TopPicks/100949073B.png",
                                                    title: "Mix Sauce Pasta (Penne)",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "100949073",
                                                            name: "Mix Sauce Pasta (Penne)",
                                                            category: "Pastas",
                                                            description: "Serves 1",
                                                            imageId: "59a99f7eee5a4656b7b6d82490857463",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814236",
                                                    creativeId: "TopPicks/4077862B.png",
                                                    title: "Cold Coffee",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "4077862",
                                                            name: "Cold Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "thvril6hi8fwrftuuayg",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Recommended",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000919",
                                                            name: "Tomato Basil Soup",
                                                            category: "Soups",
                                                            imageId: "7491a231591f7c8ef6299a3846e59f22",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "44 ratings",
                                                                    ratingCountV2: "44"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000922",
                                                            name: "Minestrone Soup",
                                                            category: "Soups",
                                                            imageId: "5d42ac81e15221854bcff2f2728b0756",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "19 ratings",
                                                                    ratingCountV2: "19"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000924",
                                                            name: "Broccoli Mushroom Soup",
                                                            category: "Soups",
                                                            imageId: "74d5792e3f3cbdbc6da69228f53e394a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "50 ratings",
                                                                    ratingCountV2: "50"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806071",
                                                            name: "Veg Manchow Soup",
                                                            category: "Soups",
                                                            imageId: "05307aa34e454058947fda4617a93185",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806072",
                                                            name: "Veg Hot & Sour Soup",
                                                            category: "Soups",
                                                            imageId: "cvw4mo9midegdkky6v1a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806080",
                                                            name: "Veg Spring Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1 | Deep-fried, stuffed rolls packed with seasoned assorted veggies.",
                                                            imageId: "uixdrme6e8v6udsill2b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "24 ratings",
                                                                    ratingCountV2: "24"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "73170622",
                                                            name: "Crispy Corn",
                                                            category: "Appetizers",
                                                            imageId: "2c482f34b257753b843846b77bda83ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000929",
                                                            name: "Mozzarella Cheese Stick",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "a5553c3cccf840486b4651bb43d6193c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000931",
                                                            name: "Cottage Cheese Finger",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "8247914a73d640b489ea18fd9da204c2",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000933",
                                                            name: "Mac An Cheese Roll",
                                                            category: "Appetizers",
                                                            imageId: "c3c9f192e21cda38a103b730eeabb617",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.2",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000938",
                                                            name: "Veg Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "y5wdcgfyq3zvieb9tq7k",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 35000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "40 ratings",
                                                                    ratingCountV2: "40"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373200",
                                                            name: "Cheesy Chicken Garlic Bread",
                                                            category: "Appetizers",
                                                            imageId: "6ea2115c9beb322d26f55e9434013258",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388291",
                                                            name: "Fish Finger",
                                                            category: "Appetizers",
                                                            imageId: "fr5h5gd3136chq0qmb2k",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.6",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388364",
                                                            name: "Chicken Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "3de7c0cd4d3a33f610dfb59cc0330fba",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388366",
                                                            name: "Grilled Chicken Tacos",
                                                            category: "Appetizers",
                                                            imageId: "3459612908fefb04a7b6a474f455117a",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388368",
                                                            name: "Chicken Corn Paper Tacos",
                                                            category: "Appetizers",
                                                            imageId: "c10090e963cebe1ca4fc0030ba692108",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388371",
                                                            name: "Signature Chicken Nachos",
                                                            category: "Appetizers",
                                                            imageId: "132354fc2cfdd5bcfcaad7ccd29c6731",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806100",
                                                            name: "Chicken & Cheese Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "70281f65f7a8ac41a197cd571fa242d0",
                                                            inStock: 1,
                                                            price: 43000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806103",
                                                            name: "Chicken Special Roll",
                                                            category: "Appetizers",
                                                            imageId: "f818471f535553a4351c1490b80147a4",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021818",
                                                            name: "Veg Noodles",
                                                            category: "Chinese",
                                                            description: "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                                            imageId: "d2dkjmf5h7vil9zzjnoo",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "84 ratings",
                                                                    ratingCountV2: "84"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ],
                                            type: "CATEGORY_TYPE_RECOMMENDED"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Soups",
                                            categories: [
                                                {
                                                    title: "Soups",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "119531729",
                                                                    name: "Veg Tom Yum Soup",
                                                                    category: "Soups",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 19900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "131044284",
                                                                    name: "Sweet Corn Soup",
                                                                    category: "Soups",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "25000919",
                                                                    name: "Tomato Basil Soup",
                                                                    category: "Soups",
                                                                    imageId: "7491a231591f7c8ef6299a3846e59f22",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 15000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "44 ratings",
                                                                            ratingCountV2: "44"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "25000922",
                                                                    name: "Minestrone Soup",
                                                                    category: "Soups",
                                                                    imageId: "5d42ac81e15221854bcff2f2728b0756",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 15000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.7",
                                                                            ratingCount: "19 ratings",
                                                                            ratingCountV2: "19"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "25000924",
                                                                    name: "Broccoli Mushroom Soup",
                                                                    category: "Soups",
                                                                    imageId: "74d5792e3f3cbdbc6da69228f53e394a",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "50 ratings",
                                                                            ratingCountV2: "50"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806071",
                                                                    name: "Veg Manchow Soup",
                                                                    category: "Soups",
                                                                    imageId: "05307aa34e454058947fda4617a93185",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "1.7",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806072",
                                                                    name: "Veg Hot & Sour Soup",
                                                                    category: "Soups",
                                                                    imageId: "cvw4mo9midegdkky6v1a",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.9",
                                                                            ratingCount: "4 ratings",
                                                                            ratingCountV2: "4"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Appetizers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044959",
                                                            name: "Chicken Spring Roll",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 32100,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000927",
                                                            name: "Corn & Cheese Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806080",
                                                            name: "Veg Spring Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1 | Deep-fried, stuffed rolls packed with seasoned assorted veggies.",
                                                            imageId: "uixdrme6e8v6udsill2b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "24 ratings",
                                                                    ratingCountV2: "24"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "73170622",
                                                            name: "Crispy Corn",
                                                            category: "Appetizers",
                                                            imageId: "2c482f34b257753b843846b77bda83ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67996521",
                                                            name: "Paneer Kulcha",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000929",
                                                            name: "Mozzarella Cheese Stick",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "a5553c3cccf840486b4651bb43d6193c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000931",
                                                            name: "Cottage Cheese Finger",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "8247914a73d640b489ea18fd9da204c2",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000933",
                                                            name: "Mac An Cheese Roll",
                                                            category: "Appetizers",
                                                            imageId: "c3c9f192e21cda38a103b730eeabb617",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.2",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000938",
                                                            name: "Veg Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "y5wdcgfyq3zvieb9tq7k",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 35000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "40 ratings",
                                                                    ratingCountV2: "40"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676683",
                                                            name: "Chicken Cheese Finger",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 48000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373200",
                                                            name: "Cheesy Chicken Garlic Bread",
                                                            category: "Appetizers",
                                                            imageId: "6ea2115c9beb322d26f55e9434013258",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373205",
                                                            name: "Chicken Cheese Fries",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "59141394",
                                                            name: "Dynamite Chicken",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "pfoied7sjl36bcui9gnv",
                                                            inStock: 1,
                                                            price: 56000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388285",
                                                            name: "Caucasian Spice Fish & Chips",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 72000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388291",
                                                            name: "Fish Finger",
                                                            category: "Appetizers",
                                                            imageId: "fr5h5gd3136chq0qmb2k",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.6",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388363",
                                                            name: "Moroccan Chicken",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388364",
                                                            name: "Chicken Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "3de7c0cd4d3a33f610dfb59cc0330fba",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388366",
                                                            name: "Grilled Chicken Tacos",
                                                            category: "Appetizers",
                                                            imageId: "3459612908fefb04a7b6a474f455117a",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388368",
                                                            name: "Chicken Corn Paper Tacos",
                                                            category: "Appetizers",
                                                            imageId: "c10090e963cebe1ca4fc0030ba692108",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388371",
                                                            name: "Signature Chicken Nachos",
                                                            category: "Appetizers",
                                                            imageId: "132354fc2cfdd5bcfcaad7ccd29c6731",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388372",
                                                            name: "Twist Cone Fish",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 72000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806098",
                                                            name: "Chicken Kulcha ",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806100",
                                                            name: "Chicken & Cheese Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "70281f65f7a8ac41a197cd571fa242d0",
                                                            inStock: 1,
                                                            price: 43000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806103",
                                                            name: "Chicken Special Roll",
                                                            category: "Appetizers",
                                                            imageId: "f818471f535553a4351c1490b80147a4",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Chinese",
                                            categories: [
                                                {
                                                    title: "Chinese",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "119533395",
                                                                    name: "Singapori Veg Noodle",
                                                                    category: "Chinese",
                                                                    imageId: "343db05cc4b92f3a6163b7d9e1a081db",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.7",
                                                                            ratingCount: "18 ratings",
                                                                            ratingCountV2: "18"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021818",
                                                                    name: "Veg Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                                                    imageId: "d2dkjmf5h7vil9zzjnoo",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "84 ratings",
                                                                            ratingCountV2: "84"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021823",
                                                                    name: "Chilli Potato",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "lw8unhoxkntfp5ikqbc6",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.7",
                                                                            ratingCount: "113 ratings",
                                                                            ratingCountV2: "113"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "60883673",
                                                                    name: "Schezwan Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "hu6hvqbmdsyfgr9n05zq",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.6",
                                                                            ratingCount: "23 ratings",
                                                                            ratingCountV2: "23"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021822",
                                                                    name: "Chilli Garlic Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | A spicy stir fry of assorted veggies and noodles tossed in hot chilli garlic sauce.",
                                                                    imageId: "fahvbq7m9vzrjyzcpl1i",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.3",
                                                                            ratingCount: "188 ratings",
                                                                            ratingCountV2: "188"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021825",
                                                                    name: "Chilli Paneer Dry",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | Diced Paneer (Indian Cottage Cheese) tossed in spicy sauce made with soya sauce, chilli sauce and Vinegar.",
                                                                    imageId: "eydcdhxfvdavqdpovbuo",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 45000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.9",
                                                                            ratingCount: "64 ratings",
                                                                            ratingCountV2: "64"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "60883672",
                                                                    name: "Veg Fried Rice",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "5614f60a7659fac365eac10e453d3b06",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "7 ratings",
                                                                            ratingCountV2: "7"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806024",
                                                                    name: "Honey Chilli Potato",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | Finger potatoes tossed with sriracha, honey, sesame & spring onions.",
                                                                    imageId: "44f09c62ba809fb44e3f129de196fba1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.9",
                                                                            ratingCount: "41 ratings",
                                                                            ratingCountV2: "41"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806029",
                                                                    name: "Veg. Manchurian Dry",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "d62187bc8fa90a8ff08b4eb59cf84167",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 42000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.9",
                                                                            ratingCount: "41 ratings",
                                                                            ratingCountV2: "41"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806031",
                                                                    name: "Chilli Mushroom Dry ",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "f7f8c3947284c8ace4c08fff7d95256c",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 42000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806034",
                                                                    name: "Veg. Salt N Pepper",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 42000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021820",
                                                                    name: "Hakka Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                                                    imageId: "gwlgrufdtbwa6jizzuq3",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.3",
                                                                            ratingCount: "104 ratings",
                                                                            ratingCountV2: "104"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Coffees, Shakes And Crushers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044281",
                                                            name: "Nutella Brownie Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "127034563",
                                                            name: "Biscoff Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077865",
                                                            name: "Strawberry Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "A refreshing milkshake prepared with strawberry sauce, ice cream and wholesome milk perfect to satisfy your cravings.",
                                                            imageId: "srrcen0hsajeed0pbsta",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "267 ratings",
                                                                    ratingCountV2: "267"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271203",
                                                            name: "Vanilla Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077862",
                                                            name: "Cold Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "thvril6hi8fwrftuuayg",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "1555 ratings",
                                                                    ratingCountV2: "1555"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805969",
                                                            name: "Kitkat Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Combination of kitkat and chocolate sauce to make it a perfect thick shake.",
                                                            imageId: "sx5w4k7sovbg6ueogbxe",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "695 ratings",
                                                                    ratingCountV2: "695"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271204",
                                                            name: "Irish Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "224528e353a23792cf44cc67ac22dc4c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "23 ratings",
                                                                    ratingCountV2: "23"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805982",
                                                            name: "Nutella Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "A perfect blend of milk, nutella, and soft vanilla ice cream. A classic for summers. Serves 1-2",
                                                            imageId: "pfl2dfavnuwxxs3rifkg",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021805",
                                                            name: "Tiramisu Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Tiramisu Frappe Blended with Chocolate Choco Chips",
                                                            imageId: "pwvnpo8lxbvdgpllb09g",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373206",
                                                            name: "Chocolate Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373208",
                                                            name: "Ferrero Rocher Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077848",
                                                            name: "Cafe Choco Cookie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.2",
                                                                    ratingCount: "50 ratings",
                                                                    ratingCountV2: "50"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628463",
                                                            name: "Caramel Frappe",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628464",
                                                            name: "Hazelnut Frappe",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Serves 1",
                                                            imageId: "cd0763f82c02ecf62408f91aa237ead9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "60 ratings",
                                                                    ratingCountV2: "60"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271213",
                                                            name: "Mocha Frappe",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "53a1390972bbd7c63cdf1aaadff21385",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "91 ratings",
                                                                    ratingCountV2: "91"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077858",
                                                            name: "Davidoff Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "307 ratings",
                                                                    ratingCountV2: "307"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "85675793",
                                                            name: "Blackberry Mango",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271214",
                                                            name: "Belgian Choco Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "4978a35f9bf554b45da8fb795a722ade",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "226 ratings",
                                                                    ratingCountV2: "226"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628465",
                                                            name: "Ferrero Rocher Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "86729088fd68e7bbd28d54be175485b5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 34900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "43 ratings",
                                                                    ratingCountV2: "43"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021855",
                                                            name: "Peanut Butter",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "311a9f9ef4c5fa16d6495e66b4c5682d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805929",
                                                            name: "Almond Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805934",
                                                            name: "Tiramisu Chip ",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805937",
                                                            name: "Dark Brownie Crusher",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "cd0f52cca7ee7dc16f734389e6a9d3ea",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "109 ratings",
                                                                    ratingCountV2: "109"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805947",
                                                            name: "Oreo Chocolate",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "4b6dddf2fc5c3d8c4b504d6d1cc9ee69",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "98 ratings",
                                                                    ratingCountV2: "98"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805949",
                                                            name: "Oreo Mint",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "4b6dddf2fc5c3d8c4b504d6d1cc9ee69",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805951",
                                                            name: "Oreo Strawberry",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805955",
                                                            name: "Berry Oreo Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805956",
                                                            name: "Oreo Mango",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "cuoech9pjhqtjmftyiyo",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805958",
                                                            name: "Oreo Walnut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805960",
                                                            name: "Oreo Black Currant",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.1",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805962",
                                                            name: "Oreo Vanilla",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805964",
                                                            name: "Choco Banana Oreo Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "c58b8d7fd7a29e4f4f3c8b86d69d684e",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805966",
                                                            name: "Red Velvet Oreo",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805971",
                                                            name: "Blackcurrant Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "657332a561f2f18fdc3e4f800b88c7fe",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "18 ratings",
                                                                    ratingCountV2: "18"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805972",
                                                            name: "Heartbeat Crusher",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805974",
                                                            name: "Chocolate Choco chip",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "25 ratings",
                                                                    ratingCountV2: "25"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805976",
                                                            name: "Vanilla Choco chip",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805978",
                                                            name: "Banana Walnut Choco chip",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805979",
                                                            name: "Mint Chocolate Chip Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805983",
                                                            name: "Nutella Peanut",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805984",
                                                            name: "Snickers Smoothie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805985",
                                                            name: "Peanut Banana",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "24bb523b11f330fffaa0c69f6d03cb2f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805989",
                                                            name: "Kesar Almond Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805993",
                                                            name: "Protein Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805994",
                                                            name: "Blueberry Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805997",
                                                            name: "Mixed Berry Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805998",
                                                            name: "Paan Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806001",
                                                            name: "Saffron Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806003",
                                                            name: "Chocolate Banana Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806006",
                                                            name: "Vanilla Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "6f24f0ae20baedb3d3bb2843492a6f4a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806008",
                                                            name: "Chocolate Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "rlvntu5uxy778d9ujhqd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "33 ratings",
                                                                    ratingCountV2: "33"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806011",
                                                            name: "Pineapple Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "cf038b2e80057ee7f32ff3883cf6c83d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806013",
                                                            name: "Alphonso Mango",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "f10d92d6b69c6c7db113ec8b17ef2997",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806017",
                                                            name: "Strawberry Chocolate Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.2",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806018",
                                                            name: "Strawberry Walnut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806021",
                                                            name: "Butterscotch Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "86bc8d2e39bcb3bd291e24d0b26a8a1c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "92 ratings",
                                                                    ratingCountV2: "92"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806023",
                                                            name: "Caramel Lovers",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "db499d83469b01ef81c5c9b568cddcaf",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806026",
                                                            name: "Caramel Popcorn Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806028",
                                                            name: "Pina Alphonso Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "95a1c40dd30521c0e4a167f966392eb9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806030",
                                                            name: "Marshmallow Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806032",
                                                            name: "Love Rose Vanilla",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 20000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806035",
                                                            name: "Red Velvet Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806037",
                                                            name: "Vanilla Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "2a869e2f73b9adef412e600cdbd0626f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806039",
                                                            name: "Chocolate Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806041",
                                                            name: "Monkey Banana Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "083293181b88b7ba910c873ebe8dea78",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806044",
                                                            name: "Bubble-gum Marshmallow",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806046",
                                                            name: "Bubble-gum Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "10 ratings",
                                                                    ratingCountV2: "10"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806048",
                                                            name: "Fruit & Nut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806050",
                                                            name: "Banoffee Pie Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806052",
                                                            name: "Tiramisu Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806054",
                                                            name: "Nutella Cheese Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806056",
                                                            name: "Blueberry Cheesecake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806058",
                                                            name: "Nutella Caramel Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806062",
                                                            name: "Kiwi Strawberry Smoothie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "7611804852b854642f932faf541f27c8",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806064",
                                                            name: "Strawberry Banana Smoothie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "bc231ce0b57f77eecd1091fbaeccb0c1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806066",
                                                            name: "Chocolate Paan Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "0ff51573d1d68ad15c113280f954093f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806070",
                                                            name: "Five Star",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "103707100",
                                                            name: "Chocolate Hazelnut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Richness of chocolate blended with hazelnut touch makes a deadly combination for shake lovers",
                                                            imageId: "a09bace04d68657d996e028f93284c3f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805946",
                                                            name: "Choco Brownie Crusher",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "140 ratings",
                                                                    ratingCountV2: "140"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805952",
                                                            name: "Nutella Oreo",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "ad8aaa3ea9674eeee5e4a5775c56cfa2",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "40 ratings",
                                                                    ratingCountV2: "40"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "112579342",
                                                            name: "Tutti Fruitti Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "112579343",
                                                            name: "Rose Paan Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805967",
                                                            name: "Red Velvet Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Salads",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044961",
                                                            name: "Chicken Tikka Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563608",
                                                            name: "Veg Caesar Salad",
                                                            category: "Salads",
                                                            description: "Iceberg, lettuce green, olive, cherry tomato, broccoli and parmesan cheese and creamy dressing.",
                                                            imageId: "43eb7ec82b0b334ac76335309d9adcf6",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.0",
                                                                    ratingCount: "70 ratings",
                                                                    ratingCountV2: "70"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563611",
                                                            name: "Grilled Veg Salad",
                                                            category: "Salads",
                                                            description: "Iceberg, broccoli, beans, zucchini, carrot, olives, onion, tomato [hot salad with olive oil].",
                                                            imageId: "c6b86b6430624f3b4eed461cb212a502",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "143 ratings",
                                                                    ratingCountV2: "143"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563609",
                                                            name: "Barbeque Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806074",
                                                            name: "Broccoli Mushroom Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "59 ratings",
                                                                    ratingCountV2: "59"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000926",
                                                            name: "Cottage Cheese Pineapple Salad",
                                                            category: "Salads",
                                                            imageId: "2713c5fd49af1b7088eef988bc21106f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676682",
                                                            name: "Smoke Chicken Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 44000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58162988",
                                                            name: "Brisket Chicken Creamy Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 39000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388245",
                                                            name: "Chicken Pineapple Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388247",
                                                            name: "Grilled Chicken Salad",
                                                            category: "Salads",
                                                            imageId: "b2233572d9e9a64f7e40e1ed2116e9da",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "73 ratings",
                                                                    ratingCountV2: "73"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806086",
                                                            name: "Chicken Caesar Salad ",
                                                            category: "Salads",
                                                            imageId: "42dfc1326334f98e56417eeaac98d364",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "33 ratings",
                                                                    ratingCountV2: "33"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806090",
                                                            name: "Crispy Fish Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 48000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119532321",
                                                            name: "Aloo Tikki Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119532322",
                                                            name: "Paneer Tikka Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Wraps",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119533397",
                                                            name: "Chilli Mushroom Wrap",
                                                            category: "Wraps",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563592",
                                                            name: "Paneer Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1 | Paneer, bell pepper, capsicum, onion, cabbage, garlic sauce and spicy oregano.",
                                                            imageId: "24047a9b9013325dc9256f7e29017925",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "103 ratings",
                                                                    ratingCountV2: "103"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563597",
                                                            name: "Spicy Paneer Tikka Wraps",
                                                            category: "Wraps",
                                                            description: "Medium Spicy | Serves 1 | Juicy grilled paneer tikka stuffed and rolled into a scrumptious wrap.",
                                                            imageId: "htpsddiwuuqybtsp4hyx",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "366 ratings",
                                                                    ratingCountV2: "366"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563594",
                                                            name: "Soya Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1 | Bell pepper, capsicum, onion, cabbage, Nutella chunks, oregano, chilli flakes and sauce.",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.5",
                                                                    ratingCount: "71 ratings",
                                                                    ratingCountV2: "71"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563598",
                                                            name: "Corny Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1 | Bell pepper, capsicum, onion, cabbage, sweet corn, oregano, chilli flakes and sauce.",
                                                            imageId: "53c1b023e1a0b88d6ae10027bd2be5e7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859012",
                                                            name: "Egg & Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "85a0321ca6e2da91d8156dcb80d73fba",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859011",
                                                            name: "Crispy Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "wm2pxqoge4u4dlqasnzl",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388417",
                                                            name: "Chilli Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "253c0d587fdb5db9d2309239e4f928b6",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.2",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388421",
                                                            name: "Pesto Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "7565ad519b92deeed37a5aa1a37ae783",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806116",
                                                            name: "Grilled Veg. Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "b58163bc53960b84a3d785c88d005ec6",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "47 ratings",
                                                                    ratingCountV2: "47"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806166",
                                                            name: "Chicken Shawarma Wrap ",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "z9vqfpotga887cb6okjc",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "29 ratings",
                                                                    ratingCountV2: "29"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388419",
                                                            name: "Grilled Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Hot Beverages",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "62668406",
                                                            name: "Hot Chocolate Drink",
                                                            category: "Hot Beverages",
                                                            imageId: "5f64a8a54ba3fb81172807d6458ef955",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "25 ratings",
                                                                    ratingCountV2: "25"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806079",
                                                            name: "Molten Hot Chocolate Drink",
                                                            category: "Hot Beverages",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Sandwich",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044299",
                                                            name: "Mushroom Capsicum Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044300",
                                                            name: "Spinach & Corn Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22200,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563599",
                                                            name: "Grilled Veg Paneer Sandwich",
                                                            category: "Sandwich",
                                                            description: "Grilled Paneer + Tomato + Onion + Tandoori Mayonnaise",
                                                            imageId: "str6dgmj5eya9agsgnvb",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "413 ratings",
                                                                    ratingCountV2: "413"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077798",
                                                            name: "Classic Tandoori Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "40e4f266cf84360d5d9627d5e6c72ae0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.6",
                                                                    ratingCount: "270 ratings",
                                                                    ratingCountV2: "270"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563604",
                                                            name: "Classic Spicy Sandwich",
                                                            category: "Sandwich",
                                                            description: "Medium Spicy | Serves 1 | Capsicum + Broccoli +Zucchini + Jalapeno with Spicy Red Sauce & Cheese",
                                                            imageId: "94a98482c0464145876da568c6798527",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "47 ratings",
                                                                    ratingCountV2: "47"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628459",
                                                            name: "Aloo Tikki Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "84 ratings",
                                                                    ratingCountV2: "84"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563600",
                                                            name: "Cheese Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "xj01vjh08icbrhu420pc",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "27 ratings",
                                                                    ratingCountV2: "27"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563602",
                                                            name: "American Cheese Sandwich",
                                                            category: "Sandwich",
                                                            description: "Broccoli + Beans + Zucchini + Carrot + Capsicum + Onion + White Cream Sauce",
                                                            imageId: "c1adipam0khlnpzhs9dx",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "33 ratings",
                                                                    ratingCountV2: "33"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563603",
                                                            name: "Club Sandwich",
                                                            category: "Sandwich",
                                                            description: "Broccoli + Zucchini + Beans + Carrot + Jalapeno with Creamy Red Sauce",
                                                            imageId: "jkjlc3veehrqrhnrnyoy",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "74 ratings",
                                                                    ratingCountV2: "74"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021815",
                                                            name: "Falafel Hummus Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "24 ratings",
                                                                    ratingCountV2: "24"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443767",
                                                            name: "Dark Brown Special Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "28 ratings",
                                                                    ratingCountV2: "28"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443770",
                                                            name: "Chicken Seekh Kabab Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            imageId: "14dcb6590eae683347d10110e3e6e149",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388431",
                                                            name: "Grilled Chicken Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "ec63478e4ad42136c9487610eee216d1",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "30 ratings",
                                                                    ratingCountV2: "30"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388434",
                                                            name: "Open Melted Chicken Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388436",
                                                            name: "Chicken Club Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            imageId: "ee1d9bc6bcf464604ff0cec46b9c02ef",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388441",
                                                            name: "Chicken Peri Peri Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "2a442efd895aa9fa05506b2315abba04",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805936",
                                                            name: "Veg. Grilled Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            imageId: "091477b70271890f13a61d7780e819d6",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "216 ratings",
                                                                    ratingCountV2: "216"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805939",
                                                            name: "Veg. Delight Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806078",
                                                            name: "Roast Chicken Crispy Club Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443768",
                                                            name: "Mutton Seekh Kabab Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Burgers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831785",
                                                            name: "Aloo Tikki Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "3cc3ae08ba8560f910f0381f2566ce5d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "393 ratings",
                                                                    ratingCountV2: "393"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831787",
                                                            name: "Cheese Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "jsu8qp3kwejvrb0xrddl",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "317 ratings",
                                                                    ratingCountV2: "317"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831788",
                                                            name: "Herbs Chilli Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "vpkswls0bwkvma5y9x3j",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "674 ratings",
                                                                    ratingCountV2: "674"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831789",
                                                            name: "Paneer Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "9ece4c79b3c9925160c8b5ed04aa5cca",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "162 ratings",
                                                                    ratingCountV2: "162"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563607",
                                                            name: "Green Garden Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "568be84be60e75c383cb48297f33cfc0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "68 ratings",
                                                                    ratingCountV2: "68"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021821",
                                                            name: "Open Veg Garden",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "18 ratings",
                                                                    ratingCountV2: "18"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676686",
                                                            name: "Juicy Chicken Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "9bddd257aa31d6cc24a916819c4cdb1e",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "16 ratings",
                                                                    ratingCountV2: "16"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676685",
                                                            name: "Egg Chicken Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "9bddd257aa31d6cc24a916819c4cdb1e",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080568",
                                                            name: "Mutton Tikki Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "71c6bae748d2a5a672a09264d64b363e",
                                                            inStock: 1,
                                                            price: 33000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.3",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388387",
                                                            name: "Chicken Tikki Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "88750040ce94d78adb8ac68e2efac7bc",
                                                            inStock: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388388",
                                                            name: "Pesto Chicken Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "75c578ed2633d445087409881a9f49b8",
                                                            inStock: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806117",
                                                            name: "Falafel Hummus Wraps",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.5",
                                                                    ratingCount: "52 ratings",
                                                                    ratingCountV2: "52"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806154",
                                                            name: "Grilled Chicken Burger ",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "xzqv0r3aasdrdrahyfig",
                                                            inStock: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806155",
                                                            name: "Fish And Chips Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "2d720e91506f3c93c7f04dba210a64a5",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Side Offers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443796",
                                                            name: "Cheese Garlic Bread",
                                                            category: "Side Offers",
                                                            description: "Serves 1 | Everything is Better with cheese & Garlicky Goodness.",
                                                            imageId: "ljygnylffanzx7rcsrxv",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 20000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "152 ratings",
                                                                    ratingCountV2: "152"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443793",
                                                            name: "Cheese Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "0d5b791377da53cf7c2102a278980a0a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "17 ratings",
                                                                    ratingCountV2: "17"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443773",
                                                            name: "Crunchy French Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "535619e08224a48b22c816fb14f363dd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563572",
                                                            name: "French Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "b7551843b418ccdf3584d1d148588057",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "152 ratings",
                                                                    ratingCountV2: "152"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563573",
                                                            name: "Garlic Bread Plain",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "0148886a811d917f3952631ff0d093af",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "75 ratings",
                                                                    ratingCountV2: "75"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563575",
                                                            name: "Falafel Pita Hummus",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "fd3068ca6121aa76c85425f2e1cf5969",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "94 ratings",
                                                                    ratingCountV2: "94"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805954",
                                                            name: "Peri Peri Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "bae234a686ed5dbdb846fd0ffdee319f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805988",
                                                            name: "Stuff Garlic Bread",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "mstnbqyyxfbazybgeedi",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805996",
                                                            name: "Nachos With Cheese",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "69f5be1332c45ea91d13d59be7b20874",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "105 ratings",
                                                                    ratingCountV2: "105"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "112579341",
                                                            name: "Cheese Peri-peri Fries",
                                                            category: "Side Offers",
                                                            description: "Peri peri fries loaded with melted mozzarella cheese",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Crispers Kingdom",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "64346558",
                                                            name: "Crispy Chicken Burger ",
                                                            category: "Crispers Kingdom",
                                                            description: "Serves 1",
                                                            imageId: "vov2s292tdwfqmalrfg2",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "15 ratings",
                                                                    ratingCountV2: "15"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806082",
                                                            name: "Crispy Chicken Salad",
                                                            category: "Crispers Kingdom",
                                                            description: "Serves 1",
                                                            imageId: "42dfc1326334f98e56417eeaac98d364",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Thirsty Quenchers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "94150142",
                                                            name: "Chilli Guava",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "94150141",
                                                            name: "Yuzu",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080573",
                                                            name: "Cumber Masala",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080572",
                                                            name: "Strawberry Masala",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080571",
                                                            name: "Masala Soda",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            imageId: "ab167572d31c1de981c8d713cf9ad3c1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080570",
                                                            name: "Peach Masala",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "94150155",
                                                            name: "Kala Khatta",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Combos",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "68554181",
                                                            name: "Noodles With Chilli Paneer",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58999219",
                                                            name: "Fried Rice With Manchurian",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "75b34874b14a0b9acb07cd187f6218d8",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "48 ratings",
                                                                    ratingCountV2: "48"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58999218",
                                                            name: "Fried Rice With Chilli Paneer",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "830033471bd61b441d228b36091fb8ee",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806049",
                                                            name: "Veg Noodles With Manchurian",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "4c152ef1e2f505f66faf957dccb097ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806096",
                                                            name: "Veg Noodles With Manchurian  ",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "4c152ef1e2f505f66faf957dccb097ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Dimsum",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736201",
                                                            name: "Chicken Gravy Dimsum (6pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736200",
                                                            name: "Achari Dimsum (6 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "b283f2b5308d30b4f7267c1613adbb12",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.1",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736199",
                                                            name: "Malai Dimsum (6 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736175",
                                                            name: "Gravy Dimsum (6 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60882574",
                                                            name: "Schezwan Chicken Dimsum ( 8 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58994282",
                                                            name: "Kurkure Chicken Dimsum( 8 Pcs ) ",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "q6y6cmuqyvqz4crbjpvk",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "19 ratings",
                                                                    ratingCountV2: "19"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "57097093",
                                                            name: "Chicken Dimsums ( 8 Pcs ) ",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "8a520958c2f2266213423a45a8e3d55f",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.4",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806134",
                                                            name: "Veg Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "grmqhghpehvz5ifjhav7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.7",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806135",
                                                            name: "Paneer & Corn Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806136",
                                                            name: "Kurkure Veg Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "02c4be58106b16a0652be6dc4a988395",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806137",
                                                            name: "Kurkure Paneer & Corn Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "c36704a15ce6e88877122da04c888066",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 33000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806138",
                                                            name: "Schezwan Veg Dimsums",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Desserts",
                                            categories: [
                                                {
                                                    title: "Desserts",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "78155342",
                                                                    name: "Strawberry Flurry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "73170624",
                                                                    name: "Oreo Flurry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.1",
                                                                            ratingCount: "5 ratings",
                                                                            ratingCountV2: "5"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "66322201",
                                                                    name: "Double Oreo Delight",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.9",
                                                                            ratingCount: "38 ratings",
                                                                            ratingCountV2: "38"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805986",
                                                                    name: "Banoffee Pie",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "c7e12b4629fad2e1669b48daa382ae77",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805990",
                                                                    name: "Choco Torte",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.1",
                                                                            ratingCount: "7 ratings",
                                                                            ratingCountV2: "7"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805992",
                                                                    name: "Chocolate Mousse",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "ce6380d27931dd0812d94149d71aab13",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.8",
                                                                            ratingCount: "7 ratings",
                                                                            ratingCountV2: "7"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805995",
                                                                    name: "Nutella Cheese Cake  ",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "ptzys9t2u1t8peqvivdo",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.5",
                                                                            ratingCount: "35 ratings",
                                                                            ratingCountV2: "35"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806002",
                                                                    name: "Blueberry Cheese Cake Pastry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "4337482ed72b9ecb7cca0ba8c57ffd9e",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.7",
                                                                            ratingCount: "8 ratings",
                                                                            ratingCountV2: "8"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806009",
                                                                    name: "Real Strawberry With Nutella ",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806020",
                                                                    name: "Mango Flurry ",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806022",
                                                                    name: "Strawberry Mango Flurry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 18000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805980",
                                                                    name: "Hot Brownie With Hot Chocolate",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "9079c5941e9c9ec99c9e1b3aed4c53ea",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 19900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "960 ratings",
                                                                            ratingCountV2: "960"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805981",
                                                                    name: "Hot Brownie With Hot Chocolate & Ice Cream",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "c5edcee7c15971037868516ee43925f7",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "98 ratings",
                                                                            ratingCountV2: "98"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805999",
                                                                    name: "Irish Tiramisu",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "bxaapk8pkvswkqxwsjyt",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "1.3",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Pancakes",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044297",
                                                            name: "Fruit Pancake ( Cocktail Fruit )",
                                                            category: "Pancakes",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712150",
                                                            name: "Banana Pancake",
                                                            category: "Pancakes",
                                                            imageId: "nzwzp9asfa3zgutxclaq",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712151",
                                                            name: "Nutella Pancake",
                                                            category: "Pancakes",
                                                            imageId: "tqyuxpb01t6fk8nozot8",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "61 ratings",
                                                                    ratingCountV2: "61"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712152",
                                                            name: "Strawberry Pancake",
                                                            category: "Pancakes",
                                                            imageId: "06a55fe03d94f07e0de7fe8c0554bcdd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712154",
                                                            name: "Classic Pancake",
                                                            category: "Pancakes",
                                                            imageId: "2d6137d6432637c31325f64e59464b6b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Ice Creams",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820440",
                                                            name: "Vanilla with KitKat Ice Cream [2 Scoops]",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820441",
                                                            name: "Vanilla With Oreo",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820442",
                                                            name: "Vanilla with Hot Chocolate Ice Cream [2 Scoops]",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820449",
                                                            name: "Black Currant",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "47a331ccc02a2aec4e2b72a905ffe51a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806025",
                                                            name: "Vanilla",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "6f24f0ae20baedb3d3bb2843492a6f4a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806027",
                                                            name: "Chocolate",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806033",
                                                            name: "Butterscotch",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "efdcb4dfc667a0835f27b55796672649",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806036",
                                                            name: "Strawberry",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "a68ed28cf0610486535c4c0581792d37",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806038",
                                                            name: "Fruit & Nut  ",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806045",
                                                            name: "Mango ",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "03230051babe743f1bfa4fa32031adfa",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806047",
                                                            name: "Pineapple",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "ac110bdd52bbe32e63c110435b218333",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Full Cakes",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "59568174",
                                                            name: "Irish Tiramisu Cake",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 237000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "59568175",
                                                            name: "Nutella Cheese Cake",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            imageId: "ubc1k5nevhg4btmgtmkc",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 211000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "35 ratings",
                                                                    ratingCountV2: "35"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806075",
                                                            name: "Banoffee Pie  ",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            imageId: "c7e12b4629fad2e1669b48daa382ae77",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 211000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806076",
                                                            name: "Blueberry Cheese Cake   ",
                                                            category: "Full Cakes",
                                                            description: "Serves 1 | Blueberry jam topped on a rich cream and cheese dessert.",
                                                            imageId: "iso0xdar8lbewtjs5aqh",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 224000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806077",
                                                            name: "Chocolate Torte Cake",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 165000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Chinese Soup",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388208",
                                                            name: "Chicken Manchow Soup",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            imageId: "49758aabff9bd651b59f7158ab09afd4",
                                                            inStock: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.6",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806167",
                                                            name: "Chicken Hot & Sour Soup",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806169",
                                                            name: "Lemon Chicken Herbs   ",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806170",
                                                            name: "Broccoli Chicken Almond Soup   ",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Main Course",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388454",
                                                            name: "Grilled Chicken Peri Peri Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388349",
                                                            name: "Fish In Lemon Butter",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            imageId: "rzvdmz5s8ark7ztsbtbf",
                                                            inStock: 1,
                                                            price: 71000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.5",
                                                                    ratingCount: "28 ratings",
                                                                    ratingCountV2: "28"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388350",
                                                            name: "Grilled Fish Peri Peri",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            imageId: "bwdktio3gotz97y3qff3",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388352",
                                                            name: "Grilled Fish Mustard Cream Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806104",
                                                            name: "Chicken Pepper Sticks",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806105",
                                                            name: "Chicken Wings With BBQ Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1 | Chicken wings glazed in smoky barbeque sauce.",
                                                            inStock: 1,
                                                            price: 66000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806107",
                                                            name: "Chicken Finger With Cocktail Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 66000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806108",
                                                            name: "Grilled Chicken BBQ Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.0",
                                                                    ratingCount: "1 rating",
                                                                    ratingCountV2: "1"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Chinese Starters",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119533393",
                                                            name: "Schezwan Chicken Noodles",
                                                            category: "Chinese Starters",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883667",
                                                            name: "Schezwan Fried Rice",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "d8098eef65a1d6206c8c346de07cbc98",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883668",
                                                            name: "Schezwan Chicken",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "48d2bd0aa185209cc3a4554fa7ee2538",
                                                            inStock: 1,
                                                            price: 54000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883669",
                                                            name: "Chicken Chilli Garlic Noodles",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "3b0c49b1036dacc7ff13262dd6faef4e",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883670",
                                                            name: "Chicken Noodles",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "ihp13zm3h9u12ymq7fti",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388374",
                                                            name: "Chilli Chicken Dry",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "xz4ex3t6g1ayctqkcmwz",
                                                            inStock: 1,
                                                            price: 56000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "39 ratings",
                                                                    ratingCountV2: "39"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388382",
                                                            name: "Chicken Hakka Noodles",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "b76c266831fe664e59abc336ad0fd53b",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806171",
                                                            name: "Chicken Manchurian ",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "1fc87fae326ff5045b5cdfdcb179644e",
                                                            inStock: 1,
                                                            price: 54000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806172",
                                                            name: "Chicken Fried Rice",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "500a042557200e6298984c363fbd92a0",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Baked Paninis",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044302",
                                                            name: "Paneer Mushroom Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563585",
                                                            name: "Grilled Veg Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36200,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.4",
                                                                    ratingCount: "56 ratings",
                                                                    ratingCountV2: "56"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563587",
                                                            name: "Grilled Veg Saucy Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563588",
                                                            name: "Cottage Cheese Panini",
                                                            category: "Baked Paninis",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021798",
                                                            name: "Mushroom Olive Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443776",
                                                            name: "Chicken Salami Sausage Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443777",
                                                            name: "Chicken Seekh Kabab Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443778",
                                                            name: "Mutton Seekh Kabab Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            price: 59900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388423",
                                                            name: "Grilled Chicken Panini",
                                                            category: "Baked Paninis",
                                                            imageId: "e3224242c38d62a225bd1037ba7d4abc",
                                                            inStock: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Tacos",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563589",
                                                            name: "Paneer Tacos",
                                                            category: "Tacos",
                                                            description: "Serves 1 | Paneer, bell pepper, capsicum, onion, cabbage, creamy mayonnaise sauce.",
                                                            imageId: "12a8e7d99eab6f95536f7f08cf4af076",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "51 ratings",
                                                                    ratingCountV2: "51"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563591",
                                                            name: "Super Classic Tacos",
                                                            category: "Tacos",
                                                            description: "Serves 1 | Bell pepper, capsicum, onion, cabbage, zucchini, cheesy creamy mayonnaise.",
                                                            imageId: "f56606366c2db184f6a262591e2c419f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "45 ratings",
                                                                    ratingCountV2: "45"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806109",
                                                            name: "Grilled Veg. Tacos",
                                                            category: "Tacos",
                                                            description: "Serves 1",
                                                            imageId: "ff5a15c4ce8b1c59a23d441f871a9190",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.7",
                                                                    ratingCount: "65 ratings",
                                                                    ratingCountV2: "65"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Bagel",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859014",
                                                            name: "Pesto Chicken Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "5a89357a633d22b5693ba921d898c8d9",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859013",
                                                            name: "Chicken Tikki Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "edc69ad93120c06f55266dc8fe0e4035",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "57916185",
                                                            name: "Grilled Chicken Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "25e3c34c7af8c524eaa64c12d01522b9",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806110",
                                                            name: "Aloo Tikki Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806112",
                                                            name: "Herbs Chilli Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "b8bcb318f382123eec1172928a8320e9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806115",
                                                            name: "Paneer Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "fb1f4a69f486d3ef31c1fafad7543145",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806156",
                                                            name: "Mutton Tikki Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806157",
                                                            name: "Fish And Chips Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 34000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Lasagne",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000930",
                                                            name: "Mix Veg Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "44783dba22554b9ff18845d8fe922de0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 49000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.5",
                                                                    ratingCount: "41 ratings",
                                                                    ratingCountV2: "41"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000932",
                                                            name: "Lasagne Au Gratin",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "c861891be6cc3fa64f67365e84163c92",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 51000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443779",
                                                            name: "Chicken Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "60173f4337a1c98baf3c3f938e379cbc",
                                                            inStock: 1,
                                                            price: 65000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443780",
                                                            name: "Bolognese Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 65000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.3",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806132",
                                                            name: "Spinach & Mushroom Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "d1cc2859dd50af644da76c84eb510461",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 49000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Pizza",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443763",
                                                            name: "Mutton Seekh Kabab Pizza [Thin Crust, 10 Inches]",
                                                            category: "Pizza",
                                                            description: "(Mutton Seekh kabab & mutton keema)",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806164",
                                                            name: "Dark Brown Special Pizza",
                                                            category: "Pizza",
                                                            description: "( Onion, Bell pepper, Green capsicum, Chicken Salami, Sausage, Cherry tomato )",
                                                            inStock: 1,
                                                            price: 78000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443764",
                                                            name: "Roast Chicken Pizza",
                                                            category: "Pizza",
                                                            description: "(Roast Chicken & Onion)",
                                                            inStock: 1,
                                                            price: 78000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806120",
                                                            name: "Farmhouse Pizza",
                                                            category: "Pizza",
                                                            description: "Serves 1 | ( Red Capsicum, yellow Capsicum, Green capsicum , Zucchini, Mushroom, Broccoli, onion, Black olive & jalapeno )",
                                                            imageId: "018ad788525ec67d39c1e8597a0b0122",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806121",
                                                            name: "Dark Brown Special Pizza ",
                                                            category: "Pizza",
                                                            description: "Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, onion, Cherry Tomato, paneer, Black olive, jalapeno)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806122",
                                                            name: "Spicy Corn Pizza",
                                                            category: "Pizza",
                                                            description: "Green capsicum, onion, Corn, black olive, jalapeno)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806124",
                                                            name: "Paneer Pizza",
                                                            category: "Pizza",
                                                            description: "Red Capsicum, yellow Capsicum, Green capsicum, Paneer, Onion, black Olive, jalapeno  )",
                                                            imageId: "5b09fbb51bd0f2a0d0784fe17a66bdc1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806125",
                                                            name: "Margarita Pizza",
                                                            category: "Pizza",
                                                            imageId: "5b1ee7b75a9b6b041ab45b9c1f95b22d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 35000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806126",
                                                            name: "Four Season Pizza",
                                                            category: "Pizza",
                                                            description: "( Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, Mushroom, zucchini, Onion, black Olive, jalapeno  )",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 46000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806129",
                                                            name: "Simply English Vegetable Pizza",
                                                            category: "Pizza",
                                                            description: "( Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, zucchini, Cherry tomato, black Olive, jalapeno  )",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806131",
                                                            name: "Grilled Vegetable Pizza",
                                                            category: "Pizza",
                                                            description: "Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, zucchini, Onion, black Olive, jalapeno  )",
                                                            imageId: "018ad788525ec67d39c1e8597a0b0122",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 43000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.1",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806158",
                                                            name: "BBQ Chicken Pizza",
                                                            category: "Pizza",
                                                            description: "( Onion, Bell pepper, Green capsicum, jalapeno & Grilled chicken )",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806159",
                                                            name: "Chicken Sausage Salami Pizza ",
                                                            category: "Pizza",
                                                            description: "chicken sausage & chicken salami)",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806161",
                                                            name: "Chicken Seekh Kabab Pizza ",
                                                            category: "Pizza",
                                                            description: "Chicken Seekh Kabab & chicken Keema)",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806163",
                                                            name: "Bolognese Pizza",
                                                            category: "Pizza",
                                                            description: "(Bolognese Sauce)",
                                                            inStock: 1,
                                                            price: 78000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806165",
                                                            name: "Pepperoni Pizza Chicken ",
                                                            category: "Pizza",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Pastas",
                                            categories: [
                                                {
                                                    title: "Others",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "27388442",
                                                                    name: "Fusilli Chicken Peri Peri Pasta",
                                                                    category: "Pastas",
                                                                    inStock: 1,
                                                                    price: 59900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "1.1",
                                                                            ratingCount: "5 ratings",
                                                                            ratingCountV2: "5"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "27388445",
                                                                    name: "Angry Chicken Pasta",
                                                                    category: "Pastas",
                                                                    imageId: "c0bfda4a4b0dbb1fa4125334cf2c854d",
                                                                    inStock: 1,
                                                                    price: 59900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "5.0",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806087",
                                                                    name: "Spaghetti Agli -E- Olio With Chicken Sausage",
                                                                    category: "Pastas",
                                                                    inStock: 1,
                                                                    price: 62000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806088",
                                                                    name: "Chicken Special Pasta",
                                                                    category: "Pastas",
                                                                    imageId: "40db6ecddd849b636b32e4085a40eec7",
                                                                    inStock: 1,
                                                                    price: 59900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    title: "veg",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949071",
                                                                    name: "Red Sauce Pasta (penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "536e15c646ffd0f83a2e8eadd604d54d",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.3",
                                                                            ratingCount: "15 ratings",
                                                                            ratingCountV2: "15"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949072",
                                                                    name: "White Sauce Pasta (penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "5c04c7cb43b0568e32214f49a53dbd30",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.8",
                                                                            ratingCount: "84 ratings",
                                                                            ratingCountV2: "84"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949073",
                                                                    name: "Mix Sauce Pasta (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "59a99f7eee5a4656b7b6d82490857463",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "193 ratings",
                                                                            ratingCountV2: "193"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949074",
                                                                    name: "Cheese Red Pasta (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "536e15c646ffd0f83a2e8eadd604d54d",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.5",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949075",
                                                                    name: "Cheese White Pasta (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "5c04c7cb43b0568e32214f49a53dbd30",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "28 ratings",
                                                                            ratingCountV2: "28"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949078",
                                                                    name: "Cheese Mix Pasta  (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "59a99f7eee5a4656b7b6d82490857463",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "35 ratings",
                                                                            ratingCountV2: "35"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021816",
                                                                    name: "Penne Arrabiata",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "40ba0ede04a674f12e64b09029be1345",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 34900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "12 ratings",
                                                                            ratingCountV2: "12"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893292",
                                                                    name: "Fusili Mushroom White Sauce Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "d5df473cf89e89a7f0cae44553ae9fea",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893295",
                                                                    name: "Penne Al Pesto",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893347",
                                                                    name: "Fusili Mushroom Mix Sauce Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.4",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893450",
                                                                    name: "Spaghetti Agli e olio",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "12563580",
                                                                    name: "Penne Veg White Sauce Creamy Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "96820e37b9482a60aca119d095cf729b",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.9",
                                                                            ratingCount: "21 ratings",
                                                                            ratingCountV2: "21"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893523",
                                                                    name: "Penne Veg Peri Peri",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893530",
                                                                    name: "Spaghetti Mix Sauce Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "9dcee1b5913aae284ffd57c00627bf35",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.4",
                                                                            ratingCount: "13 ratings",
                                                                            ratingCountV2: "13"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Mocktails",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "7056301",
                                                            name: "Virgin Mojito",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            imageId: "d0jjfnhf4t4brhchlw4b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "183 ratings",
                                                                    ratingCountV2: "183"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "7056311",
                                                            name: "Green Apple Mojito",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            imageId: "776a4a120fbce02806951ade1b97ded0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "50 ratings",
                                                                    ratingCountV2: "50"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805942",
                                                            name: "Blue Curacao",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805945",
                                                            name: "Passion Fruit",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            imageId: "a134dc0225e7ca4b8e4b853a6b65407a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "116447672",
                                                            name: "Spiced Jamun",
                                                            category: "Mocktails",
                                                            description: "Spicy flavour blended with special jamun flavour",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Iced Tea",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "73170623",
                                                            name: "Rose Ice Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271207",
                                                            name: "Lemon Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            imageId: "52a616fff6521fcb4c28570bb91b84e5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "57 ratings",
                                                                    ratingCountV2: "57"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271209",
                                                            name: "Passion Fruit Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "12 ratings",
                                                                    ratingCountV2: "12"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563606",
                                                            name: "Peach Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            imageId: "r6g0oromxk8kkjqqrkrx",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "19 ratings",
                                                                    ratingCountV2: "19"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271208",
                                                            name: "Green Apple Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            imageId: "e49efb6c2db991b1b01fcea12a9980e4",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.0",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806000",
                                                            name: "Black Berry Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806004",
                                                            name: "Pomegranate Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806012",
                                                            name: "Paan Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806015",
                                                            name: "Grenadine Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806016",
                                                            name: "Saffron Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806019",
                                                            name: "Watermelon Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "117181217",
                                                            name: "Strawberry Iced Tea",
                                                            category: "Iced Tea",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Waffle",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805928",
                                                            name: "Double Banana Toffee Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805930",
                                                            name: "Single classic Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (Maple Syrup, Butter & Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805932",
                                                            name: "Double Classic Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805933",
                                                            name: "Single Strawberry Waffle With Nutella",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (real Strawberries, maple Syrup & Nutella)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.8",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805935",
                                                            name: "Double Strawberry Waffle With Nutella",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805938",
                                                            name: "Single Kitkat Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Nutella, Maple Syrup, Crushed Nuts, KitKat & Vanilla Ice-cream)",
                                                            imageId: "5d4d64797a3e4c43409eb3b79b826420",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "75 ratings",
                                                                    ratingCountV2: "75"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805940",
                                                            name: "Double Kitkat Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805941",
                                                            name: "Single Oreo Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple Syrup, Nutella, Vanilla Ice-cream, Crushed Nuts & Oreo)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805943",
                                                            name: "Double Oreo Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805950",
                                                            name: "Single Fresh Fruits Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (Fresh Fruits, Maple Syrup, Whip cream, Vanilla ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805953",
                                                            name: "Double Fresh Fruits Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805963",
                                                            name: "Single Pineapple Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | ( Real pineapple with Maple Syrup & vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805965",
                                                            name: "Double Pineapple Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805968",
                                                            name: "Single Ferrero Rocher Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | ( Ferrero Rocher Chocolate with Nutella Topping & vanilla Ice-cream )",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "17 ratings",
                                                                    ratingCountV2: "17"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805970",
                                                            name: "Double Ferrero Rocher Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 48000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.4",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806051",
                                                            name: "Single Nutella Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple syrup, Nutella, Crushed Nuts & Vanilla Ice-cream)",
                                                            imageId: "1deeb6515010bf8158f3f9359f330951",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "125 ratings",
                                                                    ratingCountV2: "125"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806055",
                                                            name: "Single Peanut Butter",
                                                            category: "Waffle",
                                                            description: "Serves 1 | ( Maple Syrup, Peanut Butter with Crushed nuts, Whip Cream & Vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806057",
                                                            name: "Double Peanut Butter",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806059",
                                                            name: "Single Blueberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple Syrup, Whip Cream, Blueberry jam, Vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "15 ratings",
                                                                    ratingCountV2: "15"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806061",
                                                            name: "Double Blueberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806063",
                                                            name: "Single Chocolate Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (maple Syrup, Dark Chocolate, Crushed Nuts & Chocolate Ice-cream)",
                                                            imageId: "5d6f3edb647b154304beedd932887dbb",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806065",
                                                            name: "Double Chocolate Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            imageId: "1deeb6515010bf8158f3f9359f330951",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.8",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806067",
                                                            name: "Single Strawberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple Syrup, Whip Cream, Strawberry jam, Vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806068",
                                                            name: "Double Strawberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806069",
                                                            name: "Single Banana Toffee Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Fresh banana, maple Syrup, Whip Topping Cream, toffee Caramel)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806053",
                                                            name: "Double Nutella Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            imageId: "1deeb6515010bf8158f3f9359f330951",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "75 ratings",
                                                                    ratingCountV2: "75"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805957",
                                                            name: "Single Real Mango Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Real Mangoes with Maple Syrup & vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805959",
                                                            name: "Double Real Mango Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Ice Teas",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310298",
                                                            name: "Rose Ice Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310299",
                                                            name: "Lemon Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            imageId: "52a616fff6521fcb4c28570bb91b84e5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "57 ratings",
                                                                    ratingCountV2: "57"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310300",
                                                            name: "Passion Fruit Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310301",
                                                            name: "Peach Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310302",
                                                            name: "Green Apple Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            imageId: "e49efb6c2db991b1b01fcea12a9980e4",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "124109210",
                                                            name: "Passion Fruit Mango Shake",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                            type: "FSSAI",
                                            imageId: "fssai_final_edss9i",
                                            text: [
                                                "License No. 20821003000690"
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                            name: "Lorem, ipsum",
                                            area: "Sector 15",
                                            completeAddress: "Shop - 144, booth no.163, Huda Market, sec15, faridabad"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        ],
        firstOffsetRequest: true,
        isQCLink: false
    },
    tid: "77533f11-5e8d-4b54-a4a7-1c92985210c7",
    sid: "d3bd968b-8262-4755-a5c0-d4ee42f09309",
    deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
    csrfToken: "QrzNyc0FD7FG-mWnJKo-_NXJdT_1A8Z2tGSo8wHQ"
};


var $8b26bc4fcc63ea23$var$useResData = function() {
    var fetchData = function fetchData() {
        return _fetchData.apply(this, arguments);
    };
    // console.log("inside my custom hooks");
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(null), 2), list = _useState[0], setList = _useState[1];
    (0, $lcrTp.useEffect)(function() {
        fetchData();
    }, []);
    function _fetchData() {
        _fetchData = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
            var _resDataJSON_data_cards__card_card_gridElements_infoWithStyle, _resDataJSON_data_cards__card_card_gridElements, _resDataJSON_data_cards__card_card, _resDataJSON_data_cards__card, _resDataJSON_data_cards_, _resDataJSON_data, _resDataJSON_data_cards_filter__card_card_gridElements_infoWithStyle, _resDataJSON_data_cards_filter__card_card_gridElements, _resDataJSON_data_cards_filter__card_card, _resDataJSON_data_cards_filter__card, _resDataJSON_data_cards_filter_, _resDataJSON_data1, resDataJSON, resData, data, data2;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $df6b3e332a139c88$export$1087355e69a7a68)).then(function() {
                                var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(val) {
                                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    val.json()
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    resDataJSON = _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(val) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(err) {
                                return resDataJSON = (0, $6a504aa8891277a5$export$52daddf863f66fd0);
                            })
                        ];
                    case 1:
                        resData = _state.sent();
                        // resDataJSON = await resData.json();
                        data = resDataJSON === null || resDataJSON === void 0 ? void 0 : (_resDataJSON_data = resDataJSON.data) === null || _resDataJSON_data === void 0 ? void 0 : (_resDataJSON_data_cards_ = _resDataJSON_data.cards[3]) === null || _resDataJSON_data_cards_ === void 0 ? void 0 : (_resDataJSON_data_cards__card = _resDataJSON_data_cards_.card) === null || _resDataJSON_data_cards__card === void 0 ? void 0 : (_resDataJSON_data_cards__card_card = _resDataJSON_data_cards__card.card) === null || _resDataJSON_data_cards__card_card === void 0 ? void 0 : (_resDataJSON_data_cards__card_card_gridElements = _resDataJSON_data_cards__card_card.gridElements) === null || _resDataJSON_data_cards__card_card_gridElements === void 0 ? void 0 : (_resDataJSON_data_cards__card_card_gridElements_infoWithStyle = _resDataJSON_data_cards__card_card_gridElements.infoWithStyle) === null || _resDataJSON_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _resDataJSON_data_cards__card_card_gridElements_infoWithStyle.restaurants;
                        data2 = resDataJSON === null || resDataJSON === void 0 ? void 0 : (_resDataJSON_data1 = resDataJSON.data) === null || _resDataJSON_data1 === void 0 ? void 0 : (_resDataJSON_data_cards_filter_ = _resDataJSON_data1.cards.filter(function(res) {
                            var _res_card_card, _res_card;
                            return (res === null || res === void 0 ? void 0 : (_res_card = res.card) === null || _res_card === void 0 ? void 0 : (_res_card_card = _res_card.card) === null || _res_card_card === void 0 ? void 0 : _res_card_card.id) == "restaurant_grid_listing";
                        })[0]) === null || _resDataJSON_data_cards_filter_ === void 0 ? void 0 : (_resDataJSON_data_cards_filter__card = _resDataJSON_data_cards_filter_.card) === null || _resDataJSON_data_cards_filter__card === void 0 ? void 0 : (_resDataJSON_data_cards_filter__card_card = _resDataJSON_data_cards_filter__card.card) === null || _resDataJSON_data_cards_filter__card_card === void 0 ? void 0 : (_resDataJSON_data_cards_filter__card_card_gridElements = _resDataJSON_data_cards_filter__card_card.gridElements) === null || _resDataJSON_data_cards_filter__card_card_gridElements === void 0 ? void 0 : (_resDataJSON_data_cards_filter__card_card_gridElements_infoWithStyle = _resDataJSON_data_cards_filter__card_card_gridElements.infoWithStyle) === null || _resDataJSON_data_cards_filter__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _resDataJSON_data_cards_filter__card_card_gridElements_infoWithStyle.restaurants;
                        // console.log(data2);
                        // let chkData = await fetch("https://www.swiggy.com/dapi/restaurants/list/update", {
                        //   credentials: "include",
                        //   body: '{"lat":28.4089123,"lng":77.3177894,"nextOffset":"COVCELQ4KIDAuc6q2JOxbTCnEw==","widgetOffset":{"NewListingView_category_bar_chicletranking_TwoRows":"","NewListingView_category_bar_chicletranking_TwoRows_Rendition":"","collectionV5RestaurantListWidget_SimRestoRelevance_food_seo":"10","inlineFacetFilter":"","restaurantCountWidget":""},"filters":{},"seoParams":{"seoUrl":"https://www.swiggy.com/","pageType":"FOOD_HOMEPAGE","apiName":"FoodHomePage"},"page_type":"DESKTOP_WEB_LISTING","_csrf":"xMtPPKeGppH7-ybrADDQf0wY8H0O3EnmPeJ2bjZs"}',
                        //   method: "POST",
                        // });
                        // let json2=await chkData.json();
                        // console.log(chkData);
                        setList(data2);
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchData.apply(this, arguments);
    }
    return list;
};
var $8b26bc4fcc63ea23$export$2e2bcd8739ae039 = $8b26bc4fcc63ea23$var$useResData;


var $acddcaaae503ebe1$var$Filter = function(props) {
    var _props_Data = props.Data, filteredListOfRest = _props_Data.filteredListOfRest, setfilteredListOfRest = _props_Data.setfilteredListOfRest;
    var listOfRest = (0, $8b26bc4fcc63ea23$export$2e2bcd8739ae039)();
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), inputValue = _useState[0], setInputValue = _useState[1];
    var _useState1 = (0, $3tDj3._)((0, $lcrTp.useState)(false), 2), showBestRest = _useState1[0], setShowBestRest = _useState1[1];
    //console.log(props.Data, listOfRest);
    if (listOfRest != null && filteredListOfRest == null) setfilteredListOfRest(listOfRest);
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: "buttons filter flex items-center justify-center flex-wrap-reverse mb-4 gap-4 ",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                children: /*#__PURE__*/ (0, $kZF3u.jsxs)("button", {
                    variant: "contained",
                    className: "hover:cursor-pointer uppercase hover:shadow-sm px-4 py-1.5 rounded text-white m-10 bg-[#F16667] hover:bg-[#dd4747]  dark:bg-[#dd4747]  dark:hover:bg-[#F16667] transition-colors duration-300 ease-in-out",
                    onClick: function() {
                        setInputValue("");
                        if (showBestRest == false) {
                            setfilteredListOfRest(listOfRest.filter(function(val) {
                                return val.info.avgRating > 4.0;
                            }));
                            setShowBestRest(true);
                        } else {
                            setfilteredListOfRest(listOfRest);
                            setShowBestRest(false);
                        }
                    },
                    children: [
                        showBestRest == false ? "Best" : "All",
                        " restaurants"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: " search ",
                children: /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                    className: "ml-5 mr-1 h-10 bg-slate-200 dark:text-black  px-3 outline-none rounded-lg ",
                    type: "text",
                    placeholder: "Search Hotels",
                    value: inputValue,
                    onChange: function(e) {
                        console.log(e.target.value);
                        setInputValue(e.target.value);
                        setfilteredListOfRest(listOfRest.filter(function(res) {
                            return res.info.name.toLowerCase().includes(e.target.value.toLowerCase());
                        }));
                    }
                })
            })
        ]
    });
};
var $acddcaaae503ebe1$export$2e2bcd8739ae039 = $acddcaaae503ebe1$var$Filter;


//cardData[i].info.[name,id,cloudinaryImageId,cuisines,avgRatingString,.sla.slaString,locality,areaName]
// card data from swiggy
var $183b828d1a836015$var$Cardcontainer = function() {
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(null), 2), filteredListOfRest = _useState[0], setfilteredListOfRest = _useState[1];
    // console.log("im in body" ,filteredListOfRest)
    var status = (0, $67361a66487702b6$export$2e2bcd8739ae039)();
    var CardWithVeg = (0, $2c7220131b1ebb76$export$e707e773b106c157)((0, $2c7220131b1ebb76$export$2e2bcd8739ae039));
    if (status == false) return /*#__PURE__*/ (0, $kZF3u.jsx)((0, $4192f4539d43e997$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: " mx-auto p-3  ",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $acddcaaae503ebe1$export$2e2bcd8739ae039), {
                Data: {
                    filteredListOfRest: filteredListOfRest,
                    setfilteredListOfRest: setfilteredListOfRest
                }
            }),
            filteredListOfRest == null ? /*#__PURE__*/ (0, $kZF3u.jsx)((0, $e15e80a816a839ce$export$809644b82cfe94b1), {}) : /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: "Cardcontainer grid  grid-cols-[repeat(auto-fit,_minmax(320px,_1fr))] gap-6  justify-items-center items-center ",
                children: filteredListOfRest.map(function(res) {
                    var _res_info, _res_info1, _res_info2;
                    // console.log(res?.info?.veg, res.info.name);
                    // console.log(res);
                    return /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        to: "/restraurant/" + res.info.id,
                        "data-testid": "rescard",
                        children: (res === null || res === void 0 ? void 0 : (_res_info = res.info) === null || _res_info === void 0 ? void 0 : _res_info.veg) ? /*#__PURE__*/ (0, $kZF3u.jsx)(CardWithVeg, {
                            data: res
                        }, res === null || res === void 0 ? void 0 : (_res_info1 = res.info) === null || _res_info1 === void 0 ? void 0 : _res_info1.id) : /*#__PURE__*/ (0, $kZF3u.jsx)((0, $2c7220131b1ebb76$export$2e2bcd8739ae039), {
                            data: res
                        }, res === null || res === void 0 ? void 0 : (_res_info2 = res.info) === null || _res_info2 === void 0 ? void 0 : _res_info2.id)
                    });
                })
            })
        ]
    });
};
var $183b828d1a836015$export$2e2bcd8739ae039 = $183b828d1a836015$var$Cardcontainer;



var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $9Hju1 = parcelRequire("9Hju1");

var $hCdf1 = parcelRequire("hCdf1");

var $kZF3u = parcelRequire("kZF3u");


var $lfBxf = parcelRequire("lfBxf");

var $9tzan = parcelRequire("9tzan");

var $9Hju1 = parcelRequire("9Hju1");

var $hCdf1 = parcelRequire("hCdf1");


var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");

var $86d9df6141717a7d$var$UserClass = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $9Hju1._)(UserClass, _React_Component);
    var _super = (0, $hCdf1._)(UserClass);
    function UserClass(props) {
        (0, $lfBxf._)(this, UserClass);
        var _this;
        // to access props
        _this = _super.call(this, props);
        // console.log(props);
        // this.state = {
        //   // big object of state variable stores all state variables
        //   count: 0,
        //   count2: 2,
        // };
        // console.log(this.props.name+ " constructor ");
        _this.state = {
            name: "Dummy",
            login: "Dummy",
            location: "Dummy"
        };
        return _this;
    }
    (0, $9tzan._)(UserClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
                    var data, json;
                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("https://api.github.com/users/PriyanshuD24")
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    4,
                                    data.json()
                                ];
                            case 2:
                                json = _state.sent();
                                _this.setState(json);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                //destructuring
                console.log(this.state);
                var _this_state = this.state, avatar_url = _this_state.avatar_url, name = _this_state.name, login = _this_state.login, location = _this_state.location;
                // console.log(this.props.name + " rendered");
                return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                    className: "border-2 border-black dark:border-[#dedede] flex justify-between items-center  p-2 ",
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                            className: " text-xl flex flex-col  h-[148px] justify-evenly  ",
                            children: [
                                /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                                    children: [
                                        "Name : ",
                                        name,
                                        " "
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                                    children: [
                                        "Location : ",
                                        location
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                                    to: "https://github.com/PriyanshuD24",
                                    children: /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                                        className: "hover:text-[#dd4747]  dark:hover:text-[#F16667]",
                                        children: [
                                            "@",
                                            login
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                            className: "w-[148px] h-[148px] bg-[#f0f0f0]",
                            children: avatar_url ? /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                src: avatar_url,
                                alt: "Github-avatar"
                            }) : null
                        })
                    ]
                });
            }
        }
    ]);
    return UserClass;
}((0, (/*@__PURE__*/$parcel$interopDefault($lcrTp))).Component);
var $86d9df6141717a7d$export$2e2bcd8739ae039 = $86d9df6141717a7d$var$UserClass;



var $lcrTp = parcelRequire("lcrTp");

var $d4482c927dded0d7$var$About = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $9Hju1._)(About, _React_Component);
    var _super = (0, $hCdf1._)(About);
    function About(props) {
        (0, $lfBxf._)(this, About);
        return _super.call(this, props);
    }
    (0, $9tzan._)(About, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
            // console.log("parent component did mount ");
            }
        },
        {
            key: "render",
            value: function render() {
                // console.log("parent render ");
                // a
                return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "max-w-[800px] mx-auto  ",
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $86d9df6141717a7d$export$2e2bcd8739ae039), {
                        name: "child 1",
                        locality: "Faridabad"
                    })
                });
            }
        }
    ]);
    return About;
}((0, (/*@__PURE__*/$parcel$interopDefault($lcrTp))).Component);
var $d4482c927dded0d7$export$2e2bcd8739ae039 = $d4482c927dded0d7$var$About;



var $kZF3u = parcelRequire("kZF3u");
var $e0afe39733bd1d63$var$Contact = function() {
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)("h1", {
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $kZF3u.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                        type: "text",
                        placeholder: "name"
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                        type: "text",
                        name: "",
                        id: "",
                        placeholder: "message"
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                        type: "submit",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $e0afe39733bd1d63$export$2e2bcd8739ae039 = $e0afe39733bd1d63$var$Contact;



var $kZF3u = parcelRequire("kZF3u");

var $713bfbce28dcef6d$var$Error = function() {
    var err = (0, $e3ffdf28351c8739$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsxs)("h1", {
                children: [
                    " ",
                    err.status,
                    ": ",
                    err.statusText,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("h2", {
                children: err.data
            })
        ]
    });
};
var $713bfbce28dcef6d$export$2e2bcd8739ae039 = $713bfbce28dcef6d$var$Error;



var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");




var $3tDj3 = parcelRequire("3tDj3");


var $lcrTp = parcelRequire("lcrTp");


var $c4ab829b1638c188$var$useRestMenu = function(resId) {
    var fetchData = function fetchData() {
        return _fetchData.apply(this, arguments);
    };
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(null), 2), resMenu = _useState[0], setResMenu = _useState[1];
    (0, $lcrTp.useEffect)(function() {
        fetchData();
    }, []);
    function _fetchData() {
        _fetchData = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function() {
            var _json_data, _cards__groupedCard_cardGroupMap_REGULAR, _cards__groupedCard_cardGroupMap, _cards__groupedCard, json, data, cards;
            return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $df6b3e332a139c88$export$b77c1aa4fb57bd1c) + resId).then(function() {
                                var _ref = (0, $cb837825d0f9e672$export$7c398597f8905a1)(function(val) {
                                    return (0, $75cbc07a4214bd1d$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    val.json()
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    json = _state.sent()
                                                ];
                                        }
                                    });
                                });
                                return function(val) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(err) {
                                return json = (0, $6a504aa8891277a5$export$bc4d6c843416a567);
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        // json = await data.json();
                        //console.log(json);
                        // const cards = json?.data?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards;
                        cards = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.cards.filter(function(res) {
                            return "groupedCard" in res;
                        });
                        setResMenu((_cards__groupedCard = cards[0].groupedCard) === null || _cards__groupedCard === void 0 ? void 0 : (_cards__groupedCard_cardGroupMap = _cards__groupedCard.cardGroupMap) === null || _cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_cards__groupedCard_cardGroupMap_REGULAR = _cards__groupedCard_cardGroupMap.REGULAR) === null || _cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _cards__groupedCard_cardGroupMap_REGULAR.cards);
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchData.apply(this, arguments);
    }
    // console.log(resMenu);
    return resMenu;
};
var $c4ab829b1638c188$export$2e2bcd8739ae039 = $c4ab829b1638c188$var$useRestMenu;



var $kZF3u = parcelRequire("kZF3u");
// show items of specific categories

var $kZF3u = parcelRequire("kZF3u");



var $cE9Yb = parcelRequire("cE9Yb");
var $88f01b33c174dcf0$var$cartSlice = (0, $d82c5bf5c7096fe2$export$4d8d9bd83c24ae8b)({
    //takes configratution
    name: "cart",
    initialState: {
        items: [],
        totalSum: 0
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        removeItem: function(state, action) {
            var element = action.payload;
            var idx = (0, $cE9Yb.current)(state).items.indexOf(element);
            console.log(element, idx, state);
            state.items.splice(idx, 1);
        },
        clearCart: function(state, action) {
            // state.items=[];
            state.items.length = 0;
            console.log((0, $cE9Yb.current)(state));
            state.totalSum = 0;
        //return { items: [] , totalSum :0}; // returns the new state with items=[] & totalSum=0
        },
        getTotal: function(state, action) {
            var Sum = 0;
            state.items.map(function(res) {
                var _res_card;
                var _ref = res === null || res === void 0 ? void 0 : (_res_card = res.card) === null || _res_card === void 0 ? void 0 : _res_card.info, price = _ref.price, defaultPrice = _ref.defaultPrice;
                Sum += price || defaultPrice;
            });
            state.totalSum = Sum / 100;
        }
    }
});
var /*
basically this createSlice return an object with 2 keys ie
reducer (contains all the reducers)
and actions (contains all actions) 

cartSlice = {
    actions : {
        addItem : ,
        removeItem : ,
        clearCart : ,
    },
    reducers :
}
*/ $88f01b33c174dcf0$export$2e2bcd8739ae039 = $88f01b33c174dcf0$var$cartSlice.reducer;
var $88f01b33c174dcf0$var$_cartSlice_actions = $88f01b33c174dcf0$var$cartSlice.actions;
var $88f01b33c174dcf0$export$fb9705de59d96855 = $88f01b33c174dcf0$var$_cartSlice_actions.addItem, $88f01b33c174dcf0$export$fe2d9b4e03920b4c = $88f01b33c174dcf0$var$_cartSlice_actions.removeItem, $88f01b33c174dcf0$export$810121176e3e3671 = $88f01b33c174dcf0$var$_cartSlice_actions.clearCart, $88f01b33c174dcf0$export$94860ac4a286a8d9 = $88f01b33c174dcf0$var$_cartSlice_actions.getTotal;


var $c1aa9dbc3c899793$var$RestMenuCategoriesItems = function(props) {
    var handleAddItem = function handleAddItem(item) {
        dispatch((0, $88f01b33c174dcf0$export$fb9705de59d96855)(item)); // in this dipatch fn we send an action and in action we send the data ie (action.payload)
        dispatch((0, $88f01b33c174dcf0$export$94860ac4a286a8d9)());
    };
    var handleDelItem = function handleDelItem(item) {
        dispatch((0, $88f01b33c174dcf0$export$fe2d9b4e03920b4c)(item)); // in this dipatch fn we send an action and in action we send the data ie (action.payload)
        dispatch((0, $88f01b33c174dcf0$export$94860ac4a286a8d9)());
    };
    var itemCards = props.data;
    var key = props === null || props === void 0 ? void 0 : props.Key; // to check rwhether this list is rendered from cart or not
    // console.log(props);
    var dispatch = (0, $9ebbf69bd910f984$export$8ad76b76a4c905f8)(); // returns a functions
    return /*#__PURE__*/ (0, $kZF3u.jsx)("ul", {
        className: true,
        children: itemCards.map(function(res) {
            var _res_card;
            var _ref = res === null || res === void 0 ? void 0 : (_res_card = res.card) === null || _res_card === void 0 ? void 0 : _res_card.info, name = _ref.name, price = _ref.price, defaultPrice = _ref.defaultPrice, imageId = _ref.imageId, description = _ref.description, isVeg = _ref.isVeg;
            return /*#__PURE__*/ (0, $kZF3u.jsxs)("li", {
                className: "  pb-2  flex justify-between items-center  py-4 border-b-2 border-[#f0f0f0] relative",
                "data-testid": key != undefined ? "addedResCart" : "addedRes",
                children: [
                    /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                                className: "w-4 mb-2",
                                children: isVeg ? /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                    src: (0, $df6b3e332a139c88$export$f89a830e1c49df8f),
                                    alt: ""
                                }) : /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                    src: (0, $df6b3e332a139c88$export$ecdeacdb356c62b),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                                className: "text-lg",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                                className: "my-2 font-semibold",
                                children: [
                                    " \u20B9",
                                    price / 100 || defaultPrice / 100
                                ]
                            }),
                            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                                className: " text-sm text-[#8b8b8b]  overflow-hidden",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                        className: " w-32 flex flex-col justify-center items-center  ml-6",
                        children: [
                            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                                className: "w-[118px] h-[96px]",
                                children: imageId ? /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                    className: " w-[118px] h-[96px] object-cover overflow-hidden rounded-md outline-none",
                                    alt: "",
                                    src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" + imageId
                                }) : /*#__PURE__*/ (0, $kZF3u.jsx)((0, $kZF3u.Fragment), {})
                            }),
                            key != "incart" ? /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                className: " relative bottom-6 bg-white w-[100px]   border-2 text-green-400 border-[#f0f0f0] px-2 mt-2 hover:shadow-xl ",
                                onClick: function() {
                                    return handleAddItem(res);
                                },
                                "data-testid": name,
                                children: "ADD"
                            }) : /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                className: " relative bottom-6 bg-white w-[100px]   border-2 text-green-400 border-[#f0f0f0] px-2 mt-2 hover:shadow-xl ",
                                onClick: function() {
                                    handleDelItem(res);
                                },
                                "data-testid": name + "remove",
                                children: "Remove"
                            })
                        ]
                    })
                ]
            });
        })
    });
};
var $c1aa9dbc3c899793$export$2e2bcd8739ae039 = $c1aa9dbc3c899793$var$RestMenuCategoriesItems;


var $d5e035241a9fc8da$var$RestMenuCategories = function(props) {
    // console.log("inside RestMenuCat");
    // const [isVisible, setIsVisible] = useState(true);
    var _props_data = props.data, itemCards = _props_data.itemCards, title = _props_data.title;
    var open = props.open, setIsVisible = props.setIsVisible, idx = props.idx;
    // console.log("in categories " , idx ,open);
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: "my-4",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                className: "font-bold text-2xl pb-4  hover:cursor-pointer  ",
                onClick: function() {
                    setIsVisible();
                },
                children: [
                    title,
                    " (",
                    itemCards.length,
                    ")"
                ]
            }),
            open == idx && /*#__PURE__*/ (0, $kZF3u.jsx)((0, $c1aa9dbc3c899793$export$2e2bcd8739ae039), {
                data: itemCards
            })
        ]
    });
};
var $d5e035241a9fc8da$export$2e2bcd8739ae039 = $d5e035241a9fc8da$var$RestMenuCategories;


// import Collapsible from 'react-collapsible';
// import { RES_LOGO } from "../utils/cdn_url";
var $a2f560e5f2ec5101$var$RestMenu = function() {
    var _resMenu_len_card_card, _resMenu_len_card, _resMenu_len;
    var resId = (0, $e3ffdf28351c8739$export$99eaa27ddbbb95ef)().resId;
    var resMenu = (0, $c4ab829b1638c188$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(null), 2), isVisible = _useState[0], setIsVisible = _useState[1]; // index that is visible
    (0, $lcrTp.useEffect)(function() {
        window.scrollTo(0, 0); // to scroll on top
    }, []);
    if (resMenu == null || resMenu == undefined) return /*#__PURE__*/ (0, $kZF3u.jsx)((0, $e15e80a816a839ce$export$809644b82cfe94b1), {});
    var len = resMenu.length - 1;
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: "max-w-[800px] mx-auto px-4",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: " font-extrabold text-4xl pb-6 ",
                children: (_resMenu_len = resMenu[len]) === null || _resMenu_len === void 0 ? void 0 : (_resMenu_len_card = _resMenu_len.card) === null || _resMenu_len_card === void 0 ? void 0 : (_resMenu_len_card_card = _resMenu_len_card.card) === null || _resMenu_len_card_card === void 0 ? void 0 : _resMenu_len_card_card.name
            }),
            resMenu.map(function(arr, index) {
                var _arr_card_card, _arr_card, _arr_card1;
                if ((arr === null || arr === void 0 ? void 0 : (_arr_card = arr.card) === null || _arr_card === void 0 ? void 0 : (_arr_card_card = _arr_card.card) === null || _arr_card_card === void 0 ? void 0 : _arr_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory") // console.log("hi");
                return /*#__PURE__*/ (0, $kZF3u.jsx)((0, $d5e035241a9fc8da$export$2e2bcd8739ae039), {
                    data: arr === null || arr === void 0 ? void 0 : (_arr_card1 = arr.card) === null || _arr_card1 === void 0 ? void 0 : _arr_card1.card,
                    setIsVisible: function() {
                        return index == isVisible ? setIsVisible(null) : setIsVisible(index);
                    },
                    open: isVisible,
                    idx: index
                });
            })
        ]
    });
};
var $a2f560e5f2ec5101$export$2e2bcd8739ae039 = $a2f560e5f2ec5101$var$RestMenu;




var $kZF3u = parcelRequire("kZF3u");




var $5151aa328956633b$var$Cart = function() {
    var handleClick = function handleClick() {
        dispatch((0, $88f01b33c174dcf0$export$810121176e3e3671)());
    };
    var cartItems = (0, $9ebbf69bd910f984$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var totalPrice = (0, $9ebbf69bd910f984$export$2105062e25df4afe)(function(store) {
        return store.cart.totalSum;
    });
    var dispatch = (0, $9ebbf69bd910f984$export$8ad76b76a4c905f8)();
    // console.log(cartItems);
    return /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
        className: "max-w-[800px] mx-auto p-3 px-4 ",
        children: [
            /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                        className: "font-bold text-center text-3xl",
                        children: "Cart"
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                        className: "px-4 py-1.5 bg-[#F16667] hover:bg-[#dd4747] text-white rounded dark:bg-[#dd4747]  dark:hover:bg-[#F16667]  transition-colors duration-300 ease-in-out",
                        onClick: handleClick,
                        children: "Clear All"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                className: "mb-8 ",
                children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $c1aa9dbc3c899793$export$2e2bcd8739ae039), {
                    data: cartItems,
                    Key: "incart"
                })
            }),
            totalPrice != 0 && /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                className: " flex justify-between items-center ",
                children: [
                    /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                        className: "font-semibold text-xl text-left",
                        children: [
                            "Total : \u20B9",
                            totalPrice,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        to: "/payment",
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                            className: "px-4 py-1.5 bg-[#F16667] hover:bg-[#dd4747] text-white rounded dark:bg-[#dd4747]  dark:hover:bg-[#F16667] transition duration-300 ease-in-out",
                            children: "PAY"
                        })
                    })
                ]
            })
        ]
    });
};
var $5151aa328956633b$export$2e2bcd8739ae039 = $5151aa328956633b$var$Cart;




var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");



function $b2103ef3651346d2$export$2e2bcd8739ae039() {
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), val = _useState[0], setVal = _useState[1];
    var data = (0, $lcrTp.useContext)((0, $3589c1d122ad772c$export$2e2bcd8739ae039));
    var dummyData = data.dummyData, changeDummyData = data.changeDummyData;
    var _useState1 = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), user = _useState1[0], setUser = _useState1[1];
    var _useState2 = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), email = _useState2[0], setEmail = _useState2[1];
    var _useState3 = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), password = _useState3[0], setPassword = _useState3[1];
    var firebase = (0, $lcrTp.useContext)((0, $b899d5af3bd35eb4$export$a0fd8390cfe8ae69));
    //   console.log(data);
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        className: "max-w-md w-full mx-auto rounded-lg shadow-lg overflow-hidden ",
        children: /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
            className: "bg-white px-6 py-8 ",
            children: [
                /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                    className: "text-center mb-6",
                    children: [
                        /*#__PURE__*/ (0, $kZF3u.jsx)("h2", {
                            className: "text-2xl font-semibold text-gray-800",
                            children: "Welcome Back!"
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsx)("p", {
                            className: "mt-2 text-sm text-gray-600",
                            children: "Sign in to your account"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $kZF3u.jsx)("label", {
                            htmlFor: "email",
                            className: "block text-sm font-medium text-gray-700",
                            children: "Email Address"
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                            type: "email",
                            name: "email",
                            id: "email",
                            className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                            placeholder: "Enter your email address",
                            onChange: function(e) {
                                return setEmail(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $kZF3u.jsx)("label", {
                            htmlFor: "password",
                            className: "block text-sm font-medium  text-gray-700",
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                            type: "password",
                            name: "password",
                            id: "password",
                            className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                            placeholder: "Enter your password",
                            onChange: function(e) {
                                return setPassword(e.target.value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                            className: "w-full px-4 py-2 text-base font-semibold text-white bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:bg-indigo-700",
                            onClick: function() {
                                console.log("clicked");
                            },
                            children: "Sign In"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $kZF3u.jsxs)("p", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Sign in with google",
                            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                    className: "text-indigo-600 hover:text-indigo-500 ml-1",
                                    onClick: function() {
                                        firebase.signInWithGoogle();
                                    },
                                    children: "Google"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $kZF3u.jsxs)("p", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Don't have an account yet?",
                            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                    className: "text-indigo-600 hover:text-indigo-500 ml-1",
                                    children: "Sign Up"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}






var $7e512364366f06e7$var$appStore = (0, $d82c5bf5c7096fe2$export$7d8a5b498da695ac)({
    reducer: {
        // this reducer contains all the slices of main redux store
        cart: (0, $88f01b33c174dcf0$export$2e2bcd8739ae039),
        themeChanger: (0, $97e825b352217d68$export$2e2bcd8739ae039)
    }
}); // initially it empty
var $7e512364366f06e7$export$2e2bcd8739ae039 = $7e512364366f06e7$var$appStore;



var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");








var $aa0cab6b08034432$var$HeaderMobile = function() {
    var handleThemeClick = function handleThemeClick() {
        console.log(themeData);
        //themeData=="light" ? dispatch(toogleTheme("dark")) : dispatch(toogleTheme("light"));
        if (themeData == "light") {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $97e825b352217d68$export$9443a770e75d2a08)("dark"));
        } else {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $97e825b352217d68$export$9443a770e75d2a08)("light"));
        }
    };
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)("Login"), 2), btn = _useState[0], setbtn = _useState[1];
    var status = (0, $67361a66487702b6$export$2e2bcd8739ae039)();
    var data = (0, $lcrTp.useContext)((0, $3589c1d122ad772c$export$2e2bcd8739ae039));
    var dummyData = data.dummyData, changeDummyData = data.changeDummyData;
    var myName = dummyData.myName;
    var themeData = (0, $9ebbf69bd910f984$export$2105062e25df4afe)(function(store) {
        return store.themeChanger.theme;
    });
    var dispatch = (0, $9ebbf69bd910f984$export$8ad76b76a4c905f8)();
    // console.log(dummyData);
    var cartItems = (0, $9ebbf69bd910f984$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    }); // cartItems = [] (initialstate.items)
    // console.log(cartItems);
    var firebase = (0, $lcrTp.useContext)((0, $b899d5af3bd35eb4$export$a0fd8390cfe8ae69));
    var _useState1 = (0, $3tDj3._)((0, $lcrTp.useState)(null), 2), isUserLoggedIn = _useState1[0], setisUserLoggedIn = _useState1[1];
    var auth = (0, $82f70d645a4b3e84$export$ae1af26003f05816)((0, $b899d5af3bd35eb4$export$729c8b7179294ba));
    (0, $lcrTp.useEffect)(function() {
        console.log("header use effect called");
        (0, $82f70d645a4b3e84$export$4a5767248b18ef41)(auth, function(user) {
            console.log("header on auth change run");
            if (user != isUserLoggedIn) {
                console.log("header ", user, user === null || user === void 0 ? void 0 : user.displayName);
                setisUserLoggedIn(user);
            } else setisUserLoggedIn(null);
        });
    }, []);
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        children: /*#__PURE__*/ (0, $kZF3u.jsxs)("ul", {
            className: " md:hidden flex flex-col items-center gap-8 lg:gap-10 ",
            id: "list",
            children: [
                (isUserLoggedIn === null || isUserLoggedIn === void 0 ? void 0 : isUserLoggedIn.displayName) && /*#__PURE__*/ (0, $kZF3u.jsxs)("li", {
                    children: [
                        "Hey, ",
                        isUserLoggedIn === null || isUserLoggedIn === void 0 ? void 0 : isUserLoggedIn.displayName,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                        className: "w-8 ",
                        onClick: handleThemeClick,
                        children: /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                            src: themeData == "light" ? (0, $df6b3e332a139c88$export$3e936a8db52a10a0) : (0, $df6b3e332a139c88$export$f30cb9bc4f736419)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsxs)("li", {
                    children: [
                        "Online Status:",
                        status ? "\u2705" : "\u274C",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/",
                        children: "Home"
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/about",
                        children: "About Us"
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/grocery",
                        children: "Grocery"
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                    children: /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/cart",
                        children: [
                            /*#__PURE__*/ (0, $kZF3u.jsx)("img", {
                                src: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Shopping_cart_icon.svg/1250px-Shopping_cart_icon.svg.png",
                                className: "w-8 inline"
                            }),
                            /*#__PURE__*/ (0, $kZF3u.jsxs)("span", {
                                className: "font-bold",
                                children: [
                                    "(",
                                    cartItems.length,
                                    ")"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("li", {
                    children: (isUserLoggedIn === null || isUserLoggedIn === void 0 ? void 0 : isUserLoggedIn.displayName) ? /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                        className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                        onClick: function() {
                            return firebase.signout();
                        },
                        children: "Logout"
                    }) : /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        children: [
                            /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                                children: "Login"
                            }),
                            " "
                        ]
                    })
                })
            ]
        })
    });
};
var $aa0cab6b08034432$export$2e2bcd8739ae039 = $aa0cab6b08034432$var$HeaderMobile;



var $kZF3u = parcelRequire("kZF3u");
var $30a34d9372f3ac86$export$a06f1c675e846f6f = function() {
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        className: "py-3  text-center bg-slate-500 text-white dark:bg-slate-700  absolute bottom-0 left-0 w-[100%] ",
        children: "\xa9 2024 Food Delivery App"
    });
};



var $kZF3u = parcelRequire("kZF3u");



var $5a1dc8b512ec6209$export$ad8b2382ee557dc0 = function() {
    var handleclick = function handleclick() {
        dispatch((0, $88f01b33c174dcf0$export$810121176e3e3671)());
    };
    var dispatch = (0, $9ebbf69bd910f984$export$8ad76b76a4c905f8)();
    return(// <div class="bg-gray-100">
    /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        className: "flex justify-center items-center p-2  ",
        children: /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
            className: "bg-white rounded-lg shadow-md p-8 max-w-md text-center",
            children: [
                /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "text-4xl text-green-500",
                    children: "\u2713"
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("h1", {
                    className: "text-2xl font-bold text-gray-800 mt-4",
                    children: "Order Successfully Placed"
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("p", {
                    className: "text-gray-600 mt-2",
                    children: "Your order has been successfully placed. Thank you!"
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                        className: "bg-[#F16667] hover:bg-[#dd4747] dark:bg-[#dd4747]  dark:hover:bg-[#F16667] text-white font-bold py-2 px-4 rounded mt-4 transition duration-300 ease-in-out",
                        onClick: handleclick,
                        children: "Continue Shopping"
                    })
                })
            ]
        })
    }));
};




var $3tDj3 = parcelRequire("3tDj3");

var $kZF3u = parcelRequire("kZF3u");

var $lcrTp = parcelRequire("lcrTp");


function $14805a2092d819d3$export$2e2bcd8739ae039() {
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), user = _useState[0], setUser = _useState[1];
    var _useState1 = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), email = _useState1[0], setEmail = _useState1[1];
    var _useState2 = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), name = _useState2[0], setName = _useState2[1];
    var _useState3 = (0, $3tDj3._)((0, $lcrTp.useState)(""), 2), password = _useState3[0], setPassword = _useState3[1];
    var firebase = (0, $lcrTp.useContext)((0, $b899d5af3bd35eb4$export$a0fd8390cfe8ae69));
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        className: "max-w-md w-full mx-auto rounded-lg shadow-lg overflow-hidden",
        children: /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
            className: "bg-white px-6 py-8",
            children: [
                /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $kZF3u.jsx)("h2", {
                            className: "text-2xl font-semibold text-gray-800",
                            children: "Welcome Back!"
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsx)("p", {
                            className: "mt-2 text-sm text-gray-600",
                            children: "Sign up to your account"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsxs)("form", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $kZF3u.jsx)("label", {
                                    htmlFor: "email",
                                    className: "block text-sm font-medium text-gray-700",
                                    children: "Full Name"
                                }),
                                /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                                    type: "text",
                                    name: "email",
                                    id: "email",
                                    className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    placeholder: "Enter your full name",
                                    required: true,
                                    onChange: function(e) {
                                        return setName(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $kZF3u.jsx)("label", {
                                    htmlFor: "email",
                                    className: "block text-sm font-medium text-gray-700",
                                    children: "Email Address"
                                }),
                                /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                                    type: "email",
                                    name: "email",
                                    id: "email",
                                    className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    placeholder: "Enter your email address",
                                    onChange: function(e) {
                                        return setEmail(e.target.value);
                                    },
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $kZF3u.jsx)("label", {
                                    htmlFor: "password",
                                    className: "block text-sm font-medium  text-gray-700",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $kZF3u.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    placeholder: "Enter your password",
                                    onChange: function(e) {
                                        return setPassword(e.target.value);
                                    },
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                    type: "submit",
                                    className: "w-full px-4 py-2 text-base font-semibold text-white bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:bg-indigo-700",
                                    onClick: function() {
                                        firebase.signUp(email, password, name);
                                    },
                                    children: "Sign Up"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $kZF3u.jsxs)("p", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Already have account?",
                            " ",
                            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                children: /*#__PURE__*/ (0, $kZF3u.jsx)("button", {
                                    type: "submit",
                                    className: "text-indigo-600 hover:text-indigo-500",
                                    children: "Sign In"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $33a235b2bf60f7ea$var$Grocery = /*#__PURE__*/ (0, $lcrTp.lazy)(function() {
    return (parcelRequire("iT2Uc"));
});
var $33a235b2bf60f7ea$var$Container = function() {
    var changeDummyData = function changeDummyData(newData) {
        // console.log(newData);
        setdummyData({
            myName: newData
        });
    };
    console.log(window.screen.width);
    var defContext = (0, $lcrTp.useContext)((0, $3589c1d122ad772c$export$2e2bcd8739ae039));
    var _useState = (0, $3tDj3._)((0, $lcrTp.useState)(defContext), 2), dummyData = _useState[0], setdummyData = _useState[1];
    return /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
        className: "dark:bg-[#111111] dark:text-white bg-fixed backdrop-blur-lg duration-100 max-w-[100vw] ",
        children: /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
            className: "max-w-[1400px] mx-auto min-h-screen px-2 ",
            children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $9ebbf69bd910f984$export$2881499e37b75b9a), {
                store: (0, $7e512364366f06e7$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $3589c1d122ad772c$export$2e2bcd8739ae039).Provider, {
                    value: {
                        dummyData: dummyData,
                        changeDummyData: changeDummyData
                    },
                    children: /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $b899d5af3bd35eb4$export$87091915187a1a85), {
                        children: [
                            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $fd57e2fe3dae6048$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $kZF3u.jsx)("div", {
                                className: "pb-20",
                                children: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $e3ffdf28351c8739$export$910ae8079b2c2852), {})
                            }),
                            /*#__PURE__*/ (0, $kZF3u.jsx)((0, $30a34d9372f3ac86$export$a06f1c675e846f6f), {})
                        ]
                    })
                })
            })
        })
    });
};
var $33a235b2bf60f7ea$var$approuter = (0, $04fc80922e1b6460$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $kZF3u.jsx)($33a235b2bf60f7ea$var$Container, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $183b828d1a836015$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $d4482c927dded0d7$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $e0afe39733bd1d63$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $kZF3u.jsxs)((0, $lcrTp.Suspense), {
                    fallback: /*#__PURE__*/ (0, $kZF3u.jsx)("h1", {
                        children: "Loading....."
                    }),
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $kZF3u.jsx)($33a235b2bf60f7ea$var$Grocery, {}),
                        " "
                    ]
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $5151aa328956633b$export$2e2bcd8739ae039), {})
            },
            {
                path: "/login",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $b2103ef3651346d2$export$2e2bcd8739ae039), {})
            },
            {
                path: "/signup",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $14805a2092d819d3$export$2e2bcd8739ae039), {})
            },
            {
                path: "/payment",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $5a1dc8b512ec6209$export$ad8b2382ee557dc0), {})
            },
            {
                path: "/restraurant/:resId",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $a2f560e5f2ec5101$export$2e2bcd8739ae039), {})
            },
            window.screen.width < 768 && {
                path: "/header",
                element: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $aa0cab6b08034432$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $kZF3u.jsx)((0, $713bfbce28dcef6d$export$2e2bcd8739ae039), {})
    }
]);
var $33a235b2bf60f7ea$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($201994bc3c423705$exports))).createRoot(document.querySelector(".root"));
// root.render(<Container/>)
$33a235b2bf60f7ea$var$root.render(/*#__PURE__*/ (0, $kZF3u.jsx)((0, $04fc80922e1b6460$export$323e4fc2fa4753fb), {
    router: $33a235b2bf60f7ea$var$approuter
}));

})();
//# sourceMappingURL=index.06b12965.js.map
